import React, { useState } from 'react';
import {
    Button, Grid, makeStyles, Paper, Table, Dialog, DialogTitle, DialogContent,
    TableBody, TableCell, TableContainer, TableHead, TableRow, withStyles, Snackbar, Divider
} from '@material-ui/core';
import Box from '@mui/material/Box';
import { Search } from "@material-ui/icons";
import {
    Card, Form, Tab, Tabs, InputGroup,
    Container, FormControl, Row, FormLabel, Col
} from 'react-bootstrap';
import SearchIcon from '@material-ui/icons/Search';
import Home from '../home/Home';
import ImportQuerService from '../../services/importquery/ImportQuerService';
import './Invoice.css';
import InvoiceService from '../../services/importinvoice/InvoiceService';
import ItemService from '../../services/importitem/ItemService';
import JobServices from '../../services/importjob/JobServices';
import { getPointId, getUserId } from '../Utils/Common';
import MuiAlert from '@material-ui/lab/Alert';
import ImpReport from '../../services/report/ImpReport';
import { Checkbox, LinearProgress } from '@mui/material';
import { saveAs } from 'file-saver';
import Notify from './Notify';
function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}
const useStyles = makeStyles((theme) => ({
    backdrop: {
        zIndex: theme.zIndex.drawer - 1,
        color: '#fff',
    },
    container: {
        // margin: theme.spacing(1),
        // width: "76%",
        height: 250,
        border: "1px solid black",
        boxSizing: "border-box "
    },
    containerJob: {
        // margin: theme.spacing(1),
        // width: "76%",
        height: 100,
        border: "1px solid black",
        boxSizing: "border-box "
    },
    containerquery: {
        // margin: theme.spacing(1),
        // width: "76%",
        height: 350,
        border: "1px solid black",
        boxSizing: "border-box "
    },
    ControlType: {
        marginLeft: theme.spacing(1),
        marginBottom: theme.spacing(1),
        height: "4vh",
        minWidth: 180,
        maxWidth: 200
    },
    formControlJob: {
        margin: theme.spacing(1),
        minWidth: 220,
        maxWidth: 225
    },
    NameControl: {
        margin: theme.spacing(1),
        // marginBottom: theme.spacing(0),
        height: "4vh",
        minWidth: 400,
        maxWidth: 410,
    },
    formControl: {
        margin: theme.spacing(1),
        // marginBottom: theme.spacing(0),
        height: "4%",
        minWidth: '5%',
        maxWidth: '9%',
    },
    formControl1: {
        margin: theme.spacing(1),
        // marginBottom: theme.spacing(1),
        height: "4vh",
        minWidth: 160,
        maxWidth: 165,
    },
    formControl2: {
        margin: theme.spacing(1),
        // marginBottom: theme.spacing(1),
        height: "4vh",
        minWidth: 170,
        maxWidth: 180,
    },
    formRadio: {
        margin: theme.spacing(1),
        marginLeft: theme.spacing(8),
        height: "4vh",
        minWidth: 200,
        maxWidth: 200,
    },
    radio: {
        marginLeft: theme.spacing(1),
        marginTop: theme.spacing(3),
    },
    cardJob: {
        padding: theme.spacing(1),
    },
    paper: {
        padding: theme.spacing(1),
    },
    radiocard: {
        margin: theme.spacing(0.2),
        marginLeft: theme.spacing(1),
        height: 50,
    },
    card: {
        margin: theme.spacing(0.3),
        padding: theme.spacing(0.5),
    },
    card1: {
        marginTop: theme.spacing(0.3),
        marginLeft: theme.spacing(0.3),
        padding: theme.spacing(0.5),
    },
    card2: {
        marginTop: theme.spacing(0.3),
        marginRight: theme.spacing(0.3),
        padding: theme.spacing(0.5),
    },
    cardd3: {
        marginTop: theme.spacing(0.3),
        padding: theme.spacing(0.5),
    },
    card4: {
        marginLeft: theme.spacing(0.3),
        marginRight: theme.spacing(0.3),
        marginTop: theme.spacing(0.3),
        padding: theme.spacing(0.5),
    },
    card_OI: {
        marginRight: theme.spacing(0.3),
        padding: theme.spacing(0.5),
    },
    card_Tb: {
        padding: theme.spacing(0.5),
    }, tbsize: { minWidth: 700, maxWidth: 700 }
}));
const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: "royalblue",
        color: theme.palette.common.white,
    },

}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
    root: {
        '&:nth-of-type(odd)': {
            backgroundColor: 'white',
        },
    },
}))(TableRow);
function ImportTabs() {
    const classes = useStyles();
    const [radioValues, setRadioValues] = useState('');
    const [key, setKey] = useState('Query');
    const [jobDetails, setJobDetails] = useState([]);
    const [ImporterDetails, setImporterDetails] = useState([]);
    const [QuryYearDetails, setQuryYearDetails] = useState([]);
    const [QuryAmdntDetails, setQuryAmdntDetails] = useState([]);
    const [message, setMessage] = useState('');
    const [openSnack, setOpenSnack] = useState(false);
    const [severity, setSeverity] = useState('');
    const [QryalerJobNo, setQryalerJobNo] = useState('');
    const [qryvalues, setQryValues] = useState({
        imp_name: "", f_imp_Name: '', slct_year: "", qryslct_year: "", slct_job_no: "", qryslct_job_no: "",
        slct_edi_job: "", qryslct_edi_job: "", frm_date: '', to_date: '', licence_no: "", mawb_no: "",
        qrymawb_no: '', hawb_no: "", qryhawb_no: "", be_type_HWX: "", radio_input_cnt: "", slct_sublier: "",
        qryslct_sublier: "", slct_frwdr: "", qryslct_frwdr: "", item_decrption: "", qryitem_decrption: "", qryFindcusHousecode: '',
        slct_hs_code: "", qryslct_hs_code: "", slct_hs_Name: "", slct_portCode: "", slct_modeType: '', qryFindcusHouseName: ''
    })
    const [qryAmendvalue, setqryAmendvalue] = useState({
        Amnd_beNo: '', Amnd_beDate: '', Amnd_code: '', Amnd_RqstLtrNo: '', Amnd_RqstDate: '', Amnd_Reason: '',
    })
    const [QueryImprtOpen, setQueryImprtOpen] = useState(false)
    const [QueryearOpen, setQueryYearOpen] = useState(false);
    const [QuerJobOpen, setQuerJobOpen] = useState(false);
    const [QuerEdiJobOpen, setQuerEdiJobOpen] = useState(false);
    const [QuerMawbNoOpen, setQuerMawbNoOpen] = useState(false);
    const [QuerHawbNoOpen, setQuerHawbNoOpen] = useState(false);
    const [QuerSublierNoOpen, setQuerSublierNoOpen] = useState(false);
    const [QuerFrwdrOpen, setQuerFrwdrOpen] = useState(false);
    const [QuerDscrOpen, setQuerDscrOpen] = useState(false);
    const [QuerHsCodeOpen, setQuerHsCodeOpen] = useState(false);
    const [QueryCusHouseopen, setQueryCusHouseopen] = useState(false);
    const [QueryDublicateOpen, setQueryDublicateOpen] = useState(false);
    const [OpenJobAlert, setOpenJobAlert] = useState(false);
    const [OpenJobBOEupdation, setOpenJobBOEupdation] = useState(false);
    const [OpenJobPrint, setOpenJobPrint] = useState(false);
    const [QueryAmendmentDilgopen, setQueryAmendmentDilgopen] = useState(false);

    const [BeUpdationRespncDD, setBeUpdationRespncDD] = useState([]);
    const [QryProcsDupli, setQryProcsDupli] = useState(false);
    const [removeitemHiden, setRemoveItemHiden] = useState(true);
    const getItemandMove = () => {
        if (jobValues.job_no !== '') {
            if (invoicevalues.invoiceNo !== '' && invoicevalues.InvoiceId !== '') {
                resetitem(); drpData(); setKey('item'); document.getElementById('itemDesc').focus();
            } else { setMessage('Please Select Invoice From Invoice Table...!!'); setSeverity('warning'); setOpenSnack(true); }
        } else { setMessage('Please Enter Job.No From Job Table...!!'); setSeverity('warning'); setOpenSnack(true); }
    }
    const tabsselect = (k) => {
        if (k === 'Query') { JobReset(); reset(); jobDialogeReset(); setKey('Query') }
        else if (k === 'Master') {
            InvoiceReset();
            if (jobValues.job_no === '') {
                setKey('Master'); document.getElementById('MastertransiteType').focus();
                setEDiJobSaveDsa(false); setEDiJobUpdateDsa(true); setEDiJobDeleteDsa(true); setEDiJobSve(false); setEDiJobUpd(false); setEDiJobDlt(false); document.getElementById('MastertransiteType').focus();
            } else { getJobEntryAssign(jobValues.job_no); document.getElementById('MastertransiteType').focus(); }
        }
        else if (k === 'Invoice') {
            if (!jobValues.job_no || jobValues.job_no === '') { setMessage('Please Enter Job.No From Job Table...!!'); setSeverity('warning'); setOpenSnack(true); InvoiceReset(); }
            else { setKey('Invoice'); InvoiceReset(); InvoiceTableget(); document.getElementById('invoiceNo').focus(); }
            setItemSummury({
                ...ItemSummury, invoiceValue: '', terms: '', exchangeRate: '', currency: '', fright: '', insurence: '', misc: '', loadinng: '', totalValue: '',
                totalAmount: '', totalDuty: '', ass: '', bcd: '', cvd: '', sws: '', gst: '', duty: '', itm_fright: '', itm_insurence: '', itm_misc: '', itm_loadinng: '', itm_totalValue: ''
            })
        }
        else if (k === 'item') { getItemandMove(); } setJobDetails([]);
    }
    const drpData = () => {
        ItemService.getDutyType().then(res => { setItemIGSTdutyTypeDetails(res.data); setItemIGSTCessTypeDetails(res.data); })
        ItemService.getAddlDutyType().then(res => { setItemIGSTdutyAddTypeDetails(res.data); setItemIGSTCessAddTypeDetails(res.data); })
    }
    //-------------snack-handle--------------------------------
    const handleClose = () => { setOpenSnack(false); }
    //Radio onChange
    const RadioChangeHandle = (e) => { setRadioValues(e.target.value) }
    //On KeyDowns
    const QuryImpName = (e) => { if (e.key === 'F7') { QueryimporterHandleOpen(); } else if (e.key === 'Enter') { document.getElementById('QryYear').focus(); } }
    const QuryYear = (e) => { if (e.key === 'F7') { setQuryYearDetails([]); QueryYearHandleOpen(); } else if (e.key === 'Enter') { document.getElementById('slctJobNo').focus(); } }
    const QuryJobNo = (e) => { if (e.key === 'F7') { setQuryYearDetails([]); QueryJobHandleOpen(); } else if (e.key === 'Enter') { document.getElementById('slctEdiJobNo').focus(); } }
    const QuryEdiJobNo = (e) => { if (e.key === 'F7') { setQuryYearDetails([]); QueryEdiJobHandleOpen(); } else if (e.key === 'Enter') { document.getElementById('frmdate').focus(); } }
    const QuryEdiFrmDate = (e) => { if (e.key === 'Enter') { document.getElementById('toDate').focus(); } }
    const QuryEdiToDate = (e) => { if (e.key === 'Enter') { document.getElementById('Qrylicence').focus(); } }
    const QurylICENCE = (e) => { if (e.key === 'Enter') { document.getElementById('QryBeType').focus(); } }
    const QuryBeType = (e) => { if (e.key === 'Enter') { document.getElementById('mawbNo').focus(); } }
    const QuryMawbNo = (e) => { if (e.key === 'F7') { setQuryYearDetails([]); QueryMawbNoHandleOpen(); } else if (e.key === 'Enter') { document.getElementById('hawbNo').focus(); } }
    const QuryHawbNo = (e) => { if (e.key === 'F7') { setQuryYearDetails([]); QueryHawbNoHandleOpen(); } else if (e.key === 'Enter') { document.getElementById('QuryRadioInput').focus(); } }
    const QuryInvoiceSearch = (e) => { if (e.key === 'Enter') { document.getElementById('Qurysuplier').focus() } }
    const QurySupplier = (e) => { if (e.key === 'F7') { setQuryYearDetails([]); QuerySublierHandleOpen(); } else if (e.key === 'Enter') { document.getElementById('QuryFrwdr').focus(); } }
    const QuryFrwdr = (e) => { if (e.key === 'F7') { setQuryYearDetails([]); QueryFrwdrHandleOpen(); } else if (e.key === 'Enter') { document.getElementById('itemDiscription').focus(); } }
    const QuryItemDesc = (e) => { if (e.key === 'F7') { QueryDscriptionHandleOpen(); } else if (e.key === 'Enter') { document.getElementById('hsCode').focus(); } }
    const QuryHscode = (e) => { if (e.key === 'F7') { setQuryYearDetails([]); QueryHsCodeHandleOpen(); } else if (e.key === 'Enter') { document.getElementById('QuryModeType').focus(); } }
    const QuryModeTyypeKeyDown = (e) => { if (e.key === 'Enter') { document.getElementById('QuryCusHosCode').focus(); } }
    const QuryCusHosCodeKeyDown = (e) => { if (e.key === 'F7') { QueryCusHouseCodeHandleOpen(); } }
    //-------------------------onClose onOpen dialoge events-----------------------------------------
    const QueryImporterhandleClose = () => { setQueryImprtOpen(false); setQryValues({ ...qryvalues, f_imp_Name: '' }); setImporterDetails([]); setQuryIndex(0); setQuerImptrSelect([]) }
    const QueryimporterHandleOpen = () => {
        setQuryIndex(0)
        document.getElementById('qryimprter').focus(); setQueryImprtOpen(true); setQuerImptrSelect([])
        setQryValues({ ...qryvalues, f_imp_Name: qryvalues.imp_name }); setImporterDetails([]);
        var importername = '';
        if (qryvalues.imp_name !== '') { importername = qryvalues.imp_name; }
        else { importername = '-1' }
        let details = { importer_iec_no: '-1', importer_name: importername, flag: '2' }
        ImportQuerService.getImporter(details).then(res => { setImporterDetails(res.data) });
    }
    const QueryYearHandleClose = () => { setQueryYearOpen(false); setQryValues({ ...qryvalues, qryslct_year: '' }) }
    const QueryYearHandleOpen = () => {   setQuryIndex(0)
        setQueryYearOpen(true); setQryValues({ ...qryvalues, qryslct_year: qryvalues.slct_year }); setQuryYearDetails([]);
        var slct_year = '';
        if (qryvalues.slct_year !== '') {
            slct_year = qryvalues.slct_year;
        } else { slct_year = '-1' }
        let searchDetails = { importer_name: "-1", userJobDate: slct_year, consignmentNumber: "-1", userJobNo: "-1", mawbNo: "-1", hawb_no: "-1", status: "1", flag: "1" }
        ImportQuerService.getJobFilter(searchDetails).then(res => { setQuryYearDetails(res.data) });
    }
    const QueryJobHandleClose = () => {
        setQuerJobOpen(false);
        setQryValues({ ...qryvalues, qryslct_job_no: '' })
    }
    const QueryJobHandleOpen = () => {
        setQuryYearDetails([])
        setQryValues({ ...qryvalues, qryslct_job_no: qryvalues.slct_job_no })
        document.getElementById('slctJobNo').focus();
        setQuerJobOpen(true)
        var slct_job_no = '';
        if (qryvalues.slct_job_no !== '') {
            slct_job_no = qryvalues.slct_job_no;
        }
        else {
            slct_job_no = '-1'
        }
        let searchDetails = {
            importer_name: "-1", userJobDate: '-1', consignmentNumber: slct_job_no, userJobNo: "-1",
            mawbNo: "-1", hawb_no: "-1", status: "2", flag: "1"
        }
        ImportQuerService.getJobFilter(searchDetails).then(res => {
            setQuryYearDetails(res.data)
        })
    }
    const QueryEdiJobHandleClose = () => {
        setQuerEdiJobOpen(false);
        setQryValues({ ...qryvalues, qryslct_edi_job: '' })
    }
    const QueryEdiJobHandleOpen = () => {
        setQuryYearDetails([])
        setQryValues({ ...qryvalues, qryslct_edi_job: qryvalues.slct_edi_job })
        setQuerEdiJobOpen(true)
        var qryslctedijob = '';
        if (qryvalues.slct_edi_job !== '') {
            qryslctedijob = qryvalues.slct_edi_job
        }
        else {
            qryslctedijob = '-1'
        }
        let searchDetails = {
            importer_name: "-1", userJobDate: '-1', consignmentNumber: '-1', userJobNo: qryslctedijob,
            mawbNo: "-1", hawb_no: "-1", status: "2", flag: "1"
        }
        ImportQuerService.getJobFilter(searchDetails).then(res => {
            setQuryYearDetails(res.data)
        })
    }
    const QueryMawbNoHandleClose = () => { setyearImptrSelect([]);
        setQuerMawbNoOpen(false);
        setQryValues({ ...qryvalues, qrymawb_no: '' })
    }
    const QueryMawbNoHandleOpen = () => {
        setQuryYearDetails([])
        setQryValues({ ...qryvalues, qrymawb_no: qryvalues.mawb_no })
        setQuerMawbNoOpen(true)
        var qrymawb_no = '';
        if (qryvalues.mawb_no !== '') {
            qrymawb_no = qryvalues.mawb_no;
        } else {
            qrymawb_no = '-1'
        }
        let searchDetails = {
            importer_name: "-1", userJobDate: '-1', consignmentNumber: '-1', userJobNo: '-1',
            mawbNo: qrymawb_no, hawb_no: "-1", status: "4", flag: "1"
        }
        ImportQuerService.getJobFilter(searchDetails).then(res => {
            setQuryYearDetails(res.data)
        })
    }
    const QueryHawbNoHandleClose = () => {
        setQuerHawbNoOpen(false);
        setQryValues({ ...qryvalues, qryhawb_no: '' })
    }
    const QueryHawbNoHandleOpen = () => {
        setQuryYearDetails([])
        setQryValues({ ...qryvalues, qryhawb_no: qryvalues.hawb_no })
        setQuerHawbNoOpen(true)
        var qryhawbno = '';
        if (qryvalues.hawb_no !== '') {
            qryhawbno = qryvalues.hawb_no;
        } else {
            qryhawbno = '-1'
        }
        let searchDetails = {
            importer_name: "-1", userJobDate: '-1', consignmentNumber: '-1', userJobNo: '-1', mawbNo: '-1',
            hawb_no: qryhawbno, status: "5", flag: "1"
        }
        ImportQuerService.getJobFilter(searchDetails).then(res => {
            setQuryYearDetails(res.data)
        })
    }
    const QuerySublierHandleClose = () => {
        setQuerSublierNoOpen(false);
        setQryValues({ ...qryvalues, qryslct_sublier: '' })
    }
    const QuerySublierHandleOpen = () => {
        setQuryYearDetails([])
        setQryValues({ ...qryvalues, qryslct_sublier: qryvalues.slct_sublier })
        setQuerSublierNoOpen(true)
        var slctsublier = '';
        if (qryvalues.slct_sublier !== '') {
            slctsublier = qryvalues.slct_sublier;
        } else {
            slctsublier = '-1'
        }
        let searchDetails = { supplierName: slctsublier, flag: '2' }
        InvoiceService.getSupplierDetails(searchDetails).then(res => {
            setQuryYearDetails(res.data)
        })
    }
    const QueryFrwdrHandleClose = () => {
        setQryValues({ ...qryvalues, qryslct_frwdr: '' })
        setQuerFrwdrOpen(false);
    }
    const QueryFrwdrHandleOpen = () => {
        setQuryYearDetails([])
        setQryValues({ ...qryvalues, qryslct_frwdr: qryvalues.slct_frwdr })
        setQuerFrwdrOpen(true)
        var slctfrwdr = '';
        if (qryvalues.slct_frwdr !== '') {
            slctfrwdr = qryvalues.slct_frwdr;
        } else {
            slctfrwdr = '-1'
        }
        let searchDetails = { freightFwdName: slctfrwdr }
        ImportQuerService.getForwarderName(searchDetails).then(res => {
            setQuryYearDetails(res.data)
        })
    }
    const QueryDscriptionHandleClose = () => {
        setQuerDscrOpen(false);
        setQryValues({ ...qryvalues, qryitem_decrption: '' })

    }
    const QueryDscriptionHandleOpen = () => {
        setQuryYearDetails([])
        setQryValues({ ...qryvalues, qryitem_decrption: qryvalues.item_decrption })
        setQuerDscrOpen(true);
        var itemName = '';
        if (!qryvalues.item_decrption) {
            itemName = '-1'
        } else {
            itemName = qryvalues.item_decrption
        }
        ItemService.getItemNameSearch(itemName, 1).then(res => {
            setQuryYearDetails(res.data)
        })
    }
    const QueryHsCodeHandleClose = () => {
        setQuerHsCodeOpen(false);
        setQryValues({ ...qryvalues, slct_hs_Name: '', qryslct_hs_code: '' })
    }
    const QueryHsCodeHandleOpen = () => {
        setQuryYearDetails([])
        setQryValues({ ...qryvalues, qryslct_hs_code: qryvalues.slct_hs_code })
        setQuerHsCodeOpen(true)
        var slcthscode = '';
        if (qryvalues.slct_hs_code !== '') {
            slcthscode = qryvalues.slct_hs_code;
        } else {
            slcthscode = '-1'
        }
        let details = { hsCode: slcthscode, hsName: '-1', flag: '1' }
        ItemService.getHsCode(details).then(res => {
            setQuryYearDetails(res.data)
        })
    }
    const QueryCusHouseCodeHandleClose = () => {
        setQueryCusHouseopen(false);
        setQryValues({ ...qryvalues, qryFindcusHouseName: '', qryFindcusHousecode: '' })
    }
    const QueryCusHouseCodeHandleOpen = () => {
        setQuryYearDetails([]); setQueryCusHouseopen(true); setQryValues({ ...qryvalues, qryFindcusHousecode: qryvalues.slct_portCode, qryFindcusHouseName: '' });
        var CustomHousecode, transitTypeCode = '';
        if (qryvalues.slct_portCode === '' || !qryvalues.slct_portCode) { CustomHousecode = '-1' }
        else { CustomHousecode = qryvalues.slct_portCode; }
        if (qryvalues.slct_modeType !== '') { transitTypeCode = qryvalues.slct_modeType; }
        else { transitTypeCode = '-1' }
        let details = { cusHouseCode: CustomHousecode, transitTypeCode: transitTypeCode, customHouseLocation: '-1' };
        ImportQuerService.getCustomHouseCodeForDashBoard(details).then(res => {
            setQuryYearDetails(res.data)
        })
    }

    const QueryDublicateJobClose = () => {
        setQueryDublicateOpen(false)
    }
    const QueryDublicateJobOpen = () => {
        setQueryDublicateOpen(true)
    }

    const QueryAmendmentDilgHandleClose = () => {
        setQueryAmendmentDilgopen(false)
        ClearBeAmendment();
    }

    const QueryAmendmentDilgHandleOpen = () => {
        if (qryvalues.slct_job_no !== '') {
            setQueryAmendmentDilgopen(true)
            ImportQuerService.getAmendmentCode().then(res => {
                setQuryAmdntDetails(res.data);
            })
            getBeAmendDetails()
        } else {
            setMessage('Kindly select the job'); setSeverity('warning'); setOpenSnack(true); document.getElementById('slctJobNo').focus();
        }
    }

    //....................Amenment validation.......
    const AmendmentValidation = () => {
        if (qryAmendvalue.Amnd_code !== '') {
            if (qryAmendvalue.Amnd_RqstLtrNo !== '') {
                if (qryAmendvalue.Amnd_RqstDate !== '') {
                    if (qryAmendvalue.Amnd_Reason !== '') {
                        return true;
                    } else {
                        setMessage('Please Enter the Responce ..!!'); setSeverity('warning'); setOpenSnack(true); document.getElementById('reason').focus();
                    }
                } else {
                    setMessage('Please Select the Req Date ..!!'); setSeverity('warning'); setOpenSnack(true); document.getElementById('requestDate').focus();
                }
            } else {
                setMessage('Please Enter the Req Letter ..!!'); setSeverity('warning'); setOpenSnack(true); document.getElementById('rqstLtrno').focus();
            }
        } else {
            setMessage('Please Select the Amend Code ..!!'); setSeverity('warning'); setOpenSnack(true); document.getElementById('AmendmentCode').focus();
        }
        return false;
    }

    //--------------------Dialogbox=onClick events-----------------------------------

    const AddAmendOnClick = () => {
        if (AmendmentValidation() === true) {
            let details = {
                consignmentNumber: qryvalues.slct_job_no, amendCode: qryAmendvalue.Amnd_code,
                reasonForAmend: qryAmendvalue.Amnd_Reason, reqLetterNo: qryAmendvalue.Amnd_RqstLtrNo, reqDate: qryAmendvalue.Amnd_RqstDate
            }
            ImportQuerService.insertBeAmendment(details).then(res => {
                const message = res.data.message;
                if (message.toString() === "SUCCESS") {
                    setMessage('Insert Successfully'); setSeverity('success'); setOpenSnack(true); QueryDublicateJobno()
                } else {
                    setMessage(message.toString()); setSeverity('error'); setOpenSnack(true);
                }
            }).catch(error => { setMessage(error.message); setSeverity('error'); setOpenSnack(true); InvoiceSvbReset(); })
        }
    }
    const UpdateAmendOnClick = () => {
        if (AmendmentValidation() === true) {
            let details = {
                consignmentNumber: qryvalues.slct_job_no, amendCode: qryAmendvalue.Amnd_code,
                reasonForAmend: qryAmendvalue.Amnd_Reason, reqLetterNo: qryAmendvalue.Amnd_RqstLtrNo, reqDate: qryAmendvalue.Amnd_RqstDate
            }
            ImportQuerService.updateBeAmendment(details).then(res => {
                const message = res.data.message;
                if (message.toString() === "SUCCESS") {
                    setMessage('update Successfully'); setSeverity('success'); setOpenSnack(true); getBeAmendDetails();
                } else {
                    setMessage(message.toString()); setSeverity('error'); setOpenSnack(true);
                }
            }).catch(error => { setMessage(error.message); setSeverity('error'); setOpenSnack(true); InvoiceSvbReset(); })
        }
    }
    const getBeAmendDetails = () => {
        let details = { consignmentNumber: qryvalues.slct_job_no }
        ImportQuerService.getBeAmendDetails(details).then(res => {
            const data = res.data;
            const Amntdetails = data.map((beDetail) => beDetail);
            setqryAmendvalue({
                ...qryAmendvalue, Amnd_beNo: Amntdetails[0].beNo, Amnd_beDate: Amntdetails[0].beDate, Amnd_code: Amntdetails[0].amendCode, Amnd_RqstLtrNo: Amntdetails[0].reqLetterNo,
                Amnd_RqstDate: Amntdetails[0].reqDate, Amnd_Reason: Amntdetails[0].reasonForAmend
            })
        })
    }
    const ClearBeAmendment = () => {
        setqryAmendvalue({ ...qryAmendvalue, Amnd_beNo: '', Amnd_beDate: '', Amnd_code: '', Amnd_RqstLtrNo: '', Amnd_RqstDate: '', Amnd_Reason: '' });
    }
    //--------------dialogBox_KeyDown---------------------//

    const [QuryIndex, setQuryIndex] = useState(0);
    const [MasterTransitSelect ,setMasterTransitSelect] = useState([]);
    const [InvoiceSelect ,setInvoiceSelect] = useState([]);
    const [ItemSelect ,setItemSelect] = useState([]);
    const QueryImpTbleDown = (e) => {
        if (e.key === 'ArrowDown') {
            const myData = ImporterDetails.map((node) => node);
            let selectDetails = []; selectDetails = (QuerImptrSelect, myData[QuryIndex + 1].importer_name); setQuerImptrSelect(selectDetails); setQuryIndex(QuryIndex + 1);
        }
        if (e.key === 'ArrowUp') {
            const myData = ImporterDetails.map((node) => node);
            let selectDetails = []; selectDetails = (QuerImptrSelect, myData[QuryIndex - 1].importer_name); setQuerImptrSelect(selectDetails); setQuryIndex(QuryIndex - 1);
        }
        if (e.key === 'Enter') {
            const myData = ImporterDetails.map((node) => node); var txt_selectImporter = '';
            if (myData[QuryIndex].importer_name === '' || !myData[QuryIndex].importer_name) { txt_selectImporter = '-1'; }
            else { txt_selectImporter = myData[QuryIndex].importer_name; }
            let searchDetails = {
                importer_name: txt_selectImporter, userJobDate: '-1', consignmentNumber: '-1', userJobNo: '-1', fromDate: '-1', toDate: '-1', mawbNo: "-1", hawb_no: "-1", impTypeBoe: '-1',
                invoiceNumber: "-1", freightFwdName: "-1", status: "null", flag: "1", supplierName: "-1", licence: "-1", item_description: "-1", hsCode: "-1", modeType: '-1', portCode: '-1'
            }
            ImportQuerService.getJobSearch(searchDetails).then(res => { setJobDetails(res.data); }); setQueryImprtOpen(false); setQryValues({ ...qryvalues, imp_name: myData[QuryIndex].importer_name })
        }
    }
    const QueryJobTbleDown = (e) => {  const myData = jobDetails.map((node) => node);let selectDetails = [];
        if (e.key === 'ArrowDown') { selectDetails = (yearImptrSelect, myData[QuryIndex + 1].consignmentNumber); setyearImptrSelect(selectDetails); setQuryIndex(QuryIndex + 1);   }
        if (e.key === 'ArrowUp') { selectDetails = (yearImptrSelect, myData[QuryIndex - 1].consignmentNumber); setyearImptrSelect(selectDetails); setQuryIndex(QuryIndex - 1); }
        if (e.key === 'Enter') {editJobsdetails(myData[QuryIndex])}
    }
    const QueryYearTbleDown = (e,type) => { 
        if (e.key === 'ArrowDown') {
            const myData = QuryYearDetails.map((node) => node);
            let selectDetails = []; if(type==='s'){selectDetails = (yearImptrSelect, myData[QuryIndex + 1].supplierName);}
            else if(type==='f'){selectDetails = (yearImptrSelect, myData[QuryIndex + 1].freightFwdName);} 
            else if(type==='c'){selectDetails = (yearImptrSelect, myData[QuryIndex + 1].customHouseCode);} 
            else if(type==='i'){selectDetails = (yearImptrSelect, myData[QuryIndex + 1].item_description);} else if(type==='hs'){selectDetails = (yearImptrSelect, myData[QuryIndex + 1].hsCode);}
            else{selectDetails = (yearImptrSelect, myData[QuryIndex + 1].consignmentNumber);} setyearImptrSelect(selectDetails); setQuryIndex(QuryIndex + 1);
        }
        if (e.key === 'ArrowUp') {
            const myData = QuryYearDetails.map((node) => node);
            let selectDetails = []; if(type==='s'){selectDetails = (yearImptrSelect, myData[QuryIndex - 1].supplierName);}
            else if(type==='f'){selectDetails = (yearImptrSelect, myData[QuryIndex - 1].freightFwdName);}
            else if(type==='i'){selectDetails = (yearImptrSelect, myData[QuryIndex - 1].item_description);}
            else if(type==='c'){selectDetails = (yearImptrSelect, myData[QuryIndex - 1].customHouseCode);}
            else if(type==='hs'){selectDetails = (yearImptrSelect, myData[QuryIndex - 1].hsCode);}
            else{selectDetails = (yearImptrSelect, myData[QuryIndex - 1].consignmentNumber);} setyearImptrSelect(selectDetails); setQuryIndex(QuryIndex - 1);
        }
        if (e.key === 'Enter') {
            const myData = QuryYearDetails.map((node) => node); var txt_selectYear ,txt_consigment ,txt_edi_job ,mawb_no ,hawb_no= '-1';
            var suplier='-1';var freightFwdName='-1';var item_desc= '-1';var hsCode='-1';var customHouseCode='-1';
            if(type==='y'){
            if (myData[QuryIndex].consignmentNumber === '' || !myData[QuryIndex].consignmentNumber) { txt_selectYear = '-1'; }
            else { txt_selectYear = myData[QuryIndex].consignmentNumber; } setQueryYearOpen(false);txt_consigment='-1';txt_edi_job='-1';hawb_no='-1';mawb_no='-1';setQryValues({ ...qryvalues, slct_year: myData[QuryIndex].consignmentNumber })
            }else if(type==='j'){
                if (myData[QuryIndex].consignmentNumber === '' || !myData[QuryIndex].consignmentNumber) { txt_consigment = '-1'; }
                else { txt_consigment = myData[QuryIndex].consignmentNumber; } setQuerJobOpen(false);txt_edi_job='-1';txt_selectYear='-1';hawb_no='-1';mawb_no='-1';setQryValues({ ...qryvalues, slct_job_no: myData[QuryIndex].consignmentNumber })
            }else if(type==='e'){
                if (myData[QuryIndex].consignmentNumber === '' || !myData[QuryIndex].consignmentNumber) { txt_edi_job = '-1'; }
                else { txt_edi_job = myData[QuryIndex].consignmentNumber; } setQuerEdiJobOpen(false);txt_consigment='-1';txt_selectYear='-1';hawb_no='-1';mawb_no='-1';setQryValues({ ...qryvalues, slct_edi_job: myData[QuryIndex].consignmentNumber })
            }else if(type==='m'){
                if (myData[QuryIndex].consignmentNumber === '' || !myData[QuryIndex].consignmentNumber) { mawb_no = '-1'; }
                else { mawb_no = myData[QuryIndex].consignmentNumber; } setQuerMawbNoOpen(false);txt_consigment='-1';txt_selectYear='-1';hawb_no='-1';txt_edi_job='-1';setQryValues({ ...qryvalues, mawb_no: myData[QuryIndex].consignmentNumber })
            }else if(type==='h'){
                if (myData[QuryIndex].consignmentNumber === '' || !myData[QuryIndex].consignmentNumber) { hawb_no = '-1'; }
                else { hawb_no = myData[QuryIndex].consignmentNumber; } setQuerHawbNoOpen(false);txt_consigment='-1';txt_selectYear='-1';txt_edi_job='-1';mawb_no='-1';setQryValues({ ...qryvalues, hawb_no: myData[QuryIndex].consignmentNumber })
            }else if(type==='s'){
                if (myData[QuryIndex].supplierName === '' || !myData[QuryIndex].supplierName) { suplier = '-1'; }
                else { suplier = myData[QuryIndex].supplierName; } setQuerSublierNoOpen(false);txt_consigment='-1';txt_selectYear='-1';txt_edi_job='-1';mawb_no='-1';hawb_no='-1';setQryValues({ ...qryvalues, slct_sublier: myData[QuryIndex].supplierName })
            }else if(type==='f'){
                if (myData[QuryIndex].freightFwdName === '' || !myData[QuryIndex].freightFwdName) { freightFwdName = '-1'; }
                else { freightFwdName = myData[QuryIndex].freightFwdName; } setQuerFrwdrOpen(false);txt_consigment='-1';txt_selectYear='-1';txt_edi_job='-1';mawb_no='-1';hawb_no='-1';setQryValues({ ...qryvalues, slct_frwdr: myData[QuryIndex].freightFwdName })
            }else if(type==='i'){
                if (myData[QuryIndex].item_description === '' || !myData[QuryIndex].item_description) { item_desc = '-1'; }
                else { item_desc = myData[QuryIndex].item_description; } setQuerDscrOpen(false);txt_consigment='-1';txt_selectYear='-1';txt_edi_job='-1';mawb_no='-1';hawb_no='-1';setQryValues({ ...qryvalues, item_decrption: myData[QuryIndex].item_description })
            }else if(type==='hs'){
                if (myData[QuryIndex].hsCode === '' || !myData[QuryIndex].hsCode) { hsCode = '-1'; }
                else { hsCode = myData[QuryIndex].item_description; } setQuerHsCodeOpen(false);txt_consigment='-1';txt_selectYear='-1';txt_edi_job='-1';mawb_no='-1';hawb_no='-1';setQryValues({ ...qryvalues, slct_hs_code: myData[QuryIndex].hsCode })
            }else if(type==='c'){
                if (myData[QuryIndex].customHouseCode === '' || !myData[QuryIndex].customHouseCode) { customHouseCode = '-1'; }
                else { customHouseCode = myData[QuryIndex].customHouseCode; } setQueryCusHouseopen(false);txt_consigment='-1';txt_selectYear='-1';txt_edi_job='-1';mawb_no='-1';hawb_no='-1';setQryValues({ ...qryvalues, slct_portCode: myData[QuryIndex].customHouseCode })
            }
            let searchDetails = {
                importer_name: '-1', userJobDate:txt_selectYear, consignmentNumber: txt_consigment, userJobNo: txt_edi_job, fromDate: '-1', toDate: '-1', mawbNo: mawb_no, hawb_no: hawb_no, impTypeBoe: '-1',
                invoiceNumber: "-1", freightFwdName: freightFwdName, status: "null", flag: "1", supplierName: suplier, licence: "-1", item_description: item_desc, hsCode: hsCode, modeType: '-1', portCode: customHouseCode,cusHouseCode:customHouseCode
            }
            ImportQuerService.getJobSearch(searchDetails).then(res => { setJobDetails(res.data); }); 
        }
    }
    const HandleQuryDialogImpName = (e) => {
        if (e.key === 'Enter') {
            setQuerImptrSelect([]);
            document.getElementById("QuryImpTbl").focus(); setQuryIndex(0)
            const myData = ImporterDetails.map((node) => node); let seclindex = [];
            seclindex = (QuerImptrSelect, myData[0].importer_name); setQuerImptrSelect(seclindex);
        }
    }

    const QueryYearKeyDown=(e)=>{
        if (e.key === 'Enter') {
            setyearImptrSelect([]);
            document.getElementById("yearQuery_id").focus(); setQuryIndex(0)
            const myData = QuryYearDetails.map((node) => node); let seclindex = [];
            seclindex = (yearImptrSelect, myData[0].consignmentNumber); setyearImptrSelect(seclindex);
        }
    }

    const QueryJobKeyDown=(e)=>{
        if ( e.key === 'Enter') {
            setyearImptrSelect([]);document.getElementById("JobQuery_id").focus(); setQuryIndex(0)
            const myData = QuryYearDetails.map((node) => node); let seclindex = [];
            seclindex = (yearImptrSelect, myData[0].consignmentNumber); setyearImptrSelect(seclindex);
        }
    }

    const queryEdiJobKeyDownHandle=(e)=>{
        if ( e.key === 'Enter') {
            setyearImptrSelect([]);document.getElementById("EdiJobQuery_id").focus(); setQuryIndex(0)
            const myData = QuryYearDetails.map((node) => node); let seclindex = [];
            seclindex = (yearImptrSelect, myData[0].consignmentNumber); setyearImptrSelect(seclindex);
        }  
    }

    const queryMawbKeyDownHandle=(e)=>{
        if (e.key === 'Enter') {
            setyearImptrSelect([]);document.getElementById("mawbQuery_id").focus(); setQuryIndex(0)
            const myData = QuryYearDetails.map((node) => node); let seclindex = [];
            seclindex = (yearImptrSelect, myData[0].consignmentNumber); setyearImptrSelect(seclindex);
        }  
    }
    const queryHawbKeyDownHandle=(e)=>{
        if (e.key === 'Enter') {
            setyearImptrSelect([]);document.getElementById("hawbQuery_id").focus(); setQuryIndex(0)
            const myData = QuryYearDetails.map((node) => node); let seclindex = [];
            seclindex = (yearImptrSelect, myData[0].consignmentNumber); setyearImptrSelect(seclindex);
        }  
    }
    const querySuplierKeyDownHandle=(e)=>{
        if (e.key === 'Enter') {
            setyearImptrSelect([]);document.getElementById("suplierQuery_id").focus(); setQuryIndex(0)
            const myData = QuryYearDetails.map((node) => node); let seclindex = [];
            seclindex = (yearImptrSelect, myData[0].supplierName); setyearImptrSelect(seclindex);
        }  
    }
    const queryFrwdKeyDownHandle=(e)=>{
        if (e.key === 'Enter') {
            setyearImptrSelect([]);document.getElementById("frwdQuery_id").focus(); setQuryIndex(0)
            const myData = QuryYearDetails.map((node) => node); let seclindex = [];
            seclindex = (yearImptrSelect, myData[0].freightFwdName); setyearImptrSelect(seclindex);
        }   
    }
    const queryItemDescKeyDownHandle=(e)=>{
        if ( e.key === 'Enter') {
            setyearImptrSelect([]);document.getElementById("itemDescQuery_id").focus(); setQuryIndex(0)
            const myData = QuryYearDetails.map((node) => node); let seclindex = [];
            seclindex = (yearImptrSelect, myData[0].item_description); setyearImptrSelect(seclindex);
        }   
    }

    const queryHsNameKeyDownHandle=(e)=>{
        if (e.key === 'Enter') {
            setyearImptrSelect([]);document.getElementById("hsCodeQuery_id").focus(); setQuryIndex(0)
            const myData = QuryYearDetails.map((node) => node); let seclindex = [];
            seclindex = (yearImptrSelect, myData[0].hsCode); setyearImptrSelect(seclindex);
        }  
    }
    const queryCustomKeyDownHandle=(e)=>{
        if ( e.key === 'Enter') {
            setyearImptrSelect([]);document.getElementById("customhouseCodeQuery_id").focus(); setQuryIndex(0)
            const myData = QuryYearDetails.map((node) => node); let seclindex = [];
            seclindex = (yearImptrSelect, myData[0].customHouseCode); setyearImptrSelect(seclindex);
        }  
    }
    const QuryJobAmndBeKeyDown=(e)=>{
        if ( e.key === 'Enter') {  const myData = jobDetails.map((node) => node); let seclindex = [];
            setyearImptrSelect([]);document.getElementById("jobDetailsQuery_id").focus(); setQuryIndex(0)          
            seclindex = (yearImptrSelect, myData[0].consignmentNumber); setyearImptrSelect(seclindex);
        }  
    }
    const queryHsCodeKeyDownHandle=(e)=>{if (e.key === 'Enter'){document.getElementById("queryDialog_hsName_id").focus();}}
    const queryCustomnameKeyDownHandle=(e)=>{if (e.key === 'Enter'){document.getElementById("find_qury_customHouseCode_id").focus();}}

    //--------------------onClick events-----------------------------------
    const [QuerImptrSelect, setQuerImptrSelect] = useState([]);
    const [yearImptrSelect, setyearImptrSelect] = useState([]);
    const editImportQry = (importer, i) => {
        let valueSlected = [];
        valueSlected = (QuerImptrSelect, importer.importer_name)
        setQuerImptrSelect(valueSlected); setQuryIndex(i)
        setQryValues({ ...qryvalues, imp_name: importer.importer_name })
        var txt_selectImporter = '';
        if (importer.importer_name !== '') { txt_selectImporter = importer.importer_name; }
        else { txt_selectImporter = '-1'; }
        let searchDetails = {
            importer_name: txt_selectImporter, userJobDate: '-1', consignmentNumber: '-1', userJobNo: '-1', fromDate: '-1', toDate: '-1', mawbNo: "-1", hawb_no: "-1", impTypeBoe: '-1',
            invoiceNumber: "-1", freightFwdName: "-1", status: "null", flag: "1", supplierName: "-1", licence: "-1", item_description: "-1", hsCode: "-1", modeType: '-1', portCode: '-1'
        }
        ImportQuerService.getJobSearch(searchDetails).then(res => { setJobDetails(res.data); });
        setQueryImprtOpen(false);
    }
    const editQryYear = (year,i) => {
        let valueSlected = [];
        valueSlected = (yearImptrSelect, year.consignmentNumber)
        setyearImptrSelect(valueSlected); setQuryIndex(i)
        setQryValues({ ...qryvalues, slct_year: year.consignmentNumber });
        var txt_selectYear = '';
        if (year.consignmentNumber !== '') { txt_selectYear = year.consignmentNumber; }
        else { txt_selectYear = '-1'; }
        let searchDetails = {
            importer_name: '-1', userJobDate: txt_selectYear, consignmentNumber: '-1', userJobNo: '-1', fromDate: '-1', toDate: '-1', mawbNo: "-1", hawb_no: "-1", impTypeBoe: '-1',
            invoiceNumber: "-1", freightFwdName: "-1", status: "null", flag: "1", supplierName: "-1", licence: "-1", item_description: "-1", hsCode: "-1", modeType: '-1', portCode: '-1'
        }
        ImportQuerService.getJobSearch(searchDetails).then(res => { setJobDetails(res.data); }); setQueryYearOpen(false);
    }
    const editJobNo = (jobno,i) => {
        setQryValues({ ...qryvalues, slct_job_no: jobno.consignmentNumber })
        var txt_selectJobNo = '';
        if (jobno.consignmentNumber !== '') { txt_selectJobNo = jobno.consignmentNumber; }
        else { txt_selectJobNo = '-1'; }
        let searchDetails = {
            importer_name: '-1', userJobDate: '-1', consignmentNumber: txt_selectJobNo, userJobNo: '-1',
            fromDate: '-1', toDate: '-1', mawbNo: "-1", hawb_no: "-1", impTypeBoe: '-1', invoiceNumber: "-1", freightFwdName: "-1", status: "null", flag: "1",
            supplierName: "-1", licence: "-1", item_description: "-1", hsCode: "-1", modeType: '-1', portCode: '-1'
        }
        ImportQuerService.getJobSearch(searchDetails).then(res => { setJobDetails(res.data); });
        setQuerJobOpen(false);
    }
    const editEDiJonNo = (edi) => {
        setQryValues({ ...qryvalues, slct_edi_job: edi.consignmentNumber })
        var txt_selectUserJobNo = '';
        if (edi.consignmentNumber !== '') {
            txt_selectUserJobNo = edi.consignmentNumber;
        }
        else {
            txt_selectUserJobNo = '-1';
        }
        let searchDetails = {
            importer_name: '-1', userJobDate: '-1', consignmentNumber: '-1', userJobNo: txt_selectUserJobNo, fromDate: '-1', toDate: '-1', mawbNo: "-1", hawb_no: "-1", impTypeBoe: '-1',
            invoiceNumber: "-1", freightFwdName: "-1", status: "null", flag: "1", supplierName: "-1", licence: "-1", item_description: "-1", hsCode: "-1", modeType: '-1', portCode: '-1'
        }
        ImportQuerService.getJobSearch(searchDetails).then(res => {
            setJobDetails(res.data);
        }).catch(error => {

        })
        setQuerEdiJobOpen(false)
    }

    const editMawbNo = (mawb) => {
        setQryValues({ ...qryvalues, mawb_no: mawb.consignmentNumber })
        let searchDetails = {
            importer_name: "-1", userJobDate: '-1', consignmentNumber: '-1', userJobNo: "-1",
            fromDate: "-1", toDate: "-1", mawbNo: mawb.consignmentNumber, hawb_no: "-1", impTypeBoe: "-1",
            invoiceNumber: "-1", freightFwdName: "-1", status: "null", flag: "3", supplierName: "-1",
            licence: "-1", item_description: "-1", hsCode: "-1", modeType: '-1', portCode: '-1'
        }
        ImportQuerService.getJobSearch(searchDetails).then(res => {
            setJobDetails(res.data);
        }).catch(error => {

        })
        setQuerMawbNoOpen(false);
    }
    const editHawbNo = (hawb) => {
        setQryValues({ ...qryvalues, hawb_no: hawb.consignmentNumber })
        setJobDetails([]);
        let searchDetails = {
            importer_name: "-1", userJobDate: '-1', consignmentNumber: '-1', userJobNo: "-1",
            fromDate: "-1", toDate: "-1", mawbNo: '-1', hawb_no: hawb.consignmentNumber, impTypeBoe: "-1",
            invoiceNumber: "-1", freightFwdName: "-1", status: "null", flag: "3", supplierName: "-1",
            licence: "-1", item_description: "-1", hsCode: "-1", modeType: '-1', portCode: '-1'
        }
        ImportQuerService.getJobSearch(searchDetails).then(res => {
            setJobDetails(res.data);
        })
        setQuerHawbNoOpen(false);
    }

    const NewJob = () => {
        setKey('Master')
    }
    const editJobsdetails = (jobs) => {
        if (jobs.consignmentNumber === '') { setMessage('Please Select Job No from Job Table'); setSeverity('error'); setOpenSnack(true); }
        else { getJobEntryAssign(jobs.consignmentNumber); document.getElementById('MastertransiteType').focus(); }
    }
    const getJobEntryAssign = (job) => {
        let details = { consignmentId: job, consignmentNumber: job, flag: '1' }
        ImportQuerService.getConsignmentJobEntryAssign(details).then(res => {
            setEDiJobSaveDsa(true); setEDiJobUpdateDsa(false); setEDiJobDeleteDsa(false);
            setEDiJobSve(false); setEDiJobUpd(false); setEDiJobDlt(false); setKey('Master');
            const allData = res.data;
            const mappingDatas = allData.map(((asignData) => asignData));
            setJobValues({
                ...jobValues, job_no: mappingDatas[0].consignmentNumber, mode_A_L_S: mappingDatas[0].transitTypeId, edi_job_no: mappingDatas[0].userJobNo,
                model_A_L_S_Name: mappingDatas[0].transitTypeName, customHousCode: mappingDatas[0].cusHouseCode, chs_name: mappingDatas[0].customHouseLocation, branch: mappingDatas[0].regionalName,
                iec_search: mappingDatas[0].importer_iec_no, forwarder: mappingDatas[0].freightFwdName, name: mappingDatas[0].importer_name, branch_sr_no: mappingDatas[0].branchId, address_1: mappingDatas[0].importerAddress,
                addresh_2: mappingDatas[0].importerAddress1, state: mappingDatas[0].deliveryStateName, countryOrigin: mappingDatas[0].countryId, ad_code: mappingDatas[0].ad_code,
                countryOriginName: mappingDatas[0].countryName, countrt_of_cm: mappingDatas[0].countryOfCmId, countrt_of_cmName: mappingDatas[0].countryOfCmName, port_of_loding: mappingDatas[0].origin_portId,
                port_of_lodingName: mappingDatas[0].origin_portName, certificate_y_N: mappingDatas[0].certificate, bond_y_N: mappingDatas[0].bond, container_detail: mappingDatas[0].beContainer,
                class_g_p_n: mappingDatas[0].impClass, type_H_W_x: mappingDatas[0].typeBoeCode, imp_type_G_O_p_U: mappingDatas[0].impTypeBoeCode, kacha_y_N: mappingDatas[0].kacha, dif_def: mappingDatas[0].defBoe, green_chn: mappingDatas[0].greenChn, hss_y_n: mappingDatas[0].hss,
            })
            let jobnum = { consignmentId: mappingDatas[0].consignmentNumber }
            JobServices.getIGM_Details(jobnum).then(res => { setJobIgmDetails(res.data); })
            if (mappingDatas[0].transitTypeId === 'a' || mappingDatas[0].transitTypeId === 'A') {
                setJobGateWayhide(true); setJobRepPorthide(true);
            } else { setJobGateWayhide(false); setJobRepPorthide(false); }
        }).catch(error => { setMessage(error.message); setSeverity('error'); setOpenSnack(true); })
    }
    const editFrwder = (frwdr) => {
        setQryValues({ ...qryvalues, slct_frwdr: frwdr.freightFwdName })
        let searchDetails = {
            importer_name: '-1', userJobDate: '-1', consignmentNumber: "-1", userJobNo: "-1", fromDate: "-1", toDate: "-1", mawbNo: "-1", hawb_no: "-1",
            impTypeBoe: "-1", invoiceNumber: "-1", freightFwdName: frwdr.freightFwdName, status: "null", flag: "7", supplierName: "-1",
            licence: "-1", item_description: "-1", hsCode: "-1", modeType: '-1', portCode: '-1'
        }
        ImportQuerService.getJobSearch(searchDetails).then(res => { setJobDetails(res.data); })
        setQuerFrwdrOpen(false)
    }
    const editSupplier = (suplier) => {
        setQryValues({ ...qryvalues, slct_sublier: suplier.supplierName });
        let searchDetails = {
            importer_name: '-1', userJobDate: '-1', consignmentNumber: "-1", userJobNo: "-1", fromDate: "-1", toDate: "-1", mawbNo: "-1", hawb_no: "-1",
            impTypeBoe: "-1", invoiceNumber: "-1", freightFwdName: '-1', status: "null", flag: "8", supplierName: suplier.supplierName, licence: "-1",
            item_description: "-1", hsCode: "-1", modeType: '-1', portCode: '-1'
        }
        ImportQuerService.getJobSearch(searchDetails).then(res => { setJobDetails(res.data); });
        setQuerSublierNoOpen(false);
    }
    const editItemDsc = (item) => {
        setQryValues({ ...qryvalues, item_decrption: item.item_description });
        let searchDetails = {
            importer_name: '-1', userJobDate: '-1', consignmentNumber: "-1", userJobNo: "-1",
            fromDate: "-1", toDate: "-1", mawbNo: "-1", hawb_no: "-1", impTypeBoe: "-1", invoiceNumber: "-1", freightFwdName: '-1', status: "null", flag: "10",
            supplierName: '-1', licence: "-1", item_description: item.item_description, hsCode: "-1", modeType: '-1', portCode: '-1'
        }
        ImportQuerService.getJobSearch(searchDetails).then(res => { setJobDetails(res.data); });
        setQuerDscrOpen(false);
    }
    const editHscode = (hsCode) => {
        setQryValues({ ...qryvalues, slct_hs_code: hsCode.hsCode });
        let searchDetails = {
            importer_name: '-1', userJobDate: '-1', consignmentNumber: "-1", userJobNo: "-1", fromDate: "-1", toDate: "-1", mawbNo: "-1",
            hawb_no: "-1", impTypeBoe: "-1", invoiceNumber: "-1", freightFwdName: '-1', status: "null", flag: "11", supplierName: '-1',
            licence: "-1", item_description: '-1', hsCode: hsCode.hsCode, modeType: '-1', portCode: '-1'
        }
        ImportQuerService.getJobSearch(searchDetails).then(res => { setJobDetails(res.data); });
        setQuerHsCodeOpen(false);
    }
    const editCuscode = (trns) => {
        setQryValues({ ...qryvalues, slct_portCode: trns.customHouseCode })
        var portCode = '';
        if (trns.customHouseCode !== '') { portCode = trns.customHouseCode; }
        else { portCode = '-1' }
        let searchDetails = {
            importer_name: '-1', userJobDate: '-1', consignmentNumber: "-1", userJobNo: "-1", fromDate: "-1", toDate: "-1", mawbNo: "-1",
            hawb_no: "-1", impTypeBoe: "-1", invoiceNumber: "-1", freightFwdName: '-1', status: "null", flag: "11", supplierName: '-1',
            licence: "-1", item_description: '-1', hsCode: '-1', modeType: '-1', portCode: portCode
        }
        ImportQuerService.getJobSearch(searchDetails).then(res => { setJobDetails(res.data); });
        setQueryCusHouseopen(false);
    }
    //----------------------------OnChange handle--------------------------------------------------
    const QueryDialogImporterhandleChange = (e) => {
        setImporterDetails([]);
        setQryValues({ ...qryvalues, f_imp_Name: e.target.value }); setImporterDetails([]);
        var importer_name = '';
        if (!e.target.value || e.target.value === '') {
            importer_name = '-1';
        } else {
            importer_name = e.target.value
        }
        let details = { importer_iec_no: '-1', importer_name: importer_name, flag: '2' }
        ImportQuerService.getImporter(details).then((res) => { setImporterDetails([]); setImporterDetails(res.data); })
    }
    const Queryimporter = (e) => {
        setJobDetails([]);
        setQryValues({ ...qryvalues, imp_name: e.target.value })
        setJobDetails([]);
        var importer_name = '';
        if (e.target.value === '' || !e.target.value) {
            importer_name = '-1'
        } else {
            importer_name = e.target.value;
        }
        let searchDetails = {
            importer_name: importer_name, userJobDate: '-1', consignmentNumber: "-1", userJobNo: "-1",
            fromDate: "-1", toDate: "-1", mawbNo: "-1", hawb_no: "-1", impTypeBoe: "-1",
            invoiceNumber: "-1", freightFwdName: "-1", status: "null", flag: "1", supplierName: "-1",
            licence: "-1", item_description: "-1", hsCode: "-1", modeType: '-1', portCode: '-1'
        }
        ImportQuerService.getJobSearch(searchDetails).then(res => {
            if (JSON.stringify(res.data) === []) {
                setJobDetails([]);
            } else {
                setJobDetails(res.data);
            }
        })
    }
    const QueryDialogSlctYear = (e) => {
        setQuryYearDetails([]);
        setQryValues({ ...qryvalues, qryslct_year: e.target.value });
        setQuryYearDetails([]);
        var userJobDate = '';
        if (e.target.value === '' || !e.target.value) {
            userJobDate = '-1'
        } else {
            userJobDate = e.target.value;
        }
        let searchDetails = {
            importer_name: "-1", userJobDate: userJobDate, consignmentNumber: "-1", userJobNo: "-1",
            mawbNo: "-1", hawb_no: "-1", status: "1", flag: "1"
        }
        ImportQuerService.getJobFilter(searchDetails).then(res => {
            setQuryYearDetails(res.data);
        })
    }
    const QuerySlctYear = (e) => {
        setQryValues({ ...qryvalues, slct_year: e.target.value.replace(/[^0-9.]/ig, '') })
        setJobDetails([]);
        var userJobDate = '';
        if (e.target.value === '' || !e.target.value) {
            userJobDate = '-1'
        } else {
            userJobDate = e.target.value;
        }
        let searchDetails = {
            importer_name: "-1", userJobDate: userJobDate, consignmentNumber: "-1", userJobNo: "-1",
            fromDate: "-1", toDate: "-1", mawbNo: "-1", hawb_no: "-1", impTypeBoe: "-1",
            invoiceNumber: "-1", freightFwdName: "-1", status: "null", flag: "1", supplierName: "-1",
            licence: "-1", item_description: "-1", hsCode: "-1", modeType: '-1', portCode: '-1'
        }
        ImportQuerService.getJobSearch(searchDetails).then(res => {
            if (JSON.stringify(res.data) === []) {
                setJobDetails([]);
            } else {
                setJobDetails(res.data);
            }
        })
    }
    const QueryDalogSlctJob = (e) => {
        setQuryYearDetails([]);
        setQryValues({ ...qryvalues, qryslct_job_no: e.target.value });
        setQuryYearDetails([]);
        var consignmentNumber = '';
        if (!e.target.value || e.target.value === '') {
            consignmentNumber = '-1'
        } else {
            consignmentNumber = e.target.value
        }
        let searchDetails = {
            importer_name: "-1", userJobDate: '-1', consignmentNumber: consignmentNumber,
            userJobNo: "-1", mawbNo: "-1", hawb_no: "-1", status: "2", flag: "1"
        }
        ImportQuerService.getJobFilter(searchDetails).then(res => {
            setQuryYearDetails(res.data);
        })
    }
    const QuerySlctJob = (e) => {
        setJobDetails([]);
        setQryValues({ ...qryvalues, slct_job_no: e.target.value });
        setJobDetails([]);
        var consignmentNumber = '';
        if (e.target.value === '' || !e.target.value) {
            consignmentNumber = '-1';
        } else {
            consignmentNumber = e.target.value;
        }
        let searchDetails = {
            importer_name: "-1", userJobDate: '-1', consignmentNumber: consignmentNumber, userJobNo: "-1",
            fromDate: "-1", toDate: "-1", mawbNo: "-1", hawb_no: "-1", impTypeBoe: "-1",
            invoiceNumber: "-1", freightFwdName: "-1", status: "null", flag: "1", supplierName: "-1",
            licence: "-1", item_description: "-1", hsCode: "-1", modeType: '-1', portCode: '-1', cusHouseCode: '-1'
        }
        ImportQuerService.getJobSearch(searchDetails).then(res => {
            setJobDetails([]);
            if (JSON.stringify(res.data) === []) {
                setJobDetails([]);
            } else {
                setJobDetails(res.data);
            }
        })
    }
    const QueryDialogSlctEdiJob = (e) => {
        setQuryYearDetails([]);
        setQryValues({ ...qryvalues, qryslct_edi_job: e.target.value });
        setQuryYearDetails([]);
        var userJobNo = '';
        if (!e.target.value || e.target.value === '') {
            userJobNo = '-1';
        } else {
            userJobNo = e.target.value
        }
        let searchDetails = {
            importer_name: "-1", userJobDate: '-1', consignmentNumber: '-1',
            userJobNo: userJobNo, mawbNo: "-1", hawb_no: "-1", status: "3", flag: "1"
        }
        ImportQuerService.getJobFilter(searchDetails).then(res => {
            setQuryYearDetails(res.data)
        })
    }
    const QuerySlctEdiJob = (e) => {
        setQryValues({ ...qryvalues, slct_edi_job: e.target.value });
        setJobDetails([]);
        var userJobNo = '';
        if (e.target.value === '') {
            userJobNo = '-1'
        } else {
            userJobNo = e.target.value;
        }
        let searchDetails = {
            importer_name: "-1", userJobDate: '-1', consignmentNumber: '-1', userJobNo: userJobNo, fromDate: "-1",
            toDate: "-1", mawbNo: "-1", hawb_no: "-1", impTypeBoe: "-1", invoiceNumber: "-1", freightFwdName: "-1", status: "null",
            flag: "1", supplierName: "-1", licence: "-1", item_description: "-1", hsCode: "-1", modeType: '-1', portCode: '-1'
        }
        ImportQuerService.getJobSearch(searchDetails).then(res => {
            if (JSON.stringify(res.data) === []) {
                setJobDetails([]);
            } else {
                setJobDetails(res.data);
            }
        })
    }
    const QuerySlctFrmDate = (e) => {
        setQryValues({ ...qryvalues, frm_date: e.target.value });
        setJobDetails([]);
        var fromDate, toDate = ''
        if (e.target.value === '') {
            fromDate = '-1'
        } else {
            fromDate = e.target.value
        } if (qryvalues.to_date === '') {
            toDate = '-1'
        } else {
            toDate = qryvalues.to_date
        }
        let searchDetails = {
            importer_name: "-1", userJobDate: '-1', consignmentNumber: '-1', userJobNo: '-1',
            fromDate: fromDate, toDate: toDate, mawbNo: "-1", hawb_no: "-1", impTypeBoe: "-1",
            invoiceNumber: "-1", freightFwdName: "-1", status: "null", flag: "1", supplierName: "-1",
            licence: "-1", item_description: "-1", hsCode: "-1", modeType: '-1', portCode: '-1'
        }
        ImportQuerService.getJobSearch(searchDetails).then(res => {
            if (JSON.stringify(res.data) === []) {
                setJobDetails([]);
            } else {
                setJobDetails(res.data);
            }
        })
    }
    const QuerySlctTomDate = (e) => {
        setJobDetails([])
        setQryValues({ ...qryvalues, to_date: e.target.value });
        setJobDetails([]);
        var fromDate, toDate = '';
        if (qryvalues.frm_date === '') {
            fromDate = '-1'
        } else {
            fromDate = qryvalues.frm_date
        } if (e.target.value === '' || !e.target.value) {
            toDate = '-1'
        } else {
            toDate = e.target.value;
        }
        let searchDetails = {
            importer_name: "-1", userJobDate: '-1', consignmentNumber: '-1', userJobNo: '-1', fromDate: fromDate,
            toDate: toDate, mawbNo: "-1", hawb_no: "-1", impTypeBoe: "-1", invoiceNumber: "-1", freightFwdName: "-1",
            status: "null", flag: "1", supplierName: "-1", licence: "-1", item_description: "-1", hsCode: "-1",
            modeType: '-1', portCode: '-1'
        }
        ImportQuerService.getJobSearch(searchDetails).then(res => {
            if (JSON.stringify(res.data) === []) {
                setJobDetails([]);
            } else {
                setJobDetails(res.data);
            }
        })
    }
    const QuerySlctLicenceNo = (e) => {
        setJobDetails([]);
        setQryValues({ ...qryvalues, licence_no: e.target.value })
        setJobDetails([]);
        var licence = '';
        if (e.target.value === '' || !e.target.value) {
            licence = '-1'
        } else {
            licence = e.target.value;
        }
        let searchDetails = {
            importer_name: "-1", userJobDate: '-1', consignmentNumber: '-1', userJobNo: '-1', fromDate: '-1', toDate: '-1',
            mawbNo: "-1", hawb_no: "-1", impTypeBoe: "-1", invoiceNumber: "-1", freightFwdName: "-1", status: "null",
            flag: "9", supplierName: "-1", licence: licence, item_description: "-1", hsCode: "-1", modeType: '-1',
            portCode: '-1'
        }
        ImportQuerService.getJobSearch(searchDetails).then(res => {
            if (JSON.stringify(res.data) === []) {
                setJobDetails([]);
            } else {
                setJobDetails(res.data);
            }
        })
    }
    const QueryDialogMawbNo = (e) => {
        setQuryYearDetails([]);
        setQryValues({ ...qryvalues, qrymawb_no: e.target.value });
        setQuryYearDetails([]);
        var mawbNo = '';
        if (!e.target.value) {
            mawbNo = '-1'
        } else {
            mawbNo = e.target.value
        }
        let searchDetails = {
            importer_name: "-1", userJobDate: '-1',
            consignmentNumber: '-1', userJobNo: '-1', mawbNo: mawbNo,
            hawb_no: "-1", status: "4", flag: "1"
        }
        ImportQuerService.getJobFilter(searchDetails).then(res => {
            setQuryYearDetails(res.data)
        })
    }
    const QueryMawbNo = (e) => {
        setQryValues({ ...qryvalues, mawb_no: e.target.value })
        setJobDetails([]);
        var mawbNo = '';
        if (e.target.value === '') {
            mawbNo = '-1'
        } else {
            mawbNo = e.target.value;
        }
        let searchDetails = {
            importer_name: "-1", userJobDate: '-1', consignmentNumber: '-1', userJobNo: '-1', fromDate: '-1', toDate: '-1',
            mawbNo: mawbNo, hawb_no: "-1", impTypeBoe: "-1", invoiceNumber: "-1", freightFwdName: "-1", status: "null",
            flag: "3", supplierName: "-1", licence: "-1", item_description: "-1", hsCode: "-1", modeType: '-1', portCode: '-1'
        }
        ImportQuerService.getJobSearch(searchDetails).then(res => {
            if (JSON.stringify(res.data) === []) { setJobDetails([]); } else { setJobDetails(res.data); }
        })
    }
    const QueryDialogHawb = (e) => {
        setQuryYearDetails([])
        setQryValues({ ...qryvalues, qryhawb_no: e.target.value });
        setQuryYearDetails([]);
        var hawb_no = '';
        if (!e.target.value || e.target.value === '') {
            hawb_no = '-1'
        } else {
            hawb_no = e.target.value;
        }
        let searchDetails = {
            importer_name: "-1", userJobDate: '-1', consignmentNumber: '-1', userJobNo: '-1', mawbNo: '-1',
            hawb_no: hawb_no, status: "5", flag: "2"
        }
        ImportQuerService.getJobFilter(searchDetails).then(res => {
            setQuryYearDetails(res.data)
        })
    }
    const QueryHawb = (e) => {
        setJobDetails([])
        setQryValues({ ...qryvalues, hawb_no: e.target.value })
        setJobDetails([]);
        var hawb_no = '';
        if (e.target.value === '') {
            hawb_no = '-1';
        } else {
            hawb_no = e.target.value;
        }
        let searchDetails = {
            importer_name: "-1", userJobDate: '-1', consignmentNumber: '-1', userJobNo: '-1', fromDate: '-1', toDate: '-1',
            mawbNo: '-1', hawb_no: hawb_no, impTypeBoe: "-1", invoiceNumber: "-1", freightFwdName: "-1", status: "null",
            flag: "3", supplierName: "-1", licence: "-1", item_description: "-1", hsCode: "-1", modeType: '-1', portCode: '-1'
        }
        ImportQuerService.getJobSearch(searchDetails).then(res => {
            if (JSON.stringify(res.data) === []) { setJobDetails([]); } else { setJobDetails(res.data); }
        })
    }
    const QueryRadioInputChanghandle = (e) => {
        setJobDetails([]);
        setQryValues({ ...qryvalues, radio_input_cnt: e.target.value })
        setJobDetails([]);
        var invoiceNumber = ''
        if (e.target.value === '') {
            invoiceNumber = '-1'
        } else {
            invoiceNumber = e.target.value;
        }
        let searchDetails = {
            importer_name: "-1", userJobDate: '-1', consignmentNumber: '-1', userJobNo: '-1', fromDate: '-1', toDate: '-1', mawbNo: '-1', hawb_no: '-1', impTypeBoe: "-1",
            invoiceNumber: invoiceNumber, freightFwdName: "-1", status: 'null', flag: radioValues, supplierName: "-1",
            licence: "-1", item_description: "-1", hsCode: "-1", modeType: '-1', portCode: '-1'
        }
        ImportQuerService.getJobSearch(searchDetails).then(res => {
            if (JSON.stringify(res.data) === []) { setJobDetails([]); } else { setJobDetails(res.data); }
        })
    }
    const QueryDialogSlctSublier = (e) => {
        setQuryYearDetails([]);
        setQryValues({ ...qryvalues, qryslct_sublier: e.target.value });
        setQuryYearDetails([]);
        var supplierName = '';
        if (!e.target.value) {
            supplierName = '-1'
        } else {
            supplierName = e.target.value
        }
        let searchDetails = {
            supplierName: supplierName, flag: '2'
        }
        InvoiceService.getSupplierDetails(searchDetails).then(res => {
            setQuryYearDetails(res.data)
        })
    }
    const QuerySlctSublier = (e) => {
        setJobDetails([]);
        setQryValues({ ...qryvalues, slct_sublier: e.target.value });
        setJobDetails([]);
        var supplierName = ''
        if (e.target.value === '') {
            supplierName = '-1';
        } else {
            supplierName = e.target.value;
        }
        let searchDetails = {
            importer_name: '-1', userJobDate: '-1', consignmentNumber: "-1", userJobNo: "-1", fromDate: "-1", toDate: "-1",
            mawbNo: "-1", hawb_no: "-1", impTypeBoe: "-1", invoiceNumber: "-1", freightFwdName: "-1", status: "null", flag: "8",
            supplierName: supplierName, licence: "-1", item_description: "-1", hsCode: "-1", modeType: '-1', portCode: '-1'
        }
        ImportQuerService.getJobSearch(searchDetails).then(res => {
            if (JSON.stringify(res.data) === []) { setJobDetails([]); } else { setJobDetails(res.data); }
        })
    }
    const QueryDialogSlctFrwder = (e) => {
        setQuryYearDetails([]);
        setQryValues({ ...qryvalues, qryslct_frwdr: e.target.value });
        setQuryYearDetails([]);
        var freightFwdName = '';
        if (!e.target.value || e.target.value === '') {
            freightFwdName = '';
        } else {
            freightFwdName = e.target.value
        }
        let searchDetails = {
            freightFwdName: freightFwdName
        }
        ImportQuerService.getForwarderName(searchDetails).then(res => {
            setQuryYearDetails(res.data)
        })
    }
    const QuerySlctFrwder = (e) => {
        setJobDetails([]);
        setQryValues({ ...qryvalues, slct_frwdr: e.target.value });
        setJobDetails([]);
        var freightFwdName = '';
        if (e.target.value === '') {
            freightFwdName = '-1'
        } else {
            freightFwdName = e.target.value;
        }
        let searchDetails = {
            importer_name: '-1', userJobDate: '-1', consignmentNumber: "-1", userJobNo: "-1", fromDate: "-1",
            toDate: "-1", mawbNo: "-1", hawb_no: "-1", impTypeBoe: "-1", invoiceNumber: "-1", freightFwdName: freightFwdName,
            status: "null", flag: "7", supplierName: '-1', licence: "-1", item_description: "-1", hsCode: "-1", modeType: '-1',
            portCode: '-1'
        }
        ImportQuerService.getJobSearch(searchDetails).then(res => {
            if (JSON.stringify(res.data) === []) { setJobDetails([]); } else { setJobDetails(res.data); }
        })
    }
    const QueryBeType_H_W_X = (e) => {
        setJobDetails([]);
        if (e.target.value === '' || e.target.value === 'H' || e.target.value === 'h' || e.target.value === 'W' || e.target.value === 'w' || e.target.value === 'X' || e.target.value === 'x') {
            setQryValues({ ...qryvalues, be_type_HWX: e.target.value })
            var impTypeBoe = '';
            if (e.target.value === '') {
                impTypeBoe = '-1';
            }
            else {
                impTypeBoe = e.target.value
            }
            setJobDetails([]);
            let searchDetails = {
                importer_name: '-1', userJobDate: '-1', consignmentNumber: "-1", userJobNo: "-1", fromDate: "-1", toDate: "-1",
                mawbNo: "-1", hawb_no: "-1", impTypeBoe: impTypeBoe, invoiceNumber: "-1", freightFwdName: '-1', status: "null",
                flag: "1", supplierName: '-1', licence: "-1", item_description: "-1", hsCode: "-1", modeType: '-1', portCode: '-1'
            }
            ImportQuerService.getJobSearch(searchDetails).then(res => {
                if (JSON.stringify(res.data) === []) { setJobDetails([]); } else { setJobDetails(res.data); }
            })
        }
    }
    const QueryDialogItemDscrption = (e) => {
        setQuryYearDetails([]); setQryValues({ ...qryvalues, qryitem_decrption: e.target.value });
        setQuryYearDetails([]);
        var itemName = '';
        if (!e.target.value) { itemName = '-1' }
        else { itemName = e.target.value }
        ItemService.getItemNameSearch(itemName, '1').then(res => { setQuryYearDetails([]); setQuryYearDetails(res.data); })
    }
    const QueryItemDscrption = (e) => {
        setJobDetails([]);
        setQryValues({ ...qryvalues, item_decrption: e.target.value });
        setJobDetails([]);
        var item_description = ''
        if (e.target.value === '') {
            item_description = '-1'
        } else {
            item_description = e.target.value;
        }
        let searchDetails = {
            importer_name: '-1', userJobDate: '-1', consignmentNumber: "-1", userJobNo: "-1",
            fromDate: "-1", toDate: "-1", mawbNo: "-1", hawb_no: "-1", impTypeBoe: "-1",
            invoiceNumber: "-1", freightFwdName: '-1', status: "null", flag: "10", supplierName: '-1',
            licence: "-1", item_description: item_description, hsCode: "-1", modeType: '-1', portCode: '-1'
        }
        ImportQuerService.getJobSearch(searchDetails).then(res => {
            if (JSON.stringify(res.data) === []) { setJobDetails([]); } else { setJobDetails(res.data); }
        })
    }
    const QueryDialogHsCode = (e) => {
        setQuryYearDetails([])
        setQryValues({ ...qryvalues, qryslct_hs_code: e.target.value });
        setQuryYearDetails([]);
        var hsCode = '';
        if (!e.target.value || e.target.value === '') {
            hsCode = '-1'
        }
        else {
            hsCode = e.target.value
        }
        let details = { hsCode: hsCode, hsName: '-1', flag: '1' }
        ItemService.getHsCode(details).then(res => {
            setQuryYearDetails(res.data)
        })
    }
    const QueryDialogHsName = (e) => {
        setQuryYearDetails([]);
        setQryValues({ ...qryvalues, slct_hs_Name: e.target.value });
        setQuryYearDetails([]);
        var hsName = '';
        if (!e.target.value || e.target.value === '') {
            hsName = '-1'
        }
        else {
            hsName = e.target.value;
        }
        let details = { hsCode: '-1', hsName: hsName, flag: '1' }
        ItemService.getHsCode(details).then(res => {
            setQuryYearDetails(res.data)
        })
    }
    const QueryHsCode = (e) => {
        setJobDetails([]);
        setQryValues({ ...qryvalues, slct_hs_code: e.target.value });
        setJobDetails([]);
        var hsCode = '';
        if (e.target.value === '' || !e.target.value) {
            hsCode = '-1'
        } else {
            hsCode = e.target.value;
        }
        let searchDetails = {
            importer_name: '-1', userJobDate: '-1', consignmentNumber: "-1", userJobNo: "-1",
            fromDate: "-1", toDate: "-1", mawbNo: "-1", hawb_no: "-1", impTypeBoe: "-1",
            invoiceNumber: "-1", freightFwdName: '-1', status: "null", flag: "11", supplierName: '-1',
            licence: "-1", item_description: '-1', hsCode: hsCode, modeType: '-1', portCode: '-1'
        }
        ImportQuerService.getJobSearch(searchDetails).then(res => {
            if (JSON.stringify(res.data) === []) { setJobDetails([]); } else { setJobDetails(res.data); }
        })
    }
    const QueryDialogCusHsName = (e) => {
        setQuryYearDetails([]);
        setQryValues({ ...qryvalues, qryFindcusHouseName: e.target.value });
        setQuryYearDetails([]);
        var CustomHousename, transitTypeCode = '';
        if (e.target.value !== '') {
            CustomHousename = e.target.value;
        } else {
            CustomHousename = '-1'
        }
        if (qryvalues.slct_modeType !== '') {
            transitTypeCode = qryvalues.slct_modeType;
        } else {
            transitTypeCode = '-1'
        }
        let details = { cusHouseCode: '-1', transitTypeCode: transitTypeCode, customHouseLocation: CustomHousename };
        ImportQuerService.getCustomHouseCodeForDashBoard(details).then(res => {
            setQuryYearDetails(res.data)
        })
    }
    const QueryDialogCusHsCode = (e) => {
        setQuryYearDetails([]);
        setQryValues({ ...qryvalues, qryFindcusHousecode: e.target.value });
        setQuryYearDetails([]);
        var findCustomHousecode, transitTypeCode = '';
        if (e.target.value !== '') {
            findCustomHousecode = e.target.value;
        } else {
            findCustomHousecode = '-1'
        }
        if (qryvalues.slct_modeType !== '') {
            transitTypeCode = qryvalues.slct_modeType;
        } else {
            transitTypeCode = '-1'
        }
        let details = { cusHouseCode: findCustomHousecode, transitTypeCode: transitTypeCode, customHouseLocation: '-1' };
        ImportQuerService.getCustomHouseCodeForDashBoard(details).then(res => {
            setQuryYearDetails(res.data)
        })
    }
    const QryBeNoChangeHandle = (e) => {
        setqryAmendvalue({ ...qryAmendvalue, Amnd_beNo: e.target.value })
    }
    const QryBeDateChangeHandle = (e) => {
        setqryAmendvalue({ ...qryAmendvalue, Amnd_beDate: e.target.value })
    }
    const QryAmendentcodeChangeHandle = (e) => {
        setqryAmendvalue({ ...qryAmendvalue, Amnd_code: e.target.value })
    }
    const QryRqstNoChangeHandle = (e) => {
        setqryAmendvalue({ ...qryAmendvalue, Amnd_RqstLtrNo: e.target.value })
    }
    const QryRqstDateChangeHandle = (e) => {
        setqryAmendvalue({ ...qryAmendvalue, Amnd_RqstDate: e.target.value })
    }
    const QryRspncChangeHandle = (e) => {
        setqryAmendvalue({ ...qryAmendvalue, Amnd_Reason: e.target.value })
    }
    const QueryPortCode = (e) => {
        setJobDetails([])
        setQryValues({ ...qryvalues, slct_portCode: e.target.value })
        setJobDetails([]);
        var portcode, modeTpe = '';
        if (e.target.value === '') {
            portcode = '-1'
        } else {
            portcode = e.target.value;
        }
        if (qryvalues.slct_modeType === '') {
            modeTpe = '-1'
        } else {
            modeTpe = qryvalues.slct_modeType;
        }
        let searchDetails = {
            importer_name: '-1', userJobDate: '-1', consignmentNumber: "-1", userJobNo: "-1",
            fromDate: "-1", toDate: "-1", mawbNo: "-1", hawb_no: "-1", impTypeBoe: "-1",
            invoiceNumber: "-1", freightFwdName: '-1', status: "null", flag: "12", supplierName: '-1',
            licence: "-1", item_description: '-1', hsCode: '-1', modeType: modeTpe, portCode: portcode
        }
        ImportQuerService.getJobSearch(searchDetails).then(res => {
            if (JSON.stringify(res.data) === []) { setJobDetails([]); } else { setJobDetails(res.data); }
        })
    }
    const QueryModeType = (e) => {
        setJobDetails([]);
        var portcode, modeType = '';
        if (e.target.value === 'A' || e.target.value === 'a' || e.target.value === 'S' || e.target.value === 's' ||
            e.target.value === 'L' || e.target.value === 'l' || e.target.value === '') {
            setQryValues({ ...qryvalues, slct_modeType: e.target.value });
            setJobDetails([]);
            if (e.target.value === '') {
                modeType = '-1'
            } else {
                modeType = e.target.value;
            }
            if (qryvalues.slct_portCode === '') {
                portcode = '-1'
            } else {
                portcode = qryvalues.slct_portCode;
            }
            let searchDetails = {
                importer_name: '-1', userJobDate: '-1', consignmentNumber: "-1", userJobNo: "-1",
                fromDate: "-1", toDate: "-1", mawbNo: "-1", hawb_no: "-1", impTypeBoe: "-1",
                invoiceNumber: "-1", freightFwdName: '-1', status: "null", flag: "12", supplierName: '-1',
                licence: "-1", item_description: '-1', hsCode: '-1', modeType: modeType, cusHouseCode: portcode
            }
            ImportQuerService.getJobSearch(searchDetails).then(res => {
                if (JSON.stringify(res.data) === []) { setJobDetails([]); } else { setJobDetails(res.data); }
            })
        }
    }
    const reset = () => {
        setRadioValues('')
        setJobDetails([]);
        setQryValues({
            ...qryvalues,
            imp_name: "", slct_year: "", slct_job_no: "", slct_edi_job: "", frm_date: '', to_date: '', licence_no: "", mawb_no: "", hawb_no: "",
            be_type_HWX: "", radio_input_cnt: "", slct_sublier: "", slct_frwdr: "", item_decrption: "",
            slct_hs_code: "", qryslct_hs_code: "", slct_hs_Name: "", slct_portCode: "", slct_modeType: '', qryFindcusHouseName: '', qryFindcusHousecode: '',
        })
    }
    const [amendmentStatus ,setamendmentStatus] = useState('0')
    const QueryDublicateJobno = () => {setamendmentStatus('0')
        if (qryvalues.slct_job_no !== '') {
            setQryProcsDupli(true)
            let details = { consignmentNumber: qryvalues.slct_job_no }
            ImportQuerService.insertDuplicateJobImport(details).then(res => {
                const data = res.data;
                const jobno = data.map((qryJob) => qryJob.consignmentNumber);
                setQryProcsDupli(false)
                if (!jobno || jobno === '') {
                    setMessage('Insert Failed')
                    setSeverity('error')
                    setOpenSnack(true)
                } else {
                    setQryalerJobNo(jobno)
                    QueryDublicateJobOpen();
                    if(amendmentStatus === '1')
					{
                        let details2 = { consignmentNumber: jobno.toString(), userJobNo: qryvalues.slct_job_no }
                        JobServices.updateBeAmendmentStatus(details2).then(res => { });
					}
                   
                }
            }).catch(error => {
                setQryProcsDupli(false)
                setMessage(error.message)
                setSeverity('error')
                setOpenSnack(true)
            })
        } else {
            setMessage('Please Enter The Job Number')
            setSeverity('warning')
            setOpenSnack(true)
            document.getElementById('slctJobNo').focus();
        }
    }
    // ------------------------------------------Job----------------------------------------------------------------
    const [transitDetails, setTransitDetails] = useState([]);
    const [CustomHouseDetails, setCustomHouseDetails] = useState([]);
    const [BranchDetails, setBranchDetails] = useState([]);
    const [ForwdrDetails, setForwdrDetails] = useState([]);
    const [JobImporterDetails, setJobImporterDetails] = useState([]);
    const [BranchSrDetails, setBranchSrDetails] = useState([]);
    const [JobAdCodeDetails, setAdcodeDetailsDetails] = useState([]);
    const [JobCountryOrigineDtails, setJobCountryOrigineDtails] = useState([]);
    const [JobCountryOfCmDtails, setJobCountryOfCmDtails] = useState([]);
    const [certifcatetypeDetai, setCertifcatetypeDetai] = useState([]);
    const [jobigmdropdwon, setjobigmdropdwon] = useState([]);
    const [bondcodeDrp, setBondcodeDrp] = useState([]);
    const [jobIgmDetails, setJobIgmDetails] = useState([]);
    const [jobHssDetails, setjobHssDetails] = useState([]);
    const [jobSecDetails, setjobSecDetails] = useState([]);
    const [jobGstinDrp, setjobGstinDrp] = useState([]);
    const [jobCmrcialDetails, setjobCmrcialDetails] = useState([]);

    const [JobradioValues, setJobRadioValues] = useState('IEC_code');
    const [jobValues, setJobValues] = useState({
        chaCode: 'AGIPP8287CCH001', mode_A_L_S: '', model_A_L_S_Name: '', customHousCode: '',
        chs_name: '', branch: "DELHI OFFICE", forwarder: '', iec_search: '',
        name: '', branch_sr_no: '', address_1: '', addresh_2: '', city: '', state: '', pincode: '', ad_code: '', job_no: '', edi_job_no: '',
        countryOrigin: "", countryOriginName: "", countrt_of_cm: "", countrt_of_cmName: "", certificate_y_N: "N", bond_y_N: "N",
        port_of_loding: "", port_of_lodingName: "", container_detail: "N", class_g_p_n: "N", type_H_W_x: "H", imp_type_G_O_p_U: "P",
        kacha_y_N: "N", dif_def: "", green_chn: "N", hss_y_n: "N", sec_48_y_n: "N", public_sec_y_n: "N", first_check_y_n: "N",
        prior_be_y_n: "N", commercial_tax_y_n: "Y", ucr: "", ucr_type: "", paymentMode_D_T: "T",
        //-----igm
        igmId: 0, igm_No: "", mawb_no: "", hawb_no: "", no_of_pkgs: "", gross_wt: "", unit: "KGS", inWardDate: '', igmDate: '',
        mawbDate: '', hawbDate: '', pkg_code: "PKG", marks_and_number: "As Per BL", gatewayNo: "", gateWayDate: '',
        repPortCode: "", repPortName: "",
        //Boe Updation
        be_no: '', be_date: '', be_response: '', be_reason: ''
    })
    const [jobDialogValues, setJobDialogValues] = useState({
        transit_name: "", transit_code: "", cusHousName: "", cusHousCode: "", branch: "", forwdr: "", importer_name: "",
        importer_code: "", importer_state: "", branch_sr_no: "", ad_code: '', f_countryOrginName: "", f_countryOriginCode: "",
        f_countryOfCm: "", f_countryOfCmCode: "", f_countryoriginPortName: "", f_countryOfOriginPortCode: "", f_port_ofName: "",
        f_port_Code: "",
        //-----certificate----
        certificateId: 0, certificate_No: '', certificate_Type: '', certificate_Date: '',
        //----container----
        containerId: 0, container_igm_no: '', container_no: '', container_size: '', l_f_c: '', seal_no: '', truck_no: '',
        //---bond---
        bondNo: '', old_bondNo: '', bond_code: '', bond_port: '', find_bond_port: '', bond_portName: '', bond_amount: '', bg_debited: '', bg_rate: '',
        bg_ammount: '',
        //----TypeHWX---
        typeH_w_xCode: '', typeH_w_xCustSiteId: '', typeH_w_xCustSiteName: '', findtypeH_w_xCustSiteId: '', findtypeH_w_xPkgCode: '',
        typeH_w_xBeNo: '', typeH_w_xBeDate: '', typeH_w_xNoOfPkg: 0, typeH_w_xPkgCode: '', typeH_w_xPkgName: '', typeH_w_xGroos: 0,
        findtypeH_w_xUnitCode: '', typeH_w_xUnitCode: '', typeH_w_xUnitName: '', typeH_w_xAnnexureNo: '', typeH_w_xAnnexureDate: '',
        typeH_w_xDFW: '', typeH_w_xLFE: '', typeH_w_xMLR: '', typeH_w_xECD: '',
        //-------hss -----------
        hss_iecCode: '', findhss_iecCode: '', hss_oldiecCode: '', hss_iecName: '', hss_precedingLevel: '', hss_brnchSrNo: '',
        findhss_brnchSrNo: '', hss_brncSrName: '', hss_name: '', hss_address1: '', hss_address2: '', hss_city: '',
        hss_state: '', hss_pincode: '',
        //-----sec-48
        sec_PermissionId: '', sec_PermissionDesc: '', sec_PermissionCode: '',
        //commercial-Tax
        comrcial_txId: 0, comrcial_StateCode: '', comrcial_CtxCode: '', comrcial_ctx_regNo: '',
        // repport
        f_report_name: '', f_report_code: ''
    })
    const [JobInwardatehide, setJobInwardatehide] = useState(false);
    const [JobIgmhide, setJobIgmhide] = useState(false);
    const [JobIgmtrnsitChnghide, setJobIgmtrnsitChnghide] = useState(false);
    const [JobGatwayhide, setJobGateWayhide] = useState(false);
    const [JobRepPorthide, setJobRepPorthide] = useState(false);

    const [JobTypeHWX_LE_Radio, setJobTypeHWX_LE_Radio] = useState('')
    const [JobTypeHWX_MLR_Radio, setJobTypeHWX_MLR_Radio] = useState('')
    const [JobModelOpen, setJobModelOpen] = useState(false);
    const [JobChsOpen, setJobChsOpen] = useState(false);
    const [JobBranchOpen, setJobBranchOpen] = useState(false);
    const [JobFrwdrOpen, setJobFrwdrOpen] = useState(false);
    const [JobIecOpen, setJobIecOpen] = useState(false);
    const [JobBrncSrOpen, setJobBrncSrOpen] = useState(false);
    const [JobAdCodeOpen, setJobAdCodeOpen] = useState(false);
    const [JobCountryOriginOpen, setJobCountryOriginOpen] = useState(false);
    const [JobCountryCmOpen, setJobCountryCmOpen] = useState(false);
    const [JobPortOfLoadingOpen, setJobPortOfLoadingOpen] = useState(false);
    const [JobCertificateOpen, setJobCertificateOpen] = useState(false);
    const [JobBondOpen, setJobBondOpen] = useState(false);
    const [JobBondPortOpen, setJobBondPortOpen] = useState(false);
    const [JobContainerOpen, setJobContainerOpen] = useState(false);
    const [JobTypeHWXOpen, setJobTypeHWXOpen] = useState(false);
    const [JobTypeHWXCUSIDOpen, setJobTypeHWXCUSIDOpen] = useState(false);
    const [JobTypeHWXpkgcodeOpen, setJobTypeHWXpkgcodeOpen] = useState(false);
    const [JobTypeHWXUnitCodeOpen, setJobTypeHWXUnitCodeOpen] = useState(false);
    const [JobHSSOpen, setJobHSSOpen] = useState(false);
    const [JobHSS_IecOpen, setJobHSS_IecOpen] = useState(false);
    const [JobHSS_BrncSrOpen, setJobHSS_BrncSrOpen] = useState(false);
    const [JobSec_48Open, setJobSec_48Open] = useState(false);
    const [Job1stCheackOpen, setJob1stCheackOpen] = useState(false);
    const [JobComrcilTaxOpen, setJobComrcilTaxOpen] = useState(false);
    const [JobUnitCodeOpen, setJobUnitCodeOpen] = useState(false);
    const [JobPkgCodeOpen, setJobPkgCodeOpen] = useState(false);
    const [JobRepPortOpen, setJobRepPortOpen] = useState(false);

    const [jobDialoSavDisa, setJobDialoSavDisa] = useState(false);
    const [jobDialogSave, setJobDialogSave] = useState(false);
    const [jobDialogUpdtDisa, setJobDialogUpdtDisa] = useState(true);
    const [jobDialogUpdate, setJobDialogUpdate] = useState(false);
    const [jobDialogDltDisa, setJobDialogDltDisa] = useState(true);
    const [jobDialogDelete, setJobDialogDeletea] = useState(false);

    const [bondSaveDisab, setBondSaveDisab] = useState(false);
    const [jobBondSave, setJobBondSave] = useState(false);

    const [bondUpdtDisab, setBondUpdtDisab] = useState(true);
    const [jobBondUpdt, setJobBondUpdt] = useState(false);

    const [bondDltDisab, setBondDltDisab] = useState(true);
    const [jobBondDlt, setJobBondDlt] = useState(false);

    const [JobContainerSveDsab, setJobContainerSveDsab] = useState(false);
    const [JobContainerSve, setJobContainerSve] = useState(false);

    const [JobContainerUpdtDsab, setJobContainerUpdtDsab] = useState(true);
    const [JobContainerUpdt, setJobContainerUpdt] = useState(false);

    const [JobContainerDltDsab, setJobContainerDltDsab] = useState(true);
    const [JobContainerDlt, setJobContainerDlt] = useState(false);

    const [JobHssSaveDsab, setJobHssSaveDsab] = useState(false);
    const [JobHssSve, setJobHssSve] = useState(false);

    const [JobHssUpdateDsab, setJobHssUpdateDsab] = useState(true);
    const [JobHssUpd, setJobHssUpd] = useState(false);

    const [JobHssDeleteDsab, setJobHssDeleteDsab] = useState(true);
    const [JobHssDlt, setJobHssDlt] = useState(false);

    const [JobSec_48SaveDsab, setJobSec_48SaveDsab] = useState(false);
    const [JobSec_48Updatedsab, setJobSec_48Updatedsab] = useState(true);
    const [JobSec_48DeleteDsab, setJobSec_48DeleteDsab] = useState(true);

    const [JobSec_48Sve, setJobSec_48Sve] = useState(false);
    const [JobSec_48Upd, setJobSec_48Upd] = useState(false);
    const [JobSec_48Dlt, setJobSec_48Dlt] = useState(false);

    const [JobIGMSaveDsab, setJobIGMSaveDsab] = useState(false);
    const [JobIGMUpdatedsab, setJobIGMUpdatedsab] = useState(true);
    const [JobIGMDeleteDsab, setJobIGMDeleteDsab] = useState(true);

    const [JobIGMSve, setJobIGMSve] = useState(false);
    const [JobIGMUpd, setJobIGMUpd] = useState(false);
    const [JobIGMDlt, setJobIGmDlt] = useState(false);

    const [JobComTxSaveDsab, setJobComTxSaveDsab] = useState(false);
    const [JobComTxUpdateDsab, setJobComTxUpdateDsab] = useState(true);
    const [JobComTxDeleteDsab, setJobComTxDeleteDsab] = useState(true);
    const [JobComTxSve, setJobComTxSve] = useState(false);
    const [JobComTxUpd, setJobComTxUpd] = useState(false);
    const [JobComTxDlt, setJobComTxDlt] = useState(false);

    const [EDiJobSaveDsa, setEDiJobSaveDsa] = useState(false);
    const [EDiJobUpdateDsa, setEDiJobUpdateDsa] = useState(true);
    const [EDiJobDeleteDsa, setEDiJobDeleteDsa] = useState(true);
    const [EDiJobSve, setEDiJobSve] = useState(false);
    const [EDiJobUpd, setEDiJobUpd] = useState(false);
    const [EDiJobDlt, setEDiJobDlt] = useState(false);

    //----------------------------------keyUp---------------------------------------------------------------------
    const JobDialogTransitNameKeyDown = (e) => { if (e.key === 'Enter') { document.getElementById('JobDialogFTransitCode').focus(); } }
    const JobDialogCusHousNameKeyDown = (e) => { if (e.key === 'Enter') { document.getElementById('JobDialogFCusHouseCode').focus(); } }
    const JobDialogIecImporterNameKeyDown = (e) => { if (e.key === 'Enter') { document.getElementById('JobDialogImportCode').focus(); } }
    const JobDialogImporterStateKeyDown = (e) => { if (e.key === 'Enter') { document.getElementById('JobDialogJobBranchSlNo').focus(); } }
    const JobDialogFindOriginCntryNameKeyDown = (e) => { if (e.key === 'Enter') { document.getElementById('JobDialogOriginFCntryCode').focus(); } }
    const JobDialogFindPortCntryNameKeyDown = (e) => { if (e.key === 'Enter') { document.getElementById('JobDialogPortFindPortCode').focus(); } }
    const JobDialogCertificateNoKeyDown = (e) => { if (e.key === 'Enter') { document.getElementById('jobCertificateType').focus(); } }
    const JobDialogCertificateTypeKeyDown = (e) => { if (e.key === 'Enter') { document.getElementById('JobCertificateDate').focus(); } }
    const JobDialogCertificateDateKeyDown = (e) => { if (e.key === 'Enter') { if (jobDialoSavDisa === false) { SaveCertificate(); } else { UpdateCertificate(); } } }
    const JobDialogFindBondPortNameKeyDown = (e) => { if (e.key === 'Enter') { document.getElementById('JobFindBandPortCode').focus(); } }
    const JobDialogBondPortNoKeyDown = (e) => { if (e.key === 'Enter') { document.getElementById('JobKeyBondCode').focus(); } }
    const JobDialogBondCodeKeyDown = (e) => { if (e.key === 'Enter') { document.getElementById('JobBondBondPort').focus(); } }
    const jobModeKeyUpHandle = (e) => {
        if (e.key === 'F7') { JobModeSearchHandleOpen(); }
        if (e.key === 'Enter') { document.getElementById('chsCode').focus(); }
    }

    const focusoutAirMode = () => {
        if (jobValues.mode_A_L_S === 'A' || jobValues.mode_A_L_S === 'a') {
            setJobIgmtrnsitChnghide(false); setJobGateWayhide(true); setJobRepPorthide(true);
        }
        if (jobValues.mode_A_L_S === 'S' || jobValues.mode_A_L_S === 's') {
            setJobIgmtrnsitChnghide(true); setJobGateWayhide(false); setJobRepPorthide(false);
        }
        if (jobValues.mode_A_L_S === 'L' || jobValues.mode_A_L_S === 'l') {
            setJobIgmtrnsitChnghide(true); setJobGateWayhide(false); setJobRepPorthide(false);
        }
    }

    const masterhssiecodeOnkeyDown = (e) => { if (e.key === 'F7') { JobHss_iec_Open(); } if (e.key === 'Enter') { document.getElementById('JobDialogHssBranchSlNo').focus(); } }
    const masterhssBrnchSrOnkeyDown = (e) => { if (e.key === 'F7') { JobHssbrncSrOpen(); } if (e.key === 'Enter') { document.getElementById('JobDialogHssPrecedingLevel01').focus(); } }
    const masterhssPrecedingLvl01keyDown = (e) => { if (e.key === 'Enter') { if (JobHssSaveDsab === false) { jobHss_Save(); } else { jobHssUpdate(); } } }
    const JobDialogCmrcialTaxStateCodekeyDown = (e) => { if (e.key === 'Enter') { document.getElementById('JobDialogComercialCTXtax').focus(); } }
    const JobDialogCmrcialTaxCtxTypekeyDown = (e) => { if (e.key === 'Enter') { document.getElementById('JobDialogCtxRegistrationNo').focus(); } }
    const JobDialogCmrcialTaxCtxRegistrationKeyDown = (e) => { if (e.key === 'Enter') { if (JobComTxSaveDsab === false) { commercialTaxSave(); } else { commercialTaxUpdate(); } } }
    const jobChsCodeKeyUpHandle = (e) => {
        if (e.key === 'F7') { JobChsCodeHandleOpen(); }
        if (e.key === 'Enter') { document.getElementById('Branch').focus(); }
    }
    const jobBranchKeyUpHandle = (e) => {
        if (e.key === 'F7') { JobBranchHandleOpen(); }
        if (e.key === 'Enter') { document.getElementById('frwdr').focus(); }
    }
    const jobForwdrKeyUpHandle = (e) => {
        if (e.key === 'F7') {
            JobFrwdrHandleOpen();
        }
        if (e.key === 'Enter') { document.getElementById('gvt_iec').focus(); }
    }
    const jobIecSearchKeyUpHandle = (e) => {
        if (e.key === 'F7') { JobIecHandleOpen(); }
        if (e.key === 'Enter') { document.getElementById('brnc_no').focus(); }
    }
    const jobBranchSrNoKeyUpHandle = (e) => {
        if (e.key === 'F7') { JobBrancSrHandleOpen(); }
        if (e.key === 'Enter') { document.getElementById('ad_code').focus(); }
    }
    const jobAdCodeKeyUP = (e) => {
        if (e.key === 'F7') {
            JobAdCodeHandleOpen();
        }
        if (e.key === 'Enter') { document.getElementById('Jobedi_job').focus(); }
    }
    const jobAdButtonKeyUP = (e) => {
        if (e.key === 'Enter') { document.getElementById('Jobedi_job').focus(); }
    }
    const jobEdiJobKeyUP = (e) => {
        if (e.key === 'Enter') { document.getElementById('jonCntryOrgin').focus(); }
    }
    const JobcntryorgnKeyUp = (e) => {
        if (e.key === 'F7') { JobCountryOriginHandleOpen(); }
        else if (e.key === 'Enter') { document.getElementById('jobCntryOfCm').focus(); }
    }
    const jobCntryCmkeyUp = (e) => {
        if (e.key === 'F7') { JobCountryCMHandleOpen(); }
        if (e.key === 'Enter') { document.getElementById('portLoding').focus(); }
    }
    const jobPortofLoadingKeyup = (e) => {
        if (e.key === 'F7') { JobPortOfLoadinHandleOpen(); }
        if (e.key === 'Enter') { document.getElementById('Certificate').focus(); }
    }
    const JobCertificateKeyUp = (e) => {
        if (e.key === 'Enter') {
            if (jobValues.certificate_y_N === 'Y' || jobValues.certificate_y_N === 'y') {
                if (jobValues.job_no === '') {
                    setMessage('Please Select Job No From Job Table'); setSeverity('warning'); setOpenSnack(true)
                } else {
                    setAdcodeDetailsDetails([])
                    setJobDialogValues({ ...jobDialogValues, certificateId: 0, certificate_No: '', certificate_Type: '', certificate_Date: '' })
                    setJobCertificateOpen(true);
                    JobServices.getCertificateType().then(res => { setCertifcatetypeDetai(res.data) }); document.getElementById('Bond').focus();
                    let details = { consignmentId: jobValues.job_no }
                    JobServices.getCertificateDetails(details).then(res => { setAdcodeDetailsDetails(res.data) })
                }
            } else if (jobValues.certificate_y_N === 'N' || jobValues.certificate_y_N === 'n') {
                document.getElementById('Bond').focus(); setJobCertificateOpen(false)
            }
        }
    }
    const jobBondKeyUp = (e) => {
        if (e.key === 'Enter') {
            if (jobValues.bond_y_N === 'Y' || jobValues.bond_y_N === 'y') {
                if (!jobValues.job_no) { setMessage('Please Select Job No From Job Table'); setSeverity('warning'); setOpenSnack(true) }
                else {
                    setAdcodeDetailsDetails([]); setJobBondOpen(true); document.getElementById('Classgpn').focus();
                    JobServices.getbondCode().then(res => { setBondcodeDrp(res.data) })
                    let details = { consignmentId: jobValues.job_no }
                    JobServices.getBondDetails(details).then(res => { setAdcodeDetailsDetails(res.data) })
                    bondReset();
                }
            } else if (jobValues.bond_y_N === 'N' || jobValues.bond_y_N === 'n') {
                document.getElementById('Classgpn').focus();
                setJobCertificateOpen(false)
            }
        }
    }
    const jobContainerKeyUp = (e) => {
        if (e.key === 'Enter') {
            if (jobValues.container_detail === 'Y' || jobValues.container_detail === 'y') {
                if (!jobValues.job_no) {
                    setMessage('Please Select Job No From Job Table'); setSeverity('warning'); setOpenSnack(true)
                } else {
                    setAdcodeDetailsDetails([]); setJobContainerOpen(true); containerReset();
                    let details = { consignmentId: jobValues.job_no }
                    JobServices.getContainer(details).then(res => { setAdcodeDetailsDetails(res.data) });
                    JobServices.getIgmBasedOnContainer(jobValues.job_no).then(res => { setjobigmdropdwon(res.data) })
                }
            } else if (jobValues.container_detail === 'N' || jobValues.container_detail === 'n') {
                setJobContainerOpen(false)
            }
        }
    }
    const jobClassKeyUp = (e) => { if (e.key === 'Enter') { document.getElementById('Type(H/W/X)').focus(); } }
    const jobdialogeBondPortKeyUp = (e) => { if (e.key === 'F7') { DialogeJobBondPortOpenHandle(); } if (e.key === 'Enter') { document.getElementById('BondAmount').focus(); } }
    const jobdialogeBondAmountKeyUp = (e) => { if (e.key === 'Enter') { document.getElementById('BgDebited').focus(); } }
    const jobdialogeBondBgDebitedKeyDown = (e) => { if (e.key === 'Enter') { document.getElementById('BgRate').focus(); } }
    const jobdialogeBondBgRateKeyDown = (e) => { if (e.key === 'Enter') { document.getElementById('BgAmount').focus(); } }
    const jobdialogeBondBgAmountKeyDown = (e) => { if (e.key === 'Enter') { if (bondSaveDisab === false) { JobDialogeBondDetailSave(); } else { JobDialogeBondDetailUpdate(); } } }
    const jobdialogeContainerIgmNoKeyDown = (e) => { if (e.key === 'Enter') { document.getElementById('JobDialogContainerNo').focus(); } }
    const jobdialogeContainerNoKeyDown = (e) => { if (e.key === 'Enter') { document.getElementById('JobDialogContainerSize').focus(); } }
    const jobdialogeContainerSizeKeyDown = (e) => { if (e.key === 'Enter') { document.getElementById('jobDialogContainerLFC').focus(); } }
    const jobdialogeContainerLFCKeyDown = (e) => { if (e.key === 'Enter') { document.getElementById('JobDialogcontainerSealNo').focus(); } }
    const jobdialogeContainerSealNoKeyDown = (e) => { if (e.key === 'Enter') { document.getElementById('JobDialogTruckNo').focus(); } }
    const jobdialogeContainerTruckNoKeyDown = (e) => { if (e.key === 'Enter') { if (JobContainerSveDsab === false) { jobContainerSave(); } else { jobContainerUpdate(); } } }
    const jobdialogeTypeHWXKeyDown = (e) => { if (e.key === 'Enter') { document.getElementById('JobCustSiteId').focus(); } }
    const JobDialogWhereCusHusNameKeyDown = (e) => { if (e.key === 'Enter') { document.getElementById('msterFindCustomeCode').focus(); } }
    const JobDialogWherePkgNameKeyDown = (e) => { if (e.key === 'Enter') { document.getElementById('MstrFindPKgCode').focus(); } }
    const JobDialogWhereUniteNameKeyDown = (e) => { if (e.key === 'Enter') { document.getElementById('wareunitCode').focus(); } }
    const JobDialogIGMUnitNameKeyDown = (e) => { if (e.key === 'Enter') { document.getElementById('igm_FindUniteCode_id').focus(); } }
    const JobDialogIGMPKGNameKeyDown = (e) => { if (e.key === 'Enter') { document.getElementById('igmFindPkgCode_id').focus(); } }
    const JobDialogIGMGateWayPortNameKeyDown = (e) => { if (e.key === 'Enter') { document.getElementById('igmFind_gatwayPortCode_id').focus(); } }
    const JobTypeHWXKeyUp = (e) => {
        if (e.key === 'Enter') {
            if (jobValues.type_H_W_x === 'W' || jobValues.type_H_W_x === 'w' || jobValues.type_H_W_x === 'X' || jobValues.type_H_W_x === 'x') {
                setJobValues({ ...jobValues, type_H_W_x: e.target.value });
                if (jobValues.job_no === '') { setMessage('Please Select The Job Number'); setSeverity('warning'); setOpenSnack(true); }
                else { setJobTypeHWXOpen(true); JobTypegetWarehouseDetails(); document.getElementById('impTypeG_O_P_U').focus(); }
            } else { document.getElementById('impTypeG_O_P_U').focus(); }
        }
    }
    const JobImpTypeGOPUKeyUp = (e) => { if (e.key === 'Enter') { document.getElementById('jobkacha').focus(); } }
    const JobkachaKeyUp = (e) => { if (e.key === 'Enter') { document.getElementById('JobDifDefDF').focus(); } }
    const JobDifDefKeyUp = (e) => { if (e.key === 'Enter') { document.getElementById('JobgreenChn').focus(); } }
    const JobGressnChnKeyUp = (e) => { if (e.key === 'Enter') { document.getElementById('JobHss').focus(); } }
    const JobHssKeyUp = (e) => {
        if (e.key === 'Enter') {
            if (jobValues.hss_y_n === 'Y' || jobValues.hss_y_n === 'y') {
                if (jobValues.job_no === '') { setMessage('Please Select The Job Number'); setSeverity('warning'); setOpenSnack(true); }
                else { JobHssDialogeOpen(); document.getElementById('sec').focus(); }
            } else if (jobValues.hss_y_n === 'N' || jobValues.hss_y_n === 'n') { document.getElementById('sec').focus(); }
        }
    }
    const JobSec_48KeyUp = (e) => {
        if (e.key === 'Enter') {
            if (jobValues.sec_48_y_n === 'Y' || jobValues.sec_48_y_n === 'y') {
                if (jobValues.job_no === '') { setMessage('Please Select The Job Number'); setSeverity('warning'); setOpenSnack(true) }
                else { JobSec_48_Openhandle(); document.getElementById('publicSec').focus(); }
            }
            else if (jobValues.sec_48_y_n === 'N' || jobValues.sec_48_y_n === 'n') { document.getElementById('publicSec').focus(); }
        }
    }
    const JobPublicSecKeyUp = (e) => { if (e.key === 'Enter') { document.getElementById('1stcheack').focus(); } }
    const Job1stCheackKeyUp = (e) => {
        if (e.key === 'Enter') {
            if (jobValues.first_check_y_n === 'Y' || jobValues.first_check_y_n === 'y') { Job1stCheackOpenhandle(); document.getElementById('priorbe').focus(); }
            else if (jobValues.first_check_y_n === 'N' || jobValues.first_check_y_n === 'n' || jobValues.first_check_y_n === '') { document.getElementById('priorbe').focus(); }
        }
    }
    const JobPriorKeydown = (e) => {
        if (e.key === "Enter") {
            document.getElementById('cmmrcialtax').focus();
            if (jobValues.prior_be_y_n === 'Y' || jobValues.prior_be_y_n === 'y') {
                if (jobValues.mode_A_L_S === 'A' || jobValues.mode_A_L_S === 'a') { setJobIgmhide(true); setJobInwardatehide(true); setJobGateWayhide(true); setJobRepPorthide(true); }
                else if (jobValues.mode_A_L_S === 'S' || jobValues.mode_A_L_S === 's') { setJobIgmhide(false); setJobInwardatehide(true); setJobGateWayhide(true); setJobRepPorthide(false); }
                else if (jobValues.mode_A_L_S === 'L' || jobValues.mode_A_L_S === 'l') { setJobIgmhide(true); setJobInwardatehide(true); setJobGateWayhide(false); setJobRepPorthide(false); }
            }
            else if (jobValues.prior_be_y_n === 'N' || jobValues.prior_be_y_n === 'n') {
                if (jobValues.mode_A_L_S === 'A' || jobValues.mode_A_L_S === 'a') { setJobIgmhide(false); setJobInwardatehide(false); setJobGateWayhide(true); setJobRepPorthide(true); }
                else if (jobValues.mode_A_L_S === 'S' || jobValues.mode_A_L_S === 's') { setJobIgmhide(false); setJobInwardatehide(false); setJobGateWayhide(true); setJobRepPorthide(false); }
                else if (jobValues.mode_A_L_S === 'L' || jobValues.mode_A_L_S === 'l') { setJobIgmhide(false); setJobInwardatehide(false); setJobGateWayhide(false); setJobRepPorthide(false); }
            }
        }
    }
    const JobCommercialtaxKeydown = (e) => {
        if (e.key === "Enter") {
            if (jobValues.commercial_tax_y_n === 'Y' || jobValues.commercial_tax_y_n === 'y') {
                if (jobValues.job_no === '') { setMessage('Please Select The Job Number'); setSeverity('warning'); setOpenSnack(true) }
                else { JobCommercialtxOpenHandle(); document.getElementById('ucr').focus(); }
            }
            else { document.getElementById('ucr').focus(); }
        }
    }
    const JobUcrKeydown = (e) => { if (e.key === "Enter") { document.getElementById('ucrType').focus(); } }
    const JobUcrTypeKeydown = (e) => { if (e.key === "Enter") { document.getElementById('PaymentMode').focus(); } }
    const JobPaymentModeKeydown = (e) => {
        if (e.key === "Enter") {
            if (JobIgmhide === false) { document.getElementById('igmno').focus(); } else { document.getElementById('mblno').focus(); }
        }
    }
    ////////////////////////////////////////////////////////////////////
    const JobIgmNoKeydown = (e) => { if ((e.key === "Enter")) { document.getElementById('igm_date').focus(); } }
    const jobigmdatekeydown = (e) => { if (e.key === "Enter") { document.getElementById('mblno').focus(); } }
    const JobMBLNoKeydown = (e) => { if (e.key === "Enter") { document.getElementById('mawb_date').focus(); } }
    const jobmawb_datekeydown = (e) => { if (e.key === "Enter") { document.getElementById('hblno').focus(); } }
    const JobHBLNoKeydown = (e) => { if (e.key === "Enter") { document.getElementById('Haw_date').focus(); } }
    const jobHaw_datekeydown = (e) => { if (e.key === "Enter") { document.getElementById('noOfPkgs').focus(); } }
    const JobNoOfPkgsKeydown = (e) => { if (e.key === "Enter") { document.getElementById('pkg_code').focus(); } }
    const JobPkgCodeKeyDown = (e) => { if (e.key === "Enter") { document.getElementById('grooswt').focus(); } else if (e.key === 'F7') { JobPkgCode_Openhandle(); } }
    const JobGrossWtKeydown = (e) => { if (e.key === "Enter") { document.getElementById('jobunit').focus(); } }
    const JobunitKeyDown = (e) => { if (e.key === "Enter") { document.getElementById('InwardDate').focus(); } else if (e.key === 'F7') { JobUnitCode_Openhandle(); } }
    const jobInwardatekeydown = (e) => { if (e.key === "Enter") { document.getElementById('marks_number').focus(); } }
    const jobmarks_numberkeydown = (e) => {
        if (e.key === "Enter") {
            if (jobValues.mode_A_L_S === 'L' || jobValues.mode_A_L_S === 'l') { document.getElementById('gateway_igmno').focus(); }
            else { document.getElementById('Jsvigm').focus(); }
        }
    }
    const jobgateway_igmnokeydown = (e) => { if (e.key === "Enter") { document.getElementById('Report_id').focus(); } }
    const jobDialogeWarehusCusIdkeyup = (e) => {
        if (e.key === 'Enter') { document.getElementById('beno').focus(); }
        if (e.key === 'F7') { JobTypeHWX_custSiteId_Open(); }
    }
    const jobDialogeWarehusBeNokeyup = (e) => { if (e.key === 'Enter') { document.getElementById('JobDialogBedate').focus(); } }
    const jobDialogeWarehusBeDateKeyDown = (e) => { if (e.key === 'Enter') { document.getElementById('JobDialogNoOfPkg').focus(); } }
    const jobDialogeWarehusNoOfPkgKeyDown = (e) => { if (e.key === 'Enter') { document.getElementById('JobDialogPkgCode').focus(); } }
    const jobDialogeWarehusGrossWtKeyDown = (e) => { if (e.key === 'Enter') { document.getElementById('JobDialogUnit').focus(); } }
    const JobTypeHWX_pkgCodeKeyUp = (e) => {
        if (e.key === 'Enter') { document.getElementById('JobtypeHwxgrosswt').focus(); }
        if (e.key === 'F7') { JobTypeHWX_pkgCode_Open(); }
    }
    const JobTypeHWX_UnitCodeKeyUp = (e) => {
        if (e.key === 'Enter') { document.getElementById('AnnexureNo').focus(); }
        if (e.key === 'F7') { JobTypeHWX_UnitCode_Open(); }
    }
    const JobTypeHWX_AnnexreNoKeyUp = (e) => { if (e.key === 'Enter') { document.getElementById('JobDialogAnnexureDate').focus(); } }
    const JobTypeHWX_AnnexureDateKeyUp = (e) => { if (e.key === 'Enter') { document.getElementById('JobDateOfFinalDFW').focus(); } }
    const JobTypeHWX_DateOfFinalWareHouseKeyUp = (e) => { if (e.key === 'Enter') { document.getElementById('loadingForExBond').focus(); } }
    const JobTypeHWX_WareHouseLoadingForExBondKeyUp = (e) => { if (e.key === 'Enter') { document.getElementById('JobDialogTypeMiscellaneousLoadRate').focus(); } }
    const JobTypeHWX_WareHouseMiscellaneousKeyUp = (e) => { if (e.key === 'Enter') { document.getElementById('JobDialogExbondConsulateDescription').focus(); } }
    const JobTypeHWX_WareHouseExbondConsulateKeyUp = (e) => { if (e.key === 'Enter') { jobupdateWarehouse(); } }
    const JobDialogHssFindImportNameKeyDown = (e) => { if (e.key === 'Enter') { document.getElementById('JobDialogHssFindImporterCode').focus(); } }
    const JobDialogHssFindImportStateKeyDown = (e) => { if (e.key === 'Enter') { document.getElementById('JobDialogHssFindBranchSLno').focus(); } }
    const JobRepPortKeyDown = (e) => {
        if (e.key === 'F7') { JobRepPort_Openhandle(); }
        else if (e.key === 'Enter') { document.getElementById('gateWayDate').focus(); }
    }
    ///hhh
    const JobGatewayKeyDown = (e) => {
        if (e.key === 'Enter') {
            if (JobIGMSaveDsab === false) { document.getElementById('Jsvigm').focus(); }
            else { document.getElementById('JupdIgm').focus(); }
        }
    }
    const JobTypegetWarehouseDetails = () => {
        let details = { consignmentId: jobValues.job_no }
        JobServices.getWarehouseDetails(details).then(res => {
            const data = res.data;
            const warehusdetails = data.map((whd) => whd);
            var lfe, mlr = '';
            if (warehusdetails[0].exbondAmt !== 0 || warehusdetails[0].exbondAmt !== 0.0) {
                lfe = warehusdetails[0].exbondAmt;
                setJobTypeHWX_LE_Radio('a')
            }
            else if (warehusdetails[0].exbondRate !== 0 || warehusdetails[0].exbondRate !== 0.0) {
                lfe = warehusdetails[0].exbondRate;
                setJobTypeHWX_LE_Radio('r')
            } else {
                lfe = '';
            }
            // ----- ------ ------ ---- // ----
            if (warehusdetails[0].mis_amount !== 0 || warehusdetails[0].mis_amount !== 0.0) {
                mlr = warehusdetails[0].mis_amount;
                setJobTypeHWX_MLR_Radio('a')
            }
            else if (warehusdetails[0].mis_rate !== 0 || warehusdetails[0].mis_rate !== 0.0) {
                mlr = warehusdetails[0].mis_rate;
                setJobTypeHWX_MLR_Radio('r')
            } else {
                mlr = '';
                setJobTypeHWX_MLR_Radio('')
            }
            setJobDialogValues({
                ...jobDialogValues, typeH_w_xCode: warehusdetails[0].warehouseCode, typeH_w_xCustSiteId: warehusdetails[0].warehouseCustomeSite
                , typeH_w_xBeNo: warehusdetails[0].warehouseBeNo, typeH_w_xBeDate: warehusdetails[0].warehouseBeDate, typeH_w_xNoOfPkg: warehusdetails[0].noofPkg,
                typeH_w_xPkgCode: warehusdetails[0].pkgCode, typeH_w_xGroos: warehusdetails[0].gross_wt, typeH_w_xUnitCode: warehusdetails[0].uomCode, typeH_w_xAnnexureNo: warehusdetails[0].annexureNo
                , typeH_w_xAnnexureDate: warehusdetails[0].annexureDate, typeH_w_xDFW: warehusdetails[0].finalWarehousingDate, typeH_w_xLFE: lfe, typeH_w_xMLR: mlr, typeH_w_xECD: warehusdetails[0].exbondDesc
            })
        })
    }
    //--------------------------------------onFocusOut---------------------------------------------------------------
    const cntryOfOrginOnBlur = (e) => {
        if (jobValues.job_no === '' || !jobValues.job_no || jobValues.job_no === null) {
            if (jobValues.name === '') {
                setMessage('IEC CODE NOT AVAILABLE FROM MASTER')
                setOpenSnack(true)
                setSeverity('error')
            } else {
                if (jobValues.address_1 === '') {
                    setMessage('BRANCH SR.NO NOT AVAILABLE FROM MASTER')
                    setOpenSnack(true)
                    setSeverity('error')
                }
                else {
                    if (jobValues.customHousCode === '') {
                        setMessage('CUSTOM HOUSE CODE NOT AVAILABLE FROM MASTER')
                        setOpenSnack(true)
                        setSeverity('error')
                    } else {
                        let details = { importer_iec_no: jobValues.iec_search, branchId: jobValues.branch_sr_no, createdBy: getUserId() }
                        JobServices.insertPreAlertJobNo(details).then(res => {
                            if (res.data[0].consignmentNumber === 'Error') {
                                setMessage('Pre Alert job.No Not Created'); setSeverity('error'); setOpenSnack(true)
                            } else {
                                setJobValues({ ...jobValues, job_no: res.data[0].userJobNo, edi_job_no: res.data[0].consignmentNumber })
                            }

                        }).catch(error => {
                            setMessage(error.message);
                            setSeverity('error');
                            setOpenSnack(true)
                        })
                    }

                }
            }
        }
    }
    //hhh
    const JobMarksNumberonBlur = () => {
        if (jobValues.mode_A_L_S === 'i' || jobValues.mode_A_L_S === 'I' || jobValues.mode_A_L_S === 'L' || jobValues.mode_A_L_S === 'l') {
            document.getElementById('gateway_igmno').focus();
        } else {
            if (JobIGMSaveDsab === false) {
                saveigm();
            } else {
                updateIgm();
                document.getElementById('igmno').focus();
            }
        }
    }

    const JobGatewayDateonBlur = () => {
        if (JobIGMSaveDsab === false) {
            saveigm();
        } else {
            updateIgm();
        }
    }

    const masterTransitKeyDown=(e)=>{
        const mydata = transitDetails.map(node=>node);var selectdetails = [];
        if(e.key==='ArrowDown'){selectdetails = (MasterTransitSelect ,mydata[QuryIndex+1].transitTypeCode); setMasterTransitSelect(selectdetails);setQuryIndex(QuryIndex+1);}
       else if(e.key==='ArrowUp'){selectdetails = (MasterTransitSelect ,mydata[QuryIndex-1].transitTypeCode); setMasterTransitSelect(selectdetails);setQuryIndex(QuryIndex-1);}
       else if(e.key==='Enter'){jobeditTransitType(mydata[QuryIndex])}
    }
    const masterCustomKeyDown=(e)=>{
        const mydata = CustomHouseDetails.map(node=>node);var selectdetails = [];
        if(e.key==='ArrowDown'){selectdetails = (MasterTransitSelect ,mydata[QuryIndex+1].customHouseCode); setMasterTransitSelect(selectdetails);setQuryIndex(QuryIndex+1);}
       else if(e.key==='ArrowUp'){selectdetails = (MasterTransitSelect ,mydata[QuryIndex-1].customHouseCode); setMasterTransitSelect(selectdetails);setQuryIndex(QuryIndex-1);}
       else if(e.key==='Enter'){JobEditCusHouscode(mydata[QuryIndex])}
    }

    const masterBranchKeyDown=(e)=>{
        const mydata = BranchDetails.map(node=>node);var selectdetails = [];
        if(e.key==='ArrowDown'){selectdetails = (MasterTransitSelect ,mydata[QuryIndex+1].regionalName); setMasterTransitSelect(selectdetails);setQuryIndex(QuryIndex+1);}
       else if(e.key==='ArrowUp'){selectdetails = (MasterTransitSelect ,mydata[QuryIndex-1].regionalName); setMasterTransitSelect(selectdetails);setQuryIndex(QuryIndex-1);}
       else if(e.key==='Enter'){JobEditBranchName(mydata[QuryIndex])}
    }

    const masterFrwdrKeyDown=(e)=>{
        const mydata = ForwdrDetails.map(node=>node);var selectdetails = [];
        if(e.key==='ArrowDown'){selectdetails = (MasterTransitSelect ,mydata[QuryIndex+1].freightFwdName); setMasterTransitSelect(selectdetails);setQuryIndex(QuryIndex+1);}
       else if(e.key==='ArrowUp'){selectdetails = (MasterTransitSelect ,mydata[QuryIndex-1].freightFwdName); setMasterTransitSelect(selectdetails);setQuryIndex(QuryIndex-1);}
       else if(e.key==='Enter'){JobEditFrwdr(mydata[QuryIndex])}
    }

    const masterImporterIecKeyDown=(e)=>{
        const mydata = JobImporterDetails.map(node=>node);var selectdetails = [];
        if(e.key==='ArrowDown'){selectdetails = (MasterTransitSelect ,mydata[QuryIndex+1].importer_iec_no); setMasterTransitSelect(selectdetails);setQuryIndex(QuryIndex+1);}
       else if(e.key==='ArrowUp'){selectdetails = (MasterTransitSelect ,mydata[QuryIndex-1].importer_iec_no); setMasterTransitSelect(selectdetails);setQuryIndex(QuryIndex-1);}
       else if(e.key==='Enter'){jobEditImporter(mydata[QuryIndex])}
    }
    const masterBrnchSlNOKeyDown=(e)=>{
        const mydata = BranchSrDetails.map(node=>node);var selectdetails = [];
        if(e.key==='ArrowDown'){selectdetails = (MasterTransitSelect ,mydata[QuryIndex+1].branch_sl_no); setMasterTransitSelect(selectdetails);setQuryIndex(QuryIndex+1);}
       else if(e.key==='ArrowUp'){selectdetails = (MasterTransitSelect ,mydata[QuryIndex-1].branch_sl_no); setMasterTransitSelect(selectdetails);setQuryIndex(QuryIndex-1);}
       else if(e.key==='Enter'){jobEditBrncSl(mydata[QuryIndex])}
    }
    const masterAdCodeKeyDown=(e)=>{
        const mydata = JobAdCodeDetails.map(node=>node);var selectdetails = [];
        if(e.key==='ArrowDown'){selectdetails = (MasterTransitSelect ,mydata[QuryIndex+1].ad_code); setMasterTransitSelect(selectdetails);setQuryIndex(QuryIndex+1);}
       else if(e.key==='ArrowUp'){selectdetails = (MasterTransitSelect ,mydata[QuryIndex-1].ad_code); setMasterTransitSelect(selectdetails);setQuryIndex(QuryIndex-1);}
       else if(e.key==='Enter'){jobEditAdCode(mydata[QuryIndex])}
    }
    const masterOriginCountryKeyDown=(e)=>{
        const mydata = JobCountryOrigineDtails.map(node=>node);var selectdetails = [];
        if(e.key==='ArrowDown'){selectdetails = (MasterTransitSelect ,mydata[QuryIndex+1].countryIdString); setMasterTransitSelect(selectdetails);setQuryIndex(QuryIndex+1);}
       else if(e.key==='ArrowUp'){selectdetails = (MasterTransitSelect ,mydata[QuryIndex-1].countryIdString); setMasterTransitSelect(selectdetails);setQuryIndex(QuryIndex-1);}
       else if(e.key==='Enter'){JobEditCntryOrign(mydata[QuryIndex])}
    }
    const masterConsigmentCountryKeyDown=(e)=>{
        const mydata = JobCountryOfCmDtails.map(node=>node);var selectdetails = [];
        if(e.key==='ArrowDown'){selectdetails = (MasterTransitSelect ,mydata[QuryIndex+1].countryIdString); setMasterTransitSelect(selectdetails);setQuryIndex(QuryIndex+1);}
       else if(e.key==='ArrowUp'){selectdetails = (MasterTransitSelect ,mydata[QuryIndex-1].countryIdString); setMasterTransitSelect(selectdetails);setQuryIndex(QuryIndex-1);}
       else if(e.key==='Enter'){JobEditCntryOfCm(mydata[QuryIndex])}
    }
    const masterOriginPortKeyDown=(e)=>{
            const mydata = JobCountryOfCmDtails.map(node=>node);var selectdetails = [];
        if(e.key==='ArrowDown'){selectdetails = (MasterTransitSelect ,mydata[QuryIndex+1].customPointCode); setMasterTransitSelect(selectdetails);setQuryIndex(QuryIndex+1);}
       else if(e.key==='ArrowUp'){selectdetails = (MasterTransitSelect ,mydata[QuryIndex-1].customPointCode); setMasterTransitSelect(selectdetails);setQuryIndex(QuryIndex-1);}
       else if(e.key==='Enter'){JobEditCntryOfPort(mydata[QuryIndex])}
    }
    const masterCertificateNoKeyDown=(e)=>{
            const mydata = JobAdCodeDetails.map(node=>node);var selectdetails = [];
        if(e.key==='ArrowDown'){selectdetails = (MasterTransitSelect ,mydata[QuryIndex+1].certificateNo); setMasterTransitSelect(selectdetails);setQuryIndex(QuryIndex+1);}
       else if(e.key==='ArrowUp'){selectdetails = (MasterTransitSelect ,mydata[QuryIndex-1].certificateNo); setMasterTransitSelect(selectdetails);setQuryIndex(QuryIndex-1);}
       else if(e.key==='Enter'){jobEditCertificate(mydata[QuryIndex])}
    }
    const masterBondPortKeyDown=(e)=>{
            const mydata = CustomHouseDetails.map(node=>node);var selectdetails = [];
        if(e.key==='ArrowDown'){selectdetails = (MasterTransitSelect ,mydata[QuryIndex+1].customHouseCode); setMasterTransitSelect(selectdetails);setQuryIndex(QuryIndex+1);}
       else if(e.key==='ArrowUp'){selectdetails = (MasterTransitSelect ,mydata[QuryIndex-1].customHouseCode); setMasterTransitSelect(selectdetails);setQuryIndex(QuryIndex-1);}
       else if(e.key==='Enter'){jobbondPortCusDetails(mydata[QuryIndex])}
    }
    const masterBondDetailsKeyDown=(e)=>{
            const mydata = JobAdCodeDetails.map(node=>node);var selectdetails = [];
        if(e.key==='ArrowDown'){selectdetails = (MasterTransitSelect ,mydata[QuryIndex+1].bondNo); setMasterTransitSelect(selectdetails);setQuryIndex(QuryIndex+1);}
       else if(e.key==='ArrowUp'){selectdetails = (MasterTransitSelect ,mydata[QuryIndex-1].bondNo); setMasterTransitSelect(selectdetails);setQuryIndex(QuryIndex-1);}
       else if(e.key==='Enter'){jobEditBondDetails(mydata[QuryIndex])}
    }
    const masterContainerDetailsKeyDown=(e)=>{ const mydata = JobAdCodeDetails.map(node=>node);var selectdetails = [];
        if(e.key==='ArrowDown'){selectdetails = (MasterTransitSelect ,mydata[QuryIndex+1].containorNo); setMasterTransitSelect(selectdetails);setQuryIndex(QuryIndex+1);}
       else if(e.key==='ArrowUp'){selectdetails = (MasterTransitSelect ,mydata[QuryIndex-1].containorNo); setMasterTransitSelect(selectdetails);setQuryIndex(QuryIndex-1);}
       else if(e.key==='Enter'){jobEditContainer(mydata[QuryIndex])}
    }
    const masterWhereCusHusDetailsKeyDown=(e)=>{ const mydata = CustomHouseDetails.map(node=>node);var selectdetails = [];
        if(e.key==='ArrowDown'){selectdetails = (MasterTransitSelect ,mydata[QuryIndex+1].customHouseCode); setMasterTransitSelect(selectdetails);setQuryIndex(QuryIndex+1);}
       else if(e.key==='ArrowUp'){selectdetails = (MasterTransitSelect ,mydata[QuryIndex-1].customHouseCode); setMasterTransitSelect(selectdetails);setQuryIndex(QuryIndex-1);}
       else if(e.key==='Enter'){JobEditwareCusHouscode(mydata[QuryIndex])}
    }
    const masterWherePkgKeyDown=(e)=>{ const mydata = CustomHouseDetails.map(node=>node);var selectdetails = [];
        if(e.key==='ArrowDown'){selectdetails = (MasterTransitSelect ,mydata[QuryIndex+1].unitCode); setMasterTransitSelect(selectdetails);setQuryIndex(QuryIndex+1);}
       else if(e.key==='ArrowUp'){selectdetails = (MasterTransitSelect ,mydata[QuryIndex-1].unitCode); setMasterTransitSelect(selectdetails);setQuryIndex(QuryIndex-1);}
       else if(e.key==='Enter'){JobEditwarePkgCode(mydata[QuryIndex])}
    }
    const masterWhereunitKeyDown=(e)=>{ const mydata = CustomHouseDetails.map(node=>node);var selectdetails = [];
        if(e.key==='ArrowDown'){selectdetails = (MasterTransitSelect ,mydata[QuryIndex+1].unitCode); setMasterTransitSelect(selectdetails);setQuryIndex(QuryIndex+1);}
       else if(e.key==='ArrowUp'){selectdetails = (MasterTransitSelect ,mydata[QuryIndex-1].unitCode); setMasterTransitSelect(selectdetails);setQuryIndex(QuryIndex-1);}
       else if(e.key==='Enter'){JobEditwareUnitCode(mydata[QuryIndex])}
    }
    const masterHssImrtCodeKeyDown=(e)=>{ const mydata = JobImporterDetails.map(node=>node);var selectdetails = [];
        if(e.key==='ArrowDown'){selectdetails = (MasterTransitSelect ,mydata[QuryIndex+1].importer_iec_no); setMasterTransitSelect(selectdetails);setQuryIndex(QuryIndex+1);}
       else if(e.key==='ArrowUp'){selectdetails = (MasterTransitSelect ,mydata[QuryIndex-1].importer_iec_no); setMasterTransitSelect(selectdetails);setQuryIndex(QuryIndex-1);}
       else if(e.key==='Enter'){EditHssImport(mydata[QuryIndex])}
    }
    const masterHssBrnchSlNoKeyDown=(e)=>{ const mydata = BranchSrDetails.map(node=>node);var selectdetails = [];
        if(e.key==='ArrowDown'){selectdetails = (MasterTransitSelect ,mydata[QuryIndex+1].branch_sl_no); setMasterTransitSelect(selectdetails);setQuryIndex(QuryIndex+1);}
       else if(e.key==='ArrowUp'){selectdetails = (MasterTransitSelect ,mydata[QuryIndex-1].branch_sl_no); setMasterTransitSelect(selectdetails);setQuryIndex(QuryIndex-1);}
       else if(e.key==='Enter'){jobEditHss_BrncSl(mydata[QuryIndex])}
    }
    const masterHssDetailsKeyDown=(e)=>{ const mydata = jobHssDetails.map(node=>node);var selectdetails = [];
        if(e.key==='ArrowDown'){selectdetails = (MasterTransitSelect ,mydata[QuryIndex+1].iecCodeHss); setMasterTransitSelect(selectdetails);setQuryIndex(QuryIndex+1);}
       else if(e.key==='ArrowUp'){selectdetails = (MasterTransitSelect ,mydata[QuryIndex-1].iecCodeHss); setMasterTransitSelect(selectdetails);setQuryIndex(QuryIndex-1);}
       else if(e.key==='Enter'){JobEditHssDetail(mydata[QuryIndex])}
    }
    const masterSec48DetailsKeyDown=(e)=>{ const mydata = jobSecDetails.map(node=>node);var selectdetails = [];
        if(e.key==='ArrowDown'){selectdetails = (MasterTransitSelect ,mydata[QuryIndex+1].permissionCode); setMasterTransitSelect(selectdetails);setQuryIndex(QuryIndex+1);}
       else if(e.key==='ArrowUp'){selectdetails = (MasterTransitSelect ,mydata[QuryIndex-1].permissionCode); setMasterTransitSelect(selectdetails);setQuryIndex(QuryIndex-1);}
       else if(e.key==='Enter'){JobEditSec48Detail(mydata[QuryIndex])}
    }
    const master1stCheckKeyDown=(e)=>{ const mydata = jobSecDetails.map(node=>node);var selectdetails = [];
        if(e.key==='ArrowDown'){selectdetails = (MasterTransitSelect ,mydata[QuryIndex+1].permissionCode); setMasterTransitSelect(selectdetails);setQuryIndex(QuryIndex+1);}
       else if(e.key==='ArrowUp'){selectdetails = (MasterTransitSelect ,mydata[QuryIndex-1].permissionCode); setMasterTransitSelect(selectdetails);setQuryIndex(QuryIndex-1);}
       else if(e.key==='Enter'){JobEdit1stCheckDetail(mydata[QuryIndex])}
    }
    const masterCmrclKeyDown=(e)=>{ const mydata = jobCmrcialDetails.map(node=>node);var selectdetails = [];
        if(e.key==='ArrowDown'){selectdetails = (MasterTransitSelect ,mydata[QuryIndex+1].taxStateCode); setMasterTransitSelect(selectdetails);setQuryIndex(QuryIndex+1);}
       else if(e.key==='ArrowUp'){selectdetails = (MasterTransitSelect ,mydata[QuryIndex-1].taxStateCode); setMasterTransitSelect(selectdetails);setQuryIndex(QuryIndex-1);}
       else if(e.key==='Enter'){JobEditCmrcialTxDetail(mydata[QuryIndex])}
    }
    const masterUniteCodeDetailsKeyDown=(e)=>{ const mydata = CustomHouseDetails.map(node=>node);var selectdetails = [];
        if(e.key==='ArrowDown'){selectdetails = (MasterTransitSelect ,mydata[QuryIndex+1].unitCode); setMasterTransitSelect(selectdetails);setQuryIndex(QuryIndex+1);}
       else if(e.key==='ArrowUp'){selectdetails = (MasterTransitSelect ,mydata[QuryIndex-1].unitCode); setMasterTransitSelect(selectdetails);setQuryIndex(QuryIndex-1);}
       else if(e.key==='Enter'){JobEditIgmUnitCode(mydata[QuryIndex])}
    }
    const masterIGMPKGCodeDetailsKeyDown=(e)=>{ const mydata = CustomHouseDetails.map(node=>node);var selectdetails = [];
        if(e.key==='ArrowDown'){selectdetails = (MasterTransitSelect ,mydata[QuryIndex+1].unitCode); setMasterTransitSelect(selectdetails);setQuryIndex(QuryIndex+1);}
       else if(e.key==='ArrowUp'){selectdetails = (MasterTransitSelect ,mydata[QuryIndex-1].unitCode); setMasterTransitSelect(selectdetails);setQuryIndex(QuryIndex-1);}
       else if(e.key==='Enter'){JobEditIgmPkgCode(mydata[QuryIndex])}
    }
    const masterIGMGateWayPortKeyDown=(e)=>{ const mydata = CustomHouseDetails.map(node=>node);var selectdetails = [];
        if(e.key==='ArrowDown'){selectdetails = (MasterTransitSelect ,mydata[QuryIndex+1].customHouseCode); setMasterTransitSelect(selectdetails);setQuryIndex(QuryIndex+1);}
       else if(e.key==='ArrowUp'){selectdetails = (MasterTransitSelect ,mydata[QuryIndex-1].customHouseCode); setMasterTransitSelect(selectdetails);setQuryIndex(QuryIndex-1);}
       else if(e.key==='Enter'){JobEditReport(mydata[QuryIndex])}
    }
    const masterIgmTableKeyDown=(e)=>{ const mydata = jobIgmDetails.map(node=>node);var selectdetails = [];
        if(e.key==='ArrowDown'){selectdetails = (MasterTransitSelect ,mydata[QuryIndex+1].igmNo); setMasterTransitSelect(selectdetails);setQuryIndex(QuryIndex+1);}
       else if(e.key==='ArrowUp'){selectdetails = (MasterTransitSelect ,mydata[QuryIndex-1].igmNo); setMasterTransitSelect(selectdetails);setQuryIndex(QuryIndex-1);}
       else if(e.key==='Enter'){EditIgmDetails(mydata[QuryIndex])}
    }

    const JobDialogTransitCodeKeyDown=(e)=>{const mydata = transitDetails.map(node=>node);
        if(e.key==='Enter'){document.getElementById('masterTrnsit_id').focus();setMasterTransitSelect([]);
            setQuryIndex(0);var selectdetails = [];selectdetails = (MasterTransitSelect ,mydata[0].transitTypeCode); setMasterTransitSelect(selectdetails);
        }
    }
    const JobDialogCusHousCodeKeyDown=(e)=>{const mydata = CustomHouseDetails.map(node=>node);
        if(e.key==='Enter'){document.getElementById('masterCusCode_id').focus();setMasterTransitSelect([]);
            setQuryIndex(0);var selectdetails = [];selectdetails = (MasterTransitSelect ,mydata[0].customHouseCode); setMasterTransitSelect(selectdetails);
        }
    }

    const JobDialogBranchKeyDown=(e)=>{ const mydata = BranchDetails.map(node=>node);
        if(e.key==='Enter'){document.getElementById('masterBranch_id').focus();setMasterTransitSelect([]);
            setQuryIndex(0);var selectdetails = [];selectdetails = (MasterTransitSelect ,mydata[0].regionalName); setMasterTransitSelect(selectdetails);
        }
    }

    const JobDialogforwrdrKeyDown=(e)=>{ const mydata = ForwdrDetails.map(node=>node);
        if(e.key==='Enter'){document.getElementById('masterRegional_id').focus();setMasterTransitSelect([]);
        setQuryIndex(0);var selectdetails = [];selectdetails = (MasterTransitSelect ,mydata[0].freightFwdName); setMasterTransitSelect(selectdetails);
    }
    }

    const JobDialogIecImporterCodeKeyDown=(e)=>{ const mydata = JobImporterDetails.map(node=>node); 
        if(e.key==='Enter'){document.getElementById('masterImporterIec_id').focus();setMasterTransitSelect([]);
        setQuryIndex(0);var selectdetails = [];selectdetails = (MasterTransitSelect ,mydata[0].importer_iec_no); setMasterTransitSelect(selectdetails);
    }
    }

    const JobDialogBranchSl_noKeyDown=(e)=>{ const mydata = BranchSrDetails.map(node=>node); 
        if(e.key==='Enter'){document.getElementById('masterBrnch_sl_id').focus();setMasterTransitSelect([]);
        setQuryIndex(0);var selectdetails = [];selectdetails = (MasterTransitSelect ,mydata[0].branch_sl_no); setMasterTransitSelect(selectdetails);
    }
    }
    const JobDialogAdCodeKeyDown=(e)=>{ const mydata = JobAdCodeDetails.map(node=>node); 
        if(e.key==='Enter'){document.getElementById('masterAdCode_id').focus();setMasterTransitSelect([]);
        setQuryIndex(0);var selectdetails = [];selectdetails = (MasterTransitSelect ,mydata[0].ad_code); setMasterTransitSelect(selectdetails);
    }
    }

    const JobDialogFindOriginCntryCodeKeyDown=(e)=>{ const mydata = JobCountryOrigineDtails.map(node=>node); 
        if(e.key==='Enter'){document.getElementById('masterOriginCountry_id').focus();setMasterTransitSelect([]);
        setQuryIndex(0);var selectdetails = [];selectdetails = (MasterTransitSelect ,mydata[0].countryIdString); setMasterTransitSelect(selectdetails);
    }
    }
    const JobDialogFindConsignCntryCodeKeyDown=(e)=>{ const mydata = JobCountryOfCmDtails.map(node=>node); 
        if(e.key==='Enter'){document.getElementById('masterConsignmentCountry_id').focus();setMasterTransitSelect([]);
        setQuryIndex(0);var selectdetails = [];selectdetails = (MasterTransitSelect ,mydata[0].countryIdString); setMasterTransitSelect(selectdetails);
    }
    }
    const JobDialogFindPortCntrycodeKeyDown=(e)=>{ const mydata = JobCountryOfCmDtails.map(node=>node); 
        if(e.key==='Enter'){document.getElementById('masterOriginPort_id').focus();setMasterTransitSelect([]);
        setQuryIndex(0);var selectdetails = [];selectdetails = (MasterTransitSelect ,mydata[0].customPointCode); setMasterTransitSelect(selectdetails);
    }
    }
    const JobDialogCertificateRefBtnKeyDown=(e)=>{ const mydata = JobAdCodeDetails.map(node=>node); 
        if(e.key==='Enter'){document.getElementById('masterCertificateNo_id').focus();setMasterTransitSelect([]);
        setQuryIndex(0);var selectdetails = [];selectdetails = (MasterTransitSelect ,mydata[0].certificateNo); setMasterTransitSelect(selectdetails);
    }
    }
    const JobDialogFindBondPortCodeKeyDown=(e)=>{ const mydata = CustomHouseDetails.map(node=>node); 
        if(e.key==='Enter'){document.getElementById('masterBondPortCode_id').focus();setMasterTransitSelect([]);
        setQuryIndex(0);var selectdetails = [];selectdetails = (MasterTransitSelect ,mydata[0].customHouseCode); setMasterTransitSelect(selectdetails);
    }
    }
    const JobDialogBondRefBtnKeyDown=(e)=>{ const mydata = JobAdCodeDetails.map(node=>node); 
        if(e.key==='Enter'){document.getElementById('masterBondDetails_id').focus();setMasterTransitSelect([]);
        setQuryIndex(0);var selectdetails = [];selectdetails = (MasterTransitSelect ,mydata[0].bondNo); setMasterTransitSelect(selectdetails);}
    }
    const JobDialogContainerRefBtnKeyDown=(e)=>{ const mydata = JobAdCodeDetails.map(node=>node); 
        if(e.key==='Enter'){document.getElementById('masterContainerDetails_id').focus();setMasterTransitSelect([]);
        setQuryIndex(0);var selectdetails = [];selectdetails = (MasterTransitSelect ,mydata[0].bondNo); setMasterTransitSelect(selectdetails);}
    }
    const JobDialogWhereCusHusKeyDown=(e)=>{ const mydata = CustomHouseDetails.map(node=>node); 
        if(e.key==='Enter'){document.getElementById('masterwhereCusHusDetails_id').focus();setMasterTransitSelect([]);
        setQuryIndex(0);var selectdetails = [];selectdetails = (MasterTransitSelect ,mydata[0].customHouseCode); setMasterTransitSelect(selectdetails);}
    }
    const JobDialogWherePkgcodeKeyDown=(e)=>{ const mydata = CustomHouseDetails.map(node=>node); 
        if(e.key==='Enter'){document.getElementById('masterwherePKGDetails_id').focus();setMasterTransitSelect([]);
        setQuryIndex(0);var selectdetails = [];selectdetails = (MasterTransitSelect ,mydata[0].unitCode); setMasterTransitSelect(selectdetails);}
    }
    const JobDialogWhereUnitecodeKeyDown=(e)=>{ const mydata = CustomHouseDetails.map(node=>node); 
        if(e.key==='Enter'){document.getElementById('masterwhereUnitDetails_id').focus();setMasterTransitSelect([]);
        setQuryIndex(0);var selectdetails = [];selectdetails = (MasterTransitSelect ,mydata[0].unitCode); setMasterTransitSelect(selectdetails);}
    }
    const JobDialogHssFindImportCodeKeyDown=(e)=>{ const mydata = JobImporterDetails.map(node=>node); 
        if(e.key==='Enter'){document.getElementById('masterHssImportDetails_id').focus();setMasterTransitSelect([]);
        setQuryIndex(0);var selectdetails = [];selectdetails = (MasterTransitSelect ,mydata[0].importer_iec_no); setMasterTransitSelect(selectdetails);}
    }
    const JobDialogHssFindBrnchSrlKeyDown=(e)=>{ const mydata = BranchSrDetails.map(node=>node); 
        if(e.key==='Enter'){document.getElementById('masterHssBrnchSlno_id').focus();setMasterTransitSelect([]);
        setQuryIndex(0);var selectdetails = [];selectdetails = (MasterTransitSelect ,mydata[0].branch_sl_no); setMasterTransitSelect(selectdetails);}
    }
    const masterhssDetailsRefBtnkeyDown=(e)=>{ const mydata = jobHssDetails.map(node=>node); 
        if(e.key==='Enter'){document.getElementById('masterHssDetails_id').focus();setMasterTransitSelect([]);
        setQuryIndex(0);var selectdetails = [];selectdetails = (MasterTransitSelect ,mydata[0].iecCodeHss); setMasterTransitSelect(selectdetails);}
    }
    const masterSec48DetailsRefBtnkeyDown=(e)=>{ const mydata = jobSecDetails.map(node=>node); 
        if(e.key==='Enter'){document.getElementById('masterSec48Details_id').focus();setMasterTransitSelect([]);
        setQuryIndex(0);var selectdetails = [];selectdetails = (MasterTransitSelect ,mydata[0].permissionCode); setMasterTransitSelect(selectdetails);}
    }
    const master1stCheckRefBtnkeyDown=(e)=>{ const mydata = jobSecDetails.map(node=>node); 
        if(e.key==='Enter'){document.getElementById('master1stCheck_id').focus();setMasterTransitSelect([]);
        setQuryIndex(0);var selectdetails = [];selectdetails = (MasterTransitSelect ,mydata[0].permissionCode); setMasterTransitSelect(selectdetails);}
    }
    const JobDialogCmrcialTaxRefBtnKeyDown=(e)=>{ const mydata = jobCmrcialDetails.map(node=>node); 
        if(e.key==='Enter'){document.getElementById('masterCmrcl_id').focus();setMasterTransitSelect([]);
        setQuryIndex(0);var selectdetails = [];selectdetails = (MasterTransitSelect ,mydata[0].taxStateCode); setMasterTransitSelect(selectdetails);}
    }
    const JobDialogIGMUnitCodeKeyDown=(e)=>{ const mydata = CustomHouseDetails.map(node=>node); 
        if(e.key==='Enter'){document.getElementById('masterUnitCodeDetails_id').focus();setMasterTransitSelect([]);
        setQuryIndex(0);var selectdetails = [];selectdetails = (MasterTransitSelect ,mydata[0].unitCode); setMasterTransitSelect(selectdetails);}
    }
    const JobDialogIGMPKGCodeKeyDown=(e)=>{ const mydata = CustomHouseDetails.map(node=>node); 
        if(e.key==='Enter'){document.getElementById('masterIGMPKGCodeDetails_id').focus();setMasterTransitSelect([]);
        setQuryIndex(0);var selectdetails = [];selectdetails = (MasterTransitSelect ,mydata[0].unitCode); setMasterTransitSelect(selectdetails);}
    }
    const JobDialogIGMGateWayPortKeyDown=(e)=>{ const mydata = CustomHouseDetails.map(node=>node); 
        if(e.key==='Enter'){document.getElementById('masterIGMGatewayReport_id').focus();setMasterTransitSelect([]);
        setQuryIndex(0);var selectdetails = [];selectdetails = (MasterTransitSelect ,mydata[0].customHouseCode); setMasterTransitSelect(selectdetails);}
    }
    const masterIgmRefBtneKeyDown=(e)=>{ const mydata = jobIgmDetails.map(node=>node); 
        if(e.key==='Enter'){document.getElementById('masterIGMGatewayReport_id').focus();setMasterTransitSelect([]);
        setQuryIndex(0);var selectdetails = [];selectdetails = (MasterTransitSelect ,mydata[0].igmNo); setMasterTransitSelect(selectdetails);}
    }

    //--------------------------------------DIALOG OPEN CLOSE-----------------------------------------------------

    const JobModelsearchHandleClose = () => {
        setJobModelOpen(false);
        setJobDialogValues({ ...jobDialogValues, transit_name: '', transit_code: '' })
    }
    const JobModeSearchHandleOpen = () => {
        setJobDialogValues({ ...jobDialogValues, transit_code: jobValues.mode_A_L_S })
        setTransitDetails([])
        var transitCode, transitName = '';
        setJobModelOpen(true)
        if (jobValues.model_A_L_S_Name === '') {
            transitName = '-1'
        } else {
            transitName = jobValues.model_A_L_S_Name;
        }
        if (jobValues.mode_A_L_S === '') {
            transitCode = '-1'
        } else {
            transitCode = jobValues.mode_A_L_S;
        }
        let details = {
            transitTypeCode: transitCode,
            transitTypeName: transitName, flag: '2'
        }
        JobServices.getTransitType(details).then(res => {
            setTransitDetails(res.data);
        })
    }

    const JobChsCodeHandleClose = () => {
        setJobChsOpen(false);
        setJobDialogValues({ ...jobDialogValues, cusHousCode: '', cusHousName: '' })
    }
    const JobChsCodeHandleOpen = () => {
        setCustomHouseDetails([])
        setJobDialogValues({ ...jobDialogValues, cusHousCode: jobValues.customHousCode })
        if (jobValues.mode_A_L_S === '') {
            setMessage('Please Select Transite Type');
            setSeverity('error')
            setOpenSnack(true)
        } else {
            setJobChsOpen(true)
            var cusCode, trnsiCode = '';
            if (jobValues.customHousCode !== '') {
                cusCode = jobValues.customHousCode;
            } else {
                cusCode = '-1'
            }
            if (jobValues.mode_A_L_S === '') {
                trnsiCode = '-1'
            } else {
                trnsiCode = jobValues.mode_A_L_S;
            }
            let details = {
                cusHouseCode: cusCode, customHouseLocation: '-1'
                , flag: '2', transitTypeId: trnsiCode
            }
            JobServices.getCustomHouseCodeBasedOnTransitType(details).then(res => {
                setCustomHouseDetails(res.data)
            })
        }
    }
    const JobBranchHandleClose = () => {
        setJobBranchOpen(false);
    }
    const JobBranchHandleOpen = () => {
        setBranchDetails([])
        setJobBranchOpen(true)
        setJobDialogValues({ ...jobDialogValues, branch: jobValues.branch })
        var brnchname = '';
        if (jobValues.branch === '') {
            brnchname = '-1';
        } else {
            brnchname = jobValues.branch;
        }
        let details = { regionalName: brnchname }
        JobServices.getRegionalName(details).then(res => {
            setBranchDetails(res.data)
        })
    }
    const JobFrwdrHandleClose = () => {
        setJobFrwdrOpen(false);
        setJobDialogValues({ ...jobDialogValues, forwdr: '' })
    }
    const JobFrwdrHandleOpen = () => {
        setForwdrDetails([])
        setJobFrwdrOpen(true)
        var frwdrName = ''
        if (jobValues.forwarder === '') {
            frwdrName = '-1'
        } else {
            frwdrName = jobValues.forwarder
        }
        let searchDetails = {
            freightFwdName: frwdrName
        }
        ImportQuerService.getForwarderName(searchDetails).then(res => {
            setForwdrDetails(res.data)
        })
    }

    const JobIecHandleClose = () => {
        setJobIecOpen(false);
        setJobDialogValues({ ...jobDialogValues, importer_name: '', importer_code: '' })
    }
    const JobIecHandleOpen = () => {
        setJobDialogValues({ ...jobDialogValues, importer_name: '', importer_code: jobValues.iec_search })
        setJobImporterDetails([])
        setJobIecOpen(true)
        var iec_code, iec_name = '';
        if (jobValues.iec_search === '') {
            iec_code = '-1'
        } else {
            iec_code = jobValues.iec_search
        } if (jobValues.name === '') {
            iec_name = '-1'
        } else {
            iec_name = jobValues.name
        }
        let details = { importer_iec_no: iec_code, importer_name: iec_name, flag: '2' }
        ImportQuerService.getImporter(details).then(res => {
            setJobImporterDetails(res.data)
        })
    }

    const JobBrancSrHandleClose = () => {
        setJobBrncSrOpen(false);
        setJobDialogValues({ ...jobDialogValues, importer_name: '', importer_code: '' })
    }
    const JobBrancSrHandleOpen = () => {
        setBranchSrDetails([])
        setJobBrncSrOpen(true)
        setJobDialogValues({ ...jobDialogValues, branch_sr_no: jobValues.branch_sr_no })
        var importer_iec_no, branch_sl_no = '';
        if (jobValues.branch_sr_no === '') {
            branch_sl_no = '-1'
        } else {
            branch_sl_no = jobValues.branch_sr_no
        }
        if (jobValues.iec_search === '') {
            importer_iec_no = '-1'
        } else {
            importer_iec_no = jobValues.iec_search
        }
        let details = { importer_iec_no: importer_iec_no, importer_name: '-1', branch_sl_no: branch_sl_no }
        JobServices.getImporterBranch(details).then(res => {
            setBranchSrDetails(res.data)
        })
    }
    const JobAdCodeHandleClose = () => {
        setJobAdCodeOpen(false);
    }
    const JobAdCodeHandleOpen = () => {
        setAdcodeDetailsDetails([])
        setJobAdCodeOpen(true)
        setJobDialogValues({ ...jobDialogValues, ad_code: jobValues.ad_code })
        var importer_iec_no, ad_code = '';
        if (jobValues.ad_code === '' || !jobValues.ad_code) {
            ad_code = '-1';
        } else {
            ad_code = jobValues.ad_code;
        } if (jobValues.iec_search === '' || !jobValues.iec_search) {
            importer_iec_no = '-1'
        } else {
            importer_iec_no = jobValues.iec_search
        }
        let details = { importer_iec_no: importer_iec_no, ad_code: ad_code }
        JobServices.getAdCode(details).then(res => {
            setAdcodeDetailsDetails(res.data)
        })
    }
    const JobCountryOriginHandleClose = () => {
        setJobCountryOriginOpen(false);
        // document.getElementById('jonCntryOrgin').focus();
        setJobDialogValues({ ...jobDialogValues, f_countryOriginCode: '', f_countryOrginName: '' })
    }
    const JobCountryOriginHandleOpen = () => {
        setJobCountryOrigineDtails([]);
        setJobCountryOriginOpen(true)
        setJobDialogValues({ ...jobDialogValues, f_countryOriginCode: jobValues.countryOrigin })
        var countryIdString = '';
        if (jobValues.countryOrigin === '') {
            countryIdString = '-1';
        } else {
            countryIdString = jobValues.countryOrigin;
        }
        let details = { countryIdString: countryIdString, countryName: '-1', flag: '2' }
        JobServices.getCountryName(details).then(res => {
            setJobCountryOrigineDtails(res.data)
        })
    }
    const JobCountryCMHandleClose = () => {
        setJobCountryCmOpen(false);
        setJobDialogValues({ ...jobDialogValues, f_countryOfCmCode: '', f_countryOfCm: '' })
    }
    const JobCountryCMHandleOpen = () => {
        setJobCountryOfCmDtails([])
        setJobCountryCmOpen(true)
        setJobDialogValues({ ...jobDialogValues, f_countryOfCmCode: jobValues.countrt_of_cm })
        var countryIdString = '';
        if (jobValues.countrt_of_cm === '') {
            countryIdString = '-1';
        } else {
            countryIdString = jobValues.countrt_of_cm;
        }
        let details = { countryIdString: countryIdString, countryName: '-1', flag: '2' }
        JobServices.getCountryName(details).then(res => {
            setJobCountryOfCmDtails(res.data)

        })
    }
    const JobPortOfLoadinHandleClose = () => {
        setJobPortOfLoadingOpen(false);
        setJobDialogValues({ ...jobDialogValues, f_port_ofName: '', f_port_Code: '' })
    }
    const JobPortOfLoadinHandleOpen = () => {
        setJobCountryOfCmDtails([])

        if (jobValues.mode_A_L_S === '') {
            setMessage('Kindly enter the transit type')
            setSeverity('warning');
            setOpenSnack(true)
        } else {
            if (jobValues.countryOrigin === '') {
                setMessage('Kindly select the country of origin')
                setSeverity('warning');
                setOpenSnack(true)
            } else {
                if (jobValues.countrt_of_cm === '') {
                    setMessage('Kindly select the country of Cm')
                    setSeverity('warning');
                    setOpenSnack(true)
                } else {
                    setJobPortOfLoadingOpen(true)
                    setJobDialogValues({ ...jobDialogValues, f_port_Code: jobValues.port_of_loding })
                    var portCode, portName = '';
                    if (jobValues.port_of_loding === '') {
                        portCode = '-1';
                    } else {
                        portCode = jobValues.port_of_loding;
                    }
                    if (jobValues.port_of_lodingName === '') {
                        portName = '-1';
                    } else {
                        portName = jobValues.port_of_lodingName;
                    }
                    let Details = {
                        customPointCode: portCode, customPointName: portName, flag: '2'
                        , transitTypeId: jobValues.mode_A_L_S, countryId: jobValues.countryOrigin, countryCode: jobValues.countrt_of_cm
                    }
                    JobServices.getPortLocationBasedCountryTransitType(Details).then(res => {
                        setJobCountryOfCmDtails(res.data)
                    })
                }
            }
        }
    }
    const JobCertificateClose = () => {
        setJobCertificateOpen(false)
    }
    const JobBondClose = () => {
        setAdcodeDetailsDetails([]);
        setJobBondOpen(false); document.getElementById('Classgpn').focus();
        bondReset();
    }
    const JobBondPortClose = () => {
        setJobBondPortOpen(false)
        setJobDialogValues({ ...jobDialogValues, bond_portName: '', find_bond_port: '' })
    }
    const DialogeJobBondPortOpenHandle = () => {
        setJobBondPortOpen(true)
        setJobDialogValues({ ...jobDialogValues, find_bond_port: jobDialogValues.bond_port })
        var cusnam, cusCode = '';
        if (jobDialogValues.bond_portName === '') {
            cusnam = '-1'
        }
        else {
            cusnam = jobDialogValues.bond_portName;
        }
        if (jobDialogValues.bond_port === '') {
            cusCode = '-1'
        } else {
            cusCode = jobDialogValues.bond_port;
        }
        let details = {
            cusHouseCode: cusCode, customHouseLocation: cusnam
            , flag: '2'
        }
        JobServices.getCustomHouseCode(details).then(res => {
            setCustomHouseDetails(res.data)
        })
    }
    const JobContainerClose = () => {
        setJobContainerOpen(false);
        containerReset();
    }
    const JobTypeHWXClose = () => {
        setJobTypeHWXOpen(false);
    }
    const JobTypeHWX_custSiteId_Close = () => {
        setJobTypeHWXCUSIDOpen(false);
        setJobDialogValues({ ...jobDialogValues, findtypeH_w_xCustSiteId: '', typeH_w_xCustSiteName: '' })
    }

    const JobTypeHWX_custSiteId_Open = () => {
        setCustomHouseDetails([])
        setJobTypeHWXCUSIDOpen(true);
        setJobDialogValues({ ...jobDialogValues, findtypeH_w_xCustSiteId: jobDialogValues.typeH_w_xCustSiteId, typeH_w_xCustSiteName: '' })
        var customHouseLocation, cusHouseCode = ''
        if (jobDialogValues.typeH_w_xCustSiteName !== '') { customHouseLocation = jobDialogValues.typeH_w_xCustSiteName; }
        else { customHouseLocation = "-1"; }
        if (jobDialogValues.typeH_w_xCustSiteId === '' || !jobDialogValues.typeH_w_xCustSiteId) { cusHouseCode = '-1' }
        else { cusHouseCode = jobDialogValues.typeH_w_xCustSiteId; }
        let details = { customHouseLocation: customHouseLocation, cusHouseCode: cusHouseCode, flag: '2' }
        JobServices.getCustomHouseCode(details).then(res => { setCustomHouseDetails(res.data) })
    }
    const JobTypeHWX_pkgCode_Close = () => {
        setJobTypeHWXpkgcodeOpen(false);
        setJobDialogValues({ ...jobDialogValues, typeH_w_xPkgName: '', findtypeH_w_xPkgCode: '' })
    }
    const JobTypeHWX_pkgCode_Open = () => {
        setJobTypeHWXpkgcodeOpen(true);
        setCustomHouseDetails([])
        setJobDialogValues({ ...jobDialogValues, findtypeH_w_xPkgCode: jobDialogValues.typeH_w_xPkgCode, typeH_w_xPkgName: '' })
        var unitCode = '';
        if (jobDialogValues.typeH_w_xPkgCode === '' || !jobDialogValues.typeH_w_xPkgCode) { unitCode = '-1'; }
        else { unitCode = jobDialogValues.typeH_w_xPkgCode; }
        let details = { unitName: '-1', unitCode: unitCode, flag: '2' }
        JobServices.getUOM(details).then(res => { setCustomHouseDetails(res.data) })
    }

    const JobTypeHWX_UnitCode_Close = () => {
        setJobTypeHWXUnitCodeOpen(false)
        setJobDialogValues({ ...jobDialogValues, typeH_w_xUnitName: '', findtypeH_w_xUnitCode: '' })
    }
    const JobTypeHWX_UnitCode_Open = () => {
        setJobTypeHWXUnitCodeOpen(true);
        setJobDialogValues({ ...jobDialogValues, findtypeH_w_xUnitCode: jobDialogValues.typeH_w_xUnitCode })
        setCustomHouseDetails([])
        var unitCode = '';
        if (jobDialogValues.typeH_w_xUnitCode === '' || !jobDialogValues.typeH_w_xUnitCode) { unitCode = '-1'; }
        else { unitCode = jobDialogValues.typeH_w_xUnitCode; }
        let details = { unitName: '-1', unitCode: unitCode, flag: '2' }
        JobServices.getUOM(details).then(res => { setCustomHouseDetails(res.data); })
    }

    const JobHssClose = () => {
        jobHssRefresh();
        setJobHSSOpen(false)
    }
    const JobHssDialogeOpen = () => {
        jobHssRefresh();
        setjobHssDetails([]);
        if (jobValues.job_no === '') {
            setMessage('Select Job.No From Job Table');
            setSeverity('warning');
            setOpenSnack(true)
        } else {
            setJobHSSOpen(true);
            JobServices.getHSSDetails(jobValues.job_no).then(res => {
                setjobHssDetails(res.data);
            })

        }
    }

    const JobHss_iecClose = () => {
        setJobHSS_IecOpen(false); setJobImporterDetails([]);
        setJobDialogValues({ ...jobDialogValues, findhss_iecCode: '', hss_iecName: '' })
    }
    const JobHss_iec_Open = () => {
        setJobHSS_IecOpen(true); setJobImporterDetails([]);
        setJobDialogValues({ ...jobDialogValues, findhss_iecCode: jobDialogValues.hss_iecCode })
        var iec_code, iec_name = '';
        if (jobDialogValues.hss_iecCode === '') {
            iec_code = '-1'
        } else {
            iec_code = jobDialogValues.hss_iecCode
        } if (jobDialogValues.hss_iecName === '') {
            iec_name = '-1'
        } else {
            iec_name = jobDialogValues.hss_iecName
        }
        let details = { importer_iec_no: iec_code, importer_name: iec_name, flag: '2' }
        ImportQuerService.getImporter(details).then(res => {
            setJobImporterDetails(res.data)
        })
    }
    const JobHss_brncSrClose = () => {
        setJobHSS_BrncSrOpen(false);
        setJobDialogValues({ ...jobDialogValues, hss_brncSrName: '', findhss_brnchSrNo: '' })
    }
    const JobHssbrncSrOpen = () => {
        setJobHSS_BrncSrOpen(true); setBranchSrDetails([]);
        setJobDialogValues({ ...jobDialogValues, findhss_brnchSrNo: jobDialogValues.hss_brnchSrNo })
        var importer_iec_no, branch_sl_no = '';
        if (jobDialogValues.hss_brnchSrNo === '' || !jobDialogValues.hss_brnchSrNo) { branch_sl_no = '-1' }
        else { branch_sl_no = jobDialogValues.hss_brnchSrNo }
        if (jobDialogValues.hss_iecCode === '' || !jobDialogValues.hss_iecCode) { importer_iec_no = '-1' }
        else { importer_iec_no = jobDialogValues.hss_iecCode; }
        let details = { importer_iec_no: importer_iec_no, importer_name: '-1', branch_sl_no: branch_sl_no }
        JobServices.getImporterBranch(details).then(res => { setBranchSrDetails(res.data); })
    }

    const JobSec_48Closehandle = () => {
        setjobSecDetails([])
        jobSec48Refresh('S48')
        setJobSec_48Open(false)
    }
    const JobSec_48_Openhandle = () => {
        setjobSecDetails([]);
        setJobDialogValues({ ...jobDialogValues, sec_PermissionCode: 'S48', sec_PermissionDesc: '' })
        setJobSec_48Open(true);
        JobServices.getPermission(jobValues.job_no, 'S48').then(res => {
            setjobSecDetails(res.data);
        })
    }

    const Job1stCheackClosehandle = () => {
        setjobSecDetails([]);
        setJobDialogValues({ ...jobDialogValues, sec_PermissionDesc: '' })
        setJob1stCheackOpen(false);
    }
    const Job1stCheackOpenhandle = () => {
        setjobSecDetails([]);
        setJobDialogValues({ ...jobDialogValues, sec_PermissionCode: 'FCK', sec_PermissionDesc: '' })
        setJob1stCheackOpen(true);
        JobServices.getPermission(jobValues.job_no, 'FCK').then(res => {
            setjobSecDetails(res.data);
        })
    }

    const JobCommercialtxClosehandle = () => {
        setJobComrcilTaxOpen(false)
    }
    const JobCommercialtxOpenHandle = () => {
        setjobCmrcialDetails([]);
        setJobComrcilTaxOpen(true);
        JobServices.getGstinType().then(res => {
            setjobGstinDrp(res.data);
        })
        JobServices.getCommercialTax(jobValues.job_no).then(res => {
            setjobCmrcialDetails(res.data);
        })
        let details = { importer_iec_no: jobValues.iec_search, deliveryStateName: jobValues.branch_sr_no }
        JobServices.getCTXTypeAssign(details).then(res => {
            const data = res.data;
            const result = data.map((CmTx) => CmTx);
            setJobDialogValues({
                ...jobDialogValues, comrcial_ctx_regNo: result[0].customPointCode
                , comrcial_CtxCode: result[0].statementCode, comrcial_StateCode: result[0].deliveryStateName
            });
        })

    }

    const JobUnitCodeClosehandle = () => {
        setJobUnitCodeOpen(false);
        setJobDialogValues({ ...jobDialogValues, findtypeH_w_xUnitCode: '', typeH_w_xUnitName: '' });
    }
    const JobUnitCode_Openhandle = () => {
        setJobUnitCodeOpen(true);
        setJobDialogValues({ ...jobDialogValues, findtypeH_w_xUnitCode: jobValues.unit });
        var unitCode = '';
        if (jobValues.unit === '') {
            unitCode = '-1'
        } else {
            unitCode = jobValues.unit;
        }
        let details = { unitCode: unitCode, unitName: '-1', flag: 2 }
        JobServices.getUOM(details).then(res => {
            setCustomHouseDetails(res.data);
        })
    }

    const JobEditIgmUnitCode = (cus) => {
        JobUnitCodeClosehandle();
        setJobValues({ ...jobValues, unit: cus.unitCode });
    }

    const JobPkgCodeClosehandle = () => {
        setJobPkgCodeOpen(false);
        setJobDialogValues({ ...jobDialogValues, findtypeH_w_xUnitCode: '', typeH_w_xUnitName: '' });
    }
    const JobPkgCode_Openhandle = () => {
        setJobPkgCodeOpen(true);
        setJobDialogValues({ ...jobDialogValues, findtypeH_w_xUnitCode: jobValues.pkg_code });
        var unitCode = '';
        if (jobValues.pkg_code === '') {
            unitCode = '-1'
        }
        else {
            unitCode = jobValues.pkg_code;
        }
        let details = { unitCode: unitCode, unitName: '-1', flag: 2 }
        JobServices.getUOM(details).then(res => {
            setCustomHouseDetails(res.data);
        })
    }

    const JobEditIgmPkgCode = (cus) => {
        setJobValues({ ...jobValues, pkg_code: cus.unitCode });
        JobPkgCodeClosehandle();
    }

    const JobRepPortClosehandle = () => {
        setJobDialogValues({ ...jobDialogValues, f_report_code: '', f_report_name: '' });
        setJobRepPortOpen(false);
    }
    const JobRepPort_Openhandle = () => {
        if (jobValues.mode_A_L_S === '') {
            setMessage('Please Enter the Transite Type')
            setSeverity('warning');
            setOpenSnack(true);
        } else {
            setJobRepPortOpen(true);
            setJobDialogValues({ ...jobDialogValues, f_report_code: jobValues.repPortCode });
            var customHouseLocation, cusHouseCode = '';
            if (jobValues.repPortCode !== '') {
                customHouseLocation = "-1";
                cusHouseCode = jobValues.repPortCode;
            }
            else if (jobValues.repPortName !== '') {
                customHouseLocation = jobValues.repPortName;
                cusHouseCode = "-1";
            }
            else {
                customHouseLocation = "-1";
                cusHouseCode = "-1";
            }
            let details = {
                customHouseLocation: customHouseLocation, cusHouseCode: cusHouseCode,
                flag: 2, transitTypeId: jobValues.mode_A_L_S
            }
            JobServices.getCustomHouseCodeBasedOnTransitType(details).then(res => {
                setCustomHouseDetails(res.data);
            })
        }
    }
    const JobBOEupdationClosehandle = () => {
        setOpenJobBOEupdation(false);
    }
    const JobBOEupdationOpenhandle = () => {
        setOpenJobBOEupdation(true);
        let details = { consignmentId: jobValues.job_no }
        JobServices.getBeDetails(details).then(res => {
            const data = res.data;
            const bedetails = data.map((beDetail) => beDetail);
            setJobValues({
                ...jobValues, be_no: bedetails[0].beNo, be_date: bedetails[0].beDate,
                be_response: bedetails[0].beResponse, be_reason: bedetails[0].beReason
            })
        })
        JobServices.getBeResponse().then(res => {
            setBeUpdationRespncDD(res.data)
        })
    }
    const jobPrintCloshHandle = () => {
        setOpenJobPrint(false);
    }
    const jobPrintOpenHandle = () => {
        setOpenJobPrint(true);
    }

    //--------------------------------onClick-Dialog-BoxTable---------------------------------------------------------------

    const jobeditTransitType = (trns) => {
        setJobModelOpen(false);
        setJobValues({ ...jobValues, mode_A_L_S: trns.transitTypeCode, model_A_L_S_Name: trns.transitTypeName })
        setJobDialogValues({ ...jobDialogValues, transit_code: trns.transitTypeCode })
        if (trns.transitTypeCode === 'A' || trns.transitTypeCode === 'a') {
            setJobIgmtrnsitChnghide(false);
            setJobGateWayhide(true);
            setJobRepPorthide(true)
        } else if (trns.transitTypeCode === 'S' || trns.transitTypeCode === 's' || trns.transitTypeCode === 'L' || trns.transitTypeCode === 'l') {
            setJobIgmtrnsitChnghide(true);
            setJobGateWayhide(false);
            setJobRepPorthide(false);
        }
    }

    const JobEditCusHouscode = (cus) => {
        setJobChsOpen(false)
        setJobValues({ ...jobValues, chs_name: cus.customHouseLocation, customHousCode: cus.customHouseCode })
        setJobDialogValues({ ...jobDialogValues, cusHousCode: cus.customHouseCode })
    }
    const JobEditwareCusHouscode = (cus) => {
        setJobTypeHWXCUSIDOpen(false)
        setJobDialogValues({ ...jobDialogValues, typeH_w_xCustSiteId: cus.customHouseCode })
    }
    const JobEditwarePkgCode = (cus) => {
        setJobTypeHWXpkgcodeOpen(false)
        setJobDialogValues({ ...jobDialogValues, typeH_w_xPkgCode: cus.unitCode })
    }
    const JobEditwareUnitCode = (cus) => {
        setJobTypeHWXUnitCodeOpen(false)
        setJobDialogValues({ ...jobDialogValues, typeH_w_xUnitCode: cus.unitCode })
    }

    const JobEditBranchName = (brncdta) => {
        setJobBranchOpen(false)
        setJobValues({ ...jobValues, branch: brncdta.regionalName })
        setJobDialogValues({ ...jobDialogValues, branch: brncdta.regionalName })
    }
    const JobEditFrwdr = (frwd) => {
        setJobFrwdrOpen(false)
        setJobValues({ ...jobValues, forwarder: frwd.freightFwdName })
        setJobDialogValues({ ...jobDialogValues, forwdr: frwd.freightFwdName })
    }
    const jobEditImporter = (impdtails) => {
        setJobIecOpen(false)
        setJobValues({
            ...jobValues, iec_search: impdtails.importer_iec_no,
            name: impdtails.importer_name
        })
        setJobDialogValues({ ...jobDialogValues, importer_code: impdtails.importer_iec_no })
    }
    const jobEditBrncSl = (brncsr) => {
        setJobBrncSrOpen(false)
        setJobValues({
            ...jobValues, branch_sr_no: brncsr.branch_sl_no,
            address_1: brncsr.importerAddress,
            addresh_2: brncsr.importerAddress1,
            state: brncsr.importerState,
            city: brncsr.importer_city,
            pincode: brncsr.pincode
        })
        setJobDialogValues({ ...jobDialogValues, branch_sr_no: brncsr.branch_sl_no })
    }
    const jobEditAdCode = (brncsr) => {
        setJobAdCodeOpen(false)
        setJobValues({ ...jobValues, ad_code: brncsr.ad_code })
        setJobDialogValues({ ...jobDialogValues, ad_code: brncsr.ad_code })
        document.getElementById('ad_code').focus();
    }
    const JobEditCntryOrign = (cntrorgn) => {
        setJobCountryOriginOpen(false)
        setJobValues({ ...jobValues, countryOrigin: cntrorgn.countryIdString, countryOriginName: cntrorgn.countryName });
        setJobDialogValues({ ...jobDialogValues, f_countryOriginCode: cntrorgn.countryIdString });
        document.getElementById('jonCntryOrgin').focus();
    }
    const JobEditCntryOfCm = (cntrorgn) => {
        setJobCountryCmOpen(false)
        setJobValues({ ...jobValues, countrt_of_cm: cntrorgn.countryIdString, countrt_of_cmName: cntrorgn.countryName });
        setJobDialogValues({ ...jobDialogValues, f_countryOfCmCode: cntrorgn.countryIdString });
        document.getElementById('jonCntryOrgin').focus();
    }
    const JobEditCntryOfPort = (cntrorgn) => {
        setJobPortOfLoadingOpen(false)
        setJobValues({ ...jobValues, port_of_loding: cntrorgn.customPointCode, port_of_lodingName: cntrorgn.customPointName });
        setJobDialogValues({ ...jobDialogValues, f_port_Code: cntrorgn.customPointCode });
        document.getElementById('jonCntryOrgin').focus();
    }
    const jobEditCertificate = (crtficate) => {
        setJobDialogValues({
            ...jobDialogValues, certificate_No: crtficate.certificateNo, certificateId: crtficate.certificateId
            , certificate_Type: crtficate.certificateTypeDesc, certificate_Date: crtficate.certificateDate
        })
        if (crtficate.certificateId !== 0) {
            setJobDialoSavDisa(true);
            setJobDialogUpdtDisa(false)
            setJobDialogDltDisa(false)
        }
    }
    const jobbondPortCusDetails = (brncsr) => {
        setJobDialogValues({ ...jobDialogValues, bond_port: brncsr.customHouseCode })
        setJobBondPortOpen(false)
    }
    const jobEditBondDetails = (brncsr) => {
        setJobDialogValues({
            ...jobDialogValues, bond_port: brncsr.destinationId, bondNo: brncsr.bondNo, old_bondNo: brncsr.bondNo
            , bond_code: brncsr.bondCodeDesc, bond_amount: brncsr.bondAmount, bg_debited: brncsr.bgDebit
            , bg_rate: brncsr.bgRate, bg_ammount: brncsr.bgAmount
        })
        setBondSaveDisab(true)
        setBondUpdtDisab(false);
        setBondDltDisab(false)
    }
    const jobEditContainer = (brncsr) => {
        setJobDialogValues({
            ...jobDialogValues, container_no: brncsr.containorNo, container_size: brncsr.containorSize, container_igm_no: brncsr.igmId
            , l_f_c: brncsr.lcl_fcl, seal_no: brncsr.sealNo, truck_no: brncsr.truck_no, containerId: brncsr.containerId
        })
        setJobContainerSveDsab(true)
        setJobContainerUpdtDsab(false);
        setJobContainerDltDsab(false)
    }

    const EditHssImport = (Hss) => {
        setJobHSS_IecOpen(false);
        setJobDialogValues({ ...jobDialogValues, hss_iecCode: Hss.importer_iec_no, hss_name: Hss.importer_name })
    }
    const jobEditHss_BrncSl = (brncsr) => {
        setJobHSS_BrncSrOpen(false);
        setJobDialogValues({
            ...jobDialogValues, hss_brnchSrNo: brncsr.branch_sl_no, hss_address1: brncsr.importerAddress
            , hss_address2: brncsr.importerAddress1, hss_city: brncsr.importer_city, hss_state: brncsr.importerState, hss_pincode: brncsr.pincode
        })
    }

    const JobEditHssDetail = (hss) => {
        setJobDialogValues({
            ...jobDialogValues, hss_iecCode: hss.iecCodeHss, hss_name: hss.importer_name, hss_brnchSrNo: hss.branch_sl_no
            , hss_address1: hss.importerAddress, hss_oldiecCode: hss.iecCodeHss, hss_address2: hss.importerAddress1, hss_city: hss.importer_city
            , hss_pincode: hss.pincode, hss_precedingLevel: hss.precedingLevel, hss_state: hss.importerState
        })
        setJobHssSaveDsab(true);
        setJobHssUpdateDsab(false);
        setJobHssDeleteDsab(false);

        setJobHssSve(false);
        setJobHssUpd(false);
        setJobHssDlt(false);
    }

    const JobEditSec48Detail = (hss) => {
        setJobSec_48SaveDsab(true);
        setJobSec_48Updatedsab(false);
        setJobSec_48DeleteDsab(false);

        setJobSec_48Sve(false);
        setJobSec_48Upd(false);
        setJobSec_48Dlt(false);
        setJobDialogValues({
            ...jobDialogValues, sec_PermissionId: hss.permissionId, sec_PermissionCode: 'S48'
            , sec_PermissionDesc: hss.permissionReq
        })
    }

    const JobEdit1stCheckDetail = (hss) => {
        setJobSec_48SaveDsab(true);
        setJobSec_48Updatedsab(false);
        setJobSec_48DeleteDsab(false);

        setJobSec_48Sve(false);
        setJobSec_48Upd(false);
        setJobSec_48Dlt(false);

        setJobDialogValues({
            ...jobDialogValues, sec_PermissionId: hss.permissionId, sec_PermissionCode: 'FCK'
            , sec_PermissionDesc: hss.permissionReq
        })
    }

    const JobEditCmrcialTxDetail = (cmt) => {
        setJobComTxSaveDsab(true);
        setJobComTxUpdateDsab(false);
        setJobComTxDeleteDsab(false);
        setJobComTxSve(false);
        setJobComTxUpd(false);
        setJobComTxDlt(false);
        setJobDialogValues({
            ...jobDialogValues, comrcial_StateCode: cmt.taxStateCode, comrcial_CtxCode: cmt.gstinTypeCode
            , comrcial_ctx_regNo: cmt.gstinNo, comrcial_txId: cmt.commercialTaxId
        })
    }

    const JobEditReport = (cus) => {
        setJobRepPortOpen(false);
        setJobDialogValues({ ...jobDialogValues, f_report_code: cus.customHouseCode });
        setJobValues({ ...jobValues, repPortCode: cus.customHouseCode, repPortName: cus.customHouseLocation });
    }

    //--------------------------------onClick---------------------------------------------------------------------

    //SaveCertificate
    const SaveCertificate = () => {
        setJobDialoSavDisa(true)
        setJobDialogSave(true)
        if (!jobDialogValues.certificate_No) {
            setMessage('Certificate.No is required');
            setSeverity('error')
            setOpenSnack(true)
            setJobDialoSavDisa(false)
            setJobDialogSave(false)
            // jobDialogeReset();
        } else if (!jobDialogValues.certificate_Type) {
            setMessage('Certificate Type is required');
            setSeverity('error')
            setOpenSnack(true)
            setJobDialoSavDisa(false)
            setJobDialogSave(false)
            // jobDialogeReset();
        }
        else if (!jobDialogValues.certificate_Date) {
            setMessage('Certificate date is required');
            setSeverity('error')
            setOpenSnack(true)
            setJobDialoSavDisa(false)
            setJobDialogSave(false)
            // jobDialogeReset();
        } else {
            let details = {
                consignmentId: jobValues.job_no, certificateNo: jobDialogValues.certificate_No,
                certificateDate: jobDialogValues.certificate_Date, certificateType: jobDialogValues.certificate_Type
            }
            JobServices.insertCertificateDetails(details).then(res => {
                const message = res.data.message;
                jobDialogeReset();
                if (message.toString() === "Insert Success") {
                    setMessage('Certificate Insert Success');
                    setSeverity('success');
                    setOpenSnack(true);
                } else if (message.toString() === "") { setMessage('Certificate Insert Failed'); setSeverity('error'); setOpenSnack(true); }
                else {
                    setMessage(message);
                    setSeverity('error');
                    setOpenSnack(true);
                }
                let details = { consignmentId: jobValues.job_no }
                JobServices.getCertificateDetails(details).then(res => {
                    setAdcodeDetailsDetails(res.data)
                    setJobDialoSavDisa(false)
                    setJobDialogSave(false)
                })

            })
        }
    }

    //UpdateCertificate
    const UpdateCertificate = () => {
        setJobDialogUpdate(true)
        setJobDialogUpdtDisa(true)
        setJobDialogDltDisa(true)
        if (jobDialogValues.certificateId === 0) {
            setMessage('Certificate is InValide');
            setSeverity('error')
            setOpenSnack(true)
            setJobDialogUpdtDisa(false)
            setJobDialogUpdate(false)
            // jobDialogeReset();
        } else {
            if (!jobDialogValues.certificate_No) {
                setMessage('Certificate.No is required');
                setSeverity('error')
                setOpenSnack(true)
                setJobDialogUpdtDisa(false)
                setJobDialogUpdate(false)
                // jobDialogeReset();
            } else if (!jobDialogValues.certificate_Type) {
                setMessage('Certificate Type is required');
                setSeverity('error')
                setOpenSnack(true)
                setJobDialogUpdtDisa(false)
                setJobDialogUpdate(false)
                // jobDialogeReset();
            }
            else if (!jobDialogValues.certificate_Date) {
                setMessage('Certificate Date is required');
                setSeverity('error')
                setOpenSnack(true)
                setJobDialogUpdtDisa(false)
                setJobDialogUpdate(false)
                // jobDialogeReset();
            } else {
                let details = {
                    certificateId: jobDialogValues.certificateId, consignmentId: jobValues.job_no, certificateNo: jobDialogValues.certificate_No,
                    certificateDate: jobDialogValues.certificate_Date, certificateType: jobDialogValues.certificate_Type
                }
                JobServices.updateCertificateDetails(details).then(res => {
                    const message = res.data.message;
                    if (message.toString() === "SUCCESS") {
                        setMessage('Certificate Update Success');
                        setSeverity('success');
                        setOpenSnack(true);
                        jobDialogeReset();
                    }
                    else {
                        setMessage(message);
                        setSeverity('error');
                        setOpenSnack(true);
                        jobDialogeReset();
                    }
                    let details = { consignmentId: jobValues.job_no }
                    JobServices.getCertificateDetails(details).then(res => {
                        setAdcodeDetailsDetails(res.data)
                        setJobDialoSavDisa(false);
                        setJobDialogUpdate(false);
                        setJobDialogUpdtDisa(true);
                        setJobDialogDltDisa(true);
                        setJobDialogSave(false);
                    })

                })
            }
        }
    }
    //DeleteCertificate
    const DeleteCertificate = () => {
        setJobDialogDeletea(true)
        setJobDialogDltDisa(true)
        setJobDialogUpdtDisa(true)
        if (jobDialogValues.certificateId === 0) {
            setMessage('Certificate is InValide');
            setSeverity('error')
            setOpenSnack(true)
            setJobDialogDltDisa(true)
            setJobDialogDeletea(false)
            setJobDialoSavDisa(false);
            jobDialogeReset();
        } else {

            JobServices.deleteCertificateDetails(jobValues.job_no, jobDialogValues.certificateId).then(res => {
                const message = res.data.message;
                if (message.toString() === "SUCCESS") {
                    setMessage('Certificate Delete Success');
                    setSeverity('success');
                    setOpenSnack(true);
                    jobDialogeReset();
                }
                else {
                    setMessage(message);
                    setSeverity('error');
                    setOpenSnack(true);
                    jobDialogeReset();
                }
                let details = { consignmentId: jobValues.job_no }
                JobServices.getCertificateDetails(details).then(res => {
                    setAdcodeDetailsDetails(res.data)
                    setJobDialoSavDisa(false);
                    setJobDialogUpdate(false);
                    setJobDialogUpdtDisa(true);
                    setJobDialogDltDisa(true);
                    setJobDialogDeletea(false)
                    setJobDialogSave(false);
                })

            }).catch(error => {
                setJobDialoSavDisa(false);
                setJobDialogUpdate(false);
                setJobDialogUpdtDisa(true);
                setJobDialogDltDisa(true);
                setJobDialogDeletea(false)
                setJobDialogSave(false);
            })

        }
    }

    const certificateReset = () => {
        jobDialogeReset();
        setJobDialogUpdtDisa(true)
        setJobDialogDltDisa(true)
        setJobDialogSave(false)
        setJobDialoSavDisa(false)
    }
    //-----------JobDialogeBondDetailSave   
    const JobDialogeBondDetailSave = () => {
        setJobBondSave(true)
        setBondSaveDisab(true)
        if (jobValues.job_no === '') {
            setMessage('Job.No is Empty');
            setSeverity('error');
            setOpenSnack(true)
            setJobBondSave(false)
            setBondSaveDisab(false)
        } else {
            if (jobDialogValues.bondNo === '') {
                setMessage('Bond.No is Missing');
                setSeverity('error');
                setOpenSnack(true)
                setJobBondSave(false)
                setBondSaveDisab(false)
            } else if (jobDialogValues.bond_code === '') {
                setMessage('Please Select Bond Code');
                setSeverity('error');
                setOpenSnack(true);
                setJobBondSave(false)
                setBondSaveDisab(false)
            } else if (jobDialogValues.bond_port === '') {
                setMessage('Bond Port code is Missing');
                setSeverity('error');
                setOpenSnack(true);
                setJobBondSave(false)
                setBondSaveDisab(false)
            } else {
                var bondAmount, bgDebited, bgRate, bgAmount = ''
                if (jobDialogValues.bond_amount === '') {
                    bondAmount = '0.00';
                } else {
                    bondAmount = jobDialogValues.bond_amount;
                }
                if (jobDialogValues.bg_debited === '') {
                    bgDebited = '0.00';
                } else {
                    bgDebited = jobDialogValues.bg_debited;
                }
                if (jobDialogValues.bg_rate === '') {
                    bgRate = '0.00';
                } else {
                    bgRate = jobDialogValues.bg_rate;
                } if (jobDialogValues.bg_ammount === '') {
                    bgAmount = '0.00';
                } else {
                    bgAmount = jobDialogValues.bg_ammount;
                }
                let details = {
                    consignmentId: jobValues.job_no, bondNo: jobDialogValues.bondNo, bondAmount: bondAmount
                    , bondCode: jobDialogValues.bond_code, destinationId: jobDialogValues.bond_port,
                    bgRate: bgRate, bgAmount: bgAmount, bgDebit: bgDebited
                }
                JobServices.insertBondDetails(details).then(res => {
                    bondReset();
                    const message = res.data.message;
                    if (message.toString() === 'SUCCESS') {
                        setMessage("BOND INSERT " + message.toString())
                        setSeverity('success')
                        setOpenSnack(true)

                    } else {
                        setMessage(message.toString())
                        setSeverity('error')
                        setOpenSnack(true)

                    }
                    let details = { consignmentId: jobValues.job_no }
                    JobServices.getBondDetails(details).then(res => {
                        setAdcodeDetailsDetails(res.data)
                    })
                }).catch(error => {
                    bondReset();
                    setMessage(error.message);
                    setSeverity('error');
                    setOpenSnack(true)
                })
            }
        }
    }
    const JobDialogeBondDetailUpdate = () => {
        setBondSaveDisab(true)
        setBondUpdtDisab(true);
        setBondDltDisab(true)
        setJobBondSave(false)
        setJobBondUpdt(true);
        setJobBondDlt(false)
        if (jobValues.job_no === '') {
            setMessage('Job.No is Empty');
            setSeverity('error');
            setOpenSnack(true)
            setBondSaveDisab(true)
            setBondUpdtDisab(false);
            setBondDltDisab(false)
            setJobBondSave(false)
            setJobBondUpdt(false);
            setJobBondDlt(false)
        } else {
            if (jobDialogValues.bondNo === '') {
                setMessage('Bond.No is Missing');
                setSeverity('error');
                setOpenSnack(true)
                setBondSaveDisab(true)
                setBondUpdtDisab(false);
                setBondDltDisab(false)
                setJobBondSave(false)
                setJobBondUpdt(false);
                setJobBondDlt(false)
            } else if (jobDialogValues.old_bondNo === '') {
                setMessage('Please Select Bond Details In Table');
                setSeverity('error');
                setOpenSnack(true)
                setBondSaveDisab(true)
                setBondUpdtDisab(false);
                setBondDltDisab(false)
                setJobBondSave(false)
                setJobBondUpdt(false);
                setJobBondDlt(false)
            } else if (jobDialogValues.bond_code === '') {
                setMessage('Please Select Bond Code');
                setSeverity('error');
                setOpenSnack(true);
                setBondSaveDisab(true)
                setBondUpdtDisab(false);
                setBondDltDisab(false)
                setJobBondSave(false)
                setJobBondUpdt(false);
                setJobBondDlt(false)
            } else if (jobDialogValues.bond_port === '') {
                setMessage('Bond Port code is Missing');
                setSeverity('error');
                setOpenSnack(true);
                setBondSaveDisab(true)
                setBondUpdtDisab(false);
                setBondDltDisab(false)
                setJobBondSave(false)
                setJobBondUpdt(false);
                setJobBondDlt(false)
            } else {
                var bondAmount, bgDebited, bgRate, bgAmount = ''
                if (jobDialogValues.bond_amount === '') {
                    bondAmount = '0.00';
                } else {
                    bondAmount = jobDialogValues.bond_amount;
                }
                if (jobDialogValues.bg_debited === '') {
                    bgDebited = '0.00';
                } else {
                    bgDebited = jobDialogValues.bg_debited;
                }
                if (jobDialogValues.bg_rate === '') {
                    bgRate = '0.00';
                } else {
                    bgRate = jobDialogValues.bg_rate;
                } if (jobDialogValues.bg_ammount === '') {
                    bgAmount = '0.00';
                } else {
                    bgAmount = jobDialogValues.bg_ammount;
                }
                let details = {
                    consignmentId: jobValues.job_no, bondNo: jobDialogValues.bondNo, oldBondNo: jobDialogValues.old_bondNo,
                    bondAmount: bondAmount, bondCode: jobDialogValues.bond_code, destinationId: jobDialogValues.bond_port,
                    bgRate: bgRate, bgAmount: bgAmount, bgDebit: bgDebited
                }
                JobServices.updateBondDetails(details).then(res => {
                    bondReset();
                    const message = res.data.message;
                    if (message.toString() === 'SUCCESS') {
                        setMessage("BOND UPDATE " + message.toString())
                        setSeverity('success')
                        setOpenSnack(true)

                    } else {
                        setMessage(message.toString())
                        setSeverity('error')
                        setOpenSnack(true)

                    }
                    let details = { consignmentId: jobValues.job_no }
                    JobServices.getBondDetails(details).then(res => {
                        setAdcodeDetailsDetails(res.data)
                    })
                }).catch(error => {
                    bondReset();
                    setMessage(error.message);
                    setSeverity('error');
                    setOpenSnack(true)
                })
            }
        }
    }
    const JobDialogeBondDetailDelete = () => {
        setBondSaveDisab(true)
        setBondUpdtDisab(true);
        setBondDltDisab(true)

        setJobBondSave(false)
        setJobBondUpdt(false);
        setJobBondDlt(true)
        if (jobValues.job_no === '') {
            setMessage('Job.No is Empty');
            setSeverity('error');
            setOpenSnack(true)
            setBondSaveDisab(true)
            setBondUpdtDisab(false);
            setBondDltDisab(false)
            setJobBondSave(false)
            setJobBondUpdt(false);
            setJobBondDlt(false)
        } else {
            if (jobDialogValues.bondNo === '') {
                setMessage('Bond.No is Missing');
                setSeverity('error');
                setOpenSnack(true)
                setBondSaveDisab(true)
                setBondUpdtDisab(false);
                setBondDltDisab(false)
                setJobBondSave(false)
                setJobBondUpdt(false);
                setJobBondDlt(false)
            } else if (jobDialogValues.old_bondNo === '') {
                setMessage('Please Select Bond Details In Table');
                setSeverity('error');
                setOpenSnack(true)
                setBondSaveDisab(true)
                setBondUpdtDisab(false);
                setBondDltDisab(false)
                setJobBondSave(false)
                setJobBondUpdt(false);
                setJobBondDlt(false)
            } else {
                JobServices.deleteBondDetails(jobValues.job_no, jobDialogValues.bondNo).then(res => {
                    bondReset();
                    const message = res.data.message;
                    if (message.toString() === 'SUCCESS') {
                        setMessage("BOND DELETE " + message.toString())
                        setSeverity('success')
                        setOpenSnack(true)

                    } else {
                        setMessage(message.toString())
                        setSeverity('error')
                        setOpenSnack(true)

                    }
                    let details = { consignmentId: jobValues.job_no }
                    JobServices.getBondDetails(details).then(res => {
                        setAdcodeDetailsDetails(res.data)
                    })
                }).catch(error => {
                    bondReset();
                    setMessage(error.message);
                    setSeverity('error');
                    setOpenSnack(true)
                })
            }
        }
    }
    const bondReset = () => {
        setJobDialogValues({
            ...jobDialogValues, bond_port: '', bondNo: '', old_bondNo: ''
            , bond_code: '', bond_amount: '', bg_debited: ''
            , bg_rate: '', bg_ammount: ''
        });
        document.getElementById('bondNo').focus();
        setBondSaveDisab(false);
        setBondUpdtDisab(true);
        setBondDltDisab(true);

        setJobBondSave(false);
        setJobBondUpdt(false);
        setJobBondDlt(false);
    }

    const jobContainerSave = () => {
        setJobContainerSveDsab(true);
        setJobContainerSve(true);
        if (jobValues.job_no === '') {
            setMessage('Please Select Job No From Job Table');
            setSeverity('warning');
            setOpenSnack(true);
            setJobContainerSveDsab(false);
            setJobContainerSve(false);
        } else {
            if (jobDialogValues.container_no === '') {
                setMessage('Please Enter Container No');
                setSeverity('warning');
                setOpenSnack(true);
                setJobContainerSveDsab(false);
                setJobContainerSve(false);
            } else {
                let details = {
                    igmId: jobDialogValues.container_igm_no,
                    consignmentId: jobValues.job_no, lcl_fcl: jobDialogValues.l_f_c, containorNo: jobDialogValues.container_no
                    , containorSize: jobDialogValues.container_size, sealNo: jobDialogValues.seal_no, truck_no: jobDialogValues.truck_no
                }
                JobServices.insertContainer(details).then(res => {
                    const message = res.data.message;
                    if (message.toString() === 'SUCCESS') {
                        setMessage('Container Insert Success');
                        setSeverity('success');
                        setOpenSnack(true)
                        containerReset();
                    } else {
                        setMessage(message.toString());
                        setSeverity('error');
                        setOpenSnack(true)
                        containerReset();
                    }
                    let details = { consignmentId: jobValues.job_no }
                    JobServices.getContainer(details).then(res => {
                        setAdcodeDetailsDetails(res.data)
                    })
                }).catch(error => {
                    setMessage(error.message);
                    setSeverity('error');
                    setOpenSnack(true);
                    containerReset();
                })
            }
        }
    }
    const jobContainerUpdate = () => {
        setJobContainerUpdtDsab(true);
        setJobContainerDltDsab(true);

        setJobContainerUpdt(true);
        setJobContainerDlt(false);
        if (jobValues.job_no === '') {
            setMessage('Please Select Job No From Job Table');
            setSeverity('warning');
            setOpenSnack(true);
            setJobContainerSveDsab(false);
            setJobContainerSve(false);
        } else {
            if (jobDialogValues.containerId === 0) {
                setMessage('Invalid Container');
                setSeverity('warning');
                setOpenSnack(true);
                setJobContainerUpdtDsab(false);
                setJobContainerDltDsab(false);

                setJobContainerUpdt(false);
                setJobContainerDlt(false);
            }
            else if (jobDialogValues.container_no === '') {
                setMessage('Please Enter Container No');
                setSeverity('warning');
                setOpenSnack(true);
                setJobContainerUpdtDsab(false);
                setJobContainerDltDsab(false);

                setJobContainerUpdt(false);
                setJobContainerDlt(false);
            } else {
                let details = {
                    igmId: jobDialogValues.container_igm_no,
                    containerId: jobDialogValues.containerId, consignmentId: jobValues.job_no, lcl_fcl: jobDialogValues.l_f_c, containorNo: jobDialogValues.container_no
                    , containorSize: jobDialogValues.container_size, sealNo: jobDialogValues.seal_no, truck_no: jobDialogValues.truck_no
                }
                JobServices.updateContainer(details).then(res => {
                    const message = res.data.message;
                    if (message.toString() === 'SUCCESS') {
                        setMessage('Container Update Success');
                        setSeverity('success');
                        setOpenSnack(true)
                        containerReset();
                    } else {
                        setMessage(message.toString());
                        setSeverity('error');
                        setOpenSnack(true)
                        containerReset();
                    }
                    let details = { consignmentId: jobValues.job_no }
                    JobServices.getContainer(details).then(res => {
                        setAdcodeDetailsDetails(res.data)
                    })
                }).catch(error => {
                    setMessage(error.message);
                    setSeverity('error');
                    setOpenSnack(true);
                    containerReset();
                })
            }
        }

    }
    const jobContainerDelete = () => {
        setJobContainerUpdtDsab(true);
        setJobContainerDltDsab(true);

        setJobContainerUpdt(false);
        setJobContainerDlt(true);
        if (jobValues.job_no === '') {
            setMessage('Please Select Job No From Job Table');
            setSeverity('warning');
            setOpenSnack(true);
            setJobContainerSveDsab(false);
            setJobContainerSve(false);
        } else {
            if (jobDialogValues.containerId === 0) {
                setMessage('Invalid Container');
                setSeverity('warning');
                setOpenSnack(true);
                setJobContainerUpdtDsab(false);
                setJobContainerDltDsab(false);

                setJobContainerUpdt(false);
                setJobContainerDlt(false);
            }
            else if (jobDialogValues.container_no === '') {
                setMessage('Please Enter Container No');
                setSeverity('warning');
                setOpenSnack(true);
                setJobContainerUpdtDsab(false);
                setJobContainerDltDsab(false);

                setJobContainerUpdt(false);
                setJobContainerDlt(false);
            } else {

                JobServices.deleteContainer(jobDialogValues.containerId).then(res => {
                    const message = res.data.message;
                    if (message.toString() === 'SUCCESS') {
                        setMessage('Container Delete Success');
                        setSeverity('success');
                        setOpenSnack(true)
                        containerReset();
                    } else {
                        setMessage(message.toString());
                        setSeverity('error');
                        setOpenSnack(true)
                        containerReset();
                    }
                    let details = { consignmentId: jobValues.job_no }
                    JobServices.getContainer(details).then(res => {
                        setAdcodeDetailsDetails(res.data)
                    })
                }).catch(error => {
                    setMessage(error.message);
                    setSeverity('error');
                    setOpenSnack(true);
                    containerReset();
                })
            }
        }

    }

    const containerReset = () => {
        setJobDialogValues({
            ...jobDialogValues, container_no: '', container_size: '', l_f_c: ''
            , seal_no: '', truck_no: '', containerId: 0
        })
        setJobContainerSveDsab(false);
        setJobContainerUpdtDsab(true);
        setJobContainerDltDsab(true);

        setJobContainerSve(false);
        setJobContainerUpdt(false);
        setJobContainerDlt(false);
    }

    const jobupdateWarehouse = () => {

        if (!jobValues.job_no) {
            setMessage('Select Job.No Form Job Table');
            setSeverity('warning');
            setOpenSnack(true);
        } else {
            if (!jobDialogValues.typeH_w_xCode) {
                setMessage('Code is missing or Empty');
                setSeverity('warning');
                setOpenSnack(true);
            } else {
                var lef_a, lef_r, mlr_a, mlr_r, le_status, mlr_status = '';
                var custsitid, beno, beDate, no_of_pkgs, pkgCode, gross_wt, finalWarehousingDate, uomCode, annexureNo, annexureDate, exbondDesc = '';
                if (JobTypeHWX_LE_Radio === 'a') {
                    lef_a = jobDialogValues.typeH_w_xLFE;
                    lef_r = 0;
                    le_status = "1";
                }
                else if (JobTypeHWX_LE_Radio === 'b') {
                    lef_a = 0;
                    lef_r = jobDialogValues.typeH_w_xLFE;
                    le_status = "2";
                }
                else {
                    lef_a = 0;
                    lef_r = 0;
                    le_status = "0";
                }
                if (JobTypeHWX_MLR_Radio === 'a') {
                    mlr_a = jobDialogValues.typeH_w_xMLR;
                    mlr_r = 0;
                    mlr_status = "1";
                }
                else if (JobTypeHWX_MLR_Radio === 'b') {
                    mlr_a = 0;
                    mlr_r = jobDialogValues.typeH_w_xMLR;
                    mlr_status = "2";
                }
                else {
                    mlr_a = 0;
                    mlr_r = 0;
                    mlr_status = "0";
                }
                // ---
                if (jobDialogValues.typeH_w_xCustSiteId === '') {
                    custsitid = null
                } else {
                    custsitid = jobDialogValues.typeH_w_xCustSiteId
                }
                if (jobDialogValues.typeH_w_xBeNo === '') {
                    beno = null
                } else {
                    beno = jobDialogValues.typeH_w_xBeNo
                }
                if (jobDialogValues.typeH_w_xBeDate === '') {
                    beDate = null
                } else {
                    beDate = jobDialogValues.typeH_w_xBeDate
                }
                if (jobDialogValues.typeH_w_xNoOfPkg === '') {
                    no_of_pkgs = null
                } else {
                    no_of_pkgs = jobDialogValues.typeH_w_xNoOfPkg
                }
                if (jobDialogValues.typeH_w_xPkgCode === '') {
                    pkgCode = null
                } else {
                    pkgCode = jobDialogValues.typeH_w_xPkgCode
                }
                if (jobDialogValues.typeH_w_xGroos === '') {
                    gross_wt = null
                } else {
                    gross_wt = jobDialogValues.typeH_w_xGroos
                }
                if (jobDialogValues.typeH_w_xUnitCode === '') {
                    uomCode = null
                } else {
                    uomCode = jobDialogValues.typeH_w_xUnitCode
                }
                if (jobDialogValues.typeH_w_xAnnexureNo === '') {
                    annexureNo = null
                } else {
                    annexureNo = jobDialogValues.typeH_w_xAnnexureNo
                }
                if (jobDialogValues.typeH_w_xAnnexureDate === '') {
                    annexureDate = null
                } else {
                    annexureDate = jobDialogValues.typeH_w_xAnnexureDate
                }
                if (jobDialogValues.typeH_w_xDFW === '') {
                    finalWarehousingDate = null
                } else {
                    finalWarehousingDate = jobDialogValues.typeH_w_xDFW
                }
                if (jobDialogValues.typeH_w_xECD === '') {
                    exbondDesc = null
                } else {
                    exbondDesc = jobDialogValues.typeH_w_xECD
                }
                let details = {
                    consignmentId: jobValues.job_no, warehouseCode: jobDialogValues.typeH_w_xCode, warehouseCustomeSite: custsitid
                    , warehouseBeNo: beno, warehouseBeDate: beDate, noofPkg: no_of_pkgs, pkgCode: pkgCode, gross_wt: gross_wt, uomCode: uomCode,
                    annexureNo: annexureNo, annexureDate: annexureDate, finalWarehousingDate: finalWarehousingDate, exbondStatus: le_status, exbondAmt: lef_a, exbondRate: lef_r,
                    mis_status: mlr_status, mis_amount: mlr_a, mis_rate: mlr_r, exbondDesc: exbondDesc
                }
                JobServices.updateWarehouseDetails(details).then(res => {
                    const message = res.data.message;
                    if (message.toString() === 'SUCCESS') {
                        setMessage('WareHouse Update Success');
                        setSeverity('success');
                        setOpenSnack(true)
                    } else {
                        setMessage(message.toString());
                        setSeverity('error');
                        setOpenSnack(true)
                    }
                }).catch(error => {
                    setMessage(error.message);
                    setSeverity('error');
                    setOpenSnack(true)
                })
            }
        }

    }
    const jobWarehouseClear = () => {
        setJobDialogValues({
            ...jobDialogValues, typeH_w_xCode: '', typeH_w_xCustSiteId: '', typeH_w_xBeNo: '', typeH_w_xBeDate: ''
            , typeH_w_xNoOfPkg: 0, typeH_w_xPkgCode: '', typeH_w_xGroos: 0, typeH_w_xUnitCode: '', typeH_w_xAnnexureNo: '', typeH_w_xAnnexureDate: ''
            , typeH_w_xDFW: '', typeH_w_xLFE: '', typeH_w_xMLR: '', typeH_w_xECD: ''
        })
    }
    const jobHss_Save = () => {
        setJobHssSaveDsab(true);
        setJobHssSve(true)
        if (jobDialogValues.hss_iecCode === '') {
            setMessage('Please Enter the IEC Code');
            setSeverity('warning');
            setOpenSnack(true);
            setJobHssSaveDsab(false);
            setJobHssSve(false);
        } else {
            if (jobDialogValues.hss_brnchSrNo === '') {
                setMessage('Please Enter the Branch Sr.No');
                setSeverity('warning');
                setOpenSnack(true);
                setJobHssSaveDsab(false);
                setJobHssSve(false);
            } else {
                if (jobDialogValues.hss_precedingLevel === '') {
                    setMessage('Please Enter the PrecedingLevel');
                    setSeverity('warning');
                    setOpenSnack(true);
                    setJobHssSaveDsab(false);
                    setJobHssSve(false);
                } else {
                    let details = {
                        consignmentId: jobValues.job_no, iecCodeHss: jobDialogValues.hss_iecCode, precedingLevel: jobDialogValues.hss_precedingLevel
                        , branch_sl_no: jobDialogValues.hss_brnchSrNo, importer_name: jobDialogValues.hss_name, importerAddress: jobDialogValues.hss_address1
                        , importerAddress1: jobDialogValues.hss_address2, importer_city: jobDialogValues.hss_city, pincode: jobDialogValues.hss_pincode,
                        importerState: jobDialogValues.hss_state
                    }
                    JobServices.insertHSSDetails(details).then(res => {
                        const message = res.data.message;
                        if (message.toString() === 'SUCCESS') {
                            setMessage('Hss Insert Successfully')
                            setSeverity('success');
                            setOpenSnack(true);
                            JobServices.getHSSDetails(jobValues.job_no).then(res => {
                                setjobHssDetails(res.data);
                            })
                            jobHssRefresh();
                        } else {
                            setMessage(message.toString())
                            setSeverity('error');
                            setOpenSnack(true);
                            setJobHssSaveDsab(false);
                            setJobHssSve(false);
                        }
                    }).catch(error => {
                        setMessage(error.message)
                        setSeverity('error');
                        setOpenSnack(true);
                        jobHssRefresh();
                    })
                }
            }
        }
    }
    const jobHssUpdate = () => {
        setJobHssUpdateDsab(true);
        setJobHssUpd(true);
        if (jobDialogValues.hss_oldiecCode !== '') {
            if (jobDialogValues.hss_iecCode === '') {
                setMessage('Please Enter the IEC Code');
                setSeverity('warning');
                setOpenSnack(true);
                setJobHssUpdateDsab(false);
                setJobHssUpd(false);
            } else {
                if (jobDialogValues.hss_brnchSrNo === '') {
                    setMessage('Please Enter the Branch Sr.No');
                    setSeverity('warning');
                    setOpenSnack(true);
                    setJobHssUpdateDsab(false);
                    setJobHssUpd(false);
                } else {
                    if (jobDialogValues.hss_precedingLevel === '') {
                        setMessage('Please Enter the PrecedingLevel');
                        setSeverity('warning');
                        setOpenSnack(true);
                        setJobHssUpdateDsab(false);
                        setJobHssUpd(false);
                    } else {
                        let details = {
                            consignmentId: jobValues.job_no, oldIecCodeHss: jobDialogValues.hss_oldiecCode, iecCodeHss: jobDialogValues.hss_iecCode, precedingLevel: jobDialogValues.hss_precedingLevel
                            , branch_sl_no: jobDialogValues.hss_brnchSrNo, importer_name: jobDialogValues.hss_name, importerAddress: jobDialogValues.hss_address1
                            , importerAddress1: jobDialogValues.hss_address2, importer_city: jobDialogValues.hss_city, pincode: jobDialogValues.hss_pincode,
                            importerState: jobDialogValues.hss_state
                        }
                        JobServices.updateHSSDetails(details).then(res => {
                            const message = res.data.message;
                            if (message.toString() === 'SUCCESS') {
                                setMessage('Hss Update Successfully')
                                setSeverity('success');
                                setOpenSnack(true);
                                JobServices.getHSSDetails(jobValues.job_no).then(res => {
                                    setjobHssDetails(res.data);
                                })
                                jobHssRefresh();
                            } else {
                                setMessage(message.toString())
                                setSeverity('error');
                                setOpenSnack(true);
                                setJobHssUpdateDsab(false);
                                setJobHssUpd(false);
                            }
                        }).catch(error => {
                            setMessage(error.message)
                            setSeverity('error');
                            setOpenSnack(true);
                            jobHssRefresh();
                        })
                    }
                }
            }
        } else {
            setMessage('Please Slecte Hss Details from Hss Table');
            setSeverity('warning');
            setOpenSnack(true);
        }
    }
    const jobHssDelete = () => {
        setJobHssDeleteDsab(true);
        setJobHssDlt(true);
        JobServices.deleteHSSDetails(jobValues.job_no, jobDialogValues.hss_oldiecCode).then(res => {
            const message = res.data.message;
            if (message.toString() === 'SUCCESS') {
                setMessage('Hss Deleted Successfully')
                setSeverity('success');
                setOpenSnack(true);
                JobServices.getHSSDetails(jobValues.job_no).then(res => {
                    setjobHssDetails(res.data);
                })
                jobHssRefresh();
            } else {
                setMessage(message.toString())
                setSeverity('error');
                setOpenSnack(true);
                setJobHssDeleteDsab(false);
                setJobHssDlt(false);
            }
        }).catch(error => {
            setMessage(error.message)
            setSeverity('error');
            setOpenSnack(true);
            jobHssRefresh();
        })
    }
    const jobHssRefresh = () => {
        setJobHssSaveDsab(false);
        setJobHssSve(false);
        setJobHssUpdateDsab(true);
        setJobHssUpd(false);
        setJobHssDeleteDsab(true);
        setJobHssDlt(false);
        setJobDialogValues({
            ...jobDialogValues, hss_iecCode: '', hss_iecName: '', hss_brnchSrNo: '', hss_brncSrName: ''
            , hss_name: '', hss_address1: '', hss_address2: '', hss_city: '', hss_precedingLevel: '', hss_state: '', hss_pincode: ''
        })
    }

    const jobSec48Save = (num) => {
        setJobSec_48SaveDsab(true);
        setJobSec_48Sve(true);
        if (jobDialogValues.sec_PermissionDesc === '') {
            setMessage('Please Enter Permission Description');
            setSeverity('warning');
            setOpenSnack(true);
            setJobSec_48SaveDsab(false);
            setJobSec_48Sve(false);
        } else {
            let details = {
                consignmentId: jobValues.job_no, permissionCode: jobDialogValues.sec_PermissionCode,
                permissionReq: jobDialogValues.sec_PermissionDesc
            }
            JobServices.insertPermission(details).then(res => {
                const message = res.data.message;
                if (message.toString() === 'SUCCESS') {
                    setMessage('Insert Successfull');
                    setSeverity('success');
                    setOpenSnack(true);
                    JobServices.getPermission(jobValues.job_no, jobDialogValues.sec_PermissionCode).then(res => {
                        setjobSecDetails(res.data);
                    })
                    jobSec48Refresh(num);
                } else {
                    setMessage(message.toString());
                    setSeverity('error');
                    setOpenSnack(true);
                    setJobSec_48SaveDsab(false);
                    setJobSec_48Sve(false);
                }
            }).catch(error => {
                setMessage(error.message);
                setSeverity('error');
                setOpenSnack(true);
                jobSec48Refresh(num);
            })
        }
    }
    const jobSec48Update = (num) => {
        setJobSec_48Updatedsab(true);
        setJobSec_48Upd(true);
        if (jobDialogValues.sec_PermissionId === '') {
            setMessage('Please Select Permission details from Permission Table');
            setSeverity('warning');
            setOpenSnack(true);
            setJobSec_48Updatedsab(false);
            setJobSec_48Upd(false);
        }
        else {
            setJobSec_48Upd(true);
            if (jobDialogValues.sec_PermissionDesc === '') {
                setMessage('Please Enter Permission Description');
                setSeverity('warning');
                setOpenSnack(true);
                setJobSec_48Updatedsab(false);
                setJobSec_48Upd(false);
            } else {
                let details = {
                    permissionId: jobDialogValues.sec_PermissionId, permissionCode: jobDialogValues.sec_PermissionCode,
                    permissionReq: jobDialogValues.sec_PermissionDesc
                }
                JobServices.updatePermission(details).then(res => {
                    const message = res.data.message;
                    if (message.toString() === 'SUCCESS') {
                        setMessage('Update Successfull');
                        setSeverity('success');
                        setOpenSnack(true);
                        JobServices.getPermission(jobValues.job_no, jobDialogValues.sec_PermissionCode).then(res => {
                            setjobSecDetails(res.data);
                        })
                        jobSec48Refresh(num);
                    } else {
                        setMessage(message.toString());
                        setSeverity('error');
                        setOpenSnack(true);
                        setJobSec_48Updatedsab(false);
                        setJobSec_48Upd(false);
                    }
                }).catch(error => {
                    setMessage(error.message);
                    setSeverity('error');
                    setOpenSnack(true);
                    jobSec48Refresh(num);
                })
            }
        }
    }
    const jobSec48Delete = (num) => {
        setJobSec_48DeleteDsab(true);
        setJobSec_48Dlt(true);
        if (jobDialogValues.sec_PermissionId === '') {
            setMessage('Please Select Permission details from Permission Table');
            setSeverity('warning');
            setOpenSnack(true);
            setJobSec_48DeleteDsab(false);
            setJobSec_48Dlt(false);
        } else {
            JobServices.deletePermission(jobDialogValues.sec_PermissionId).then(res => {
                const message = res.data.message;
                if (message.toString() === 'SUCCESS') {
                    setMessage('Delete Successfully');
                    setSeverity('success');
                    setOpenSnack(true);
                    JobServices.getPermission(jobValues.job_no, jobDialogValues.sec_PermissionCode).then(res => {
                        setjobSecDetails(res.data);
                    })
                    jobSec48Refresh(num);
                } else {
                    setMessage(message.toString());
                    setSeverity('error');
                    setOpenSnack(true);
                    setJobSec_48DeleteDsab(false);
                    setJobSec_48Dlt(false);
                }
            }).catch(error => {
                setMessage(error.message);
                setSeverity('error');
                setOpenSnack(true);
                jobSec48Refresh(num);
            })
        }
    }

    const jobSec48Refresh = (code) => {
        setJobSec_48SaveDsab(false);
        setJobSec_48Updatedsab(true);
        setJobSec_48DeleteDsab(true);

        setJobSec_48Sve(false);
        setJobSec_48Upd(false);
        setJobSec_48Dlt(false);
        setJobDialogValues({
            ...jobDialogValues, sec_PermissionId: '', sec_PermissionCode: code
            , sec_PermissionDesc: ''
        })


    }

    const commercialTaxSave = () => {
        setJobComTxSaveDsab(true);
        setJobComTxSve(true);
        if (jobValues.job_no !== '') {
            let details = {
                consignmentId: jobValues.job_no, taxStateCode: jobDialogValues.comrcial_StateCode,
                gstinType: jobDialogValues.comrcial_CtxCode, gstinNo: jobDialogValues.comrcial_ctx_regNo
            }
            JobServices.insertCommercialTax(details).then(res => {
                const message = res.data.message;
                if (message.toString() === 'SUCCESS') {
                    setMessage('Inserted Successfull');
                    setSeverity('success');
                    setOpenSnack(true);
                    ComrcialRefresh();
                } else {
                    setMessage(message.toString());
                    setSeverity('error');
                    setOpenSnack(true);
                    ComrcialRefresh();
                }
                JobServices.getCommercialTax(jobValues.job_no).then(res => {
                    setjobCmrcialDetails(res.data);
                })
            }).catch(error => {
                setMessage(error.message);
                setSeverity('error');
                setOpenSnack(true);
                ComrcialRefresh();
            })
        } else {
            setMessage('Please Enter A Job.No');
            setSeverity('error');
            setOpenSnack(true);
            setJobComTxSaveDsab(false);
            setJobComTxSve(false);
        }
    }

    const commercialTaxUpdate = () => {
        setJobComTxUpdateDsab(true);
        setJobComTxUpd(true);
        if (jobDialogValues.comrcial_txId !== 0) {
            let details = {
                consignmentId: jobValues.job_no, taxStateCode: jobDialogValues.comrcial_StateCode,
                gstinType: jobDialogValues.comrcial_CtxCode, gstinNo: jobDialogValues.comrcial_ctx_regNo
                , commercialTaxId: jobDialogValues.comrcial_txId
            }
            JobServices.updateCommercialTax(details).then(res => {
                const message = res.data.message;
                if (message.toString() === 'SUCCESS') {
                    setMessage('Updated Successfull');
                    setSeverity('success');
                    setOpenSnack(true);
                    ComrcialRefresh();
                } else {
                    setMessage(message.toString());
                    setSeverity('error');
                    setOpenSnack(true);
                    ComrcialRefresh();
                }
                JobServices.getCommercialTax(jobValues.job_no).then(res => {
                    setjobCmrcialDetails(res.data);
                })
            }).catch(error => {
                setMessage(error.message);
                setSeverity('error');
                setOpenSnack(true);
                ComrcialRefresh();
            })
        } else {
            setMessage('Commercial details is undifines Please Slecte Commercial Below Table');
            setSeverity('warning');
            setOpenSnack(true);
            ComrcialRefresh();
        }
    }
    const commercialTaxDelete = () => {
        setJobComTxDeleteDsab(true);
        setJobComTxDlt(true);
        if (jobDialogValues.comrcial_txId !== 0) {
            JobServices.deleteCommercialTax(jobValues.job_no, jobDialogValues.comrcial_txId).then(res => {
                const message = res.data.message;
                if (message.toString() === 'SUCCESS') {
                    setMessage('Deleted Successfull');
                    setSeverity('success');
                    setOpenSnack(true);
                    ComrcialRefresh();
                } else {
                    setMessage(message.toString());
                    setSeverity('error');
                    setOpenSnack(true);
                    ComrcialRefresh();
                }
                JobServices.getCommercialTax(jobValues.job_no).then(res => {
                    setjobCmrcialDetails(res.data);
                })
            }).catch(error => {
                setMessage(error.message);
                setSeverity('error');
                setOpenSnack(true);
                ComrcialRefresh();
            })
        } else {
            setMessage('Commercial details is undifines Please Slecte Commercial Below Table');
            setSeverity('warning');
            setOpenSnack(true);
            ComrcialRefresh();
        }
    }

    const ComrcialRefresh = () => {
        setJobComTxSaveDsab(false);
        setJobComTxUpdateDsab(true);
        setJobComTxDeleteDsab(true);
        setJobComTxSve(false);
        setJobComTxUpd(false);
        setJobComTxDlt(false);

        let details = { importer_iec_no: jobValues.iec_search, deliveryStateName: jobValues.branch_sr_no }
        JobServices.getCTXTypeAssign(details).then(res => {
            const data = res.data;
            const result = data.map((CmTx) => CmTx);
            setJobDialogValues({
                ...jobDialogValues, comrcial_ctx_regNo: result[0].customPointCode, comrcial_txId: 0
                , comrcial_CtxCode: result[0].statementCode, comrcial_StateCode: result[0].deliveryStateName
            });
        })
    }

    //--------------------------------DIALOG on Change------------------------------------------------------------
    const JobDialogTransitChangeHandel = (e) => {
        setTransitDetails([]); setJobDialogValues({ ...jobDialogValues, transit_name: e.target.value }); setTransitDetails([])

        var transitCode, transitName = '';
        if (e.target.value === '') {
            transitName = '-1'
        } else {
            transitName = e.target.value;
        }
        if (jobDialogValues.transit_code === '') {
            transitCode = '-1'
        } else {
            transitCode = jobDialogValues.transit_code;
        }
        let details = {
            transitTypeCode: transitCode,
            transitTypeName: transitName, flag: '2'
        }
        JobServices.getTransitType(details).then(res => {
            setTransitDetails(res.data);
        })
    }
    const JobDialogTransitCodeChangeHandel = (e) => {
        setTransitDetails([]); setJobDialogValues({ ...jobDialogValues, transit_code: e.target.value }); setTransitDetails([]);
        var transitCode, transitName = '';
        if (e.target.value === '') {
            transitCode = '-1'
        } else {
            transitCode = e.target.value;
        }
        if (jobDialogValues.transit_name === '') {
            transitName = '-1'
        } else {
            transitName = jobDialogValues.transit_name;
        }
        let details = {
            transitTypeCode: transitCode,
            transitTypeName: transitName, flag: '2'
        }
        JobServices.getTransitType(details).then(res => {
            setTransitDetails(res.data);
        })
    }
    const JobDialogCHSChangeHandel = (e) => {
        setCustomHouseDetails([]); setJobDialogValues({ ...jobDialogValues, cusHousName: e.target.value }); setCustomHouseDetails([]);
        if (jobValues.mode_A_L_S === '') {

        } else {
            setJobChsOpen(true)
            var cusnam, cusCode, trnsiCode = '';
            if (e.target.value === '') {
                cusnam = '-1'
            }
            else {
                cusnam = e.target.value;
            } if (jobDialogValues.cusHousCode === '') {
                cusCode = '-1'
            } else {
                cusCode = jobDialogValues.cusHousCode;
            }
            if (jobValues.mode_A_L_S === '') {
                trnsiCode = '-1'
            } else {
                trnsiCode = jobValues.mode_A_L_S;
            }
            let details = {
                cusHouseCode: cusCode, customHouseLocation: cusnam
                , flag: '2', transitTypeId: trnsiCode
            }
            JobServices.getCustomHouseCodeBasedOnTransitType(details).then(res => {
                setCustomHouseDetails(res.data)
            })
        }
    }
    const JobDialogChsCodeChangeHandel = (e) => {
        setCustomHouseDetails([]); setJobDialogValues({ ...jobDialogValues, cusHousCode: e.target.value }); setCustomHouseDetails([]);
        if (jobValues.mode_A_L_S === '') {

        } else {
            setJobChsOpen(true)
            var cusnam, cusCode, trnsiCode = '';
            if (e.target.value === '') {
                cusCode = '-1'
            }
            else {
                cusCode = e.target.value;
            } if (jobDialogValues.cusHousName === '') {
                cusnam = '-1'
            } else {
                cusnam = jobDialogValues.cusHousName;
            }
            if (jobValues.mode_A_L_S === '') {
                trnsiCode = '-1'
            } else {
                trnsiCode = jobValues.mode_A_L_S;
            }
            let details = {
                cusHouseCode: cusCode, customHouseLocation: cusnam
                , flag: '2', transitTypeId: trnsiCode
            }
            JobServices.getCustomHouseCodeBasedOnTransitType(details).then(res => {
                setCustomHouseDetails(res.data)
            })
        }
    }

    const JobDialogBranchChangeHandel = (e) => {
        setBranchDetails([]); setJobDialogValues({ ...jobDialogValues, branch: e.target.value }); setBranchDetails([]);
        var brnchname = '';
        if (e.target.value === '') {
            brnchname = '-1';
        } else {
            brnchname = e.target.value;
        }
        let details = { regionalName: brnchname }
        JobServices.getRegionalName(details).then(res => {
            setBranchDetails(res.data)
        })
    }

    const JobDialogForwdrChangeHandel = (e) => {
        setForwdrDetails([]); setJobDialogValues({ ...jobDialogValues, forwdr: e.target.value }); setForwdrDetails([]);
        var frwdrName = ''
        if (e.target.value === '') {
            frwdrName = '-1'
        } else {
            frwdrName = e.target.value
        }
        let searchDetails = {
            freightFwdName: frwdrName
        }
        ImportQuerService.getForwarderName(searchDetails).then(res => {
            setForwdrDetails(res.data)
        })
    }

    const JobDialogImpNameChangeHandel = (e) => {
        setJobImporterDetails([]); setJobDialogValues({ ...jobDialogValues, importer_name: e.target.value }); setJobImporterDetails([])
        var iec_code, iec_name = '';
        if (jobDialogValues.importer_code === '') {
            iec_code = '-1'
        } else {
            iec_code = jobDialogValues.importer_code
        } if (e.target.value === '') {
            iec_name = '-1'
        } else {
            iec_name = e.target.value
        }
        let details = { importer_iec_no: iec_code, importer_name: iec_name, flag: '2' }
        ImportQuerService.getImporter(details).then(res => {
            setJobImporterDetails(res.data)
        })
    }
    const JobDialogImpCodeChangeHandel = (e) => {
        setJobImporterDetails([]); setJobDialogValues({ ...jobDialogValues, importer_code: e.target.value }); setJobImporterDetails([])
        var iec_code, iec_name = '';
        if (jobDialogValues.importer_name === '') {
            iec_name = '-1'
        } else {
            iec_name = jobDialogValues.importer_name
        }
        if (e.target.value === '') {
            iec_code = '-1'
        } else {
            iec_code = e.target.value
        }
        let details = { importer_iec_no: iec_code, importer_name: iec_name, flag: '2' }
        ImportQuerService.getImporter(details).then(res => {
            setJobImporterDetails(res.data)
        })
    }
    const JobDialogImpStateChangeHandel = (e) => {
        setBranchSrDetails([]); setJobDialogValues({ ...jobDialogValues, importer_state: e.target.value }); setBranchSrDetails([]);
        var importer_iec_no, importer_state, branch_sl_no = '';
        if (jobValues.branch_sr_no === '') {
            branch_sl_no = '-1'
        } else {
            branch_sl_no = jobValues.branch_sr_no
        }
        if (e.target.value === '') {
            importer_state = '-1'
        } else {
            importer_state = e.target.value
        }
        if (jobValues.iec_search === '') {
            importer_iec_no = '-1'
        } else {
            importer_iec_no = jobValues.iec_search
        }
        let details = { importer_iec_no: importer_iec_no, importer_name: importer_state, branch_sl_no: branch_sl_no }
        JobServices.getImporterBranch(details).then(res => {
            setBranchSrDetails(res.data)
        })
    }
    const JobDialogAdCodeChangeHandel = (e) => {
        setAdcodeDetailsDetails([]); setJobDialogValues({ ...jobDialogValues, ad_code: e.target.value })
        setAdcodeDetailsDetails([]);
        var importer_iec_no, ad_code = '';
        if (e.target.value === '') {
            ad_code = '-1'
        } else {
            ad_code = e.target.value
        } if (jobValues.iec_search === '') {
            importer_iec_no = '-1'
        } else {
            importer_iec_no = jobValues.iec_search
        }
        let details = { importer_iec_no: importer_iec_no, ad_code: ad_code }
        JobServices.getAdCode(details).then(res => {
            setAdcodeDetailsDetails(res.data)
        })
    }
    const JobDialogCntryOrgnNameeChangeHandel = (e) => {
        setJobCountryOrigineDtails([]);
        setJobDialogValues({ ...jobDialogValues, f_countryOrginName: e.target.value })
        setJobCountryOrigineDtails([]);
        var countryIdString, countryName = ''
        if (jobDialogValues.f_countryOriginCode === '') {
            countryIdString = '-1';
        } else {
            countryIdString = jobDialogValues.f_countryOriginCode;
        }
        if (e.target.value === '') {
            countryName = '-1'
        } else {
            countryName = e.target.value;
        }
        let details = { countryIdString: countryIdString, countryName: countryName, flag: '2' }
        JobServices.getCountryName(details).then(res => {
            setJobCountryOrigineDtails(res.data)
        })
    }
    const JobDialogCntryOrgnCodeChangeHandel = (e) => {
        setJobCountryOrigineDtails([]);
        setJobDialogValues({ ...jobDialogValues, f_countryOriginCode: e.target.value });
        setJobCountryOrigineDtails([]);
        var countryIdString, countryName = '';
        if (jobDialogValues.f_countryOrginName === '') {
            countryName = '-1';
        } else {
            countryName = jobDialogValues.f_countryOrginName;
        }
        if (e.target.value === '') {
            countryIdString = '-1';
        } else {
            countryIdString = e.target.value;
        }
        let details = { countryIdString: countryIdString, countryName: countryName, flag: '2' }
        JobServices.getCountryName(details).then(res => {
            setJobCountryOrigineDtails(res.data)
        })
    }
    const JobDialogBranchSrChangeHandel = (e) => {
        setBranchSrDetails([]);
        setJobDialogValues({ ...jobDialogValues, branch_sr_no: e.target.value });
        setBranchSrDetails([]);
        var importer_iec_no, importer_state, branch_sl_no = '';
        if (e.target.value === '') {
            branch_sl_no = '-1'
        } else {
            branch_sl_no = e.target.value
        }
        if (jobDialogValues.importer_state === '') {
            importer_state = '-1'
        } else {
            importer_state = jobDialogValues.importer_state
        }
        if (jobValues.iec_search === '') {
            importer_iec_no = '-1'
        } else {
            importer_iec_no = jobValues.iec_search
        }
        let details = { importer_iec_no: importer_iec_no, importer_name: importer_state, branch_sl_no: branch_sl_no }
        JobServices.getImporterBranch(details).then(res => {
            setBranchSrDetails(res.data)
        })
    }

    const JobDialogCntryOfCmNamChangeHandel = (e) => {
        setJobCountryOfCmDtails([]); setJobDialogValues({ ...jobDialogValues, f_countryOfCm: e.target.value }); setJobCountryOfCmDtails([]);
        var countryIdString, countryName = '';
        if (e.target.value === '') {
            countryName = '-1';
        } else {
            countryName = e.target.value;
        } if (jobDialogValues.f_countryOfCmCode === '') {
            countryIdString = '-1'
        } else {
            countryIdString = jobDialogValues.f_countryOfCmCode
        }
        let details = { countryIdString: countryIdString, countryName: countryName, flag: '2' }
        JobServices.getCountryName(details).then(res => {
            setJobCountryOfCmDtails(res.data)
        })
    }
    const JobDialogCntryOfCmCodChangeHandel = (e) => {
        setJobCountryOfCmDtails([]); setJobDialogValues({ ...jobDialogValues, f_countryOfCmCode: e.target.value }); setJobCountryOfCmDtails([]);
        var countryIdString, countryName = '';
        if (e.target.value === '') {
            countryIdString = '-1';
        } else {
            countryIdString = e.target.value;
        } if (jobDialogValues.f_countryOfCm === '') {
            countryName = '-1'
        } else {
            countryName = jobDialogValues.f_countryOfCm
        }
        let details = { countryIdString: countryIdString, countryName: countryName, flag: '2' }
        JobServices.getCountryName(details).then(res => {
            setJobCountryOfCmDtails(res.data);
        })
    }

    const JobDialogPortNameChangeHandel = (e) => {
        setJobCountryOfCmDtails([]); setJobDialogValues({ ...jobDialogValues, f_port_ofName: e.target.value }); setJobCountryOfCmDtails([]);
        var portCode, portName = '';
        if (e.target.value === '') {
            portName = '-1';
        } else {
            portName = e.target.value;
        }
        if (jobValues.port_of_loding === '') {
            portCode = '-1';
        } else {
            portCode = jobValues.port_of_loding;
        }
        let Details = {
            customPointCode: portCode, customPointName: portName, flag: '2'
            , transitTypeId: jobValues.mode_A_L_S, countryId: jobValues.countryOrigin, countryCode: jobValues.countrt_of_cm
        }
        JobServices.getPortLocationBasedCountryTransitType(Details).then(res => {
            setJobCountryOfCmDtails(res.data);
        })
    }
    const JobDialogPortCodeChangeHandel = (e) => {
        setJobCountryOfCmDtails([]); setJobDialogValues({ ...jobDialogValues, f_port_Code: e.target.value }); setJobCountryOfCmDtails([]);
        var portCode, portName = '';
        if (e.target.value === '') {
            portCode = '-1';
        } else {
            portCode = e.target.value;
        }
        if (jobValues.port_of_lodingName === '') {
            portName = '-1';
        } else {
            portName = jobValues.port_of_lodingName;
        }
        let Details = {
            customPointCode: portCode, customPointName: portName, flag: '2'
            , transitTypeId: jobValues.mode_A_L_S, countryId: jobValues.countryOrigin, countryCode: jobValues.countrt_of_cm
        }
        JobServices.getPortLocationBasedCountryTransitType(Details).then(res => {
            setJobCountryOfCmDtails(res.data)
        })
    }
    const JobDialogCertificateNoChangeHandel = (e) => {
        setJobDialogValues({ ...jobDialogValues, certificate_No: e.target.value })
    }
    const JobDialogCertificateTypeChangeHandel = (e) => {
        setJobDialogValues({ ...jobDialogValues, certificate_Type: e.target.value })
    }
    const JobDialogCertificateDateChangeHandel = (e) => {
        setJobDialogValues({ ...jobDialogValues, certificate_Date: e.target.value })
    }
    const JobDialogBondNoChangeHandel = (e) => {
        setJobDialogValues({ ...jobDialogValues, bondNo: e.target.value })
    }
    const JobDialogBondCodeChangeHandel = (e) => {
        setJobDialogValues({ ...jobDialogValues, bond_code: e.target.value })
    }
    const JobDialogBondPortChangeHandel = (e) => {
        setJobDialogValues({ ...jobDialogValues, bond_port: e.target.value })
    }
    const JobDialogBondAmountChangeHandel = (e) => {
        setJobDialogValues({ ...jobDialogValues, bond_amount: e.target.value })
    }
    const JobDialogBgDebitedChangeHandel = (e) => {
        setJobDialogValues({ ...jobDialogValues, bg_debited: e.target.value })
    }
    const JobDialogBgRateChangeHandel = (e) => {
        setJobDialogValues({ ...jobDialogValues, bg_rate: e.target.value })
    }
    const JobDialogBgAmountChangeHandel = (e) => {
        setJobDialogValues({ ...jobDialogValues, bg_ammount: e.target.value })
    }
    const JobDialogF_BondPortNameChangeHandel = (e) => {
        setJobDialogValues({ ...jobDialogValues, bond_portName: e.target.value })
        var cusnam, cusCode = '';
        if (e.target.value === '') {
            cusnam = '-1'
        }
        else {
            cusnam = e.target.value;
        }
        if (jobDialogValues.bond_port === '') {
            cusCode = '-1'
        } else {
            cusCode = jobDialogValues.bond_port;
        }
        let details = {
            cusHouseCode: cusCode, customHouseLocation: cusnam
            , flag: '2'
        }
        JobServices.getCustomHouseCode(details).then(res => {
            setCustomHouseDetails(res.data)
        })
    }

    const JobDialogF_BondPortCodeChangeHandel = (e) => {
        setJobDialogValues({ ...jobDialogValues, find_bond_port: e.target.value })
        var cusnam, cusCode = '';
        if (jobDialogValues.find_bond_port === '') {
            cusnam = '-1'
        }
        else {
            cusnam = jobDialogValues.bond_portName;
        }
        if (e.target.value === '') {
            cusCode = '-1'
        } else {
            cusCode = e.target.value;
        }
        let details = {
            cusHouseCode: cusCode, customHouseLocation: cusnam
            , flag: '2'
        }
        JobServices.getCustomHouseCode(details).then(res => {
            setCustomHouseDetails(res.data)
        })
    }
    const JobDialogIgmNoChangeHandel = (e) => {
        setJobDialogValues({ ...jobDialogValues, container_igm_no: e.target.value })
    }
    const JobDialogContainerNoChangeHandel = (e) => {
        setJobDialogValues({ ...jobDialogValues, container_no: e.target.value })
    }
    const JobDialogContainersizeChangeHandel = (e) => {
        setJobDialogValues({ ...jobDialogValues, container_size: e.target.value })
    }
    const JobDialog_L_F_C_ChangeHandel = (e) => {
        if (e.target.value === 'L' || e.target.value === 'l' || e.target.value === 'C' ||
            e.target.value === 'c' || e.target.value === 'F' || e.target.value === 'f' || e.target.value === '') {
            setJobDialogValues({ ...jobDialogValues, l_f_c: e.target.value })
        }
    }
    const JobDialogSealNoChangeHandel = (e) => {
        setJobDialogValues({ ...jobDialogValues, seal_no: e.target.value })
    }
    const JobDialogTruckNoChangeHandel = (e) => {
        setJobDialogValues({ ...jobDialogValues, truck_no: e.target.value })
    }

    const JabDialogTypeWXHCodeChangehandle = (e) => {
        setJobDialogValues({ ...jobDialogValues, typeH_w_xCode: e.target.value })
    }
    const JabDialogTypeWXhCustSiteIdChangehandle = (e) => {
        setJobDialogValues({ ...jobDialogValues, typeH_w_xCustSiteId: e.target.value })
    }
    const JobDialogwareCHSChangeHandel = (e) => {
        setJobDialogValues({ ...jobDialogValues, typeH_w_xCustSiteName: e.target.value })
        var customHouseLocation = '';
        if (e.target.value !== '') { customHouseLocation = e.target.value; }
        else { customHouseLocation = "-1"; }
        let details = { customHouseLocation: customHouseLocation, cusHouseCode: '-1', flag: '2' }
        JobServices.getCustomHouseCode(details).then(res => {
            setCustomHouseDetails(res.data)
        })
    }
    const JobDialogwereChsCodeChangeHandel = (e) => {
        setJobDialogValues({ ...jobDialogValues, findtypeH_w_xCustSiteId: e.target.value })
        var cusHouseCode = '';
        if (e.target.value !== '') { cusHouseCode = e.target.value; }
        else { cusHouseCode = "-1"; }
        let details = { customHouseLocation: '-1', cusHouseCode: cusHouseCode, flag: '2' }
        JobServices.getCustomHouseCode(details).then(res => { setCustomHouseDetails(res.data); })
    }

    const JabDialogTypeWXhBeNoChangehandle = (e) => {
        setJobDialogValues({ ...jobDialogValues, typeH_w_xBeNo: e.target.value })
    }
    const JabDialogTypeWXhBeDateChangehandle = (e) => {
        setJobDialogValues({ ...jobDialogValues, typeH_w_xBeDate: e.target.value })
    }
    const JabDialogTypeWXhNoOfPkgChangehandle = (e) => {
        setJobDialogValues({ ...jobDialogValues, typeH_w_xNoOfPkg: e.target.value })
    }

    const JabDialogTypeWXhPkgCodeChangehandle = (e) => {
        setJobDialogValues({ ...jobDialogValues, typeH_w_xPkgCode: e.target.value })
    }
    const JobDialogwarePackageNameChangeHandel = (e) => {
        setJobDialogValues({ ...jobDialogValues, typeH_w_xPkgName: e.target.value })
        var unitName = ''
        if (e.target.value !== '') { unitName = e.target.value; }
        else { unitName = "-1"; }
        let details = { unitName: unitName, unitCode: '-1', flag: '2' }
        JobServices.getUOM(details).then(res => { setCustomHouseDetails(res.data) })
    }
    const JobDialogwerePackageCodeChangeHandel = (e) => {
        setJobDialogValues({ ...jobDialogValues, findtypeH_w_xPkgCode: e.target.value })
        var unitCode = '';
        if (e.target.value !== '') { unitCode = e.target.value; }
        else { unitCode = "-1"; }
        let details = { unitName: '-1', unitCode: unitCode, flag: '2' }
        JobServices.getUOM(details).then(res => {
            setCustomHouseDetails(res.data)
        })
    }
    const JobDialogwareUnitNameChangeHandel = (e) => {
        setJobDialogValues({ ...jobDialogValues, typeH_w_xUnitName: e.target.value })
        var unitName = ''
        if (e.target.value !== '') { unitName = e.target.value; }
        else { unitName = "-1"; }
        let details = { unitName: unitName, unitCode: '-1', flag: '2' }
        JobServices.getUOM(details).then(res => {
            setCustomHouseDetails(res.data)
        })
    }
    const JobDialogwereUnitCodeChangeHandel = (e) => {
        setJobDialogValues({ ...jobDialogValues, findtypeH_w_xUnitCode: e.target.value })
        var unitCode = '';
        if (e.target.value !== '') { unitCode = e.target.value; }
        else { unitCode = "-1"; }
        let details = { unitName: '-1', unitCode: unitCode, flag: '2' }
        JobServices.getUOM(details).then(res => { setCustomHouseDetails(res.data); })
    }

    const JabDialogTypeWXhGrossWgtChangehandle = (e) => {
        setJobDialogValues({ ...jobDialogValues, typeH_w_xGroos: e.target.value })
    }

    const JabDialogTypeWXhUnitCodeChangehandle = (e) => {
        setJobDialogValues({ ...jobDialogValues, typeH_w_xUnitCode: e.target.value })
    }

    const JabDialogTypeWXhAnnexureNoChangehandle = (e) => {
        setJobDialogValues({ ...jobDialogValues, typeH_w_xAnnexureNo: e.target.value })
    }

    const JabDialogTypeWXhAnnexureDateChangehandle = (e) => {
        setJobDialogValues({ ...jobDialogValues, typeH_w_xAnnexureDate: e.target.value })
    }

    const JabDialogTypeWXhDFWChangehandle = (e) => {
        setJobDialogValues({ ...jobDialogValues, typeH_w_xDFW: e.target.value })
    }

    const JabDialogTypeWXhLE_RadioChangehandle = (e) => {
        setJobTypeHWX_LE_Radio(e.target.value)
    }

    const JabDialogTypeWXhLFE_Changehandle = (e) => {
        setJobDialogValues({ ...jobDialogValues, typeH_w_xLFE: e.target.value })
    }

    const JabDialogTypeWXhMLR_RadioChangehandle = (e) => {
        setJobTypeHWX_MLR_Radio(e.target.value)
    }

    const JabDialogTypeWXhMLRChangehandle = (e) => {
        setJobDialogValues({ ...jobDialogValues, typeH_w_xMLR: e.target.value })
    }

    const JabDialogTypeWXhECDChangehandle = (e) => {
        setJobDialogValues({ ...jobDialogValues, typeH_w_xECD: e.target.value })
    }

    const JobDialogHss_iecCodeHandle = (e) => {
        setJobDialogValues({ ...jobDialogValues, hss_iecCode: e.target.value })
    }

    const JobDialogHss_brnchSrHandle = (e) => {
        setJobDialogValues({ ...jobDialogValues, hss_brnchSrNo: e.target.value })
    }

    const JobDialogHss_PrecedingLvlHandle = (e) => {
        const re = /^[0-1\b]+$/;
        if (e.target.value === '' || re.test(e.target.value)) {
            setJobDialogValues({ ...jobDialogValues, hss_precedingLevel: e.target.value })
        }
    }

    const JobDialogHss_ImpNameChangeHandel = (e) => {
        setJobDialogValues({ ...jobDialogValues, hss_iecName: e.target.value }); setJobImporterDetails([]);
        var iec_code, iec_name = '';
        if (jobDialogValues.hss_iecCode === '') {
            iec_code = '-1'
        } else {
            iec_code = jobDialogValues.hss_iecCode
        } if (e.target.value === '') {
            iec_name = '-1'
        } else {
            iec_name = e.target.value
        }
        let details = { importer_iec_no: iec_code, importer_name: iec_name, flag: '2' }
        ImportQuerService.getImporter(details).then(res => {
            setJobImporterDetails(res.data)
        })
    }
    const JobDialogHss_ImpCodeChangeHandel = (e) => {
        setJobDialogValues({ ...jobDialogValues, findhss_iecCode: e.target.value }); setJobImporterDetails([]);
        var iec_code, iec_name = '';
        if (e.target.value === '') {
            iec_code = '-1'
        } else {
            iec_code = e.target.value
        } if (jobDialogValues.hss_iecName === '') {
            iec_name = '-1'
        } else {
            iec_name = jobDialogValues.hss_iecName
        }
        let details = { importer_iec_no: iec_code, importer_name: iec_name, flag: '2' }
        ImportQuerService.getImporter(details).then(res => {
            setJobImporterDetails(res.data)
        })
    }

    const JobDialogHss_impStateChangeHandel = (e) => {
        setJobDialogValues({ ...jobDialogValues, hss_brncSrName: e.target.value }); setBranchSrDetails([]);
        var importer_iec_no, importerState, branch_sl_no = '';
        if (jobDialogValues.hss_brnchSrNo === '') {
            branch_sl_no = '-1'
        } else {
            branch_sl_no = jobDialogValues.hss_brnchSrNo
        }
        if (jobDialogValues.hss_iecCode === '') {
            importer_iec_no = '-1'
        } else {
            importer_iec_no = jobDialogValues.hss_iecCode
        }
        if (e.target.value !== '') {
            importerState = e.target.value
        } else {
            importerState = '-1'
        }
        let details = { importer_iec_no: importer_iec_no, importer_name: importerState, branch_sl_no: branch_sl_no }
        JobServices.getImporterBranch(details).then(res => {
            setBranchSrDetails(res.data)
        })
    }
    const JobDialogHss_BrnSrNoChangeHandel = (e) => {
        setJobDialogValues({ ...jobDialogValues, findhss_brnchSrNo: e.target.value }); setBranchSrDetails([]);
        var importer_iec_no, branch_sl_no, importerState = '';
        if (e.target.value === '') {
            branch_sl_no = '-1'
        } else {
            branch_sl_no = e.target.value;
        }
        if (jobDialogValues.hss_iecCode === '') {
            importer_iec_no = '-1'
        } else {
            importer_iec_no = jobDialogValues.hss_iecCode;
        }
        if (jobDialogValues.hss_brncSrName !== '') {
            importerState = jobDialogValues.hss_brncSrName;
        } else {
            importerState = '-1'
        }
        let details = { importer_iec_no: importer_iec_no, importer_name: importerState, branch_sl_no: branch_sl_no }
        JobServices.getImporterBranch(details).then(res => {
            setBranchSrDetails(res.data)
        })

    }

    const jobDialogePermissionDescChngHndl = (e) => {
        setJobDialogValues({ ...jobDialogValues, sec_PermissionDesc: e.target.value })
    }

    const JobCtxStateCodeChangeHandle = (e) => {
        setJobDialogValues({ ...jobDialogValues, comrcial_StateCode: e.target.value })
    }
    const JobCtxTypeChangeHandle = (e) => {
        setJobDialogValues({ ...jobDialogValues, comrcial_CtxCode: e.target.value })
    }
    const JobCtxRegNoChangeHandle = (e) => {
        setJobDialogValues({ ...jobDialogValues, comrcial_ctx_regNo: e.target.value })
    }

    const jobFindReportNameChngHandle = (e) => {
        setJobDialogValues({ ...jobDialogValues, f_report_name: e.target.value });
        var customHouseLocation, cusHouseCode = '';
        if (jobDialogValues.f_report_code !== '') {
            cusHouseCode = jobDialogValues.f_report_code;
        } else {
            cusHouseCode = "-1";
        }
        if (e.target.value !== '') {
            customHouseLocation = e.target.value;
        }
        else {
            customHouseLocation = "-1";
        }
        let details = {
            cusHouseCode: cusHouseCode, customHouseLocation: customHouseLocation,
            flag: 2, transitTypeId: jobValues.mode_A_L_S
        }
        JobServices.getCustomHouseCodeBasedOnTransitType(details).then(res => {
            setCustomHouseDetails(res.data);
        })
    }
    const jobFindReportCodeChngHandle = (e) => {
        setJobDialogValues({ ...jobDialogValues, f_report_code: e.target.value });
        var customHouseLocation, cusHouseCode = '';
        if (e.target.value !== '') {
            cusHouseCode = e.target.value;
        } else {
            cusHouseCode = "-1";
        }

        if (jobDialogValues.f_report_name !== '') {
            customHouseLocation = jobDialogValues.f_report_name;
        }
        else {
            customHouseLocation = "-1";
        }
        let details = {
            customHouseLocation: customHouseLocation, cusHouseCode: cusHouseCode,
            flag: 2, transitTypeId: jobValues.mode_A_L_S
        }
        JobServices.getCustomHouseCodeBasedOnTransitType(details).then(res => {
            setCustomHouseDetails(res.data);
        })
    }
    //boe----------
    const jobBOEBeNoChngHandle = (e) => {
        setJobValues({ ...jobValues, be_no: e.target.value });
    }
    const jobBOEBeDateChngHandle = (e) => {
        setJobValues({ ...jobValues, be_date: e.target.value });
    }
    const jobBOEBeResponseChngHandle = (e) => {
        setJobValues({ ...jobValues, be_response: e.target.value });
    }
    const jobBOEBeReasonChngHandle = (e) => {
        setJobValues({ ...jobValues, be_reason: e.target.value });
    }

    //--------------------------------------onClick-evente-botton-------------------------------------------------
    const validateConsignment = () => {
        if (jobValues.job_no !== '') {
            if (jobValues.iec_search !== '') {
                if (jobValues.branch_sr_no !== '') {
                    if (jobValues.countryOrigin !== '') {
                        if (jobValues.countrt_of_cm !== '') {
                            if (jobValues.mode_A_L_S !== '') {
                                if (jobValues.port_of_loding !== '') {
                                    if (jobValues.type_H_W_x !== '') {
                                        if (jobValues.imp_type_G_O_p_U !== '') {
                                            if (jobValues.paymentMode_D_T !== '') {
                                                if (jobValues.name !== '') {
                                                    if (jobValues.address_1 !== '') {
                                                        if (jobValues.countryOriginName !== '') {
                                                            if (jobValues.countrt_of_cmName !== '') {
                                                                if (jobValues.model_A_L_S_Name !== '') {
                                                                    if (jobValues.port_of_lodingName !== '') {
                                                                        if (jobValues.customHousCode !== '') {
                                                                            if (jobValues.chs_name !== '') {
                                                                                if (jobValues.ad_code !== '') {
                                                                                    return true;
                                                                                }
                                                                                else {
                                                                                    document.getElementById('ad_code').focus();
                                                                                    setMessage('Please Enter The AD Code');
                                                                                    setSeverity('warning');
                                                                                    setOpenSnack(true);
                                                                                }
                                                                            }
                                                                            else {
                                                                                document.getElementById('chsCode').focus();
                                                                                setMessage('Custom House Code is not based on selected  Transit mode');
                                                                                setSeverity('warning');
                                                                                setOpenSnack(true);
                                                                            }
                                                                        }
                                                                        else {
                                                                            document.getElementById('chsCode').focus();
                                                                            setMessage('Custom House Code Not Availabel From Master');
                                                                            setSeverity('warning');
                                                                            setOpenSnack(true);
                                                                        }
                                                                    }
                                                                    else {
                                                                        document.getElementById('portLoding').focus();
                                                                        setMessage('Port of Loading Not Availabel From Master (or) It is not based on selected Transit mode');
                                                                        setSeverity('warning');
                                                                        setOpenSnack(true);
                                                                    }
                                                                }
                                                                else {
                                                                    document.getElementById('transiteType').focus();
                                                                    setMessage('Transit Mode Not Availabel From Master');
                                                                    setSeverity('warning');
                                                                    setOpenSnack(true);
                                                                }
                                                            }
                                                            else {
                                                                document.getElementById('jobCntryOfCm').focus();
                                                                setMessage('Consignment Country Not Availabel From Master'); setSeverity('warning'); setOpenSnack(true);
                                                            }
                                                        }
                                                        else {
                                                            document.getElementById('jonCntryOrgin').focus();
                                                            setMessage('Country of Origin Not Availabel From Master'); setSeverity('warning'); setOpenSnack(true);
                                                        }
                                                    }
                                                    else {
                                                        document.getElementById('brnc_no').focus();
                                                        setMessage('Branch Sr.No Not Availabel From Master'); setSeverity('warning'); setOpenSnack(true);
                                                    }
                                                }
                                                else {
                                                    document.getElementById('gvt_iec').focus();
                                                    setMessage('Importer IEC Code Not Availabel From Master'); setSeverity('warning'); setOpenSnack(true);
                                                }
                                            }
                                            else {
                                                document.getElementById('PaymentMode').focus();
                                                setMessage('Please Enter the Payment Mode'); setSeverity('warning'); setOpenSnack(true);
                                            }
                                        }
                                        else {
                                            document.getElementById('impTypeG_O_P_U').focus();
                                            setMessage('Please Enter the Imp Type'); setSeverity('warning'); setOpenSnack(true);
                                        }
                                    }
                                    else {
                                        document.getElementById('Type(H/W/X)').focus();
                                        setMessage('Please Enter the BOE Type'); setSeverity('warning'); setOpenSnack(true);
                                    }
                                }
                                else {
                                    document.getElementById('portLoding').focus();
                                    setMessage('Please Enter the Port of Loading'); setSeverity('warning'); setOpenSnack(true);
                                }
                            }
                            else {
                                document.getElementById('transiteType').focus();
                                setMessage('Please Enter The Transit Type'); setSeverity('warning'); setOpenSnack(true);
                            }
                        }
                        else {
                            document.getElementById('jobCntryOfCm').focus();
                            setMessage('Please Enter the Country Of Consignment.'); setSeverity('warning'); setOpenSnack(true);
                        }
                    }
                    else {
                        document.getElementById('jonCntryOrgin').focus();
                        setMessage('Please Enter the Origin Country.'); setSeverity('warning'); setOpenSnack(true);
                    }
                }
                else {
                    document.getElementById('brnc_no').focus();
                    setMessage('Please Enter the Branch Sr No.'); setSeverity('warning'); setOpenSnack(true);
                }
            }
            else {
                document.getElementById('gvt_iec').focus();
                setMessage('Please Enter the IEC No.'); setSeverity('warning'); setOpenSnack(true);
            }
        } else {
            setMessage('Job.No is Empty or Missing'); setSeverity('warning'); setOpenSnack(true);
        }
        return false;

    }

    const validateSvAndUpdaIgm = () => {
        if (jobValues.unit !== '') {
            if (jobValues.pkg_code !== '') {
                if (jobValues.mawb_no !== '') {
                    if (jobValues.no_of_pkgs !== '') {
                        if (jobValues.gross_wt !== '') {
                            if (jobValues.mawbDate !== '') {
                                return true;
                            }
                            else {
                                setMessage('Please Enter the MBL Date'); setSeverity('warning');
                            }
                        }
                        else {
                            setMessage('Please Enter the Gross Weight'); setSeverity('warning'); setOpenSnack(true)
                        }
                    }
                    else {
                        setMessage('Please Enter the No Of Packages'); setSeverity('warning'); setOpenSnack(true)

                    }
                }
                else {
                    setMessage('Please Enter the MAWB or MBL No'); setSeverity('warning'); setOpenSnack(true)
                }
            }
            else {
                setMessage('Please Enter Package Code'); setSeverity('warning'); setOpenSnack(true)
            }
        }
        else {
            setMessage('Please Enter the Unit Code'); setSeverity('warning'); setOpenSnack(true)
        }
        return false;
    }
    const [confirmDialog, setConfonfirmDialog] = useState({ isOpen: false, Title: '' });
    const functioigm = () => { setConfonfirmDialog({ ...confirmDialog, isOpen: false }); document.getElementById('igmno').focus(); }
    const addinvoice = () => {
        if (jobValues.mode_A_L_S === 'S' || jobValues.mode_A_L_S === 's' || jobValues.mode_A_L_S === 'L' || jobValues.mode_A_L_S === 'l') {
            setConfonfirmDialog({ ...confirmDialog, isOpen: false }); document.getElementById('container').focus();
        }
        else {
            setConfonfirmDialog({
                isOpen: true, Title: "Do You Want To Add Invoice ...!",
                noConfirm: () => { setConfonfirmDialog({ ...confirmDialog, isOpen: false }); setOpenJobAlert(true); document.getElementById('igmno').focus(); },
                onConfirm: () => { tabsselect('Invoice'); setConfonfirmDialog({ ...confirmDialog, isOpen: false }); }
            })
        }
    }
    const insertIgm = () => {
        if (validateSvAndUpdaIgm() === true) {
            setJobIGMSaveDsab(true);
            setJobIGMSve(true);
            var gateWay_port_code, gateWay_igmNo, gateWay_igmDate, igmDate, hawbDate, inwardDate = '';
            if (jobValues.gatewayNo !== '') { gateWay_igmNo = jobValues.gatewayNo; }
            else { gateWay_igmNo = null; }
            if (jobValues.gateWayDate !== '') { gateWay_igmDate = jobValues.gateWayDate; }
            else { gateWay_igmDate = null; }
            if (jobValues.repPortCode !== '') { gateWay_port_code = jobValues.repPortCode; }
            else { gateWay_port_code = null; }
            if (jobValues.igmDate !== "") { igmDate = jobValues.igmDate }
            else { igmDate = null; }
            if (jobValues.hawbDate !== "") { hawbDate = jobValues.hawbDate; }
            else { hawbDate = null; }
            if (jobValues.inWardDate !== "") { inwardDate = jobValues.inWardDate; }
            else { inwardDate = null; }
            let details = {
                consignmentId: jobValues.job_no, igmNo: jobValues.igm_No, igmDate: igmDate, mawbNo: jobValues.mawb_no, mawb_date: jobValues.mawbDate, hawb_no: jobValues.hawb_no,
                hawbDate: hawbDate, noofPkg: jobValues.no_of_pkgs, totalWeight: jobValues.gross_wt, uomCode: jobValues.unit, inwardDate: inwardDate, gateWay_port_code: gateWay_port_code,
                gateWay_igmNo: gateWay_igmNo, packageCode: jobValues.pkg_code, gateWay_igmDate: gateWay_igmDate, marksNumbers: jobValues.marks_and_number
            }
            JobServices.insertIGMDetails(details).then(res => {
                const message = res.data.message;
                if (message.toString() === 'SUCCESS') {
                    setMessage('IGM Inserted SuccssFully'); setSeverity('success'); refreshigm(); setOpenSnack(true);
                    let jobnum = { consignmentId: jobValues.job_no }
                    JobServices.getIGM_Details(jobnum).then(res => { setJobIgmDetails(res.data); });
                    setConfonfirmDialog({ isOpen: true, Title: "Do You Want To Add More IGM", noConfirm: () => { addinvoice() }, onConfirm: () => { functioigm() } })
                } else {
                    setMessage(message.toString()); setSeverity('error'); setOpenSnack(true);
                    refreshigm();
                }
                if (jobValues.mode_A_L_S === 'S' || jobValues.mode_A_L_S === 's' || jobValues.mode_A_L_S === 'L' || jobValues.mode_A_L_S === 'l') {
                    document.getElementById('container').focus();
                } else { document.getElementById('igmno').focus(); }
            }).catch(error => {
                setMessage(error.message); setSeverity('error'); setOpenSnack(true);
                refreshigm();
            })
        }
    }

    const saveigm = () => {
        if (validateConsignment() === true) {
            setJobIGMSaveDsab(true); setJobIGMUpdatedsab(true); setJobIGMDeleteDsab(true);
            setJobIGMSve(true); setJobIGMUpd(false); setJobIGmDlt(false);
            let details = {
                beConsignmentId: jobValues.job_no, consignmentId: jobValues.job_no, messageType: ''
                , cusHouseCode: jobValues.customHousCode, userJobNo: jobValues.edi_job_no, userJobDate: '', beNo: jobValues.be_no,
                beDate: jobValues.be_date, typeBoe: jobValues.type_H_W_x, importer_iec_no: jobValues.iec_search, branch_sl_no: jobValues.branch_sr_no
                , importer_name: jobValues.name, importerAddress: jobValues.address_1, importerAddress1: jobValues.addresh_2, importer_city: jobValues.city,
                importerState: jobValues.state, pincode: jobValues.pincode, class_boe: jobValues.class_g_p_n, transitTypeCode: jobValues.mode_A_L_S, impTypeBoe: jobValues.imp_type_G_O_p_U
                , kacha: jobValues.kacha_y_N, publicSec: jobValues.public_sec_y_n, bePermission: null, origin_portName: jobValues.port_of_loding, chaCode: jobValues.chaCode, countryCode: jobValues.countryOrigin
                , countryOfCmName: jobValues.countrt_of_cm, port_of_shipment: null, greenChn: jobValues.green_chn, secFourEdight: jobValues.sec_48_y_n, ucrNo: jobValues.ucr, ucrType: jobValues.ucr_type
                , priorBE: jobValues.prior_be_y_n, ad_code: jobValues.ad_code, firstCheck: jobValues.first_check_y_n, warehouseCode: '', warehouseCustomeSite: '0', warehouseBeNo: '', warehouseBeDate: '',
                paymentMode: jobValues.paymentMode_D_T, bond: jobValues.bond_y_N, certificate: jobValues.certificate_y_N, commercialTax: jobValues.commercial_tax_y_n, hss: jobValues.hss_y_n, beContainer: jobValues.container_detail
                , impClass: jobValues.class_g_p_n, regionalName: jobValues.branch, freightFwdName: jobValues.forwarder, createdBy: getUserId(), pointId: getPointId()
            }
            JobServices.insertEdiJob(details).then(res => {
                setEDiJobSaveDsa(false); setEDiJobSve(false);
                const message = res.data.message;
                if (message.toString() === 'SUCCESS') {
                    setJobIGMSaveDsab(false); setJobIGMUpdatedsab(true); setJobIGMDeleteDsab(true);
                    setJobIGMSve(false); setJobIGMUpd(false); setJobIGmDlt(false);
                    insertIgm();
                } else {
                    setMessage(message.toString()); setSeverity('error'); setOpenSnack(true); refreshigm();
                }
            }).catch(error => {
                setMessage(error.message); setSeverity('error'); setOpenSnack(true);
                setEDiJobSaveDsa(false); setEDiJobSve(false); refreshigm();
            })
        }
        setEDiJobSaveDsa(false);
        setEDiJobSve(false);
    }

    const JobEdiJobAlertClosehandle = () => {
        setOpenJobAlert(false); document.getElementById('igmno').focus();
    }

    const updateIgm = () => {
        if (validateSvAndUpdaIgm() === true) {
            if (jobValues.igmId !== 0) {
                setJobIGMSaveDsab(true);
                setJobIGMUpdatedsab(true);
                setJobIGMDeleteDsab(false);

                setJobIGMSve(false);
                setJobIGMUpd(true);
                setJobIGmDlt(false);
                var gateWay_port_code, gateWay_igmNo, gateWay_igmDate, igmDate, hawbDate, inWardDate = '';
                if (jobValues.gatewayNo !== '') { gateWay_igmNo = jobValues.gatewayNo; }
                else { gateWay_igmNo = null; }
                if (jobValues.gateWayDate !== '') { gateWay_igmDate = jobValues.gateWayDate; }
                else { gateWay_igmDate = null; }
                if (jobValues.repPortCode !== '') { gateWay_port_code = jobValues.repPortCode; }
                else { gateWay_port_code = null; }
                if (jobValues.igmDate !== '' || jobValues.igmDate !== '0000-00-00') { igmDate = jobValues.igmDate }
                else { igmDate = null }
                if (jobValues.hawbDate !== '' || jobValues.hawbDate !== '0000-00-00') { hawbDate = jobValues.hawbDate; } else { hawbDate = null }
                if (jobValues.inWardDate !== '' || jobValues.inWardDate !== '000-00-00') { inWardDate = jobValues.inWardDate; } else { inWardDate = null; }
                let details = {
                    consignmentId: jobValues.job_no, igmNo: jobValues.igm_No, igmDate: igmDate, mawbNo: jobValues.mawb_no, mawb_date: jobValues.mawbDate,
                    hawb_no: jobValues.hawb_no, hawbDate: hawbDate, noofPkg: jobValues.no_of_pkgs, totalWeight: jobValues.gross_wt, uomCode: jobValues.unit, inwardDate: inWardDate,
                    gateWay_port_code: gateWay_port_code, gateWay_igmNo: gateWay_igmNo, packageCode: jobValues.pkg_code, gateWay_igmDate: gateWay_igmDate, marksNumbers: jobValues.marks_and_number
                }
                JobServices.updateIGMDetails(jobValues.igmId, details).then(res => {
                    const message = res.data.message;
                    if (message.toString() === 'SUCCESS') {
                        setMessage('Igm Updated SuccssFully');
                        setSeverity('success');
                        refreshigm();
                        let jobnum = { consignmentId: jobValues.job_no }
                        JobServices.getIGM_Details(jobnum).then(res => {
                            setJobIgmDetails(res.data);
                        })
                        setOpenSnack(true);
                    } else {
                        setMessage(message.toString());
                        setSeverity('error');
                        setOpenSnack(true);
                        setJobIGMSaveDsab(true);
                        setJobIGMUpdatedsab(false);
                        setJobIGMDeleteDsab(false);

                        setJobIGMSve(false);
                        setJobIGMUpd(false);
                        setJobIGmDlt(false);
                    }
                }).catch(error => {
                    setMessage(error.message);
                    setSeverity('error');
                    setOpenSnack(true);
                    refreshigm();
                })
            }
        } else {
            setMessage('Please Slect IGM From IGM Table');
            setSeverity('warning');
            setOpenSnack(true);
        }
    }

    const IgmDelete = () => {
        setConfonfirmDialog({ ...confirmDialog, isOpen: false })
        JobServices.deleteIGMDetails(jobValues.igmId).then(res => {
            const message = res.data.message;
            if (message.toString() === 'SUCCESS') {
                setMessage('Igm Deleted Successfully');
                setSeverity('success');
                setOpenSnack(true);
                let jobnum = { consignmentId: jobValues.job_no }
                JobServices.getIGM_Details(jobnum).then(res => {
                    setJobIgmDetails(res.data);
                })
                refreshigm();
            } else {
                setMessage(message.toString());
                setSeverity('primary');
                setOpenSnack(true);
                refreshigm();
            }
        }).catch(error => {
            setMessage(error.message);
            setSeverity('error');
            setOpenSnack(true);
            refreshigm();
        })
    }

    const JobDeleteIgmDetails = () => {
        setJobIGMDeleteDsab(true);
        setJobIGmDlt(true);
        if (jobValues.igmId === 0) {
            setMessage('Pleas Select IGM From IGM Table');
            setSeverity('warning');
            setOpenSnack(true);
            setJobIGMDeleteDsab(false);
            setJobIGmDlt(false);
        } else {
            setConfonfirmDialog({
                isOpen: true, Title: "Do You Want To Add More IGM", noConfirm: () => { setConfonfirmDialog({ ...confirmDialog, isOpen: false }) },
                onConfirm: () => { IgmDelete() }
            })
        }
    }

    const refreshigm = () => {
        setJobValues({
            ...jobValues, igmId: 0, igm_No: '', igmDate: '', mawb_no: '', mawbDate: '', hawb_no: '', hawbDate: '', no_of_pkgs: ''
            , gross_wt: '', unit: 'KGS', inWardDate: '', pkg_code: 'PKG', marks_and_number: 'As Per BL', gateWayDate: '', gatewayNo: '', repPortCode: '', repPortName: ''
        });
        setJobIGMSaveDsab(false); setJobIGMUpdatedsab(true); setJobIGMDeleteDsab(true);
        setJobIGMSve(false); setJobIGMUpd(false); setJobIGmDlt(false);
    }
    const EditIgmDetails = (igm) => {
        setJobValues({
            ...jobValues, igmId: igm.igmId, igm_No: igm.igmNo, igmDate: igm.igmDate, mawb_no: igm.mawbNo,
            mawbDate: igm.mawb_date, hawb_no: igm.hawb_no, hawbDate: igm.hawbDate, no_of_pkgs: igm.noofPkg, gross_wt: igm.totalWeight,
            unit: igm.uomCode, inWardDate: igm.inwardDate, pkg_code: igm.packageCode, marks_and_number: igm.marksNumbers,
            gatewayNo: igm.gateWay_igmNo, gateWayDate: igm.gateWay_igmDate, repPortCode: igm.gateWay_port_code, repPortName: igm.gatewayPortName
        });
        setJobIGMSaveDsab(true); setJobIGMUpdatedsab(false); setJobIGMDeleteDsab(false);
        setJobIGMSve(false); setJobIGMUpd(false); setJobIGmDlt(false);
    }

    const saveJob = () => {
        setEDiJobSaveDsa(true); setEDiJobSve(true); saveigm();
    }

    const updateEdiJob = () => {
        if (validateConsignment() === true) {
            setEDiJobUpdateDsa(true); setEDiJobUpd(true);
            let details = {
                beConsignmentId: jobValues.job_no, consignmentId: jobValues.job_no, messageType: ''
                , cusHouseCode: jobValues.customHousCode, userJobNo: jobValues.edi_job_no, userJobDate: '', beNo: jobValues.be_no,
                beDate: jobValues.be_date, typeBoe: jobValues.type_H_W_x, importer_iec_no: jobValues.iec_search, branch_sl_no: jobValues.branch_sr_no
                , importer_name: jobValues.name, importerAddress: jobValues.address_1, importerAddress1: jobValues.addresh_2, importer_city: jobValues.city,
                importerState: jobValues.state, pincode: jobValues.pincode, class_boe: jobValues.class_g_p_n, transitTypeCode: jobValues.mode_A_L_S, impTypeBoe: jobValues.imp_type_G_O_p_U
                , kacha: jobValues.kacha_y_N, publicSec: jobValues.public_sec_y_n, bePermission: null, origin_portName: jobValues.port_of_loding, chaCode: jobValues.chaCode, countryCode: jobValues.countryOrigin
                , countryOfCmName: jobValues.countrt_of_cm, port_of_shipment: null, greenChn: jobValues.green_chn, secFourEdight: jobValues.sec_48_y_n, ucrNo: jobValues.ucr, ucrType: jobValues.ucr_type
                , priorBE: jobValues.prior_be_y_n, ad_code: jobValues.ad_code, firstCheck: jobValues.first_check_y_n, warehouseCode: '', warehouseCustomeSite: '0', warehouseBeNo: '', warehouseBeDate: '', updatedBy: getUserId(),
                paymentMode: jobValues.paymentMode_D_T, bond: jobValues.bond_y_N, certificate: jobValues.certificate_y_N, commercialTax: jobValues.commercial_tax_y_n, hss: jobValues.hss_y_n, beContainer: jobValues.container_detail
                , impClass: jobValues.class_g_p_n, regionalName: jobValues.branch, freightFwdName: jobValues.forwarder, createdBy: getUserId(), pointId: getPointId()
            }
            JobServices.updateEdiJob(details).then(res => {
                setEDiJobUpdateDsa(false);
                setEDiJobUpd(false);
                const message = res.data.message;
                if (message.toString() === 'SUCCESS') {
                    setMessage('Update Successfully');
                    setSeverity('success');
                    setOpenSnack(true);
                    refreshigm();
                } else {
                    setMessage(message.toString());
                    setSeverity('error');
                    setOpenSnack(true)
                }
            }).catch(error => {
                setMessage(error.message);
                setSeverity('error');
                setOpenSnack(true);
                setEDiJobUpdateDsa(false);
                setEDiJobUpd(false);
            })
        }
    }

    const jobDelete = () => {
        setConfonfirmDialog({ ...confirmDialog, isOpen: false });
        JobServices.deleteConsignment(jobValues.job_no).then(res => {
            setEDiJobDeleteDsa(false);
            setEDiJobDlt(false);
            const message = res.data.message;
            if (message.toString() === 'SUCCESS') {
                setMessage('Delete Successfully');
                setSeverity('success');
                setOpenSnack(true);
                refreshigm();
                let type = { operationType: '1' }
                JobServices.getConsignmentJobEntry(type).then(res => {

                })
            } else {
                setMessage(message.toString());
                setSeverity('error');
                setOpenSnack(true)
            }
        }).catch(error => {
            setMessage(error.message);
            setSeverity('error');
            setOpenSnack(true);
            setEDiJobDeleteDsa(false);
            setEDiJobDlt(false);
        })
    }

    const EdiJobDelete = () => {

        if (jobValues.job_no !== '') {
            setEDiJobDeleteDsa(true); setEDiJobDlt(true);
            setConfonfirmDialog({
                isOpen: true, Title: 'Are You Sure To Delete This Job.?',
                noConfirm: () => { setConfonfirmDialog({ ...confirmDialog, isOpen: false }); }, onConfirm: () => { jobDelete() }
            })
        } else { setMessage('Select Designation from the List..!'); setSeverity('warning'); setOpenSnack(true); }
    }

    const JobBePrint = () => {
        if (EDiJobUpdateDsa === false) {
            ItemBeCheackListPrint(0);
        } else {
            setMessage('Please Select or Entered Job No...!!');
            setSeverity('warning');
            setOpenSnack(true);
        }
    }

    const JobCheacklistPrint = () => {
        if (EDiJobUpdateDsa === false) {
            ItemBeCheackListPrint(1);
        } else {
            setMessage('Please Select or Entered Job No...!!');
            setSeverity('warning');
            setOpenSnack(true);
        }
    }
    const jobBeUpdationSave = () => {
        let details = {
            consignmentId: jobValues.job_no, beNo: jobValues.be_no, beDate: jobValues.be_date,
            beResponse: jobValues.be_response, beReason: jobValues.be_reason
        }
        JobServices.updateBeUpdation(details).then(res => {
            const message = res.data.message;
            if (message.toString() === 'SUCCESS') {
                setMessage('Updated Successfully');
                setSeverity('success');
                setOpenSnack(true);
            } else {
                setMessage(message.toString());
                setSeverity('error');
                setOpenSnack(true)
            }
        }).catch(error => {
            setMessage(error.message);
            setSeverity('error');
            setOpenSnack(true);
        })
    }
    //------------------------------------OnChange handle---------------------------------------------------------;
    //RADIO ONChange
    const JobRadioChangeHandle = (e) => {
        setJobRadioValues(e.target.value)
    }

    const jobModeChangeHandle = (e) => {
        setJobDialogValues({ ...jobDialogValues, transit_code: e.target.value.replace(/[`~0-9!@#$%^&*()_|+{}=[?;:'",.<>]/gi, '') });
        setJobValues({ ...jobValues, mode_A_L_S: e.target.value });
        if (e.target.value === 'A' || e.target.value === 'S' || e.target.value === 'L' || e.target.value === 'a'
            || e.target.value === 's' || e.target.value === 'l') {
            let details = {
                transitTypeCode: e.target.value,
                transitTypeName: '-1', flag: '1'
            }
            JobServices.getTransitType(details).then(res => {
                const dataname = res.data.map((trnsitName) => trnsitName)
                setJobValues({ ...jobValues, mode_A_L_S: e.target.value.replace(/[`~0-9!@#$%^&*()_|+{}=[?;:'",.<>]/gi, ''), model_A_L_S_Name: dataname[0].transitTypeName });
            })
        } else if (e.target.value === '') {
            setJobValues({ ...jobValues, mode_A_L_S: e.target.value, model_A_L_S_Name: '' });
        }

    }
    const jobChaCodehangeHandle = (e) => {
        setJobValues({ ...jobValues, chaCode: e.target.value.replace(/[`~!@#$%^&*()_|+{}=[?;:'",.<>]/gi, '') });
    }

    const jobModelNameChangeHandle = (e) => {
        setJobValues({ ...jobValues, model_A_L_S_Name: e.target.value.replace(/[`~!@#$%^&*()_|+{}=[?;:'",.<>]/gi, '') });
    }

    const jobChsCodeChangeHandle = (e) => {
        setJobValues({ ...jobValues, customHousCode: e.target.value.replace(/[`~!@#$%^&*()_|+{}=[?;:'",.<>]/gi, '') });
        if (jobValues.mode_A_L_S === '') {
            setMessage('Kindly Select Transit Type')
            setSeverity('error')
            setOpenSnack(true)
        } else {
            var cusCode, trnsiCode = '';
            if (e.target.value === '') {
                setJobValues({ ...jobValues, customHousCode: e.target.value.replace(/[`~!@#$%^&*()_|+{}=[?;:'",.<>]/gi, ''), chs_name: '' })
            }
            else {
                cusCode = e.target.value;
                if (jobValues.mode_A_L_S === '') { trnsiCode = '-1' }
                else { trnsiCode = jobValues.mode_A_L_S; }
                let details = { cusHouseCode: cusCode, customHouseLocation: '-1', flag: '1', transitTypeId: trnsiCode }
                JobServices.getCustomHouseCodeBasedOnTransitType(details).then(res => {
                    const data = res.data;
                    const nameAndCode = data.map((trnsit) => trnsit.customHouseLocation)
                    setJobValues({ ...jobValues, customHousCode: e.target.value.replace(/[`~!@#$%^&*()_|+{}=[?;:'",.<>]/gi, ''), chs_name: nameAndCode });
                })
            }
        }
    }

    const jobChsNameCodeChangeHandle = (e) => {
        setJobValues({ ...jobValues, chs_name: e.target.value.replace(/[`~!@#$%^&*()_|+{}=[?;:'",.<>]/gi, '') });

    }

    const jobBranchChangeHandle = (e) => {
        setJobValues({ ...jobValues, branch: e.target.value.replace(/[`~!@#$%^&*()_|+{}=[?;:'",.<>]/gi, '') });
        setJobDialogValues({ ...jobDialogValues, branch: e.target.value.replace(/[`~!@#$%^&*()_|+{}=[?;:'",.<>]/gi, '') })
    }

    const jobForwarderChangeHandle = (e) => {
        setJobValues({ ...jobValues, forwarder: e.target.value.replace(/[`~!@#$%^&*()_|+{}=[?;:'",.<>]/gi, '') });
        setJobDialogValues({ ...jobDialogValues, forwdr: e.target.value.replace(/[`~!@#$%^&*()_|+{}=[?;:'",.<>]/gi, '') })
    }

    const jobJob_NoChangeHandle = (e) => {
        setJobValues({ ...jobValues, job_no: e.target.value.replace(/[`~!@#$%^&*()_|+{}=[?;:'",.<>]/gi, '') });
    }

    const JobIecSearchChangeHandle = (e) => {
        setJobValues({ ...jobValues, iec_search: e.target.value.replace(/[`~!@#$%^&*()_|+{}=[?;:'",.<>]/gi, '') });
        setJobDialogValues({ ...jobDialogValues, importer_code: e.target.value.replace(/[`~!@#$%^&*()_|+{}=[?;:'",.<>]/gi, '') })
        var iec_code = '';
        if (e.target.value === '') { iec_code = '-1' }
        else { iec_code = e.target.value }
        let details = { importer_iec_no: iec_code, importer_name: '-1', flag: '1' }
        ImportQuerService.getImporter(details).then(res => {
            const data = res.data
            const name = data.map((imptr) => imptr)
            if (!name[0]) {
                setJobValues({ ...jobValues, iec_search: e.target.value.replace(/[`~!@#$%^&*()_|+{}=[?;:'",.<>]/gi, ''), name: '' });
            } else {
                if (e.target.value === '') {
                    setJobValues({ ...jobValues, iec_search: e.target.value.replace(/[`~!@#$%^&*()_|+{}=[?;:'",.<>]/gi, ''), name: '' });
                } else {
                    setJobValues({ ...jobValues, iec_search: e.target.value.replace(/[`~!@#$%^&*()_|+{}=[?;:'",.<>]/gi, ''), name: name[0].importer_name });
                }
            }
        })
    }

    const JobBr_SrChangeHandle = (e) => {
        setJobValues({ ...jobValues, branch_sr_no: e.target.value.replace(/[`~!@#$%^&*()_|+{}=[?;:'",.<>]/gi, '') });
        setJobDialogValues({ ...jobDialogValues, branch_sr_no: e.target.value.replace(/[`~!@#$%^&*()_|+{}=[?;:'",.<>]/gi, '') });
        var importer_iec_no, branch_sl_no = '';
        if (e.target.value === '') {
            branch_sl_no = '-1'
        } else {
            branch_sl_no = e.target.value;
        }
        if (jobValues.iec_search === '') {
            importer_iec_no = '-1'
        } else {
            importer_iec_no = jobValues.iec_search
        }
        let details = { importer_iec_no: importer_iec_no, importer_name: '-1', branch_sl_no: branch_sl_no }
        JobServices.getImporterBranch(details).then(res => {
            const data = res.data;
            const brncsrl = data.map((detail) => detail);
            if (e.target.value === '') {
                setJobValues({
                    ...jobValues, branch_sr_no: e.target.value.replace(/[`~!@#$%^&*()_|+{}=[?;:'",.<>]/gi, ''), address_1: '', addresh_2: '',
                    city: '', state: '', pincode: '', ad_code: ''
                });
            } else {
                setJobValues({
                    ...jobValues, branch_sr_no: e.target.value.replace(/[`~!@#$%^&*()_|+{}=[?;:'",.<>]/gi, ''), address_1: brncsrl[0].importerAddress, addresh_2: brncsrl[0].importerAddress1,
                    city: brncsrl[0].importer_city, state: brncsrl[0].importerState, pincode: brncsrl[0].pincode, ad_code: brncsrl[0].ad_code
                });
            }
        })
    }

    const JobADcodChangeHandle = (e) => {
        setJobValues({ ...jobValues, ad_code: e.target.value.replace(/[`~!@#$%^&*()_|+{}=[?;:'",.<>]/gi, '') });
        setJobDialogValues({ ...jobDialogValues, ad_code: e.target.value.replace(/[`~!@#$%^&*()_|+{}=[?;:'",.<>]/gi, '') })
    }

    const jobEdiJob_NoChangeHandle = (e) => {
        setJobValues({ ...jobValues, edi_job_no: e.target.value.replace(/[`~!@#$%^&*()_|+{}=[?;:'",.<>]/gi, '') });
    }

    const JobcountryOriginChangeHandle = (e) => {
        setJobValues({ ...jobValues, countryOrigin: e.target.value.replace(/[`~0-9!@#$%^&*()_|+{}[=?;:'",.<>]/gi, '') });
        setJobDialogValues({ ...jobDialogValues, f_countryOriginCode: e.target.value.replace(/[`~0-9!@#$%^&*(){}_|+[=?;:'",.<>]/gi, '') });

        if (e.target.value === '') {
            setJobValues({ ...jobValues, countryOrigin: e.target.value.replace(/[`~0-9!@#$%^&*()_|+{}[=?;:'",.<>]/gi, ''), countryOriginName: '' })
        } else {
            let details = { countryIdString: e.target.value, countryName: '-1', flag: '1' }
            JobServices.getCountryName(details).then(res => {
                const data = res.data;
                const country = data.map((cntry) => cntry)
                setJobValues({ ...jobValues, countryOrigin: e.target.value.replace(/[`~0-9!@#$%^&*()_|+{}=[?;:'",.<>]/gi, ''), countryOriginName: country[0].countryName })
            })
        }
    }

    const JobcountryCmChangeHandle = (e) => {
        setJobValues({ ...jobValues, countrt_of_cm: e.target.value.replace(/[`~0-9!@#$%^&*()_|+{}=[?;:'",.<>]/gi, '') });
        setJobDialogValues({ ...jobDialogValues, f_countryOfCmCode: e.target.value.replace(/[`~0-9!@#$%^&*()_|+{}=[?;:'",.<>]/gi, '') })
        if (e.target.value === '') {
            setJobValues({ ...jobValues, countrt_of_cm: e.target.value.replace(/[`~0-9!@#$%^&*()_|+{}=[?;:'",.<>]/gi, ''), countrt_of_cmName: '' });
        } else {
            let details = { countryIdString: e.target.value.replace(/[`~0-9!@#$%^&*()_|+{}=[?;:'",.<>]/gi, ''), countryName: '-1', flag: '1' }
            JobServices.getCountryName(details).then(res => {
                const data = res.data;
                const contryName = data.map((cnt) => cnt)
                setJobValues({ ...jobValues, countrt_of_cm: e.target.value.replace(/[`~0-9!@#$%^&*()_|+{}=[?;:'",.<>]/gi, ''), countrt_of_cmName: contryName[0].countryName });

            })
        }

    }

    const JobCertificateChangeHandle = (e) => {
        if (e.target.value === 'Y' || e.target.value === 'y') {
            setJobValues({ ...jobValues, certificate_y_N: e.target.value });
            if (jobValues.job_no === '') {
                setOpenSnack(true);
                setMessage('Select Job.No')
                setSeverity('error');
            } else {
                setJobCertificateOpen(true); setAdcodeDetailsDetails([])
                JobServices.getCertificateType().then(res => { setCertifcatetypeDetai(res.data); })
                let details = { consignmentId: jobValues.job_no }
                JobServices.getCertificateDetails(details).then(res => { setAdcodeDetailsDetails(res.data) }); document.getElementById('Bond').focus();
            }
        } else if (e.target.value === '') {
            setJobValues({ ...jobValues, certificate_y_N: e.target.value });
            setJobCertificateOpen(false)
        } else if (e.target.value === 'N' || e.target.value === 'n') {
            setJobValues({ ...jobValues, certificate_y_N: e.target.value });
            document.getElementById('Bond').focus();
            setJobCertificateOpen(false)
        }
    }
    const JobContainerChangeHandle = (e) => {
        if (e.target.value === 'Y' || e.target.value === 'y') {
            setJobValues({ ...jobValues, container_detail: e.target.value });
            if (jobValues.job_no === '') {
                setMessage('Please Select Job No From Job Table');
                setSeverity('warning');
                setOpenSnack(true)
            } else {
                setJobContainerOpen(true);
                let details = { consignmentId: jobValues.job_no }
                JobServices.getContainer(details).then(res => {
                    setAdcodeDetailsDetails(res.data)
                })
                JobServices.getIgmBasedOnContainer(jobValues.job_no).then(res => {
                    setjobigmdropdwon(res.data)
                })
            }
        } else if (e.target.value === '') {
            setJobValues({ ...jobValues, container_detail: e.target.value });
            setJobContainerOpen(false)
        } else if (e.target.value === 'N' || e.target.value === 'n') {
            setJobValues({ ...jobValues, container_detail: e.target.value });
            setJobContainerOpen(false)
        }
    }

    const JobBondChangeHandle = (e) => {
        if (e.target.value === 'Y' || e.target.value === 'y') {
            setJobValues({ ...jobValues, bond_y_N: e.target.value });
            if (!jobValues.job_no) {
                setMessage('Select Job.No');
                setSeverity('error')
                setOpenSnack(true)
            } else {
                setAdcodeDetailsDetails([]); document.getElementById('Classgpn').focus();
                setJobBondOpen(true);
                JobServices.getbondCode().then(res => {
                    setBondcodeDrp(res.data)
                })
                let details = { consignmentId: jobValues.job_no }
                JobServices.getBondDetails(details).then(res => {
                    setAdcodeDetailsDetails(res.data)
                })
            }
        } else if (e.target.value === '') {
            setJobValues({ ...jobValues, bond_y_N: e.target.value });
        } else if (e.target.value === 'N' || e.target.value === 'n') {
            setJobValues({ ...jobValues, bond_y_N: e.target.value });
            document.getElementById('Classgpn').focus();
        }
    }
    const JobClassChangeHandle = (e) => {
        if (e.target.value === 'N' || e.target.value === 'n' || e.target.value === 'G' ||
            e.target.value === 'g' || e.target.value === 'P' || e.target.value === 'p' || e.target.value === '') {
            setJobValues({ ...jobValues, class_g_p_n: e.target.value });
        }
    }

    const JobPortOfLoadingChangeHandle = (e) => {
        setJobValues({ ...jobValues, port_of_loding: e.target.value.replace(/[`~0-9!@#$%^&*()_|+{}=[?;:'",.<>]/gi, '') });
        setJobDialogValues({ ...jobDialogValues, f_port_Code: e.target.value.replace(/[`~0-9!@#$%^&*()_|+{}=[?;:'",.<>]/gi, '') })
        var portCode = '';
        if (e.target.value === '') {
            portCode = '-1';
        } else {
            portCode = e.target.value;
        }
        let Details = {
            customPointCode: portCode, customPointName: '-1', flag: '1'
            , transitTypeId: jobValues.mode_A_L_S, countryId: jobValues.countryOrigin, countryCode: jobValues.countrt_of_cm
        }
        JobServices.getPortLocationBasedCountryTransitType(Details).then(res => {
            const data = res.data;
            const cntry = data.map((item) => item)
            if (e.target.value !== '') {
                setJobValues({ ...jobValues, port_of_loding: e.target.value.replace(/[`~0-9!@#$%^&*()_|+{}=[?;:'",.<>]/gi, ''), port_of_lodingName: cntry[0].customPointName });
            } else {
                setJobValues({ ...jobValues, port_of_loding: e.target.value.replace(/[`~0-9!@#$%^&*()_|+{}=[?;:'",.<>]/gi, ''), port_of_lodingName: '' });
            }
        })
    }
    // const JobPortOfLoadinNameHandleOpen = (e) => {
    //     setJobValues({ ...jobValues, port_of_lodingName: e.target.value.replace(/[`~0-9!@#$%^&*()_|+{}=[?;:'",.<>]/gi, '') });
    // }

    const JobTypeHWXChangeHandle = (e) => {
        if (e.target.value === 'H' || e.target.value === 'h') {
            setJobValues({ ...jobValues, type_H_W_x: e.target.value }); document.getElementById('impTypeG_O_P_U').focus();
        } else if (e.target.value === 'W' || e.target.value === 'X' || e.target.value === 'w' || e.target.value === 'x') {
            setJobValues({ ...jobValues, type_H_W_x: e.target.value });
            if (jobValues.job_no === '') { setMessage('Please Select The Job Number'); setSeverity('warning'); setOpenSnack(true); }
            else { setJobTypeHWXOpen(true); JobTypegetWarehouseDetails(); document.getElementById('impTypeG_O_P_U').focus(); }
        } else if (e.target.value === '') { setJobValues({ ...jobValues, type_H_W_x: e.target.value }); }
    }

    const JobImpTypeGOPUChangeHandle = (e) => {
        if (e.target.value === 'G' || e.target.value === 'O' || e.target.value === 'P' || e.target.value === 'U' || e.target.value === '') {
            setJobValues({ ...jobValues, imp_type_G_O_p_U: e.target.value });
        }
    }

    const JobKachaChangeHandle = (e) => {
        if (e.target.value === 'Y' || e.target.value === 'N' || e.target.value === 'y' || e.target.value === 'n' || e.target.value === '') {
            setJobValues({ ...jobValues, kacha_y_N: e.target.value });
        }
    }
    const JobDifDefChangeHandle = (e) => {
        if (e.target.value === 'D' || e.target.value === 'F' || e.target.value === 'd' || e.target.value === 'f' || e.target.value === '') {
            setJobValues({ ...jobValues, dif_def: e.target.value });
        }
    }

    const JobGreenChnChangeHandle = (e) => {
        if (e.target.value === 'Y' || e.target.value === 'N' || e.target.value === 'y' || e.target.value === 'n' || e.target.value === '') {
            setJobValues({ ...jobValues, green_chn: e.target.value });
        }
    }

    const JobHssYNChangeHandle = (e) => {
        if (e.target.value === 'Y' || e.target.value === 'y') {
            setJobValues({ ...jobValues, hss_y_n: e.target.value }); document.getElementById('sec').focus();
            if (jobValues.job_no === '') {
                setMessage('Please Select The Job Number')
                setSeverity('warning')
                setOpenSnack(true)
            } else {
                JobHssDialogeOpen();
            }
        }
        else if (e.target.value === 'N' || e.target.value === 'n') {
            setJobValues({ ...jobValues, hss_y_n: e.target.value });
            document.getElementById('sec').focus();
        } else if (e.target.value === '') {
            setJobValues({ ...jobValues, hss_y_n: e.target.value });
        }
    }
    const JobSec_48ChangeHandle = (e) => {
        if (e.target.value === 'Y' || e.target.value === 'y') {
            setJobValues({ ...jobValues, sec_48_y_n: e.target.value }); document.getElementById('publicSec').focus();
            if (jobValues.job_no === '') {
                setMessage('Please Select The Job Number')
                setSeverity('warning')
                setOpenSnack(true)
            } else {
                JobSec_48_Openhandle();
            }
        }
        else if (e.target.value === 'N' || e.target.value === 'n') {
            setJobValues({ ...jobValues, sec_48_y_n: e.target.value });
            document.getElementById('publicSec').focus();
        } else if (e.target.value === '') {
            setJobValues({ ...jobValues, sec_48_y_n: e.target.value });
        }
    }
    const JobpublicSecChangeHandle = (e) => {
        if (e.target.value === 'Y' || e.target.value === 'y') {
            setJobValues({ ...jobValues, public_sec_y_n: e.target.value }); document.getElementById('1stcheack').focus();
        }
        else if (e.target.value === 'N' || e.target.value === 'n') {
            setJobValues({ ...jobValues, public_sec_y_n: e.target.value });
            document.getElementById('1stcheack').focus();
        } else if (e.target.value === '') {
            setJobValues({ ...jobValues, public_sec_y_n: e.target.value });
        }
    }
    const Job1stCheackChangeHandle = (e) => {
        if (e.target.value === 'Y' || e.target.value === 'y') {
            setJobValues({ ...jobValues, first_check_y_n: e.target.value }); document.getElementById('priorbe').focus();
            if (jobValues.job_no === '') {
                setMessage('Please Select The Job Number')
                setSeverity('warning')
                setOpenSnack(true)
            } else {
                Job1stCheackOpenhandle();
            }
        }
        else if (e.target.value === 'N' || e.target.value === 'n') {
            setJobValues({ ...jobValues, first_check_y_n: e.target.value });
            document.getElementById('priorbe').focus();
        } else if (e.target.value === '') {
            setJobValues({ ...jobValues, first_check_y_n: e.target.value });
        }
    }

    const JobPriorBeChangeHandle = (e) => {
        if (e.target.value === 'Y' || e.target.value === 'y') {
            document.getElementById('cmmrcialtax').focus();
            setJobValues({ ...jobValues, prior_be_y_n: e.target.value });
            if (jobValues.mode_A_L_S === 'A' || jobValues.mode_A_L_S === 'a') { setJobIgmhide(true); setJobInwardatehide(true); setJobGateWayhide(true); setJobRepPorthide(true); }
            else if (jobValues.mode_A_L_S === 'S' || jobValues.mode_A_L_S === 's') { setJobIgmhide(false); setJobInwardatehide(true); setJobGateWayhide(true); setJobRepPorthide(false); }
            else if (jobValues.mode_A_L_S === 'L' || jobValues.mode_A_L_S === 'l') { setJobIgmhide(true); setJobInwardatehide(true); setJobGateWayhide(false); setJobRepPorthide(false); }
        } else if (e.target.value === 'N' || e.target.value === 'n') {
            setJobValues({ ...jobValues, prior_be_y_n: e.target.value });
            if (jobValues.mode_A_L_S === 'A' || jobValues.mode_A_L_S === 'a') { setJobIgmhide(false); setJobInwardatehide(false); setJobGateWayhide(true); setJobRepPorthide(true); }
            else if (jobValues.mode_A_L_S === 'S' || jobValues.mode_A_L_S === 's') { setJobIgmhide(false); setJobInwardatehide(false); setJobGateWayhide(true); setJobRepPorthide(false); }
            else if (jobValues.mode_A_L_S === 'L' || jobValues.mode_A_L_S === 'l') { setJobIgmhide(false); setJobInwardatehide(false); setJobGateWayhide(false); setJobRepPorthide(false); }
        } if (e.target.value === 'A' || e.target.value === 'A') {
            document.getElementById('cmmrcialtax').focus();
            setJobValues({ ...jobValues, prior_be_y_n: e.target.value });
            if (jobValues.mode_A_L_S === 'A' || jobValues.mode_A_L_S === 'a') { setJobIgmhide(true); setJobInwardatehide(true); setJobGateWayhide(true); setJobRepPorthide(true); }
            else if (jobValues.mode_A_L_S === 'S' || jobValues.mode_A_L_S === 's') { setJobIgmhide(true); setJobInwardatehide(true); setJobGateWayhide(true); setJobRepPorthide(false); }
            else if (jobValues.mode_A_L_S === 'L' || jobValues.mode_A_L_S === 'l') { setJobIgmhide(true); setJobInwardatehide(true); setJobGateWayhide(false); setJobRepPorthide(false); }
        }  else if (e.target.value === '') { setJobValues({ ...jobValues, prior_be_y_n: e.target.value }); }
    }
    const JobCommercialtaxChangeHandle = (e) => {
        if (e.target.value === 'Y' || e.target.value === 'y') {
            setJobValues({ ...jobValues, commercial_tax_y_n: e.target.value }); document.getElementById('ucr').focus()
            if (jobValues.job_no === '') { setMessage('Please Select The Job Number'); setSeverity('warning'); setOpenSnack(true); }
            else { JobCommercialtxOpenHandle(); }
        }
        else if (e.target.value === 'N' || e.target.value === 'n' || e.target.value === '') {
            setJobValues({ ...jobValues, commercial_tax_y_n: e.target.value });
            if (e.target.value === 'N' || e.target.value === 'n') { document.getElementById('ucr').focus(); }
        }
    }

    const JobUcrChangeHandle = (e) => {
        setJobValues({ ...jobValues, ucr: e.target.value.replace(/[`~0-9!@#$%^&*()_|+{}=[?;:'",.<>]/gi, '') })
    }
    const JobUcrTypeChangeHandle = (e) => {
        setJobValues({ ...jobValues, ucr_type: e.target.value.replace(/[`~0-9!@#$%^&*()_|+{}=[?;:'",.<>]/gi, '') })
    }
    const JobPaymentmodeChangeHandle = (e) => {
        setJobValues({ ...jobValues, paymentMode_D_T: e.target.value.replace(/[`~0-9!@#$%^&*()_|+{}=[?;:'",.<>]/gi, '') })
    }
    const JobIgmNoChangeHandle = (e) => {
        setJobValues({ ...jobValues, igm_No: e.target.value.replace(/[`~!@#$%^&*()_|+{}=[?;:'",.<>]/gi, '') })
    }
    const JobMawbNoChangeHandle = (e) => {
        setJobValues({ ...jobValues, mawb_no: e.target.value.replace(/[`~!@#$%^&*()_|+{}=[?;:'",.<>]/gi, '') })
    }
    const JobHawbNoChangeHandle = (e) => {
        setJobValues({ ...jobValues, hawb_no: e.target.value.replace(/[`~!@#$%^&*()_|+{}=[?;:'",.<>]/gi, '') })
    }
    const JobNoOfPkgChangeHandle = (e) => {
        setJobValues({ ...jobValues, no_of_pkgs: e.target.value.replace(/[^0-9.]/ig, '') })
    }
    const JobGrossWtChangeHandle = (e) => {
        setJobValues({ ...jobValues, gross_wt: e.target.value.replace(/[^0-9.]/ig, '') })
    }
    const JobunitChangeHandle = (e) => {
        setJobValues({ ...jobValues, unit: e.target.value.replace(/[`~0-9!@#$%^&*()_|+{}=[?;:'",.<>]/gi, '') })
    }
    const JobInwaedateChangeHandle = (e) => {
        setJobValues({ ...jobValues, inWardDate: e.target.value })
    }

    const JobIgmdateChangeHandle = (e) => {
        setJobValues({ ...jobValues, igmDate: e.target.value })
    }
    const JobMawbDateChangeHandle = (e) => {
        setJobValues({ ...jobValues, mawbDate: e.target.value })
    }
    const JobHawbDateChangeHandle = (e) => {
        setJobValues({ ...jobValues, hawbDate: e.target.value })
    }
    const JobPkgCodeChangeHandle = (e) => {
        setJobValues({ ...jobValues, pkg_code: e.target.value.replace(/[`~0-9!@#$%^&*()_|+{}=[?;:'",.<>]/gi, '') })
    }
    const JobMarksNumsChangeHandle = (e) => {
        setJobValues({ ...jobValues, marks_and_number: e.target.value.replace(/[`~!@#$%^&*()_|+{}=[?;:'",.<>]/gi, '') })
    }

    const JobGatewaNoChangeHandle = (e) => {
        setJobValues({ ...jobValues, gatewayNo: e.target.value.replace(/[`~!@#$%^&*()_|+{}=[?;:'",.<>]/gi, '') })
    }
    const JobRepPortChangeHandle = (e) => {
        setJobValues({ ...jobValues, repPortCode: e.target.value.replace(/[`~!@#$%^&*()_|+{}=[?;:'",.<>]/gi, '') })
        if (jobValues.mode_A_L_S === '') {
            setMessage('Please Enter the Transite Type')
            setSeverity('warning');
            setOpenSnack(true);
        } else {
            var cusHouseCode = "";
            if (e.target.value !== '') {
                cusHouseCode = e.target.value;
            } else {
                cusHouseCode = "-1";
            }
            let details = {
                cusHouseCode: cusHouseCode, customHouseLocation: '-1', flag: 1,
                transitTypeId: jobValues.mode_A_L_S
            }
            JobServices.getCustomHouseCodeBasedOnTransitType(details).then(res => {
                const data = res.data;
                var locetion;
                if (e.target.value !== '') {
                    locetion = data.map((cus) => cus.customHouseLocation);
                } else {
                    locetion = '';
                }
                setJobValues({ ...jobValues, repPortCode: e.target.value.replace(/[`~!@#$%^&*()_|+{}=[?;:'",.<>]/gi, ''), repPortName: locetion })
            })
        }
    }
    const JobGateWayDateChangeHandle = (e) => {
        setJobValues({ ...jobValues, gateWayDate: e.target.value })
    }
    const jobDialogeReset = () => {
        setJobDialogValues({
            ...jobDialogValues, transit_name: "", transit_code: "", cusHousName: "", cusHousCode: "", branch: "", forwdr: "",
            importer_name: "", importer_code: "", importer_state: "", branch_sr_no: "", ad_code: '', f_countryOrginName: "", f_countryOriginCode: "",
            f_countryOfCm: "", f_countryOfCmCode: "", f_countryoriginPortName: "", f_countryOfOriginPortCode: "", f_port_ofName: "", f_port_Code: "",
            //-----certificate----
            certificateId: 0, certificate_No: '', certificate_Type: '', certificate_Date: '',
            //----container----
            containerId: 0, container_no: '', container_size: '', l_f_c: '', seal_no: '', truck_no: '',
            //---bond---
            bondNo: '', old_bondNo: '', bond_code: '', bond_port: '', bond_portName: '', bond_amount: '', bg_debited: '', bg_rate: '', bg_ammount: '',
            //----TypeHWX---
            typeH_w_xCode: '', typeH_w_xCustSiteId: '', typeH_w_xCustSiteName: '', typeH_w_xBeNo: '', typeH_w_xBeDate: '', typeH_w_xNoOfPkg: 0,
            typeH_w_xPkgCode: '', typeH_w_xPkgName: '', typeH_w_xGroos: 0, typeH_w_xUnitCode: '', typeH_w_xUnitName: '', typeH_w_xAnnexureNo: '',
            typeH_w_xAnnexureDate: '', typeH_w_xDFW: '', typeH_w_xLFE: '', typeH_w_xMLR: '', typeH_w_xECD: '',
            //-------hss -----------
            hss_iecCode: '', hss_oldiecCode: '', hss_iecName: '', hss_precedingLevel: '', hss_brnchSrNo: '', hss_brncSrName: '', hss_name: '', hss_address1: '',
            hss_address2: '', hss_city: '', hss_state: '', hss_pincode: '',
            //-----sec-48
            sec_PermissionId: '', sec_PermissionDesc: '', sec_PermissionCode: '',
            //commercial-Tax
            comrcial_StateCode: '', comrcial_CtxCode: '', comrcial_ctx_regNo: ''
        })
    }
    const JobReset = () => {
        setJobIgmDetails([])
        setJobIGMSaveDsab(false);
        setJobIGMUpdatedsab(true);
        setJobIGMDeleteDsab(true);

        setJobIGMSve(false);
        setJobIGMUpd(false);
        setJobIGmDlt(false);
        setJobValues({
            ...jobValues, chaCode: 'AGIPP8287CCH001', mode_A_L_S: "", model_A_L_S_Name: "", customHousCode: "", chs_name: "",
            branch: "DELHI OFFICE", forwarder: "", iec_search: "", name: "", branch_sr_no: "", address_1: "", addresh_2: "", city: "",
            state: "", pincode: "", ad_code: "", job_no: "", edi_job_no: "", countryOrigin: "", countryOriginName: "", countrt_of_cm: "",
            countrt_of_cmName: "", certificate_y_N: "N", bond_y_N: "N", port_of_loding: "", port_of_lodingName: "", container_detail: "N", class_g_p_n: "N",
            type_H_W_x: "H", imp_type_G_O_p_U: "P", kacha_y_N: "N", dif_def: "", green_chn: "N", hss_y_n: "N", sec_48_y_n: "N", public_sec_y_n: "N", first_check_y_n: "N", prior_be_y_n: "N",
            commercial_tax_y_n: "Y", ucr: "", ucr_type: "", paymentMode_D_T: "T",
            //-----igm
            igm_No: "", mawb_no: "", hawb_no: "", no_of_pkgs: "", gross_wt: "", unit: "KGS", inWardDate: '', igmDate: '', mawbDate: '', hawbDate: '', pkg_code: "PKG", marks_and_number: "As Per BL",
            gatewayNo: "", gateWayDate: '', repPortCode: "", repPortName: "",
            //Boe Updation
            be_no: '', be_date: '', be_response: '', be_reason: ''
        })
    }
    /*----------------------------------------------------------------------------------------------------------
        ----------------------------------------TabsInvoice----------------------------------------------
    ---------------------------------------------------------------------------------------------------------- */

    const [indexTablevalue, setindexTablevalue] = useState('')
    const [invoiceTabledetails, setinvoiceTabledetails] = useState([]);
    const [invoicedetails, setinvoicedetails] = useState([]);
    const [invoicedetails2, setinvoicedetails2] = useState([]);
    const [invoiceCountryntDrp, setinvoiceCountryntDrp] = useState([]);
    const [invoicevalues, setinvoiceValues] = useState({
        // .............
        InvoiceId: '', svbId: '', thirdPartyId: '', sellerId: '', brokerId: '', discountId: '', miscId: '', invoiceindex: '',
        // ........///
        invoiceNo: '', invoiceDate: '', invoiceValue: '', Currency: '', ExchangeRate: '', Terms: '', SupplierName: '', Address1: '', Address2: '', SupplierCountry: '',
        disable_supcountry_Name: '', Address3: '', PinCode: '', SVBLoading: "N", SVBDescription: '', Thirdparty: "N", Seller: "N", Broker: "N", RelationBetweenBuyerSeller: "N",
        NatureOfTransaction: 'O', disable_NatureofTransaction_Name: 'Others', TermOfPayment: 'OTH', disable_Termsofpayment: 'Others', ConditionsOfRestrictionSale: "N",
        ValuationMethod: 'RULE4', disable_valuationmethod: 'Transcation Value', DiscountChargesIncludedInThisInvoice: "N", CummulativeCharges: "N", AreThereMiscChargesNotSpecifiedInThisInvoice: "N", PurchaseOrderDetailsNo: '',
        PurchaseOrderDetailsDate: '', ContractDetailsNo: '', ContractDetailsDate: '', LetterOfCreditDetailsNo: '', LetterOfCreditDetailsDate: '', AEOCode: '',
        AEORole: '', AEOCountry: '', disable_AeocountryName: '', LoadNo: '', Condition1: '', Condition2: '', OtherInformation: '',
    })
    // .......................................Dialog inputs..........

    const [dialoginvoicevalues, setdialoginvoicevalues] = useState({
        FindCurrencyName: '', FindCurrencyCode: '', FindTermsName: '', FindTermsCode: '', FindSupplierName: '', FindCountryName: '', FindCountryCode: '', FindTransactionName: '', FindTransactionCode: '',
        FindPaymentTermsName: '', FindPaymentTermsCode: '', ValuationFindPaymentTermsName: '', ValuationFindPaymentTermsCode: '', AeoFindCountryName: '', AeoFindCountryCode: '',
        // .....................................key_event_onchangecode....................
        SVBReferenceNo: '', SVBDate: '', CustomHouseCode: '', SVBType: 'B', SVB_Load_Assable_Value_percentage: '0.00',
        SVB_Load_Duty_Percentage: '0.00', Av_is_Final_or_Provisional: 'N', Duty_is_Final_or_Provisional: 'N', FindCusHouseName: '', FindCusHouseCode: '', ThirdPartyName: '',
        ThirdPartyCountry: '', ThirdPartyAddress: '', ThirdPartyCity: '', ThirdPartyPincode: '', ThirdPartyDivision: '', FindSupplierNameDialog: '', SellerName: '', SellerCountry: '',
        SellerAddress: '', SellerCity: '', SellerPincode: '', SellerDivision: '', BrokerName: '', BrokerCountry: '', BrokerAddress: '', BrokerCity: '', BrokerPincode: '',
        BrokerDivision: '', NatureofDiscount: '', DiscountRate: '', DiscountAmount: '', MiscCodeType: '', MiscDescription: '', MiscRate: '', MiscAmmount: '',
    })
    // .............................................ratio button for invoiceterms.......................................
    const [BifrctionStsValues, setBifrctionStsValues] = useState({
        FreightCHARGES: '0.00', FreightCURRENCY: '', FreightEXCHANGE: '', FreightRATE: '0.0000', InsuranceCHARGES: '0.00', InsuranceCURRENCY: '', InsuranceEXCHANGE: '', InsuranceRATE: '0.0000',
        AgencyComCHARGES: '0.00', AgencyComCURRENCY: '', AgencyComEXCHANGE: '', AgencyComRATE: '0.0000', LoadingCHARGES: '0.00', LoadingCURRENCY: '', LoadingEXCHANGE: '', LoadingRATE: '0.0000',
        MiscValuesCHARGES: '0.00', MiscValuesCURRENCY: '', MiscValuesEXCHANGE: '', MiscValuesRATE: '0.0000', HSSValuesCHARGES: '0.00', HSSValuesRATE: '0.0000', LandingRATE: '0.0000',
        // ........autobrification.....///
        FreightDetailsCHARGES: '0', FreightDetailsCURRENCY: '', FreightDetailsExchange: '', FreightDetailsRATE: '0', InsuranceDetailsCHARGES: '0', InsuranceDetailsCURRENCY: '',
        InsuranceDetailsExchange: '', InsuranceDetailsRATE: '0', AgencyCommCHARGES: '0', AgencyCommCURRENCY: '', AgencycommDetailsExchange: '', AgencyCommRATE: '0', MiscDetailsCHARGES: '0',
        MiscDetailsCURRENCY: '', MiscDetailsEXCHANGE: '', MiscDetailsRATE: '0',
    })
    // ............................hiden setup..................///
    const [invoiceradiovalues, setinvoiceradiovalues] = useState('2') //radio
    const [Addterms, setAddterms] = useState(true)//title chng
    const [invc_showADDterms, setinvc_showADDterms] = useState(false)// table chng
    const [invoiceSvb_AV_Hidn, setinvoiceSvb_AV_Hidn] = useState(false)
    const [invoiceSvb_duty_Hidn, setinvoiceSvb_duty_Hidn] = useState(false)
    // .......hidden manual_radio.....
    const [hideinvoiceFright, sethideinvoiceFright] = useState(false)
    const [hideInsurance, sethideInsurance] = useState(false)
    const [hideAgencyCom, sethideAgencyCom] = useState(false)
    const [hideLoading, sethideLoading] = useState(false)
    const [hideMiscValues, sethideMiscValues] = useState(false)
    const [hideHssValues, sethideHssValues] = useState(false)
    const [hideLanding, sethideLanding] = useState(false)
    // /........hidden bifurcation_radio...
    const [hiddenbifur_frieght, sethiddenbifur_frieght] = useState(false)
    const [hiddenbifur_insurance, sethiddenbifur_insurance] = useState(false)
    const [hiddenbifur_misc, sethiddenbifur_misc] = useState(false)
    const [hiddenbifur_agencycomn, sethiddenbifur_agencycomn] = useState(false)
    // save--Disabel boolen
    const [InvoiceSaveDsa, setInvoiceSaveDsa] = useState(false);
    const [InvoiceUpdateDsa, setInvoiceUpdateDsa] = useState(true);
    const [InvoiceDeleteDsa, setInvoiceDeleteDsa] = useState(true);
    const [InvoiceProcsSve, setInvoiceProcsSve] = useState(false);
    const [InvoiceProcsUpd, setInvoiceProcsUpd] = useState(false);
    const [InvoiceProcsDlt, setInvoiceProcsDlt] = useState(false);
    /////invoiceTbl butons disable
    const [InvoiceSaveTableDsa, setInvoiceSaveTableDsa] = useState(false);
    const [InvoiceUpdateTableDsa, setInvoiceUpdateTableDsa] = useState(true);
    const [InvoiceDeleteTableDsa, setInvoiceDeleteTableDsa] = useState(true);
    const [invoiceDublicateTableDsa, setinvoiceDublicateTableDsa] = useState(true);

    const [InvoiceProcsTableSve, setInvoiceProcsTableSve] = useState(false);
    const [InvoiceProcsTableUpd, setInvoiceProcsTableUpd] = useState(false);
    const [InvoiceProcsTableDlt, setInvoiceProcsTableDlt] = useState(false);
    const [InvoiceProcsTableDubli, setInvoiceProcsTableDubli] = useState(false);

    // ......................................dailogcode....................................
    const [InvoiceCurrencyopen, setInvoiceCurruncyOpen] = useState(false);
    const [InvoiceTermsopen, setInvoiceTermsOpen] = useState(false);
    const [InvoiceSuplierNameopen, setInvoiceSuplierNameopen] = useState(false);
    const [InvoiceSupplierCountryopen, setInvoiceSuplierCountryopen] = useState(false);
    const [InvoiceNatureOfTransactionopen, setInvoiceNatureOfTransactionopen] = useState(false);
    const [InvoiceTermOfPaymentChangeopen, setInvoiceTermOfPaymentChangeopen] = useState(false);
    const [InvoiceValuationMethodopen, setInvoiceValuationMethodopen] = useState(false);
    const [InvoiceAEOCountryopen, setInvoiceAEOCountryopen] = useState(false);
    const [InvoiceCustomHouseCodeopen, setInvoiceCustomHouseCodeopen] = useState(false);
    const [InvoiceThirdPartyNameopen, setInvoiceThirdPartyNameopen] = useState(false);
    const [invoiceBulkUploadOpen, setinvoiceBulkUploadOpen] = useState(false);
    const [invoiceBulkUploadErrorOpen, setinvoiceBulkUploadErrorOpen] = useState(false);
    // ......................................Dialogcode....................................
    const InvoiceCurrencyhandleClickOpen = () => {
        setInvoiceCurruncyOpen(true); document.getElementById('invoiceterms').focus();
        setdialoginvoicevalues({ ...dialoginvoicevalues, FindCurrencyCode: invoicevalues.Currency })
        setinvoicedetails([])
        var currency_code = '';
        if (invoicevalues.Currency !== '') {
            currency_code = invoicevalues.Currency;
        }
        else {
            currency_code = '-1';
        }
        let details = { currency_code: currency_code, currencyPrefix: '-1', flag: 1 }
        InvoiceService.getCurrency(details).then(res => {
            setinvoicedetails(res.data);
        })
    };
    const InvoiceCurrencyhandleClose = () => {
        setInvoiceCurruncyOpen(false); document.getElementById('invoiceterms').focus();
        setdialoginvoicevalues({ ...dialoginvoicevalues, FindCurrencyName: '', FindCurrencyCode: '' })
        setinvoicedetails([]);
    };
    ///
    const InvoiceTermshandleClickOpen = () => {
        setdialoginvoicevalues({ ...dialoginvoicevalues, FindTermsCode: invoicevalues.Terms })
        setInvoiceTermsOpen(true);
        setinvoicedetails([])
        var InvoiceTermscode = '';
        if (invoicevalues.Terms !== '') {
            InvoiceTermscode = invoicevalues.Terms
        }
        else {
            InvoiceTermscode = '-1'
        }
        let details = { terms_code: InvoiceTermscode, terms_Name: '-1', flag: 2 }
        InvoiceService.getInvoiceTerms(details).then(res => {
            setinvoicedetails(res.data);
        })
    };
    const InvoiceTermshandleClose = () => {
        setdialoginvoicevalues({ ...dialoginvoicevalues, FindTermsName: '' })
        setInvoiceTermsOpen(false); document.getElementById('invoiceterms').focus();
        setinvoicedetails([]);
    };
    const InvoiceSupplierNamehandleClickOpen = () => {
        document.getElementById('invoicesup_ad1').focus();
        setdialoginvoicevalues({ ...dialoginvoicevalues, FindSupplierName: invoicevalues.SupplierName })
        setInvoiceSuplierNameopen(true);
        setinvoicedetails([])
        var supplierName = '';
        if (invoicevalues.SupplierName !== '') {
            supplierName = invoicevalues.SupplierName
        }
        else {
            supplierName = '-1';
        }
        let details = { supplierName: supplierName, flag: 2 }
        InvoiceService.getSupplierDetails(details).then(res => {
            setinvoicedetails(res.data);
        })
    };
    const InvoiceSupplierNamehandlehandleClose = () => {
        setInvoiceSuplierNameopen(false); document.getElementById('invoicesup_ad1').focus();
        setinvoicedetails([]);
    };
    const InvoiceSupplierCountryhandleClickOpen = () => {
        setdialoginvoicevalues({ ...dialoginvoicevalues, FindCountryCode: invoicevalues.SupplierCountry }); document.getElementById('invoicesup_ad3').focus();
        setInvoiceSuplierCountryopen(true);
        setinvoicedetails([])
        var countryId = '';
        if (invoicevalues.SupplierCountry !== '') {
            countryId = invoicevalues.SupplierCountry
        }
        else {
            countryId = '-1';
        }
        let details = { countryIdString: countryId, countryName: '-1', flag: 2 }
        JobServices.getCountryName(details).then(res => {
            setinvoicedetails(res.data);
        })
    };

    const InvoiceSupplierCountryhandleClose = () => {
        setInvoiceSuplierCountryopen(false); document.getElementById('invoicesup_ad3').focus();
        setdialoginvoicevalues({ ...dialoginvoicevalues, FindCountryName: '' });
        setinvoicedetails([])
    };
    const InvoiceNatureOfTransactionhandleClickOpen = () => {
        setInvoiceNatureOfTransactionopen(true); document.getElementById('invoiceTermsOfPayment').focus();
        setdialoginvoicevalues({ ...dialoginvoicevalues, FindTransactionCode: invoicevalues.NatureOfTransaction })
        setinvoicedetails([])
        var NatureofTrans = '';
        if (invoicevalues.NatureOfTransaction !== '') {
            NatureofTrans = invoicevalues.NatureOfTransaction
        }
        else {
            NatureofTrans = '-1';
        }
        let details = { transactionCode: NatureofTrans, transactionName: '-1', flag: 2 }
        InvoiceService.getTransactionMode(details).then(res => {
            setinvoicedetails(res.data);
        })
    };

    const InvoiceNatureOfTransactionhandleClose = () => {
        setInvoiceNatureOfTransactionopen(false); document.getElementById('invoiceTermsOfPayment').focus();
        setdialoginvoicevalues({ ...dialoginvoicevalues, FindTransactionName: '', FindTransactionCode: '' })
        setinvoicedetails([]);
    };
    const InvoiceTermOfPaymentChangehandleClickOpen = () => {
        setdialoginvoicevalues({ ...dialoginvoicevalues, FindPaymentTermsCode: invoicevalues.TermOfPayment }); document.getElementById('invoiceCond_OfRestrictionSale').focus();
        setInvoiceTermOfPaymentChangeopen(true);
        setinvoicedetails([])
        var Termspayment = '';
        if (invoicevalues.TermOfPayment !== '') {
            Termspayment = invoicevalues.TermOfPayment;
        }
        else {
            Termspayment = '-1';
        }
        let details = { paymentTermsCode: Termspayment, paymentTermsName: '-1', flag: 2 }
        InvoiceService.getpaymentTerms(details).then(res => {
            setinvoicedetails(res.data);
        })
    };
    const InvoiceTermOfPaymentChangehandleClose = () => {
        setInvoiceTermOfPaymentChangeopen(false); document.getElementById('invoiceCond_OfRestrictionSale').focus();
        setdialoginvoicevalues({ ...dialoginvoicevalues, FindPaymentTermsName: '' })
        setinvoicedetails([]);
    };
    const InvoiceValuationMethodClickOpen = () => {
        setdialoginvoicevalues({ ...dialoginvoicevalues, ValuationFindPaymentTermsCode: invoicevalues.ValuationMethod })
        setInvoiceValuationMethodopen(true);
        setinvoicedetails([])
        var Valuationmethod = '';
        if (invoicevalues.ValuationMethod !== '') {
            Valuationmethod = invoicevalues.ValuationMethod;
        }
        else {
            Valuationmethod = '-1';
        }
        let details = { valuationMethodCode: Valuationmethod, valuationMethodName: '-1', flag: 2 }
        InvoiceService.getValuationMethod(details).then(res => {
            setinvoicedetails(res.data);
        })
    };
    const InvoiceValuationMethodhandleClose = () => {
        setInvoiceValuationMethodopen(false);
        setdialoginvoicevalues({ ...dialoginvoicevalues, ValuationFindPaymentTermsName: '' })
        setinvoicedetails([]);
    };
    const InvoiceAEOCountryhandleClickOpen = () => {
        setdialoginvoicevalues({ ...dialoginvoicevalues, AeoFindCountryCode: invoicevalues.AEOCountry })
        setInvoiceAEOCountryopen(true);
        setinvoicedetails([])
        var Aeocountrycode = '';
        if (invoicevalues.AEOCountry === '' || !invoicevalues.AEOCountry) {
            Aeocountrycode = '-1'
        }
        else {
            Aeocountrycode = invoicevalues.AEOCountry;
        }
        let details = { countryIdString: Aeocountrycode, countryName: '-1', flag: 2 }
        JobServices.getCountryName(details).then(res => {
            setinvoicedetails(res.data);
        })
    };

    const InvoiceAEOCountryhandleClose = () => {
        setInvoiceAEOCountryopen(false);
        setdialoginvoicevalues({ ...dialoginvoicevalues, AeoFindCountryName: '' })
        setinvoicedetails([]);
    };
    const InvoiceCustomHouseCodehandleClickOpen = () => {
        setdialoginvoicevalues({ ...dialoginvoicevalues, FindCusHouseCode: dialoginvoicevalues.CustomHouseCode })
        setInvoiceCustomHouseCodeopen(true);
        setinvoicedetails2([]);
        var customhousecode = '';
        if (dialoginvoicevalues.CustomHouseCode !== '') {
            customhousecode = dialoginvoicevalues.CustomHouseCode
        }
        else {
            customhousecode = '-1';
        }
        let details = { cusHouseCode: customhousecode, customHouseLocation: '-1', flag: '2' }
        JobServices.getCustomHouseCode(details).then(res => {
            setinvoicedetails2(res.data);
        })
    }
    const InvoiceCustomHouseCodehandleClose = () => {
        setInvoiceCustomHouseCodeopen(false);
        setdialoginvoicevalues({ ...dialoginvoicevalues, FindCusHouseName: '' })
        setinvoicedetails2([]);
    };

    const InvoiceThirdPartyNameClickOpen = () => {
        setdialoginvoicevalues({ ...dialoginvoicevalues, FindSupplierNameDialog: dialoginvoicevalues.ThirdPartyName })
        setInvoiceThirdPartyNameopen(true);
        setinvoicedetails2([])
        var Thirdpartname = '';
        if (dialoginvoicevalues.ThirdPartyName !== '') {
            Thirdpartname = dialoginvoicevalues.ThirdPartyName
        }
        else {
            Thirdpartname = '-1';
        }
        let details = { supplierName: Thirdpartname, flag: '2' }
        InvoiceService.getSupplierDetails(details).then(res => {
            setinvoicedetails2(res.data);
        })
    };
    const InvoiceThirdPartyNamehandleClose = () => {
        setInvoiceThirdPartyNameopen(false);
        setinvoicedetails2([]);
    };
    ///////Bull_upload Invoice
    const invoiceBulkUploadclose = () => {
        setinvoiceBulkUploadOpen(false)
    };
    const invoiceBulkUploadhandleOpen = () => {
        setinvoiceBulkUploadOpen(true);
    }
    const invoice_Dwnld_temp = () => {
        saveAs(process.env.PUBLIC_URL + '/DownlodsFile/ImportInvoice.xlsx', 'ImportInvoice.xlsx')
    }
    const InvoiceErrorFilesClose = () => {
        setinvoiceBulkUploadErrorOpen(false)
    }
    const InvoiceErrorFilesOpen = () => {
        setinvoiceBulkUploadErrorOpen(true)
        InvoiceService.getInvoiceErrorList(jobValues.job_no).then(res => {
            invoicedetails(res.data)
        })

    }
    const invoice_excelUploadFile = () => {
        if (jobValues.job_no === '' || !jobValues.job_no) {
            setMessage("Please Select a Job.No from Job Table");
            setSeverity('warning');
            setOpenSnack(true);
            setExcelUpload(false);
        }
        else {
            setExcelUpload(true);
        }
    }
    const invoiceselectFile = (event) => {
        let currentFile = event.target.files[0]
        setCurrentFile(currentFile);
        InvoiceService.excelDataUpload(jobValues.job_no, currentFile).then((response) => {
            event.target.value = null;
            setMessage(response.data.message);
            setSeverity('success');
            setOpenSnack(true);
            setCurrentFile(undefined);
            InvoiceTableget();
        }).catch((error) => {
            setCurrentFile(undefined);
            InvoiceTableget();
            setMessage(error.message);
            setSeverity('error');
            setOpenSnack(true);
            event.target.value = null;
        });
        setinvoiceBulkUploadOpen(false)
        event.target.value = null;
    }
    const invoiceBulkrefresh = () => {
        setCurrentFile(undefined)
    }

    // ......................................onKeyUpDialogcode....................................
    const [invoicetermsdialogopen, setinvoicetermsdialogopen] = useState(false); //terms radio dialog box
    const [InvoiceSvbLoadingopen, setInvoiceSvbLoadingopen] = useState(false);
    const [InvoiceThirdPartyopen, setInvoiceThirdPartyopen] = useState(false);
    const [InvoiceSelleropen, setInvoiceSelleropen] = useState(false);
    const [InvoiceBrokeropen, setInvoiceBrokeropen] = useState(false);
    const [InvoiceAddDiscountDetailsopen, setInvoiceAddDiscountDetailsopen] = useState(false);
    const [InvoiceAddMiscDetailsopen, setInvoiceAddMiscDetailsopen] = useState(false);

    // ......................................onKeyUpDialogcode....................................

    const invoicetermskeyhandleopen = () => {
        setinvoicetermsdialogopen(true);
        let details = { currency_code: '-1', currencyPrefix: '-1', flag: 1 }; document.getElementById('invoicesup_name').focus();
        InvoiceService.getCurrency(details).then(res => {
            setinvoicedetails(res.data);
        })
    }
    const inovicetermskeyhandleClose = () => {
        //termsdialogbox
        if (TermsValidation() === true) {
            setinvoicetermsdialogopen(false); document.getElementById('invoicesup_name').focus();
        }
    }
    const InvoiceSvbLoadingkeyhandleopen = () => {
        if (invoicevalues.InvoiceId !== '') {
            setInvoiceSvbLoadingopen(true);
            InvoiceService.getSvb(invoicevalues.InvoiceId).then(res => {
                setinvoicedetails(res.data);
            })
        }
        else {
            setMessage('Please Select The Invoice Number')
            setSeverity('warning')
            setOpenSnack(true)
        }
    }
    const InvoiceSvbLoadingkeyhandleClose = () => {
        setInvoiceSvbLoadingopen(false);
        setinvoicedetails([]);
        InvoiceSvbReset();
        setdialoginvoicevalues({
            ...dialoginvoicevalues, SVBReferenceNo: '', SVBDate: '', CustomHouseCode: '',
            SVBType: 'B', SVB_Load_Assable_Value_percentage: '0.00', SVB_Load_Duty_Percentage: '0.00', Av_is_Final_or_Provisional: 'N',
            Duty_is_Final_or_Provisional: 'N'
        });
    };
    const InvoiceThirdPartyhandleopen = () => {
        if (invoicevalues.InvoiceId !== '') {
            setInvoiceThirdPartyopen(true); document.getElementById('invoiceSeller').focus();
            let details = { countryIdString: '-1', countryName: '-1', flag: 1 }
            JobServices.getCountryName(details).then(res => {
                setinvoiceCountryntDrp(res.data);
            })
            let details2 = { invoiceId: invoicevalues.InvoiceId }
            InvoiceService.getThirdparty(details2).then(res => {
                setinvoicedetails(res.data)
            })
        }
        else {
            setMessage('Please Select The Invoice Number')
            setSeverity('warning')
            setOpenSnack(true)
        }
    };
    const InvoiceThirdPartyhandleClose = () => {
        setInvoiceThirdPartyopen(false); document.getElementById('invoiceSeller').focus();
        setinvoicedetails([]);
        InvoiceThirdPartyReset();
        setdialoginvoicevalues({
            ...dialoginvoicevalues, ThirdPartyName: '', ThirdPartyCountry: '',
            ThirdPartyAddress: '', ThirdPartyCity: '', ThirdPartyPincode: '', ThirdPartyDivision: ''
        });
    };
    const InvoiceSellerhandleopen = () => {
        if (invoicevalues.InvoiceId !== '') {
            setInvoiceSelleropen(true); document.getElementById('invoicebroker').focus();
            let details = { countryIdString: '-1', countryName: '-1', flag: 1 }
            JobServices.getCountryName(details).then(res => {
                setinvoiceCountryntDrp(res.data);
            })
            InvoiceService.getSeller(invoicevalues.InvoiceId).then(res => {
                setinvoicedetails(res.data);
            })
        }
        else {
            setMessage('Please Select The Invoice Number')
            setSeverity('warning')
            setOpenSnack(true)
        }
    };
    const InvoiceSellerhandleClose = () => {
        setInvoiceSelleropen(false); document.getElementById('invoicebroker').focus();
        setinvoiceCountryntDrp([]);
        setdialoginvoicevalues({
            ...dialoginvoicevalues, SellerName: '', SellerCountry: '', SellerAddress: '',
            SellerCity: '', SellerPincode: '', SellerDivision: ''
        })
        setinvoicedetails([])
    };
    const InvoiceBrokerhandleopen = () => {
        if (invoicevalues.InvoiceId !== '') {
            setInvoiceBrokeropen(true); document.getElementById('invoicerela_bw_bs').focus();
            let details = { countryIdString: '-1', countryName: '-1', flag: 1 }
            JobServices.getCountryName(details).then(res => {
                setinvoiceCountryntDrp(res.data);
            })
            InvoiceService.getBroker(invoicevalues.InvoiceId).then(res => {
                setinvoicedetails(res.data);
            })
        }
        else {
            setMessage('Please Select The Invoice Number')
            setSeverity('warning')
            setOpenSnack(true)
        }
    };
    const InvoiceBrokerhandleClose = () => {
        setInvoiceBrokeropen(false); document.getElementById('invoicerela_bw_bs').focus();
        setinvoiceCountryntDrp([]);
        setdialoginvoicevalues({
            ...dialoginvoicevalues, BrokerName: '', BrokerCountry: '', BrokerAddress: '',
            BrokerCity: '', BrokerPincode: '', BrokerDivision: ''
        })
        setinvoicedetails([])
    };
    const InvoiceAddDiscountDetailshandleopen = () => {
        if (invoicevalues.InvoiceId !== '') {
            setInvoiceAddDiscountDetailsopen(true); document.getElementById('invoiceCummulativeCharges').focus();
            InvoiceService.getDiscount(invoicevalues.InvoiceId).then(res => {
                setinvoicedetails(res.data);
            })
        }
        else {
            setMessage('Please Select The Invoice Number')
            setSeverity('warning')
            setOpenSnack(true)
        }
    };
    const InvoiceAddDiscountDetailshandleClose = () => {
        setInvoiceAddDiscountDetailsopen(false); document.getElementById('invoiceCummulativeCharges').focus();
        setinvoicedetails([]);
        setdialoginvoicevalues({ dialoginvoicevalues, NatureofDiscount: '', DiscountRate: '', DiscountAmount: '' })

    };
    const InvoiceAddMiscDetailshandleopen = () => {
        if (invoicevalues.InvoiceId !== '') {
            setInvoiceAddMiscDetailsopen(true); document.getElementById('invoiceaeocode').focus();
            InvoiceService.getMisc(invoicevalues.InvoiceId).then(res => {
                setinvoicedetails(res.data);
            })
        }
        else {
            setMessage('Please Select The Invoice Number')
            setSeverity('warning')
            setOpenSnack(true)
        }
    };
    const InvoiceAddMiscDetailshandleClose = () => {
        setInvoiceAddMiscDetailsopen(false); document.getElementById('invoiceaeocode').focus();
        setinvoicedetails([]);
        setdialoginvoicevalues({ ...dialoginvoicevalues, MiscCodeType: '', MiscDescription: '', MiscRate: '', MiscAmmount: '' })
    };
    // ..............methods.....
    const calculateAutoBifurcateFrgInsValue = () => {
        let details = { consignmentId: jobValues.job_no }
        InvoiceService.calculateAutoBifurcateFrgInsValue(details).then(res => {
            const message = res.data.message;
            if (message.toString() === 'SUCCESS') {
                setMessage('Inserted Successfully')
                setSeverity('success')
                setOpenSnack(true);
            }
            else {
                setMessage(message.toString());
                setSeverity('Auto Bifurcation Insertion Failed');
                setOpenSnack(true);
            }
        })
    }

    // ...............invoice table get..//
    const InvoiceTableget = () => {
        let details = { consignmentId: jobValues.job_no, flag: 1 }
        InvoiceService.getCommercialInvoice(details).then(res => {
            setinvoiceTabledetails(res.data)
        })
    }
    //.............AutoBifrication Get..//
    const getAutoBifurcateValue = () => {
        let details = { consignmentId: jobValues.job_no }
        InvoiceService.getAutoBifurcateValue(details).then(res => {
            const data = res.data;
            const asgnAutoBifr_Vl = data.map((trns) => trns)
            setBifrctionStsValues({
                ...BifrctionStsValues, FreightDetailsCHARGES: asgnAutoBifr_Vl[0].freightValue, FreightDetailsCURRENCY: asgnAutoBifr_Vl[0].freightCurrency,
                FreightDetailsExchange: asgnAutoBifr_Vl[0].frtExchangeRate, FreightDetailsRATE: asgnAutoBifr_Vl[0].freightRate, InsuranceDetailsCHARGES: asgnAutoBifr_Vl[0].insuranceValue,
                InsuranceDetailsCURRENCY: asgnAutoBifr_Vl[0].insuranceCurrency, InsuranceDetailsExchange: asgnAutoBifr_Vl[0].insExchangeRate, InsuranceDetailsRATE: asgnAutoBifr_Vl[0].insuranceRate,
                MiscDetailsCHARGES: asgnAutoBifr_Vl[0].miscValue, MiscDetailsCURRENCY: asgnAutoBifr_Vl[0].miscCurrency, MiscDetailsEXCHANGE: asgnAutoBifr_Vl[0].miscExchangeRate,
                MiscDetailsRATE: asgnAutoBifr_Vl[0].miscRate, AgencyCommCHARGES: asgnAutoBifr_Vl[0].agencyValue, AgencyCommCURRENCY: asgnAutoBifr_Vl[0].agencyCurrency,
                AgencycommDetailsExchange: asgnAutoBifr_Vl[0].agencyExchange, AgencyCommRATE: asgnAutoBifr_Vl[0].agencyRate,
            })
        })
    }
    // ...............terms Validation...........
    const TermsValidation = (e) => {
        if (invoiceradiovalues === '2') {
            if (invoicevalues.Terms === 'FOB' || invoicevalues.Terms === 'fob') {
                if (BifrctionStsValues.FreightCHARGES !== '0.00' || BifrctionStsValues.FreightCHARGES !== '0') {
                    if (BifrctionStsValues.FreightCURRENCY !== '') {
                        if (BifrctionStsValues.FreightEXCHANGE) {
                            if (BifrctionStsValues.InsuranceCHARGES !== '0.00' || BifrctionStsValues.InsuranceCHARGES !== '0') {
                                if (BifrctionStsValues.InsuranceCURRENCY !== '') {
                                    if (BifrctionStsValues.InsuranceEXCHANGE !== '') {
                                        return true
                                    } else {
                                        setMessage('Insurance Exchange Rate should not be empty')
                                        setSeverity('warning')
                                        setOpenSnack(true);
                                    }

                                } else {
                                    setMessage('Insurance Currency should not be empty')
                                    setSeverity('warning')
                                    setOpenSnack(true);
                                }

                            } else {
                                setMessage('Insurance Value should not be empty')
                                setSeverity('warning')
                                setOpenSnack(true);
                            }

                        } else {
                            setMessage('Freight Exchange Rate should not be empty')
                            setSeverity('warning')
                            setOpenSnack(true);
                        }

                    } else {
                        setMessage('Freight Currency should not be empty')
                        setSeverity('warning')
                        setOpenSnack(true);
                    }
                } else {
                    setMessage('Freight Value should not be empty')
                    setSeverity('warning')
                    setOpenSnack(true);
                }
            }
            else if (invoicevalues.Terms === 'ci' || invoicevalues.Terms === 'CI') {
                if (BifrctionStsValues.FreightCHARGES !== '0.00' || BifrctionStsValues.FreightCHARGES !== '0') {
                    if (BifrctionStsValues.FreightCURRENCY !== '') {
                        if (BifrctionStsValues.FreightEXCHANGE !== '') {
                            return (true)
                        } else {
                            setMessage('Freight Exchange Rate should not be empty')
                            setSeverity('warning')
                            setOpenSnack(true);
                        }

                    } else {
                        setMessage('Freight Currency should not be empty')
                        setSeverity('warning')
                        setOpenSnack(true);
                    }
                } else {
                    setMessage('Freight Value should not be empty')
                    setSeverity('warning')
                    setOpenSnack(true);
                }
            }
            else if (invoicevalues.Terms === 'cf' || invoicevalues.Terms === 'CF') {
                if (BifrctionStsValues.InsuranceCHARGES !== '0.00' || BifrctionStsValues.InsuranceCHARGES !== '0') {
                    if (BifrctionStsValues.InsuranceCURRENCY !== '') {
                        if (BifrctionStsValues.InsuranceEXCHANGE !== '') {
                            return (true)
                        } else {
                            setMessage('Insurance Exchange Rate should not be empty')
                            setSeverity('warning')
                            setOpenSnack(true);
                        }

                    } else {
                        setMessage('Insurance Currency should not be empty')
                        setSeverity('warning')
                        setOpenSnack(true);
                    }

                } else {
                    setMessage('Insurance Value should not be empty')
                    setSeverity('warning')
                    setOpenSnack(true);
                }
            }
            else {
                return (true)
            }
            return (false)
        }
        else if (invoiceradiovalues === '1') {
            return true
        }
    }
    //--------------------------------Buttons-operations-------------------------------------------

    const invoiceValidetion = () => {
        if (invoicevalues.invoiceDate !== '') {

            if (invoicevalues.invoiceValue !== '') {

                if (invoicevalues.Currency !== '') {

                    if (invoicevalues.ExchangeRate !== '') {

                        if (invoicevalues.Terms !== '') {

                            if (invoicevalues.SupplierName !== '') {

                                if (invoicevalues.Address1 !== '') {

                                    if (invoicevalues.disable_supcountry_Name !== '') {

                                        if (invoicevalues.NatureOfTransaction !== '') {

                                            if (invoicevalues.TermOfPayment !== '') {

                                                if (invoicevalues.ValuationMethod !== '') {
                                                    return true;
                                                } else {
                                                    setMessage('Please Enter The Valuation Method', 'Warning ..!!');
                                                    setSeverity('warning');
                                                    setOpenSnack(true);
                                                    document.getElementById('invoiceValuationMethod').focus();
                                                }
                                            } else {
                                                setMessage('Please Enter The Terms of Payment', 'Warning ..!!');
                                                setSeverity('warning');
                                                setOpenSnack(true);
                                                document.getElementById('invoiceTermsOfPayment').focus();

                                            }
                                        } else {
                                            setMessage('Please Enter The Nature of Transaction', 'Warning ..!!');
                                            setSeverity('warning');
                                            setOpenSnack(true);
                                            document.getElementById('invoiceNatureOfTransaction').focus();

                                        }
                                    } else {
                                        setMessage('Please Enter The Supplier Country', 'Warning ..!!');
                                        setSeverity('warning');
                                        setOpenSnack(true);
                                        document.getElementById('invoicesup_cntry').focus();
                                    }
                                } else {
                                    setMessage('Please Enter the Supplier Address1', 'Warning ..!!');
                                    setSeverity('warning');
                                    setOpenSnack(true);
                                    document.getElementById('invoicesup_ad1').focus();
                                }
                            } else {
                                setMessage('Please Enter The Supplier Name', 'Warning ..!!');
                                setSeverity('warning');
                                setOpenSnack(true);
                                document.getElementById('invoicesup_name').focus();
                            }
                        } else {
                            setMessage('Please Enter Invoice Terms', 'Warning ..!!');
                            setSeverity('warning');
                            setOpenSnack(true);
                            document.getElementById('invoiceterms').focus();
                        }
                    } else {
                        setMessage('Please Enter The Exchange Rate', 'Warning ..!!');
                        setSeverity('warning');
                        setOpenSnack(true);
                        document.getElementById('invoicecurrency').focus();
                    }
                } else {
                    setMessage('Please Enter the Invoice Currency', 'Warning ..!!');
                    setSeverity('warning');
                    setOpenSnack(true);
                    document.getElementById('invoicecurrency').focus();
                }
            } else {
                setMessage('Please Enter the Invoice Value', 'Warning ..!!');
                setSeverity('warning');
                setOpenSnack(true);
                document.getElementById('invoicevalue').focus();
            }
        }
        else {
            setMessage('Please Enter the Invoice Date', 'Warning ..!!');
            setSeverity('warning');
            setOpenSnack(true);
            document.getElementById('invoicedate').focus();
        }
        return false;
    }

    /*Invoicesave*/
    const InvoiceSave = () => {
        if (invoiceValidetion() === true) {
            setInvoiceSaveTableDsa(true);
            setInvoiceProcsTableSve(true);
            if (jobValues.job_no !== '') {
                var PurchaseOrderDetailsDate, ContractDetailsDate, LetterOfCreditDetailsDate, FreightCURRENCY, InsuranceCURRENCY = '';
                var MiscValuesCURRENCY, LoadingCURRENCY, AgencyComCURRENCY, FreightEXCHANGE, InsuranceEXCHANGE, AgencyComEXCHANGE, LoadingEXCHANGE, MiscValuesEXCHANGE = '';

                if (invoicevalues.PurchaseOrderDetailsDate !== '') {
                    PurchaseOrderDetailsDate = invoicevalues.PurchaseOrderDetailsDate
                }
                else {
                    PurchaseOrderDetailsDate = null;
                }
                if (invoicevalues.ContractDetailsDate !== '') {
                    ContractDetailsDate = invoicevalues.ContractDetailsDate
                }
                else {
                    ContractDetailsDate = null;
                }
                if (invoicevalues.LetterOfCreditDetailsDate !== '') {
                    LetterOfCreditDetailsDate = invoicevalues.LetterOfCreditDetailsDate
                }
                else {
                    LetterOfCreditDetailsDate = null;
                }
                if (BifrctionStsValues.FreightCURRENCY !== '') {
                    FreightCURRENCY = BifrctionStsValues.FreightCURRENCY
                }
                else {
                    FreightCURRENCY = null;
                }
                if (BifrctionStsValues.InsuranceCURRENCY !== '') {
                    InsuranceCURRENCY = BifrctionStsValues.InsuranceCURRENCY
                }
                else {
                    InsuranceCURRENCY = null;
                }
                if (BifrctionStsValues.MiscValuesCURRENCY !== '') {
                    MiscValuesCURRENCY = BifrctionStsValues.MiscValuesCURRENCY
                }
                else {
                    MiscValuesCURRENCY = null;
                }
                if (BifrctionStsValues.LoadingCURRENCY !== '') {
                    LoadingCURRENCY = BifrctionStsValues.LoadingCURRENCY
                }
                else {
                    LoadingCURRENCY = null;
                }
                if (BifrctionStsValues.AgencyComCURRENCY !== '') {
                    AgencyComCURRENCY = BifrctionStsValues.AgencyComCURRENCY
                }
                else {
                    AgencyComCURRENCY = null;
                }
                if (BifrctionStsValues.FreightEXCHANGE !== '') {
                    FreightEXCHANGE = BifrctionStsValues.FreightEXCHANGE
                }
                else {
                    FreightEXCHANGE = null;
                }
                if (BifrctionStsValues.InsuranceEXCHANGE !== '') {
                    InsuranceEXCHANGE = BifrctionStsValues.InsuranceEXCHANGE
                }
                else {
                    InsuranceEXCHANGE = null;
                }
                if (BifrctionStsValues.AgencyComEXCHANGE !== '') {
                    AgencyComEXCHANGE = BifrctionStsValues.AgencyComEXCHANGE
                }
                else {
                    AgencyComEXCHANGE = null;
                }
                if (BifrctionStsValues.LoadingEXCHANGE !== '') {
                    LoadingEXCHANGE = BifrctionStsValues.LoadingEXCHANGE
                }
                else {
                    LoadingEXCHANGE = null;
                }
                if (BifrctionStsValues.MiscValuesEXCHANGE !== '') {
                    MiscValuesEXCHANGE = BifrctionStsValues.MiscValuesEXCHANGE
                }
                else {
                    MiscValuesEXCHANGE = null;
                }
                // invoiceInbox-validation....

                let details = {
                    consignmentId: jobValues.job_no, invoiceId: invoicevalues.InvoiceId, invoiceNumber: invoicevalues.invoiceNo, invoiceDate: invoicevalues.invoiceDate,
                    currency_code: invoicevalues.Currency, exchangeRate: invoicevalues.ExchangeRate, invoiceValue: invoicevalues.invoiceValue, invoiceTerm: invoicevalues.Terms,
                    supplierName: invoicevalues.SupplierName, supplierAddress1: invoicevalues.Address1, supplierAddress2: invoicevalues.Address2, supplierPincode: invoicevalues.PinCode,
                    supplierCountryName: invoicevalues.disable_supcountry_Name, thirdParty: invoicevalues.Thirdparty, seller: invoicevalues.Seller, broker: invoicevalues.Broker,
                    svbLoading: invoicevalues.SVBLoading, svbDescription: invoicevalues.SVBDescription, relBtByrSeller: invoicevalues.RelationBetweenBuyerSeller,
                    transactionCode: invoicevalues.NatureOfTransaction, paymentTermsCode: invoicevalues.TermOfPayment, condRestriction: invoicevalues.ConditionsOfRestrictionSale,
                    valuationMethodCode: invoicevalues.ValuationMethod, discount: invoicevalues.DiscountChargesIncludedInThisInvoice, cummulative: invoicevalues.CummulativeCharges,
                    misc: invoicevalues.AreThereMiscChargesNotSpecifiedInThisInvoice, aeoCode: invoicevalues.AEOCode, aeoRole: invoicevalues.AEORole, aeoCountryId: invoicevalues.AEOCountry,
                    loadNo: invoicevalues.LoadNo, condtion1: invoicevalues.Condition1, otherInformation: invoicevalues.OtherInformation, orderNo: invoicevalues.PurchaseOrderDetailsNo,
                    orderDate: PurchaseOrderDetailsDate, contractNo: invoicevalues.ContractDetailsNo, contractDate: ContractDetailsDate,
                    letterNo: invoicevalues.LetterOfCreditDetailsNo, letterDate: LetterOfCreditDetailsDate, hssRate: BifrctionStsValues.HSSValuesRATE, hssValue: BifrctionStsValues.HSSValuesCHARGES,
                    freightValue: BifrctionStsValues.FreightCHARGES, freightRate: BifrctionStsValues.FreightRATE, freightCurrency: FreightCURRENCY, insuranceValue: BifrctionStsValues.InsuranceCHARGES,
                    insuranceRate: BifrctionStsValues.InsuranceRATE, insuranceCurrency: InsuranceCURRENCY, miscValue: BifrctionStsValues.MiscValuesCHARGES, miscCurrency: MiscValuesCURRENCY,
                    miscRate: BifrctionStsValues.MiscValuesRATE, landingRate: BifrctionStsValues.LandingRATE, loadingValue: BifrctionStsValues.LoadingCHARGES, loadingCurrency: LoadingCURRENCY,
                    loadingRate: BifrctionStsValues.LoadingRATE, agencyValue: BifrctionStsValues.AgencyComCHARGES, agencyCurrency: AgencyComCURRENCY, agencyRate: BifrctionStsValues.AgencyComRATE,
                    supplierAddress3: invoicevalues.Address3, frtExchangeRate: FreightEXCHANGE, insExchangeRate: InsuranceEXCHANGE, agyExchangeRate: AgencyComEXCHANGE,
                    loadExchangeRate: LoadingEXCHANGE, miscExchangeRate: MiscValuesEXCHANGE, createdBy: getUserId()
                }
                InvoiceService.insertCommercialInvoice(details).then(res => {
                    const message = res.data.message;
                    if (message.toString() === 'SUCCESS') {
                        setMessage('Inserted Successfully'); setSeverity('success'); setOpenSnack(true);
                        setConfonfirmDialog({
                            isOpen: true, Title: 'Do You Want To Add Item', onConfirm: () => { getItemandMove(); setConfonfirmDialog({ ...confirmDialog, isOpen: false }) },
                            noConfirm: () => { InvoiceReset(); setConfonfirmDialog({ ...confirmDialog, isOpen: false }) }
                        })
                        if (invoiceradiovalues === '1') { calculateAutoBifurcateFrgInsValue(); }
                    }
                    else {
                        setMessage(message.toString()); setSeverity('error'); setOpenSnack(true); InvoiceReset();
                    } setinvoiceTabledetails([])
                    InvoiceTableget();
                }).catch(error => {
                    setMessage(error.message); setSeverity('error'); setOpenSnack(true); InvoiceReset();
                })

            } else {
                setMessage('Please Select Job No From Job Table'); setSeverity('Warning'); setOpenSnack(true);
            }
        }
    }

    const InvoiceUpdate = () => {
        if (invoiceValidetion() === true) {
            setInvoiceUpdateTableDsa(true);
            setInvoiceProcsTableUpd(true);
            if (jobValues.job_no !== '') {
                var PurchaseOrderDetailsDate, ContractDetailsDate, LetterOfCreditDetailsDate, FreightCURRENCY, InsuranceCURRENCY = '';
                var MiscValuesCURRENCY, LoadingCURRENCY, AgencyComCURRENCY, FreightEXCHANGE, InsuranceEXCHANGE, AgencyComEXCHANGE, LoadingEXCHANGE, MiscValuesEXCHANGE = '';

                if (invoicevalues.PurchaseOrderDetailsDate !== '') {
                    PurchaseOrderDetailsDate = invoicevalues.PurchaseOrderDetailsDate
                }
                else {
                    PurchaseOrderDetailsDate = null;
                }
                if (invoicevalues.ContractDetailsDate !== '') {
                    ContractDetailsDate = invoicevalues.ContractDetailsDate
                }
                else {
                    ContractDetailsDate = null;
                }
                if (invoicevalues.LetterOfCreditDetailsDate !== '') {
                    LetterOfCreditDetailsDate = invoicevalues.LetterOfCreditDetailsDate
                }
                else {
                    LetterOfCreditDetailsDate = null;
                }
                if (BifrctionStsValues.FreightCURRENCY !== '') {
                    FreightCURRENCY = BifrctionStsValues.FreightCURRENCY
                }
                else {
                    FreightCURRENCY = null;
                }
                if (BifrctionStsValues.InsuranceCURRENCY !== '') {
                    InsuranceCURRENCY = BifrctionStsValues.InsuranceCURRENCY
                }
                else {
                    InsuranceCURRENCY = null;
                }
                if (BifrctionStsValues.MiscValuesCURRENCY !== '') {
                    MiscValuesCURRENCY = BifrctionStsValues.MiscValuesCURRENCY
                }
                else {
                    MiscValuesCURRENCY = null;
                }
                if (BifrctionStsValues.LoadingCURRENCY !== '') {
                    LoadingCURRENCY = BifrctionStsValues.LoadingCURRENCY
                }
                else {
                    LoadingCURRENCY = null;
                }
                if (BifrctionStsValues.AgencyComCURRENCY !== '') {
                    AgencyComCURRENCY = BifrctionStsValues.AgencyComCURRENCY
                }
                else {
                    AgencyComCURRENCY = null;
                }
                if (BifrctionStsValues.FreightEXCHANGE !== '') {
                    FreightEXCHANGE = BifrctionStsValues.FreightEXCHANGE
                }
                else {
                    FreightEXCHANGE = null;
                }
                if (BifrctionStsValues.InsuranceEXCHANGE !== '') {
                    InsuranceEXCHANGE = BifrctionStsValues.InsuranceEXCHANGE
                }
                else {
                    InsuranceEXCHANGE = null;
                }
                if (BifrctionStsValues.AgencyComEXCHANGE !== '') {
                    AgencyComEXCHANGE = BifrctionStsValues.AgencyComEXCHANGE
                }
                else {
                    AgencyComEXCHANGE = null;
                }
                if (BifrctionStsValues.LoadingEXCHANGE !== '') {
                    LoadingEXCHANGE = BifrctionStsValues.LoadingEXCHANGE
                }
                else {
                    LoadingEXCHANGE = null;
                }
                if (BifrctionStsValues.MiscValuesEXCHANGE !== '') {
                    MiscValuesEXCHANGE = BifrctionStsValues.MiscValuesEXCHANGE
                }
                else {
                    MiscValuesEXCHANGE = null;
                }
                // invoiceInbox-validation....

                let details = {
                    consignmentId: jobValues.job_no, invoiceId: invoicevalues.InvoiceId, invoiceNumber: invoicevalues.invoiceNo, invoiceDate: invoicevalues.invoiceDate,
                    currency_code: invoicevalues.Currency, exchangeRate: invoicevalues.ExchangeRate, invoiceValue: invoicevalues.invoiceValue, invoiceTerm: invoicevalues.Terms,
                    supplierName: invoicevalues.SupplierName, supplierAddress1: invoicevalues.Address1, supplierAddress2: invoicevalues.Address2, supplierPincode: invoicevalues.PinCode,
                    supplierCountryName: invoicevalues.disable_supcountry_Name, thirdParty: invoicevalues.Thirdparty, seller: invoicevalues.Seller, broker: invoicevalues.Broker,
                    svbLoading: invoicevalues.SVBLoading, svbDescription: invoicevalues.SVBDescription, relBtByrSeller: invoicevalues.RelationBetweenBuyerSeller,
                    transactionCode: invoicevalues.NatureOfTransaction, paymentTermsCode: invoicevalues.TermOfPayment, condRestriction: invoicevalues.ConditionsOfRestrictionSale,
                    valuationMethodCode: invoicevalues.ValuationMethod, discount: invoicevalues.DiscountChargesIncludedInThisInvoice, cummulative: invoicevalues.CummulativeCharges,
                    misc: invoicevalues.AreThereMiscChargesNotSpecifiedInThisInvoice, aeoCode: invoicevalues.AEOCode, aeoRole: invoicevalues.AEORole, aeoCountryId: invoicevalues.AEOCountry,
                    loadNo: invoicevalues.LoadNo, condtion1: invoicevalues.Condition1, otherInformation: invoicevalues.OtherInformation, orderNo: invoicevalues.PurchaseOrderDetailsNo,
                    orderDate: PurchaseOrderDetailsDate, contractNo: invoicevalues.ContractDetailsNo, contractDate: ContractDetailsDate,
                    letterNo: invoicevalues.LetterOfCreditDetailsNo, letterDate: LetterOfCreditDetailsDate, hssRate: BifrctionStsValues.HSSValuesRATE, hssValue: BifrctionStsValues.HSSValuesCHARGES,
                    freightValue: BifrctionStsValues.FreightCHARGES, freightRate: BifrctionStsValues.FreightRATE, freightCurrency: FreightCURRENCY, insuranceValue: BifrctionStsValues.InsuranceCHARGES,
                    insuranceRate: BifrctionStsValues.InsuranceRATE, insuranceCurrency: InsuranceCURRENCY, miscValue: BifrctionStsValues.MiscValuesCHARGES, miscCurrency: MiscValuesCURRENCY,
                    miscRate: BifrctionStsValues.MiscValuesRATE, landingRate: BifrctionStsValues.LandingRATE, loadingValue: BifrctionStsValues.LoadingCHARGES, loadingCurrency: LoadingCURRENCY,
                    loadingRate: BifrctionStsValues.LoadingRATE, agencyValue: BifrctionStsValues.AgencyComCHARGES, agencyCurrency: AgencyComCURRENCY, agencyRate: BifrctionStsValues.AgencyComRATE,
                    supplierAddress3: invoicevalues.Address3, frtExchangeRate: FreightEXCHANGE, insExchangeRate: InsuranceEXCHANGE, agyExchangeRate: AgencyComEXCHANGE,
                    loadExchangeRate: LoadingEXCHANGE, miscExchangeRate: MiscValuesEXCHANGE, updatedBy: getUserId()
                }
                InvoiceService.updateCommercialInvoice(details).then(res => {
                    const message = res.data.message;
                    if (message.toString() === 'SUCCESS') {
                        setMessage('Updated Successfully'); setSeverity('success'); setOpenSnack(true);
                        if (invoiceradiovalues === '1') { calculateAutoBifurcateFrgInsValue() }
                    }
                    else {
                        setMessage(message.toString()); setSeverity('error'); setOpenSnack(true);
                    }
                    InvoiceTableget(); InvoiceReset();
                }).catch(error => {
                    setMessage(error.message); setSeverity('error'); setOpenSnack(true); InvoiceReset();
                })
            }
            else {
                setMessage('Please Select Job No From Job Table'); setSeverity('Warning'); setOpenSnack(true);
            }
        }
    }
    const InvoiceDelete = () => {
        setInvoiceDeleteTableDsa(true);
        setInvoiceProcsTableDlt(true);
        setConfonfirmDialog({
            isOpen: true, Title: 'Are Sure to Delete This ...!', noConfirm: () => { setConfonfirmDialog({ ...confirmDialog, isOpen: false }); },
            onConfirm: () => {
                setConfonfirmDialog({ ...confirmDialog, isOpen: false });
                InvoiceService.deleteCommercialInvoice(invoicevalues.InvoiceId).then(res => {
                    const message = res.data.message;
                    if (message.toString() === 'SUCCESS') { setMessage('Deleted Successfully'); setOpenSnack(true); setSeverity('success'); }
                    else { setMessage(message.toString()); setSeverity('error'); setOpenSnack(true); }
                    InvoiceReset(); InvoiceTableget();
                }).catch(error => { setMessage(error.message); setSeverity('error'); setOpenSnack(true); InvoiceReset(); });
            }
        })
    }
    const InvoiceReset = () => {
        setinvoiceValues({
            ...invoicevalues, InvoiceId: '', invoiceNo: '', invoiceDate: '', invoiceValue: '', Currency: '', ExchangeRate: '', Terms: '', SupplierName: '', Address1: '', Address2: '', SupplierCountry: '',
            disable_supcountry_Name: '', Address3: '', PinCode: '', SVBLoading: "N", SVBDescription: '', Thirdparty: "N", Seller: "N", Broker: "N", RelationBetweenBuyerSeller: "N",
            NatureOfTransaction: 'O', disable_NatureofTransaction_Name: 'Others', TermOfPayment: 'OTH', disable_Termsofpayment: 'Others', ConditionsOfRestrictionSale: "N", ValuationMethod: 'RULE4',
            disable_valuationmethod: 'Transaction Value', DiscountChargesIncludedInThisInvoice: "N", CummulativeCharges: "N", AreThereMiscChargesNotSpecifiedInThisInvoice: "N", PurchaseOrderDetailsNo: '',
            PurchaseOrderDetailsDate: '', ContractDetailsNo: '', ContractDetailsDate: '', LetterOfCreditDetailsNo: '', LetterOfCreditDetailsDate: '', AEOCode: '', AEORole: '',
            AEOCountry: '', disable_AeocountryName: '', LoadNo: '', Condition1: '', Condition2: '', OtherInformation: '',
        })
        setBifrctionStsValues({
            ...BifrctionStsValues, FreightCHARGES: '0.00', FreightCURRENCY: '', FreightEXCHANGE: '', FreightRATE: '0.0000', InsuranceCHARGES: '0.00', InsuranceCURRENCY: '',
            InsuranceEXCHANGE: '', InsuranceRATE: '0.0000', AgencyComCHARGES: '0.00', AgencyComCURRENCY: '', AgencyComEXCHANGE: '', AgencyComRATE: '0.0000', LoadingCHARGES: '0.00',
            LoadingCURRENCY: '', LoadingEXCHANGE: '', LoadingRATE: '0.0000', MiscValuesCHARGES: '0.00', MiscValuesCURRENCY: '', MiscValuesEXCHANGE: '', MiscValuesRATE: '0.0000',
            HSSValuesCHARGES: '0.00', HSSValuesRATE: '0.0000', LandingRATE: '0.0000',
            FreightDetailsCHARGES: '0', FreightDetailsCURRENCY: '', FreightDetailsExchange: '', FreightDetailsRATE: '0', InsuranceDetailsCHARGES: '0', InsuranceDetailsCURRENCY: '',
            InsuranceDetailsExchange: '', InsuranceDetailsRATE: '0', MiscDetailsCHARGES: '0', MiscDetailsCURRENCY: '', MiscDetailsEXCHANGE: '', MiscDetailsRATE: '0', AgencyCommCHARGES: '0',
            AgencyCommCURRENCY: '', AgencycommDetailsExchange: '', AgencyCommRATE: '0',

        })
        setInvoiceSaveTableDsa(false); setInvoiceUpdateTableDsa(true); setInvoiceDeleteTableDsa(true); setinvoiceDublicateTableDsa(true)
        setInvoiceProcsTableSve(false); setInvoiceProcsTableUpd(false); setInvoiceProcsTableDlt(false); setInvoiceProcsTableDubli(false)
        document.getElementById('invoiceNo').focus();
    }
    const InvoiceDuplicateBtn = () => {
        let details = { consignmentId: jobValues.job_no, invoiceId: invoicevalues.InvoiceId }
        InvoiceService.insertDuplicateInvoiceImport(details).then(res => {
            const message = res.data.message;
            if (message.toString() === 'SUCCESS') {
                setMessage('Duplicate Invoice Inserted');
                setSeverity('success')
                setOpenSnack(true)
            } else {
                setMessage(message.toString());
                setSeverity('error');
                setOpenSnack(true);
            }
            InvoiceTableget();
            InvoiceReset();
        }).catch(error => {
            setMessage(error.message);
            setSeverity('error');
            setOpenSnack(true);
            InvoiceReset();
        })
    }
    /*//Autobifrication-update/*/
    const InvoiceAutoBifr_Update = () => {
        setInvoiceUpdateDsa(true);
        setInvoiceProcsUpd(true);
        var FrieghtValue, FrieghtRate, FrieghtCurrency, FrieghtExchange, InsuranceValue, InsuranceRate, InsuranceCurrency, InsuranceExchange = '';
        var MiscValue, MiscRate, MiscCurrency, MiscExchange, AgencyValue, AgencyRate, AgencyCurrency, AgencyExchange = '';
        if (invoicevalues.Terms === 'ci' || invoicevalues.Terms === 'CI') {
            FrieghtValue = BifrctionStsValues.FreightDetailsCHARGES;
            FrieghtCurrency = BifrctionStsValues.FreightDetailsCURRENCY;
            FrieghtExchange = BifrctionStsValues.FreightDetailsExchange;
            FrieghtRate = BifrctionStsValues.FreightDetailsRATE;

            InsuranceValue = '0.00';
            InsuranceCurrency = null;
            InsuranceExchange = '0.0000';
            InsuranceRate = '0';
        }
        if (invoicevalues.Terms === 'cf' || invoicevalues.Terms === 'CF') {
            FrieghtValue = '0.00';
            FrieghtCurrency = null;
            FrieghtExchange = '0.0000';
            FrieghtRate = '0';

            InsuranceValue = BifrctionStsValues.InsuranceDetailsCHARGES;
            InsuranceCurrency = BifrctionStsValues.InsuranceDetailsCURRENCY;
            InsuranceExchange = BifrctionStsValues.InsuranceDetailsExchange;
            InsuranceRate = BifrctionStsValues.InsuranceDetailsRATE;
        }
        if (invoicevalues.Terms === 'fob' || invoicevalues.Terms === 'FOB') {
            FrieghtValue = BifrctionStsValues.FreightDetailsCHARGES;
            FrieghtCurrency = BifrctionStsValues.FreightDetailsCURRENCY;
            FrieghtExchange = BifrctionStsValues.FreightDetailsExchange;
            FrieghtRate = BifrctionStsValues.FreightDetailsRATE;

            InsuranceValue = BifrctionStsValues.InsuranceDetailsCHARGES;
            InsuranceCurrency = BifrctionStsValues.InsuranceDetailsCURRENCY;
            InsuranceExchange = BifrctionStsValues.InsuranceDetailsExchange;
            InsuranceRate = BifrctionStsValues.InsuranceDetailsRATE;
        }
        if (invoicevalues.Terms === 'cf' || invoicevalues.Terms === 'CF') {
            FrieghtValue = '0.00';
            FrieghtCurrency = null;
            FrieghtExchange = '0.0000';
            FrieghtRate = '0';

            InsuranceValue = '0.00';
            InsuranceCurrency = null;
            InsuranceExchange = '0.0000';
            InsuranceRate = '0';
        }
        if (BifrctionStsValues.MiscDetailsCHARGES !== '') {
            MiscValue = BifrctionStsValues.MiscDetailsCHARGES;
        }
        else {
            MiscValue = '0.00'
        }
        if (BifrctionStsValues.MiscDetailsCURRENCY !== '') {
            MiscCurrency = BifrctionStsValues.MiscDetailsCURRENCY;
        }
        else {
            MiscCurrency = null;
        }
        if (BifrctionStsValues.MiscDetailsEXCHANGE !== '') {
            MiscExchange = BifrctionStsValues.MiscDetailsEXCHANGE;
        }
        else {
            MiscExchange = '0.0000'
        }
        if (BifrctionStsValues.MiscDetailsRATE !== '') {
            MiscRate = BifrctionStsValues.MiscDetailsRATE;
        }
        else {
            MiscRate = '0'
        }
        if (BifrctionStsValues.AgencyCommCHARGES !== '') {
            AgencyValue = BifrctionStsValues.AgencyCommCHARGES;
        }
        else {
            AgencyValue = '0.00'
        }
        if (BifrctionStsValues.AgencyCommCURRENCY !== '') {
            AgencyCurrency = BifrctionStsValues.AgencyCommCURRENCY;
        }
        else {
            AgencyCurrency = null;
        }
        if (BifrctionStsValues.AgencycommDetailsExchange !== '') {
            AgencyExchange = BifrctionStsValues.AgencycommDetailsExchange;
        }
        else {
            AgencyExchange = '0.0000'
        }
        if (BifrctionStsValues.AgencyCommRATE !== '') {
            AgencyRate = BifrctionStsValues.AgencyCommRATE;
        }
        else {
            AgencyRate = '0'
        }

        let details = {
            consignmentId: jobValues.job_no, freightValue: FrieghtValue, freightRate: FrieghtRate, freightCurrency: FrieghtCurrency, frtExchangeRate: FrieghtExchange,
            insuranceValue: InsuranceValue, insuranceCurrency: InsuranceCurrency, insExchangeRate: InsuranceExchange, insuranceRate: InsuranceRate,
            miscValue: MiscValue, miscCurrency: MiscCurrency, miscExchangeRate: MiscExchange, miscRate: MiscRate, agencyValue: AgencyValue,
            agencyRate: AgencyRate, agencyCurrency: AgencyCurrency, agencyExchange: AgencyExchange
        }
        InvoiceService.updateJobFrgtInsDetails(details).then(res => {
            const message = res.data.message;
            if (message.toString() === 'SUCCESS') {
                inovicetermskeyhandleClose();
            }
            else {
                setMessage(message.toString());
                setSeverity('error');
                setOpenSnack(true);
            }
            setInvoiceUpdateDsa(false);
            setInvoiceProcsUpd(false);
        }).catch(error => {
            setMessage(error.message);
            setSeverity('error');
            setOpenSnack(true);
            setInvoiceUpdateDsa(false);
            setInvoiceProcsUpd(false);
        })
    }
    /*svbloadingdialog*/
    const InvoiceSvbSave = () => {
        setInvoiceSaveDsa(true);
        setInvoiceProcsSve(true)

        let details = {
            invoiceId: invoicevalues.InvoiceId, svbRefNo: dialoginvoicevalues.SVBReferenceNo, svbDate: dialoginvoicevalues.SVBDate,
            cusHouseCode: dialoginvoicevalues.CustomHouseCode, loadType: dialoginvoicevalues.SVBType, assablePerc: dialoginvoicevalues.SVB_Load_Assable_Value_percentage,
            dutyPerc: dialoginvoicevalues.SVB_Load_Duty_Percentage, avFinal: dialoginvoicevalues.Av_is_Final_or_Provisional, dutyFinal: dialoginvoicevalues.Duty_is_Final_or_Provisional
        }
        InvoiceService.insertSvb(details).then(res => {
            const message = res.data.message;
            if (message.toString() === "SUCCESS") {
                setMessage('Inserted Successfully');
                setSeverity('success');
                setOpenSnack(true);
            }
            else {
                setMessage(message.toString());
                setSeverity('error');
                setOpenSnack(true);
            }
            InvoiceSvbReset();
            InvoiceService.getSvb(invoicevalues.InvoiceId).then(res => {
                setinvoicedetails(res.data);
            })
        }).catch(error => {
            setMessage(error.message);
            setSeverity('error');
            setOpenSnack(true);
            InvoiceSvbReset();
        })
    }
    const InvoiceSvbUpdate = () => {
        setInvoiceUpdateDsa(true);
        setInvoiceProcsUpd(true);
        let details = {
            svbId: invoicevalues.svbId, svbRefNo: dialoginvoicevalues.SVBReferenceNo, svbDate: dialoginvoicevalues.SVBDate,
            cusHouseCode: dialoginvoicevalues.CustomHouseCode, loadType: dialoginvoicevalues.SVBType, assablePerc: dialoginvoicevalues.SVB_Load_Assable_Value_percentage,
            dutyPerc: dialoginvoicevalues.SVB_Load_Duty_Percentage, avFinal: dialoginvoicevalues.Av_is_Final_or_Provisional, dutyFinal: dialoginvoicevalues.Duty_is_Final_or_Provisional
        }
        InvoiceService.updateSvb(invoicevalues.InvoiceId, details).then(res => {
            const message = res.data.message;
            if (message.toString() === 'SUCCESS') {
                setMessage('Updated Successfully');
                setSeverity('success');
                setOpenSnack(true);
            }
            else {
                setMessage(message.toString());
                setSeverity('error');
                setOpenSnack(true);
            }
            InvoiceSvbReset();
            InvoiceService.getSvb(invoicevalues.InvoiceId).then(res => {
                setinvoicedetails(res.data);
            })
        }).catch(error => {
            setMessage(error.message);
            setSeverity('error');
            setOpenSnack(true);
            InvoiceSvbReset();
        })
    }
    const InvoiceSvbDelete = () => {
        setInvoiceDeleteDsa(true);
        setInvoiceProcsDlt(true);
        InvoiceService.deleteSvb(invoicevalues.svbId).then(res => {
            const message = res.data.message;
            if (message.toString() === 'SUCCESS') {
                setMessage('Deleted Successfully');
                setOpenSnack(true);
                setSeverity('success')
            }
            else {
                setMessage(message.toString());
                setSeverity('error');
                setOpenSnack(true);
            }
            InvoiceSvbReset();
            InvoiceService.getSvb(invoicevalues.InvoiceId).then(res => {
                setinvoicedetails(res.data);
            })
        }).catch(error => {
            setMessage(error.message);
            setSeverity('error');
            setOpenSnack(true);
            InvoiceSvbReset();
        })
    }

    const InvoiceSvbReset = () => {
        setdialoginvoicevalues({
            ...dialoginvoicevalues, SVBReferenceNo: '', SVBDate: '', CustomHouseCode: '',
            SVBType: 'B', SVB_Load_Assable_Value_percentage: '0.00', SVB_Load_Duty_Percentage: '0.00', Av_is_Final_or_Provisional: 'N',
            Duty_is_Final_or_Provisional: 'N'
        });
        setInvoiceSaveDsa(false);
        setInvoiceUpdateDsa(true);
        setInvoiceDeleteDsa(true);
        setInvoiceProcsSve(false);
        setInvoiceProcsUpd(false);
        setInvoiceProcsDlt(false);
    }

    /*thirdpartydialogbutonsOperations*/
    const InvoiceThirdPartySave = () => {
        if (dialoginvoicevalues.ThirdPartyName !== '') {
            setInvoiceSaveDsa(true);
            setInvoiceProcsSve(true);
            let details = {
                invoiceId: invoicevalues.InvoiceId, name: dialoginvoicevalues.ThirdPartyName,
                address: dialoginvoicevalues.ThirdPartyAddress, city: dialoginvoicevalues.ThirdPartyCity,
                pincode: dialoginvoicevalues.ThirdPartyPincode, division: dialoginvoicevalues.ThirdPartyDivision, countryName: dialoginvoicevalues.ThirdPartyCountry
            }
            InvoiceService.insetThirdparty(details).then(res => {
                const message = res.data.message;
                if (message.toString() === 'SUCCESS') {
                    setMessage('Inserted Successfully');
                    setOpenSnack(true);
                    setSeverity('success')
                }
                else {
                    setMessage(message.toString());
                    setSeverity('error');
                    setOpenSnack(true);
                }
                InvoiceThirdPartyReset();
                let details2 = { invoiceId: invoicevalues.InvoiceId }
                InvoiceService.getThirdparty(details2).then(res => {
                    setinvoicedetails(res.data)
                })
            }).catch(error => {
                setMessage(error.message);
                setSeverity('error');
                setOpenSnack(true);
                InvoiceThirdPartyReset();
            })
        } else {
            setMessage('Please Enter The Third Party Name')
            setSeverity('warning')
            setOpenSnack(true)
            document.getElementById('invoiceTPnameId').focus();
        }
    }
    const InvoiceThirdPartyUpdate = () => {
        if (dialoginvoicevalues.ThirdPartyName !== '') {
            setInvoiceUpdateDsa(true);
            setInvoiceProcsUpd(true);

            let details = {
                thirdPartyId: invoicevalues.thirdPartyId, invoiceId: invoicevalues.InvoiceId, name: dialoginvoicevalues.ThirdPartyName,
                address: dialoginvoicevalues.ThirdPartyAddress, city: dialoginvoicevalues.ThirdPartyCity,
                pincode: dialoginvoicevalues.ThirdPartyPincode, division: dialoginvoicevalues.ThirdPartyDivision,
                countryName: dialoginvoicevalues.ThirdPartyCountry
            }
            InvoiceService.updateThirdParty(details).then(res => {
                const message = res.data.message;
                if (message.toString() === 'SUCCESS') {
                    setMessage('Updated Successfully');
                    setOpenSnack(true);
                    setSeverity('success')
                }
                else {
                    setMessage(message.toString());
                    setSeverity('error');
                    setOpenSnack(true);
                }
                InvoiceThirdPartyReset();
                let details2 = { invoiceId: invoicevalues.InvoiceId }
                InvoiceService.getThirdparty(details2).then(res => {
                    setinvoicedetails(res.data)
                })
            }).catch(error => {
                setMessage(error.message);
                setSeverity('error');
                setOpenSnack(true);
                InvoiceThirdPartyReset();
            })
        } else {
            setMessage('Please Enter The Third Party Name')
            setSeverity('warning')
            setOpenSnack(true)
            document.getElementById('invoiceTPnameId').focus();
        }

    }
    const InvoiceThirdPartyDelete = () => {
        setInvoiceDeleteDsa(true);
        setInvoiceProcsDlt(true);
        InvoiceService.deleteThirdParty(invoicevalues.thirdPartyId).then(res => {
            const message = res.data.message;
            if (message.toString() === 'SUCCESS') {
                setMessage('Deleted Successfully');
                setOpenSnack(true);
                setSeverity('success')
            }
            else {
                setMessage(message.toString());
                setSeverity('error');
                setOpenSnack(true);
            }
            InvoiceThirdPartyReset();
            let details2 = { invoiceId: invoicevalues.InvoiceId }
            InvoiceService.getThirdparty(details2).then(res => {
                setinvoicedetails(res.data)
            })
        }).catch(error => {
            setMessage(error.message);
            setSeverity('error');
            setOpenSnack(true);
            InvoiceThirdPartyReset();
        })
    }
    const InvoiceThirdPartyReset = () => {
        setdialoginvoicevalues({
            ...dialoginvoicevalues, ThirdPartyName: '',
            ThirdPartyCountry: '', ThirdPartyAddress: '', ThirdPartyCity: '', ThirdPartyPincode: '', ThirdPartyDivision: ''
        });
        setInvoiceSaveDsa(false);
        setInvoiceUpdateDsa(true);
        setInvoiceDeleteDsa(true);

        setInvoiceProcsSve(false);
        setInvoiceProcsUpd(false);
        setInvoiceProcsDlt(false);
    }

    /*InvoiceSellerButtonsOperations*/

    const InvoiceSellerSave = () => {
        setInvoiceSaveDsa(true)
        setInvoiceProcsSve(true)
        let details = {
            invoiceId: invoicevalues.InvoiceId, name: dialoginvoicevalues.SellerName,
            address: dialoginvoicevalues.SellerAddress, city: dialoginvoicevalues.SellerCity,
            pincode: dialoginvoicevalues.SellerPincode, division: dialoginvoicevalues.SellerDivision, countryName: dialoginvoicevalues.SellerCountry,
        }
        InvoiceService.insertSeller(details).then(res => {
            const message = res.data.message;
            if (message.toString() === 'SUCCESS') {
                setMessage('Inserted Successfully');
                setOpenSnack(true);
                setSeverity('success')
            }
            else {
                setMessage(message.toString());
                setSeverity('error');
                setOpenSnack(true);
            }
            InvoiceSellerReset();
            InvoiceService.getSeller(invoicevalues.InvoiceId).then(res => {
                setinvoicedetails(res.data);
            })
        }).catch(error => {
            setMessage(error.message);
            setSeverity('error');
            setOpenSnack(true);
            InvoiceSellerReset();
        })
    }
    const InvoiceSellerUpdate = () => {
        setInvoiceUpdateDsa(true);
        setInvoiceProcsUpd(true);
        let details = {
            sellerId: invoicevalues.sellerId, invoiceId: invoicevalues.InvoiceId, name: dialoginvoicevalues.SellerName,
            address: dialoginvoicevalues.SellerAddress, city: dialoginvoicevalues.SellerCity,
            pincode: dialoginvoicevalues.SellerPincode, division: dialoginvoicevalues.SellerDivision,
            countryName: dialoginvoicevalues.SellerCountry,
        }
        InvoiceService.updateSeller(details).then(res => {
            const message = res.data.message;
            if (message.toString() === 'SUCCESS') {
                setMessage('Updated Successfully')
                setOpenSnack(true);
                setSeverity('success')
            }
            else {
                setMessage(message.toString());
                setSeverity('error');
                setOpenSnack(true);
            }
            InvoiceSellerReset();
            InvoiceService.getSeller(invoicevalues.InvoiceId).then(res => {
                setinvoicedetails(res.data);
            })
        }).catch(error => {
            setMessage(error.message);
            setSeverity('error');
            setOpenSnack(true);
            InvoiceSellerReset();
        })
    }
    const InvoiceSellerDelete = () => {
        setInvoiceDeleteDsa(true);
        setInvoiceProcsDlt(true);
        InvoiceService.deleteSeller(invoicevalues.sellerId).then(res => {
            const message = res.data.message;
            if (message.toString() === 'SUCCESS') {
                setMessage('Deleted Successfully');
                setOpenSnack(true);
                setSeverity('success')
            }
            else {
                setMessage(message.toString());
                setSeverity('error');
                setOpenSnack(true);
            }
            InvoiceSellerReset();
            InvoiceService.getSeller(invoicevalues.InvoiceId).then(res => {
                setinvoicedetails(res.data);
            })
        }).catch(error => {
            setMessage(error.message);
            setSeverity('error');
            setOpenSnack(true);
            InvoiceSellerReset();
        })
    }
    const InvoiceSellerReset = () => {
        setdialoginvoicevalues({
            ...dialoginvoicevalues, SellerName: '', SellerAddress: '', SellerPincode: '', SellerDivision: '', SellerCountry: '',
            SellerCity: ''
        })
        setInvoiceSaveDsa(false);
        setInvoiceUpdateDsa(true);
        setInvoiceDeleteDsa(true);

        setInvoiceProcsSve(false);
        setInvoiceProcsUpd(false);
        setInvoiceProcsDlt(false);
    }
    /*InvoiceBrokerButtonsOperations*/

    const InvoiceBrokerSave = () => {
        setInvoiceSaveDsa(true)
        setInvoiceProcsSve(true)
        let details = {
            invoiceId: invoicevalues.InvoiceId, name: dialoginvoicevalues.BrokerName, address: dialoginvoicevalues.BrokerAddress,
            city: dialoginvoicevalues.BrokerCity, pincode: dialoginvoicevalues.BrokerPincode,
            division: dialoginvoicevalues.BrokerDivision, countryName: dialoginvoicevalues.BrokerCountry,
        }
        InvoiceService.insertBroker(details).then(res => {
            const message = res.data.message;
            if (message.toString() === 'SUCCESS') {
                setMessage('Inserted SuccessFully')
                setOpenSnack(true);
                setSeverity('success')
            }
            else {
                setMessage(message.toString());
                setSeverity('error');
                setOpenSnack(true);
            }
            InvoiceBrokerReset();
            InvoiceService.getBroker(invoicevalues.InvoiceId).then(res => {
                setinvoicedetails(res.data);
            })
        }).catch(error => {
            setMessage(error.message);
            setSeverity('error');
            setOpenSnack(true);
            InvoiceBrokerReset();
        })

    }
    const InvoiceBrokerUpdate = () => {
        setInvoiceUpdateDsa(true);
        setInvoiceProcsUpd(true);
        let details = {
            brokerId: invoicevalues.brokerId, invoiceId: invoicevalues.InvoiceId, name: dialoginvoicevalues.BrokerName, address: dialoginvoicevalues.BrokerAddress,
            city: dialoginvoicevalues.BrokerCity, pincode: dialoginvoicevalues.BrokerPincode,
            division: dialoginvoicevalues.BrokerDivision, countryName: dialoginvoicevalues.BrokerCountry
        }
        InvoiceService.updateBroker(details).then(res => {
            const message = res.data.message;
            if (message.toString() === 'SUCCESS') {
                setMessage('Updated Successfully')
                setOpenSnack(true);
                setSeverity('success')
            }
            else {
                setMessage(message.toString());
                setSeverity('error');
                setOpenSnack(true);
            }
            InvoiceBrokerReset();
            InvoiceService.getBroker(invoicevalues.InvoiceId).then(res => {
                setinvoicedetails(res.data);
            })
        }).catch(error => {
            setMessage(error.message);
            setSeverity('error');
            setOpenSnack(true);
            InvoiceBrokerReset();
        })
    }
    const InvoiceBrokerDelete = () => {
        setInvoiceDeleteDsa(true);
        setInvoiceProcsDlt(true);
        InvoiceService.deleteBroker(invoicevalues.brokerId).then(res => {
            const message = res.data.message;
            if (message.toString() === 'SUCCESS') {
                setMessage('Deleted Successfully');
                setOpenSnack(true);
                setSeverity('success')
            }
            else {
                setMessage(message.toString());
                setSeverity('error');
                setOpenSnack(true);
            }
            InvoiceBrokerReset();
            InvoiceService.getBroker(invoicevalues.InvoiceId).then(res => {
                setinvoicedetails(res.data);
            })
        }).catch(error => {
            setMessage(error.message);
            setSeverity('error');
            setOpenSnack(true);
            InvoiceBrokerReset();
        })
    }
    const InvoiceBrokerReset = () => {
        setdialoginvoicevalues({ ...dialoginvoicevalues, BrokerName: '', BrokerCountry: '', BrokerAddress: '', BrokerCity: '', BrokerPincode: '', BrokerDivision: '' })
        setInvoiceSaveDsa(false);
        setInvoiceUpdateDsa(true);
        setInvoiceDeleteDsa(true);

        setInvoiceProcsSve(false);
        setInvoiceProcsUpd(false);
        setInvoiceProcsDlt(false);
    }

    /*InvoiceDiscountButnsOperations*/

    const InvoiceDiscount_dtlsSave = () => {
        setInvoiceSaveDsa(true)
        setInvoiceProcsSve(true)
        let details = {
            invoiceId: invoicevalues.InvoiceId, natDiscount: dialoginvoicevalues.NatureofDiscount,
            discountAmount: dialoginvoicevalues.DiscountAmount, discountRate: dialoginvoicevalues.DiscountRate
        }
        InvoiceService.insertDiscount(details).then(res => {
            const message = res.data.message;
            if (message.toString() === "SUCCESS") {
                setMessage('Inserted SuccessFully')
                setOpenSnack(true);
                setSeverity('success')
            }
            else {
                setMessage(message.toString());
                setSeverity('error');
                setOpenSnack(true);
            }
            InvoiceDiscount_dtlsReset();
            InvoiceService.getDiscount(invoicevalues.InvoiceId).then(res => {
                setinvoicedetails(res.data);
            })
        }).catch(error => {
            setMessage(error.message);
            setSeverity('error');
            setOpenSnack(true);
            InvoiceDiscount_dtlsReset();
        })
    }
    const InvoiceDiscount_dtlsUpdate = () => {
        setInvoiceUpdateDsa(true);
        setInvoiceProcsUpd(true);
        let details = {
            discountId: invoicevalues.discountId, invoiceId: invoicevalues.InvoiceId, natDiscount: dialoginvoicevalues.NatureofDiscount,
            discountAmount: dialoginvoicevalues.DiscountAmount, discountRate: dialoginvoicevalues.DiscountRate
        }
        InvoiceService.updateDiscount(details).then(res => {
            const message = res.data.message;
            if (message.toString() === "SUCCESS") {
                setMessage('Updated SuccessFully')
                setOpenSnack(true);
                setSeverity('success')
            }
            else {
                setMessage(message.toString());
                setSeverity('error');
                setOpenSnack(true);
            }
            InvoiceDiscount_dtlsReset();
            InvoiceService.getDiscount(invoicevalues.InvoiceId).then(res => {
                setinvoicedetails(res.data);
            })
        }).catch(error => {
            setMessage(error.message);
            setSeverity('error');
            setOpenSnack(true);
            InvoiceDiscount_dtlsReset();
        })
    }
    const InvoiceDiscount_dtlsDelete = () => {
        setInvoiceDeleteDsa(true);
        setInvoiceProcsDlt(true);
        InvoiceService.deleteDiscount(invoicevalues.discountId).then(res => {
            const message = res.data.message;
            if (message.toString() === 'SUCCESS') {
                setMessage('Deleted Successfully');
                setOpenSnack(true);
                setSeverity('success')
            }
            else {
                setMessage(message.toString());
                setSeverity('error');
                setOpenSnack(true);
            }
            InvoiceDiscount_dtlsReset();
            InvoiceService.getDiscount(invoicevalues.InvoiceId).then(res => {
                setinvoicedetails(res.data);
            })
        }).catch(error => {
            setMessage(error.message);
            setSeverity('error');
            setOpenSnack(true);
            InvoiceDiscount_dtlsReset();
        })
    }
    const InvoiceDiscount_dtlsReset = () => {
        setdialoginvoicevalues({
            dialoginvoicevalues,
            NatureofDiscount: '', DiscountRate: '', DiscountAmount: ''
        })
        setInvoiceSaveDsa(false);
        setInvoiceUpdateDsa(true);
        setInvoiceDeleteDsa(true);

        setInvoiceProcsSve(false);
        setInvoiceProcsUpd(false);
        setInvoiceProcsDlt(false);
    }

    /*InvoiceMiscDetailsButnsOperations*/
    const InvoiceMisc_dtlsSave = () => {
        setInvoiceSaveDsa(true)
        setInvoiceProcsSve(true)
        let details = {
            invoiceId: invoicevalues.InvoiceId, miscCode: dialoginvoicevalues.MiscCodeType, miscDescription: dialoginvoicevalues.MiscDescription,
            miscRate: dialoginvoicevalues.MiscRate, miscAmount: dialoginvoicevalues.MiscAmmount
        }
        InvoiceService.insertMisc(details).then(res => {
            const message = res.data.message;
            if (message.toString() === "SUCCESS") {
                setMessage('Inserted SuccessFully')
                setOpenSnack(true);
                setSeverity('success')
            }
            else {
                setMessage(message.toString());
                setSeverity('error');
                setOpenSnack(true);
            }
            InvoiceMisc_dtlsReset();
            InvoiceService.getMisc(invoicevalues.InvoiceId).then(res => {
                setinvoicedetails(res.data);
            })
        }).catch(error => {
            setMessage(error.message);
            setSeverity('error');
            setOpenSnack(true);
            InvoiceMisc_dtlsReset();
        })
    }
    const InvoiceMisc_dtlsUpdate = () => {
        setInvoiceUpdateDsa(true);
        setInvoiceProcsUpd(true);
        let details = {
            miscId: invoicevalues.miscId, invoiceId: invoicevalues.InvoiceId, miscCode: dialoginvoicevalues.MiscCodeType, miscDescription: dialoginvoicevalues.MiscDescription,
            miscRate: dialoginvoicevalues.MiscRate, miscAmount: dialoginvoicevalues.MiscAmmount
        }
        InvoiceService.updateMisc(details).then(res => {
            const message = res.data.message;
            if (message.toString() === "SUCCESS") {
                setMessage('Updated SuccessFully')
                setOpenSnack(true);
                setSeverity('success')
            }
            else {
                setMessage(message.toString());
                setSeverity('error');
                setOpenSnack(true);
            }
            InvoiceMisc_dtlsReset();
            InvoiceService.getMisc(invoicevalues.InvoiceId).then(res => {
                setinvoicedetails(res.data);
            })
        }).catch(error => {
            setMessage(error.message);
            setSeverity('error');
            setOpenSnack(true);
            InvoiceMisc_dtlsReset();
        })
    }
    const InvoiceMisc_dtlsDelete = () => {
        setInvoiceDeleteDsa(true);
        setInvoiceProcsDlt(true);
        InvoiceService.deleteMisc(invoicevalues.miscId).then(res => {
            const message = res.data.message;
            if (message.toString() === 'SUCCESS') {
                setMessage('Deleted Successfully');
                setOpenSnack(true);
                setSeverity('success')
            }
            else {
                setMessage(message.toString());
                setSeverity('error');
                setOpenSnack(true);
            }
            InvoiceMisc_dtlsReset();
            InvoiceService.getMisc(invoicevalues.InvoiceId).then(res => {
                setinvoicedetails(res.data);
            })
        }).catch(error => {
            setMessage(error.message);
            setSeverity('error');
            setOpenSnack(true);
            InvoiceDiscount_dtlsReset();
        })
    }
    const InvoiceMisc_dtlsReset = () => {
        setdialoginvoicevalues({ ...dialoginvoicevalues, MiscCodeType: '', MiscDescription: '', MiscRate: '', MiscAmmount: '' });

        setInvoiceSaveDsa(false);
        setInvoiceUpdateDsa(true);
        setInvoiceDeleteDsa(true);

        setInvoiceProcsSve(false);
        setInvoiceProcsUpd(false);
        setInvoiceProcsDlt(false);
    }

    // ...............................inputsonchangemethodcode..............................................
    const InvoiceInvoiceNoChangeHandle = (e) => {
        setinvoiceValues({ ...invoicevalues, invoiceNo: e.target.value.replace(/[`~!@#$%^&*()_|+{}=[?;:'",.<>]/gi, '') })
    }
    const InvoiceInvoicedateChangeHandle = (e) => {
        setinvoiceValues({ ...invoicevalues, invoiceDate: e.target.value })
    }
    const InvoiceInvoiceValueChangeHandle = (e) => {
        setinvoiceValues({ ...invoicevalues, invoiceValue: e.target.value.replace(/[^0-9.]/ig, '') })
    }
    const InvoiceCurrencyValueChangeHandle = (e) => {
        setinvoiceValues({ ...invoicevalues, Currency: e.target.value.replace(/[`~0-9!@#$%^&*()_|+{}=[?;:'",.<>]/gi, '') });
        var currency_code = '';
        if (e.target.value !== '') {
            currency_code = e.target.value;
        }
        else {
            currency_code = '-1';
        }
        let details = { currency_code: currency_code, currencyPrefix: '-1', flag: 1 }
        InvoiceService.getCurrency(details).then(res => {
            const data = res.data;
            const currencydetails = data.map((trns) => trns.indianValue)
            if (e.target.value === '') {
                setinvoiceValues({ ...invoicevalues, Currency: e.target.value.replace(/[`~0-9!@#$%^&*()_|+{}=[?;:'",.<>]/gi, ''), ExchangeRate: '' })
            }
            else {
                setinvoiceValues({ ...invoicevalues, Currency: e.target.value.replace(/[`~0-9!@#$%^&*()_|+{}=[?;:'",.<>]/gi, ''), ExchangeRate: currencydetails[0] })
            }
        })
    }
    const InvoiceExchangeRateChangeHandle = (e) => {
        setinvoiceValues({ ...invoicevalues, ExchangeRate: e.target.value })
    }
    const InvoiceTermsChangeHandle = (e) => {
        setinvoiceValues({ ...invoicevalues, Terms: e.target.value.replace(/[`~0-9!@#$%^&*()_|+{}=[?;:'",.<>]/gi, '') })
    }
    const InvoiceSupplierNameChangeHandle = (e) => {
        setinvoiceValues({ ...invoicevalues, SupplierName: e.target.value.replace(/[`~0-9!@#$%^&*()_|+{}=[?;:'"<>]/gi, '') })
    }
    const InvoiceAddress1ChangeHandle = (e) => {
        setinvoiceValues({ ...invoicevalues, Address1: e.target.value.replace(/[`~!@#$%^&*()_|+{}=[?;:'"<>]/gi, '') })
    }
    const InvoiceAddress2ChangeHandle = (e) => {
        setinvoiceValues({ ...invoicevalues, Address2: e.target.value.replace(/[`~!@#$%^&*()_|+{}=[?;:'"<>]/gi, '') })
    }
    const InvoiceSupplierCountryChangeHandle = (e) => {
        setinvoiceValues({ ...invoicevalues, SupplierCountry: e.target.value.replace(/[`~0-9!@#$%^&*()_|+{}=[?;:'"<>]/gi, '') })
        var countryId = '';
        if (e.target.value !== '') {
            countryId = e.target.value
        }
        else {
            countryId = '-1';
        }
        let details = { countryIdString: countryId, countryName: '-1', flag: 2 }
        JobServices.getCountryName(details).then(res => {
            const data = res.data;
            const countryname = data.map((trns) => trns.countryName)
            if (e.target.value === '') {
                setinvoiceValues({ ...invoicevalues, SupplierCountry: e.target.value.replace(/[`~0-9!@#$%^&*()_|+{}=[?;:'",.<>]/gi, ''), disable_supcountry_Name: '' })
            }
            else {
                setinvoiceValues({ ...invoicevalues, SupplierCountry: e.target.value.replace(/[`~0-9!@#$%^&*()_|+{}=[?;:'",.<>]/gi, ''), disable_supcountry_Name: countryname[0] })
            }
        })
    }
    const InvoiceAddress3ChangeHandle = (e) => {
        setinvoiceValues({ ...invoicevalues, Address3: e.target.value.replace(/[`~!@#$%^&*()_|+{}=[?;:'"<>]/gi, '') })
    }
    const InvoicePinCodeChangeHandle = (e) => {
        setinvoiceValues({ ...invoicevalues, PinCode: e.target.value.replace(/[^0-9.]/ig, '') })
    }
    const InvoiceSVBLoadingChangeHandle = (e) => {
        if (e.target.value === 'y' || e.target.value === 'Y' || e.target.value === "N" || e.target.value === "n" || e.target.value === '') {
            setinvoiceValues({ ...invoicevalues, SVBLoading: e.target.value })
            if (e.target.value === 'Y' || e.target.value === 'y') { InvoiceSvbLoadingkeyhandleopen(); document.getElementById('SVBDescription').focus(); }
            else if (e.target.value === "N" || e.target.value === "n") { document.getElementById('SVBDescription').focus(); }
        }
    }
    const InvoiceSVBDescriptionChangeHandle = (e) => {
        setinvoiceValues({ ...invoicevalues, SVBDescription: e.target.value.replace(/[`~!@#$%^&*_|+{}=[?;:'"<>]/gi, '') })
    }
    const InvoiceThirdpartyChangeHandle = (e) => {
        if (e.target.value === 'y' || e.target.value === 'Y' || e.target.value === "N" || e.target.value === "n" || e.target.value === '') {
            setinvoiceValues({ ...invoicevalues, Thirdparty: e.target.value })
            if (e.target.value === 'Y' || e.target.value === 'y') {
                InvoiceThirdPartyhandleopen();
            }
            else if (e.target.value === "N" || e.target.value === "n") {
                e.preventDefault();
                document.getElementById('invoiceSeller').focus();
            }

        }
    }
    const InvoiceSellerChangeHandle = (e) => {
        if (e.target.value === 'y' || e.target.value === 'Y' || e.target.value === "N" || e.target.value === "n" || e.target.value === '') {
            setinvoiceValues({ ...invoicevalues, Seller: e.target.value })
            if (e.target.value === 'Y' || e.target.value === 'y') {
                InvoiceSellerhandleopen();
            }
            else if (e.target.value === "N" || e.target.value === "n") {
                e.preventDefault();
                document.getElementById('invoicebroker').focus();
            }
        }
    }
    const InvoiceBrokerChangeHandle = (e) => {
        if (e.target.value === 'y' || e.target.value === 'Y' || e.target.value === "N" || e.target.value === "n" || e.target.value === '') {
            setinvoiceValues({ ...invoicevalues, Broker: e.target.value })
            if (e.target.value === 'Y' || e.target.value === 'y') {
                InvoiceBrokerhandleopen();
            }
            else if (e.target.value === "N" || e.target.value === "n") {
                e.preventDefault();
                document.getElementById('invoicerela_bw_bs').focus();
            }
        }
    }
    const InvoiceRelationBetweenBuyerSellerChangeHandle = (e) => {
        if (e.target.value === 'y' || e.target.value === 'Y' || e.target.value === "N" || e.target.value === "n" || e.target.value === '') {
            document.getElementById('invoiceNatureOfTransaction').focus()
            setinvoiceValues({ ...invoicevalues, RelationBetweenBuyerSeller: e.target.value })
        }
    }
    const InvoiceNatureOfTransactionChangeHandle = (e) => {
        setinvoiceValues({ ...invoicevalues, NatureOfTransaction: e.target.value })
        var NatureofTrans = '';
        if (e.target.value !== '') {
            NatureofTrans = e.target.value;
        }
        else {
            NatureofTrans = '-1';
        }
        let details = { transactionCode: NatureofTrans, transactionName: '-1', flag: 2 }
        InvoiceService.getTransactionMode(details).then(res => {
            const data = res.data;
            const Nature = data.map((trns) => trns.transactionName)
            if (e.target.value === '') {
                setinvoiceValues({ ...invoicevalues, NatureOfTransaction: e.target.value, disable_NatureofTransaction_Name: '' })
            }
            else {
                setinvoiceValues({ ...invoicevalues, NatureOfTransaction: e.target.value, disable_NatureofTransaction_Name: Nature[0] })
            }
        })
    }
    const InvoiceTermOfPaymentChangeHandle = (e) => {
        setinvoiceValues({ ...invoicevalues, TermOfPayment: e.target.value })
        var Termspayment = '';
        if (e.target.value !== '') {
            Termspayment = e.target.value;
        }
        else {
            Termspayment = '-1';
        }
        let details = { paymentTermsCode: Termspayment, paymentTermsName: '-1', flag: 2 }
        InvoiceService.getpaymentTerms(details).then(res => {
            const data = res.data;
            const trmsOfPymnt = data.map((trns) => trns.paymentTermsName)
            if (e.target.value === '') {
                setinvoiceValues({ ...invoicevalues, TermOfPayment: e.target.value, disable_Termsofpayment: '' })
            }
            else {
                setinvoiceValues({ ...invoicevalues, TermOfPayment: e.target.value, disable_Termsofpayment: trmsOfPymnt[0] })
            }
        })
    }
    const InvoiceConditionsOfRestrictionSaleChangeHandle = (e) => {
        if (e.target.value === 'Y' || e.target.value === 'y' || e.target.value === 'N' || e.target.value === 'n' || e.target.value === '') {
            setinvoiceValues({ ...invoicevalues, ConditionsOfRestrictionSale: e.target.value })
        }
    }
    const InvoiceValuationMethodChangeHandle = (e) => {
        setinvoiceValues({ ...invoicevalues, ValuationMethod: e.target.value })
        var Valuationmethod = '';
        if (e.target.value !== '') {
            Valuationmethod = e.target.value;
        }
        else {
            Valuationmethod = '-1';
        }
        let details = { valuationMethodCode: Valuationmethod, valuationMethodName: '-1', flag: 2 }
        InvoiceService.getValuationMethod(details).then(res => {
            const data = res.data;
            const valuaionmthd = data.map((trns) => trns.valuationMethodName)
            if (e.target.value === '') {
                setinvoiceValues({ ...invoicevalues, ValuationMethod: e.target.value, disable_valuationmethod: '' })
            }
            else {
                setinvoiceValues({ ...invoicevalues, ValuationMethod: e.target.value, disable_valuationmethod: valuaionmthd[0] })
            }
        })
    }
    const InvoiceDiscountChargesIncludedInThisInvoiceChangeHandle = (e) => {
        if (e.target.value === 'y' || e.target.value === 'Y' || e.target.value === "N" || e.target.value === "n" || e.target.value === '') {
            setinvoiceValues({ ...invoicevalues, DiscountChargesIncludedInThisInvoice: e.target.value })
            if (e.target.value === 'Y' || e.target.value === 'y') {
                InvoiceAddDiscountDetailshandleopen();
            }
            else if (e.target.value === "N" || e.target.value === "n") {
                e.preventDefault();
                document.getElementById('invoiceCummulativeCharges').focus();
            }
        }
    }
    const InvoiceCummulativeChargesChangeHandle = (e) => {
        if (e.target.value === "y" || e.target.value === 'Y' || e.target.value === 'N' || e.target.value === 'n' || e.target.value === '') {
            setinvoiceValues({ ...invoicevalues, CummulativeCharges: e.target.value })
        }
    }
    const InvoiceAreThereMiscChargesNotSpecifiedInThisInvoiceChangeHandle = (e) => {
        if (e.target.value === 'y' || e.target.value === 'Y' || e.target.value === "N" || e.target.value === "n" || e.target.value === '') {
            setinvoiceValues({ ...invoicevalues, AreThereMiscChargesNotSpecifiedInThisInvoice: e.target.value })
            if (e.target.value === 'Y' || e.target.value === 'y') {
                InvoiceAddMiscDetailshandleopen();
            }
            else if (e.target.value === "N" || e.target.value === "n") {
                e.preventDefault();
                document.getElementById('invoiceaeocode').focus();
            }
        }
    }
    const InvoicePurchaseOrderDetailsNoChangeHandle = (e) => {
        setinvoiceValues({ ...invoicevalues, PurchaseOrderDetailsNo: e.target.value })
    }
    const InvoicePurchaseOrderDetailsDateChangeHandle = (e) => {
        setinvoiceValues({ ...invoicevalues, PurchaseOrderDetailsDate: e.target.value })
    }
    const InvoiceContractDetailsNoChangeHandle = (e) => {
        setinvoiceValues({ ...invoicevalues, ContractDetailsNo: e.target.value })
    }
    const InvoiceContractDetailsDateChangeHandle = (e) => {
        setinvoiceValues({ ...invoicevalues, ContractDetailsDate: e.target.value })
    }
    const InvoiceLetterOfCreditDetailsNoChangeHandle = (e) => {
        setinvoiceValues({ ...invoicevalues, LetterOfCreditDetailsNo: e.target.value })
    }
    const InvoiceLetterOfCreditDetailsDateChangeHandle = (e) => {
        setinvoiceValues({ ...invoicevalues, LetterOfCreditDetailsDate: e.target.value })
    }
    const InvoiceAEOCodeChangeHandle = (e) => {
        setinvoiceValues({ ...invoicevalues, AEOCode: e.target.value })
    }
    const InvoiceAEORoleChangeHandle = (e) => {
        setinvoiceValues({ ...invoicevalues, AEORole: e.target.value })
    }
    const InvoiceAEOCountryChangeHandle = (e) => {
        setinvoiceValues({ ...invoicevalues, AEOCountry: e.target.value })
        var Aeocountrycode = '';
        if (e.target.value !== '') {
            Aeocountrycode = e.target.value
        }
        else {
            Aeocountrycode = '-1';
        }
        let details = { countryIdString: Aeocountrycode, countryName: '-1', flag: 2 }
        JobServices.getCountryName(details).then(res => {
            const data = res.data;
            const aeocntry = data.map((trns) => trns.countryName)
            if (e.target.value === '') {
                setinvoiceValues({ ...invoicevalues, AEOCountry: e.target.value, disable_AeocountryName: '' })
            }
            else {
                setinvoiceValues({ ...invoicevalues, AEOCountry: e.target.value, disable_AeocountryName: aeocntry[0] })
            }
        })
    }
    const InvoiceLoadNoChangeHandle = (e) => {
        setinvoiceValues({ ...invoicevalues, LoadNo: e.target.value })
    }
    const InvoiceCondition1ChangeHandle = (e) => {
        setinvoiceValues({ ...invoicevalues, Condition1: e.target.value })
    }
    const InvoiceCondition2ChangeHandle = (e) => {
        setinvoiceValues({ ...invoicevalues, Condition2: e.target.value })
    }
    const InvoiceOtherInformationChangeHandle = (e) => {
        setinvoiceValues({ ...invoicevalues, OtherInformation: e.target.value })
    }
    // ...........................dailogonchangeinputcodes.............................
    const InvoiceFindCurrencyNameChangeHandle = (e) => {
        setdialoginvoicevalues({ ...dialoginvoicevalues, FindCurrencyName: e.target.value })
        var currencyPrefix = '';
        if (e.target.value !== '') {
            currencyPrefix = e.target.value;
        }
        else {
            currencyPrefix = '-1';
        }
        let details = { currency_code: '-1', currencyPrefix: currencyPrefix, flag: 1 }
        InvoiceService.getCurrency(details).then(res => {
            setinvoicedetails(res.data);
        })
    }
    const InvoiceFindCurrencyCodeChangeHandle = (e) => {
        setdialoginvoicevalues({ ...dialoginvoicevalues, FindCurrencyCode: e.target.value })
        var currency_code = '';
        if (e.target.value !== '') {
            currency_code = e.target.value;
        }
        else {
            currency_code = '-1';
        }
        let details = { currency_code: currency_code, currencyPrefix: '-1', flag: 1 }
        InvoiceService.getCurrency(details).then(res => {
            setinvoicedetails(res.data);
        })
    }
    const InvoiceFindTermsNameChangeHandle = (e) => {
        setdialoginvoicevalues({ ...dialoginvoicevalues, FindTermsName: e.target.value })
        var InvoiceTermsName = '';
        if (e.target.value !== '') {
            InvoiceTermsName = e.target.value;
        }
        else {
            InvoiceTermsName = '-1'
        }
        let details = { terms_code: '-1', terms_Name: InvoiceTermsName, flag: 2 }
        InvoiceService.getInvoiceTerms(details).then(res => {
            setinvoicedetails(res.data);
        })
    }
    const InvoiceFindTermsCodeChangeHandle = (e) => {
        setdialoginvoicevalues({ ...dialoginvoicevalues, FindTermsCode: e.target.value })
        var InvoiceTermscode = '';
        if (e.target.value !== '') {
            InvoiceTermscode = e.target.value;
        }
        else {
            InvoiceTermscode = '-1'
        }
        let details = { terms_code: InvoiceTermscode, terms_Name: '-1', flag: 2 }
        InvoiceService.getInvoiceTerms(details).then(res => {
            setinvoicedetails(res.data);
        })
    }
    const InvoiceFindSupplierNameChangeHandle = (e) => {
        setdialoginvoicevalues({ ...dialoginvoicevalues, FindSupplierName: e.target.value })
        var SupplierName = '';
        if (e.target.value !== '') {
            SupplierName = e.target.value;
        }
        else {
            SupplierName = '-1';
        }
        let details = { supplierName: SupplierName, flag: 2 }
        InvoiceService.getSupplierDetails(details).then(res => {
            setinvoicedetails(res.data);
        })
    }
    const InvoiceFindCountryNameChangeHandle = (e) => {
        setdialoginvoicevalues({ ...dialoginvoicevalues, FindCountryName: e.target.value })
        var countryname = '';
        if (e.target.value !== '') {
            countryname = e.target.value;

        }
        else {
            countryname = '-1';
        }
        let details = { countryIdString: '-1', countryName: countryname, flag: 2 }
        JobServices.getCountryName(details).then(res => {
            setinvoicedetails(res.data);
        })
    }
    const InvoiceFindCountryCodeChangeHandle = (e) => {
        setdialoginvoicevalues({ ...dialoginvoicevalues, FindCountryCode: e.target.value })
        var countryid = '';
        if (e.target.value !== '') {
            countryid = e.target.value;

        }
        else {
            countryid = '-1';
        }
        let details = { countryIdString: countryid, countryName: '-1', flag: 2 }
        JobServices.getCountryName(details).then(res => {
            setinvoicedetails(res.data);
        })
    }
    const InvoiceFindTransactionNameChangeHandle = (e) => {
        setdialoginvoicevalues({ ...dialoginvoicevalues, FindTransactionName: e.target.value })
        var NatureofTransname = '';
        if (e.target.value !== '') {
            NatureofTransname = e.target.value;
        }
        else {
            NatureofTransname = '-1';
        }
        let details = { transactionCode: '-1', transactionName: NatureofTransname, flag: 2 }
        InvoiceService.getTransactionMode(details).then(res => {
            setinvoicedetails(res.data);
        })
    }
    const InvoiceFindTransactionCodeChangeHandle = (e) => {
        setdialoginvoicevalues({ ...invoicevalues, FindTransactionCode: e.target.value })
        var transactionCode = '';
        if (e.target.value !== '') {
            transactionCode = e.target.value;
        }
        else {
            transactionCode = '-1';
        }
        let details = { transactionCode: transactionCode, transactionName: '-1', flag: 2 }
        InvoiceService.getTransactionMode(details).then(res => {
            setinvoicedetails(res.data);
        })
    }
    const InvoiceFindPaymentTermsNameChangeHandle = (e) => {
        setdialoginvoicevalues({ ...dialoginvoicevalues, FindPaymentTermsName: e.target.value })
        var Termspaymentname = '';
        if (e.target.value !== '') {
            Termspaymentname = e.target.value;
        }
        else {
            Termspaymentname = '-1';
        }
        let details = { paymentTermsCode: '-1', paymentTermsName: Termspaymentname, flag: 2 }
        InvoiceService.getpaymentTerms(details).then(res => {
            setinvoicedetails(res.data);
        })
    }
    const InvoiceFindPaymentTermsCodeChangeHandle = (e) => {
        setdialoginvoicevalues({ ...dialoginvoicevalues, FindPaymentTermsCode: e.target.value })
        var Termspaymentcode = '';
        if (e.target.value !== '') {
            Termspaymentcode = e.target.value;
        }
        else {
            Termspaymentcode = '-1';
        }
        let details = { paymentTermsCode: Termspaymentcode, paymentTermsName: '-1', flag: 2 }
        InvoiceService.getpaymentTerms(details).then(res => {
            setinvoicedetails(res.data);
        })
    }
    const InvoiceValuationFindPaymentTermsNameChangeHandle = (e) => {
        setdialoginvoicevalues({ ...dialoginvoicevalues, ValuationFindPaymentTermsName: e.target.value })
        var Valuationmethodname = '';
        if (e.target.value !== '') {
            Valuationmethodname = e.target.value;
        }
        else {
            Valuationmethodname = '-1';
        }
        let details = { valuationMethodCode: '-1', valuationMethodName: Valuationmethodname, flag: 2 }
        InvoiceService.getValuationMethod(details).then(res => {
            setinvoicedetails(res.data);
        })
    }
    const InvoiceValuationFindPaymentTermsCodeChangeHandle = (e) => {
        setdialoginvoicevalues({ ...dialoginvoicevalues, ValuationFindPaymentTermsCode: e.target.value })
        var Valuationmethodcode = '';
        if (e.target.value !== '') {
            Valuationmethodcode = e.target.value;
        }
        else {
            Valuationmethodcode = '-1';
        }
        let details = { valuationMethodCode: Valuationmethodcode, valuationMethodName: '-1', flag: 2 }
        InvoiceService.getValuationMethod(details).then(res => {
            setinvoicedetails(res.data);
        })
    }
    const InvoiceAeoFindCountryNameChangeHandle = (e) => {
        setdialoginvoicevalues({ ...dialoginvoicevalues, AeoFindCountryName: e.target.value })
        var Aeocountryname = '';
        if (e.target.value !== '') {
            Aeocountryname = e.target.value;
        }
        else {
            Aeocountryname = '-1';
        }
        let details = { countryIdString: '-1', countryName: Aeocountryname, flag: 2 }
        JobServices.getCountryName(details).then(res => {
            setinvoicedetails(res.data);
        })
    }
    const InvoiceAeoFindCountryCodeChangeHandle = (e) => {
        setdialoginvoicevalues({ ...dialoginvoicevalues, AeoFindCountryCode: e.target.value })
        var Aeocountrycode = '';
        if (e.target.value !== '') {
            Aeocountrycode = e.target.value;
        }
        else {
            Aeocountrycode = '-1';
        }
        let details = { countryIdString: Aeocountrycode, countryName: '-1', flag: 2 }
        JobServices.getCountryName(details).then(res => {
            setinvoicedetails(res.data);
        })
    }
    // ......................................KeyUpdialogcode....................................

    //termsOnchange

    const FreightCHARGESchangehandle = (e) => {
        setBifrctionStsValues({ ...BifrctionStsValues, FreightCHARGES: e.target.value })
    }
    const FreightCURRENCYchangehandle = (e) => {
        const filtervalue = invoicedetails.find((trns) => trns.currency_code === e.target.value)
        setBifrctionStsValues({ ...BifrctionStsValues, FreightCURRENCY: e.target.value, FreightEXCHANGE: filtervalue.indianValue });
    }
    const FreightEXCHANGEchangehandle = (e) => {
        setBifrctionStsValues({ ...BifrctionStsValues, FreightEXCHANGE: e.target.value })
    }
    const FreightRATEchangehandle = (e) => {
        setBifrctionStsValues({ ...BifrctionStsValues, FreightRATE: e.target.value })
        var InvoicValue, FreightRate, Freightvalue = '';
        if (BifrctionStsValues.MiscValuesCHARGES !== '0' || BifrctionStsValues.MiscValuesCHARGES !== '0.00' || BifrctionStsValues.MiscValuesCHARGES !== 0) {
            InvoicValue = (parseFloat(invoicevalues.invoiceValue) + parseFloat(BifrctionStsValues.MiscValuesCHARGES));
        } else {
            InvoicValue = invoicevalues.invoiceValue;
        }
        FreightRate = e.target.value;
        Freightvalue = ((InvoicValue * FreightRate) / 100)
        setBifrctionStsValues({ ...BifrctionStsValues, FreightCHARGES: parseFloat(Freightvalue).toFixed(2), FreightRATE: e.target.value })
    }
    const InsuranceCHARGESchangehandle = (e) => {
        setBifrctionStsValues({ ...BifrctionStsValues, InsuranceCHARGES: e.target.value })

    }
    const InsuranceCURRENCYchangehandle = (e) => {
        const filtervalue = invoicedetails.find((trns) => trns.currency_code === e.target.value)
        setBifrctionStsValues({ ...BifrctionStsValues, InsuranceCURRENCY: e.target.value, InsuranceEXCHANGE: filtervalue.indianValue })
    }
    const InsuranceEXCHANGEchangehandle = (e) => {
        setBifrctionStsValues({ ...BifrctionStsValues, InsuranceEXCHANGE: e.target.value })
    }
    const InsuranceRATEchangehandle = (e) => {
        setBifrctionStsValues({ ...BifrctionStsValues, InsuranceRATE: e.target.value })
        var InvoicValue, InsuranceRate, Insurancevalue = '';
        if (BifrctionStsValues.MiscValuesCHARGES !== '0' || BifrctionStsValues.MiscValuesCHARGES !== '0.00') {
            InvoicValue = (parseFloat(invoicevalues.invoiceValue) + parseFloat(BifrctionStsValues.MiscValuesCHARGES));
        } else {
            InvoicValue = invoicevalues.invoiceValue;
        }
        InsuranceRate = e.target.value;
        Insurancevalue = ((InvoicValue * InsuranceRate) / 100)
        setBifrctionStsValues({ ...BifrctionStsValues, InsuranceCHARGES: parseFloat(Insurancevalue).toFixed(2), InsuranceRATE: e.target.value })
    }
    const AgencyComCHARGESchangehandle = (e) => {
        setBifrctionStsValues({ ...BifrctionStsValues, AgencyComCHARGES: e.target.value })
    }
    const AgencyComCURRENCYchangehandle = (e) => {
        const filtervalue = invoicedetails.find((trns) => trns.currency_code === e.target.value)
        setBifrctionStsValues({ ...BifrctionStsValues, AgencyComCURRENCY: e.target.value, AgencyComEXCHANGE: filtervalue.indianValue })
    }
    const AgencyComEXCHANGEchangehandle = (e) => {
        setBifrctionStsValues({ ...BifrctionStsValues, AgencyComEXCHANGE: e.target.value })
    }
    const AgencyComRATEchangehandle = (e) => {
        setBifrctionStsValues({ ...BifrctionStsValues, AgencyComRATE: e.target.value })
        var invoicevalue, agencyrate, agencyvalue = '';
        invoicevalue = invoicevalues.invoiceValue;
        agencyrate = e.target.value;
        agencyvalue = ((parseFloat(invoicevalue) * parseFloat(agencyrate)) / 100)
        setBifrctionStsValues({ ...BifrctionStsValues, AgencyComCHARGES: parseFloat(agencyvalue).toFixed(2), AgencyComRATE: e.target.value })
    }
    const LoadingCHARGESchangehandle = (e) => {
        setBifrctionStsValues({ ...BifrctionStsValues, LoadingCHARGES: e.target.value })
    }
    const LoadingCURRENCYchangehandle = (e) => {
        const filtervalue = invoicedetails.find((trns) => trns.currency_code === e.target.value)
        setBifrctionStsValues({ ...BifrctionStsValues, LoadingCURRENCY: e.target.value, LoadingEXCHANGE: filtervalue.indianValue })
    }
    const LoadingEXCHANGEchangehandle = (e) => {
        setBifrctionStsValues({ ...BifrctionStsValues, LoadingEXCHANGE: e.target.value, })
    }
    const LoadingRATEchangehandle = (e) => {
        setBifrctionStsValues({ ...BifrctionStsValues, LoadingRATE: e.target.value })
        var invoicevalue, loadingrate, loadingvalue = '';
        invoicevalue = invoicevalues.invoiceValue;
        loadingrate = e.target.value;
        loadingvalue = ((parseFloat(invoicevalue) * parseFloat(loadingrate)) / 100)
        setBifrctionStsValues({ ...BifrctionStsValues, LoadingCHARGES: parseFloat(loadingvalue).toFixed(2), LoadingRATE: e.target.value })
    }
    const MiscValuesCHARGESchangehandle = (e) => {
        setBifrctionStsValues({ ...BifrctionStsValues, MiscValuesCHARGES: e.target.value })
    }
    const MiscValuesCURRENCYchangehandle = (e) => {
        const filtervalue = invoicedetails.find((trns) => trns.currency_code === e.target.value)
        setBifrctionStsValues({ ...BifrctionStsValues, MiscValuesCURRENCY: e.target.value, MiscValuesEXCHANGE: filtervalue.indianValue })
    }
    const MiscValuesEXCHANGEchangehandle = (e) => {
        setBifrctionStsValues({ ...BifrctionStsValues, MiscValuesEXCHANGE: e.target.value })
    }
    const MisValuesRATEchangehandle = (e) => {
        setBifrctionStsValues({ ...BifrctionStsValues, MiscValuesRATE: e.target.value })
        var invoicevalue, miscvalueraterate, miscvalue = '';
        invoicevalue = invoicevalues.invoiceValue;
        miscvalueraterate = e.target.value;
        miscvalue = ((parseFloat(invoicevalue) * parseFloat(miscvalueraterate)) / 100);
        var InvoicValue, InsuranceRate, Insurancevalue, FreightRate, Freightvalue = '';
        if (miscvalue !== '0' || miscvalue !== '0.00') {
            InvoicValue = (parseFloat(invoicevalues.invoiceValue) + parseFloat(miscvalue));
        } else {
            InvoicValue = invoicevalues.invoiceValue;
        }

        InsuranceRate = BifrctionStsValues.InsuranceRATE
        Insurancevalue = ((InvoicValue * InsuranceRate) / 100);
        FreightRate = BifrctionStsValues.FreightRATE
        Freightvalue = ((InvoicValue * FreightRate) / 100);
        setBifrctionStsValues({
            ...BifrctionStsValues, MiscValuesCHARGES: parseFloat(miscvalue).toFixed(2), MiscValuesRATE: e.target.value,
            InsuranceCHARGES: parseFloat(Insurancevalue).toFixed(2), FreightCHARGES: parseFloat(Freightvalue).toFixed(2)
        })
    }
    const HSSValuesCHARGESchangehandle = (e) => {
        setBifrctionStsValues({ ...BifrctionStsValues, HSSValuesCHARGES: e.target.value })
    }
    const HSSValuesRATEchangehandle = (e) => {
        setBifrctionStsValues({ ...BifrctionStsValues, HSSValuesRATE: e.target.value })
        var invoicevalue, Hssrate, Hssvalue = '';
        invoicevalue = invoicevalues.invoiceValue;
        Hssrate = e.target.value;
        Hssvalue = ((parseInt(invoicevalue) * parseInt(Hssrate)) / 100)
        setBifrctionStsValues({ ...BifrctionStsValues, HSSValuesCHARGES: Hssvalue, HSSValuesRATE: e.target.value })
    }
    const LandingValuesRATEchangehandle = (e) => {
        setBifrctionStsValues({ ...BifrctionStsValues, LandingRATE: e.target.value })
    }
    // .......autobrification......./
    const FreightDetailsCHARGESchangehandle = (e) => {
        setBifrctionStsValues({ ...BifrctionStsValues, FreightDetailsCHARGES: e.target.value })
    }
    const FreightDetailsCURRENCYchangehandle = (e) => {
        const filtervalue = invoicedetails.find((trns) => trns.currency_code === e.target.value);
        setBifrctionStsValues({ ...BifrctionStsValues, FreightDetailsCURRENCY: e.target.value, FreightDetailsExchange: filtervalue.indianValue })
    }
    const FreightDetailsRATEchangehandle = (e) => {
        setBifrctionStsValues({ ...BifrctionStsValues, FreightDetailsRATE: e.target.value })
    }
    const InsuranceDetailsCHARGESchangehandle = (e) => {
        setBifrctionStsValues({ ...BifrctionStsValues, InsuranceDetailsCHARGES: e.target.value })
    }
    const InsuranceDetailsCURRENCYchangehandle = (e) => {
        const filtervalue = invoicedetails.find((trns) => trns.currency_code === e.target.value);
        setBifrctionStsValues({ ...BifrctionStsValues, InsuranceDetailsCURRENCY: e.target.value, InsuranceDetailsExchange: filtervalue.indianValue })
    }
    const InsuranceDetailsRATEchangehandle = (e) => {
        setBifrctionStsValues({ ...BifrctionStsValues, InsuranceDetailsRATE: e.target.value })
    }
    const MiscDetailsCHARGESchangehandle = (e) => {
        setBifrctionStsValues({ ...BifrctionStsValues, MiscDetailsCHARGES: e.target.value })
    }
    const MiscDetailsCURRENCYchangehandle = (e) => {
        const filtervalue = invoicedetails.find((trns) => trns.currency_code === e.target.value)
        setBifrctionStsValues({ ...BifrctionStsValues, MiscDetailsCURRENCY: e.target.value, MiscDetailsEXCHANGE: filtervalue.indianValue })
    }
    const MiscDetailsRATEchangehandle = (e) => {
        setBifrctionStsValues({ ...BifrctionStsValues, MiscDetailsRATE: e.target.value })
    }
    const AgencyCommCHARGESchangehandle = (e) => {
        setBifrctionStsValues({ ...BifrctionStsValues, AgencyCommCHARGES: e.target.value })
    }
    const AgencyCommCURRENCYchangehandle = (e) => {
        const filtervalue = invoicedetails.find((trns) => trns.currency_code === e.target.value)
        setBifrctionStsValues({ ...BifrctionStsValues, AgencyCommCURRENCY: e.target.value, AgencycommDetailsExchange: filtervalue.indianValue })
    }
    const AgencyCommRATEchangehandle = (e) => {
        setBifrctionStsValues({ ...BifrctionStsValues, AgencyCommRATE: e.target.value })
    }
    // ...................//
    const InvoiceSVBReferenceNoChangeHandle = (e) => {
        setdialoginvoicevalues({ ...dialoginvoicevalues, SVBReferenceNo: e.target.value })
    }
    const InvoiceSVBDateChangeHandle = (e) => {
        setdialoginvoicevalues({ ...dialoginvoicevalues, SVBDate: e.target.value })
    }
    const InvoiceCustomHouseCodeChangeHandle = (e) => {
        setdialoginvoicevalues({ ...dialoginvoicevalues, CustomHouseCode: e.target.value })
    }
    const InvoiceSVBTypeChangeHandle = (e) => {
        if (e.target.value === 'A' || e.target.value === 'a' || e.target.value === '') {
            setdialoginvoicevalues({ ...dialoginvoicevalues, SVBType: e.target.value })
            setinvoiceSvb_duty_Hidn(true)
        }
        if (e.target.value === 'D' || e.target.value === 'd' || e.target.value === '') {
            setdialoginvoicevalues({ ...dialoginvoicevalues, SVBType: e.target.value })
            setinvoiceSvb_AV_Hidn(true)
        }
        if (e.target.value === 'B' || e.target.value === 'b' || e.target.value === '') {
            setdialoginvoicevalues({ ...dialoginvoicevalues, SVBType: e.target.value })
            setinvoiceSvb_AV_Hidn(false)
            setinvoiceSvb_duty_Hidn(false)
        }
    }
    const InvoiceSVB_Load_Assable_Value_percentageChangeHandle = (e) => {
        setdialoginvoicevalues({ ...dialoginvoicevalues, SVB_Load_Assable_Value_percentage: e.target.value })
    }
    const InvoiceSVB_Load_Duty_PercentageChangeHandle = (e) => {
        setdialoginvoicevalues({ ...dialoginvoicevalues, SVB_Load_Duty_Percentage: e.target.value })
    }
    const InvoiceAv_is_Final_or_ProvisionalChangeHandle = (e) => {
        setdialoginvoicevalues({ ...dialoginvoicevalues, Av_is_Final_or_Provisional: e.target.value })
    }
    const InvoiceDuty_is_Final_or_ProvisionalChangeHandle = (e) => {
        setdialoginvoicevalues({ ...dialoginvoicevalues, Duty_is_Final_or_Provisional: e.target.value })
    }
    const InvoiceFindCusHouseNameChangeHandle = (e) => {
        setdialoginvoicevalues({ ...dialoginvoicevalues, FindCusHouseName: e.target.value })
        var customhousename = '';
        if (e.target.value !== '') {
            customhousename = e.target.value;
        }
        else {
            customhousename = '-1';
        }
        let details = { cusHouseCode: '-1', customHouseLocation: customhousename, flag: '2' }
        JobServices.getCustomHouseCode(details).then(res => {
            setinvoicedetails2(res.data);
        })
    }
    const InvoiceFindCusHouseCodeChangeHandle = (e) => {
        setdialoginvoicevalues({ ...dialoginvoicevalues, FindCusHouseCode: e.target.value })
        var customhousecode = '';
        if (e.target.value !== '') {
            customhousecode = e.target.value;
        }
        else {
            customhousecode = '-1';
        }
        let details = { cusHouseCode: customhousecode, customHouseLocation: '-1', flag: '2' }
        JobServices.getCustomHouseCode(details).then(res => {
            setinvoicedetails2(res.data);
        })
    }
    const InvoiceThirdPartyNameChangeHandle = (e) => {
        setdialoginvoicevalues({ ...dialoginvoicevalues, ThirdPartyName: e.target.value })
    }
    const InvoiceThirdPartyCountryChangeHandle = (e) => {
        setdialoginvoicevalues({ ...dialoginvoicevalues, ThirdPartyCountry: e.target.value })
            ()
    }
    const InvoiceThirdPartyAddressChangeHandle = (e) => {
        setdialoginvoicevalues({ ...dialoginvoicevalues, ThirdPartyAddress: e.target.value })
    }
    const InvoiceThirdPartyCityChangeHandle = (e) => {
        setdialoginvoicevalues({ ...dialoginvoicevalues, ThirdPartyCity: e.target.value })
    }
    const InvoiceThirdPartyPincodeChangeHandle = (e) => {
        setdialoginvoicevalues({ ...dialoginvoicevalues, ThirdPartyPincode: e.target.value })
    }
    const InvoiceThirdPartyDivisionChangeHandle = (e) => {
        setdialoginvoicevalues({ ...dialoginvoicevalues, ThirdPartyDivision: e.target.value })
    }
    const InvoiceFindSupplierNameDialogChangeHandle = (e) => {
        setdialoginvoicevalues({ ...dialoginvoicevalues, FindSupplierNameDialog: e.target.value })
        var Thirdpartyname = '';
        if (e.target.value !== '') {
            Thirdpartyname = e.target.value;
        }
        else {
            Thirdpartyname = '-1';
        }
        let details = { supplierName: Thirdpartyname, flag: '2' }
        InvoiceService.getSupplierDetails(details).then(res => {
            setinvoicedetails2(res.data);
        })
    }
    const InvoiceSellerNameChangeHandle = (e) => {
        setdialoginvoicevalues({ ...dialoginvoicevalues, SellerName: e.target.value })
    }
    const InvoiceSellerCountryChangeHandle = (e) => {
        setdialoginvoicevalues({ ...dialoginvoicevalues, SellerCountry: e.target.value })
    }
    const InvoiceSellerAddressChangeHandle = (e) => {
        setdialoginvoicevalues({ ...dialoginvoicevalues, SellerAddress: e.target.value })
    }
    const InvoiceSellerCityChangeHandle = (e) => {
        setdialoginvoicevalues({ ...dialoginvoicevalues, SellerCity: e.target.value })
    }
    const InvoiceSellerPincodeChangeHandle = (e) => {
        setdialoginvoicevalues({ ...dialoginvoicevalues, SellerPincode: e.target.value })
    }
    const InvoiceSellerDivisionChangeHandle = (e) => {
        setdialoginvoicevalues({ ...dialoginvoicevalues, SellerDivision: e.target.value })
    }
    const InvoiceBrokerNameChangeHandle = (e) => {
        setdialoginvoicevalues({ ...dialoginvoicevalues, BrokerName: e.target.value })
    }
    const InvoiceBrokerCountryChangeHandle = (e) => {
        setdialoginvoicevalues({ ...dialoginvoicevalues, BrokerCountry: e.target.value })
    }
    const InvoiceBrokerAddressChangeHandle = (e) => {
        setdialoginvoicevalues({ ...dialoginvoicevalues, BrokerAddress: e.target.value })
    }
    const InvoiceBrokerCityChangeHandle = (e) => {
        setdialoginvoicevalues({ ...dialoginvoicevalues, BrokerCity: e.target.value })
    }
    const InvoiceBrokerPincodeChangeHandle = (e) => {
        setdialoginvoicevalues({ ...dialoginvoicevalues, BrokerPincode: e.target.value })
    }
    const InvoiceBrokerDivisionChangeHandle = (e) => {
        setdialoginvoicevalues({ ...dialoginvoicevalues, BrokerDivision: e.target.value })
    }
    const InvoiceNatureofDiscountChangeHandle = (e) => {
        setdialoginvoicevalues({ ...dialoginvoicevalues, NatureofDiscount: e.target.value })
    }
    const InvoiceDiscountRateChangeHandle = (e) => {
        setdialoginvoicevalues({ ...dialoginvoicevalues, DiscountRate: e.target.value })
    }
    const InvoiceDiscountAmountChangeHandle = (e) => {
        setdialoginvoicevalues({ ...dialoginvoicevalues, DiscountAmount: e.target.value })
    }
    const InvoiceMiscCodeTypeChangeHandle = (e) => {
        setdialoginvoicevalues({ ...dialoginvoicevalues, MiscCodeType: e.target.value })
    }
    const InvoiceMiscDescriptionChangeHandle = (e) => {
        setdialoginvoicevalues({ ...dialoginvoicevalues, MiscDescription: e.target.value })
    }
    const InvoiceMiscRateChangeHandle = (e) => {
        setdialoginvoicevalues({ ...dialoginvoicevalues, MiscRate: e.target.value })
    }
    const InvoiceMiscAmmountChangeHandle = (e) => {
        setdialoginvoicevalues({ ...dialoginvoicevalues, MiscAmmount: e.target.value })
    }
    const invoiceradioChangeHandle = (e) => {
        setinvoiceradiovalues(e.target.value)

    }
    // ......................................KeyUp event....................................//
    const InvoiceDialogCurruncyCodeKeyDown = (e) => { if (e.key === 'Enter') { document.getElementById('InvoiceDialogCurrunCode').focus(); } }
    const InvoiceDialogTermsNameKeyDown = (e) => { if (e.key === 'Enter') { document.getElementById('InvoiceFindTermsCode').focus(); } }
    const InvoiceDialogSupplierCntryNameKeyDown = (e) => { if (e.key === 'Enter') { document.getElementById('InvoiceFindCntryCode').focus(); } }
    const InvoiceDialogNatureTrnsctionNameKeyDown = (e) => { if (e.key === 'Enter') { document.getElementById('invoiceTransctionCode').focus(); } }
    const InvoiceDialogValutionMethodtermsNameKeyDown = (e) => { if (e.key === 'Enter') { document.getElementById('ValuationPaymentMethodDetails').focus(); } }
    const InvoiceDialogPaymentTermsNameKeyDown = (e) => { if (e.key === 'Enter') { document.getElementById('PaymentTermsCode').focus(); } }
    const InvoiceDialogAEoCountryDetailsKeyDown = (e) => { if (e.key === 'Enter') { document.getElementById('InvoiceAeoFContryCode').focus(); } }
    const invoiceTermsFrightChargsKeDown = (e) => { if (e.key === 'Enter') { document.getElementById('invoiceFrightCurruncy').focus(); } }
    const invoiceTermsFrightCurruncyKeDown = (e) => { if (e.key === 'Enter') { document.getElementById('invoiceFrightExchngRate').focus(); } }
    const invoiceTermsFrightExchangRateKeDown = (e) => { if (e.key === 'Enter') { document.getElementById('InvoiceFrightRate').focus(); } }
    const invoiceTermsFrightRateKeyDown = (e) => { if (e.key === 'Enter') { document.getElementById('InvoiceInsuranceCharges').focus(); } }
    const invoiceTermsInsuranceChargesKeyDown = (e) => { if (e.key === 'Enter') { document.getElementById('InvoiceInsuranceCurruncy').focus(); } }
    const invoiceTermsInsuranceCurruncyKeyDown = (e) => { if (e.key === 'Enter') { document.getElementById('InvoiceInsuranceExchangeRate').focus(); } }
    const invoiceTermsInsuranceExchangeRateKeyDown = (e) => { if (e.key === 'Enter') { document.getElementById('InvoiceInsuranceRate').focus(); } }
    const invoiceTermsInsuranceRateKeyDown = (e) => { if (e.key === 'Enter') { document.getElementById('InvoiceAgencyCharges').focus(); } }
    const invoiceTermsAgencChargesKeyDown = (e) => { if (e.key === 'Enter') { document.getElementById('InvoiceAgencyCurruncy').focus(); } }
    const invoiceTermsAgencyCurruncyKeyDown = (e) => { if (e.key === 'Enter') { document.getElementById('InvoiceAgencyExchangeRate').focus(); } }
    const invoiceTermsAgencyExchangeRateKeyDown = (e) => { if (e.key === 'Enter') { document.getElementById('invoiceAgencyRate').focus(); } }
    const invoiceTermsAgencyRateKeyDown = (e) => { if (e.key === 'Enter') { document.getElementById('invoiceLodingCharges').focus(); } }
    const invoiceTermsLoadChargesKeyDown = (e) => { if (e.key === 'Enter') { document.getElementById('InvoiceLoadingCurruncy').focus(); } }
    const invoiceTermsLoadCurruncyKeyDown = (e) => { if (e.key === 'Enter') { document.getElementById('InvoiceLoadingExchangeRate').focus(); } }
    const invoiceTermsLoadingExchangeRateKeyDown = (e) => { if (e.key === 'Enter') { document.getElementById('invoiceLoadingRate').focus(); } }
    const invoiceTermsLoadingRateKeyDown = (e) => { if (e.key === 'Enter') { document.getElementById('InvoiceMiscCharges').focus(); } }
    const invoiceTermsinvoiceMiscChargesKeyDown = (e) => { if (e.key === 'Enter') { document.getElementById('InvoiceMiscCurruncy').focus(); } }
    const invoiceTermsinvoiceMiscCurruncyKeyDown = (e) => { if (e.key === 'Enter') { document.getElementById('InvoiceCurruncyExchangeRate').focus(); } }
    const invoiceTermsinvoiceMiscExchangeRateKeyDown = (e) => { if (e.key === 'Enter') { document.getElementById('InvoiceExchangeRate').focus(); } }
    const invoiceTermsinvoiceMiscRateKeyDown = (e) => { if (e.key === 'Enter') { document.getElementById('InvoiceHssValueCharges').focus(); } }
    const invoiceTermsinvoiceHssValueChargesKeyDown = (e) => { if (e.key === 'Enter') { document.getElementById('InvoiceHssValueRate').focus(); } }
    const invoiceTermsinvoiceHssValueRateKeyDown = (e) => { if (e.key === 'Enter') { document.getElementById('InvoiceLandingRate').focus(); } }
    const invoiceTermsAutoFrightchrgesKeyDown = (e) => { if (e.key === 'Enter') { document.getElementById('InvoiceAutoFrightCurruncy').focus(); } }
    const invoiceTermsAutoFrightCurruncyKeyDown = (e) => { if (e.key === 'Enter') { document.getElementById('InvoiceAutoFrightRate').focus(); } }
    const invoiceTermsAutoFrightRateKeyDown = (e) => { if (e.key === 'Enter') { document.getElementById('InvoicAutoInsuranceCharges').focus(); } }
    const invoiceTermsAutoInsuranceChargeKeyDown = (e) => { if (e.key === 'Enter') { document.getElementById('InvoiceAutoInsuranceCurruncy').focus(); } }
    const invoiceTermsAutoInsuranceCurruncyKeyDown = (e) => { if (e.key === 'Enter') { document.getElementById('InvoiceAutoInsuranceRate').focus(); } }
    const invoiceTermsAutoInsuranceRateKeyDown = (e) => { if (e.key === 'Enter') { document.getElementById('InvoiceAutoMiscCharges').focus(); } }
    const invoiceTermsAutoMiscChargesKeyDown = (e) => { if (e.key === 'Enter') { document.getElementById('InvoiceAutoMisCurruncy').focus(); } }
    const invoiceTermsAutoMiscCurruncyKeyDown = (e) => { if (e.key === 'Enter') { document.getElementById('InvoiceAutoMiscRate').focus(); } }
    const invoiceTermsAutoMiscRateKeyDown = (e) => { if (e.key === 'Enter') { document.getElementById('InvoiceAutoAgencyCharges').focus(); } }
    const invoiceTermsAutoAgencyChargesKeyDown = (e) => { if (e.key === 'Enter') { document.getElementById('InvoiceAutoAgencyCurrunhcy').focus(); } }
    const invoiceTermsAutoAgencyCurruncyKeyDown = (e) => { if (e.key === 'Enter') { document.getElementById('InvoiceAutoAutoAgencyrate').focus(); } }
    const invoiceTermsAutoAgencyRateKeyDown = (e) => { if (e.key === 'Enter') { InvoiceAutoBifr_Update(); } }
    const invoiceinvoicenokeyup = (e) => { if (e.key === 'Enter') { document.getElementById('invoicedate').focus(); } }
    const invoiceinvoicedatekeyup = (e) => { if (e.key === 'Enter') { document.getElementById('invoicevalue').focus(); } }
    const invoiceinvoicevaluekeyup = (e) => { if (e.key === 'Enter') { document.getElementById('invoicecurrency').focus(); } }
    const invoiceinvoicecurrencykeyup = (e) => {
        if (e.key === 'F7') { InvoiceCurrencyhandleClickOpen(); document.getElementById('invoiceterms').focus(); }
        if (e.key === 'Enter') { document.getElementById('invoiceterms').focus(); }
    }
    const invoiceinvoicetermskeyup = (e) => {
        if (e.key === 'F7') {
            InvoiceTermshandleClickOpen();
        }
        else if (e.key === 'Enter') {
            if (invoiceradiovalues === '1') {
                setinvoicedetails([])
                getAutoBifurcateValue();
                if (invoicevalues.Terms === "CF" || invoicevalues.Terms === "cf") {
                    invoicetermskeyhandleopen();
                    setAddterms(false); setinvc_showADDterms(false); sethiddenbifur_frieght(true); sethiddenbifur_insurance(false)
                    sethiddenbifur_misc(false); sethiddenbifur_agencycomn(false)
                    if (indexTablevalue !== 1) {
                        setBifrctionStsValues({
                            ...BifrctionStsValues, InsuranceDetailsCHARGES: '0', InsuranceDetailsCURRENCY: '', InsuranceDetailsExchange: '', InsuranceDetailsRATE: '0',
                            MiscDetailsCHARGES: '0', MiscDetailsCURRENCY: '', MiscDetailsEXCHANGE: '', MiscDetailsRATE: '0', AgencyCommCHARGES: '0', AgencyCommCURRENCY: '', AgencycommDetailsExchange: '', AgencyCommRATE: '0',
                        })
                    }
                }
                else if (invoicevalues.Terms === "CI" || invoicevalues.Terms === "ci") {
                    invoicetermskeyhandleopen();
                    setAddterms(false)
                    setinvc_showADDterms(false); setinvc_showADDterms(false); sethiddenbifur_frieght(false); sethiddenbifur_insurance(true)
                    sethiddenbifur_misc(false); sethiddenbifur_agencycomn(false)
                    if (indexTablevalue !== 1) {
                        setBifrctionStsValues({
                            ...BifrctionStsValues, FreightDetailsCHARGES: '0', FreightDetailsCURRENCY: '', FreightDetailsExchange: '', FreightDetailsRATE: '0',
                            MiscDetailsCHARGES: '0', MiscDetailsCURRENCY: '', MiscDetailsEXCHANGE: '', MiscDetailsRATE: '0', AgencyCommCHARGES: '0', AgencyCommCURRENCY: '', AgencycommDetailsExchange: '',
                            AgencyCommRATE: '0',
                        })
                    }
                }
                else if (invoicevalues.Terms === "CIF" || invoicevalues.Terms === "cif") {
                    invoicetermskeyhandleopen();
                    setAddterms(false); setinvc_showADDterms(false); setinvc_showADDterms(false); sethiddenbifur_frieght(true); sethiddenbifur_insurance(true)
                    sethiddenbifur_misc(false); sethiddenbifur_agencycomn(false)
                    if (indexTablevalue !== 1) {
                        setBifrctionStsValues({
                            ...BifrctionStsValues, MiscDetailsCHARGES: '0', MiscDetailsCURRENCY: '', MiscDetailsEXCHANGE: '', MiscDetailsRATE: '0', AgencyCommCHARGES: '0',
                            AgencyCommCURRENCY: '', AgencycommDetailsExchange: '', AgencyCommRATE: '0',
                        })
                    }
                }
                else if (invoicevalues.Terms === "FOB" || invoicevalues.Terms === "fob") {
                    invoicetermskeyhandleopen(); setAddterms(false); setinvc_showADDterms(false); setinvc_showADDterms(false)
                    sethiddenbifur_frieght(false); sethiddenbifur_insurance(false); sethiddenbifur_misc(false); sethiddenbifur_agencycomn(false)
                    if (indexTablevalue !== 1) {
                        setBifrctionStsValues({
                            ...BifrctionStsValues, FreightDetailsCHARGES: '0', FreightDetailsCURRENCY: '', FreightDetailsExchange: '', FreightDetailsRATE: '0', InsuranceDetailsCHARGES: '0', InsuranceDetailsCURRENCY: '',
                            InsuranceDetailsExchange: '', InsuranceDetailsRATE: '0', MiscDetailsCHARGES: '0', MiscDetailsCURRENCY: '', MiscDetailsEXCHANGE: '', MiscDetailsRATE: '0', AgencyCommCHARGES: '0',
                            AgencyCommCURRENCY: '', AgencycommDetailsExchange: '', AgencyCommRATE: '0',
                        })
                    }
                }
            }
            //manual 
            else if (invoiceradiovalues === '2') {
                if (invoicevalues.Terms === "CF" || invoicevalues.Terms === "cf") {
                    invoicetermskeyhandleopen(); setAddterms(true)
                    setinvc_showADDterms(true); sethideinvoiceFright(true); sethideInsurance(false); sethideAgencyCom(false); sethideLoading(false); sethideMiscValues(false); sethideHssValues(false)
                    sethideLanding(false)
                    if (indexTablevalue !== 1) {
                        setBifrctionStsValues({
                            ...BifrctionStsValues, InsuranceCURRENCY: invoicevalues.Currency, InsuranceEXCHANGE: invoicevalues.ExchangeRate, InsuranceCHARGES: '0.00',
                            InsuranceRATE: '0.0000', AgencyComCHARGES: '0.00', AgencyComCURRENCY: '', AgencyComEXCHANGE: '', AgencyComRATE: '0.0000', LoadingCHARGES: '0.00', LoadingCURRENCY: '',
                            LoadingEXCHANGE: '', LoadingRATE: '0.0000', MiscValuesCHARGES: '0.00', MiscValuesCURRENCY: '', MiscValuesEXCHANGE: '', MiscValuesRATE: '0.0000',
                            HSSValuesCHARGES: '0.00', HSSValuesRATE: '0.0000', LandingRATE: '0.0000',
                        })
                    }
                }
                else if (invoicevalues.Terms === "CI" || invoicevalues.Terms === "ci") {
                    invoicetermskeyhandleopen(); setAddterms(true); setinvc_showADDterms(true); sethideinvoiceFright(false)
                    sethideInsurance(true); sethideAgencyCom(false); sethideLoading(false); sethideMiscValues(false); sethideHssValues(false); sethideLanding(false)
                    if (indexTablevalue !== 1) {
                        setBifrctionStsValues({
                            ...BifrctionStsValues, FreightCURRENCY: invoicevalues.Currency, FreightEXCHANGE: invoicevalues.ExchangeRate,
                            FreightCHARGES: '0.00', FreightRATE: '0.0000', AgencyComCHARGES: '0.00', AgencyComCURRENCY: '', AgencyComEXCHANGE: '', AgencyComRATE: '0.0000', LoadingCHARGES: '0.00',
                            LoadingCURRENCY: '', LoadingEXCHANGE: '', LoadingRATE: '0.0000', MiscValuesCHARGES: '0.00', MiscValuesCURRENCY: '', MiscValuesEXCHANGE: '',
                            MiscValuesRATE: '0.0000', HSSValuesCHARGES: '0.00', HSSValuesRATE: '0.0000', LandingRATE: '0.0000',
                        })
                    }
                }
                else if (invoicevalues.Terms === "CIF" || invoicevalues.Terms === "cif") {
                    invoicetermskeyhandleopen(); setAddterms(true); setinvc_showADDterms(true); sethideinvoiceFright(true); sethideInsurance(true); sethideAgencyCom(false)
                    sethideLoading(false); sethideMiscValues(false); sethideHssValues(false); sethideLanding(false)
                    if (indexTablevalue !== 1) {
                        setBifrctionStsValues({
                            ...BifrctionStsValues, AgencyComCHARGES: '0.00', AgencyComCURRENCY: invoicevalues.Currency, AgencyComEXCHANGE: invoicevalues.ExchangeRate, AgencyComRATE: '0.0000', LoadingCHARGES: '0.00',
                            LoadingCURRENCY: '', LoadingEXCHANGE: '', LoadingRATE: '0.0000', MiscValuesCHARGES: '0.00', MiscValuesCURRENCY: '', MiscValuesEXCHANGE: '', MiscValuesRATE: '0.0000',
                            HSSValuesCHARGES: '0.00', HSSValuesRATE: '0.0000', LandingRATE: '0.0000',
                        })
                    }
                }
                else if (invoicevalues.Terms === "FOB" || invoicevalues.Terms === "fob") {
                    invoicetermskeyhandleopen(); setAddterms(true); setinvc_showADDterms(true); sethideinvoiceFright(false); sethideInsurance(false)
                    sethideAgencyCom(false); sethideLoading(false); sethideMiscValues(false); sethideHssValues(false); sethideLanding(false)
                    if (indexTablevalue !== 1) {
                        setBifrctionStsValues({
                            ...BifrctionStsValues, FreightCHARGES: '0.00', FreightCURRENCY: '', FreightEXCHANGE: '', FreightRATE: '0.0000', InsuranceCHARGES: '0.00', InsuranceCURRENCY: '',
                            InsuranceEXCHANGE: '', InsuranceRATE: '0.0000', AgencyComCHARGES: '0.00', AgencyComCURRENCY: '', AgencyComEXCHANGE: '', AgencyComRATE: '0.0000', LoadingCHARGES: '0.00',
                            LoadingCURRENCY: '', LoadingEXCHANGE: '', LoadingRATE: '0.0000', MiscValuesCHARGES: '0.00', MiscValuesCURRENCY: '', MiscValuesEXCHANGE: '', MiscValuesRATE: '0.0000',
                            HSSValuesCHARGES: '0.00', HSSValuesRATE: '0.0000', LandingRATE: '0.0000',
                        })
                    }
                }
            }
            else if (invoicevalues.Terms === "EXW" || invoicevalues.Terms === "exw") {
                setinvoicetermsdialogopen(false)
                e.preventDefault();
                document.getElementById('invoicesup_name').focus();
            }
        }

    }

    const invoicesup_namekeyup = (e) => {
        if (e.key === 'F7') { InvoiceSupplierNamehandleClickOpen(); document.getElementById('invoicesup_ad1').focus(); }
        if (e.key === 'Enter') { document.getElementById('invoicesup_ad1').focus(); }
    }
    const invoicesup_ad1keyup = (e) => { if (e.key === 'Enter') { document.getElementById('invoicesup_ad2').focus(); } }
    const invoicesup_ad2keyup = (e) => { if (e.key === 'Enter') { document.getElementById('invoicesup_cntry').focus(); } }
    const invoicesup_cntrykeyup = (e) => {
        if (e.key === 'F7') {
            InvoiceSupplierCountryhandleClickOpen(); document.getElementById('invoicesup_ad3').focus();
        }
        if (e.key === 'Enter') {
            if (invoicevalues.disable_supcountry_Name === '' || !invoicevalues.disable_supcountry_Name) {
                setMessage('Supplier Country Not Available From Master'); setSeverity('warning'); setOpenSnack(true);
            }
            document.getElementById('invoicesup_ad3').focus();
        }
    }
    const invoicesup_ad3keyup = (e) => { if (e.key === 'Enter') { document.getElementById('invoicesup_pincode').focus(); } }
    const invoicesup_pincode = (e) => { if (e.key === 'Enter') { document.getElementById('invoiceSVBLoading').focus(); } }
    const InvoiceSvbLoadingKeyUp = (e) => {
        if (e.key === "Enter") {
            if (invoicevalues.SVBLoading === 'Y' || invoicevalues.SVBLoading === 'y') {
                InvoiceSvbLoadingkeyhandleopen();
                var input = document.getElementById('SVBDescription')
                input.focus();
                input.select();
            }
            else if (invoicevalues.SVBLoading === 'N' || invoicevalues.SVBLoading === 'n') {
                var input2 = document.getElementById('SVBDescription')
                input2.focus();
                input2.select();
            }
        }
    }
    const invoicesusvbdescritionkeyup = (e) => {
        if (e.key === 'Enter') {
            var input = document.getElementById('invoiceThirdParty')
            input.focus();
            input.select();
        }
    }
    const InvoiceThirdPartyKeyUp = (e) => {
        if (e.key === "Enter") {
            if (invoicevalues.Thirdparty === 'Y' || invoicevalues.Thirdparty === 'y') {
                InvoiceThirdPartyhandleopen();
                var input = document.getElementById('invoiceSeller')
                input.focus();
                input.select();
            } else if (invoicevalues.SVBLoading === 'N' || invoicevalues.SVBLoading === 'n') {
                e.preventDefault();
                var input2 = document.getElementById('invoiceSeller')
                input2.focus();
                input2.select();
            }
        }
    }
    const InvoiceSellerKeyUp = (e) => {
        if (e.key === "Enter") {
            if (invoicevalues.Seller === 'Y' || invoicevalues.Seller === 'y') {
                InvoiceSellerhandleopen();
                var input = document.getElementById('invoicebroker')
                input.focus();
                input.select();
            } else if (invoicevalues.SVBLoading === 'N' || invoicevalues.SVBLoading === 'n') {
                var input2 = document.getElementById('invoicebroker')
                input2.focus();
                input2.select();
            }
        }
    }
    const InvoiceBrokerKeyUp = (e) => {
        if (e.key === "Enter") {
            if (invoicevalues.Broker === 'Y' || invoicevalues.Broker === 'y') {
                InvoiceBrokerhandleopen();
                var input = document.getElementById('invoicerela_bw_bs')
                input.focus();
                input.select();
            } else if (invoicevalues.SVBLoading === 'N' || invoicevalues.SVBLoading === 'n') {
                var input2 = document.getElementById('invoicerela_bw_bs')
                input2.focus();
                input2.select();
            }
        }
    }
    const invoice_rela_bw_bandskeyup = (e) => { if (e.key === 'Enter') { document.getElementById('invoiceNatureOfTransaction').focus(); } }
    const invoiceNatureOfTransactionkeyup = (e) => {
        if (e.key === 'F7') {
            InvoiceNatureOfTransactionhandleClickOpen(); document.getElementById('invoiceTermsOfPayment').focus();
        }
        if (e.key === 'Enter') {
            if (invoicevalues.disable_NatureofTransaction_Name === '' || !invoicevalues.disable_NatureofTransaction_Name) {
                setMessage('Nature of Transaction Not Available From Master'); setSeverity('warning'); setOpenSnack(true);
            }
            else { document.getElementById('invoiceTermsOfPayment').focus(); }
        }
    }
    const invoiceTermsOfPaymentkeyup = (e) => {
        if (e.key === 'F7') {
            InvoiceTermOfPaymentChangehandleClickOpen();
            var input = document.getElementById('invoiceCond_OfRestrictionSale')
            input.focus();
            input.select();
        }
        if (e.key === 'Enter') {
            if (invoicevalues.disable_Termsofpayment === '' || !invoicevalues.disable_Termsofpayment) {
                setMessage('Terms of Payment Not Available From Master');
                setSeverity('warning');
                setOpenSnack(true)
            }
            else {
                e.preventDefault();
                var input2 = document.getElementById('invoiceCond_OfRestrictionSale')
                input2.focus();
                input2.select();
            }
        }
    }
    const invoicecond_OfRestrictionSaleonkeyup = (e) => { if (e.key === 'Enter') { document.getElementById('invoiceValuationMethod').focus(); } }
    const invoiceValuationMethod = (e) => {
        if (e.key === 'F7') {
            InvoiceValuationMethodClickOpen();
        }
        if (e.key === 'Enter') {
            if (invoicevalues.disable_valuationmethod === '' || !invoicevalues.disable_valuationmethod) {
                setMessage('Valuation Method Code Not Available From Master');
                setSeverity('warning');
                setOpenSnack(true)
            }
            else {
                e.preventDefault();
                var input = document.getElementById('invoiceDiscountCharges')
                input.focus();
                input.select();
            }
        }

    }

    const InvoiceAddDiscountDetailsKeyUp = (e) => {
        if (e.key === "Enter") {
            if (invoicevalues.DiscountChargesIncludedInThisInvoice === 'Y' || invoicevalues.DiscountChargesIncludedInThisInvoice === 'y') {
                InvoiceAddDiscountDetailshandleopen();
                var input = document.getElementById('invoiceCummulativeCharges')
                input.focus();
                input.select();
            } else if (invoicevalues.SVBLoading === 'N' || invoicevalues.SVBLoading === 'n') {
                e.preventDefault();
                var input2 = document.getElementById('invoiceCummulativeCharges')
                input2.focus();
                input2.select();
            }
        }
    }
    const invoiceCummulativeChargeskeyup = (e) => {
        if (e.key === 'Enter') {
            var input = document.getElementById('invoiceMiscCharges')
            input.focus();
            input.select();
        }
    }
    const InvoiceAddMiscDetailsKeyUp = (e) => {
        if (e.key === "Enter") {
            if (invoicevalues.AreThereMiscChargesNotSpecifiedInThisInvoice === 'Y' || invoicevalues.AreThereMiscChargesNotSpecifiedInThisInvoice === 'y') {
                InvoiceAddMiscDetailshandleopen(); document.getElementById('invoiceaeocode').focus();
            } else if (invoicevalues.SVBLoading === 'N' || invoicevalues.SVBLoading === 'n') {
                e.preventDefault();
                document.getElementById('invoiceaeocode').focus();
            }
        }
    }
    const invoiceaeocodekeyup = (e) => { if (e.key === 'Enter') { document.getElementById('invoiceaeorole').focus(); } }
    const invoiceaeorolekeyup = (e) => { if (e.key === 'Enter') { document.getElementById('invoiceaeocountry').focus(); } }
    const invoiceaeocountrykeyup = (e) => {
        if (e.key === 'F7') { InvoiceAEOCountryhandleClickOpen(); }
        if (e.key === 'Enter') { document.getElementById('invoiceloadno').focus(); }
    }
    const invoiceloadnokeyup = (e) => { if (e.key === 'Enter') { document.getElementById('invoicecond1').focus(); } }
    const invoicecond1keyup = (e) => { if (e.key === 'Enter') { document.getElementById('invoicecond2').focus(); } }
    const invoicecond2keyup = (e) => { if (e.key === 'Enter') { document.getElementById('invoiceotherinformation').focus(); } }
    const invoiceotherinformationkeyup = (e) => { if (e.key === 'Enter') { document.getElementById('invoicePODno').focus(); } }
    const invoicePODnokeyup = (e) => { if (e.key === 'Enter') { document.getElementById('invoicePODdate').focus(); } }
    const invoicePODdatekeyup = (e) => { if (e.key === 'Enter') { document.getElementById('invoiceCDno').focus(); } }
    const invoiceCDnokeyup = (e) => { if (e.key === 'Enter') { document.getElementById('invoiceCDdate').focus(); } }
    const invoiceCDdatekeyup = (e) => { if (e.key === 'Enter') { document.getElementById('invoiceLCDno').focus(); } }
    const invoiceLCDno1keyup = (e) => { if (e.key === 'Enter') { document.getElementById('invoiceLCDdate').focus(); } }
    //.SVBLOading.
    const invoiceSvbRefnokeyup = (e) => { if (e.key === 'Enter') { document.getElementById('invoicesvbdate').focus(); } }
    const invoiceSvbdatekeyup = (e) => { if (e.key === 'Enter') { document.getElementById('invoicesvbCHC').focus(); } }
    const Invoicesvb_custom_hus_cd_keyup = (e) => {
        if (e.key === 'F7') { InvoiceCustomHouseCodehandleClickOpen(); }
        else if (e.key === 'Enter') { document.getElementById('invoicesvbTyp').focus(); }
    }
    const invoiceSvbTypkeyup = (e) => {
        if (dialoginvoicevalues.SVBType === 'D' || dialoginvoicevalues.SVBType === 'd') {
            if (e.key === 'Enter') { document.getElementById('invoicesvbDutyPrcnt').focus(); }
        }
        else if (dialoginvoicevalues.SVBType === 'A' || dialoginvoicevalues.SVBType === 'a' || dialoginvoicevalues.SVBType === 'B' || dialoginvoicevalues.SVBType === 'b') {
            if (e.key === 'Enter') { document.getElementById('invoicesvbASPrnct').focus(); }
        }
    }
    const invoiceSvbASPrnctkeyup = (e) => {
        if (dialoginvoicevalues.SVBType === 'A' || dialoginvoicevalues.SVBType === 'a') {
            if (e.key === 'Enter') { document.getElementById('invoicesvbAVfinl').focus(); }
        }
        else if (e.key === 'Enter') { document.getElementById('invoicesvbDutyPrcnt').focus(); }
    }
    const invoiceSvbDutyPrcntkeyup = (e) => {
        if (dialoginvoicevalues.SVBType === 'D' || dialoginvoicevalues.SVBType === 'd') {
            if (e.key === 'Enter') { document.getElementById('invoicesvbDutyFinl').focus(); }
        }
        else if (e.key === 'Enter') { document.getElementById('invoicesvbAVfinl').focus(); }
    }
    const invoiceSvbAVfinlkeyup = (e) => {
        if (dialoginvoicevalues.SVBType === 'A' || dialoginvoicevalues.SVBType === 'a') {
            if (InvoiceSaveDsa === false) { document.getElementById('invoicesvbsave').focus(); }
            else { document.getElementById('invoicesvbUpdate').focus(); }
        }
        else if (e.key === 'Enter') { document.getElementById('invoicesvbDutyFinl').focus(); }
    }
    const invoiceSvbdutyfinlkeyup = (e) => {
        if (e.key === 'Enter') {
            if (InvoiceSaveDsa === false) { document.getElementById('invoicesvbsave').focus(); }
            else { document.getElementById('invoicesvbUpdate').focus(); }
        }
    }
    // ....ThirdParty..
    const InvoiceThirdpartydailogname_keyup = (e) => {
        if (e.key === 'F7') { InvoiceThirdPartyNameClickOpen() }
        else if (e.key === 'Enter') { document.getElementById('invoiceTPcntry').focus(); }
    }
    const invoiceTPcntrykeyup = (e) => { if (e.key === 'Enter') { document.getElementById('invoiceTPadrs').focus(); } }
    const invoiceTPAdreskeyup = (e) => { if (e.key === 'Enter') { document.getElementById('invoiceTPCity').focus(); } }
    const invoiceTPCitykeyup = (e) => { if (e.key === 'Enter') { document.getElementById('invoiceTPpincd').focus(); } }
    const invoiceTPPincdkeyup = (e) => { if (e.key === 'Enter') { document.getElementById('invoiceDiv').focus(); } }
    const invoiceTPDivsnkeyup = (e) => {
        if (e.key === 'Enter') {
            if (InvoiceSaveDsa === false) { document.getElementById('invoiceTPsave').focus(); }
            else { document.getElementById('invoiceTPUpdate').focus(); }
        }
    }
    //seller
    const invoicesellernmkeyup = (e) => { if (e.key === 'Enter') { document.getElementById('invoicesellercntry').focus(); } }
    const invoicesellercntrykeyup = (e) => { if (e.key === 'Enter') { document.getElementById('invoiceselleradrs').focus(); } }
    const invoiceselleradrskeyup = (e) => { if (e.key === 'Enter') { document.getElementById('invoicesellercity').focus(); } }
    const invoicesellercitykeyup = (e) => { if (e.key === 'Enter') { document.getElementById('invoicesellerpncd').focus(); } }
    const invoicesellerpncdkeyup = (e) => { if (e.key === 'Enter') { document.getElementById('invoicesellerdiv').focus(); } }
    const invoicesellerdivkeyup = (e) => {
        if (e.key === 'Enter') {
            if (InvoiceSaveDsa === false) { document.getElementById('invoicesellersaveid').focus(); }
            else { document.getElementById('invoicesellerupdateid').focus(); }
        }
    }
    //broker
    const invoiceBrokernmkeyup = (e) => { if (e.key === 'Enter') { document.getElementById('invoiceBrokercntry').focus(); } }
    const invoiceBrokercntrykeyup = (e) => { if (e.key === 'Enter') { document.getElementById('invoiceBrokeradrs').focus(); } }
    const invoiceBrokeradrskeyup = (e) => { if (e.key === 'Enter') { document.getElementById('invoiceBrokercity').focus(); } }
    const invoiceBrokercitykeyup = (e) => { if (e.key === 'Enter') { document.getElementById('invoiceBrokerpncd').focus(); } }
    const invoiceBrokerpncdkeyup = (e) => { if (e.key === 'Enter') { document.getElementById('invoiceBrokerdiv').focus(); } }
    const invoiceBrokerdivkeyup = (e) => {
        if (e.key === 'Enter') {
            if (InvoiceSaveDsa === false) { document.getElementById('invoicebrokersaveid').focus(); }
            else { document.getElementById('invoicebrokerupdateid').focus(); }
        }
    }
    //discount
    const invoiceDisct_natrkeyup = (e) => { if (e.key === 'Enter') { document.getElementById('invoiceDiscntrate').focus(); } }
    const invoiceDisct_ratekeyup = (e) => { if (e.key === 'Enter') { document.getElementById('invoiceDiscntamnt').focus(); } }
    const invoiceDisct_amntkeyup = (e) => {
        if (e.key === 'Enter') {
            if (InvoiceSaveDsa === false) { document.getElementById('invoiceDiscntSaveId').focus(); }
            else { document.getElementById('invoiceDiscntUpdateId').focus(); }
        }
    }
    ///miscDetails
    const invoiceMisctypkeyup = (e) => { if (e.key === 'Enter') { document.getElementById('invoicemiscDesc').focus(); } }
    const invoiceMiscDeckeyup = (e) => { if (e.key === 'Enter') { document.getElementById('invoicemiscrate').focus(); } }
    const invoiceMiscratekeyup = (e) => { if (e.key === 'Enter') { document.getElementById('invoicemiscamnt').focus(); } }
    const invoiceMiscamntkeyup = (e) => {
        if (e.key === 'Enter') {
            if (InvoiceSaveDsa === false) {
                document.getElementById('invoicemiscSaveId').focus();
            } else { document.getElementById('invoicemiscUpdateId').focus(); }
        }
    }
    //Blur
    const insertCommercialInvoiceAlertNo = () => {
        if (invoicevalues.InvoiceId === '') {
            if (invoicevalues.invoiceNo !== '') {
                let details = {
                    consignmentId: jobValues.job_no, invoiceNumber: invoicevalues.invoiceNo
                }
                InvoiceService.insertCommercialInvoiceAlertNo(details).then(res => {
                    const data = res.data;
                    const invoice = data.map((trns) => trns.invoiceId)
                    if (!invoice) {
                        setMessage('Invoice pre Alert No Is Not Generated')
                        setSeverity('warning');
                        setOpenSnack(true);
                    }
                    else {
                        setinvoiceValues({ ...invoicevalues, InvoiceId: invoice[0] });
                    }

                })

            } else {
                setMessage('Please Enter The Invoice No')
                setSeverity('warning')
                setOpenSnack(true)
                document.getElementById('invoiceNo').focus();
            }
        }

    }
//selected
    const InvoiceCurruncyTbleKeyDown=(e,type)=>{ const mydata = invoicedetails.map(node=>node);var selectdetails = [];
        if(e.key==='ArrowDown'){
           if(type==='curruncy'){selectdetails = (InvoiceSelect ,mydata[QuryIndex+1].currency_code); setInvoiceSelect(selectdetails);setQuryIndex(QuryIndex+1);}
          else if(type==='termsCntion'){selectdetails = (InvoiceSelect ,mydata[QuryIndex+1].terms_code); setInvoiceSelect(selectdetails);setQuryIndex(QuryIndex+1);}
          else if(type==='Supplier'){selectdetails = (InvoiceSelect ,mydata[QuryIndex+1].supplierName); setInvoiceSelect(selectdetails);setQuryIndex(QuryIndex+1);}
          else if(type==='SupplierCountry'){selectdetails = (InvoiceSelect ,mydata[QuryIndex+1].countryIdString); setInvoiceSelect(selectdetails);setQuryIndex(QuryIndex+1);}
          else if(type==='TransitionCountry'){selectdetails = (InvoiceSelect ,mydata[QuryIndex+1].transactionCode); setInvoiceSelect(selectdetails);setQuryIndex(QuryIndex+1);}
          else if(type==='paymentTerms'){selectdetails = (InvoiceSelect ,mydata[QuryIndex+1].paymentTermsCode); setInvoiceSelect(selectdetails);setQuryIndex(QuryIndex+1);}
          else if(type==='valuetionMethod'){selectdetails = (InvoiceSelect ,mydata[QuryIndex+1].valuationMethodCode); setInvoiceSelect(selectdetails);setQuryIndex(QuryIndex+1);}
          else if(type==='AEOCOUNTRY'){selectdetails = (InvoiceSelect ,mydata[QuryIndex+1].countryIdString); setInvoiceSelect(selectdetails);setQuryIndex(QuryIndex+1);}
        }
       else if(e.key==='ArrowUp'){
        if(type==='curruncy'){selectdetails = (InvoiceSelect ,mydata[QuryIndex-1].currency_code); setInvoiceSelect(selectdetails);setQuryIndex(QuryIndex-1);}
        else if(type==='termsCntion'){selectdetails = (InvoiceSelect ,mydata[QuryIndex-1].terms_code); setInvoiceSelect(selectdetails);setQuryIndex(QuryIndex-1);}
        else if(type==='Supplier'){selectdetails = (InvoiceSelect ,mydata[QuryIndex-1].supplierName); setInvoiceSelect(selectdetails);setQuryIndex(QuryIndex-1);}
        else if(type==='SupplierCountry'){selectdetails = (InvoiceSelect ,mydata[QuryIndex-1].countryIdString); setInvoiceSelect(selectdetails);setQuryIndex(QuryIndex-1);}
        else if(type==='TransitionCountry'){selectdetails = (InvoiceSelect ,mydata[QuryIndex-1].transactionCode); setInvoiceSelect(selectdetails);setQuryIndex(QuryIndex-1);}
        else if(type==='paymentTerms'){selectdetails = (InvoiceSelect ,mydata[QuryIndex-1].paymentTermsCode); setInvoiceSelect(selectdetails);setQuryIndex(QuryIndex-1);}
        else if(type==='valuetionMethod'){selectdetails = (InvoiceSelect ,mydata[QuryIndex-1].valuationMethodCode); setInvoiceSelect(selectdetails);setQuryIndex(QuryIndex-1);}
        else if(type==='AEOCOUNTRY'){selectdetails = (InvoiceSelect ,mydata[QuryIndex-1].countryIdString); setInvoiceSelect(selectdetails);setQuryIndex(QuryIndex-1);}
    }
    else if(e.key==='Enter'){
        if(type==='curruncy'){editInvoiceCurrency(mydata[QuryIndex])} else if(type==='termsCntion'){editinvoiceterms(mydata[QuryIndex])} else if(type==='Supplier'){editinvoicesupplierName(mydata[QuryIndex])}
        else if(type==='SupplierCountry'){editInvoiceCountryName(mydata[QuryIndex])} else if(type==='TransitionCountry'){editInvoiceTransactiondetails(mydata[QuryIndex])}
        else if(type==='paymentTerms'){editInvoiceTermsofpayment(mydata[QuryIndex])} else if(type==='valuetionMethod'){editInvoicevaluationmethod(mydata[QuryIndex])}
        else if(type==='AEOCOUNTRY'){editInvoiceAEoCountry(mydata[QuryIndex])}
    }
    }
    const InvoicDetailsTbleKeyDown=(e,type)=>{ const mydata = invoicedetails.map(node=>node);var selectdetails = [];
        if(e.key==='ArrowDown'){
           if(type==='SVPLoading'){selectdetails = (InvoiceSelect ,mydata[QuryIndex+1].svbRefNo); setInvoiceSelect(selectdetails);setQuryIndex(QuryIndex+1);}
           else if(type==='InvoiceCustHusDet'){selectdetails = (InvoiceSelect ,mydata[QuryIndex+1].customHouseCode); setInvoiceSelect(selectdetails);setQuryIndex(QuryIndex+1);}
           else if(type==='ThirdParty'){selectdetails = (InvoiceSelect ,mydata[QuryIndex+1].name); setInvoiceSelect(selectdetails);setQuryIndex(QuryIndex+1);}
           else if(type==='ThirdPartySuplierName'){selectdetails = (InvoiceSelect ,mydata[QuryIndex+1].supplierName); setInvoiceSelect(selectdetails);setQuryIndex(QuryIndex+1);}
           else if(type==='sellerdetails'){selectdetails = (InvoiceSelect ,mydata[QuryIndex+1].name); setInvoiceSelect(selectdetails);setQuryIndex(QuryIndex+1);}
           else if(type==='BrokerDetails'){selectdetails = (InvoiceSelect ,mydata[QuryIndex+1].name); setInvoiceSelect(selectdetails);setQuryIndex(QuryIndex+1);}
           else if(type==='DiscountDetails'){selectdetails = (InvoiceSelect ,mydata[QuryIndex+1].natDiscount); setInvoiceSelect(selectdetails);setQuryIndex(QuryIndex+1);}
           else if(type==='miscDetails'){selectdetails = (InvoiceSelect ,mydata[QuryIndex+1].miscCode); setInvoiceSelect(selectdetails);setQuryIndex(QuryIndex+1);}
        } else if(e.key==='ArrowUp'){
           if(type==='SVPLoading'){selectdetails = (InvoiceSelect ,mydata[QuryIndex-1].svbRefNo); setInvoiceSelect(selectdetails);setQuryIndex(QuryIndex-1);}
           else if(type==='InvoiceCustHusDet'){selectdetails = (InvoiceSelect ,mydata[QuryIndex-1].customHouseCode); setInvoiceSelect(selectdetails);setQuryIndex(QuryIndex-1);}
           else if(type==='ThirdParty'){selectdetails = (InvoiceSelect ,mydata[QuryIndex-1].name); setInvoiceSelect(selectdetails);setQuryIndex(QuryIndex-1);}
           else if(type==='ThirdPartySuplierName'){selectdetails = (InvoiceSelect ,mydata[QuryIndex-1].supplierName); setInvoiceSelect(selectdetails);setQuryIndex(QuryIndex-1);}
           else if(type==='sellerdetails'){selectdetails = (InvoiceSelect ,mydata[QuryIndex-1].name); setInvoiceSelect(selectdetails);setQuryIndex(QuryIndex-1);}
           else if(type==='BrokerDetails'){selectdetails = (InvoiceSelect ,mydata[QuryIndex-1].name); setInvoiceSelect(selectdetails);setQuryIndex(QuryIndex-1);}
           else if(type==='DiscountDetails'){selectdetails = (InvoiceSelect ,mydata[QuryIndex-1].natDiscount); setInvoiceSelect(selectdetails);setQuryIndex(QuryIndex-1);}
           else if(type==='miscDetails'){selectdetails = (InvoiceSelect ,mydata[QuryIndex-1].miscCode); setInvoiceSelect(selectdetails);setQuryIndex(QuryIndex-1);}
         } else if(e.key==='Enter'){
           if(type==='SVPLoading'){EditInvoiceSVBDetails(mydata[QuryIndex])} 
           else if(type==='InvoiceCustHusDet'){editinvoicecustomcode(mydata[QuryIndex])}
            else if(type==='ThirdParty'){editInvoiceThirdparty(mydata[QuryIndex])}
           else if(type==='ThirdPartySuplierName'){editInvoicethirdpartyname(mydata[QuryIndex])} 
           else if(type==='sellerdetails'){editInvoiceSellerdetails(mydata[QuryIndex])}
           else if(type==='BrokerDetails'){editInvoiceBrokerdetails(mydata[QuryIndex])} 
           else if(type==='DiscountDetails'){editInvoiceDiscountdetails(mydata[QuryIndex])}
           else if(type==='miscDetails'){editInvoiceMiscdetails(mydata[QuryIndex])}
         }
    }
    const invoiceTblSelctKeyDown=(e)=>{ const mydata = invoiceTabledetails.map(node=>node);var selectdetails = [];
        if(e.key==='ArrowDown'){ selectdetails = (InvoiceSelect ,mydata[QuryIndex+1].invoiceNumber); setInvoiceSelect(selectdetails);setQuryIndex(QuryIndex+1);}
        else if(e.key==='ArrowUp'){selectdetails = (InvoiceSelect ,mydata[QuryIndex-1].invoiceNumber); setInvoiceSelect(selectdetails);setQuryIndex(QuryIndex-1);}
        else if(e.key==='Enter'){editInvoiceTableDetails(mydata[QuryIndex])}
    }

    const InvoiceDialogCurruncyNameKeyDown=(e)=>{const mydata = invoicedetails.map(node=>node); 
        if(e.key==='Enter'){document.getElementById('invoiceCurruncyTblDetails_id').focus();setInvoiceSelect([]);
        setQuryIndex(0);var selectdetails = [];selectdetails = (InvoiceSelect ,mydata[0].currency_code); setInvoiceSelect(selectdetails);}
    }
    const InvoiceDialogTermsCodeKeyDown=(e)=>{const mydata = invoicedetails.map(node=>node); 
        if(e.key==='Enter'){document.getElementById('invoiceTermsTblDetails_id').focus();setInvoiceSelect([]);
        setQuryIndex(0);var selectdetails = [];selectdetails = (InvoiceSelect ,mydata[0].terms_code); setInvoiceSelect(selectdetails);}
    }
    const InvoiceDialogSupplierNameKeyDown=(e)=>{const mydata = invoicedetails.map(node=>node); 
        if(e.key==='Enter'){document.getElementById('invoiceSupplierTblDetails_id').focus();setInvoiceSelect([]);
        setQuryIndex(0);var selectdetails = [];selectdetails = (InvoiceSelect ,mydata[0].supplierName); setInvoiceSelect(selectdetails);}
    }
    const InvoiceDialogSupplierCntryCodeKeyDown=(e)=>{const mydata = invoicedetails.map(node=>node); 
        if(e.key==='Enter'){document.getElementById('invoiceSupplierCountryTblDetails_id').focus();setInvoiceSelect([]);
        setQuryIndex(0);var selectdetails = [];selectdetails = (InvoiceSelect ,mydata[0].countryIdString); setInvoiceSelect(selectdetails);}
    }
    const InvoiceDialogNatureTrnsctionCodeKeyDown=(e)=>{const mydata = invoicedetails.map(node=>node); 
        if(e.key==='Enter'){document.getElementById('invoiceTransitionCountryTblDetails_id').focus();setInvoiceSelect([]);
        setQuryIndex(0);var selectdetails = [];selectdetails = (InvoiceSelect ,mydata[0].transactionCode); setInvoiceSelect(selectdetails);}
    }
    const InvoiceDialogPaymentTermsCodeKeyDown=(e)=>{const mydata = invoicedetails.map(node=>node); 
        if(e.key==='Enter'){document.getElementById('invoicePaymentTermsTblDetails_id').focus();setInvoiceSelect([]);
        setQuryIndex(0);var selectdetails = [];selectdetails = (InvoiceSelect ,mydata[0].paymentTermsCode); setInvoiceSelect(selectdetails);}
    }
    const InvoiceDialogValutiontermsCodeKeyDown=(e)=>{const mydata = invoicedetails.map(node=>node); 
        if(e.key==='Enter'){document.getElementById('invoiceValuetionMethodTblDetails_id').focus();setInvoiceSelect([]);
        setQuryIndex(0);var selectdetails = [];selectdetails = (InvoiceSelect ,mydata[0].valuationMethodCode); setInvoiceSelect(selectdetails);}
    }
    const InvoiceDialogAEoCountryCodeDetailsKeyDown=(e)=>{const mydata = invoicedetails.map(node=>node); 
        if(e.key==='Enter'){document.getElementById('invoiceAEOCOUNTRYTblDetails_id').focus();setInvoiceSelect([]);
        setQuryIndex(0);var selectdetails = [];selectdetails = (InvoiceSelect ,mydata[0].countryIdString); setInvoiceSelect(selectdetails);}
    }
    const invoiceSvbDetailsRefkeyup=(e)=>{const mydata = invoicedetails.map(node=>node); 
        if(e.key==='Enter'){document.getElementById('invoiceSVPLoadingTblDetails_id').focus();setInvoiceSelect([]);
        setQuryIndex(0);var selectdetails = [];selectdetails = (InvoiceSelect ,mydata[0].svbRefNo); setInvoiceSelect(selectdetails);}
    }
    const invoiceCusHousCodekeyup=(e)=>{const mydata = invoicedetails.map(node=>node); 
        if(e.key==='Enter'){document.getElementById('invoiceCusHusDetailsTblDetails_id').focus();setInvoiceSelect([]);
        setQuryIndex(0);var selectdetails = [];selectdetails = (InvoiceSelect ,mydata[0].customHouseCode); setInvoiceSelect(selectdetails);}
    }
    const invoiceTP_RefBtnkeyup=(e)=>{const mydata = invoicedetails.map(node=>node); 
        if(e.key==='Enter'){document.getElementById('invoicThirdPartyDtailsTblDetails_id').focus();setInvoiceSelect([]);
        setQuryIndex(0);var selectdetails = [];selectdetails = (InvoiceSelect ,mydata[0].name); setInvoiceSelect(selectdetails);}
    }
    const InvoiceDialogThirdPartySupplierNameKeyDown=(e)=>{const mydata = invoicedetails.map(node=>node); 
        if(e.key==='Enter'){document.getElementById('invoiceThirdPartySuplierNameTblDetails_id').focus();setInvoiceSelect([]);
        setQuryIndex(0);var selectdetails = [];selectdetails = (InvoiceSelect ,mydata[0].supplierName); setInvoiceSelect(selectdetails);}
    }
    const invoicesellerRefBtnKeyup=(e)=>{const mydata = invoicedetails.map(node=>node); 
        if(e.key==='Enter'){document.getElementById('invoicesellerTblDetails_id').focus();setInvoiceSelect([]);
        setQuryIndex(0);var selectdetails = [];selectdetails = (InvoiceSelect ,mydata[0].name); setInvoiceSelect(selectdetails);}
    }
    const invoiceBrokerRefBtnkeyup=(e)=>{const mydata = invoicedetails.map(node=>node); 
        if(e.key==='Enter'){document.getElementById('invoiceBrokerTblDetails_id').focus();setInvoiceSelect([]);
        setQuryIndex(0);var selectdetails = [];selectdetails = (InvoiceSelect ,mydata[0].name); setInvoiceSelect(selectdetails);}
    }
    const invoiceDisct_RefBtnkeyup=(e)=>{const mydata = invoicedetails.map(node=>node); 
        if(e.key==='Enter'){document.getElementById('invoiceDiscountTblDetails_id').focus();setInvoiceSelect([]);
        setQuryIndex(0);var selectdetails = [];selectdetails = (InvoiceSelect ,mydata[0].natDiscount); setInvoiceSelect(selectdetails);}
    }
    const invoiceMiscRefBtnkeyup=(e)=>{const mydata = invoicedetails.map(node=>node); 
        if(e.key==='Enter'){document.getElementById('invoicemiscDetailsTblDetails_id').focus();setInvoiceSelect([]);
        setQuryIndex(0);var selectdetails = [];selectdetails = (InvoiceSelect ,mydata[0].miscCode); setInvoiceSelect(selectdetails);}
    }
    const invoiceBulkUpldBTNkeyup=(e)=>{const mydata = invoiceTabledetails.map(node=>node); var selectdetails = [];
        if( e.key==='Tab'){document.getElementById('invoiceotherinformation').focus();setInvoiceSelect([]);
        setQuryIndex(0);selectdetails = (InvoiceSelect ,mydata[0].invoiceNumber); setInvoiceSelect(selectdetails);}
        if(e.key==='Enter'){document.getElementById('InvoiceTable_id').focus();setInvoiceSelect([]);
        setQuryIndex(0); selectdetails = (InvoiceSelect ,mydata[0].invoiceNumber); setInvoiceSelect(selectdetails);}
    }

    //  onclick dialogbox table-index--

    const editInvoiceCurrency = (trns) => {
        setinvoiceValues({ ...invoicevalues, Currency: trns.currency_code, ExchangeRate: trns.indianValue });
        InvoiceCurrencyhandleClose();
    }
    const editinvoicesupplierName = (trns) => {
        setinvoiceValues({
            ...invoicevalues, SupplierName: trns.supplierName, Address1: trns.supplierAddress1, Address2: trns.supplierAddress2,
            Address3: trns.supplierAddress3, PinCode: trns.supplierPincode, SupplierCountry: trns.countryName,
            disable_supcountry_Name: trns.supplierCountryName
        });
        InvoiceSupplierNamehandlehandleClose();
    }
    const editInvoiceCountryName = (trns) => {
        setinvoiceValues({ ...invoicevalues, SupplierCountry: trns.countryIdString, disable_supcountry_Name: trns.countryName });
        InvoiceSupplierCountryhandleClose();
    }
    const editInvoiceTransactiondetails = (trns) => {
        setinvoiceValues({ ...invoicevalues, NatureOfTransaction: trns.transactionCode, disable_NatureofTransaction_Name: trns.transactionName });
        InvoiceNatureOfTransactionhandleClose();
    }
    const editInvoiceTermsofpayment = (trns) => {
        setinvoiceValues({ ...invoicevalues, TermOfPayment: trns.paymentTermsCode, disable_Termsofpayment: trns.paymentTermsName });
        InvoiceTermOfPaymentChangehandleClose();
    }
    const editInvoicevaluationmethod = (trns) => {
        setinvoiceValues({ ...invoicevalues, ValuationMethod: trns.valuationMethodCode, disable_valuationmethod: trns.valuationMethodName });
        InvoiceValuationMethodhandleClose();
    }
    const editInvoiceAEoCountry = (trns) => {
        setinvoiceValues({ ...invoicevalues, AEOCountry: trns.countryIdString, disable_AeocountryName: trns.countryName });
        InvoiceAEOCountryhandleClose();
    }
    const editInvoicethirdpartyname = (trns) => {
        setdialoginvoicevalues({
            ...dialoginvoicevalues, ThirdPartyName: trns.supplierName, ThirdPartyCountry: trns.supplierCountryName,
            ThirdPartyAddress: trns.supplierAddress1, ThirdPartyPincode: trns.supplierPincode
        })
        InvoiceThirdPartyNamehandleClose();
    }
    const editinvoicecustomcode = (trns) => {
        setdialoginvoicevalues({ ...dialoginvoicevalues, CustomHouseCode: trns.customHouseCode })
        setInvoiceCustomHouseCodeopen(false);
    }
    const editinvoiceterms = (trns) => {
        setinvoiceValues({ ...invoicevalues, Terms: trns.terms_code })
        InvoiceTermshandleClose()
    }

    const EditInvoiceSVBDetails = (trns) => {
        setinvoiceValues({ ...invoicevalues, svbId: trns.svbId })
        setdialoginvoicevalues({
            ...dialoginvoicevalues, SVBReferenceNo: trns.svbRefNo, SVBDate: trns.svbDate, CustomHouseCode: trns.cusHouseCode,
            SVBType: trns.loadType, SVB_Load_Assable_Value_percentage: trns.assablePerc, SVB_Load_Duty_Percentage: trns.dutyPerc,
            Av_is_Final_or_Provisional: trns.avFinal, Duty_is_Final_or_Provisional: trns.dutyFinal
        })
        setInvoiceSaveDsa(true)
        setInvoiceUpdateDsa(false)
        setInvoiceDeleteDsa(false)
    }
    const editInvoiceThirdparty = (trns) => {
        setinvoiceValues({ ...invoicevalues, thirdPartyId: trns.thirdPartyId })
        setdialoginvoicevalues({
            ...dialoginvoicevalues, ThirdPartyName: trns.name, ThirdPartyCountry: trns.countryName,
            ThirdPartyAddress: trns.address, ThirdPartyCity: trns.city, ThirdPartyPincode: trns.pincode, ThirdPartyDivision: trns.division
        })
        setInvoiceSaveDsa(true)
        setInvoiceUpdateDsa(false)
        setInvoiceDeleteDsa(false)
    }
    const editInvoiceSellerdetails = (trns) => {
        setinvoiceValues({ ...invoicevalues, sellerId: trns.sellerId })
        setdialoginvoicevalues({
            ...dialoginvoicevalues, SellerName: trns.name, SellerAddress: trns.address, SellerCity: trns.city,
            SellerPincode: trns.pincode, SellerDivision: trns.division, SellerCountry: trns.countryName,
        })
        setInvoiceSaveDsa(true)
        setInvoiceUpdateDsa(false)
        setInvoiceDeleteDsa(false)
    }
    const editInvoiceBrokerdetails = (trns) => {
        setinvoiceValues({ ...invoicevalues, brokerId: trns.brokerId })
        setdialoginvoicevalues({
            ...dialoginvoicevalues, BrokerName: trns.name, BrokerAddress: trns.address, BrokerCity: trns.city,
            BrokerPincode: trns.pincode, BrokerDivision: trns.division, BrokerCountry: trns.countryName,
        })
        setInvoiceSaveDsa(true)
        setInvoiceUpdateDsa(false)
        setInvoiceDeleteDsa(false)
    }
    const editInvoiceDiscountdetails = (trns) => {
        setinvoiceValues({ ...invoicevalues, discountId: trns.discountId })
        setdialoginvoicevalues({
            ...dialoginvoicevalues, NatureofDiscount: trns.natDiscount, DiscountAmount: trns.discountAmount,
            DiscountRate: trns.discountRate
        })
        setInvoiceSaveDsa(true)
        setInvoiceUpdateDsa(false)
        setInvoiceDeleteDsa(false)
    }

    const editInvoiceMiscdetails = (trns) => {
        setinvoiceValues({ ...invoicevalues, miscId: trns.miscId })
        setdialoginvoicevalues({
            ...dialoginvoicevalues, MiscCodeType: trns.miscCode, MiscDescription: trns.miscDescription,
            MiscRate: trns.miscRate, MiscAmmount: trns.miscAmount
        })
        setInvoiceSaveDsa(true)
        setInvoiceUpdateDsa(false)
        setInvoiceDeleteDsa(false)

    }
    //
    const editInvoiceTableDetails = (trns,i) => {var selectdetails=[];
        setInvoiceSaveTableDsa(true);setQuryIndex(i);selectdetails = (InvoiceSelect ,trns.invoiceNumber); setInvoiceSelect(selectdetails);
        setInvoiceUpdateTableDsa(false);
        setInvoiceDeleteTableDsa(false);
        setinvoiceDublicateTableDsa(false);
        setindexTablevalue(1);
        let details = { invoiceId: trns.invoiceId }
        InvoiceService.getCommercialInvoiceAssign(details).then(res => {
            const data = res.data;
            const Invoiceasignvalues = data.map((trns) => trns)

            setinvoiceValues({
                ...invoicevalues, InvoiceId: trns.invoiceId, invoiceNo: Invoiceasignvalues[0].invoiceNumber, invoiceDate: Invoiceasignvalues[0].invoiceDate, invoiceValue: Invoiceasignvalues[0].invoiceValue,
                Currency: Invoiceasignvalues[0].currency_code, ExchangeRate: Invoiceasignvalues[0].exchangeRate, Terms: Invoiceasignvalues[0].invoiceTerm, SupplierName: Invoiceasignvalues[0].supplierName,
                Address1: Invoiceasignvalues[0].supplierAddress1, Address2: Invoiceasignvalues[0].supplierAddress2, SupplierCountry: Invoiceasignvalues[0].countryName,
                disable_supcountry_Name: Invoiceasignvalues[0].supplierCountryName, Address3: Invoiceasignvalues[0].supplierAddress3, PinCode: Invoiceasignvalues[0].supplierPincode,
                SVBLoading: Invoiceasignvalues[0].svbLoading, SVBDescription: Invoiceasignvalues[0].svbDescription, Thirdparty: Invoiceasignvalues[0].thirdParty,
                Seller: Invoiceasignvalues[0].seller, Broker: Invoiceasignvalues[0].broker, RelationBetweenBuyerSeller: Invoiceasignvalues[0].relBtByrSeller,
                NatureOfTransaction: Invoiceasignvalues[0].transactionCode, disable_NatureofTransaction_Name: Invoiceasignvalues[0].transactionName, TermOfPayment: Invoiceasignvalues[0].paymentTermsCode,
                disable_Termsofpayment: Invoiceasignvalues[0].paymentTermsName, ConditionsOfRestrictionSale: Invoiceasignvalues[0].condRestriction, ValuationMethod: Invoiceasignvalues[0].valuationMethodCode,
                disable_valuationmethod: Invoiceasignvalues[0].valuationMethodName, DiscountChargesIncludedInThisInvoice: Invoiceasignvalues[0].discount, CummulativeCharges: Invoiceasignvalues[0].cummulative,
                AreThereMiscChargesNotSpecifiedInThisInvoice: Invoiceasignvalues[0].misc, PurchaseOrderDetailsNo: Invoiceasignvalues[0].orderNo,
                PurchaseOrderDetailsDate: Invoiceasignvalues[0].orderDate, ContractDetailsNo: Invoiceasignvalues[0].contractNo, ContractDetailsDate: Invoiceasignvalues[0].contractDate,
                LetterOfCreditDetailsNo: Invoiceasignvalues[0].letterNo, LetterOfCreditDetailsDate: Invoiceasignvalues[0].letterDate, AEOCode: Invoiceasignvalues[0].aeoCode,
                AEORole: Invoiceasignvalues[0].aeoRole, AEOCountry: Invoiceasignvalues[0].aeoCountryId, disable_AeocountryName: Invoiceasignvalues[0].aeoCountryName, LoadNo: Invoiceasignvalues[0].loadNo,
                Condition1: Invoiceasignvalues[0].condtion1, Condition2: Invoiceasignvalues[0].condition2, OtherInformation: Invoiceasignvalues[0].otherInformation,
            })

            setBifrctionStsValues({
                ...BifrctionStsValues, FreightCHARGES: Invoiceasignvalues[0].freightValue, FreightCURRENCY: Invoiceasignvalues[0].freightCurrency,
                FreightEXCHANGE: Invoiceasignvalues[0].frtExchangeRate, FreightRATE: Invoiceasignvalues[0].freightRate, InsuranceCHARGES: Invoiceasignvalues[0].insuranceValue,
                InsuranceCURRENCY: Invoiceasignvalues[0].insuranceCurrency, InsuranceEXCHANGE: Invoiceasignvalues[0].insExchangeRate, InsuranceRATE: Invoiceasignvalues[0].insuranceRate,
                AgencyComCHARGES: Invoiceasignvalues[0].agencyValue, AgencyComCURRENCY: Invoiceasignvalues[0].agencyCurrency, AgencyComEXCHANGE: Invoiceasignvalues[0].agyExchangeRate,
                AgencyComRATE: Invoiceasignvalues[0].agencyRate, LoadingCHARGES: Invoiceasignvalues[0].loadingValue, LoadingCURRENCY: Invoiceasignvalues[0].loadingCurrency,
                LoadingEXCHANGE: Invoiceasignvalues[0].loadExchangeRate, LoadingRATE: Invoiceasignvalues[0].loadingRate, MiscValuesCHARGES: Invoiceasignvalues[0].miscValue,
                MiscValuesCURRENCY: Invoiceasignvalues[0].miscCurrency, MiscValuesEXCHANGE: Invoiceasignvalues[0].miscExchangeRate, MiscValuesRATE: Invoiceasignvalues[0].miscRate,
                HSSValuesCHARGES: Invoiceasignvalues[0].hssValue, HSSValuesRATE: Invoiceasignvalues[0].hssRate, LandingRATE: Invoiceasignvalues[0].landingRate,
            })
            if (Invoiceasignvalues[0].autoBifurcationStatus === '1') {
                setinvoiceradiovalues('1')
            }
            else {
                setinvoiceradiovalues('2')
            }
        })

    }
    /**----------------------------------------Items----------------------------------------------*/
    const [ItemValues, setItemValues] = useState({
        item_id: 0, item_sl_no: '', txt_item_Desc: '', txt_ritc: '', txt_cth: '', genericDesc: '', txt_rate_typeSP: '', txt_ceth: '', txt_quantity: '',
        txt_unit: '', txt_unitPrice: '', txt_currency: '', txt_totAmount: '', txt_endusCode: '', txt_originCntry: '', txt_originCntryName: '',
        txt_brand: 'NA', txt_model_no: 'NA', txt_acessory: 0, txt_sourceCountry: '', txt_sourceCountryName: '', txt_transit_country: '', txt_transit_countryName: '',
        txt_exRate: '', bcd_notfication_no: '', bcd_sl_no: '', bcd_rate_no: '', bcd_flg_no: '', bcd_amount_no: '', bcd_uqc_no: '', aidc_notfication_no: '011/2021',
        aidc_sl_no: '17', aidc_rate_no: '', aidc_flg_no: '', aidc_amount_no: '', aidc_uqc_no: '', sws_notfication_no: '', sws_sl_no: '', sws_rate_no: '',
        sws_flg_no: '', sws_amount_no: '', sws_uqc_no: '', cvd_notfication_no: '', cvd_sl_no: '', cvd_rate_no: '', cvd_flg_no: '', cvd_amount_no: '',
        cvd_uqc_no: '', edu_css_notfication_no: '', edu_css_sl_no: '', edu_css_rate_no: '', edu_css_flg_no: '', edu_css_amount_no: '', edu_css_uqc_no: '',
        schemeCodeY_N: 'N', licence_y_n: 'N', Re_importY_n: "N", svb_status_y_N: 'N', manufactureY_N: 'Y', cust_Notn_exmptY_n: 'N', anti_dumbing_duty_Y_N: 'N',
        rsp_Y_N_Q_T_D_C: 'N', ncdCustomDuty_Y_N: 'N', otherDuty_Y_N: 'N', scDuty_Y_N: 'N', IGSTDuty_Y_N: 'Y', swinfo_Y_N: 'Y', swConstitutent_Y_N: 'N',
        swProduction_Y_N: 'N', swControl_Y_N: 'N', swStatementY_N: 'N', swSuportDoc_Y_N: 'Y', PolicyPara_Y_N: 'N', igstduty_type: 'G', igstduty_Add_type: 'I',
        igstduty_flagG_C: 'G', igstduty_notfion_no: '001/2021', igstduty_sl_no: '', igstduty_rate: '', igstduty_flg: '', igstduty_amount: '',
        igstduty_uqc: '', igstduty_exmpNotn_no: '', igstduty_sl_no2: '', igstcess_type: 'G', igstcess_Add_type: 'P', igstcess_flagG_C: 'C', igstcess_notfion_no: '001/2021',
        igstcess_sl_no: '', igstcess_rate: '', igstcess_flg: '', igstcess_amount: '',
    });
    const [ItemId, setItemId] = useState('')
    const [ItemIdSlct, setItemIdSlct] = useState('')
    const [ItemDialogValues, setItemDialogValues] = useState({
        f_item_desc: '', f_ritcCode: '', f_ritcName: '', f_unitCode: '', f_unitName: '', f_currencyCode: '', f_currencyName: '', f_enduse_code: '', f_enduse_name: '', f_originCntryCode: '',
        f_originCntryName: '', f_bcd_notificationNo: '', f_bcd_notificationSrNo: '', f_aidc_notificationNo: '', f_aidc_notificationSrNo: '', f_SWS_notificationNo: '', f_SWS_notificationSrNo: '',
        f_CVD_notificationNo: '', f_CVD_notificationSrNo: '', f_EDU_notificationNo: '', f_EDU_notificationSrNo: '', f_IGSTDuty_notificationNo: '', f_IGSTDuty_notificationSrNo: '', f_IGSTCess_notificationNo: '',
        f_IGSTCess_notificationSrNo: '', f_IGSTDutyExmp_notificationNo: '', f_IGSTDutyExmp_notificationSrNo: '', scheme_code: '', scheme_codeName: '', f_scheme_code: '', f_scheme_codeName: '',
        notofi_no: '', notofi_noId: '', f_IGST_notificationNo: '', f_IGST_notificationSrNo: '', srl_no: '', rate: '', exemptionrequired: 'N', re_export: 'N', sec_20: 'N', auntiDump_notn_no: '',
        auntiDump_Srl_no: '', f_auntiDump_notn_no: '', f_auntiDump_Srl_no: '', auntiDump_cth_srl_no: '', auntiDump_sup_srl_no: '', auntiDump_advalorem_rate: '0.00', auntiDump_flag: '',
        auntiDump_quantity: '', auntiDump_uqc: '', auntiDump_notifiRate: '', auntiDump_currency: '', auntiDump_spaceAmt: '', SwType: 'CHR', SwQwalifier: 'SQC', SwCode: '', SwText: '',
        sw_mesurnment: '', Sw_Uqc: '', licence_reg_no: '', licence_code: '', licence_codeName: '', licence_Date: '', licence_reg_port: '', debit_value: '0.00', debit_quantity: '0.00',
        debit_duty: '0.00', tra_no: '', tra_date: '', Licence_item_srlNo: '', f_licencePortCode: '', f_licencePortName: '', constituentSl_no: '', constituent_name: '', constituent_code: '',
        const_percentage: '0.00', yield_percentage: '0.00', active_indredient: 'N', rsp_notnNo: '', rsp_notnSlNo: '', rsp_amount: '', rsp_rate: '', rsp_description: '', rsp_quantity: '',
        r_iPrivousSbNo: '', r_iPrivousSbdate: '', r_iPort_of_export: '', r_iInvoiceNo_sb: '', r_iItemNo_sb: '', r_iNotificationNo: '', r_iNotificationSrlNo: '', r_iExportFright: '0.00',
        r_iExportInsurance: '0.00', r_iCustomDuty: '0.00', r_iExciseDuty: '0.00', ncdDuty_notn_no: '', ncdDuty_notn_slNo: '', ncdDuty_rate: '', ncdDuty_flag: '', ncdDuty_amount: '', ncdDuty_UQC: '',
        swProd_prodIdtifier: '', swprod_Quantity: '', swProd_manufacture: '', swprod_expiryDate: '', swProd_beforeDate: '', svb_reference_no: '', svb_refrenceDate: '', svb_customhouseCode: '',
        svb_loadOn_Ad: '', svb_load_AV: '', svb_load_duty: '', svb_provi_AV: '', svb_provi_duty: '', mnfctr_manufactureId: '', mnfctr_manufactureName: '', mnfctr_country: '', mnfctr_adress: '',
        mnfctr_manufactureCity: '', mnfctr_pincode: '', mnfctr_division: '', f_suplier_name: '', custm_notfiNo: '', custm_Sl_No: '',
        custm_rate: '', custm_flag: '', custm_amount: '', custm_uqc: '', othrDuty_Type: '', othrDuty_NotifiNo: '', othrDuty_NotifiSlNo: '', othrDuty_NotifiRate: '', othrDuty_NotifiAmount: '', othrDuty_NotifiFlag: '',
        othrDuty_uqc: '', swcntl_typ_code: '', swcntl_location: '', swcntl_start_date: '', swcntl_end_date: '', swcntl_result_code: '', swcntl_result_text: '', swcntl_measurnment: '0.00',
        swcntl_uqc: '', swcntl_sl_no: '', swStatmnt_typ: '', swStatment_code: '', swStatment_text: '', swStmnt_dclrtiontypeMtnb: '', swStatment_decNo: '', swStatment_date: '', policy_paraNo: '', policy_paraYear: '',
        //swDocs
        ImageRefNo: '', DocTypeCode: '', IssuePartyName: '', PlaceOfIssue: '', DocIssueDate: '', BeneficiaryName: '', FileType: 'PDF', DeclarationTypeMTNE: 'M', DocReferenceNo: '', DocExpiryDate: '',
        IssuePartyAddress1: '', IssuePartyAddress2: '', IssuePartyCity: '', IssuePartyPincode: '', IssuePartyCode: '', BenificiaryCode: '', BenificiaryAddress1: '', BenificiaryAddress2: '',
        BenificiaryCity: '', BenificiaryPincode: '', FindDocumentType: '', FindDocumentName: '', FindSupplierName: '', ImporterIECCode: '', ImporterIECName: '', BranchSerialNo: '',
        FindImporterName: '', FindImporterCode: '', FindImporterState: '', FindBranchSr_NO: '', iceGateUser: '',
    });
    const [ItemSummury, setItemSummury] = useState({
        invoiceValue: '', terms: '', exchangeRate: '', currency: '', fright: '', insurence: '', misc: '', loadinng: '', totalValue: '', totalAmount: '', totalDuty: '', ass: '',
        bcd: '', cvd: '', sws: '', gst: '', duty: '', itm_fright: '', itm_insurence: '', itm_misc: '', itm_loadinng: '', itm_totalValue: ''
    })
    const [itemDetails, setItemDetails] = useState([]);
    const [itemDescDetails, setItemDescDetails] = useState([]);
    const [itemRitcDetails, setItemRitcDetails] = useState([]);
    const [itemSchemeCodeDetails, setItemSchemeCodeDetails] = useState([]);
    const [ItemErrordetails, setItemErrordetails] = useState([])

    const [ItemIGSTdutyTypeDetails, setItemIGSTdutyTypeDetails] = useState([]);
    const [ItemIGSTdutyAddTypeDetails, setItemIGSTdutyAddTypeDetails] = useState([]);
    const [ItemIGSTcessTypeDetails, setItemIGSTCessTypeDetails] = useState([]);
    const [ItemIGSTcessAddTypeDetails, setItemIGSTCessAddTypeDetails] = useState([]);

    const [itemSwInfoTypeDrp, setitemSwInfoTypeDrp] = useState([]);
    const [ItemSwQualifrDrp, setItemSwQualifrDrp] = useState([]);
    const [ItemSwCodeDrp, setItemSwCodeDrp] = useState([]);
    const [ItemSwUQCDrp, setItemSwUQCDrp] = useState([]);
    const [ItemCusHusCode, setItemCusHusCode] = useState([]);
    const [itemCountryDetails, setitemCountryDetails] = useState([]);

    const [currentFile, setCurrentFile] = useState(undefined);

    const [itemDescOpen, setItemDescOpen] = useState(false);
    const [itemRitcOpen, setitemRitcOpen] = useState(false);
    const [itemCTHOpen, setitemCTHOpen] = useState(false);
    const [itemCETHOpen, setitemCETHOpen] = useState(false);
    const [itemUnitOpen, setitemUnitOpen] = useState(false);
    const [ItemCurrencyOpen, setItemCurrencyOpen] = useState(false);
    const [ItemEndUseOpen, setItemEndUseOpen] = useState(false);
    const [ItemOriginCntryOpen, setItemOriginCntryOpen] = useState(false);
    const [ItemSourceCntryOpen, setItemSourceCntryOpen] = useState(false);
    const [ItemTransitCntryOpen, setItemTransitCntryOpen] = useState(false);
    const [ItemBcdNotifyNoOpen, setItemBcdNotifyNoOpen] = useState(false);
    const [ItemAidcNotifyNoOpen, setItemAidcNotifyNoOpen] = useState(false);
    const [ItemSwsNotifyNoOpen, setItemSwsNotifyNoOpen] = useState(false);
    const [ItemCVDNotifyNoOpen, setItemCVDNotifyNoOpen] = useState(false);
    const [ItemEDuCessNotifyNoOpen, setItemEDuCessNotifyNoOpen] = useState(false);
    const [ItemIGSTDutyNotifyNoOpen, setItemIGSTDutyNotifyNoOpen] = useState(false);
    const [ItemIGSTCessNotifyNoOpen, setItemIGSTCessNotifyNoOpen] = useState(false);
    const [ItemIgstExmpNotnOpen, setItemIgstExmpNotnOpen] = useState(false);
    const [ItemSchemeCodeOpen, setItemSchemeCodeOpen] = useState(false);
    const [ItemSchemeCodeDetailsOpen, setItemSchemeCodeDetailsOpen] = useState(false);
    const [ItemSchemeNotenDetailsOpen, setItemSchemeNotenDetailsOpen] = useState(false);
    const [ItemAuntiDumpingOpen, setItemAuntiDumpingOpen] = useState(false);
    const [ItemAuntiNotifiOpen, setItemAuntiNotifiOpen] = useState(false);
    const [ItemSwInfoOpen, setItemSwInfoOpen] = useState(false);
    const [ItemLicenceOpen, setItemLicenceOpen] = useState(false);
    const [ItemLicencCodeeOpen, setItemLicencCodeeOpen] = useState(false);
    const [ItemLicencPortOpen, setItemLicencPortOpen] = useState(false);
    const [ItemConstituentOpen, setItemConstituentOpen] = useState(false);
    const [ItemRspDutyOpen, setItemRspDutyOpen] = useState(false);
    const [ItemReImportOpen, setItemReImportOpen] = useState(false);
    const [ItemReImpPortCodeOpen, setItemReImpPortCodeOpen] = useState(false);
    const [ItemNcdDutyOpen, setItemNcdDutyOpen] = useState(false);
    const [ItemSwProductionOpen, setItemSwProductionOpen] = useState(false);
    const [ItemSvbStatusOpen, setItemSvbStatusOpen] = useState(false);
    const [ItemManufactureOpen, setItemManufactureOpen] = useState(false);
    const [ItemSupplierNameOpen, setItemSupplierNameOpen] = useState(false);
    const [ItemCustNotnExmpOpen, setItemCustNotnExmpOpen] = useState(false);
    const [ItemOtherDutyOpen, setItemOtherDutyOpen] = useState(false);
    const [ItemOtherDutyNotfiOpen, setItemOtherDutyNotfiOpen] = useState(false);
    const [ItemScDutyOpen, setItemScDutyOpen] = useState(false);
    const [ItemSWControlOpen, setItemSWControlOpen] = useState(false);
    const [ItemSWStatementOpen, setItemSWStatementOpen] = useState(false);

    const [itemdoctypecode_open, setitemdoctypecode_open] = useState(false)
    const [ItemSwDocsSupplierNameOpen, setItemSwDocsSupplierNameOpen] = useState(false)
    const [ItemAddHssDetailsopen, setItemAddHssDetailsopen] = useState(false)
    const [ItemImporterDetailsOpen, setItemImporterDetailsOpen] = useState(false)
    const [ItemImporterBranchDetailsOpen, setItemImporterBranchDetailsOpen] = useState(false)

    const [ItemPolicyParaOpen, setItemPolicyParaOpen] = useState(false);
    const [ItemSwDocsOpen, setItemSwDocsOpen] = useState(false);
    const [ItemBePrintOpen, setItemBePrintOpen] = useState(false);
    const [ItemBulkUploadOpen, setItemBulkUploadOpen] = useState(false);
    const [ItemBulkUploadErrorOpen, setItemBulkUploadErrorOpen] = useState(false);

    const [ItemSaveItemDsa, setItemSaveItemDsa] = useState(false);
    const [ItemUpdateItemDsa, setItemUpdateItemDsa] = useState(true);
    const [ItemDeleteItemDsa, setItemDeleteItemDsa] = useState(true);
    const [ItemBEfileItemDsa, setItemBEfileItemDsa] = useState(false);
    const [ItemCheackListItemDsa, setItemCheackListItemDsa] = useState(false);

    const [ItemSve, setItemSve] = useState(false);
    const [ItemUpd, setItemUpd] = useState(false);
    const [ItemDlt, setItemDlt] = useState(false);
    const [ItemBEprnt, setItemBEprnt] = useState(false);
    const [ItemCheacklistprnt, setItemCheacklistprnt] = useState(false);

    const [ItemlicenceDisa, setItemlicenceDisa] = useState(true);
    const [ItemIgstDutyYNDisa, setItemIgstDutyYNDisa] = useState(true);

    const [ItemSchemeSaveDsa, setItemSchemeSaveDsa] = useState(false);
    const [ItemSchemeUpdateDsa, setItemSchemeUpdateDsa] = useState(true);
    const [ItemSchemeDeleteDsa, setItemSchemeDeleteDsa] = useState(true);

    const [ItemSchemeSve, setItemSchemeSve] = useState(false);
    const [ItemSchemeUpd, setItemSchemeUpd] = useState(false);
    const [ItemSchemeDlt, setItemSchemeDlt] = useState(false);

    const [ItemAuntiDumpSaveDsa, setItemAuntiDumpSaveDsa] = useState(false);
    const [ItemAuntiDumpUpdateDsa, setItemAuntiDumpUpdateDsa] = useState(true);
    const [ItemAuntiDumpDeleteDsa, setItemAuntiDumpDeleteDsa] = useState(true);

    const [ItemAuntiDumpSve, setItemAuntiDumpSve] = useState(false);
    const [ItemAuntiDumpUpd, setItemAuntiDumpUpd] = useState(false);
    const [ItemAuntiDumpDlt, setItemAuntiDumpDlt] = useState(false);

    const [ItemSwInfoSaveDsa, setItemSwInfoSaveDsa] = useState(false);
    const [ItemSwInfoUpdateDsa, setItemSwInfoUpdateDsa] = useState(true);
    const [ItemSwInfoDeleteDsa, setItemSwInfoDeleteDsa] = useState(true);

    const [ItemSwInfoSve, setItemSwInfoSve] = useState(false);
    const [ItemSwInfoUpd, setItemSwInfoUpd] = useState(false);
    const [ItemSwInfoDlt, setItemSwInfoDlt] = useState(false);

    /*---------------------KeyUP&Down-----------------------------------*/

    const itemDescKeyDown = (e) => { if (e.key === 'F7') { itemItemDescOpenHandle(); } if (e.key === 'Enter') { document.getElementById('ritc').focus(); } }
    const ItemritcKeyDown = (e) => { if (e.key === 'F7') { itemRitc_OpenHandle(); } if (e.key === "Enter") { document.getElementById('cth').focus(); } }
    const ItemcthKeyDown = (e) => { if (e.key === 'F7') { itemCTH_OpenHandle(); } if (e.key === "Enter") { document.getElementById('genericDesc').focus(); } }
    const ItemgenericDescKeyDown = (e) => { if (e.key === "Enter") { document.getElementById('rateType').focus(); } }
    const ItemrateTypeKeyDown = (e) => { if (e.key === "Enter") { document.getElementById('ceth').focus(); } }
    const ItemcethKeyDown = (e) => { if (e.key === 'F7') { itemCETH_OpenHandle(); } if (e.key === "Enter") { document.getElementById('quantity').focus(); } }
    const ItemquantityKeyDown = (e) => { if (e.key === "Enter") { document.getElementById('unit').focus(); } }
    const ItemunitKeyDown = (e) => { if (e.key === 'F7') { itemUnit_OpenHandle(); } if (e.key === "Enter") { document.getElementById('unitPrice').focus(); } }
    const ItemunitPriceKeyDown = (e) => { if (e.key === "Enter") { document.getElementById('itemCurncyid').focus(); } }
    const ItemitemCurncyKeyDown = (e) => { if (e.key === 'F7') { itemCurrency_OpenHandle(); } if (e.key === "Enter") {var currency_code = '';
    if (ItemValues.txt_currency !== '') {currency_code = ItemValues.txt_currency; } else { currency_code = '-1'; }
    let details = { currency_code: currency_code, currencyPrefix: '-1', flag: 1 }
    InvoiceService.getCurrency(details).then(res => {const data = res.data; const valuerate = data.map(it=>it)
        setItemValues({...ItemValues,txt_exRate:valuerate[0].indianValue}) });document.getElementById('totalamntId').focus(); } }
    const ItemtotalamntIdKeyDown = (e) => { if (e.key === "Enter") { document.getElementById('endusecode').focus(); } }
    const ItemendusecodeKeyDown = (e) => { if (e.key === 'F7') { itemEndUse_OpenhHandle(); } if (e.key === "Enter") { document.getElementById('orgincntry').focus(); } }
    const ItemorgincntryKeyDown = (e) => { if (e.key === 'F7') { itemOriginCntry_OpenHandle(); } if (e.key === "Enter") { document.getElementById('brandId').focus(); } }
    const ItembrandKeyDown = (e) => { if (e.key === "Enter") { document.getElementById('modelNoId').focus(); } }
    const ItemmodelNoKeyDown = (e) => { if (e.key === "Enter") { document.getElementById('AccessoryId').focus(); } }
    const ItemAccessoryKeyDown = (e) => { if (e.key === "Enter") { document.getElementById('srcCntryId').focus(); } }
    const ItemsrcCntryKeyDown = (e) => { if (e.key === 'F7') { itemSourceCntry_OpenHandle(); } if (e.key === "Enter") { document.getElementById('transistCntryId').focus(); } }
    const ItemtransistCntryKeyDown = (e) => { if (e.key === 'F7') { itemTransiteCntry_OpenHandle() } if (e.key === "Enter") { document.getElementById('bcd_notifyNo').focus(); } }
    const ItemBCDNotifiNoKeyDown = (e) => { if (e.key === 'F7') { itemBcdNotify_OpenHandle(); } if (e.key === 'Enter') { document.getElementById('bcd_srlNo').focus() } }
    const ItemBCDSrlNoKeyDown = (e) => { if (e.key === 'Enter') { document.getElementById('aidc_notify').focus(); } }
    const ItemAdidcNotifiNoKeyDown = (e) => { if (e.key === 'F7') { itemAidcNotify_OpenHandle(); } if (e.key === 'Enter') { document.getElementById('aidc_SrlNo').focus(); } }
    const ItemAdidcSrlnoKeyDown = (e) => { if (e.key === 'Enter') { document.getElementById('sws_notifi').focus(); } }
    const ItemSwsNotificationKeyDown = (e) => { if (e.key === 'F7') { itemSwsNotify_OpenHandle();  } if (e.key === 'Enter') { document.getElementById('sws_srlNo').focus(); } }
    const ItemSws_SrlnoKeyDown = (e) => { if (e.key === 'Enter') { document.getElementById('cvd_notifi').focus(); } }
    const ItemCVDNotificationKeyDown = (e) => { if (e.key === 'F7') { itemCVDNotify_OpenHandle();  } if (e.key === 'Enter') { document.getElementById('cvd_srlno').focus(); } }
    const ItemCVD_SrlnoKeyDown = (e) => { if (e.key === 'Enter') { document.getElementById('edu_cess_notfi').focus(); } }
    const ItemEDUcessNotiKeyDown = (e) => { if (e.key === 'F7') { itemEDUCessNotify_OpenHandle(); } if (e.key === 'Enter') { document.getElementById('edu_cess_srlNo').focus(); } }
    const ItemEDUCess_SrlnoKeyDown = (e) => { if (e.key === 'Tab') { document.getElementById('policy_para').focus(); } if (e.key === 'Enter') { document.getElementById('igst_duty_type').focus(); } }
    const CustNotExptKeydown = (e) => {
        if (e.key === 'Enter') {
            if (ItemValues.cust_Notn_exmptY_n === 'Y' || ItemValues.cust_Notn_exmptY_n === 'y') {
                if (validateItem() === true) {
                    ItemCustNotnExmp_OpenHandle(); var input = document.getElementById('auntiDumping'); input.focus(); input.select();
                }
            } else if (ItemValues.cust_Notn_exmptY_n === 'N' || ItemValues.cust_Notn_exmptY_n === 'n') {
                var input2 = document.getElementById('auntiDumping'); input2.focus(); input2.select();
            }
        }
    }
    const ItemIgstDutyNotfiNoKeyDown = (e) => { if (e.key === 'F7') { itemIGSTDutyNotify_OpenHandle(); } if (e.key === 'Enter') { document.getElementById('igstDuty_srlno').focus(); } }
    const ItemIgstDutySrlnoKeyDown = (e) => { if (e.key === 'Enter') { document.getElementById('igstDutyExmpNotiNo').focus(); } }
    const ItemIgstDutyExmpNotifiNoKeyDown = (e) => { if (e.key === 'F7') { itemIGSTExmpNotify_OpenHandle(); } if (e.key === 'Enter') { document.getElementById('igstDutyExmpSrlNo').focus(); } }
    const ItemIgstDutyExmpSrlnoKeyDown = (e) => { if (e.key === 'Enter') { document.getElementById('igstcess_type').focus(); } }
    const Igstcess_typeKeyDown = (e) => { if (e.key === 'Enter') { document.getElementById('igstcessAddtyp').focus(); } }
    const IgstcessAddtypKeyDown = (e) => { if (e.key === 'Enter') { document.getElementById('igstcessflag').focus(); } }
    const IgstcessflagKeyDown = (e) => { if (e.key === 'Enter') { document.getElementById('igstCess_notifno').focus(); } }
    const ItemIgstCessNotfiNoKeyDown = (e) => { if (e.key === 'F7') { itemIGSTCessNotify_OpenHandle(); } if (e.key === 'Enter') { document.getElementById('igstCess_SrlNo').focus(); } }
    const ItemIgstCessSrlnoKeyDown = (e) => {
        if (e.key === 'Tab') {
            var input = document.getElementById('edu_cess_srlNo'); input.focus(); input.select();
        }
        if (e.key === 'Enter') { var input2 = document.getElementById('schemecodeYN'); input2.focus(); input2.select(); }
    }

    const ItemSchemeCodeYnKeyDown = (e) => {
        if (e.key === 'Enter') {
            if (ItemValues.schemeCodeY_N === 'y' || ItemValues.schemeCodeY_N === 'Y') {
                if (validateItem() === true) {
                    ItemSchemeCode_OpenHandle();
                    setItemlicenceDisa(false);
                    var input = document.getElementById('licence'); input.focus(); input.select();
                }
            } else if (ItemValues.schemeCodeY_N === 'n' || ItemValues.schemeCodeY_N === 'N') {
                var input2 = document.getElementById('re_import'); input2.focus(); input2.select();
            }
        }
    }
    const ItemAntiDumbingDutykeyDown = (e) => {
        if (ItemValues.anti_dumbing_duty_Y_N === 'y' || ItemValues.anti_dumbing_duty_Y_N === 'Y') {
            if (e.key === 'Enter') {
                var input = document.getElementById('item_Rsp'); input.focus(); input.select();
                if (validateItem() === true) {
                    ItemAuntiDumbing_OpenHandle();
                }
            }
        } else if (ItemValues.anti_dumbing_duty_Y_N === 'N' || ItemValues.anti_dumbing_duty_Y_N === 'n') {
            if (e.key === 'Enter') {
                var input2 = document.getElementById('item_Rsp'); input2.focus(); input2.select();
            }
        }
    }
    const ItemDialogFindRitcCodeKeydown = (e) => { if (e.key === 'Enter') { document.getElementById('FindRitcName').focus(); } }
    const ItemDialogFindCthCodeKeydown = (e) => { if (e.key === 'Enter') { document.getElementById('itemFindCTHName').focus(); } }
    const ItemDialogFindCethCodeKeydown = (e) => { if (e.key === 'Enter') { document.getElementById('itemFindCethName').focus(); } }
    const ItemDialogFindUnitCodeKeydown = (e) => { if (e.key === 'Enter') { document.getElementById('ItemFindUnitCode').focus(); } }
    const ItemDialogFindCurruncyCodeKeydown = (e) => { if (e.key === 'Enter') { document.getElementById('ItemFindCurruncyName').focus(); } }
    const ItemDialogFindEndCodeKeydown = (e) => { if (e.key === 'Enter') { document.getElementById('ItemFindEndUseName').focus(); } }
    const ItemDialogFindOriginCountryCodeKeydown = (e) => { if (e.key === 'Enter') { document.getElementById('FindOriginCountry').focus(); } }
    const ItemDialogFindSourceCountryCodeKeydown = (e) => { if (e.key === 'Enter') { document.getElementById('ItemSourceCountry').focus(); } }
    const ItemDialogFindTransiteCountryCodeKeydown = (e) => { if (e.key === 'Enter') { document.getElementById('ItemFindCountryName').focus(); } }
    const ItemDialogBCDFindNotifiCationNoKeydown = (e) => { if (e.key === 'Enter') { document.getElementById('ItemBcdNotifiSlNo').focus(); } }
    const ItemDialogAIDCFindNotifiCationNoKeydown = (e) => { if (e.key === 'Enter') { document.getElementById('ItemAidcNotifiSlNo').focus(); } }
    const ItemDialogSWsFindNotifiCationNoKeydown = (e) => { if (e.key === 'Enter') { document.getElementById('ItemSwsFindNotifiSlNo').focus(); } }
    const ItemDialogCvdFindNotifiCationNoKeydown = (e) => { if (e.key === 'Enter') { document.getElementById('cvdFindNotifiSlNo').focus(); } }
    const ItemDialogEDUCessFindNotifiCationNoKeydown = (e) => { if (e.key === 'Enter') { document.getElementById('ItemEduCessFindNotifiSlNo').focus(); } }
    const ItemDialogIGSTFindNotifiCationNoKeydown = (e) => { if (e.key === 'Enter') { document.getElementById('ItemIgstFindNotifiSlNo').focus(); } }
    const ItemDialogIgstCessFindNotifiCationNoKeydown = (e) => { if (e.key === 'Enter') { document.getElementById('ItemIgstCessNotifiSlNo').focus(); } }
    const ItemDialogIgstExampFindNotifiCationNoKeydown = (e) => { if (e.key === 'Enter') { document.getElementById('ItemExmpNotnFindNotifiSlNo').focus(); } }
    const itemDialogSchemeCodeOnKeyDown = (e) => { if (e.key === 'Enter') { document.getElementById('schem_notifi_no').focus(); } if (e.key === 'F7') { ItemSchemeCodeDetails_OpenHandle(); } }
    const itemDialogSchemeNotnNoOnKeyDown = (e) => { if (e.key === 'Enter') { document.getElementById('scheme_SrlNo').focus(); } if (e.key === 'F7') { ItemSchemeNotnDetails_OpenHandle(); } }
    const itemDialogSchemeSrlNoeOnKeyDown = (e) => { if (e.key === 'Enter') { getSchemeNotifiDetails(); document.getElementById('Scheme_excemption').focus(); } }
    const itemDialogSchemeExcemptionOnKeyDown = (e) => { if (e.key === 'Enter') { document.getElementById('Re-ExportDialog').focus(); } }
    const itemDialogSchemeReExportOnKeyDown = (e) => { if (e.key === 'Enter') { document.getElementById('sec_20DialogSchem').focus(); } }
    const itemDialogSchemeSec20OnKeyDown = (e) => { if (e.key === 'Enter') { if (ItemSchemeSaveDsa === false) { ItemAddSchemeSave(); } else { ItemAddSchemeUpdate(); } } }

    const ItemDialogFindAuntiDump_notn_noKeydown = (e) => { if (e.key === 'Enter') { document.getElementById('auntiNotifiSrlNo').focus(); } if (e.key === 'F7') { ItemAuntiNotifi_OpenHandle(); } }
    const ItemDialogFindAuntiDump_SrlNoKeydown = (e) => { if (e.key === 'Enter') { document.getElementById('AuntiDumpSubSrlNo').focus(); getCustomNotificationAuntiDumping(); } if (e.key === 'Tab') { document.getElementById('AuntiDumpCthSrlNo').focus(); } }
    const ItemDialogFindAuntiDump_CthSrlNoKeydown = (e) => { if (e.key === 'Enter') { document.getElementById('Advalorem_rate').focus(); } if (e.key === 'Tab') { document.getElementById('AuntiDumpSubSrlNo').focus(); } }
    const ItemDialogFindAuntiDump_SupSrlNoKeydown = (e) => { if (e.key === 'Enter') { document.getElementById('AuntiDumpCthSrlNo').focus(); } if (e.key === 'Tab') { document.getElementById('auntiNotifiSrlNo').focus(); } }
    const ItemDialogFindAuntiDump_AdvalromRateKeydown = (e) => { if (e.key === 'Enter') { document.getElementById('auntiDumbFlag').focus(); } }
    const ItemDialogFindAuntiDump_FlagKeydown = (e) => { if (e.key === 'Enter') { document.getElementById('AuntiDumbquantity').focus(); } }
    const ItemDialogFindAuntiDump_QuantityKeydown = (e) => { if (e.key === 'Enter') { document.getElementById('auntiDumb_Uqc').focus(); } }
    const ItemDialogFindAuntiDump_UqcKeydown = (e) => { if (e.key === 'Enter') { document.getElementById('currency').focus(); } }
    const ItemDialogFindAuntiDump_CurruncyKeydown = (e) => { if (e.key === 'Enter') { if (ItemAuntiDumpSaveDsa === false) { ItemAuntiDumbSave(); } else { ItemAuntiDumbUpdate(); } } }

    const ItemDialogSwTypeKeyDown = (e) => {
        if (e.key === 'Tab') { let details = { swCode: ItemDialogValues.SwType }; ItemService.getSwInfoQualifier(details).then(res => { setItemSwQualifrDrp(res.data) }) }
        if (e.key === 'Enter') { document.getElementById('swQWalifer').focus(); }
    }
    const ItemDialogSwQualifierKeyDown = (e) => {
        if (e.key === 'Tab') {
            let details = { swQualifier: ItemDialogValues.SwQwalifier }
            ItemService.getSwInfoCode(details).then(res => { setItemSwCodeDrp(res.data) })
        }
        if (e.key === 'Enter') { document.getElementById('swCode').focus(); }
    }

    const ItemDialogSwCodeKeyDown = (e) => { if (e.key === 'Enter') { document.getElementById('swText').focus(); } }
    const ItemDialogSwTextKeyDown = (e) => { if (e.key === 'Enter') { document.getElementById('swMeadureMent').focus(); } }
    const ItemDialogSwMesurementKeyDown = (e) => { if (e.key === 'Enter') { document.getElementById('swUqc').focus(); } }
    const ItemDialogSwUqcKeyDown = (e) => { if (e.key === 'Enter') { if (ItemSwInfoSaveDsa === false) { ItemAddSwInfoSave(); } else { ItemAddSwInfoUpdate(); } } }

    const ItemSwinfoYNKeyDown = (e) => {
        if (e.key === 'Enter') {
            if (ItemValues.swinfo_Y_N === 'Y' || ItemValues.swinfo_Y_N === 'y') {
                var input = document.getElementById('SW_Constituent'); input.focus(); input.select();
                if (validateItem() === true) {
                    ItemSwInfo_OpenHandle();
                }
            } if (ItemValues.swinfo_Y_N === 'N' || ItemValues.swinfo_Y_N === 'n') {
                var input2 = document.getElementById('SW_Constituent'); input2.focus(); input2.select();
            }
        }
    }

    const ItemDialogFindSchemeCodeKeyDown=(e)=>{   if (e.key === 'Enter') {document.getElementById('SchemeCode_findSchemeName_id').focus()} }
    const ItemDialogFindSchemaIgstNotnNoKeyDown=(e)=>{  if (e.key === 'Enter') { document.getElementById('DialodFindSchema_IgstNotn_id').focus()} }
    const ItemDialogFindAuntiDump_notn_noKeyDown=(e)=>{  if (e.key === 'Enter') { document.getElementById('FindAuntiDumbNotifySrlNo_id').focus()} }
    const ItemDialogLicenceFindSchemCodeKeyDown=(e)=>{  if (e.key === 'Enter') { document.getElementById('Licence_FindShemaName_id').focus()} }
    const ItemDialogFindLicencePorteCodeKeyDown=(e)=>{  if (e.key === 'Enter') { document.getElementById('LicencePort_name_id').focus()} }
    const ItemDialogFindRe_import_PorteCodeKeyDown=(e)=>{  if (e.key === 'Enter') { document.getElementById('Find_re_import_name').focus()} }
    const ItemDialogOtherDutyFindigstNotiNoKeyDown=(e)=>{  if (e.key === 'Enter') { document.getElementById('OtherDutyNotifySrlNo').focus()} }

    const ItemLicenceYNKeyDown = (e) => {
        if (e.key === 'Enter') {
            if (ItemValues.licence_y_n === 'Y' || ItemValues.licence_y_n === 'y') {
                var input = document.getElementById('re_import'); input.focus(); input.select();
                if (validateItem() === true) {
                    ItemLicence_OpenHandle();
                }
            } else if (ItemValues.licence_y_n === 'N' || ItemValues.licence_y_n === 'n') {
                var input2 = document.getElementById('re_import'); input2.focus(); input2.select();
            }
        }
    }
    const ItemRspYNQTDCKeyDown = (e) => {
        if (e.key === 'Enter') {
            if (ItemValues.rsp_Y_N_Q_T_D_C === 'Y' || ItemValues.rsp_Y_N_Q_T_D_C === 'y') {
                var input = document.getElementById('ncd_customDuty'); input.focus(); input.select();
                if (validateItem() === true) {
                    ItemRspDuty_OpenHandle();
                }
            } else if (ItemValues.rsp_Y_N_Q_T_D_C === 'N' || ItemValues.rsp_Y_N_Q_T_D_C === 'n') {
                var input2 = document.getElementById('ncd_customDuty'); input2.focus(); input2.select();
            }
        }
    }
    const ItemDialogLicenceRegNoKeyDown = (e) => { if (e.key === 'Enter') { document.getElementById('licenceCode').focus(); } }
    const ItemDialogLicenceCodeKeyDown = (e) => { if (e.key === 'Enter') { document.getElementById('Lice_date').focus(); } if (e.key === 'F7') { ItemLicenceCode_OpenHandle(); } }
    const ItemDialogLicenceRegPortKeyDown = (e) => { if (e.key === 'Enter') { document.getElementById('debit_uom').focus(); } if (e.key === 'F7') { ItemLicencePort_OpenHandle(); } }
    const ItemDialogLicenceDateKeyDown = (e) => { if (e.key === 'Enter') { document.getElementById('LicenceRegPort').focus(); } }
    const ItemDialogLicenceDebitUomKeyDown = (e) => { if (e.key === 'Enter') { document.getElementById('DebitValue').focus(); } }
    const ItemDialogLicenceDebitValueKeyDown = (e) => { if (e.key === 'Enter') { document.getElementById('DebitQuantity').focus(); } }
    const ItemDialogLicenceDebitQuantityKeyDown = (e) => { if (e.key === 'Enter') { document.getElementById('debitDuty').focus(); } }
    const ItemDialogLicenceDebitDutyKeyDown = (e) => { if (e.key === 'Enter') { document.getElementById('TraNo').focus(); } }
    const ItemDialogLicenceTraNoKeyDown = (e) => { if (e.key === 'Enter') { document.getElementById('TraDate').focus(); } }
    const ItemDialogLicenceTraDateKeyDown = (e) => { if (e.key === 'Enter') { document.getElementById('ItemSerialNoInLicence').focus(); } }
    const ItemDialogLicenceItemSerialNoInKeyDown = (e) => { if (e.key === 'Enter') { if (ItemSwInfoSaveDsa === false) { ItemAddLicenceSave(); } else { ItemAddLicenceUpdate(); } } }
    const ItemDialogSwConstituentSlNoKeyDown = (e) => { if (e.key === 'Enter') { document.getElementById('ContituentName').focus(); } }
    const ItemDialogSwConstituentNameKeyDown = (e) => { if (e.key === 'Enter') { document.getElementById('constituentCode').focus(); } }
    const ItemDialogSwConstituentCodeKeyDown = (e) => { if (e.key === 'Enter') { document.getElementById('constPercnt').focus(); } }
    const ItemDialogSwConstituentPercntKeyDown = (e) => { if (e.key === 'Enter') { document.getElementById('yieldPercnt').focus(); } }
    const ItemDialogSwCntentYieldPercntKeyDown = (e) => { if (e.key === 'Enter') { document.getElementById('activeIngredient').focus(); } }
    const ItemDialogSwCntentActiveIngredientKeyDown = (e) => { if (e.key === 'Enter') { if (ItemSwInfoSaveDsa === false) { ItemAddSWConstituentSave(); } else { ItemAddSWConstituentUpdate(); } } }
    const ItemDialogRspDutyNotenKeyDown = (e) => { if (e.key === 'Enter') { document.getElementById('notnSlNo').focus(); } }
    const ItemDialogRspDutySlNoKeyDown = (e) => { if (e.key === 'Enter') { document.getElementById('amount').focus(); } }
    const ItemDialogRspDutyAmountKeyDown = (e) => { if (e.key === 'Enter') { document.getElementById('RspDutyrate').focus(); } }
    const ItemDialogRspDutyRateKeyDown = (e) => { if (e.key === 'Enter') { document.getElementById('Rsp_Description').focus(); } }
    const ItemDialogRspDutyDescriptionKeyDown = (e) => { if (e.key === 'Enter') { document.getElementById('RSPquantity').focus(); } }
    const ItemDialogRspDutyQuantityKeyDown = (e) => { if (e.key === 'Enter') { if (ItemSwInfoSaveDsa === false) { ItemAddRSPSave(); } else { ItemAddRspUpdate(); } } }
    const ItemDialogReImportPrivousSbNoKeyDown = (e) => { if (e.key === 'Enter') { document.getElementById('priviousSbDate').focus(); } }
    const ItemDialogReImportSBDateKeyDown = (e) => { if (e.key === 'Enter') { document.getElementById('ReImportPortOfExit').focus(); } }
    const ItemDialogReImportInvoiceSbKeyDown = (e) => { if (e.key === 'Enter') { document.getElementById('itemNoSb').focus(); } }
    const ItemDialogReImportItemNoSbKeyDown = (e) => { if (e.key === 'Enter') { document.getElementById('notificationNo').focus(); } }
    const ItemDialogReImportNotificationNoKeyDown = (e) => { if (e.key === 'Enter') { document.getElementById('NotificationSlNo').focus(); } }
    const ItemDialogReImportNotificationSlNoKeyDown = (e) => { if (e.key === 'Enter') { document.getElementById('ExportFright').focus(); } }
    const ItemDialogReImportExportFrightKeyDown = (e) => { if (e.key === 'Enter') { document.getElementById('exportInsurance').focus(); } }
    const ItemDialogReImportExportInsuranceKeyDown = (e) => { if (e.key === 'Enter') { document.getElementById('customDuty').focus(); } }
    const ItemDialogReImportCustomDutyKeyDown = (e) => { if (e.key === 'Enter') { document.getElementById('Excise_Duty').focus(); } }
    const ItemDialogReImportExciseDutyKeyDown = (e) => { if (e.key === 'Enter') { if (ItemSwInfoSaveDsa === false) { ItemAddRe_importSave(); } else { ItemAddRe_importUpdate(); } } }
    const ItemDialogNcdDutyCustmDutyKeyDown = (e) => { if (e.key === 'Enter') { document.getElementById('NcdSlNo').focus(); } }
    const ItemDialogNcdDutySlnoDutyKeyDown = (e) => { if (e.key === 'Enter') { if (ItemSwInfoSaveDsa === false) { ItemAddNCDdutySave(); } else { ItemAddNCDdutyUpdate(); } } }
    const ItemDialogAddProductionIdentifieKeyDown = (e) => { if (e.key === 'Enter') { document.getElementById('addproductionQuantity').focus(); } }
    const ItemDialogAddProductionQuantityKeyDown = (e) => { if (e.key === 'Enter') { document.getElementById('debit_uom').focus(); } }
    const ItemDialogAddProductionUqcKeyDown = (e) => { if (e.key === 'Enter') { document.getElementById('manufactureDate').focus(); } }
    const ItemDialogAddProductionManfactureDateKeyDown = (e) => { if (e.key === 'Enter') { document.getElementById('expiryDate').focus(); } }
    const ItemDialogAddProductionExpiryDateKeyDown = (e) => { if (e.key === 'Enter') { document.getElementById('bestBeforeDate').focus(); } }
    const ItemDialogAddProductionBestBeforeDateKeyDown = (e) => { if (e.key === 'Enter') { if (ItemSwInfoSaveDsa === false) { ItemProdectionSave(); } else { ItemAddProdectionUpdate(); } } }

    const ItemDialogSvbRefrenceNoKeyDown = (e) => { if (e.key === 'Enter') { document.getElementById('SvBrefrenceDate').focus(); } }
    const ItemDialogSvbRefrenceDateKeyDown = (e) => { if (e.key === 'Enter') { document.getElementById('custmHouseSvb').focus(); } }
    const ItemDialogSvbCustmHuseCodeSVBKeyDown = (e) => { if (e.key === 'Enter') { document.getElementById('SVBLoadOnAD').focus(); } }
    const ItemDialogSvbSvbLoadOnADKeyDown = (e) => { if (e.key === 'Enter') { document.getElementById('svbLoadAV').focus(); } }
    const ItemDialogSvbSvbLoadOnAVKeyDown = (e) => { if (e.key === 'Enter') { document.getElementById('svLoadDuty').focus(); } }
    const ItemDialogSvbSvbLoadOnDutyKeyDown = (e) => { if (e.key === 'Enter') { document.getElementById('LoadFinalProvisionalAv').focus(); } }
    const ItemDialogSvbLoadProvisionalAVKeyDown = (e) => { if (e.key === 'Enter') { document.getElementById('provisionalDuty').focus(); } }
    const ItemDialogSvbLoadProvisionalDutyKeyDown = (e) => { if (e.key === 'Enter') { ItemSVBStatusCloshHandle(); } }
    const ItemConstituentYnKeyDown = (e) => {
        if (e.key === 'Enter') {
            if (ItemValues.swConstitutent_Y_N === 'Y' || ItemValues.swConstitutent_Y_N === 'y') {
                var input = document.getElementById('sw_production'); input.focus(); input.select();
                if (validateItem() === true) {
                    ItemSwConstituent_OpenHandle();
                }
            } else if (ItemValues.swConstitutent_Y_N === 'N' || ItemValues.swConstitutent_Y_N === 'n') {
                var input2 = document.getElementById('sw_production'); input2.focus(); input2.select();
            }
        }
    }

    const ItemReImportKeyDown = (e) => {
        if (e.key === 'Enter') {
            if (ItemValues.Re_importY_n === 'Y' || ItemValues.Re_importY_n === 'y') {
                var input = document.getElementById('svbStatus'); input.focus(); input.select();
                if (validateItem() === true) {
                    ItemReImport_OpenHandle();
                }
            } else if (ItemValues.Re_importY_n === 'N' || ItemValues.Re_importY_n === 'n') {
                var input2 = document.getElementById('svbStatus'); input2.focus(); input2.select();
            }
        }
    }

    const ItemDialogRiPortExportKeyDown = (e) => { if (e.key === 'F7') { ItemReImPortCode_OpenHandle(); } if (e.key === 'Enter') { document.getElementById('invoiceNoSb').focus(); } }
    const ItemNCDcustomDutyYnKeyDown = (e) => {
        if (e.key === 'Enter') {
            if (ItemValues.ncdCustomDuty_Y_N === 'Y' || ItemValues.ncdCustomDuty_Y_N === 'y') {
                var input = document.getElementById('otherDuty'); input.focus(); input.select();
                if (validateItem() === true) {
                    ItemNcdDuty_OpenHandle();
                }
            } else if (ItemValues.ncdCustomDuty_Y_N === 'N' || ItemValues.ncdCustomDuty_Y_N === 'n') {
                var input2 = document.getElementById('otherDuty'); input2.focus(); input2.select();
            }
        }
    }
    const ItemSWproductionKeyDown = (e) => {
        if (e.key === 'Enter') {
            if (ItemValues.swProduction_Y_N === 'Y' || ItemValues.swProduction_Y_N === 'y') {
                var input = document.getElementById('sw_control'); input.focus(); input.select();
                if (validateItem() === true) {
                    ItemSwProduction_OpenHandle();
                }
            } else if (ItemValues.swProduction_Y_N === 'N' || ItemValues.swProduction_Y_N === 'n') {
                var input2 = document.getElementById('sw_control'); input2.focus(); input2.select();
            }
        }
    }

    const ItemSvbStatusYNKeyDown = (e) => {
        if (e.key === 'Enter') {
            if (ItemValues.svb_status_y_N === 'Y' || ItemValues.svb_status_y_N === 'y') {
                if (validateItem() === true) {
                    ItemSVBStatus_OpenHandle();
                }
            } var input = document.getElementById('ManufactureYn'); input.focus(); input.select();
        }
    }

    const ItemOtherDutyYNKeyDown = (e) => {
        if (e.key === 'Enter') {
            if (ItemValues.otherDuty_Y_N === 'Y' || ItemValues.otherDuty_Y_N === 'y') {
                var input = document.getElementById('sc_duty'); input.focus(); input.select();
                if (validateItem() === true) {
                    ItemOtherDuty_OpenHandle();
                }
            } else if (ItemValues.otherDuty_Y_N === 'N' || ItemValues.otherDuty_Y_N === 'n') {
                var input2 = document.getElementById('sc_duty'); input2.focus(); input2.select();
            }
        }
    }

    const ItemManufactrNameSupplierKeyHndle = (e) => { if (e.key === 'Enter') { document.getElementById('mnfctr_cntry').focus(); } else if (e.key === 'F7') { ItemSupplier_OpenHandle(); } }
    const ItemManufactrNameCountryKeyHndle = (e) => { if (e.key === 'Enter') { document.getElementById('ManufatureDetailsAddress').focus(); } }
    const ItemManufactureAddressKeyHndle = (e) => { if (e.key === 'Enter') { document.getElementById('ManufactureCity').focus(); } }
    const ItemManufactureCityKeyHndle = (e) => { if (e.key === 'Enter') { document.getElementById('ManufacturePinCode').focus(); } }
    const ItemManufacturePinCodeKeyHndle = (e) => { if (e.key === 'Enter') { document.getElementById('ManufactureDivision').focus(); } }
    const ItemManufactureDivisionKeyHndle = (e) => { if (e.key === 'Enter') { if (ItemSwInfoSaveDsa === false) { ItemManufactureSave(); } else { ItemAddManufactureUpdate(); } } }
    const ItemDialogCustmNotifioKeydown = (e) => { if (e.key === 'Enter') { document.getElementById('custm_sl_no').focus(); } }
    const ItemDialogCustmSlNoKeydown = (e) => { if (e.key === 'Enter') { if (ItemSwInfoSaveDsa === false) { ItemCustmExmpSave(); } else { ItemAddCustmNotnExmpUpdate(); } } }
    const ItemDialogOthrDutyTyypeKeydown = (e) => { if (e.key === 'Enter') { document.getElementById('otherDutyNotifyNo').focus(); } }
    const ItemDialogOthrDutyNotifioKeydown = (e) => { if (e.key === 'Enter') { document.getElementById('othr_sl_no').focus(); } if (e.key === 'F7') { ItemOtherDutyNotfi_oprnHandle(); } }
    const ItemDialogOthrDutySlNoKeydown = (e) => { if (e.key === 'Enter') { if (ItemSwInfoSaveDsa === false) { ItemOthrDutySave(); } else { ItemOthrDutyUpdate(); } } }
    const ItemManufactureYNKeyDown = (e) => {
        if (e.key === 'Enter') {
            if (ItemValues.manufactureY_N === 'Y' || ItemValues.manufactureY_N === 'y') {
                var input = document.getElementById('cust_notnId'); input.focus(); input.select();
                if (validateItem() === true) {
                    ItemManufacture_OpenHandle();
                }
            } else if (ItemValues.manufactureY_N === 'N' || ItemValues.manufactureY_N === 'n') {
                var input2 = document.getElementById('cust_notnId'); input2.focus(); input2.select();
            }
        }
    }
    const ItemSCDYNKeyDown = (e) => {
        if (e.key === 'Enter') {
            if (ItemValues.scDuty_Y_N === 'Y' || ItemValues.scDuty_Y_N === 'y') {
                if (ItemIgstDutyYNDisa === false) {
                    var input = document.getElementById('igst_duty'); input.focus(); input.select();
                } else {
                    var input2 = document.getElementById('sw_info'); input2.focus(); input2.select();
                    setItemIgstDutyYNDisa(true);
                }
                if (validateItem() === true) {
                    ItemScDuty_OpenHandle();
                }
            } else if (ItemValues.scDuty_Y_N === 'N' || ItemValues.scDuty_Y_N === 'n') {
                if (ItemIgstDutyYNDisa === false) {
                    var input3 = document.getElementById('igst_duty'); input3.focus(); input.select();
                } else {
                    var input4 = document.getElementById('sw_info'); input4.focus(); input4.select();
                    setItemIgstDutyYNDisa(true);
                }
            }
        }
    }

    const ItemDialogScDutyNotifioKeydown = (e) => { if (e.key === 'Enter') { document.getElementById('ScDuty_sl_no').focus(); } }
    const ItemDialogScDutySlNoKeydown = (e) => { if (e.key === 'Enter') { if (ItemSwInfoSaveDsa === false) { ItemScdSave(); } else { ItemAddScdUpdate(); } } }
    const ItemDialogSwControleTypeCodeKeydown = (e) => { if (e.key === 'Enter') { document.getElementById('swControllLocation').focus(); } }
    const ItemDialogSwControleLocationKeydown = (e) => { if (e.key === 'Enter') { document.getElementById('startDate').focus(); } }
    const ItemDialogSwControleStartDateKeydown = (e) => { if (e.key === 'Enter') { document.getElementById('ContrlEndDate').focus(); } }
    const ItemDialogSwControleEndDateKeydown = (e) => { if (e.key === 'Enter') { document.getElementById('SwcontrolresultCode').focus(); } }
    const ItemDialogSwControleResultCodeKeydown = (e) => { if (e.key === 'Enter') { document.getElementById('SWControlResultText').focus(); } }
    const ItemDialogSwControleResultTextKeydown = (e) => { if (e.key === 'Enter') { document.getElementById('SwControllmeasurMent').focus(); } }
    const ItemDialogSwControleMeasurementKeydown = (e) => { if (e.key === 'Enter') { document.getElementById('SwControlSlNo').focus(); } }
    const ItemDialogSwControleSl_NoKeydown = (e) => { if (e.key === 'Enter') { if (ItemSwInfoSaveDsa === false) { ItemSwControlSave(); } else { ItemSwControlUpdate(); } } }
    const ItemDialogSwStatementTypeKeydown = (e) => { if (e.key === 'Enter') { document.getElementById('SWStatementStatementCode').focus(); } }
    const ItemDialogSwStatementCodeKeydown = (e) => { if (e.key === 'Enter') { document.getElementById('SwStatementText').focus(); } }
    const ItemDialogSwStatementTextKeydown = (e) => { if (e.key === 'Enter') { document.getElementById('SwStatementDeclaretionType').focus(); } }
    const ItemDialogSwStatementDeclaretionTypeKeydown = (e) => { if (e.key === 'Enter') { document.getElementById('SwStatementDeclarationNo').focus(); } }
    const ItemDialogSwStatementDeclaretionNoKeydown = (e) => { if (e.key === 'Enter') { document.getElementById('SwStatementDecalarationDate').focus(); } }
    const ItemDialogSwStatementDeclaretionDateKeydown = (e) => { if (e.key === 'Enter') { if (ItemSwInfoSaveDsa === false) { ItemSwStatemntSave(); } else { ItemSwStatementUpdate(); } } }
    const ItemDialogPolicyParaPolicyNoKeydown = (e) => { if (e.key === 'Enter') { document.getElementById('PolicyParaPolicyYear').focus(); } }
    const ItemDialogPolicyParaPolicyYearKeydown = (e) => { if (e.key === 'Enter') { if (ItemSwInfoSaveDsa === false) { ItemPolicySave(); } else { ItemPolicyUpdate(); } } }
    const ItemDialogViewDocumentTypeFindDocumentKeydown = (e) => { if (e.key === 'Enter') { document.getElementById('ViwDocumentTypeName').focus(); } }
    const itemSwSupprtIssuepartynamekeydown = (e) => { if (e.key === 'F7') { ItemissuepartynameOpenHandle(); } if (e.key === 'Enter') { document.getElementById('SwDocsPlaceOfIssue').focus(); } }
    const itemSwSupprtPlaceOfIssuekeydown = (e) => { if (e.key === 'Enter') { document.getElementById('SwDocsDocIssueDate').focus(); } }
    const itemSwSupprtDocIssueDatekeydown = (e) => { if (e.key === 'Enter') { document.getElementById('SwDocsBeneficiaryName').focus(); } }
    const itemSwSupprtDocImageRefNokeydown = (e) => { if (e.key === 'Enter') { document.getElementById('SwDocsDocTypeCode').focus(); } }
    const itemSwSupprtDocTypCodekeydown = (e) => { if (e.key === 'F7') { ItemDoc_typecodeOpenHandle(); } if (e.key === 'Enter') { document.getElementById('SwDocsIssuePartyName').focus(); } }
    const itemSwSupprtBeneficaryNamekeydown = (e) => { if (e.key === 'Enter') { document.getElementById('SwDocsFileType').focus(); } }
    const itemSwSupprtFileTypekeydown = (e) => { if (e.key === 'Enter') { document.getElementById('SwDocsDeclarationTYpeMTNE').focus(); } }
    const itemSwSupprtDeclaretionTypekeydown = (e) => { if (e.key === 'Enter') { if (ItemSchemeSaveDsa === false) { ItemSwDocsSave(); } else { ItemSwDocsUpdate(); } } }
    const itemSwSupprtDocRefrenceNokeydown = (e) => { if (e.key === 'Enter') { document.getElementById('SWDocsDocExpiryDate').focus(); } }
    const itemSwSupprtDocExpiryDatekeydown = (e) => { if (e.key === 'Enter') { document.getElementById('SWDocsIssuePartyAddress1').focus(); } }
    const itemSwSupprtIssuepartyAddress1keydown = (e) => { if (e.key === 'Enter') { document.getElementById('SWDocsIssuePartyAddress2').focus(); } }
    const itemSwSupprtIssuepartyAddress2keydown = (e) => { if (e.key === 'Enter') { document.getElementById('swDocsIssuePartyCity').focus(); } }
    const itemSwSupprtIssuepartyCitykeydown = (e) => { if (e.key === 'Enter') { document.getElementById('SwDocsIssuePartyPincode').focus(); } }
    const itemSwSupprtIssuePartyPinCodekeydown = (e) => { if (e.key === 'Enter') { document.getElementById('SwDocsIssuePartyCode').focus(); } }
    const itemSwSupprtIssuePartyCodekeydown = (e) => { if (e.key === 'Enter') { document.getElementById('SwDocsBenificiaryCode').focus(); } }
    const itemSwSupprtBenificiaryCodekeydown = (e) => { if (e.key === 'Enter') { document.getElementById('swDocsBenificiaryAddress1').focus(); } }
    const itemSwSupprtBenificiaryAddress1keydown = (e) => { if (e.key === 'Enter') { document.getElementById('swDocsBenificiaryAddress2').focus(); } }
    const itemSwSupprtBenificiaryAddress2keydown = (e) => { if (e.key === 'Enter') { document.getElementById('swDocsBenificiaryCity').focus(); } }
    const itemSwSupprtBenificiaryCitykeydown = (e) => { if (e.key === 'Enter') { document.getElementById('SwDocsBenificiaryPincode').focus(); } }
    const itemSwSupprtBeneficaryimporterieckeydown = (e) => { if (e.key === 'F7') { ItemImporterDetailsOpenHandle(); } if (e.key === 'Enter') { document.getElementById('SwDocsSrlNo').focus(); } }
    const itemSwSupprtBeneficaryFindimporterieckeydown = (e) => { if (e.key === 'Enter') { document.getElementById('SwDocsFindItemIecCode').focus(); } }
    const itemSwSupprtBeneficaryFindImporterStatekeydown = (e) => { if (e.key === 'Enter') { document.getElementById('SwDocsFindBrnchSrNo').focus(); } }
    const itemSwSupprtBeneficaryimporterbrnchSrNokeydown = (e) => { if (e.key === 'F7') { ItemImporterBranchDetailsOpenHandle(); } }
    const ItemSwControllKeyDown = (e) => {
        if (e.key === 'Enter') {
            if (ItemValues.swControl_Y_N === 'Y' || ItemValues.swControl_Y_N === 'y') {
                var input = document.getElementById('sw_statement'); input.focus(); input.select();
                if (validateItem() === true) {
                    ItemSWControl_OpenHandle();
                }
            } else if (ItemValues.swControl_Y_N === 'N' || ItemValues.swControl_Y_N === 'n') {
                var input2 = document.getElementById('sw_statement'); input2.focus(); input2.select();
            }
        }
    }

    const ItemSWStatmntKeyDown = (e) => {
        if (e.key === 'Enter') {
            if (ItemValues.swStatementY_N === 'Y' || ItemValues.swStatementY_N === 'y') {
                var input = document.getElementById('SW_support'); input.focus(); input.select();
                if (validateItem() === true) {
                    ItemSWStatement_OpenHandle();
                }
            } else if (ItemValues.swStatementY_N === 'N' || ItemValues.swStatementY_N === 'n') {
                var input2 = document.getElementById('SW_support'); input2.focus(); input2.select();
            }
        }
    }
    const ItemPolicyParaKeyDown = (e) => {
        if (e.key === 'Enter') {
            if (ItemValues.PolicyPara_Y_N === 'Y' || ItemValues.PolicyPara_Y_N === 'y') {
                if (ItemSaveItemDsa === false) { document.getElementById('sve_itm').focus(); }
                else { document.getElementById('update_item').focus(); }
                if (validateItem() === true) {
                    ItemPolicyPara_OpenHandle();
                }
            } else if (ItemValues.PolicyPara_Y_N === 'N' || ItemValues.PolicyPara_Y_N === 'n') {
                if (ItemSaveItemDsa === false) {
                    document.getElementById('sve_itm').focus();
                } else {
                    document.getElementById('update_item').focus();
                }
            }
        } if (e.key === 'Tab') {
            document.getElementById('igstCess_SrlNo').focus();
        }
    }
    const IgstDutyKeydown = (e) => { if (e.key === 'Enter') { document.getElementById('AddDutyTyp').focus(); } }
    const AddDutyTypKeydown = (e) => { if (e.key === 'Enter') { document.getElementById('ItemflagGC').focus(); } }
    const FlagKeydown = (e) => { if (e.key === 'Enter') { document.getElementById('igstDuty_notify').focus(); } }
    const ItemSwDocsKeyDown = (e) => {
        if (e.key === 'Enter') {
            if (ItemValues.swSuportDoc_Y_N === 'Y' || ItemValues.swSuportDoc_Y_N === 'y') {
                var input = document.getElementById('policy_para'); input.focus(); input.select();
                if (validateItem() === true) {
                    ItemSwDocs_OpenHandle();
                }
            } else if (ItemValues.swSuportDoc_Y_N === 'N' || ItemValues.swSuportDoc_Y_N === 'n') {
                var input2 = document.getElementById('policy_para'); input2.focus(); input2.select();
            }
        }
    }

    /*-----------------------FocusOut----------------------------------*/
    const insertcmrcialItemalrtno = () => {
        var itemExchangeRate = '';
        if (invoicevalues.invoiceNo !== '') {
            if (ItemSaveItemDsa === false) {
                if (ItemId === '' || ItemId === null) {
                    if (jobValues.job_no !== '' || !jobValues.job_no) {
                        if (invoicevalues.InvoiceId) {
                            if (validateItemPreAlert() === true) {
                                if (ItemValues.txt_exRate !== '') {
                                    itemExchangeRate = ItemValues.txt_exRate;
                                }
                                else {
                                    itemExchangeRate = null;
                                }
                                let Details = {
                                    invoiceId: invoicevalues.InvoiceId, item_description: ItemValues.txt_item_Desc,
                                    ritc: ItemValues.txt_ritc, cth: ItemValues.txt_cth, ceth: ItemValues.txt_ceth, qty: ItemValues.txt_quantity,
                                    unitCode: ItemValues.txt_unit, unitPrice: ItemValues.txt_unitPrice, totalAmount: ItemValues.txt_totAmount,
                                    currency_code: ItemValues.txt_currency, itemExchangeRate: itemExchangeRate, invoiceNumber: invoicevalues.invoiceNo,
                                    consignmentNumber: jobValues.job_no, consignmentId: jobValues.job_no
                                }
                                ItemService.insertCommercialItemPreAlertNo(Details).then(res => {
                                    const data = res.data;
                                    const itemid = data.map((itemid) => itemid.itemId);
                                    if (!itemid[0] || itemid === []) {
                                        setMessage('PreAlart.No is Not Created');
                                        setSeverity('error');
                                        setOpenSnack(true)
                                    } else {
                                        setItemId(itemid[0]);
                                    }
                                    // setprealrtItemId(itemId);                          
                                }).catch(error => {
                                    setMessage(error.message);
                                    setSeverity('error');
                                    setOpenSnack(true);
                                })
                            }
                        } else {
                            setMessage("Please Select Invoice No From Invoice Table");
                            setSeverity('warning');
                            setOpenSnack(true);
                        }
                    } else {
                        setMessage("Please Select Job No From Job Table");
                        setSeverity('warning');
                        setOpenSnack(true);
                    }
                }
            }
        } else {
            setMessage("Please Select Invoice No From Invoice Table");
            setSeverity('warning');
            setOpenSnack(true);
        }
    }

    const validateItemPreAlert = () => {
        if (ItemValues.txt_unit !== '') {
            if (ItemValues.txt_currency !== '') {
                if (ItemValues.txt_totAmount !== '') {
                    if (ItemValues.txt_unitPrice !== '') {
                        if (ItemValues.txt_quantity !== '') {
                            if (ItemValues.txt_ceth !== '') {
                                if (ItemValues.txt_cth !== '') {
                                    if (ItemValues.txt_ritc !== '') {
                                        if (ItemValues.txt_item_Desc !== '') {
                                            return true;
                                        }
                                        else {
                                            setMessage('Please Enter the Item Description');
                                            setSeverity('warning');
                                            setOpenSnack(true);
                                        }
                                    }
                                    else {
                                        setMessage('Please Enter the RITC');
                                        setSeverity('warning');
                                        setOpenSnack(true);
                                    }
                                }
                                else {
                                    setMessage('Please Enter the CTH');
                                    setSeverity('warning');
                                    setOpenSnack(true);
                                }
                            }
                            else {
                                setMessage('Please Enter The CETH');
                                setSeverity('warning');
                                setOpenSnack(true);
                            }
                        }
                        else {
                            setMessage('Please Enter The Quantity');
                            setSeverity('warning');
                            setOpenSnack(true);
                        }
                    }
                    else {
                        setMessage('Please Enter The Unit Price');
                        setSeverity('warning');
                        setOpenSnack(true);
                    }
                }
                else {
                    setMessage('Please Enter The Total Amount');
                    setSeverity('warning');
                    setOpenSnack(true);
                }
            }
            else {
                setMessage('Please Select Currency');
                setSeverity('warning');
                setOpenSnack(true);
            }
        }
        else {
            setMessage('Please Select Unit');
            setSeverity('warning');
            setOpenSnack(true);
        }
        return false;
    }
    // bcd
    const getBcdNotifiDetails = () => {
        var notificationNo, notificationSrNo = '';
        if (ItemValues.bcd_notfication_no !== '') {
            notificationNo = ItemValues.bcd_notfication_no;
        } else {
            notificationNo = '-1';
        }
        if (ItemValues.bcd_sl_no !== '') {
            notificationSrNo = ItemValues.bcd_sl_no;
        } else {
            notificationSrNo = '-1'
        }
        let details = {
            notificationNo: notificationNo, notificationSrNo: notificationSrNo,
            notificationType: 'BCD', hsCode: ItemValues.txt_ritc, flag: 1
        }
        var notificationRate, notificationAmount, notificationFlag, notificationUnit = '';
        ItemService.getCustomNotification(details).then(res => {
            const data = res.data;
            const bcddetails = data.map((bcd) => bcd);
            if (!bcddetails[0] || JSON.stringify(data) === []) {
                notificationRate = ItemValues.bcd_rate_no;
                notificationAmount = ItemValues.bcd_amount_no;
                notificationFlag = ItemValues.bcd_flg_no
                notificationUnit = ItemValues.bcd_uqc_no
            } else {
                setItemValues({
                    ...ItemValues, bcd_rate_no: bcddetails[0].notificationRate, bcd_flg_no: bcddetails[0].notificationFlag,
                    bcd_amount_no: bcddetails[0].notificationAmount, bcd_uqc_no: bcddetails[0].notificationUnit
                });
                if (bcddetails[0].notificationRate !== '') { notificationRate = bcddetails[0].notificationRate; } else { notificationRate = '0.00'; }
                if (bcddetails[0].notificationAmount !== '') { notificationAmount = bcddetails[0].notificationAmount; } else { notificationAmount = '0.00'; }
                if (!bcddetails[0].notificationFlag) { notificationFlag = '' } else { notificationFlag = bcddetails[0].notificationFlag }
                if (!bcddetails[0].notificationUnit) { notificationUnit = '' } else { notificationUnit = bcddetails[0].notificationUnit }
            }
            let insertDetails = {
                itemId: ItemId, notificationRate: notificationRate, notificationAmount: notificationAmount,
                notificationType: "BCD", notificationNo: ItemValues.bcd_notfication_no, notificationSrNo: ItemValues.bcd_sl_no,
                notificationUnit: notificationUnit, notificationFlag: notificationFlag, createdBy: getUserId()
            }
            ItemService.insertItemNotification(insertDetails).then(res => {

            })
        })

    }
    // aidc
    const getAIDCNotifiDetails = () => {
        var notificationNo, notificationSrNo = '';
        if (ItemValues.aidc_notfication_no !== '') {
            notificationNo = ItemValues.aidc_notfication_no;
        } else {
            notificationNo = '-1';
        }
        if (ItemValues.aidc_sl_no !== '') {
            notificationSrNo = ItemValues.aidc_sl_no;
        } else {
            notificationSrNo = '-1'
        }
        let details = {
            notificationNo: notificationNo, notificationSrNo: notificationSrNo,
            notificationType: 'AID', hsCode: '-1', flag: 1
        }
        var notificationRate, notificationFlag, notificationAmount, notificationUnit = ''
        ItemService.getCustomNotification(details).then(res => {
            const data = res.data;
            const bcddetails = data.map((bcd) => bcd);
            if (!bcddetails[0] || JSON.stringify(data) === []) {
                notificationRate = ItemValues.aidc_rate_no; notificationFlag = ItemValues.aidc_flg_no;
                notificationAmount = ItemValues.aidc_amount_no; notificationUnit = ItemValues.aidc_uqc_no;
            } else {
                setItemValues({
                    ...ItemValues, aidc_rate_no: bcddetails[0].notificationRate, aidc_flg_no: bcddetails[0].notificationFlag,
                    aidc_amount_no: bcddetails[0].notificationAmount, aidc_uqc_no: bcddetails[0].notificationUnit
                });
                notificationRate = bcddetails[0].notificationRate; notificationFlag = bcddetails[0].notificationFlag;
                notificationAmount = bcddetails[0].notificationAmount; notificationUnit = bcddetails[0].notificationUnit;
            }
            let insertDetails = {
                itemId: ItemId, notificationRate: notificationRate, notificationAmount: notificationAmount,
                notificationType: "AID", notificationNo: ItemValues.aidc_notfication_no, notificationSrNo: ItemValues.aidc_sl_no,
                notificationUnit: notificationUnit, notificationFlag: notificationFlag, createdBy: getUserId()
            }
            ItemService.insertItemNotification(insertDetails).then(res => {

            })
        })
    }
    // Sws
    const getSWSNotifiDetails = () => {
        var notificationNo, notificationSrNo = '';
        if (ItemValues.sws_notfication_no !== '') {
            notificationNo = ItemValues.sws_notfication_no;
        } else {
            notificationNo = '-1';
        }
        if (ItemValues.sws_sl_no !== '') {
            notificationSrNo = ItemValues.sws_sl_no;
        } else {
            notificationSrNo = '-1'
        }
        let details = {
            notificationNo: notificationNo, notificationSrNo: notificationSrNo,
            notificationType: 'SWS', hsCode: ItemValues.txt_ritc, flag: 1
        }
        var notificationRate, notificationFlag, notificationAmount, notificationUnit = ''
        ItemService.getCustomNotification(details).then(res => {
            const data = res.data;
            const bcddetails = data.map((bcd) => bcd);
            if (!bcddetails[0] || JSON.stringify(data) === []) {
                notificationRate = ItemValues.sws_rate_no; notificationFlag = ItemValues.sws_flg_no;
                notificationAmount = ItemValues.sws_amount_no; notificationUnit = ItemValues.sws_uqc_no;
            } else {
                setItemValues({
                    ...ItemValues, sws_rate_no: bcddetails[0].notificationRate, sws_flg_no: bcddetails[0].notificationFlag,
                    sws_amount_no: bcddetails[0].notificationAmount, sws_uqc_no: bcddetails[0].notificationUnit
                });
                notificationRate = bcddetails[0].notificationRate; notificationFlag = bcddetails[0].notificationFlag;
                notificationAmount = bcddetails[0].notificationAmount; notificationUnit = bcddetails[0].notificationUnit;
            }
            let insertDetails = {
                itemId: ItemId, notificationRate: notificationRate, notificationAmount: notificationAmount,
                notificationType: "SWS", notificationNo: ItemValues.sws_notfication_no, notificationSrNo: ItemValues.sws_sl_no,
                notificationUnit: notificationUnit, notificationFlag: notificationFlag, createdBy: getUserId()
            }
            ItemService.insertItemNotification(insertDetails).then(res => {

            })
        })

    }
    // getCVDNotifiDetails
    const getCVDNotifiDetails = () => {
        var notificationNo, notificationSrNo = '';
        if (ItemValues.cvd_notfication_no !== '') {
            notificationNo = ItemValues.cvd_notfication_no;
        } else {
            notificationNo = '-1';
        }
        if (ItemValues.cvd_sl_no !== '') {
            notificationSrNo = ItemValues.cvd_sl_no;
        } else {
            notificationSrNo = '-1'
        }
        let details = {
            notificationNo: notificationNo, notificationSrNo: notificationSrNo,
            notificationType: 'CVD', hsCode: ItemValues.txt_ritc, flag: 1
        }
        var notificationRate, notificationFlag, notificationAmount, notificationUnit = ''
        ItemService.getCustomNotification(details).then(res => {
            const data = res.data;
            const bcddetails = data.map((bcd) => bcd);
            if (!bcddetails[0] || JSON.stringify(data) === []) {
                notificationRate = ItemValues.cvd_rate_no; notificationFlag = ItemValues.cvd_flg_no;
                notificationAmount = ItemValues.cvd_amount_no; notificationUnit = ItemValues.cvd_uqc_no;
            } else {
                setItemValues({
                    ...ItemValues, cvd_rate_no: bcddetails[0].notificationRate, cvd_flg_no: bcddetails[0].notificationFlag,
                    cvd_amount_no: bcddetails[0].notificationAmount, cvd_uqc_no: bcddetails[0].notificationUnit
                });
                notificationRate = bcddetails[0].notificationRate; notificationFlag = bcddetails[0].notificationFlag;
                notificationAmount = bcddetails[0].notificationAmount; notificationUnit = bcddetails[0].notificationUnit;
            }
            let insertDetails = {
                itemId: ItemId, notificationRate: notificationRate, notificationAmount: notificationAmount,
                notificationType: "CVD", notificationNo: ItemValues.cvd_notfication_no, notificationSrNo: ItemValues.cvd_sl_no,
                notificationUnit: notificationUnit, notificationFlag: notificationFlag, createdBy: getUserId()
            }
            ItemService.insertItemNotification(insertDetails).then(res => {

            })
        })

    }
    // getEDUNotifiDetails
    const getEDUCessNotifiDetails = () => {
        var notificationNo, notificationSrNo = '';
        if (ItemValues.edu_css_notfication_no !== '') {
            notificationNo = ItemValues.edu_css_notfication_no;
        } else {
            notificationNo = '-1';
        }
        if (ItemValues.edu_css_sl_no !== '') {
            notificationSrNo = ItemValues.edu_css_sl_no;
        } else {
            notificationSrNo = '-1'
        }
        let details = {
            notificationNo: notificationNo, notificationSrNo: notificationSrNo,
            notificationType: 'EDU', hsCode: ItemValues.txt_ritc, flag: 1
        }
        var notificationRate, notificationFlag, notificationAmount, notificationUnit = ''
        ItemService.getCustomNotification(details).then(res => {
            const data = res.data;
            const bcddetails = data.map((bcd) => bcd);
            if (!bcddetails[0] || JSON.stringify(data) === []) {
                notificationRate = ItemValues.edu_css_rate_no; notificationFlag = ItemValues.edu_css_flg_no;
                notificationAmount = ItemValues.edu_css_amount_no; notificationUnit = ItemValues.edu_css_uqc_no;
            } else {
                setItemValues({
                    ...ItemValues, edu_css_rate_no: bcddetails[0].notificationRate, edu_css_flg_no: bcddetails[0].notificationFlag,
                    edu_css_amount_no: bcddetails[0].notificationAmount, edu_css_uqc_no: bcddetails[0].notificationUnit
                });
                notificationRate = bcddetails[0].notificationRate; notificationFlag = bcddetails[0].notificationFlag;
                notificationAmount = bcddetails[0].notificationAmount; notificationUnit = bcddetails[0].notificationUnit;
            }
            let insertDetails = {
                itemId: ItemId, notificationRate: notificationRate, notificationAmount: notificationAmount,
                notificationType: "EDU", notificationNo: ItemValues.edu_css_notfication_no, notificationSrNo: ItemValues.edu_css_sl_no,
                notificationUnit: notificationUnit, notificationFlag: notificationFlag, createdBy: getUserId()
            }
            ItemService.insertItemNotification(insertDetails).then(res => {

            })
        })

    }

    const validateIgstDuty = () => {
        if (ItemValues.igstduty_type !== '') {
            if (ItemValues.igstduty_Add_type !== '') {
                if (ItemValues.igstduty_flagG_C !== '') {
                    if (ItemValues.igstduty_notfion_no !== '') {

                        return true;
                    }

                    else {
                        setMessage('Igst notification no should not be empty ..!!');
                        setSeverity('warning');
                        setOpenSnack(true);
                    }
                }
                else {
                    setMessage('Igst Flag should not be empty..!!');
                    setSeverity('warning');
                    setOpenSnack(true);
                }
            }
            else {
                setMessage('Igst Add Duty Type should not be empty');
                setSeverity('warning');
                setOpenSnack(true)
            }
        }
        else {
            setMessage("Igst Duty Type should not be empty");
            setSeverity('warning');
            setOpenSnack(true)
        }
        return false;
    }

    // getIGSTdutyNotifiDetails
    const getIgstDutyNotifiDetails = () => {
        var notificationNo, notificationSrNo = '';
        if (ItemValues.igstduty_notfion_no !== '') {
            notificationNo = ItemValues.igstduty_notfion_no;
        } else {
            notificationNo = '-1';
        }
        if (ItemValues.igstduty_sl_no !== '') {
            notificationSrNo = ItemValues.igstduty_sl_no;
        } else {
            notificationSrNo = '-1'
        }
        let details = {
            notificationNo: notificationNo, notificationSrNo: notificationSrNo,
            notificationType: 'GST', hsCode: '-1', flag: 1
        }
        var notificationRate, notificationAmount, notificationUnit, notificationFlag = '';
        ItemService.getCustomNotification(details).then(res => {
            const data = res.data;
            const bcddetails = data.map((bcd) => bcd);
            if (!bcddetails[0] || JSON.stringify(data) === []) {
                if (ItemValues.igstduty_rate !== '') {
                    notificationRate = ItemValues.igstduty_rate;
                } else {
                    notificationRate = '0.00';
                }
                if (ItemValues.igstduty_amount !== '') {
                    notificationAmount = ItemValues.igstduty_amount;
                } else {
                    notificationAmount = '0.00';
                } if (!ItemValues.igstduty_uqc) {
                    notificationUnit = '';
                } else {
                    notificationUnit = ItemValues.igstduty_uqc;
                } if (!ItemValues.igstduty_flg) {
                    notificationFlag = '';
                } else {
                    notificationFlag = ItemValues.igstduty_flg;
                }
            } else {
                setItemValues({
                    ...ItemValues, igstduty_rate: bcddetails[0].notificationRate, igstduty_flg: bcddetails[0].notificationFlag,
                    igstduty_amount: bcddetails[0].notificationAmount, igstduty_uqc: bcddetails[0].notificationUnit
                });
                if (bcddetails[0].notificationRate !== '') {
                    notificationRate = bcddetails[0].notificationRate;
                } else {
                    notificationRate = '0.00';
                }
                if (bcddetails[0].notificationAmount !== '') {
                    notificationAmount = bcddetails[0].notificationAmount;
                } else {
                    notificationAmount = '0.00';
                } if (!bcddetails[0].notificationUnit) {
                    notificationUnit = '';
                } else {
                    notificationUnit = bcddetails[0].notificationUnit;
                } if (!bcddetails[0].notificationFlag) {
                    notificationFlag = '';
                } else {
                    notificationFlag = bcddetails[0].notificationFlag;
                }
            }
            if (validateIgstDuty() === true) {
                let insertDetails = {
                    itemId: ItemId, dutyType: ItemValues.igstduty_type, addlDutyType: ItemValues.igstduty_Add_type,
                    igstFlag: ItemValues.igstduty_flagG_C, exempNotNo: ItemValues.igstduty_exmpNotn_no, exempNotSrNo: ItemValues.igstduty_sl_no2
                    , notificationRate: notificationRate, notificationAmount: notificationAmount,
                    notificationType: "GST", notificationNo: ItemValues.igstduty_notfion_no, notificationSrNo: ItemValues.igstduty_sl_no,
                    notificationUnit: notificationUnit, notificationFlag: notificationFlag, status: '2', createdBy: getUserId()
                }
                ItemService.insertIgst(insertDetails).then(res => {

                })
            }
        })
    }
    // getIGSTCessNotifiDetails
    const getIgstCessNotifiDetails = () => {

        var notificationNo, notificationSrNo = '';
        if (ItemValues.igstcess_notfion_no !== '') {
            notificationNo = ItemValues.igstcess_notfion_no;
        } else {
            notificationNo = '-1';
        }
        if (ItemValues.igstcess_sl_no !== '') {
            notificationSrNo = ItemValues.igstcess_sl_no;
        } else {
            notificationSrNo = '-1'
        }
        let details = {
            notificationNo: notificationNo, notificationSrNo: notificationSrNo,
            notificationType: 'CCS', hsCode: '-1', flag: 1
        }
        var notificationRate, notificationAmount, igstFlag, notificationFlag = '';
        ItemService.getCustomNotification(details).then(res => {
            const data = res.data;
            const bcddetails = data.map((bcd) => bcd);
            if (!bcddetails[0] || JSON.stringify(data) === []) {
                if (ItemValues.igstcess_rate !== '') {
                    notificationRate = ItemValues.igstcess_rate;
                } else {
                    notificationRate = '0.00';
                }
                if (ItemValues.notificationAmount !== '') {
                    notificationAmount = ItemValues.igstcess_amount;
                } else {
                    notificationAmount = '0.00';
                }
                if (ItemValues.igstcess_flagG_C !== '') {
                    igstFlag = ItemValues.igstcess_flagG_C;
                } else {
                    igstFlag = null;
                } if (!ItemValues.igstcess_flg) {
                    notificationFlag = ''
                } else {
                    notificationFlag = ItemValues.igstcess_flg
                }

            } else {
                setItemValues({
                    ...ItemValues, igstcess_rate: bcddetails[0].notificationRate, igstcess_flg: bcddetails[0].notificationFlag,
                    igstcess_amount: bcddetails[0].notificationAmount
                });
                if (bcddetails[0].notificationRate !== '') {
                    notificationRate = bcddetails[0].notificationRate;
                } else {
                    notificationRate = '0.00';
                }
                if (bcddetails[0].notificationAmount !== '') {
                    notificationAmount = bcddetails[0].notificationAmount;
                } else {
                    notificationAmount = '0.00';
                }
                if (ItemValues.igstcess_flagG_C !== '') {
                    igstFlag = ItemValues.igstcess_flagG_C;
                } else {
                    igstFlag = null;
                } if (!bcddetails[0].notificationFlag) {
                    notificationFlag = ''
                } else {
                    notificationFlag = bcddetails[0].notificationFlag
                }
            }
            let insertDetails = {
                itemId: ItemId, dutyType: ItemValues.igstduty_type, addlDutyType: ItemValues.igstcess_Add_type,
                igstFlag: igstFlag, notificationRate: notificationRate, notificationAmount: notificationAmount,
                notificationType: "CCS", notificationNo: ItemValues.igstcess_notfion_no, notificationSrNo: ItemValues.igstcess_sl_no,
                notificationFlag: notificationFlag, createdBy: getUserId()
            }
            ItemService.insertIgstCess(insertDetails).then(res => {

            })
        })

    }
    // getSchemeNotifiDetails
    const getSchemeNotifiDetails = () => {

        var notificationNo, notificationSrNo = '';
        if (ItemDialogValues.notofi_no !== '') {
            notificationNo = ItemDialogValues.notofi_no;
        } else {
            notificationNo = '-1';
        }
        if (ItemDialogValues.srl_no !== '') {
            notificationSrNo = ItemDialogValues.srl_no;
        } else {
            notificationSrNo = '-1'
        }
        let details = {
            notificationNo: notificationNo, notificationSrNo: notificationSrNo,
            notificationType: 'AID', hsCode: '-1', flag: 1
        }
        ItemService.getCustomNotification(details).then(res => {
            const data = res.data;
            const bcddetails = data.map((bcd) => bcd);
            if (!bcddetails[0] || JSON.stringify(data) === []) {
                setItemDialogValues({ ...ItemDialogValues, rate: 0 });
            } else {
                setItemDialogValues({ ...ItemDialogValues, rate: bcddetails[0].notificationRate });
            }
        })
    }
    const getCustomNotificationAuntiDumping = () => {
        var notificationNo, notificationSrNo = '';
        if (ItemDialogValues.auntiDump_notn_no !== '') {
            notificationNo = ItemDialogValues.auntiDump_notn_no;
        } else {
            notificationNo = '-1';
        }
        if (ItemDialogValues.auntiDump_Srl_no !== '') {
            notificationSrNo = ItemDialogValues.auntiDump_Srl_no;
        } else {
            notificationSrNo = '-1'
        }
        let details = {
            notificationNo: notificationNo, notificationSrNo: notificationSrNo,
            notificationType: 'ADN', hsCode: '-1', flag: 1
        }
        ItemService.getCustomNotification(details).then(res => {
            const data = res.data;
            const auntiDump = data.map((item) => item)
            if (!auntiDump[0] || JSON.stringify(data) === []) {
                setItemDialogValues({
                    ...ItemDialogValues, auntiDump_notifiRate: '',
                    auntiDump_spaceAmt: '', auntiDump_uqc: '',
                    auntiDump_flag: '', auntiDump_quantity: '',
                    auntiDump_currency: ''
                });
            } else {
                setItemDialogValues({
                    ...ItemDialogValues, auntiDump_notifiRate: auntiDump[0].notificationRate,
                    auntiDump_spaceAmt: auntiDump[0].notificationAmount, auntiDump_uqc: auntiDump[0].notificationUnit,
                    auntiDump_flag: auntiDump[0].notificationFlag, auntiDump_quantity: ItemValues.txt_quantity / 1000,
                    auntiDump_currency: ItemValues.txt_currency
                });
            }
        })
    }
    const ItemDialogNcdNotnFocusOut = () => {
        let details = {
            notificationType: 'NCD', notificationNo: ItemDialogValues.ncdDuty_notn_no,
            notificationSrNo: ItemDialogValues.ncdDuty_notn_slNo, hsCode: '-1', flag: 1
        }
        ItemService.getCustomNotification(details).then(res => {
            const data = res.data;
            const notn = data.map((item) => item);
            setItemDialogValues({
                ...ItemDialogValues, ncdDuty_rate: notn[0].notificationRate,
                ncdDuty_flag: notn[0].notificationFlag, ncdDuty_amount: notn[0].notificationAmount,
                ncdDuty_UQC: notn[0].notificationUnit
            });
        })
    }
    //getCustomNotificationExemp
    const getCustomNotificationExemp = () => {
        let details = {
            notificationType: 'GSE', notificationNo: ItemDialogValues.custm_notfiNo,
            notificationSrNo: ItemDialogValues.custm_Sl_No, hsCode: '-1', flag: 1
        }
        ItemService.getCustomNotification(details).then(res => {
            const data = res.data;
            const notifii = data.map((item) => item);
            setItemDialogValues({
                ...ItemDialogValues, custm_rate: notifii[0].notificationRate,
                custm_amount: notifii[0].notificationAmount, custm_flag: notifii[0].notificationFlag, custm_uqc: notifii[0].notificationUnit
            })
        })
    }
    //getCustomNotificationOtherDuty
    const getCustomNotificationOtherDuty = () => {
        let details = {
            notificationType: 'OTH', notificationNo: ItemDialogValues.othrDuty_NotifiNo,
            notificationSrNo: ItemDialogValues.othrDuty_NotifiSlNo, hsCode: '-1', flag: 1
        }
        ItemService.getCustomNotification(details).then(res => {
            const data = res.data;
            const notifi = data.map((item) => item);
            setItemDialogValues({
                ...ItemDialogValues, othrDuty_NotifiRate: notifi[0].notificationRate,
                othrDuty_NotifiAmount: notifi[0].notificationAmount, othrDuty_NotifiFlag: notifi[0].notificationFlag,
                othrDuty_uqc: notifi[0].notificationUnit
            });
        })
    }

    //getScDutyNotification
    const getScDutyNotification = () => {
        let details = {
            notificationType: 'SCD', notificationNo: ItemDialogValues.custm_notfiNo,
            notificationSrNo: ItemDialogValues.custm_Sl_No, hsCode: '-1', flag: 1
        }
        ItemService.getCustomNotification(details).then(res => {
            const data = res.data;
            const notifi = data.map((item) => item);
            setItemDialogValues({
                ...ItemDialogValues, custm_rate: notifi[0].notificationRate,
                custm_amount: notifi[0].notificationAmount, custm_flag: notifi[0].notificationFlag,
                custm_uqc: notifi[0].notificationUnit
            });
        })
    }

    /*--------------------dialogbox open close-----------------------------*/

    const itemItemDescCloshHandle = () => {
        setItemDescDetails([]);
        setItemDescOpen(false); setRemoveItemHiden(true); setSelectedInvoice([]); setremoItemValue('');
        setItemDialogValues({ ...ItemDialogValues, f_item_desc: "" })
    }
    const itemItemDescOpenHandle = () => {
        setItemDescDetails([]);
        setItemDescOpen(true);
        setItemDialogValues({ ...ItemDialogValues, f_item_desc: ItemValues.txt_item_Desc })
        var itemName = '';
        if (ItemValues.txt_item_Desc === '') {
            itemName = '-1'

        } else {
            itemName = ItemValues.txt_item_Desc;
        }
        ItemService.getItemNameSearch(itemName, '1').then(res => {
            setItemDescDetails(res.data)
        })
    }


    const itemRitcCloshHandle = () => {
        setItemRitcDetails([])
        setitemRitcOpen(false);
        setItemDialogValues({ ...ItemDialogValues, f_ritcCode: '', f_ritcName: '' })
    }
    const itemRitc_OpenHandle = () => {
        setitemRitcOpen(true);
        setItemDialogValues({ ...ItemDialogValues, f_ritcCode: ItemValues.txt_ritc })
        var hsCode = '';
        if (ItemValues.txt_ritc !== '') {
            hsCode = ItemValues.txt_ritc;
        } else {
            hsCode = '-1';
        }
        let details = { hsCode: hsCode, hsName: '-1', flag: '2' }
        ItemService.getHsCode(details).then(res => {
            setItemRitcDetails(res.data);
        })
    }
    const itemCthCloshHandle = () => {
        setItemRitcDetails([])
        setitemCTHOpen(false);
        setItemDialogValues({ ...ItemDialogValues, f_ritcCode: '', f_ritcName: '' })
    }
    const itemCTH_OpenHandle = () => {
        setitemCTHOpen(true);
        setItemDialogValues({ ...ItemDialogValues, f_ritcCode: ItemValues.txt_cth })
        var hsCode = '';
        if (ItemValues.txt_cth !== '') {
            hsCode = ItemValues.txt_cth;
        } else {
            hsCode = '-1';
        }
        let details = { hsCode: hsCode, hsName: '-1', flag: '2' }
        ItemService.getHsCode(details).then(res => {
            setItemRitcDetails(res.data);
        })
    }
    const itemCEThCloshHandle = () => {
        setItemRitcDetails([])
        setitemCETHOpen(false);
        setItemDialogValues({ ...ItemDialogValues, f_ritcCode: '', f_ritcName: '' })
    }
    const itemCETH_OpenHandle = () => {
        setitemCETHOpen(true);
        setItemDialogValues({ ...ItemDialogValues, f_ritcCode: ItemValues.txt_ritc })
        var hsCode = '';
        if (ItemValues.txt_ritc !== '') {
            hsCode = ItemValues.txt_ritc;
        } else {
            hsCode = '-1';
        }
        let details = { hsCode: hsCode, hsName: '-1', flag: '2' }
        ItemService.getHsCode(details).then(res => {
            setItemRitcDetails(res.data);
        })
    }
    const itemUnitCloshHandle = () => {
        setItemRitcDetails([])
        setitemUnitOpen(false);
        setItemDialogValues({ ...ItemDialogValues, f_unitCode: '', f_unitName: '' })
    }
    const itemUnit_OpenHandle = () => {
        setitemUnitOpen(true);
        setItemDialogValues({ ...ItemDialogValues, f_unitCode: ItemValues.txt_unit })
        var unitCode = '';
        if (ItemValues.txt_unit !== '') {
            unitCode = ItemValues.txt_unit;
        } else {
            unitCode = '-1';
        }
        let details = { unitCode: unitCode, unitName: '-1', flag: 2 }
        JobServices.getUOM(details).then(res => {
            setItemRitcDetails(res.data);
        })
    }

    const itemCurrencyCloshHandle = () => {
        setItemRitcDetails([])
        setItemCurrencyOpen(false);
    }
    const itemCurrency_OpenHandle = () => {
        setItemCurrencyOpen(true);
        setItemDialogValues({ ...ItemDialogValues, f_currencyCode: ItemValues.txt_currency })
        var currency_code = '';
        if (ItemValues.txt_currency !== '') {
            currency_code = ItemValues.txt_currency;
        } else {
            currency_code = '-1';
        }
        let details = { currency_code: currency_code, currencyPrefix: '-1', flag: 1 }
        InvoiceService.getCurrency(details).then(res => {
            setItemRitcDetails(res.data);
        })
    }

    const itemEndUseCloshHandle = () => {
        setItemRitcDetails([]);
        setItemEndUseOpen(false);
    }
    const itemEndUse_OpenhHandle = () => {
        setItemRitcDetails([]);
        setItemEndUseOpen(true);
        setItemDialogValues({ ...ItemDialogValues, f_enduse_code: ItemValues.txt_endusCode })
        var endUseCode = '';
        if (ItemValues.txt_endusCode !== '') {
            endUseCode = ItemValues.txt_endusCode;
        } else {
            endUseCode = '-1';
        }
        let details = { endUseCode: endUseCode, endUseDesc: '-1', flag: 2 }
        ItemService.getEndUseCode(details).then(res => {
            setItemRitcDetails(res.data);
        })
    }

    const itemOriginCntryCloshHandle = () => {
        setItemRitcDetails([]);
        setItemOriginCntryOpen(false);
    }
    const itemOriginCntry_OpenHandle = () => {
        setItemOriginCntryOpen(true);
        setItemDialogValues({ ...ItemDialogValues, f_originCntryCode: ItemValues.txt_originCntry })
        var countryIdString = '';
        if (ItemValues.txt_originCntry !== '') {
            countryIdString = ItemValues.txt_originCntry;
        } else {
            countryIdString = '-1';
        }
        let details = { countryIdString: countryIdString, countryName: '-1', flag: 2 }
        JobServices.getCountryName(details).then(res => {
            setItemRitcDetails(res.data);
        })
    }
    const itemSourceCntryCloshHandle = () => {
        setItemRitcDetails([]);
        setItemSourceCntryOpen(false);
    }
    const itemSourceCntry_OpenHandle = () => {
        setItemSourceCntryOpen(true);
        setItemDialogValues({ ...ItemDialogValues, f_originCntryCode: ItemValues.txt_sourceCountry })
        var countryIdString = '';
        if (ItemValues.txt_sourceCountry !== '') {
            countryIdString = ItemValues.txt_sourceCountry;
        } else {
            countryIdString = '-1';
        }
        let details = { countryIdString: countryIdString, countryName: '-1', flag: 2 }
        JobServices.getCountryName(details).then(res => {
            setItemRitcDetails(res.data);
        })
    }
    const itemTransiteCntryCloshHandle = () => {
        setItemRitcDetails([]);
        setItemTransitCntryOpen(false);
    }
    const itemTransiteCntry_OpenHandle = () => {
        setItemTransitCntryOpen(true);
        setItemDialogValues({ ...ItemDialogValues, f_originCntryCode: ItemValues.txt_transit_country })
        var countryIdString = '';
        if (ItemValues.txt_transit_country !== '') {
            countryIdString = ItemValues.txt_transit_country;
        } else {
            countryIdString = '-1';
        }
        let details = { countryIdString: countryIdString, countryName: '-1', flag: 2 }
        JobServices.getCountryName(details).then(res => {
            setItemRitcDetails(res.data);
        })
    }

    const itemBcdNotifyCloshHandle = () => {document.getElementById("bcd_notifyNo").focus();setItemRitcDetails([]);        setItemBcdNotifyNoOpen(false);     }
    const itemBcdNotify_OpenHandle = () => {
        setItemRitcDetails([]); setItemBcdNotifyNoOpen(true);
        setItemDialogValues({ ...ItemDialogValues, f_bcd_notificationNo: ItemValues.bcd_notfication_no, f_bcd_notificationSrNo: ItemValues.bcd_sl_no })
        var notificationNo, notificationSrNo = '';
        if (ItemValues.bcd_notfication_no !== '') {
            notificationNo = ItemValues.bcd_notfication_no;
        } else {
            notificationNo = '-1';
        }
        if (ItemValues.bcd_sl_no !== '') {
            notificationSrNo = ItemValues.bcd_sl_no;
        } else {
            notificationSrNo = '-1'
        }
        let details = {
            notificationNo: notificationNo, notificationSrNo: notificationSrNo,
            notificationType: 'BCD', hsCode: ItemValues.txt_ritc, flag: 2
        }
        ItemService.getCustomNotification(details).then(res => {
            setItemRitcDetails(res.data);
        });
    }
    const itemAidcNotifyCloshHandle = () => {setItemRitcDetails([]); document.getElementById('aidc_notify').focus();setItemAidcNotifyNoOpen(false);    }
    const itemAidcNotify_OpenHandle = () => {
        setItemRitcDetails([]); setItemAidcNotifyNoOpen(true);
        setItemDialogValues({...ItemDialogValues, f_aidc_notificationNo: ItemValues.aidc_notfication_no,
            f_aidc_notificationSrNo: ItemValues.aidc_sl_no})
        var notificationNo, notificationSrNo = '';
        if (ItemValues.aidc_notfication_no !== '') {
            notificationNo = ItemValues.aidc_notfication_no;
        } else {
            notificationNo = '-1';
        }
        if (ItemValues.aidc_sl_no !== '') {
            notificationSrNo = ItemValues.aidc_sl_no;
        } else {
            notificationSrNo = '-1'
        }
        let details = {
            notificationNo: notificationNo, notificationSrNo: notificationSrNo,
            notificationType: 'AID', hsCode: '-1', flag: 2
        }
        ItemService.getCustomNotification(details).then(res => {
            setItemRitcDetails(res.data);
        })
    }

    const itemSwsNotifyCloshHandle = () => {setItemRitcDetails([]); setItemSwsNotifyNoOpen(false);document.getElementById("sws_notifi").focus(); }
    const itemSwsNotify_OpenHandle = () => {
        setItemSwsNotifyNoOpen(true);  setItemDialogValues({ ...ItemDialogValues, f_SWS_notificationNo: ItemValues.sws_notfication_no, f_SWS_notificationSrNo: ItemValues.sws_sl_no });
        var notificationNo, notificationSrNo = '';
        if (!ItemValues.sws_notfication_no || ItemValues.sws_notfication_no === '') {
            notificationNo = '-1';
        } else {
            notificationNo = ItemValues.sws_notfication_no;
        }
        if (!ItemValues.sws_sl_no || ItemValues.sws_sl_no === '') {
            notificationSrNo = '-1';
        } else {
            notificationSrNo = ItemValues.sws_sl_no;
        }
        let details = {
            notificationNo: notificationNo, notificationSrNo: notificationSrNo,
            notificationType: 'SWS', hsCode: ItemValues.txt_ritc, flag: 2
        }
        ItemService.getCustomNotification(details).then(res => {
            setItemRitcDetails(res.data);
        })
    }
    const itemCVDNotifyCloshHandle = () => { setItemRitcDetails([]); setItemCVDNotifyNoOpen(false); document.getElementById("cvd_notifi").focus();   }
    const itemCVDNotify_OpenHandle = () => {
        setItemCVDNotifyNoOpen(true);  setItemDialogValues({ ...ItemDialogValues, f_CVD_notificationNo: ItemValues.cvd_notfication_no, f_CVD_notificationSrNo: ItemValues.cvd_sl_no })
        var notificationNo, notificationSrNo = '';
        if (ItemValues.cvd_notfication_no !== '') {
            notificationNo = ItemValues.cvd_notfication_no;
        } else {
            notificationNo = '-1';
        }
        if (ItemValues.cvd_sl_no !== '') {
            notificationSrNo = ItemValues.cvd_sl_no;
        } else {
            notificationSrNo = '-1'
        }
        let details = {
            notificationNo: notificationNo, notificationSrNo: notificationSrNo,
            notificationType: 'CVD', hsCode: ItemValues.txt_ritc, flag: 2
        }
        ItemService.getCustomNotification(details).then(res => {
            setItemRitcDetails(res.data);
        })
    }
    const itemEDUCessNotifyCloshHandle = () => {  setItemRitcDetails([]); setItemEDuCessNotifyNoOpen(false);document.getElementById("edu_cess_notfi").focus();}
    const itemEDUCessNotify_OpenHandle = () => {
        setItemEDuCessNotifyNoOpen(true);  setItemDialogValues({ ...ItemDialogValues, f_EDU_notificationNo: ItemValues.edu_css_notfication_no, f_EDU_notificationSrNo: ItemValues.edu_css_sl_no })
        var notificationNo, notificationSrNo = '';
        if (ItemValues.edu_css_notfication_no !== '') {
            notificationNo = ItemValues.edu_css_notfication_no;
        } else {
            notificationNo = '-1';
        }
        if (ItemValues.edu_css_sl_no !== '') {
            notificationSrNo = ItemValues.edu_css_sl_no;
        } else {
            notificationSrNo = '-1'
        }
        let details = {
            notificationNo: notificationNo, notificationSrNo: notificationSrNo,
            notificationType: 'EDU', hsCode: ItemValues.txt_ritc, flag: 2
        }
        ItemService.getCustomNotification(details).then(res => {
            setItemRitcDetails(res.data);
        })
    }
    const itemIGSTDutyNotifyCloshHandle = () => {
        setItemRitcDetails([]);setItemSelect([]);
        setItemIGSTDutyNotifyNoOpen(false);
    }
    const itemIGSTDutyNotify_OpenHandle = () => {
        setItemIGSTDutyNotifyNoOpen(true);setItemSelect([]);
        setItemDialogValues({
            ...ItemDialogValues, f_IGSTDuty_notificationNo: ItemValues.igstduty_notfion_no,
            f_IGSTDuty_notificationSrNo: ItemValues.igstduty_sl_no
        })
        var notificationNo, notificationSrNo = '';
        if (ItemValues.igstduty_notfion_no !== '') {
            notificationNo = ItemValues.igstduty_notfion_no;
        } else {
            notificationNo = '-1';
        }
        if (ItemValues.igstduty_sl_no !== '') {
            notificationSrNo = ItemValues.igstduty_sl_no;
        } else {
            notificationSrNo = '-1'
        }
        let details = {
            notificationNo: notificationNo, notificationSrNo: notificationSrNo,
            notificationType: 'GST', hsCode: '-1', flag: 2
        }
        ItemService.getCustomNotification(details).then(res => {
            setItemRitcDetails(res.data);
        })
    }
    const itemIGSTCessNotifyCloshHandle = () => {
        setItemRitcDetails([])
        setItemIGSTCessNotifyNoOpen(false);
    }
    const itemIGSTCessNotify_OpenHandle = () => {
        setItemIGSTCessNotifyNoOpen(true);
        setItemDialogValues({
            ...ItemDialogValues, f_IGSTCess_notificationNo: ItemValues.igstcess_notfion_no,
            f_IGSTCess_notificationSrNo: ItemValues.igstcess_sl_no
        });

        var notificationNo, notificationSrNo = '';
        if (ItemValues.igstcess_notfion_no !== '') {
            notificationNo = ItemValues.igstcess_notfion_no;
        } else {
            notificationNo = '-1';
        }
        if (ItemValues.igstcess_sl_no !== '') {
            notificationSrNo = ItemValues.igstcess_sl_no;
        } else {
            notificationSrNo = '-1'
        }
        let details = {
            notificationNo: notificationNo, notificationSrNo: notificationSrNo,
            notificationType: 'CCS', hsCode: '-1', flag: 2
        }
        ItemService.getCustomNotification(details).then(res => {
            setItemRitcDetails(res.data);
        })
    }
    const itemIGSTDutyExmpNotifyCloshHandle = () => {
        setItemRitcDetails([]);
        setItemIgstExmpNotnOpen(false); 
    }
    const itemIGSTExmpNotify_OpenHandle = () => {
        setItemIgstExmpNotnOpen(true);
        setItemDialogValues({
            ...ItemDialogValues, f_IGSTDutyExmp_notificationNo: ItemValues.igstduty_exmpNotn_no,
            f_IGSTDutyExmp_notificationSrNo: ItemValues.igstduty_sl_no2
        });

        var notificationNo, notificationSrNo = '';
        if (ItemValues.igstduty_exmpNotn_no !== '') {
            notificationNo = ItemValues.igstduty_exmpNotn_no;
        } else {
            notificationNo = '-1';
        }
        if (ItemValues.igstduty_sl_no2 !== '') {
            notificationSrNo = ItemValues.igstduty_sl_no2;
        } else {
            notificationSrNo = '-1'
        }
        let details = {
            notificationNo: notificationNo, notificationSrNo: notificationSrNo,
            notificationType: 'GST', hsCode: '-1', flag: 2
        }
        ItemService.getCustomNotification(details).then(res => {
            setItemRitcDetails(res.data);
        })
    }

    const ItemSchemeCodeCloshHandle = () => { setItemRitcDetails([]); setItemSchemeCodeOpen(false); SchemeCodeReset(); }
    const ItemSchemeCode_OpenHandle = () => {
        setItemSchemeCodeOpen(true); document.getElementById('licence').focus();
        ItemService.getItemSchemeCode(ItemId).then(res => { setItemRitcDetails(res.data) })
    }
    const ItemSchemeCodeDetailsCloshHandle = () => { setItemSchemeCodeDetailsOpen(false); setItemSchemeCodeDetails([]); }
    const ItemSchemeCodeDetails_OpenHandle = () => {
        setItemSchemeCodeDetailsOpen(true);
        setItemDialogValues({ ...ItemDialogValues, f_scheme_code: ItemDialogValues.scheme_code, f_scheme_codeName: ItemDialogValues.scheme_codeName })
        var schemeDesc, schemeCode = '';
        if (ItemDialogValues.scheme_code !== '') {
            schemeCode = ItemDialogValues.scheme_code;
        } else { schemeCode = '-1' }
        if (ItemDialogValues.scheme_codeName !== '') { schemeDesc = ItemDialogValues.scheme_codeName; }
        else { schemeDesc = '-1' }
        let details = { schemeCode: schemeCode, schemeDesc: schemeDesc, flag: '2' }
        ItemService.getSchemeCode(details).then(res => { setItemSchemeCodeDetails(res.data); })
    }

    const ItemSchemeNotnDetailsCloshHandle = () => {
        setItemSchemeCodeDetails([]); setItemSchemeNotenDetailsOpen(false);
    }
    const ItemSchemeNotnDetails_OpenHandle = () => {
        setItemSchemeNotenDetailsOpen(true);
        setItemDialogValues({ ...ItemDialogValues, f_IGST_notificationNo: ItemDialogValues.notofi_no, f_IGST_notificationSrNo: ItemDialogValues.srl_no })
        var notificationNo, notificationSrNo = '';
        if (ItemDialogValues.notofi_no !== '') {
            notificationNo = ItemDialogValues.notofi_no;
        } else {
            notificationNo = '-1';
        }
        if (ItemDialogValues.srl_no !== '') {
            notificationSrNo = ItemDialogValues.srl_no;
        } else {
            notificationSrNo = '-1'
        }
        let details = {
            notificationNo: notificationNo, notificationSrNo: notificationSrNo,
            notificationType: 'GST', hsCode: '-1', flag: 2
        }
        ItemService.getCustomNotification(details).then(res => {
            setItemSchemeCodeDetails(res.data);
        })
    }

    //ItemAunti_DumbingCloshHandle
    const ItemAuntiDumbingCloshHandle = () => { setItemAuntiDumpingOpen(false); setItemRitcDetails([]); AuntiDumpReset(); }
    const ItemAuntiDumbing_OpenHandle = () => {
        setItemAuntiDumpingOpen(true);
        let details = { itemId: ItemId, notificationType: 'ADN' }
        ItemService.getItemNotificationAntiDumping(details).then(res => { setItemRitcDetails(res.data); })
    }
    const ItemAuntiNotifiCloshHandle = () => { setItemAuntiNotifiOpen(false); }
    const ItemAuntiNotifi_OpenHandle = () => {
        setItemAuntiNotifiOpen(true);
        setItemDialogValues({ ...ItemDialogValues, f_auntiDump_notn_no: ItemDialogValues.auntiDump_notn_no, f_auntiDump_Srl_no: ItemDialogValues.auntiDump_Srl_no })
        var notificationNo, notificationSrNo = '';
        if (ItemDialogValues.auntiDump_notn_no !== '') { notificationNo = ItemDialogValues.auntiDump_notn_no; }
        else { notificationNo = '-1'; }
        if (ItemDialogValues.auntiDump_Srl_no !== '') { notificationSrNo = ItemDialogValues.auntiDump_Srl_no; }
        else { notificationSrNo = '-1'; }
        let details = { notificationNo: notificationNo, notificationSrNo: notificationSrNo, notificationType: 'ADN', hsCode: '-1', flag: 2 }
        ItemService.getCustomNotification(details).then(res => { setItemSchemeCodeDetails(res.data); })
    }
    //ItemSwInfoCloshHandle
    const ItemSwInfoCloshHandle = () => { SwInfoReset(); setItemSwInfoOpen(false); setItemRitcDetails([]); }
    const ItemSwInfo_OpenHandle = () => {
        setItemSwInfoOpen(true);
        let details = { unitCode: '-1', unitName: '-1', flag: 1 }
        JobServices.getUOM(details).then(res => { setItemSwUQCDrp(res.data); });
        // let detailsSwinQ = { swCode: 'CHR' }
        // ItemService.getSwInfoQualifier(detailsSwinQ).then(res => { 
            setItemSwQualifrDrp([{swQualifier:'SQC'}]) //});
        ItemService.getSwInfoType().then(res => { setitemSwInfoTypeDrp(res.data); })
        let details2 = { itemId: ItemId, consignmentId: jobValues.job_no }
        ItemService.getItemSwInfo(details2).then(res => { setItemRitcDetails(res.data) });
        let details3 = { hsCode: ItemValues.txt_ritc, hsName: '-1', flag: '1' }
        ItemService.getHsCode(details3).then(res => {
            const data = res.data;
            const hscode = data.map((item) => item);
            setItemValues({
                ...ItemValues, bcd_rate_no: hscode[0].notificationRate, bcd_amount_no: hscode[0].notificationAmount,
                bcd_uqc_no: hscode[0].notificationUnit, sws_rate_no: hscode[0].totalAmount, swinfo_Y_N: 'Y'
            });
            setItemDialogValues({ ...ItemDialogValues, Sw_Uqc: hscode[0].notificationUnit });
        });
    }

    //Item_LicenceCloshHandle
    const ItemLicenceCloshHandle = () => { setItemLicenceOpen(false); setItemRitcDetails([]); LicenceReset(); }
    const ItemLicence_OpenHandle = () => {
        setItemLicenceOpen(true); LicenceReset();
        let details = { unitCode: '-1', unitName: '-1', flag: 1 }
        JobServices.getUOM(details).then(res => { setItemSwUQCDrp(res.data); })
        let detailslice = { itemId: ItemId }
        ItemService.getLicenceDetails(detailslice).then(res => { setItemRitcDetails(res.data); })
    }

    const ItemLicenceCodeCloshHandle = () => {
        setItemLicencCodeeOpen(false); setItemDialogValues({ ...ItemDialogValues, f_scheme_code: '', f_scheme_codeName: '' })
        setItemSchemeCodeDetails([]);
    }
    const ItemLicenceCode_OpenHandle = () => {
        setItemSchemeCodeDetails([]); setItemLicencCodeeOpen(true);
        setItemDialogValues({ ...ItemDialogValues, f_scheme_code: ItemDialogValues.licence_code, f_scheme_codeName: ItemDialogValues.licence_codeName })
        var schemeCode = '';
        if (ItemDialogValues.licence_code !== '') { schemeCode = ItemDialogValues.licence_code; }
        else { schemeCode = '-1' }
        let details = { schemeCode: schemeCode, schemeDesc: '-1', flag: '2' }
        ItemService.getSchemeCode(details).then(res => { setItemSchemeCodeDetails(res.data); })
    }

    const ItemLicencePortCloshHandle = () => { setItemLicencPortOpen(false); setItemSchemeCodeDetails([]); }
    const ItemLicencePort_OpenHandle = () => {
        setItemSchemeCodeDetails([]); setItemLicencPortOpen(true);
        var cusHouseCode = '';
        if (ItemDialogValues.licence_reg_port !== '') { cusHouseCode = ItemDialogValues.licence_reg_port; }
        else { cusHouseCode = '-1' }
        let details = { customHouseLocation: '-1', cusHouseCode: cusHouseCode, flag: 2 }
        JobServices.getCustomHouseCode(details).then(res => { setItemSchemeCodeDetails(res.data) });
    }

    //Item_SwConstituentCloshHandle
    const ItemSwConstituentCloshHandle = () => { setItemConstituentOpen(false); setItemRitcDetails([]); ItemAddSWConstituentReset(); }
    const ItemSwConstituent_OpenHandle = () => {
        setItemConstituentOpen(true);
        let details = { itemId: ItemId, consignmentId: jobValues.job_no }
        ItemService.getSwConstitunet(details).then(res => { setItemRitcDetails(res.data); })
    }

    const ItemRspDutyCloshHandle = () => { setItemRspDutyOpen(false); setItemRitcDetails([]); ItemAddRspReset(); }
    const ItemRspDuty_OpenHandle = () => {
        setItemRspDutyOpen(true); document.getElementById('ncd_customDuty').focus();
        setItemDialogValues({ ...ItemDialogValues, rsp_description: ItemValues.txt_item_Desc, rsp_quantity: ItemValues.txt_quantity });
        let details = { itemId: ItemId }
        ItemService.getItemRSP(details).then(res => { setItemRitcDetails(res.data) });
    }

    const ItemReImportCloshHandle = () => { setItemReImportOpen(false); setItemRitcDetails([]); ItemAddRe_importReset(); }
    const ItemReImport_OpenHandle = () => {
        setItemReImportOpen(true); setItemRitcDetails([]);
        let details = { itemId: ItemId }
        ItemService.getItemReimport(details).then(res => { setItemRitcDetails(res.data); })
    }

    const ItemReImPortCodeCloshHandle = () => { setItemReImpPortCodeOpen(false); setItemSchemeCodeDetails([]); }
    const ItemReImPortCode_OpenHandle = () => {
        setItemReImpPortCodeOpen(true);
        setItemDialogValues({ ...ItemDialogValues, f_scheme_code: ItemDialogValues.r_iPort_of_export })
        var customPointCode = '';
        if (ItemDialogValues.r_iPort_of_export !== '') { customPointCode = ItemDialogValues.r_iPort_of_export; }
        else { customPointCode = '-1' }
        let details = { customPointCode: customPointCode, customPointName: '-1', flag: 2 }
        JobServices.getPortLocationBasedTransitType(details).then(res => { setItemSchemeCodeDetails(res.data); })
    }

    const ItemNcdDutyCloshHandle = () => { setItemNcdDutyOpen(false); setItemRitcDetails([]); }
    const ItemNcdDuty_OpenHandle = () => {
        setItemNcdDutyOpen(true); setItemRitcDetails([]);
        let details = { itemId: ItemId, notificationType: 'NCD', flag: 1 }
        ItemService.getItemNotification(details).then(res => { setItemRitcDetails(res.data); });
    }

    const ItemSwProductionCloshHandle = () => { ItemAddProdectionReset(); setItemRitcDetails([]); setItemSwProductionOpen(false); }
    const ItemSwProduction_OpenHandle = () => {
        setItemSwProductionOpen(true);
        let details = { unitCode: '-1', unitName: '-1', flag: 1 }
        JobServices.getUOM(details).then(res => { setItemSwUQCDrp(res.data); });
        let detailslice = { itemId: ItemId, consignmentId: jobValues.job_no }
        ItemService.getSwProduction(detailslice).then(res => { setItemRitcDetails(res.data); })
    }

    const ItemSVBStatusCloshHandle = () => { setItemSvbStatusOpen(false); setItemCusHusCode([]); }
    const ItemSVBStatus_OpenHandle = () => {
        setItemSvbStatusOpen(true);
        let details = { customPointCode: '-1', customPointName: '-1', flag: 1 }
        JobServices.getPortLocationBasedTransitType(details).then(res => { setItemCusHusCode(res.data); })
    }

    const ItemManufactureCloshHandle = () => { setItemManufactureOpen(false); setitemCountryDetails([]); setItemRitcDetails([]); }
    const ItemManufacture_OpenHandle = () => {
        setItemManufactureOpen(true); setitemCountryDetails([]); setItemRitcDetails([]);
        let details = { countryIdString: '-1', countryName: '-1', flag: 2 }
        JobServices.getCountryName(details).then(res => { setitemCountryDetails(res.data); })
        let details2 = { itemId: ItemId }
        ItemService.import_item_getManufacture(details2).then(res => { setItemRitcDetails(res.data); })
        setItemDialogValues({
            ...ItemDialogValues, mnfctr_manufactureName: invoicevalues.SupplierName, mnfctr_country: invoicevalues.disable_supcountry_Name,
            mnfctr_adress: invoicevalues.Address1, mnfctr_pincode: invoicevalues.PinCode
        })
    }

    const ItemSupplierCloshHandle = () => { setItemSupplierNameOpen(false); setItemSchemeCodeDetails([]); }
    const ItemSupplier_OpenHandle = () => {
        setItemSupplierNameOpen(true); setItemSchemeCodeDetails([]);
        var supplierName = '';
        if (ItemDialogValues.mnfctr_manufactureName !== '') {
            supplierName = ItemDialogValues.mnfctr_manufactureName;
        }
        else { supplierName = '-1'; }
        let details = { supplierName: supplierName, flag: 2 }
        InvoiceService.getSupplierDetails(details).then(res => { setItemSchemeCodeDetails(res.data); })
    }

    const ItemCustNotnExmpCloshHandle = () => { ItemAddCustmExmpNotnNoReset(); setItemCustNotnExmpOpen(false); setItemRitcDetails([]); }
    const ItemCustNotnExmp_OpenHandle = () => {
        ItemAddCustmExmpNotnNoReset(); setItemCustNotnExmpOpen(true); setItemRitcDetails([]);
        let details = { itemId: ItemId, notificationType: 'GSE', flag: 1 }
        ItemService.getItemNotification(details).then(res => { setItemRitcDetails(res.data); })
    }

    const ItemOtherDutyCloshHandle = () => { setItemOtherDutyOpen(false); setItemCusHusCode([]); setItemRitcDetails([]); ItemAddOthrDutyReset(); }
    const ItemOtherDuty_OpenHandle = () => {
        setItemOtherDutyOpen(true); setItemCusHusCode([]); setItemRitcDetails([]); ItemAddOthrDutyReset();
        ItemService.getCustomNotificationType().then(res => { setItemCusHusCode(res.data); })
        let details = { itemId: ItemId, notificationType: '1', flag: 1 }
        ItemService.getItemNotification(details).then(res => { setItemRitcDetails(res.data); })
    }

    const ItemOtherDutyNotfiCloshHandle = () => {
        setItemOtherDutyNotfiOpen(false); setItemSchemeCodeDetails([]);
        setItemDialogValues({ ...ItemDialogValues, f_scheme_code: '', f_scheme_codeName: '' })
    }
    const ItemOtherDutyNotfi_oprnHandle = () => {
        setItemOtherDutyNotfiOpen(true); setItemSchemeCodeDetails([])
        setItemDialogValues({ ...ItemDialogValues, f_scheme_code: ItemDialogValues.othrDuty_NotifiNo, f_scheme_codeName: ItemDialogValues.othrDuty_NotifiSlNo })
        var notificationNo, notificationSrNo = '';
        if (ItemDialogValues.othrDuty_NotifiNo !== '') { notificationSrNo = ItemDialogValues.othrDuty_NotifiNo; }
        else { notificationSrNo = '-1'; }
        if (ItemDialogValues.othrDuty_NotifiSlNo !== '') { notificationNo = ItemDialogValues.othrDuty_NotifiSlNo; }
        else { notificationNo = '-1'; }
        let details = {
            notificationSrNo: notificationSrNo, notificationNo: notificationNo, notificationType: 'GST',
            hsCode: '-1', flag: 2
        }
        ItemService.getCustomNotification(details).then(res => { setItemSchemeCodeDetails(res.data); })
    }
    const ItemScDutyCloshHandle = () => { setItemScDutyOpen(false); setItemRitcDetails([]); ItemAddCustmExmpNotnNoReset(); }
    const ItemScDuty_OpenHandle = () => {
        setItemScDutyOpen(true); ItemAddCustmExmpNotnNoReset(); setItemRitcDetails([]);
        let details = { itemId: ItemId, notificationType: 'SCD', flag: 1 }
        ItemService.getItemNotification(details).then(res => { setItemRitcDetails(res.data); })
    }

    const ItemSWControlCloshHandle = () => {
        setItemSWControlOpen(false); setItemRitcDetails([]); setItemSwUQCDrp([]); setItemCusHusCode([]);
        ItemAddSwControlReset();
    }
    const ItemSWControl_OpenHandle = () => {
        setItemSWControlOpen(true); setItemRitcDetails([]); setItemSwUQCDrp([]); setItemCusHusCode([]);
        ItemAddSwControlReset();
        let uomDetails = { unitCode: '-1', unitName: '-1', flag: 1 }
        JobServices.getUOM(uomDetails).then(res => { setItemSwUQCDrp(res.data); })
        ItemService.getSwControlCode().then(res => { setItemCusHusCode(res.data); })
        let details = { itemId: ItemId, consignmentId: jobValues.job_no }
        ItemService.getSwControl(details).then(res => { setItemRitcDetails(res.data); })
    }

    const ItemSWStatementCloshHandle = () => {
        ItemAddSwStatementReset(); setItemSWStatementOpen(false); setItemSwCodeDrp([]);
        setItemCusHusCode([]); setItemRitcDetails([]);
    }
    const ItemSWStatement_OpenHandle = () => {
        setItemSWStatementOpen(true); setItemSwCodeDrp([]); setItemCusHusCode([]);
        setItemRitcDetails([]); ItemAddSwStatementReset();
        ItemService.getSwStatementType().then(res => { setItemSwCodeDrp(res.data); })
        let details = { itemId: ItemId, consignmentId: jobValues.job_no }
        ItemService.getSwStatement(details).then(res => { setItemRitcDetails(res.data); })
    }

    const ItemPolicyParaCloshHandle = () => { setItemPolicyParaOpen(false); setItemRitcDetails([]); ItemPolicyReset(); }
    const ItemPolicyPara_OpenHandle = () => {
        setItemPolicyParaOpen(true); setItemRitcDetails([]); ItemPolicyReset();
        let details = { itemId: ItemId }
        ItemService.getItemPolicyPara(details).then(res => { setItemRitcDetails(res.data); })
    }

    //swdocs
    const ItemSwDocsCloshHandle = () => { setItemSwDocsOpen(false); ItemSwDocsReset(); setItemSwUQCDrp([]); setItemRitcDetails([]); }
    const ItemSwDocs_OpenHandle = () => {
        setItemSwDocsOpen(true); ItemSwDocsReset(); setItemSwUQCDrp([]); setItemRitcDetails([]);
        ItemService.getSwSupDocFileType().then(res => { setItemSwUQCDrp(res.data); })
        let details = { itemId: ItemId, consignmentId: jobValues.job_no }
        ItemService.getSwSupportingDoc(details).then(res => { setItemRitcDetails(res.data); })
    }
    //swDocs
    const ItemDoc_typecodeOpenHandle_close = () => {
        setitemdoctypecode_open(false); setItemSchemeCodeDetails([]);
        setItemDialogValues({ ...ItemDialogValues, FindDocumentType: '', FindDocumentName: '' });
    }
    const ItemDoc_typecodeOpenHandle = () => {
        setItemDialogValues({ ...ItemDialogValues, FindDocumentType: ItemDialogValues.DocTypeCode, FindDocumentName: '' });
        setitemdoctypecode_open(true); setItemSchemeCodeDetails([]);
        var supDocType = '';
        if (ItemDialogValues.DocTypeCode !== '') { supDocType = ItemDialogValues.DocTypeCode; }
        else { supDocType = '-1'; }
        let details = { supDocType: supDocType, supDocName: '-1', flag: 2 }
        ItemService.getSwSupDocType(details).then(res => { setItemSchemeCodeDetails(res.data); })
    }

    const ItemissuepartynameOpenHandle_close = () => {
        setItemSwDocsSupplierNameOpen(false);
        setItemSchemeCodeDetails([]); setItemDialogValues({ ...ItemDialogValues, FindSupplierName: '' });
    }
    const ItemissuepartynameOpenHandle = () => {
        setItemSwDocsSupplierNameOpen(true);
        setItemDialogValues({ ...ItemDialogValues, FindSupplierName: ItemDialogValues.IssuePartyName });
        setItemSchemeCodeDetails([]);
        var supplierName = '';
        if (ItemDialogValues.IssuePartyName !== '') { supplierName = ItemDialogValues.IssuePartyName; }
        else { supplierName = '-1'; }
        let details = { supplierName: supplierName, flag: 2 }
        InvoiceService.getSupplierDetails(details).then(res => { setItemSchemeCodeDetails(res.data); })
    }
    const ItemBeneficiaryOpenHandleclose = () => { setItemAddHssDetailsopen(false); }
    const ItemBeneficiaryOpenHandle = () => { setItemAddHssDetailsopen(true); }
    const ItemImporterDetailsOpenHandleClose = () => {
        setItemImporterDetailsOpen(false);
        setItemSchemeCodeDetails([]); setItemDialogValues({ ...ItemDialogValues, FindImporterName: '', FindImporterCode: '' })
    }
    const ItemImporterDetailsOpenHandle = () => {
        setItemImporterDetailsOpen(true); setItemSchemeCodeDetails([]);
        setItemDialogValues({
            ...ItemDialogValues, FindImporterName: ItemDialogValues.ImporterIECCode
            , FindImporterCode: ''
        })
        var importer_iec_no = '';
        if (ItemDialogValues.ImporterIECCode !== '') { importer_iec_no = ItemDialogValues.ImporterIECCode; }
        else { importer_iec_no = '-1'; }
        let details = { importer_name: '-1', importer_iec_no: importer_iec_no, flag: 2 }
        JobServices.getImporter(details).then(res => { setItemSchemeCodeDetails(res.data); })
    }
    const ItemImporterBranchDetailsOpenHandleClose = () => {
        setItemImporterBranchDetailsOpen(false); setItemSchemeCodeDetails([]);
        setItemDialogValues({ ...ItemDialogValues, FindImporterState: '', FindBranchSr_NO: '' })
    }
    const ItemImporterBranchDetailsOpenHandle = () => {
        setItemImporterBranchDetailsOpen(true); setItemSchemeCodeDetails([]);
        setItemDialogValues({ ...ItemDialogValues, FindImporterState: '', FindBranchSr_NO: ItemDialogValues.BranchSerialNo });
        var branch_sl_no = '';
        if (ItemDialogValues.BranchSerialNo !== '') { branch_sl_no = ItemDialogValues.BranchSerialNo; }
        else { branch_sl_no = '-1'; }
        let details = { importer_iec_no: ItemDialogValues.ImporterIECCode, importer_name: '-1', branch_sl_no: branch_sl_no }
        JobServices.getImporterBranch(details).then(res => { setItemSchemeCodeDetails(res.data); })
    }
    const ItemBEPrintCloshHandle = () => { setItemBePrintOpen(false); setItemBEprnt(false); setItemBEfileItemDsa(false);}
    const ItemBEPrint_OpenHandle = () => {
        setItemBePrintOpen(true);
        let details = { userName: '-1' }
        ItemService.getICEGATEuser(details).then(res => { setItemSwUQCDrp(res.data); })
    }

    const ItemBulkUploadCloshHandle = () => { setItemBulkUploadOpen(false); }
    const ItemBulkUploadOpenHandle = () => { setItemBulkUploadOpen(true); }
    const ItemErrorFilesCloseHandle = () => { setItemBulkUploadErrorOpen(false) }
    const ItemErrorFilesOpenHandle = () => {
        setItemBulkUploadErrorOpen(true);
        let details = { invoiceId: invoicevalues.InvoiceId }
        ItemService.getItemErrorList(details).then(res => { setItemErrordetails(res.data); })
    }
    const [excelUpload, setExcelUpload] = useState(false);
    //excel upload velidetion handling coigmnt.no passs to allow to upload file
    const excelUploadFile = () => {
        if (jobValues.job_no === '' || !jobValues.job_no) {
            setMessage("Please Select a Job.No from Job Table");
            setSeverity('warning');
            setOpenSnack(true);
            setExcelUpload(false);
        }
        else {
            setExcelUpload(true);
        }
    }

    const selectFile = (event) => {
        let currentFile = event.target.files[0]
        setCurrentFile(currentFile);
        ItemService.uploadItem(invoicevalues.InvoiceId, currentFile).then((response) => {
            setMessage(response.data.message);
            setSeverity('success');
            setOpenSnack(true)
            event.target.value = null;
            setCurrentFile(undefined); resetitem();
        }).catch((error) => {
            setSeverity('success'); setOpenSnack(true); setMessage(error.message); resetitem();
            setCurrentFile(undefined);
            event.target.value = null;
        });
    };

    const ItemDwnTemp = () => {
        saveAs(process.env.PUBLIC_URL + '/DownlodsFile/Item.xlsx', 'Item.xlsx')
    }

    /**-----------onChange-Event------------------------------------------**/
    const ItemSlNoChangeHandle = (e) => {
        setItemValues({ ...ItemValues, item_sl_no: e.target.value.replace(/[`~a-zA-Z!@#$%^&*()_|+{}=[?;:'",.<>]/gi, '') });
        var itemSrNo = '';
        if (e.target.value !== '') {
            itemSrNo = e.target.value;
        } else {
            itemSrNo = '-1'
        }
        let detailslice = { invoiceId: invoicevalues.InvoiceId, flag: 1, itemSrNo: itemSrNo }
        ItemService.getCommercialItem(detailslice).then(res => {
            setItemDetails(res.data);
        })
    }
    const ItemItemDescChangeHandle = (e) => {
        setItemValues({ ...ItemValues, txt_item_Desc: e.target.value.replace(/[`~!@#$%^&*_|+{}=?;:'"<>]/gi, ''), genericDesc: e.target.value.replace(/[`~!@#$%^&*_|+{}=?;:'"<>]/gi, '') });
    }
    const ItemRitcChangeHandle = (e) => {
        setItemValues({
            ...ItemValues, txt_ritc: e.target.value.replace(/[^0-9.]/ig, ''), txt_ceth: e.target.value.replace(/[^0-9.]/ig, '')
            , txt_cth: e.target.value.replace(/[^0-9.]/ig, '')
        });
    }
    const ItemCTHChangeHandle = (e) => {
        setItemValues({ ...ItemValues, txt_cth: e.target.value.replace(/[^0-9.]/ig, '') });
    }
    const ItemGenericDeschangeHandle = (e) => {
        setItemValues({ ...ItemValues, genericDesc: e.target.value.replace(/[`~!@#$%^&*_|+{}=?;:'"<>]/gi, '') });
    }
    const ItemRateTypeSPChangeHandle = (e) => {
        setItemValues({ ...ItemValues, txt_rate_typeSP: e.target.value.replace(/[`~0-9!@#$%^&*()_|+{}=[?;:'",.<>]/gi, '') });
    }
    const ItemCethChangeHandle = (e) => {
        setItemValues({ ...ItemValues, txt_ceth: e.target.value.replace(/[^0-9.]/ig, '') });
    }
    const ItemQuantityChangeHandle = (e) => {
        const totamount = e.target.value * ItemValues.txt_unitPrice;
        setItemValues({ ...ItemValues, txt_quantity: e.target.value.replace(/[^0-9.]/ig, ''), txt_totAmount: totamount });
    }
    const ItemUnitChangeHandle = (e) => {
        setItemValues({ ...ItemValues, txt_unit: e.target.value });
    }
    const ItemUnitPriceChangeHandle = (e) => {
        const totamount = e.target.value * ItemValues.txt_quantity;
        setItemValues({ ...ItemValues, txt_unitPrice: e.target.value.replace(/[^0-9.]/ig, ''), txt_totAmount: totamount });
    }
    const ItemCurrencyChangeHandle = (e) => {
        setItemValues({ ...ItemValues, txt_currency: e.target.value.replace(/[`~0-9!@#$%^&*()_|+{}=[?;:'",.<>]/gi, '') });
        var currency_code, currencData = '';
        if (e.target.value !== '') {
            currency_code = e.target.value;
            let details = { currency_code: currency_code, currencyPrefix: '-1', flag: 1 }
            InvoiceService.getCurrency(details).then(res => {
                const data = res.data;
                currencData = data.map((item) => item.indianValue)
                setItemValues({ ...ItemValues, txt_currency: e.target.value.replace(/[`~0-9!@#$%^&*()_|+{}=[?;:'",.<>]/gi, ''), txt_exRate: currencData[0] });
            })
        } else {
            setItemValues({ ...ItemValues, txt_currency: e.target.value, txt_exRate: '' });
        }
    }
    const ItemTotalAmountChangeHandle = (e) => {
        const unitprice = e.target.value / ItemValues.txt_quantity;
        setItemValues({ ...ItemValues, txt_totAmount: e.target.value.replace(/[^0-9.]/ig, ''), txt_unitPrice: unitprice });
    }
    const ItemEndUseCodeChangeHandle = (e) => {
        setItemValues({ ...ItemValues, txt_endusCode: e.target.value.replace(/[`~!@#$%^&*()_|+{}=[?;:'",.<>]/gi, '') });
    }
    const ItemOriginCntryChangeHandle = (e) => {
        setItemValues({ ...ItemValues, txt_originCntry: e.target.value.replace(/[`~!@#$%^&*()_|+{}=[?;:'",.<>]/gi, '') });
        var countryIdString = '';
        if (e.target.value !== '') {
            countryIdString = e.target.value;
        } else {
            countryIdString = '-1';
        }
        let details = { countryIdString: countryIdString, countryName: '-1', flag: 1 }
        JobServices.getCountryName(details).then(res => {
            const data = res.data;
            const cntryname = data.map((cntry) => cntry.countryName)
            if (e.target.value === '') {
                setItemValues({ ...ItemValues, txt_originCntry: e.target.value.replace(/[`~!@#$%^&*()_|+{}=[?;:'",.<>]/gi, ''), txt_originCntryName: '' });
            } else {
                setItemValues({ ...ItemValues, txt_originCntry: e.target.value.replace(/[`~!@#$%^&*()_|+{}=[?;:'",.<>]/gi, ''), txt_originCntryName: cntryname[0] });
            }
        })
    }
    const ItemBrandChangeHandle = (e) => {
        setItemValues({ ...ItemValues, txt_brand: e.target.value.replace(/[`~!@#$%^&*()_|+{}=[?;:'",.<>]/gi, '') });
    }
    const ItemModelNoChangeHandle = (e) => {
        setItemValues({ ...ItemValues, txt_model_no: e.target.value.replace(/[`~!@#$%^&*()_|+{}=[?;:'",.<>]/gi, '') });
    }
    const ItemAcessoryChangeHandle = (e) => {
        if (e.target.value === '0' || e.target.value === '1' || e.target.value === '2' || e.target.value === '') {
            setItemValues({ ...ItemValues, txt_acessory: e.target.value });
        }
    }
    const ItemSourceCntryChangeHandle = (e) => {
        setItemValues({ ...ItemValues, txt_sourceCountry: e.target.value.replace(/[`~!@#$%^&*()_|+{}=[?;:'",.<>]/gi, '') });
        var countryIdString = '';
        if (e.target.value !== '') {
            countryIdString = e.target.value;
        } else {
            countryIdString = '-1';
        }
        let details = { countryIdString: countryIdString, countryName: '-1', flag: 1 }
        JobServices.getCountryName(details).then(res => {
            const data = res.data;
            const cntryname = data.map((cntry) => cntry.countryName)
            if (e.target.value === '') {
                setItemValues({ ...ItemValues, txt_sourceCountry: e.target.value.replace(/[`~!@#$%^&*()_|+{}=[?;:'",.<>]/gi, ''), txt_sourceCountryName: '' });
            } else {
                setItemValues({ ...ItemValues, txt_sourceCountry: e.target.value.replace(/[`~!@#$%^&*()_|+{}=[?;:'",.<>]/gi, ''), txt_sourceCountryName: cntryname[0] });
            }
        })
    }
    const ItemTransitCntryChangeHandle = (e) => {
        setItemValues({ ...ItemValues, txt_transit_country: e.target.value.replace(/[`~!@#$%^&*()_|+{}=[?;:'",.<>]/gi, '') });
        var countryIdString = '';
        if (e.target.value !== '') {
            countryIdString = e.target.value;
        } else {
            countryIdString = '-1';
        }
        let details = { countryIdString: countryIdString, countryName: '-1', flag: 1 }
        JobServices.getCountryName(details).then(res => {
            const data = res.data;
            const cntryname = data.map((cntry) => cntry.countryName)
            if (e.target.value === '') {
                setItemValues({ ...ItemValues, txt_transit_country: e.target.value.replace(/[`~!@#$%^&*()_|+{}=[?;:'",.<>]/gi, ''), txt_transit_countryName: '' });
            } else {
                setItemValues({ ...ItemValues, txt_transit_country: e.target.value.replace(/[`~!@#$%^&*()_|+{}=[?;:'",.<>]/gi, ''), txt_transit_countryName: cntryname[0] });
            }
        })
    }

    const validateItem = () => {
        if (jobValues.job_no !== '') {
            if (invoicevalues.invoiceNo !== '') {
                if (ItemId !== '') {
                    return true;
                }
                else {
                    setMessage("Please Select Item Description"); setSeverity('warning'); setOpenSnack(true);
                }
            }
            else {
                setMessage("Please Select Invoice No From Invoice Table"); setSeverity('warning'); setOpenSnack(true);
            }
        }
        else {
            setMessage("Please Select Job No From Job Table"); setSeverity('warning'); setOpenSnack(true);
        }
        return false;
    }

    const ItemSchemeCodeChangeHandle = (e) => {
        if (e.target.value === 'Y' || e.target.value === 'y') {
            setItemValues({ ...ItemValues, schemeCodeY_N: e.target.value, licence_y_n: e.target.value });
            if (validateItem() === true) {
                ItemSchemeCode_OpenHandle(); document.getElementById('licence').focus();
                setItemlicenceDisa(false);
            }
        } else if (e.target.value === 'N' || e.target.value === 'n' || e.target.value === '') {
            setItemValues({ ...ItemValues, schemeCodeY_N: e.target.value, licence_y_n: e.target.value });
            setItemlicenceDisa(true); document.getElementById('re_import').focus();
        }
    }
    const ItemAntiDumbingDutyChangeHandle = (e) => {
        if (e.target.value === 'y' || e.target.value === 'Y') {
            setItemValues({ ...ItemValues, anti_dumbing_duty_Y_N: e.target.value });
            // ItemAuntiDumbing_OpenHandle();
            if (validateItem() === true) {
                ItemAuntiDumbing_OpenHandle(); document.getElementById('item_Rsp').focus();
            }
        } else if (e.target.value === 'N' || e.target.value === 'n' || e.target.value === '') {
            setItemValues({ ...ItemValues, anti_dumbing_duty_Y_N: e.target.value }); document.getElementById('item_Rsp').focus();
        }
    }
    const ItemSwinfoYNChangeHandle = (e) => {
        if (e.target.value === 'y' || e.target.value === 'Y') {
            setItemValues({ ...ItemValues, swinfo_Y_N: e.target.value });
            // ItemSwInfo_OpenHandle();
            if (validateItem() === true) {
                ItemSwInfo_OpenHandle(); document.getElementById('SW_Constituent').focus();
            }
        } else if (e.target.value === 'N' || e.target.value === 'n' || e.target.value === '') {
            setItemValues({ ...ItemValues, swinfo_Y_N: e.target.value }); document.getElementById('SW_Constituent').focus();
        }
    }
    const ItemBCDNotifiNoChangeHandle = (e) => {
        setItemValues({ ...ItemValues, bcd_notfication_no: e.target.value });
    }
    const ItemBCDSlNoChangeHandle = (e) => {
        setItemValues({ ...ItemValues, bcd_sl_no: e.target.value });
    }
    const ItemLicenceYNChangeHandle = (e) => {
        if (e.target.value === 'Y' || e.target.value === 'y') {
            setItemValues({ ...ItemValues, licence_y_n: e.target.value });
            if (validateItem() === true) {
                ItemLicence_OpenHandle(); document.getElementById('re_import').focus();
            }
        } else if (e.target.value === 'N' || e.target.value === 'n') {
            setItemValues({ ...ItemValues, licence_y_n: e.target.value });
            document.getElementById('re_import').focus();
        } else if (e.target.value === '') {
            setItemValues({ ...ItemValues, licence_y_n: e.target.value });
        }
    }
    const ItemRspYNQTDCChangeHandle = (e) => {
        if (e.target.value === 'Y' || e.target.value === 'y') {
            setItemValues({ ...ItemValues, rsp_Y_N_Q_T_D_C: e.target.value });
            document.getElementById('ncd_customDuty').focus();
            if (validateItem() === true) {
                ItemRspDuty_OpenHandle(); document.getElementById('ncd_customDuty').focus();
            }
        } else if (e.target.value === 'N' || e.target.value === 'n') {
            setItemValues({ ...ItemValues, rsp_Y_N_Q_T_D_C: e.target.value });
            document.getElementById('ncd_customDuty').focus();
        } else if (e.target.value === '') {
            setItemValues({ ...ItemValues, rsp_Y_N_Q_T_D_C: e.target.value });
        }
    }
    const ItemConstituentYnChangeHandle = (e) => {
        if (e.target.value === 'Y' || e.target.value === 'y') {
            setItemValues({ ...ItemValues, swConstitutent_Y_N: e.target.value });
            // ItemSwConstituent_OpenHandle();
            if (validateItem() === true) {
                ItemSwConstituent_OpenHandle(); document.getElementById('sw_production').focus();
            }
        } else if (e.target.value === 'N' || e.target.value === 'n') {
            setItemValues({ ...ItemValues, swConstitutent_Y_N: e.target.value });
            document.getElementById('sw_production').focus();
        } else if (e.target.value === '') {
            setItemValues({ ...ItemValues, swConstitutent_Y_N: e.target.value });
        }
    }
    const ItemAdidcNotifiNoChangeHandle = (e) => {
        setItemValues({ ...ItemValues, aidc_notfication_no: e.target.value });
    }
    const ItemAdidcSlNoChangeHandle = (e) => {
        setItemValues({ ...ItemValues, aidc_sl_no: e.target.value });
    }
    const ItemReImportChangeHandle = (e) => {
        if (e.target.value === 'Y' || e.target.value === 'y') {
            setItemValues({ ...ItemValues, Re_importY_n: e.target.value });
            document.getElementById('svbStatus').focus();
            if (validateItem() === true) {
                ItemReImport_OpenHandle();
            }
        } else if (e.target.value === 'N' || e.target.value === 'n') {
            setItemValues({ ...ItemValues, Re_importY_n: e.target.value });
            document.getElementById('svbStatus').focus();
        } else if (e.target.value === '') {
            setItemValues({ ...ItemValues, Re_importY_n: e.target.value });
        }
    }
    const ItemNcdCusDutyChangeHandle = (e) => {
        if (e.target.value === 'Y' || e.target.value === 'y') {
            setItemValues({ ...ItemValues, ncdCustomDuty_Y_N: e.target.value });
            // ItemNcdDuty_OpenHandle();
            if (validateItem() === true) {
                ItemNcdDuty_OpenHandle(); document.getElementById('otherDuty').focus();
            }
        } else if (e.target.value === 'N' || e.target.value === 'n') {
            setItemValues({ ...ItemValues, ncdCustomDuty_Y_N: e.target.value });
            document.getElementById('otherDuty').focus();
        } else if (e.target.value === '') {
            setItemValues({ ...ItemValues, ncdCustomDuty_Y_N: e.target.value });
        }
    }
    const ItemSWproductionChangeHandle = (e) => {
        if (e.target.value === 'Y' || e.target.value === 'y') {
            setItemValues({ ...ItemValues, swProduction_Y_N: e.target.value });
            // ItemSwProduction_OpenHandle();
            if (validateItem() === true) {
                ItemSwProduction_OpenHandle(); document.getElementById('sw_control').focus();
            }
        } else if (e.target.value === 'N' || e.target.value === 'n') {
            setItemValues({ ...ItemValues, swProduction_Y_N: e.target.value });
            document.getElementById('sw_control').focus();
        } else if (e.target.value === '') {
            setItemValues({ ...ItemValues, swProduction_Y_N: e.target.value });
        }
    }
    const ItemSwsNotificationChangeHandle = (e) => {
        setItemValues({ ...ItemValues, sws_notfication_no: e.target.value });
    }
    const ItemSwsSlNoChangeHandle = (e) => {
        setItemValues({ ...ItemValues, sws_sl_no: e.target.value });
    }
    const ItemSvbStatusYNChangeHandle = (e) => {
        if (e.target.value === 'Y' || e.target.value === 'y') {
            setItemValues({ ...ItemValues, svb_status_y_N: e.target.value });
            document.getElementById('ManufactureYn').focus();
            if (validateItem() === true) {
                ItemSVBStatus_OpenHandle();
            }
        } else if (e.target.value === 'N' || e.target.value === 'n') {
            setItemValues({ ...ItemValues, svb_status_y_N: e.target.value });
            document.getElementById('ManufactureYn').focus();
        } else if (e.target.value === '') {
            setItemValues({ ...ItemValues, svb_status_y_N: e.target.value });
        }
    }
    const ItemOtherDutyYNChangeHandle = (e) => {

        if (e.target.value === 'Y' || e.target.value === 'y') {
            setItemValues({ ...ItemValues, otherDuty_Y_N: e.target.value });
            if (validateItem() === true) {
                ItemOtherDuty_OpenHandle(); document.getElementById('sc_duty').focus();
            }
        } else if (e.target.value === 'N' || e.target.value === 'n') {
            setItemValues({ ...ItemValues, otherDuty_Y_N: e.target.value }); document.getElementById('sc_duty').focus();
        } else if (e.target.value === '') {
            setItemValues({ ...ItemValues, otherDuty_Y_N: e.target.value });
        }
    }
    const ItemSwControllChangeHandle = (e) => {
        if (e.target.value === 'Y' || e.target.value === 'y') {
            setItemValues({ ...ItemValues, swControl_Y_N: e.target.value });
            if (validateItem() === true) {
                ItemSWControl_OpenHandle(); document.getElementById('sw_statement').focus();
            }
        } else if (e.target.value === 'N' || e.target.value === 'n') {
            setItemValues({ ...ItemValues, swControl_Y_N: e.target.value });
            document.getElementById('sw_statement').focus();
        } else if (e.target.value === '') {
            setItemValues({ ...ItemValues, swControl_Y_N: e.target.value });
        }
    }
    const ItemCvdNotifyChangeHandle = (e) => {
        setItemValues({ ...ItemValues, cvd_notfication_no: e.target.value });
    }
    const ItemCvdSlNoChangeHandle = (e) => {
        setItemValues({ ...ItemValues, cvd_sl_no: e.target.value });
    }
    const ItemManufactureYNChangeHandle = (e) => {
        if (e.target.value === 'Y' || e.target.value === 'y') {
            setItemValues({ ...ItemValues, manufactureY_N: e.target.value });
            // ItemManufacture_OpenHandle();
            if (validateItem() === true) {
                ItemManufacture_OpenHandle(); document.getElementById('ManufactureYn').focus();
            }
        } else if (e.target.value === 'N' || e.target.value === 'n') {
            setItemValues({ ...ItemValues, manufactureY_N: e.target.value });
            document.getElementById('ManufactureYn').focus();
        } else if (e.target.value === '') {
            setItemValues({ ...ItemValues, manufactureY_N: e.target.value });
        }
    }
    const ItemSCdutyChangeHandle = (e) => {
        if (e.target.value === 'Y' || e.target.value === 'y') {
            setItemValues({ ...ItemValues, scDuty_Y_N: e.target.value });
            if (ItemIgstDutyYNDisa === false) {
                document.getElementById('igst_duty').focus();
            } else {
                document.getElementById('sw_info').focus();
                setItemIgstDutyYNDisa(true);
            }
            if (validateItem() === true) {
                ItemScDuty_OpenHandle();
            }
        } else if (e.target.value === 'N' || e.target.value === 'n') {
            setItemValues({ ...ItemValues, scDuty_Y_N: e.target.value });
            if (ItemIgstDutyYNDisa === false) {
                document.getElementById('igst_duty').focus();
            } else {
                document.getElementById('sw_info').focus();
                setItemIgstDutyYNDisa(true);
            }
        } else if (e.target.value === '') {
            setItemValues({ ...ItemValues, scDuty_Y_N: e.target.value });
        }
    }
    const ItemSwStatemntChangeHandle = (e) => {
        if (e.target.value === 'Y' || e.target.value === 'y') {
            setItemValues({ ...ItemValues, swStatementY_N: e.target.value });
            document.getElementById('SW_support').focus();
            if (validateItem() === true) {
                ItemSWStatement_OpenHandle();
            }
        } else if (e.target.value === 'N' || e.target.value === 'n') {
            setItemValues({ ...ItemValues, swStatementY_N: e.target.value });
            document.getElementById('SW_support').focus();
        } else if (e.target.value === '') {
            setItemValues({ ...ItemValues, swStatementY_N: e.target.value });
        }
    }
    const ItemEDUcessNotiChangeHandle = (e) => {
        setItemValues({ ...ItemValues, edu_css_notfication_no: e.target.value });
    }
    const ItemEDUcessSrlNoChangeHandle = (e) => {
        setItemValues({ ...ItemValues, edu_css_sl_no: e.target.value });
    }
    const ItemCustNotnExmpChangeHandle = (e) => {
        if (e.target.value === 'Y' || e.target.value === 'y') {
            setItemValues({ ...ItemValues, cust_Notn_exmptY_n: e.target.value });
            document.getElementById('auntiDumping').focus();
            if (validateItem() === true) {
                ItemCustNotnExmp_OpenHandle();
            }
        } else if (e.target.value === 'N' || e.target.value === 'n') {
            setItemValues({ ...ItemValues, cust_Notn_exmptY_n: e.target.value });
            document.getElementById('auntiDumping').focus();
        } else if (e.target.value === '') {
            setItemValues({ ...ItemValues, cust_Notn_exmptY_n: e.target.value });
        }
    }
    const ItemIgstDutyyYNChangeHandle = (e) => {
        setItemValues({ ...ItemValues, IGSTDuty_Y_N: e.target.value });
    }
    const ItemSWsuportChangeHandle = (e) => {
        if (e.target.value === 'Y' || e.target.value === 'y') {
            setItemValues({ ...ItemValues, swSuportDoc_Y_N: e.target.value });
            document.getElementById('policy_para').focus();
            if (validateItem() === true) {
                ItemSwDocs_OpenHandle();
            }
        } else if (e.target.value === 'N' || e.target.value === 'n') {
            setItemValues({ ...ItemValues, swSuportDoc_Y_N: e.target.value });
            document.getElementById('policy_para').focus();
        } else if (e.target.value === '') {
            setItemValues({ ...ItemValues, swSuportDoc_Y_N: e.target.value });
        }
    }
    const ItemPolicParaYNChangeHandle = (e) => {
        if (e.target.value === 'Y' || e.target.value === 'y') {
            setItemValues({ ...ItemValues, PolicyPara_Y_N: e.target.value });
            if (ItemSaveItemDsa === false) {
                document.getElementById('sve_itm').focus();
            } else {
                document.getElementById('update_item').focus();
            }
            if (validateItem() === true) {
                ItemPolicyPara_OpenHandle();
            }
        } else if (e.target.value === 'N' || e.target.value === 'n') {
            setItemValues({ ...ItemValues, PolicyPara_Y_N: e.target.value });
            if (ItemSaveItemDsa === false) {
                document.getElementById('sve_itm').focus();
            } else {
                document.getElementById('update_item').focus();
            }
        } else if (e.target.value === '') {
            setItemValues({ ...ItemValues, PolicyPara_Y_N: e.target.value });
        }
    }
    const ItemIgstDutTyypeChangeHandle = (e) => {
        setItemValues({ ...ItemValues, igstduty_type: e.target.value });
    }
    const ItemIgstDutyAddTypeChangeHandle = (e) => {
        setItemValues({ ...ItemValues, igstduty_Add_type: e.target.value });
    }
    const ItemIgstDutyFlagGCChangeHandle = (e) => {
        setItemValues({ ...ItemValues, igstduty_flagG_C: e.target.value });
    }
    const ItemIgstDutyNotfiNoChangeHandle = (e) => {
        setItemValues({ ...ItemValues, igstduty_notfion_no: e.target.value });
    }
    const ItemIgstDutySrlNoChangeHandle = (e) => {
        setItemValues({ ...ItemValues, igstduty_sl_no: e.target.value });
    }
    const ItemIgstDutyExmpNotiNoChangeHandle = (e) => {
        setItemValues({ ...ItemValues, igstduty_exmpNotn_no: e.target.value });
    }
    const ItemIgstDutyExmpSrlNo2ChangeHandle = (e) => {
        setItemValues({ ...ItemValues, igstduty_sl_no2: e.target.value });
    }
    const ItemIgstCessTypeChangeHandle = (e) => {
        setItemValues({ ...ItemValues, igstcess_type: e.target.value });
    }
    const ItemIgstCessAddTypeChangeHandle = (e) => {
        setItemValues({ ...ItemValues, igstcess_Add_type: e.target.value });
    }
    const ItemIgstCessFlagGcChangeHandle = (e) => {
        setItemValues({ ...ItemValues, igstcess_flagG_C: e.target.value });
    }
    const ItemIgstCessNotifiNoChangeHandle = (e) => {
        setItemValues({ ...ItemValues, igstcess_notfion_no: e.target.value });
    }
    const ItemIgstCessSrlNoChangeHandle = (e) => {
        setItemValues({ ...ItemValues, igstcess_sl_no: e.target.value });
    }
    /**-----------onClick-Event------------------------------------------**/

    const validateItemSave = () => {
        if (ItemValues.txt_endusCode !== '') {
            if (ItemValues.txt_brand !== '') {
                if (ItemValues.txt_model_no !== '') {
                    if (ItemValues.txt_acessory !== '') {
                        return true;
                    }
                    else {
                        setMessage('Accessory status should not be empty ..!!');
                        setSeverity('warning');
                        setOpenSnack(true);
                    }
                }
                else {
                    setMessage('Model No should not be empty ..!!');
                    setSeverity('warning');
                    setOpenSnack(true);
                }
            }
            else {
                setMessage('Brand Name should not be empty ..!!');
                setSeverity('warning');
                setOpenSnack(true);
            }
        }
        else {
            setMessage("Please Enter The End Use Code");
            setSeverity('warning');
            setOpenSnack(true);
        }
        return false;
    }

    const validateDutyRate = () => {
        if (ItemValues.bcd_rate_no !== '') {
            if (ItemValues.aidc_rate_no !== '') {
                if (ItemValues.sws_rate_no !== '') {
                    if (ItemValues.igstduty_rate !== '') {
                        return true;
                    }
                    else {
                        setMessage('Igst Rate should not be empty ..!!');
                        setSeverity('warning');
                        setOpenSnack(true);
                    }
                }
                else {
                    setMessage('Sws Rate should not be empty ..!!');
                    setSeverity('warning');
                    setOpenSnack(true);
                }
            }
            else {
                setMessage('AIDC Rate should not be empty ..!!');
                setSeverity('warning');
                setOpenSnack(true);
            }
        }
        else {
            setMessage("Bcd Rate should not be empty");
            setSeverity('warning');
            setOpenSnack(true);
        }
        return false;
    }

    const Itemsaveitem = () => {
        if (ItemId !== '') {
            if (validateItemPreAlert() === true) {
                if (validateItemSave() === true) {
                    if (validateIgstDuty() === true) {
                        if (validateDutyRate() === true) {
                            setItemSaveItemDsa(true);
                            setItemSve(true);
                            var itemExchangeRate, countryIdString, endUseCode, svbDate, avFinal, assablePerc, dutyPerc = '';
                            var sourceCountryCode, transitCountryCode, dutyFinal = '';
                            if (ItemValues.txt_exRate !== '') {
                                itemExchangeRate = ItemValues.txt_exRate;
                            } else {
                                itemExchangeRate = null;
                            }
                            if (ItemValues.txt_originCntry !== '') {
                                countryIdString = ItemValues.txt_originCntry;
                            } else {
                                countryIdString = null;
                            }
                            if (ItemValues.txt_endusCode !== '') {
                                endUseCode = ItemValues.txt_endusCode;
                            } else {
                                endUseCode = null;
                            }
                            if (ItemDialogValues.svb_refrenceDate !== '') {
                                svbDate = ItemDialogValues.svb_refrenceDate;
                            } else {
                                svbDate = null;
                            }
                            if (ItemDialogValues.svb_provi_AV !== '') {
                                avFinal = ItemDialogValues.svb_provi_AV;
                            } else {
                                avFinal = 'N';
                            }
                            if (ItemDialogValues.svb_provi_duty !== '') {
                                dutyFinal = ItemDialogValues.svb_provi_duty;
                            } else {
                                dutyFinal = 'N';
                            }
                            if (ItemDialogValues.svb_load_AV !== '') {
                                assablePerc = ItemDialogValues.svb_load_AV;
                            } else {
                                assablePerc = '0.00';
                            }
                            if (ItemDialogValues.svb_load_duty !== '') {
                                dutyPerc = ItemDialogValues.svb_load_duty;
                            } else {
                                dutyPerc = '0.00';
                            }
                            if (ItemValues.txt_sourceCountry !== '') {
                                sourceCountryCode = ItemValues.txt_sourceCountry;
                            } else {
                                sourceCountryCode = null;
                            }
                            if (ItemValues.txt_transit_country !== '') {
                                transitCountryCode = ItemValues.txt_transit_country;
                            } else {
                                transitCountryCode = null;
                            }
                            let details = {
                                itemId: ItemId, invoiceId: invoicevalues.InvoiceId, item_description: ItemValues.txt_item_Desc,
                                ritc: ItemValues.txt_ritc, cth: ItemValues.txt_cth, ceth: ItemValues.txt_ceth, qty: ItemValues.txt_quantity,
                                unitCode: ItemValues.txt_unit, unitPrice: ItemValues.txt_unitPrice, totalAmount: ItemValues.txt_totAmount,
                                currency_code: ItemValues.txt_currency, itemExchangeRate: itemExchangeRate, brand: ItemValues.txt_brand,
                                modelNo: ItemValues.txt_model_no, countryIdString: countryIdString, endUseCode: endUseCode, manufactureDetails: ItemValues.manufactureY_N,
                                assasory: ItemValues.txt_acessory, schemeCode: ItemValues.schemeCodeY_N, licence: ItemValues.licence_y_n,
                                reimport: ItemValues.Re_importY_n, svbstatus: ItemValues.svb_status_y_N, auntiDumping: ItemValues.anti_dumbing_duty_Y_N,
                                rspDuty: ItemValues.rsp_Y_N_Q_T_D_C, ncdDuty: ItemValues.ncdCustomDuty_Y_N, otherDuty: ItemValues.otherDuty_Y_N,
                                packingDetails: 'N', scDuty: ItemValues.scDuty_Y_N, igstDuty: ItemValues.IGSTDuty_Y_N, swInfo: ItemValues.swinfo_Y_N,
                                swContineute: ItemValues.swConstitutent_Y_N, swProduction: ItemValues.swProduction_Y_N, swControl: ItemValues.swControl_Y_N,
                                swStatement: ItemValues.swStatementY_N, swSupDocs: ItemValues.swSuportDoc_Y_N, cusNotnExemp: ItemValues.cust_Notn_exmptY_n,
                                policyPera: ItemValues.PolicyPara_Y_N, svbRefNo: ItemDialogValues.svb_reference_no, svbDate: svbDate, cusHouseCode: ItemDialogValues.svb_customhouseCode,
                                svbLoading: ItemDialogValues.svb_loadOn_Ad, avFinal: avFinal, dutyFinal: dutyFinal, assablePerc: assablePerc, dutyPerc: dutyPerc,
                                genDesc: ItemValues.genericDesc, rateType: ItemValues.txt_rate_typeSP, freightAmount: ItemSummury.fright,
                                insuranceAmount: ItemSummury.insurence, miscAmount: ItemSummury.misc, loadingValue: ItemSummury.loadinng,
                                assableValue: ItemSummury.ass, cvdAmt: ItemSummury.cvd, swsAmt: ItemSummury.sws, gstAmt: ItemSummury.gst,
                                customDutyAmount: ItemSummury.duty, sourceCountryCode: sourceCountryCode, transitCountryCode: transitCountryCode,
                                createdBy: getUserId()
                            }
                            ItemService.insertCommercialItem(details).then(res => {
                                const message = res.data.message;
                                if (message.toString() === 'SUCCESS') {
                                    setMessage('Item Insert Successfully');
                                    setSeverity('success');
                                    setOpenSnack(true);
                                } else {
                                    setMessage(message.toString());
                                    setSeverity('error');
                                    setOpenSnack(true);
                                }
                                resetitem();
                            }).catch(error => {
                                setMessage(error.message);
                                setSeverity('error');
                                setOpenSnack(true);
                                resetitem();
                            })
                        }
                    }
                }
            }
        } else {
            setMessage('Item Id Is Missigng or Empty');
            setSeverity('warning');
            setOpenSnack(true);
        }
    }

    const ItemUpdateitem = () => {
        if (validateItemPreAlert() === true) {
            if (validateItemSave() === true) {
                if (validateIgstDuty() === true) {
                    if (validateDutyRate() === true) {
                        setItemUpdateItemDsa(true);
                        setItemUpd(true);
                        var itemExchangeRate, countryIdString, endUseCode, svbDate, avFinal, assablePerc, dutyPerc = '';
                        var sourceCountryCode, transitCountryCode, dutyFinal = '';
                        if (ItemValues.txt_exRate !== '') {
                            itemExchangeRate = ItemValues.txt_exRate;
                        } else {
                            itemExchangeRate = null;
                        }
                        if (ItemValues.txt_originCntry !== '') {
                            countryIdString = ItemValues.txt_originCntry;
                        } else {
                            countryIdString = null;
                        }
                        if (ItemValues.txt_endusCode !== '') {
                            endUseCode = ItemValues.txt_endusCode;
                        } else {
                            endUseCode = null;
                        }
                        if (ItemDialogValues.svb_refrenceDate !== '') {
                            svbDate = ItemDialogValues.svb_refrenceDate;
                        } else {
                            svbDate = null;
                        }
                        if (ItemDialogValues.svb_provi_AV !== '') {
                            avFinal = ItemDialogValues.svb_provi_AV;
                        } else {
                            avFinal = 'N';
                        }
                        if (ItemDialogValues.svb_provi_duty !== '') {
                            dutyFinal = ItemDialogValues.svb_provi_duty;
                        } else {
                            dutyFinal = 'N';
                        }
                        if (ItemDialogValues.svb_load_AV !== '') {
                            assablePerc = ItemDialogValues.svb_load_AV;
                        } else {
                            assablePerc = '0.00';
                        }
                        if (ItemDialogValues.svb_load_duty !== '') {
                            dutyPerc = ItemDialogValues.svb_load_duty;
                        } else {
                            dutyPerc = '0.00';
                        }
                        if (ItemValues.txt_sourceCountry !== '') {
                            sourceCountryCode = ItemValues.txt_sourceCountry;
                        } else {
                            sourceCountryCode = null;
                        }
                        if (ItemValues.txt_transit_country !== '') {
                            transitCountryCode = ItemValues.txt_transit_country;
                        } else {
                            transitCountryCode = null;
                        }
                        let details = {
                            itemId: ItemId, invoiceId: invoicevalues.InvoiceId, item_description: ItemValues.txt_item_Desc,
                            ritc: ItemValues.txt_ritc, cth: ItemValues.txt_cth, ceth: ItemValues.txt_ceth, qty: ItemValues.txt_quantity,
                            unitCode: ItemValues.txt_unit, unitPrice: ItemValues.txt_unitPrice, totalAmount: ItemValues.txt_totAmount,
                            currency_code: ItemValues.txt_currency, itemExchangeRate: itemExchangeRate, brand: ItemValues.txt_brand,
                            modelNo: ItemValues.txt_model_no, countryIdString: countryIdString, endUseCode: endUseCode, manufactureDetails: ItemValues.manufactureY_N,
                            assasory: ItemValues.txt_acessory, schemeCode: ItemValues.schemeCodeY_N, licence: ItemValues.licence_y_n,
                            reimport: ItemValues.Re_importY_n, svbstatus: ItemValues.svb_status_y_N, auntiDumping: ItemValues.anti_dumbing_duty_Y_N,
                            rspDuty: ItemValues.rsp_Y_N_Q_T_D_C, ncdDuty: ItemValues.ncdCustomDuty_Y_N, otherDuty: ItemValues.otherDuty_Y_N,
                            packingDetails: 'N', scDuty: ItemValues.scDuty_Y_N, igstDuty: ItemValues.IGSTDuty_Y_N, swInfo: ItemValues.swinfo_Y_N,
                            swContineute: ItemValues.swConstitutent_Y_N, swProduction: ItemValues.swProduction_Y_N, swControl: ItemValues.swControl_Y_N,
                            swStatement: ItemValues.swStatementY_N, swSupDocs: ItemValues.swSuportDoc_Y_N, cusNotnExemp: ItemValues.cust_Notn_exmptY_n,
                            policyPera: ItemValues.PolicyPara_Y_N, svbRefNo: ItemDialogValues.svb_reference_no, svbDate: svbDate, cusHouseCode: ItemDialogValues.svb_customhouseCode,
                            svbLoading: ItemDialogValues.svb_loadOn_Ad, avFinal: avFinal, dutyFinal: dutyFinal, assablePerc: assablePerc, dutyPerc: dutyPerc,
                            genDesc: ItemValues.genericDesc, rateType: ItemValues.txt_rate_typeSP, freightAmount: ItemSummury.fright,
                            insuranceAmount: ItemSummury.insurence, miscAmount: ItemSummury.misc, loadingValue: ItemSummury.loadinng,
                            assableValue: ItemSummury.ass, cvdAmt: ItemSummury.cvd, swsAmt: ItemSummury.sws, gstAmt: ItemSummury.gst,
                            customDutyAmount: ItemSummury.duty, sourceCountryCode: sourceCountryCode, transitCountryCode: transitCountryCode,
                            updatedBy: getUserId()
                        }
                        ItemService.updateCommercialItem(details).then(res => {
                            const message = res.data.message;
                            if (message.toString() === 'SUCCESS') {
                                setMessage('Item Update Successfully');
                                setSeverity('success');
                                setOpenSnack(true);
                            } else {
                                setMessage(message.toString());
                                setSeverity('error');
                                setOpenSnack(true);
                            }
                            resetitem(); setSelected([])
                        }).catch(error => {
                            setMessage(error.message);
                            setSeverity('error');
                            setOpenSnack(true);
                            resetitem(); setSelected([]);
                        })
                    }
                }
            }
        }
    }

    const DeleteItems = () => {
        setItemDeleteItemDsa(true);
        setItemDlt(true); setConfonfirmDialog({ ...confirmDialog, isOpen: false });
        ItemService.deleteCommercialItem(ItemIdSlct.toString()).then(res => {
            const message = res.data.message;
            if (message.toString() === 'SUCCESS') {
                setMessage('Item Delete Successfully');
                setSeverity('success');
                setOpenSnack(true);
            } else {
                setMessage(message.toString());
                setSeverity('error');
                setOpenSnack(true);
            } setSelected([])
            resetitem();
        }).catch(error => { setMessage(error.message); setSeverity('error'); setOpenSnack(true); resetitem(); setSelected([]); })
    }

    const ItemDeleteItem = () => {
        if (ItemIdSlct.toString() !== '') {
            setConfonfirmDialog({
                isOpen: true, Title: 'Are Sure to Delete this...!!', onConfirm: () => { DeleteItems(); },
                noConfirm: () => { setConfonfirmDialog({ ...confirmDialog, isOpen: false }); }
            });
        } else {
            setMessage('Please Select the Item Id From Item Table'); setSeverity('Warning'); setOpenSnack(true);
        }
    }

    const ItemDublicateItemSave = () => {
        if (ItemUpdateItemDsa === false) {
            let details = { invoiceId: invoicevalues.InvoiceId, itemId: ItemId, createdBy: getUserId() }
            ItemService.insertDuplicateItemImport(details).then(res => {
                const message = res.data.message;
                if (message.toString() === 'SUCCESS') {
                    setMessage('Item Insert Successfully');
                    setSeverity('success');
                    setOpenSnack(true);
                } else {
                    setMessage(message.toString());
                    setSeverity('error');
                    setOpenSnack(true);
                }
                resetitem();
            }).catch(error => {
                setMessage(error.message); setSeverity('error'); setOpenSnack(true); resetitem();
            })
        } else {
            setMessage('Kindly select the item table ..!!'); setSeverity('warning'); setOpenSnack(true);
        }
    }

    const generateBExbondfile = () => {
        let details = {
            consignmentNumber: jobValues.job_no, iceGateUserId: ItemDialogValues.iceGateUser,
            userJobNo: jobValues.edi_job_no
        }
        ImpReport.generateBExbondfile(details).then(res => {
            const filename = res.data.message;
            window.open('http://35.154.221.117:8081/ExportFiles/' + filename.toString(), "_blank");
            setItemSchemeSaveDsa(false);
            setItemSchemeSve(false);
        }).catch(error => {
            setItemSchemeSaveDsa(false);
            setItemSchemeSve(false);
            setMessage(error.message);
            setSeverity('error');
            setOpenSnack(true);
        })
    }

    const generateAmendmentBEfile = () => {
        let details = {
            consignmentNumber: jobValues.job_no, iceGateUserId: ItemDialogValues.iceGateUser,
            userJobNo: jobValues.edi_job_no
        }
        ImpReport.generateAmendmentBEfile(details).then(res => {
            const filename = res.data.message;
            window.open('http://35.154.221.117:8081/ExportFiles/' + filename.toString(), "_blank");
            setItemSchemeSaveDsa(false);
            setItemSchemeSve(false);
        }).catch(error => {
            setItemSchemeSaveDsa(false);
            setItemSchemeSve(false);
            setMessage(error.message);
            setSeverity('error');
            setOpenSnack(true);
        })
    }
    const generateBEfile = () => {
        let details = {
            consignmentNumber: jobValues.job_no, iceGateUserId: ItemDialogValues.iceGateUser,
            userJobNo: jobValues.edi_job_no
        }
        ImpReport.generateBEfile(details).then(res => {
            const filename = res.data.message;
            window.open('http://35.154.221.117:8081/ExportFiles/' + filename.toString(), "_blank");
        }).catch(error => {
            setItemSchemeSaveDsa(false);
            setItemSchemeSve(false);
            setMessage(error.message);
            setSeverity('error');
            setOpenSnack(true);
        })
        setItemSchemeSaveDsa(false);
        setItemSchemeSve(false);
    }

    const ItemDownlodBeClick = () => {

        if (ItemDialogValues.iceGateUser !== '') {
            setItemSchemeSaveDsa(true);
            setItemSchemeSve(true);
            let details = { consignmentNumber: jobValues.job_no }
            ItemService.getbetypeJob(details).then(res => {
                const message = res.data.message;
                if (message.toString() === 'X' || message.toString() === 'x') {
                    generateBExbondfile();
                } else if (message.toString() === '1') {
                    generateAmendmentBEfile();
                } else {
                    generateBEfile();
                }
                setItemSchemeSaveDsa(false);
                setItemSchemeSve(false);
            }).catch(error => {
                setItemSchemeSaveDsa(false);
                setItemSchemeSve(false);
                setMessage(error.message);
                setSeverity('error');
                setOpenSnack(true);
            })
        } else {
            setMessage('Please Enter the ICEGATE User Name..!!');
            setSeverity('warning');
            setOpenSnack(true);
        }
    }

    const ItemBeCheackListPrint = (val) => {
        ItemService.checkBeFlatfileChecklistErrors(jobValues.job_no).then(res => {
            const message = res.data.message;
            if (message.toString() !== '') {
                setMessage(message.toString() + ' You have Errors in this job');
                setSeverity('error');
                setOpenSnack(true);
            } else {
                if (val === 0) {
                    setItemBEfileItemDsa(true);
                    setItemBEprnt(true);
                    ItemBEPrint_OpenHandle();
                } else if (val === 1) {
                    setItemCheackListItemDsa(true);
                    setItemCheacklistprnt(true);
                    let details = { consignmentNumber: jobValues.job_no }
                    ImpReport.generateBeChecklist(details).then(res => {
                        const filename = res.data.message;
                        window.open('http://35.154.221.117:8081/ExportFiles/' + filename.toString(), "_blank");
                        setItemCheackListItemDsa(false);
                        setItemCheacklistprnt(false);
                    }).catch(error => {
                        setMessage(error.message);
                        setSeverity('error');
                        setOpenSnack(true);
                        setItemCheackListItemDsa(false);
                        setItemCheacklistprnt(false);
                    })
                }
            }
        });
        setItemBEfileItemDsa(false);
        setItemBEprnt(false);
    }

    /**-----------onClick-Table-Event------------------------------------------**/
    const EditItemDetails = (item) => {
              const selectedIndex = selected.indexOf(item.itemId);  setQuryIndex(0);
        let SelectedMawb = [];

        if (selectedIndex === -1) {
            SelectedMawb = SelectedMawb.concat([],item.itemId); setItemIdSlct(SelectedMawb);
        }  setSelected(SelectedMawb);
        setItemId(item.itemId); getCommercialItemAssign(item.itemId);
        getItemSummary(item.itemId); setItemSaveItemDsa(true);
        setItemUpdateItemDsa(false); setItemDeleteItemDsa(false);

        setItemSve(false); setItemUpd(false); setItemDlt(false);
    }
    const getCommercialItemAssign = (item_id) => {

        let details = { itemId: item_id }
        ItemService.getCommercialItemAssign(details).then(res => {
            const data = res.data;
            const items = data.map((item) => item);
            if (items[0].schemeCode === 'y' || items[0].schemeCode === 'Y') {
                setItemlicenceDisa(false);
            } else {
                setItemlicenceDisa(true);
            }
            var bcd = []; var cvd = []; var aid = [];
            var edu = []; var gst = []; var sws = []; var ccs = [];
            let detailsBCD = { itemId: item_id, notificationType: 'BCD', flag: 1 }
            ItemService.getItemNotification(detailsBCD).then(resBcd => {
                const databcd = resBcd.data;
                bcd = databcd.map((item) => item);

                let detailsCVD = { itemId: item_id, notificationType: 'CVD', flag: 1 }
                ItemService.getItemNotification(detailsCVD).then(resCVD => {
                    const datacvd = resCVD.data;
                    cvd = datacvd.map((item) => item);

                    let detailsAID = { itemId: item_id, notificationType: 'AID', flag: 1 }
                    ItemService.getItemNotification(detailsAID).then(resAID => {
                        const dataAid = resAID.data;
                        aid = dataAid.map((item) => item);

                        let detailsGST = { itemId: item_id, notificationType: 'GST', flag: 1 }
                        ItemService.getItemNotification(detailsGST).then(resGST => {
                            const dataGST = resGST.data;
                            gst = dataGST.map((item) => item);

                            let detailsSWS = { itemId: item_id, notificationType: 'SWS', flag: 1 }
                            ItemService.getItemNotification(detailsSWS).then(resSWS => {
                                const datasws = resSWS.data;
                                sws = datasws.map((item) => item);

                                let detailsEDU = { itemId: item_id, notificationType: 'EDU', flag: 1 }
                                ItemService.getItemNotification(detailsEDU).then(resEDU => {
                                    const dataEDU = resEDU.data;
                                    edu = dataEDU.map((item) => item);

                                    let detailsGCES = { itemId: item_id, notificationType: 'CCS', flag: 1 }
                                    ItemService.getItemNotification(detailsGCES).then(resGCESS => {
                                        const dataGCESS = resGCESS.data;
                                        ccs = dataGCESS.map((item) => item);



                                        var eduNotificationNo, edunotificationRate, eduNotificationSrNo = '';
                                        var edunotificationAmount, edunotificationFlag, edunotificationUnit = '';

                                        var ccsNotificationNo, ccsnotificationRate, ccsNotificationSrNo, ccsigstFlag = '';
                                        var ccsnotificationAmount, ccsnotificationFlag, ccsdutyType, ccsaddlDutyType = '';

                                        var bcdNotificationNo, bcdnotificationRate, bcdNotificationSrNo = '';
                                        var bcdnotificationAmount, bcdnotificationFlag, bcdnotificationUnit = '';
                                        if (bcd === [] || !bcd[0]) {
                                            bcdNotificationNo = '';
                                            bcdnotificationRate = '0.00';
                                            bcdNotificationSrNo = '';
                                            bcdnotificationAmount = '0.00';
                                            bcdnotificationFlag = '';
                                            bcdnotificationUnit = '';
                                        } else {
                                            bcdNotificationNo = bcd[0].notificationNo;
                                            bcdnotificationRate = bcd[0].notificationRate;
                                            bcdNotificationSrNo = bcd[0].notificationSrNo;
                                            bcdnotificationAmount = bcd[0].notificationAmount;
                                            bcdnotificationFlag = bcd[0].notificationFlag;
                                            bcdnotificationUnit = bcd[0].notificationUnit;
                                        }
                                        var cvdNotificationNo, cvdnotificationRate, cvdNotificationSrNo = '';
                                        var cvdnotificationAmount, cvdnotificationFlag, cvdnotificationUnit = '';
                                        if (cvd === [] || !cvd[0]) {
                                            cvdNotificationNo = '';
                                            cvdnotificationRate = '0.00';
                                            cvdNotificationSrNo = '';
                                            cvdnotificationAmount = '0.00';
                                            cvdnotificationFlag = '';
                                            cvdnotificationUnit = '';
                                        } else {
                                            cvdNotificationNo = cvd[0].notificationNo;
                                            cvdnotificationRate = cvd[0].notificationRate;
                                            cvdNotificationSrNo = cvd[0].notificationSrNo;
                                            cvdnotificationAmount = cvd[0].notificationAmount;
                                            cvdnotificationFlag = cvd[0].notificationFlag;
                                            cvdnotificationUnit = cvd[0].notificationUnit;
                                        }
                                        var aidNotificationNo, aidnotificationRate, aidNotificationSrNo = '';
                                        var aidnotificationAmount, aidnotificationFlag, aidnotificationUnit = '';
                                        if (aid === [] || !aid[0]) {
                                            aidNotificationNo = '';
                                            aidnotificationRate = '0.00';
                                            aidNotificationSrNo = '';
                                            aidnotificationAmount = '0.00';
                                            aidnotificationFlag = '';
                                            aidnotificationUnit = '';
                                        } else {
                                            aidNotificationNo = aid[0].notificationNo;
                                            aidnotificationRate = aid[0].notificationRate;
                                            aidNotificationSrNo = aid[0].notificationSrNo;
                                            aidnotificationAmount = aid[0].notificationAmount;
                                            aidnotificationFlag = aid[0].notificationFlag;
                                            aidnotificationUnit = aid[0].notificationUnit;
                                        }
                                        var swsNotificationNo, swsnotificationRate, swsNotificationSrNo = '';
                                        var swsnotificationAmount, swsnotificationFlag, swsnotificationUnit = '';
                                        if (sws === [] || !sws[0]) {
                                            swsNotificationNo = '';
                                            swsnotificationRate = '0.00';
                                            swsNotificationSrNo = '';
                                            swsnotificationAmount = '0.00';
                                            swsnotificationFlag = '';
                                            swsnotificationUnit = '';
                                        } else {
                                            swsNotificationNo = sws[0].notificationNo;
                                            swsnotificationRate = sws[0].notificationRate;
                                            swsNotificationSrNo = sws[0].notificationSrNo;
                                            swsnotificationAmount = sws[0].notificationAmount;
                                            swsnotificationFlag = sws[0].notificationFlag;
                                            swsnotificationUnit = sws[0].notificationUnit;
                                        }
                                        if (edu === [] || !edu[0]) {
                                            eduNotificationNo = '';
                                            edunotificationRate = '0.00';
                                            eduNotificationSrNo = '';
                                            edunotificationAmount = '0.00';
                                            edunotificationFlag = '';
                                            edunotificationUnit = '';
                                        } else {
                                            eduNotificationNo = edu[0].notificationNo;
                                            edunotificationRate = edu[0].notificationRate;
                                            eduNotificationSrNo = edu[0].notificationSrNo;
                                            edunotificationAmount = edu[0].notificationAmount;
                                            edunotificationFlag = edu[0].notificationFlag;
                                            edunotificationUnit = edu[0].notificationUnit;
                                        }
                                        var gstNotificationNo, gstnotificationRate, gstNotificationSrNo = '';
                                        var gstnotificationAmount, gstnotificationFlag, gstnotificationUnit = '';
                                        var gstdutyType, gstaddlDutyType, gstigstFlag, gstexmpNoti, gstExmpSlNo = '';
                                        if (gst === [] || !gst[0]) {

                                            gstNotificationNo = '';
                                            gstnotificationRate = '0.00';
                                            gstNotificationSrNo = '';
                                            gstnotificationAmount = '0.00';
                                            gstnotificationUnit = '';
                                            gstdutyType = '';
                                            gstaddlDutyType = '';
                                            gstigstFlag = '';
                                            gstexmpNoti = '';
                                            gstExmpSlNo = '';
                                        } else {

                                            gstNotificationNo = gst[0].notificationNo;
                                            gstnotificationRate = gst[0].notificationRate;
                                            gstNotificationSrNo = gst[0].notificationSrNo;
                                            gstnotificationAmount = gst[0].notificationAmount;
                                            gstnotificationUnit = gst[0].notificationFlag;
                                            gstdutyType = gst[0].dutyType;
                                            gstaddlDutyType = gst[0].addlDutyType;
                                            gstigstFlag = gst[0].igstFlag;
                                            gstexmpNoti = gst[0].exempNotNo;
                                            gstExmpSlNo = gst[0].exempNotSrNo;
                                        }
                                        if (ccs === [] || !ccs[0]) {
                                            ccsNotificationNo = '';
                                            ccsnotificationRate = '0.00';
                                            ccsNotificationSrNo = '';
                                            ccsnotificationAmount = '0.00';
                                            ccsnotificationFlag = '';
                                            ccsdutyType = '';
                                            ccsaddlDutyType = '';
                                            ccsigstFlag = '';
                                        } else {
                                            ccsNotificationNo = ccs[0].notificationNo;
                                            ccsnotificationRate = ccs[0].notificationRate;
                                            ccsNotificationSrNo = ccs[0].notificationSrNo;
                                            ccsnotificationAmount = ccs[0].notificationAmount;
                                            ccsnotificationFlag = ccs[0].notificationFlag;
                                            ccsdutyType = ccs[0].dutyType;
                                            ccsaddlDutyType = ccs[0].addlDutyType;
                                            ccsigstFlag = ccs[0].igstFlag;
                                        }

                                        setItemValues({
                                            ...ItemValues, item_sl_no: items[0].itemSrNo, txt_item_Desc: items[0].item_description, txt_ritc: items[0].ritc,
                                            txt_cth: items[0].cth, txt_ceth: items[0].ceth, txt_quantity: items[0].qty, txt_unit: items[0].unitCode, txt_unitPrice: items[0].unitPrice,
                                            txt_currency: items[0].currency_code, txt_exRate: items[0].itemExchangeRate, txt_totAmount: items[0].totalAmount,
                                            txt_brand: items[0].brand, txt_model_no: items[0].modelNo, txt_originCntry: items[0].countryIdString, txt_originCntryName: items[0].countryName,
                                            txt_endusCode: items[0].endUseCode, manufactureY_N: items[0].manufactureDetails, schemeCodeY_N: items[0].schemeCode,
                                            licence_y_n: items[0].licence, Re_importY_n: items[0].reimport, otherDuty_Y_N: items[0].otherDuty, txt_acessory: items[0].assasory, svb_status_y_N: items[0].svbstatus,
                                            anti_dumbing_duty_Y_N: items[0].auntiDumping, rsp_Y_N_Q_T_D_C: items[0].rspDuty, ncdCustomDuty_Y_N: items[0].ncdDuty, scDuty_Y_N: items[0].scDuty,
                                            IGSTDuty_Y_N: items[0].igstDuty, swinfo_Y_N: items[0].swInfo, swConstitutent_Y_N: items[0].swContineute, swProduction_Y_N: items[0].swProduction
                                            , swControl_Y_N: items[0].swControl, swStatementY_N: items[0].swStatement, cust_Notn_exmptY_n: items[0].cusNotnExemp, PolicyPara_Y_N: items[0].policyPera,
                                            genericDesc: items[0].genDesc, txt_rate_typeSP: items[0].rateType, txt_sourceCountry: items[0].sourceCountryCode, swSuportDoc_Y_N: items[0].swSupDocs,
                                            txt_sourceCountryName: items[0].sourceCountryName, txt_transit_country: items[0].transitCountryCode, txt_transit_countryName: items[0].transitCountryName,
                                            bcd_notfication_no: bcdNotificationNo, bcd_sl_no: bcdNotificationSrNo, bcd_rate_no: bcdnotificationRate,
                                            bcd_amount_no: bcdnotificationAmount, bcd_flg_no: bcdnotificationFlag, bcd_uqc_no: bcdnotificationUnit,

                                            cvd_notfication_no: cvdNotificationNo, cvd_sl_no: cvdNotificationSrNo, cvd_rate_no: cvdnotificationRate,
                                            cvd_amount_no: cvdnotificationAmount, cvd_flg_no: cvdnotificationFlag, cvd_uqc_no: cvdnotificationUnit, aidc_notfication_no: aidNotificationNo,

                                            aidc_sl_no: aidNotificationSrNo, aidc_rate_no: aidnotificationRate, aidc_amount_no: aidnotificationAmount,
                                            aidc_uqc_no: aidnotificationUnit, aidc_flg_no: aidnotificationFlag, edu_css_notfication_no: eduNotificationNo,

                                            edu_css_rate_no: edunotificationRate, edu_css_sl_no: eduNotificationSrNo, edu_css_amount_no: edunotificationAmount,
                                            edu_css_flg_no: edunotificationFlag, edu_css_uqc_no: edunotificationUnit, igstduty_notfion_no: gstNotificationNo,

                                            igstduty_sl_no: gstNotificationSrNo, igstduty_rate: gstnotificationRate, igstduty_flg: gstnotificationFlag,
                                            igstduty_amount: gstnotificationAmount, igstduty_uqc: gstnotificationUnit, igstduty_type: gstdutyType,
                                            igstduty_Add_type: gstaddlDutyType, igstduty_flagG_C: gstigstFlag, igstduty_exmpNotn_no: gstexmpNoti, igstduty_sl_no2: gstExmpSlNo,

                                            sws_notfication_no: swsNotificationNo, sws_sl_no: swsNotificationSrNo, sws_rate_no: swsnotificationRate,
                                            sws_flg_no: swsnotificationFlag, sws_amount_no: swsnotificationAmount, sws_uqc_no: swsnotificationUnit,

                                            igstcess_notfion_no: ccsNotificationNo, igstcess_sl_no: ccsNotificationSrNo, igstcess_rate: ccsnotificationRate,
                                            igstcess_flg: ccsnotificationFlag, igstcess_amount: ccsnotificationAmount, igstcess_type: ccsdutyType,
                                            igstcess_Add_type: ccsaddlDutyType, igstcess_flagG_C: ccsigstFlag
                                        });
                                        var svbLoading, assablePerc, dutyPerc, avFinal, dutyFinal = '';
                                        if (items[0].svbLoading !== null || items[0].svbLoading !== '') {
                                            svbLoading = items[0].svbLoading;
                                        } else { svbLoading = null }
                                        if (items[0].assablePerc !== null || items[0].assablePerc !== '') {
                                            assablePerc = items[0].assablePerc;
                                        } else { assablePerc = '0.00' }
                                        if (items[0].dutyPerc !== null || items[0].dutyPerc !== '') {
                                            dutyPerc = items[0].dutyPerc;
                                        } else { dutyPerc = '0.00' }
                                        if (items[0].avFinal !== null || items[0].avFinal !== '') {
                                            avFinal = items[0].avFinal;
                                        } else { avFinal = '0.00' }
                                        if (items[0].dutyFinal !== null || items[0].dutyFinal !== '') {
                                            dutyFinal = items[0].dutyFinal;
                                        } else { dutyFinal = 'N' }
                                        setItemDialogValues({
                                            ...ItemDialogValues, svb_reference_no: items[0].svbRefNo, svb_customhouseCode: items[0].cusHouseCode,
                                            svb_loadOn_Ad: svbLoading, svb_load_AV: assablePerc, svb_load_duty: dutyPerc, svb_provi_AV: avFinal, svb_provi_duty: dutyFinal,
                                            svb_refrenceDate: items[0].svbDate
                                        });
                                    })
                                })
                            })
                        })
                    })
                })
            })
        })
    }
    const getItemSummary = (item_id) => {
        let details2 = { invoiceId: invoicevalues.InvoiceId, itemId: item_id }
        ItemService.getItemSummary(details2).then(res => {
            const data = res.data;
            const summury = data.map((item) => item);
            setItemSummury({
                ...ItemSummury, itm_fright: summury[0].freightAmount, itm_insurence: summury[0].insuranceAmount,
                itm_misc: summury[0].miscAmount, itm_loadinng: summury[0].loadingValue, itm_totalValue: summury[0].totalAmount,
                ass: summury[0].totalAssableAmount, bcd: summury[0].bcdAmt, cvd: summury[0].cvdAmt, sws: summury[0].swsAmt,
                gst: summury[0].gstAmt, duty: summury[0].totalDutyAmount
            });
        })
    }

    /**-----------onChange-DialogBox-Event------------------------------------------**/
    const itemDialogItemdescChangeHandle = (e) => {
        setItemDialogValues({ ...ItemDialogValues, f_item_desc: e.target.value })
        var itemName = '';
        if (!e.target.value) {
            itemName = '-1'
        } else {
            itemName = e.target.value
        }
        ItemService.getItemNameSearch(itemName, '1').then(res => {
            setItemDescDetails(res.data)
        })
    }

    const ItemDialogFindRitcCodeChangeHandle = (e) => {
        setItemDialogValues({ ...ItemDialogValues, f_ritcCode: e.target.value });
        var hsCode = '';
        if (e.target.value !== '') {
            hsCode = e.target.value;
        } else {
            hsCode = '-1';
        }
        let details = { hsCode: hsCode, hsName: '-1', flag: '2' }
        ItemService.getHsCode(details).then(res => {
            setItemRitcDetails(res.data);
        })
    }
    const ItemDialogFindRitcNameChangeHandle = (e) => {
        setItemDialogValues({ ...ItemDialogValues, f_ritcName: e.target.value })
        var hsName = '';
        if (e.target.value !== '') {
            hsName = e.target.value;
        } else {
            hsName = '-1';
        }
        let details = { hsCode: '-1', hsName: hsName, flag: '2' }
        ItemService.getHsCode(details).then(res => {
            setItemRitcDetails(res.data);
        })
    }

    const ItemDialogFindUnitCodeChangeHandle = (e) => {
        setItemDialogValues({ ...ItemDialogValues, f_unitCode: e.target.value })
        var unitCode = '';
        if (e.target.value !== '') {
            unitCode = e.target.value;
        } else {
            unitCode = '-1';
        }
        let details = { unitCode: unitCode, unitName: '-1', flag: 2 }
        JobServices.getUOM(details).then(res => {
            setItemRitcDetails(res.data);
        })

    }
    const ItemDialogFindUnitNameChangeHandle = (e) => {
        setItemDialogValues({ ...ItemDialogValues, f_unitName: e.target.value })
        var unitName = '';
        if (e.target.value !== '') {
            unitName = e.target.value;
        } else {
            unitName = '-1';
        }
        let details = { unitCode: '-1', unitName: unitName, flag: 2 }
        JobServices.getUOM(details).then(res => {
            setItemRitcDetails(res.data);
        })
    }

    const ItemDialogFindCurrencyCodeChangeHandle = (e) => {
        setItemDialogValues({ ...ItemDialogValues, f_currencyCode: e.target.value })
        var currency_code = '';
        if (e.target.value !== '') {
            currency_code = e.target.value;
        } else {
            currency_code = '-1';
        }
        let details = { currency_code: currency_code, currencyPrefix: '-1', flag: 1 }
        InvoiceService.getCurrency(details).then(res => {
            setItemRitcDetails(res.data);
        })
    }
    const ItemDialogFindCurrencyNameChangeHandle = (e) => {
        setItemDialogValues({ ...ItemDialogValues, f_currencyName: e.target.value })
        var currencyPrefix = '';
        if (e.target.value !== '') {
            currencyPrefix = e.target.value;
        } else {
            currencyPrefix = '-1';
        }
        let details = { currency_code: '-1', currencyPrefix: currencyPrefix, flag: 1 }
        InvoiceService.getCurrency(details).then(res => {
            setItemRitcDetails(res.data);
        })

    }
    const ItemDialogFindEndUseCodeChangeHandle = (e) => {
        setItemDialogValues({ ...ItemDialogValues, f_enduse_code: e.target.value })
        var endUseCode = '';
        if (e.target.value !== '') {
            endUseCode = e.target.value;
        } else {
            endUseCode = '-1';
        }
        let details = { endUseCode: endUseCode, endUseDesc: '-1', flag: 2 }
        ItemService.getEndUseCode(details).then(res => {
            setItemRitcDetails(res.data);
        })
    }
    const ItemDialogFindEndUseNameChangeHandle = (e) => {
        setItemDialogValues({ ...ItemDialogValues, f_enduse_name: e.target.value })
        var endUseDesc = '';
        if (e.target.value !== '') {
            endUseDesc = e.target.value;
        } else {
            endUseDesc = '-1';
        }
        let details = { endUseCode: '-1', endUseDesc: endUseDesc, flag: 2 }
        ItemService.getEndUseCode(details).then(res => {
            setItemRitcDetails(res.data);
        })
    }

    const ItemDialogOriginCntryCodeChangeHandle = (e) => {
        setItemDialogValues({ ...ItemDialogValues, f_originCntryCode: e.target.value })
        var countryIdString = '';
        if (e.target.value !== '') {
            countryIdString = e.target.value;
        } else {
            countryIdString = '-1';
        }
        let details = { countryIdString: countryIdString, countryName: '-1', flag: 2 }
        JobServices.getCountryName(details).then(res => {
            setItemRitcDetails(res.data);
        })
    }
    const ItemDialogFindOriginCntryNameChangeHandle = (e) => {
        setItemDialogValues({ ...ItemDialogValues, f_originCntryName: e.target.value })
        var countryName = '';
        if (e.target.value !== '') {
            countryName = e.target.value;
        } else {
            countryName = '-1';
        }
        let details = { countryIdString: '-1', countryName: countryName, flag: 2 }
        JobServices.getCountryName(details).then(res => {
            setItemRitcDetails(res.data);
        })
    }

    const ItemDialogBcdNotifyNoChangeHandle = (e) => {
        setItemDialogValues({ ...ItemDialogValues, f_bcd_notificationNo: e.target.value })
        var notificationNo, notificationSrNo = '';
        if (e.target.value !== '') {
            notificationNo = e.target.value;
        } else {
            notificationNo = '-1';
        }
        if (ItemDialogValues.f_bcd_notificationSrNo !== '') {
            notificationSrNo = ItemDialogValues.f_bcd_notificationSrNo;
        } else {
            notificationSrNo = '-1'
        }
        let details = {
            notificationNo: notificationNo, notificationSrNo: notificationSrNo,
            notificationType: 'BCD', hsCode: ItemValues.txt_ritc, flag: 2
        }
        ItemService.getCustomNotification(details).then(res => {
            setItemRitcDetails(res.data);
        })
    }
    const ItemDialogBcdNotifySrNoChangeHandle = (e) => {
        setItemDialogValues({ ...ItemDialogValues, f_bcd_notificationSrNo: e.target.value })
        var notificationNo, notificationSrNo = '';
        if (ItemDialogValues.f_bcd_notificationNo !== '') {
            notificationNo = ItemDialogValues.f_bcd_notificationNo;
        } else {
            notificationNo = '-1';
        }
        if (e.target.value !== '') {
            notificationSrNo = e.target.value;
        } else {
            notificationSrNo = '-1'
        }
        let details = {
            notificationNo: notificationNo, notificationSrNo: notificationSrNo,
            notificationType: 'BCD', hsCode: ItemValues.txt_ritc, flag: 2
        }
        ItemService.getCustomNotification(details).then(res => {
            setItemRitcDetails(res.data);
        })
    }
    const ItemDialogAidcNotifyNoChangeHandle = (e) => {
        setItemDialogValues({ ...ItemDialogValues, f_aidc_notificationNo: e.target.value })
        var notificationNo, notificationSrNo = '';
        if (e.target.value !== '') {
            notificationNo = e.target.value;
        } else {
            notificationNo = '-1';
        }
        if (ItemDialogValues.f_aidc_notificationSrNo !== '') {
            notificationSrNo = ItemDialogValues.f_aidc_notificationSrNo;
        } else {
            notificationSrNo = '-1'
        }
        let details = {
            notificationNo: notificationNo, notificationSrNo: notificationSrNo,
            notificationType: 'AID', hsCode: '-1', flag: 2
        }
        ItemService.getCustomNotification(details).then(res => {
            setItemRitcDetails(res.data);
        })
    }
    const ItemDialogAidcNotifySrNoChangeHandle = (e) => {
        setItemDialogValues({ ...ItemDialogValues, f_aidc_notificationSrNo: e.target.value })
        var notificationNo, notificationSrNo = '';
        if (ItemDialogValues.f_aidc_notificationNo !== '') {
            notificationNo = ItemDialogValues.f_aidc_notificationNo;
        } else {
            notificationNo = '-1';
        }
        if (e.target.value !== '') {
            notificationSrNo = e.target.value;
        } else {
            notificationSrNo = '-1'
        }
        let details = {
            notificationNo: notificationNo, notificationSrNo: notificationSrNo,
            notificationType: 'AID', hsCode: '-1', flag: 2
        }
        ItemService.getCustomNotification(details).then(res => {
            setItemRitcDetails(res.data);
        })
    }

    const ItemDialogSWSNotifyNoChangeHandle = (e) => {
        setItemDialogValues({ ...ItemDialogValues, f_SWS_notificationNo: e.target.value })
        var notificationNo, notificationSrNo = '';
        if (e.target.value !== '') {
            notificationNo = e.target.value;
        } else {
            notificationNo = '-1';
        }
        if (ItemDialogValues.f_SWS_notificationSrNo !== '') {
            notificationSrNo = ItemDialogValues.f_SWS_notificationSrNo;
        } else {
            notificationSrNo = '-1'
        }
        let details = {
            notificationNo: notificationNo, notificationSrNo: notificationSrNo,
            notificationType: 'SWS', hsCode: ItemValues.txt_ritc, flag: 2
        }
        ItemService.getCustomNotification(details).then(res => {
            setItemRitcDetails(res.data);
        })
    }
    const ItemDialogSWSNotifySrNoChangeHandle = (e) => {
        setItemDialogValues({ ...ItemDialogValues, f_SWS_notificationSrNo: e.target.value })
        var notificationNo, notificationSrNo = '';
        if (ItemDialogValues.f_SWS_notificationSrNo !== '') {
            notificationNo = ItemDialogValues.f_SWS_notificationSrNo;
        } else {
            notificationNo = '-1';
        }
        if (e.target.value !== '') {
            notificationSrNo = e.target.value;
        } else {
            notificationSrNo = '-1'
        }
        let details = {
            notificationNo: notificationNo, notificationSrNo: notificationSrNo,
            notificationType: 'SWS', hsCode: ItemValues.txt_ritc, flag: 2
        }
        ItemService.getCustomNotification(details).then(res => {
            setItemRitcDetails(res.data);
        })
    }
    const ItemDialogCVDNotifyNoChangeHandle = (e) => {
        setItemDialogValues({ ...ItemDialogValues, f_CVD_notificationNo: e.target.value })
        var notificationNo, notificationSrNo = '';
        if (e.target.value !== '') {
            notificationNo = e.target.value;
        } else {
            notificationNo = '-1';
        }
        if (ItemDialogValues.f_CVD_notificationSrNo !== '') {
            notificationSrNo = ItemDialogValues.f_CVD_notificationSrNo;
        } else {
            notificationSrNo = '-1'
        }
        let details = {
            notificationNo: notificationNo, notificationSrNo: notificationSrNo,
            notificationType: 'CVD', hsCode: ItemValues.txt_ritc, flag: 2
        }
        ItemService.getCustomNotification(details).then(res => {
            setItemRitcDetails(res.data);
        })
    }
    const ItemDialogCVDNotifySrNoChangeHandle = (e) => {
        setItemDialogValues({ ...ItemDialogValues, f_CVD_notificationSrNo: e.target.value })
        var notificationNo, notificationSrNo = '';
        if (ItemDialogValues.f_CVD_notificationNo !== '') {
            notificationNo = ItemDialogValues.f_CVD_notificationNo;
        } else {
            notificationNo = '-1';
        }
        if (e.target.value !== '') {
            notificationSrNo = e.target.value;
        } else {
            notificationSrNo = '-1'
        }
        let details = {
            notificationNo: notificationNo, notificationSrNo: notificationSrNo,
            notificationType: 'CVD', hsCode: ItemValues.txt_ritc, flag: 2
        }
        ItemService.getCustomNotification(details).then(res => {
            setItemRitcDetails(res.data);
        })
    }
    const ItemDialogEDUNotifyNoChangeHandle = (e) => {
        setItemDialogValues({ ...ItemDialogValues, f_EDU_notificationNo: e.target.value })
        var notificationNo, notificationSrNo = '';
        if (e.target.value !== '') {
            notificationNo = e.target.value;
        } else {
            notificationNo = '-1';
        }
        if (ItemDialogValues.f_EDU_notificationSrNo !== '') {
            notificationSrNo = ItemDialogValues.f_EDU_notificationSrNo;
        } else {
            notificationSrNo = '-1'
        }
        let details = {
            notificationNo: notificationNo, notificationSrNo: notificationSrNo,
            notificationType: 'EDU', hsCode: ItemValues.txt_ritc, flag: 2
        }
        ItemService.getCustomNotification(details).then(res => {
            setItemRitcDetails(res.data);
        })
    }
    const ItemDialogEDUNotifySrNoChangeHandle = (e) => {
        setItemDialogValues({ ...ItemDialogValues, f_EDU_notificationSrNo: e.target.value })
        var notificationNo, notificationSrNo = '';
        if (ItemDialogValues.f_EDU_notificationNo !== '') {
            notificationNo = ItemDialogValues.f_EDU_notificationNo;
        } else {
            notificationNo = '-1';
        }
        if (e.target.value !== '') {
            notificationSrNo = e.target.value;
        } else {
            notificationSrNo = '-1'
        }
        let details = {
            notificationNo: notificationNo, notificationSrNo: notificationSrNo,
            notificationType: 'EDU', hsCode: ItemValues.txt_ritc, flag: 2
        }
        ItemService.getCustomNotification(details).then(res => {
            setItemRitcDetails(res.data);
        })
    }
    const ItemDialogIGSTDutyNotifyNoChangeHandle = (e) => {
        setItemDialogValues({ ...ItemDialogValues, f_IGSTDuty_notificationNo: e.target.value })
        var notificationNo, notificationSrNo = '';
        if (e.target.value !== '') {
            notificationNo = e.target.value;
        } else {
            notificationNo = '-1';
        }
        if (ItemDialogValues.f_IGSTDuty_notificationSrNo !== '') {
            notificationSrNo = ItemDialogValues.f_IGSTDuty_notificationSrNo;
        } else {
            notificationSrNo = '-1'
        }
        let details = {
            notificationNo: notificationNo, notificationSrNo: notificationSrNo,
            notificationType: 'GST', hsCode: '-1', flag: 2
        }
        ItemService.getCustomNotification(details).then(res => {
            setItemRitcDetails(res.data);
        })
    }
    const ItemDialogIGSTDutynotifySrNoChangeHandle = (e) => {
        setItemDialogValues({ ...ItemDialogValues, f_IGSTDuty_notificationSrNo: e.target.value });

        var notificationNo, notificationSrNo = '';
        if (ItemDialogValues.f_IGSTDuty_notificationNo !== '') {
            notificationNo = ItemDialogValues.f_IGSTDuty_notificationNo;
        } else {
            notificationNo = '-1';
        }
        if (e.target.value !== '') {
            notificationSrNo = e.target.value;
        } else {
            notificationSrNo = '-1'
        }
        let details = {
            notificationNo: notificationNo, notificationSrNo: notificationSrNo,
            notificationType: 'GST', hsCode: '-1', flag: 2
        }
        ItemService.getCustomNotification(details).then(res => {
            setItemRitcDetails(res.data);
        })
    }
    const ItemDialogIGSTCessNotifyNoChangeHandle = (e) => {
        setItemDialogValues({ ...ItemDialogValues, f_IGSTCess_notificationNo: e.target.value })
        var notificationNo, notificationSrNo = '';
        if (e.target.value !== '') {
            notificationNo = e.target.value;
        } else {
            notificationNo = '-1';
        }
        if (ItemDialogValues.f_IGSTCess_notificationSrNo !== '') {
            notificationSrNo = ItemDialogValues.f_IGSTCess_notificationSrNo;
        } else {
            notificationSrNo = '-1'
        }
        let details = {
            notificationNo: notificationNo, notificationSrNo: notificationSrNo,
            notificationType: 'CCS', hsCode: '-1', flag: 2
        }
        ItemService.getCustomNotification(details).then(res => {
            setItemRitcDetails(res.data);
        })
    }
    const ItemDialogIGSTCessnotifySrNoChangeHandle = (e) => {
        setItemDialogValues({ ...ItemDialogValues, f_IGSTCess_notificationSrNo: e.target.value });

        var notificationNo, notificationSrNo = '';
        if (ItemDialogValues.f_IGSTCess_notificationNo !== '') {
            notificationNo = ItemDialogValues.f_IGSTCess_notificationNo;
        } else {
            notificationNo = '-1';
        }
        if (e.target.value !== '') {
            notificationSrNo = e.target.value;
        } else {
            notificationSrNo = '-1'
        }
        let details = {
            notificationNo: notificationNo, notificationSrNo: notificationSrNo,
            notificationType: 'CCS', hsCode: '-1', flag: 2
        }
        ItemService.getCustomNotification(details).then(res => {
            setItemRitcDetails(res.data);
        })
    }
    const ItemDialogIGSTDutyExmpNotifyNoChangeHandle = (e) => {
        setItemDialogValues({ ...ItemDialogValues, f_IGSTDutyExmp_notificationNo: e.target.value })
        var notificationNo, notificationSrNo = '';
        if (e.target.value !== '') {
            notificationNo = e.target.value;
        } else {
            notificationNo = '-1';
        }
        if (ItemDialogValues.f_IGSTDutyExmp_notificationSrNo !== '') {
            notificationSrNo = ItemDialogValues.f_IGSTDutyExmp_notificationSrNo;
        } else {
            notificationSrNo = '-1'
        }
        let details = {
            notificationNo: notificationNo, notificationSrNo: notificationSrNo,
            notificationType: 'GST', hsCode: '-1', flag: 2
        }
        ItemService.getCustomNotification(details).then(res => {
            setItemRitcDetails(res.data);
        })
    }
    const ItemDialogIGSTDutyExmpnotifySrNoChangeHandle = (e) => {
        setItemDialogValues({ ...ItemDialogValues, f_IGSTDutyExmp_notificationSrNo: e.target.value });

        var notificationNo, notificationSrNo = '';
        if (ItemDialogValues.f_IGSTDutyExmp_notificationNo !== '') {
            notificationNo = ItemDialogValues.f_IGSTDutyExmp_notificationNo;
        } else {
            notificationNo = '-1';
        }
        if (e.target.value !== '') {
            notificationSrNo = e.target.value;
        } else {
            notificationSrNo = '-1'
        }
        let details = {
            notificationNo: notificationNo, notificationSrNo: notificationSrNo,
            notificationType: 'GST', hsCode: '-1', flag: 2
        }
        ItemService.getCustomNotification(details).then(res => {
            setItemRitcDetails(res.data);
        })
    }
    const itemDialogSchemeCodeChngHndl = (e) => {
        setItemDialogValues({ ...ItemDialogValues, scheme_code: e.target.value });
        var schemeCode = '';
        if (e.target.value !== '') {
            schemeCode = e.target.value;
        } else {
            schemeCode = '-1'
        }
        let details = { schemeCode: schemeCode, schemeDesc: '-1', flag: '2' }
        ItemService.getSchemeCode(details).then(res => {
            const data = res.data;
            const scheme = data.map((item) => item);
            if (e.target.value !== '') {
                setItemDialogValues({
                    ...ItemDialogValues, scheme_code: e.target.value
                    , scheme_codeName: scheme[0].schemeDesc
                });
            } else {
                setItemDialogValues({
                    ...ItemDialogValues, scheme_code: e.target.value
                    , scheme_codeName: ''
                });
            }

        })
    }
    const itemDialogShemNotificationNoChngHndl = (e) => {
        setItemDialogValues({ ...ItemDialogValues, notofi_no: e.target.value });
    }
    const itemDialogShemSrlNoChngHndl = (e) => {
        setItemDialogValues({ ...ItemDialogValues, srl_no: e.target.value });
    }
    const itemDialogShemExcempRquiredChngHndl = (e) => {
        if (e.target.value === 'Y' || e.target.value === 'y' || e.target.value === 'N' || e.target.value === 'n' || e.target.value === '') {
            setItemDialogValues({ ...ItemDialogValues, exemptionrequired: e.target.value });
        }
    }
    const itemDialogShemreExportChngHndl = (e) => {
        if (e.target.value === 'Y' || e.target.value === 'y' || e.target.value === 'N' || e.target.value === 'n' || e.target.value === '') {
            setItemDialogValues({ ...ItemDialogValues, re_export: e.target.value });
        }
    }
    const itemDialogShemSec_20ChngHndl = (e) => {
        if (e.target.value === 'Y' || e.target.value === 'y' || e.target.value === 'N' || e.target.value === 'n' || e.target.value === '') {
            setItemDialogValues({ ...ItemDialogValues, sec_20: e.target.value });
        }
    }

    const ItemDialogFindSchemeCodeChngHandle = (e) => {
        setItemDialogValues({ ...ItemDialogValues, f_scheme_code: e.target.value });
        var schemeDesc, schemeCode = '';
        if (e.target.value !== '') {
            schemeCode = e.target.value;
        } else {
            schemeCode = '-1'
        }
        if (ItemDialogValues.scheme_codeName !== '') {
            schemeDesc = ItemDialogValues.scheme_codeName;
        } else {
            schemeDesc = '-1'
        }
        let details = { schemeCode: schemeCode, schemeDesc: schemeDesc, flag: '2' }
        ItemService.getSchemeCode(details).then(res => {
            setItemSchemeCodeDetails(res.data);
        })
    }
    const ItemDialogFindSchemeNameChngHandle = (e) => {
        setItemDialogValues({ ...ItemDialogValues, f_scheme_codeName: e.target.value });
        var schemeDesc, schemeCode = '';
        if (ItemDialogValues.scheme_code !== '') {
            schemeCode = ItemDialogValues.scheme_code;
        } else {
            schemeCode = '-1'
        }
        if (e.target.value !== '') {
            schemeDesc = e.target.value;
        } else {
            schemeDesc = '-1'
        }
        let details = { schemeCode: schemeCode, schemeDesc: schemeDesc, flag: '2' }
        ItemService.getSchemeCode(details).then(res => {
            setItemSchemeCodeDetails(res.data);
        })
    }

    const ItemDialogFindSchemeNotnChngHandle = (e) => {
        setItemDialogValues({ ...ItemDialogValues, f_IGST_notificationNo: e.target.value });
        var notificationNo, notificationSrNo = '';
        if (e.target.value !== '') {
            notificationNo = e.target.value;
        } else {
            notificationNo = '-1';
        }
        if (ItemDialogValues.f_IGST_notificationSrNo !== '') {
            notificationSrNo = ItemDialogValues.f_IGST_notificationSrNo;
        } else {
            notificationSrNo = '-1'
        }
        let details = {
            notificationNo: notificationNo, notificationSrNo: notificationSrNo,
            notificationType: 'GST', hsCode: '-1', flag: 2
        }
        ItemService.getCustomNotification(details).then(res => {
            setItemSchemeCodeDetails(res.data);
        })
    }
    const ItemDialogFindSchemeSrlNoChngHandle = (e) => {
        setItemDialogValues({ ...ItemDialogValues, f_IGST_notificationSrNo: e.target.value });
        var notificationNo, notificationSrNo = '';
        if (ItemDialogValues.f_IGST_notificationNo !== '') {
            notificationNo = ItemDialogValues.f_IGST_notificationNo;
        } else {
            notificationNo = '-1';
        }
        if (e.target.value !== '') {
            notificationSrNo = e.target.value;
        } else {
            notificationSrNo = '-1'
        }
        let details = {
            notificationNo: notificationNo, notificationSrNo: notificationSrNo,
            notificationType: 'GST', hsCode: '-1', flag: 2
        }
        ItemService.getCustomNotification(details).then(res => {
            setItemSchemeCodeDetails(res.data);
        })
    }

    const ItemAuntidmpNotnChngHndl = (e) => {
        setItemDialogValues({ ...ItemDialogValues, auntiDump_notn_no: e.target.value });
    }
    const ItemAuntidmpSrlNoChngHndl = (e) => {
        setItemDialogValues({ ...ItemDialogValues, auntiDump_Srl_no: e.target.value });
    }
    const ItemAuntidmpCthSrlNoChngHndl = (e) => {
        setItemDialogValues({ ...ItemDialogValues, auntiDump_cth_srl_no: e.target.value });
    }
    const ItemAuntidmpSupSrlNoChngHndl = (e) => {
        setItemDialogValues({ ...ItemDialogValues, auntiDump_sup_srl_no: e.target.value });
    }
    const ItemAuntidmpAdvaloremRateChngHndl = (e) => {
        setItemDialogValues({ ...ItemDialogValues, auntiDump_advalorem_rate: e.target.value });
    }
    const ItemAuntidmpFlagChngHndl = (e) => {
        setItemDialogValues({ ...ItemDialogValues, auntiDump_flag: e.target.value });
    }
    const ItemAuntidmpQuantityChngHndl = (e) => {
        setItemDialogValues({ ...ItemDialogValues, auntiDump_quantity: e.target.value });
    }
    const ItemAuntidmpUnitChngHndl = (e) => {
        setItemDialogValues({ ...ItemDialogValues, auntiDump_uqc: e.target.value });
    }
    const ItemAuntidmpCurrencyChngHndl = (e) => {
        setItemDialogValues({ ...ItemDialogValues, auntiDump_currency: e.target.value });
    }
    const ItemDialogFindAuntiDump_notn_noChngHandle = (e) => {
        setItemDialogValues({ ...ItemDialogValues, f_auntiDump_notn_no: e.target.value })
        var notificationNo, notificationSrNo = '';
        if (e.target.value !== '') {
            notificationNo = e.target.value;
        } else {
            notificationNo = '-1';
        }
        if (ItemDialogValues.f_auntiDump_Srl_no !== '') {
            notificationSrNo = ItemDialogValues.f_auntiDump_Srl_no;
        } else {
            notificationSrNo = '-1'
        }
        let details = {
            notificationNo: notificationNo, notificationSrNo: notificationSrNo,
            notificationType: 'ADN', hsCode: '-1', flag: 2
        }
        ItemService.getCustomNotification(details).then(res => {
            setItemSchemeCodeDetails(res.data);
        })
    }
    const ItemDialogFindAuntiDump_Srl_noChngHandle = (e) => {
        setItemDialogValues({ ...ItemDialogValues, f_auntiDump_Srl_no: e.target.value })
        var notificationNo, notificationSrNo = '';
        if (ItemDialogValues.f_auntiDump_notn_no !== '') {
            notificationNo = ItemDialogValues.f_auntiDump_notn_no;
        } else {
            notificationNo = '-1';
        }
        if (e.target.value !== '') {
            notificationSrNo = e.target.value;
        } else {
            notificationSrNo = '-1'
        }
        let details = {
            notificationNo: notificationNo, notificationSrNo: notificationSrNo,
            notificationType: 'ADN', hsCode: '-1', flag: 2
        }
        ItemService.getCustomNotification(details).then(res => {
            setItemSchemeCodeDetails(res.data);
        })
    }

    const ItemDialogSwTypeChngHandl = (e) => {
        setItemDialogValues({ ...ItemDialogValues, SwType: e.target.value });
        let details = { swCode: e.target.value }
        ItemService.getSwInfoQualifier(details).then(res => {
            setItemSwQualifrDrp(res.data)
        });
    }
    const ItemDialogSwQualifierChngHandl = (e) => {
        setItemDialogValues({ ...ItemDialogValues, SwQwalifier: e.target.value });
        let details = { swQualifier: e.target.value }
        ItemService.getSwInfoCode(details).then(res => {
            setItemSwCodeDrp(res.data)
        })
    }
    const ItemDialogSwCodeChngHandl = (e) => {
        setItemDialogValues({ ...ItemDialogValues, SwCode: e.target.value });
    }
    const ItemDialogSwTextChngHandl = (e) => {
        setItemDialogValues({ ...ItemDialogValues, SwText: e.target.value });
    }
    const ItemDialogSwMeasurementChngHandl = (e) => {
        setItemDialogValues({ ...ItemDialogValues, sw_mesurnment: e.target.value });
    }
    const ItemDialogSwUqcChngHandl = (e) => {
        setItemDialogValues({ ...ItemDialogValues, Sw_Uqc: e.target.value });
    }

    const ItemDialogLicenceRegNoChngHandl = (e) => {
        setItemDialogValues({ ...ItemDialogValues, licence_reg_no: e.target.value });
    }
    const ItemDialogLicenceCodeChngHandl = (e) => {
        setItemDialogValues({ ...ItemDialogValues, licence_code: e.target.value });
    }
    const ItemDialogLicenceRegDateChngHandl = (e) => {
        setItemDialogValues({ ...ItemDialogValues, licence_Date: e.target.value });
    }
    const ItemDialogLicenceRegPortChngHandl = (e) => {
        setItemDialogValues({ ...ItemDialogValues, licence_reg_port: e.target.value });
    }
    const ItemDialogDebitValueChngHandl = (e) => {
        setItemDialogValues({ ...ItemDialogValues, debit_value: e.target.value });
    }
    const ItemDialogDebitQuantityChngHandl = (e) => {
        setItemDialogValues({ ...ItemDialogValues, debit_quantity: e.target.value });
    }
    const ItemDialogDebitDutyChngHandl = (e) => {
        setItemDialogValues({ ...ItemDialogValues, debit_duty: e.target.value });
    }
    const ItemDialogTraNoChngHandl = (e) => {
        setItemDialogValues({ ...ItemDialogValues, tra_no: e.target.value });
    }
    const ItemDialogTraDateChngHandl = (e) => {
        setItemDialogValues({ ...ItemDialogValues, tra_date: e.target.value });
    }
    const ItemDialogLicenceSrlNoChngHandl = (e) => {
        setItemDialogValues({ ...ItemDialogValues, Licence_item_srlNo: e.target.value });
    }
    const ItemDialogFindLicenceCodeChngHandle = (e) => {
        setItemDialogValues({ ...ItemDialogValues, f_licencePortCode: e.target.value });
        var cusHouseCode = '';
        if (e.target.value !== '') {
            cusHouseCode = e.target.value;
        } else {
            cusHouseCode = '-1'
        }
        let details = { customHouseLocation: '-1', cusHouseCode: cusHouseCode, flag: 2 }
        JobServices.getCustomHouseCode(details).then(res => {
            setItemSchemeCodeDetails(res.data)
        });
    }
    const ItemDialogFindLicenceNameChngHandle = (e) => {
        setItemDialogValues({ ...ItemDialogValues, f_licencePortName: e.target.value });
        var customHouseLocation = '';
        if (e.target.value !== '') {
            customHouseLocation = e.target.value;
        } else {
            customHouseLocation = '-1'
        }
        let details = { customHouseLocation: customHouseLocation, cusHouseCode: '-1', flag: 2 }
        JobServices.getCustomHouseCode(details).then(res => {
            setItemSchemeCodeDetails(res.data)
        });
    }

    const ItemDialogConstituenSlNoChngHndl = (e) => {
        setItemDialogValues({ ...ItemDialogValues, constituentSl_no: e.target.value });
    }
    const ItemDialogConstituenNameChngHndl = (e) => {
        setItemDialogValues({ ...ItemDialogValues, constituent_name: e.target.value });
    }
    const ItemDialogConstituenCodeChngHndl = (e) => {
        setItemDialogValues({ ...ItemDialogValues, constituent_code: e.target.value });
    }
    const ItemDialogConstPercentageChngHndl = (e) => {
        setItemDialogValues({ ...ItemDialogValues, const_percentage: e.target.value });
    }
    const ItemDialogYieldPercentageChngHndl = (e) => {
        setItemDialogValues({ ...ItemDialogValues, yield_percentage: e.target.value });
    }
    const ItemDialogActiveIngredientChngHndl = (e) => {
        setItemDialogValues({ ...ItemDialogValues, active_indredient: e.target.value });
    }
    const ItemDialogRspNotnNoChngHndl = (e) => {
        setItemDialogValues({ ...ItemDialogValues, rsp_notnNo: e.target.value });
    }
    const ItemDialogRspSlNoChngHndl = (e) => {
        setItemDialogValues({ ...ItemDialogValues, rsp_notnSlNo: e.target.value });
    }
    const ItemDialogRspAmountChngHndl = (e) => {
        setItemDialogValues({ ...ItemDialogValues, rsp_amount: e.target.value });
    }
    const ItemDialogRspRateChngHndl = (e) => {
        setItemDialogValues({ ...ItemDialogValues, rsp_rate: e.target.value });
    }
    const ItemDialogRspDescriptioneChngHndl = (e) => {
        setItemDialogValues({ ...ItemDialogValues, rsp_description: e.target.value });
    }
    const ItemDialogRspQuantityChngHndl = (e) => {
        setItemDialogValues({ ...ItemDialogValues, rsp_quantity: e.target.value });
    }
    const ItemDialogRiPriviousSbNoChngHndl = (e) => {
        setItemDialogValues({ ...ItemDialogValues, r_iPrivousSbNo: e.target.value });
    }
    const ItemDialogRiPriviousSbDateChngHndl = (e) => {
        setItemDialogValues({ ...ItemDialogValues, r_iPrivousSbdate: e.target.value });
    }
    const ItemDialogRiPortExportChngHndl = (e) => {
        setItemDialogValues({ ...ItemDialogValues, r_iPort_of_export: e.target.value });
    }
    const ItemDialogRiInvoiceNoSbChngHndl = (e) => {
        setItemDialogValues({ ...ItemDialogValues, r_iInvoiceNo_sb: e.target.value });
    }
    const ItemDialogRiItemSbNoChngHndl = (e) => {
        setItemDialogValues({ ...ItemDialogValues, r_iItemNo_sb: e.target.value });
    }
    const ItemDialogRiNotificationNoChngHndl = (e) => {
        setItemDialogValues({ ...ItemDialogValues, r_iNotificationNo: e.target.value });
    }
    const ItemDialogRiNotificationSlNoChngHndl = (e) => {
        setItemDialogValues({ ...ItemDialogValues, r_iNotificationSrlNo: e.target.value });
    }
    const ItemDialogRiExportFrightChngHndl = (e) => {
        setItemDialogValues({ ...ItemDialogValues, r_iExportFright: e.target.value });
    }
    const ItemDialogRiExportInsurenceChngHndl = (e) => {
        setItemDialogValues({ ...ItemDialogValues, r_iExportInsurance: e.target.value });
    }
    const ItemDialogRiCustomDutyChngHndl = (e) => {
        setItemDialogValues({ ...ItemDialogValues, r_iCustomDuty: e.target.value });
    }
    const ItemDialogRiExciseDutyChngHndl = (e) => {
        setItemDialogValues({ ...ItemDialogValues, r_iExciseDuty: e.target.value });
    }

    const ItemDialogFindPortCodeChngHandle = (e) => {
        setItemDialogValues({ ...ItemDialogValues, f_scheme_code: e.target.value });
        var customPointCode = '';
        if (e.target.value !== '') {
            customPointCode = e.target.value;
        } else {
            customPointCode = '-1'
        }
        let details = { customPointCode: customPointCode, customPointName: '-1', flag: 2 }
        JobServices.getPortLocationBasedTransitType(details).then(res => {
            setItemSchemeCodeDetails(res.data);
        })
    }
    const ItemDialogFindPortNameChngHandle = (e) => {
        setItemDialogValues({ ...ItemDialogValues, f_scheme_codeName: e.target.value });
        var customPointName = '';
        if (e.target.value !== '') {
            customPointName = e.target.value;
        } else {
            customPointName = '-1'
        }
        let details = { customPointCode: '-1', customPointName: customPointName, flag: 2 }
        JobServices.getPortLocationBasedTransitType(details).then(res => {
            setItemSchemeCodeDetails(res.data);
        })
    }

    const ItemDialogNcdNotnNoChngHandle = (e) => {
        setItemDialogValues({ ...ItemDialogValues, ncdDuty_notn_no: e.target.value })
    }
    const ItemDialogNcdNotnSlNoChngHandle = (e) => {
        setItemDialogValues({ ...ItemDialogValues, ncdDuty_notn_slNo: e.target.value })
    }

    const ItemDialogProdIdentiChngHandl = (e) => {
        setItemDialogValues({ ...ItemDialogValues, swProd_prodIdtifier: e.target.value })
    }
    const ItemDialogProQuantityChngHandl = (e) => {
        setItemDialogValues({ ...ItemDialogValues, swprod_Quantity: e.target.value })
    }
    const ItemDialogManufctrDateChngHandl = (e) => {
        setItemDialogValues({ ...ItemDialogValues, swProd_manufacture: e.target.value })
    }
    const ItemDialogExipryDateChngHandl = (e) => {
        setItemDialogValues({ ...ItemDialogValues, swprod_expiryDate: e.target.value })
    }
    const ItemDialogBeforeDateChngHandl = (e) => {
        setItemDialogValues({ ...ItemDialogValues, swProd_beforeDate: e.target.value })
    }
    const ItemDialogSvbReferenceChngHndl = (e) => {
        setItemDialogValues({ ...ItemDialogValues, svb_reference_no: e.target.value });
    }
    const ItemDialogSvbReferenceDateChngHndl = (e) => {
        setItemDialogValues({ ...ItemDialogValues, svb_refrenceDate: e.target.value });
    }
    const ItemDialogSvbCustomHusCodeChngHndl = (e) => {
        setItemDialogValues({ ...ItemDialogValues, svb_customhouseCode: e.target.value });
    }
    const ItemDialogSvbLoadOnADChngHndl = (e) => {
        setItemDialogValues({ ...ItemDialogValues, svb_loadOn_Ad: e.target.value });
    }
    const ItemDialogSvbLoadAVChngHndl = (e) => {
        setItemDialogValues({ ...ItemDialogValues, svb_load_AV: e.target.value });
    }
    const ItemDialogSvbLoadDutyChngHndl = (e) => {
        setItemDialogValues({ ...ItemDialogValues, svb_load_duty: e.target.value });
    }
    const ItemDialogSvbProviAvChngHndl = (e) => {
        setItemDialogValues({ ...ItemDialogValues, svb_provi_AV: e.target.value });
    }
    const ItemDialogSvbProviDutyChngHndl = (e) => {
        setItemDialogValues({ ...ItemDialogValues, svb_provi_duty: e.target.value });
    }

    const ItemDialogManufactrNameChngHndl = (e) => {
        setItemDialogValues({ ...ItemDialogValues, mnfctr_manufactureName: e.target.value });
    }
    const ItemDialogMnfctrCountryChngHndl = (e) => {
        setItemDialogValues({ ...ItemDialogValues, mnfctr_country: e.target.value });
    }
    const ItemDialogMnfctrAdressChngHndl = (e) => {
        setItemDialogValues({ ...ItemDialogValues, mnfctr_adress: e.target.value });
    }
    const ItemDialogMnfctrManufactureCityChngHndl = (e) => {
        setItemDialogValues({ ...ItemDialogValues, mnfctr_manufactureCity: e.target.value });
    }
    const ItemDialogMnfctrPincodeChngHndl = (e) => {
        setItemDialogValues({ ...ItemDialogValues, mnfctr_pincode: e.target.value });
    }
    const ItemDialogMnfctrDivisionChngHndl = (e) => {
        setItemDialogValues({ ...ItemDialogValues, mnfctr_division: e.target.value });
    }
    const ItemDialogFindSupplierChngHndl = (e) => {
        setItemDialogValues({ ...ItemDialogValues, f_suplier_name: e.target.value });
    }

    const ItemDialogCustmNotifiNoChngHndl = (e) => {
        setItemDialogValues({ ...ItemDialogValues, custm_notfiNo: e.target.value });
    }
    const ItemDialogCustmSlNoChngHndl = (e) => {
        setItemDialogValues({ ...ItemDialogValues, custm_Sl_No: e.target.value });
    }

    const ItemDialogFindothrDtyNotfiNoChngHandle = (e) => {
        setItemDialogValues({ ...ItemDialogValues, f_scheme_code: e.target.value });
        var notificationNo, notificationSrNo = ''; setItemSchemeCodeDetails([]);
        if (ItemDialogValues.f_scheme_codeName !== '') {
            notificationSrNo = ItemDialogValues.f_scheme_codeName;
        } else {
            notificationSrNo = '-1';
        }
        if (e.target.value !== '') {
            notificationNo = e.target.value;
        } else {
            notificationNo = '-1';
        }
        let details = {
            notificationSrNo: notificationSrNo, notificationNo: notificationNo, notificationType: 'GST',
            hsCode: '-1', flag: 2
        }
        ItemService.getCustomNotification(details).then(res => { setItemSchemeCodeDetails([]); setItemSchemeCodeDetails(res.data); })
    }
    const ItemDialogFindothrDtyNotfiSlNoChngHandle = (e) => {
        setItemDialogValues({ ...ItemDialogValues, f_scheme_codeName: e.target.value });
        var notificationNo, notificationSrNo = ''; setItemSchemeCodeDetails([]);
        if (e.target.value !== '') {
            notificationSrNo = e.target.value;
        } else {
            notificationSrNo = '-1';
        }
        if (ItemDialogValues.f_scheme_code !== '') {
            notificationNo = ItemDialogValues.f_scheme_code;
        } else {
            notificationNo = '-1';
        }
        let details = {
            notificationSrNo: notificationSrNo, notificationNo: notificationNo, notificationType: 'GST',
            hsCode: '-1', flag: 2
        }
        ItemService.getCustomNotification(details).then(res => { setItemSchemeCodeDetails(res.data); })
    }
    const ItemDialogOthrDutyTypeChngHndl = (e) => {
        setItemDialogValues({ ...ItemDialogValues, othrDuty_Type: e.target.value });
    }
    const ItemDialogOthrDutyNotifiNotifiNoChngHndl = (e) => {
        setItemDialogValues({ ...ItemDialogValues, othrDuty_NotifiNo: e.target.value });
    }
    const ItemDialogOthrDutyNotifiNotifiSlNoChngHndl = (e) => {
        setItemDialogValues({ ...ItemDialogValues, othrDuty_NotifiSlNo: e.target.value });
    }

    const ItemDialogSwcntlTypeCodeChngHndl = (e) => {
        setItemDialogValues({ ...ItemDialogValues, swcntl_typ_code: e.target.value });
        let details = { swControl: e.target.value }
        ItemService.getSwControlResult(details).then(res => {
            setItemSwCodeDrp(res.data)
        });
    }
    const ItemDialogSwcntlLocationChngHndl = (e) => {
        setItemDialogValues({ ...ItemDialogValues, swcntl_location: e.target.value });
    }
    const ItemDialogSwcntlStartDateChngHndl = (e) => {
        setItemDialogValues({ ...ItemDialogValues, swcntl_start_date: e.target.value });
    }
    const ItemDialogSwcntlEndDateChngHndl = (e) => {
        setItemDialogValues({ ...ItemDialogValues, swcntl_end_date: e.target.value });
    }
    const ItemDialogSwcntlResultCodeChngHndl = (e) => {
        setItemDialogValues({ ...ItemDialogValues, swcntl_result_code: e.target.value });
    }
    const ItemDialogSwcntlResultTextChngHndl = (e) => {
        setItemDialogValues({ ...ItemDialogValues, swcntl_result_text: e.target.value });
    }
    const ItemDialogSwcntlMeasurnmentChngHndl = (e) => {
        setItemDialogValues({ ...ItemDialogValues, swcntl_measurnment: e.target.value });
    }
    const ItemDialogSwcntlUqcChngHndl = (e) => {
        setItemDialogValues({ ...ItemDialogValues, swcntl_uqc: e.target.value });
    }
    const ItemDialogSwcntlSlNoChngHndl = (e) => {
        setItemDialogValues({ ...ItemDialogValues, swcntl_sl_no: e.target.value });
    }

    const ItemDialogSwStmntTypeChngHndl = (e) => {
        setItemDialogValues({ ...ItemDialogValues, swStatmnt_typ: e.target.value });
        let details = { swStatementType: e.target.value }
        ItemService.getSwStatementCode(details).then(res => {
            setItemCusHusCode(res.data);
        });
    }
    const ItemDialogSwStmntCodeChngHndl = (e) => {
        setItemDialogValues({ ...ItemDialogValues, swStatment_code: e.target.value });
    }
    const ItemDialogSwStmntTxtChngHndl = (e) => {
        setItemDialogValues({ ...ItemDialogValues, swStatment_text: e.target.value });
    }
    const ItemDialogSwStmntDecTypeMTNBChngHndl = (e) => {
        setItemDialogValues({ ...ItemDialogValues, swStmnt_dclrtiontypeMtnb: e.target.value });
    }
    const ItemDialogSwStmntDecNoChngHndl = (e) => {
        setItemDialogValues({ ...ItemDialogValues, swStatment_decNo: e.target.value });
    }
    const ItemDialogSwStmntDecDateChngHndl = (e) => {
        setItemDialogValues({ ...ItemDialogValues, swStatment_date: e.target.value });
    }

    const ItemDialogPolicyParaNoChngHndl = (e) => {
        setItemDialogValues({ ...ItemDialogValues, policy_paraNo: e.target.value });
    }
    const ItemDialogPolicyParaYearChngHndl = (e) => {
        setItemDialogValues({ ...ItemDialogValues, policy_paraYear: e.target.value });
    }

    //swDocs----
    const ItemImageRefNoChangeHandle = (e) => {
        setItemDialogValues({ ...ItemDialogValues, ImageRefNo: e.target.value })

    }
    const ItemDocTypeCodeChangeHandle = (e) => {
        setItemDialogValues({ ...ItemDialogValues, DocTypeCode: e.target.value })

    }
    const ItemIssuePartyNameChangeHandle = (e) => {
        setItemDialogValues({ ...ItemDialogValues, IssuePartyName: e.target.value })

    }
    const ItemPlaceOfIssueIssuePartyNameChangeHandle = (e) => {
        setItemDialogValues({ ...ItemDialogValues, PlaceOfIssue: e.target.value })

    }
    const ItemDocIssueDateChangeHandle = (e) => {
        setItemDialogValues({ ...ItemDialogValues, DocIssueDate: e.target.value })

    }
    const ItemBeneficiaryNameChangeHandle = (e) => {
        setItemDialogValues({ ...ItemDialogValues, BeneficiaryName: e.target.value })

    }
    const ItemFileTypeChangeHandle = (e) => {
        setItemDialogValues({ ...ItemDialogValues, FileType: e.target.value })
    }
    const ItemDeclarationTypeChangeHandle = (e) => {
        if (e.target.value === 'm' || e.target.value === 'M' || e.target.value === 'N' || e.target.value === 'n' ||
            e.target.value === 't' || e.target.value === 'T') {
            setItemDialogValues({ ...ItemDialogValues, DeclarationTypeMTNE: e.target.value })
        } else if (e.target.value === '') {
            setItemDialogValues({ ...ItemDialogValues, DeclarationTypeMTNE: e.target.value })
        }
    }
    const ItemDocReferenceNoChangeHandle = (e) => {
        setItemDialogValues({ ...ItemDialogValues, DocReferenceNo: e.target.value })
    }
    const ItemDocExpiryDateChangeHandle = (e) => {
        setItemDialogValues({ ...ItemDialogValues, DocExpiryDate: e.target.value })
    }
    const ItemIssuePartyAddress1ChangeHandle = (e) => {
        setItemDialogValues({ ...ItemDialogValues, IssuePartyAddress1: e.target.value })
    }
    const ItemIssuePartyAddress2ChangeHandle = (e) => {
        setItemDialogValues({ ...ItemDialogValues, IssuePartyAddress2: e.target.value })
    }
    const ItemIssuePartyCityChangeHandle = (e) => {
        setItemDialogValues({ ...ItemDialogValues, IssuePartyCity: e.target.value })
    }
    const ItemIssuePartyPincodeChangeHandle = (e) => {
        setItemDialogValues({ ...ItemDialogValues, IssuePartyPincode: e.target.value })
    }
    const ItemIssuePartyCodeChangeHandle = (e) => {
        setItemDialogValues({ ...ItemDialogValues, IssuePartyCode: e.target.value })
    }
    const ItemBenificiaryCodeChangeHandle = (e) => {
        setItemDialogValues({ ...ItemDialogValues, BenificiaryCode: e.target.value })
    }
    const ItemBenificiaryAddress1ChangeHandle = (e) => {
        setItemDialogValues({ ...ItemDialogValues, BenificiaryAddress1: e.target.value })
    }
    const ItemBenificiaryAddress2ChangeHandle = (e) => {
        setItemDialogValues({ ...ItemDialogValues, BenificiaryAddress2: e.target.value })
    }
    const ItemBenificiaryCityChangeHandle = (e) => {
        setItemDialogValues({ ...ItemDialogValues, BenificiaryCity: e.target.value })
    }
    const ItemBenificiaryPincodeChangeHandle = (e) => {
        setItemDialogValues({ ...ItemDialogValues, BenificiaryPincode: e.target.value })
    }
    const ItemFindDocumentTypeChangeHandle = (e) => {
        setItemDialogValues({ ...ItemDialogValues, FindDocumentType: e.target.value })
        var supDocType = '';
        if (e.target.value !== '') {
            supDocType = e.target.value;
        } else {
            supDocType = '-1';
        }
        let details = { supDocType: supDocType, supDocName: '-1', flag: 2 }
        ItemService.getSwSupDocType(details).then(res => {
            setItemSchemeCodeDetails(res.data);
        })
    }
    const ItemFindDocumentNameChangeHandle = (e) => {
        setItemDialogValues({ ...ItemDialogValues, FindDocumentName: e.target.value });
        var supDocName = '';
        if (e.target.value !== '') {
            supDocName = e.target.value;
        } else {
            supDocName = '-1';
        }
        let details = { supDocType: '-1', supDocName: supDocName, flag: 2 }
        ItemService.getSwSupDocType(details).then(res => {
            setItemSchemeCodeDetails(res.data);
        })
    }
    const ItemFindSupplierNameChangeHandle = (e) => {
        setItemDialogValues({ ...ItemDialogValues, FindSupplierName: e.target.value });
        var supplierName = '';
        if (e.target.value !== '') {
            supplierName = e.target.value;
        } else {
            supplierName = '-1';
        }
        let details = { supplierName: supplierName, flag: 2 }
        InvoiceService.getSupplierDetails(details).then(res => {
            setItemSchemeCodeDetails(res.data);
        })
    }
    const ItemImporterIECCodeChangeHandle = (e) => {
        setItemDialogValues({ ...ItemDialogValues, ImporterIECCode: e.target.value })
    }
    const ItemBranchSerialNoChangeHandle = (e) => {
        setItemDialogValues({ ...ItemDialogValues, BranchSerialNo: e.target.value })
    }
    const ItemFindImporterNameChangeHandle = (e) => {
        setItemDialogValues({ ...ItemDialogValues, FindImporterName: e.target.value });
        var importer_iec_no = '';
        if (e.target.value !== '') {
            importer_iec_no = e.target.value;
        } else {
            importer_iec_no = '-1';
        }
        let details = { importer_name: importer_iec_no, importer_iec_no: '-1', flag: 2 }
        JobServices.getImporter(details).then(res => {
            setItemSchemeCodeDetails(res.data);
        })
    }
    const ItemFindImporterCodeChangeHandle = (e) => {
        setItemDialogValues({ ...ItemDialogValues, FindImporterCode: e.target.value });
        var importer_name = '';
        if (e.target.value !== '') {
            importer_name = e.target.value;
        } else {
            importer_name = '-1';
        }
        let details = { importer_name: '-1', importer_iec_no: importer_name, flag: 2 }
        JobServices.getImporter(details).then(res => {
            setItemSchemeCodeDetails(res.data);
        })
    }
    const ItemFindImporterStateChangeHandle = (e) => {
        setItemDialogValues({ ...ItemDialogValues, FindImporterState: e.target.value })
        var importer_name = '';
        if (e.target.value !== '') {
            importer_name = e.target.value;
        } else {
            importer_name = '-1';
        }
        let details = {
            importer_iec_no: ItemDialogValues.ImporterIECCode, importer_name: importer_name,
            branch_sl_no: '-1'
        }
        JobServices.getImporterBranch(details).then(res => {
            setItemSchemeCodeDetails(res.data)
        })
    }
    const ItemFindBranchSr_NOChangeHandle = (e) => {
        setItemDialogValues({ ...ItemDialogValues, FindBranchSr_NO: e.target.value });
        var branch_sl_no = '';
        if (e.target.value !== '') {
            branch_sl_no = e.target.value;
        } else {
            branch_sl_no = '-1';
        }
        let details = {
            importer_iec_no: ItemDialogValues.ImporterIECCode, importer_name: '-1',
            branch_sl_no: branch_sl_no
        }
        JobServices.getImporterBranch(details).then(res => {
            setItemSchemeCodeDetails(res.data)
        })
    }

    const ItemIceGateUserChangeHandle = (e) => {
        setItemDialogValues({ ...ItemDialogValues, iceGateUser: e.target.value })
    }


    /**-----------onClick-DialogBox-Event----------------------e--------------------**/

    const ItemAddSchemeSave = () => {
        if (ItemDialogValues.rate !== '') {
            if (ItemId !== '') {
                setItemSchemeSaveDsa(true);
                setItemSchemeSve(true);
                let details = {
                    schemeCode: ItemDialogValues.scheme_code, excemptionReq: ItemDialogValues.exemptionrequired
                    , notificationNo: ItemDialogValues.notofi_no, notificationSrNo: ItemDialogValues.srl_no, reExport: ItemDialogValues.re_export,
                    sec20: ItemDialogValues.sec_20, itemId: ItemId
                }
                ItemService.import_item_insertItemSchemeCode(details).then(res => {
                    const message = res.data.message;
                    if (message.toString() === 'SUCCESS') {
                        setMessage('Scheme Code Add Successfully');
                        setSeverity('success');
                        setOpenSnack(true);
                        ItemService.getItemSchemeCode(ItemId).then(res => {
                            setItemRitcDetails(res.data)
                        })
                        SchemeCodeReset();
                    } else {
                        setMessage(message.toString());
                        setSeverity('error');
                        setOpenSnack(true);
                        SchemeCodeReset();
                    }
                })
            } else {
                setMessage('ItemId is Missing Please Select Item Table');
                setSeverity('warning');
                setOpenSnack(true);
            }
        } else {
            setMessage('Invalid Notification no');
            setSeverity('warning');
            setOpenSnack(true);
        }
    }

    const ItemAddSchemeUpdate = () => {
        setItemSchemeUpdateDsa(true);
        setItemSchemeUpd(true);
        let details = {
            notificationId: ItemDialogValues.notofi_noId, schemeCode: ItemDialogValues.scheme_code,
            excemptionReq: ItemDialogValues.exemptionrequired, notificationNo: ItemDialogValues.notofi_no,
            notificationSrNo: ItemDialogValues.srl_no, reExport: ItemDialogValues.re_export,
            sec20: ItemDialogValues.sec_20
        }
        ItemService.import_item_updateItemSchemeCode(details).then(res => {
            const message = res.data.message;
            if (message.toString() === 'SUCCESS') {
                setMessage('Scheme Code Update Successfully');
                setSeverity('success');
                setOpenSnack(true);
                ItemService.getItemSchemeCode(ItemId).then(res => {
                    setItemRitcDetails(res.data)
                })
                SchemeCodeReset();
            } else {
                setMessage(message.toString());
                setSeverity('error');
                setOpenSnack(true);
                SchemeCodeReset();
            }
        })
    }

    const ItemAddSchemeDelete = () => {

        ItemService.import_item_deleteItemSchemeCode(ItemDialogValues.notofi_noId).then(res => {
            const message = res.data.message;
            if (message.toString() === 'SUCCESS') {
                setMessage('Scheme Code Delete Successfully');
                setSeverity('success');
                setOpenSnack(true);
                ItemService.getItemSchemeCode(ItemId).then(res => {
                    setItemRitcDetails(res.data)
                })
                SchemeCodeReset();
            } else {
                setMessage(message.toString());
                setSeverity('error');
                setOpenSnack(true);
                SchemeCodeReset();
            }
        })
    }

    const SchemeCodeReset = () => {
        setItemDialogValues({
            ...ItemDialogValues, scheme_code: '', scheme_codeName: '', notofi_no: '', srl_no: '',
            rate: '', exemptionrequired: 'N', re_export: 'N', sec_20: 'N'
        })
        setItemSchemeSaveDsa(false);
        setItemSchemeUpdateDsa(true);
        setItemSchemeDeleteDsa(true);

        setItemSchemeSve(false);
        setItemSchemeUpd(false);
        setItemSchemeDlt(false);
    }

    const ItemAuntiDumbSave = () => {
        var notificationAmount = '';
        if (ItemDialogValues.auntiDump_notifiRate !== '') {
            setItemAuntiDumpSaveDsa(true);
            setItemAuntiDumpSve(true);
            if (ItemDialogValues.auntiDump_spaceAmt !== '') {
                notificationAmount = ItemDialogValues.auntiDump_spaceAmt;
            } else {
                notificationAmount = '0.00'
            }
            let details = {
                itemId: ItemId, notificationType: 'ADN', notificationNo: ItemDialogValues.auntiDump_notn_no,
                notificationSrNo: ItemDialogValues.auntiDump_Srl_no, notificationRate: ItemDialogValues.auntiDump_notifiRate,
                notificationAmount: notificationAmount, notificationUnit: ItemDialogValues.auntiDump_uqc, notificationFlag: ItemDialogValues.auntiDump_flag,
                antiDumpSlNo: ItemDialogValues.auntiDump_cth_srl_no, antiDumpSupplierSlNo: ItemDialogValues.auntiDump_sup_srl_no,
                advaloremRate: ItemDialogValues.auntiDump_advalorem_rate, qty: ItemDialogValues.auntiDump_quantity,
                currency_code: ItemDialogValues.auntiDump_currency, createdBy: getUserId()
            }
            ItemService.insertItemNotificationAntiDumping(details).then(res => {
                const message = res.data.message;
                if (message.toString() === 'SUCCESS') {
                    setMessage('AuntiDumping Add Successfully');
                    setSeverity('success');
                    setOpenSnack(true);
                    AuntiDumpReset();
                } else {
                    setMessage(message.toString());
                    setSeverity('error');
                    setOpenSnack(true);
                    AuntiDumpReset();
                }
                let details = { itemId: ItemId, notificationType: 'ADN' }
                ItemService.getItemNotificationAntiDumping(details).then(res => {
                    setItemRitcDetails(res.data);
                })
            }).catch(error => {
                setMessage(error.message);
                setSeverity('error');
                setOpenSnack(true);
                AuntiDumpReset();
            })
        } else {
            setMessage('Rate should not be empty');
            setSeverity('warning');
            setOpenSnack(true);
            AuntiDumpReset();
        }
    }

    const ItemAuntiDumbUpdate = () => {
        var notificationAmount = '';
        if (ItemDialogValues.auntiDump_notifiRate !== '') {
            setItemAuntiDumpUpdateDsa(true);
            setItemAuntiDumpUpd(true);
            if (ItemDialogValues.auntiDump_spaceAmt !== '') {
                notificationAmount = ItemDialogValues.auntiDump_spaceAmt;
            } else {
                notificationAmount = '0.00'
            }
            let details = {
                notificationId: ItemDialogValues.notofi_noId, notificationType: 'ADN',
                notificationNo: ItemDialogValues.auntiDump_notn_no, notificationSrNo: ItemDialogValues.auntiDump_Srl_no,
                notificationRate: ItemDialogValues.auntiDump_notifiRate, notificationAmount: notificationAmount, notificationUnit: ItemDialogValues.auntiDump_uqc,
                notificationFlag: ItemDialogValues.auntiDump_flag, antiDumpSlNo: ItemDialogValues.auntiDump_cth_srl_no, antiDumpSupplierSlNo: ItemDialogValues.auntiDump_sup_srl_no,
                advaloremRate: ItemDialogValues.auntiDump_advalorem_rate, qty: ItemDialogValues.auntiDump_quantity,
                currency_code: ItemDialogValues.auntiDump_currency, updatedBy: getUserId()
            }
            ItemService.updateItemNotificationAntiDumping(details).then(res => {
                const message = res.data.message;
                if (message.toString() === 'SUCCESS') {
                    setMessage('AuntiDumping Update Successfully');
                    setSeverity('success');
                    setOpenSnack(true);
                    AuntiDumpReset();
                } else {
                    setMessage(message.toString());
                    setSeverity('error');
                    setOpenSnack(true);
                    AuntiDumpReset();
                }
                let details = { itemId: ItemId, notificationType: 'ADN' }
                ItemService.getItemNotificationAntiDumping(details).then(res => {
                    setItemRitcDetails(res.data);
                })
            }).catch(error => {
                setMessage(error.message);
                setSeverity('error');
                setOpenSnack(true);
                AuntiDumpReset();
            })
        } else {
            setMessage('Rate should not be empty');
            setSeverity('warning');
            setOpenSnack(true);
            AuntiDumpReset();
        }
    }
    const ItemAuntiDump_Delet = () => {
        if (window.confirm("Do You Want To Delete This..!")) {
            ItemService.deleteItemNotificationAntiDumping(ItemDialogValues.notofi_noId).then(res => {
                const message = res.data.message;
                if (message.toString() === 'SUCCESS') {
                    setMessage('AuntiDumping Delete Successfully');
                    setSeverity('success');
                    setOpenSnack(true);
                    AuntiDumpReset();
                } else {
                    setMessage(message.toString());
                    setSeverity('error');
                    setOpenSnack(true);
                    AuntiDumpReset();
                }
                let details = { itemId: ItemId, notificationType: 'ADN' }
                ItemService.getItemNotificationAntiDumping(details).then(res => {
                    setItemRitcDetails(res.data);
                })
            }).catch(error => {
                setMessage(error.message);
                setSeverity('error');
                setOpenSnack(true);
                AuntiDumpReset();
            })
        } else {

        }
    }

    const AuntiDumpReset = () => {
        setItemDialogValues({
            ...ItemDialogValues, auntiDump_notn_no: '', auntiDump_Srl_no: '',
            auntiDump_cth_srl_no: '', auntiDump_sup_srl_no: '', auntiDump_advalorem_rate: '0.00', auntiDump_currency: '',
            auntiDump_flag: '', auntiDump_uqc: '', auntiDump_notifiRate: '', auntiDump_quantity: '', auntiDump_spaceAmt: ''
        })
        setItemAuntiDumpSaveDsa(false);
        setItemAuntiDumpUpdateDsa(true);
        setItemAuntiDumpDeleteDsa(true);

        setItemAuntiDumpSve(false);
        setItemAuntiDumpUpd(false);
        setItemAuntiDumpDlt(false);
    }

    const validateInfo = () => {
        if (ItemDialogValues.SwType !== '') {
            if (ItemDialogValues.SwQwalifier !== '') {
                return true;
            }
            else {
                setMessage('Please Select The Sw Qualifier..!!');
                setSeverity('warning');
                setOpenSnack(true);
            }
        }
        else {
            setMessage('Please Select The Sw Info Type..!!')
            setSeverity('warning');
            setOpenSnack(true);
        }
        return false;
    }

    const validateInfoUQC = () => {
        if (ItemDialogValues.SwQwalifier !== 'SQC' && ItemDialogValues.SwQwalifier !== 'sqc') {
            return true;
        }
        else {
            if (ItemDialogValues.Sw_Uqc !== '' && ItemDialogValues.Sw_Uqc !== null) {
                return true;
            }
            else {
                setMessage('Please Select The Sw UQC...!!');
                setSeverity('warning');
                setOpenSnack(true);
            }
        }
        return false;
    }

    const ItemAddSwInfoSave = () => {
        if (validateInfo() === true) {
            if (validateInfoUQC() === true) {
                setItemSwInfoSaveDsa(true);
                setItemSwInfoSve(true)
                var swmsr = ''
                if (ItemDialogValues.sw_mesurnment === '') { swmsr = '0.0' }
                else { swmsr = ItemDialogValues.sw_mesurnment }
                let details = {
                    consignmentId: jobValues.job_no, itemId: ItemId, swType: ItemDialogValues.SwType,
                    swQualifier: ItemDialogValues.SwQwalifier, swCode: ItemDialogValues.SwCode,
                    swtxt: ItemDialogValues.SwText, swInfoMsr: swmsr, unitCode: ItemDialogValues.Sw_Uqc
                }
                ItemService.insertItemSwInfo(details).then(res => {
                    const message = res.data.message;
                    if (message.toString() === 'SUCCESS') {
                        setMessage('SwInfo Add Successfully');
                        setSeverity('success');
                        setOpenSnack(true);
                    } else {
                        setMessage(message.toString());
                        setSeverity('error');
                        setOpenSnack(true);
                    }
                    SwInfoReset();
                    let details2 = { itemId: ItemId, consignmentId: jobValues.job_no }
                    ItemService.getItemSwInfo(details2).then(res => {
                        setItemRitcDetails(res.data)
                    });
                }).catch(error => {
                    setMessage(error.message);
                    setSeverity('error');
                    setOpenSnack(true);
                    SwInfoReset();
                })
            }
        }
    }
    const ItemAddSwInfoUpdate = () => {
        if (validateInfo() === true) {
            if (validateInfoUQC() === true) {
                setItemSwInfoUpdateDsa(true);
                setItemSwInfoUpd(true)
                let details = {
                    notificationId: ItemDialogValues.notofi_noId, swType: ItemDialogValues.SwType,
                    swQualifier: ItemDialogValues.SwQwalifier, swCode: ItemDialogValues.SwCode,
                    swtxt: ItemDialogValues.SwText, swMsr: ItemDialogValues.sw_mesurnment, unitCode: ItemDialogValues.Sw_Uqc
                }
                ItemService.updateItemSwInfo(details).then(res => {
                    const message = res.data.message;
                    if (message.toString() === 'SUCCESS') {
                        setMessage('SwInfo Update Successfully');
                        setSeverity('success');
                        setOpenSnack(true);
                    } else {
                        setMessage(message.toString());
                        setSeverity('error');
                        setOpenSnack(true);
                    }
                    SwInfoReset();
                    let details2 = { itemId: ItemId, consignmentId: jobValues.job_no }
                    ItemService.getItemSwInfo(details2).then(res => {
                        setItemRitcDetails(res.data)
                    });
                }).catch(error => {
                    setMessage(error.message);
                    setSeverity('error');
                    setOpenSnack(true);
                    SwInfoReset();
                })
            }
        }
    }
    const ItemAddSwInfoDelete = () => {
        setItemSwInfoDeleteDsa(true);
        setItemSwInfoDlt(true)
        ItemService.deleteItemSwInfo(ItemDialogValues.notofi_noId).then(res => {
            const message = res.data.message;
            if (message.toString() === 'SUCCESS') {
                setMessage('SwInfo Delet Successfully');
                setSeverity('success');
                setOpenSnack(true);
            } else {
                setMessage(message.toString());
                setSeverity('error');
                setOpenSnack(true);
            }
            SwInfoReset();
            let details2 = { itemId: ItemId, consignmentId: jobValues.job_no }
            ItemService.getItemSwInfo(details2).then(res => {
                setItemRitcDetails(res.data)
            });
        }).catch(error => {
            setMessage(error.message);
            setSeverity('error');
            setOpenSnack(true);
            SwInfoReset();
        })

    }
    const SwInfoReset = () => {
        setItemDialogValues({
            ...ItemDialogValues, SwType: 'CHR', SwQwalifier: 'SQC'
            , SwCode: '', SwText: '', sw_mesurnment: ''
        });
        setItemSwInfoSaveDsa(false);
        setItemSwInfoUpdateDsa(true);
        setItemSwInfoDeleteDsa(true);

        setItemSwInfoSve(false)
        setItemSwInfoUpd(false)
        setItemSwInfoDlt(false)
    }

    const ItemAddLicenceSave = () => {
        setItemSwInfoSaveDsa(true);
        setItemSwInfoSve(true)
        let details = {
            itemId: ItemId, debitValue: ItemDialogValues.debit_value, debitQty: ItemDialogValues.debit_quantity,
            unitCode: ItemDialogValues.Sw_Uqc, licenceRegNo: ItemDialogValues.licence_reg_no, licenceCode: ItemDialogValues.licence_code,
            licenceRegDate: ItemDialogValues.licence_Date, customPointCode: ItemDialogValues.licence_reg_port, traNo: ItemDialogValues.tra_no,
            traDate: ItemDialogValues.tra_date, debitDuty: ItemDialogValues.debit_duty, licenceSrNo: ItemDialogValues.Licence_item_srlNo
        }
        ItemService.insertItemLicenceDetails(details).then(res => {
            const message = res.data.message;
            if (message.toString() === 'SUCCESS') {
                setMessage('Licence Add Successfully');
                setSeverity('success');
                setOpenSnack(true);
            } else {
                setMessage(message.toString());
                setSeverity('error');
                setOpenSnack(true);
            }
            LicenceReset();
            let detailslice = { itemId: ItemId }
            ItemService.getLicenceDetails(detailslice).then(res => {
                setItemRitcDetails(res.data);
            })
        }).catch(error => {
            setMessage(error.message);
            setSeverity('error');
            setOpenSnack(true);
            LicenceReset();
        })
    }
    const ItemAddLicenceUpdate = () => {
        setItemSwInfoUpdateDsa(true);
        setItemSwInfoUpd(true)
        let details = {
            notificationId: ItemDialogValues.notofi_noId, debitValue: ItemDialogValues.debit_value,
            debitQty: ItemDialogValues.debit_quantity, unitCode: ItemDialogValues.Sw_Uqc, licenceRegNo: ItemDialogValues.licence_reg_no,
            licenceCode: ItemDialogValues.licence_code, licenceRegDate: ItemDialogValues.licence_Date, customPointCode: ItemDialogValues.licence_reg_port,
            traNo: ItemDialogValues.tra_no, traDate: ItemDialogValues.tra_date, debitDuty: ItemDialogValues.debit_duty,
            licenceSrNo: ItemDialogValues.Licence_item_srlNo
        }
        ItemService.updateItemLicenceDetails(details).then(res => {
            const message = res.data.message;
            if (message.toString() === 'SUCCESS') {
                setMessage('Licence Update Successfully');
                setSeverity('success');
                setOpenSnack(true);
            } else {
                setMessage(message.toString());
                setSeverity('error');
                setOpenSnack(true);
            }
            LicenceReset();
            let detailslice = { itemId: ItemId }
            ItemService.getLicenceDetails(detailslice).then(res => {
                setItemRitcDetails(res.data);
            })
        }).catch(error => {
            setMessage(error.message);
            setSeverity('error');
            setOpenSnack(true);
            LicenceReset();
        })
    }
    const ItemAddLicenceDelete = () => {
        setItemSwInfoDeleteDsa(true);
        setItemSwInfoDlt(true)

        ItemService.deleteItemLicenceDetails(ItemDialogValues.notofi_noId).then(res => {
            const message = res.data.message;
            if (message.toString() === 'SUCCESS') {
                setMessage('Licence Delete Successfully');
                setSeverity('success');
                setOpenSnack(true);
            } else {
                setMessage(message.toString());
                setSeverity('error');
                setOpenSnack(true);
            }
            LicenceReset();
            let detailslice = { itemId: ItemId }
            ItemService.getLicenceDetails(detailslice).then(res => {
                setItemRitcDetails(res.data);
            })
        }).catch(error => {
            setMessage(error.message);
            setSeverity('error');
            setOpenSnack(true);
            LicenceReset();
        })
    }

    const LicenceReset = () => {
        setItemDialogValues({
            ...ItemDialogValues, licence_reg_no: '', licence_code: '',
            licence_Date: '', licence_reg_port: '', debit_duty: '0.00', Sw_Uqc: ItemValues.txt_unit,
            debit_value: '0.00', debit_quantity: ItemValues.txt_quantity, tra_no: '', tra_date: '',
            notofi_noId: '', Licence_item_srlNo: ''
        })
        setItemSwInfoSaveDsa(false); setItemSwInfoUpdateDsa(true); setItemSwInfoDeleteDsa(true);
        setItemSwInfoSve(false); setItemSwInfoUpd(false); setItemSwInfoDlt(false);
    }

    const validateConstituent = () => {
        if (ItemDialogValues.constituent_code !== '') {
            if (ItemDialogValues.constituent_name !== '') {
                if (ItemDialogValues.constituentSl_no !== '') {
                    return true;
                }
                else {
                    setMessage('Please Enter The Consituent Sr No..!!');
                    setSeverity('warning');
                    setOpenSnack(true);
                }
            }
            else {
                setMessage('Please Enter The Consituent Name..!!');
                setSeverity('warning');
                setOpenSnack(true);
            }
        }
        else {
            setMessage('Please Enter The Consituent Code..!!');
            setSeverity('warning');
            setOpenSnack(true);
        }
        return false;
    }

    const ItemAddSWConstituentSave = () => {
        if (validateConstituent() === true) {
            setItemSwInfoSaveDsa(true);
            setItemSwInfoSve(true);
            let swDetails = {
                consignmentId: jobValues.job_no, itemId: ItemId, srNo: ItemDialogValues.constituentSl_no,
                consName: ItemDialogValues.constituent_name, consCode: ItemDialogValues.constituent_code,
                consPerc: ItemDialogValues.const_percentage, consYieldPerc: ItemDialogValues.yield_percentage,
                consActive: ItemDialogValues.active_indredient
            }
            ItemService.insertItemSwConstituent(swDetails).then(res => {
                const message = res.data.message;
                if (message.toString() === 'SUCCESS') {
                    setMessage('SwConstituent Add Successfully');
                    setSeverity('success');
                    setOpenSnack(true);
                } else {
                    setMessage(message.toString());
                    setSeverity('error');
                    setOpenSnack(true);
                }
                ItemAddSWConstituentReset();
                let detailslice = { itemId: ItemId }
                ItemService.getSwConstitunet(detailslice).then(res => {
                    setItemRitcDetails(res.data);
                })
            }).catch(error => {
                setMessage(error.message);
                setSeverity('error');
                setOpenSnack(true);
                ItemAddSWConstituentReset();
            })
        }
    }
    const ItemAddSWConstituentUpdate = () => {
        if (validateConstituent() === true) {
            setItemSwInfoUpdateDsa(true);
            setItemSwInfoUpd(true);
            let swDetails = {
                itemId: ItemDialogValues.notofi_noId, srNo: ItemDialogValues.constituentSl_no,
                consName: ItemDialogValues.constituent_name, consCode: ItemDialogValues.constituent_code,
                consPerc: ItemDialogValues.const_percentage, consYieldPerc: ItemDialogValues.yield_percentage,
                consActive: ItemDialogValues.active_indredient
            }
            ItemService.updateItemSwConstituent(swDetails).then(res => {
                const message = res.data.message;
                if (message.toString() === 'SUCCESS') {
                    setMessage('SwConstituent Update Successfully');
                    setSeverity('success');
                    setOpenSnack(true);
                } else {
                    setMessage(message.toString());
                    setSeverity('error');
                    setOpenSnack(true);
                }
                ItemAddSWConstituentReset();
                let detailslice = { itemId: ItemId }
                ItemService.getSwConstitunet(detailslice).then(res => {
                    setItemRitcDetails(res.data);
                })
            }).catch(error => {
                setMessage(error.message);
                setSeverity('error');
                setOpenSnack(true);
                ItemAddSWConstituentReset();
            })
        }
    }
    const ItemAddSWConstituentDelete = () => {
        setItemSwInfoDeleteDsa(true);
        setItemSwInfoDlt(true);
        ItemService.deleteItemSwConstituent(ItemDialogValues.notofi_noId).then(res => {
            const message = res.data.message;
            if (message.toString() === 'SUCCESS') {
                setMessage('SwConstituent Delete Successfully');
                setSeverity('success');
                setOpenSnack(true);
            } else {
                setMessage(message.toString());
                setSeverity('error');
                setOpenSnack(true);
            }
            ItemAddSWConstituentReset();
            let detailslice = { itemId: ItemId }
            ItemService.getSwConstitunet(detailslice).then(res => {
                setItemRitcDetails(res.data);
            })
        }).catch(error => {
            setMessage(error.message);
            setSeverity('error');
            setOpenSnack(true);
            ItemAddSWConstituentReset();
        })
    }
    const ItemAddSWConstituentReset = () => {
        setItemDialogValues({
            ...ItemDialogValues, constituentSl_no: '', constituent_name: '', notofi_noId: '',
            constituent_code: '', const_percentage: '0.00', yield_percentage: '0.00', active_indredient: 'N'
        })
        setItemSwInfoSaveDsa(false);
        setItemSwInfoUpdateDsa(true);
        setItemSwInfoDeleteDsa(true);

        setItemSwInfoSve(false)
        setItemSwInfoUpd(false)
        setItemSwInfoDlt(false)
    }

    const ItemAddRSPSave = () => {
        setItemSwInfoSaveDsa(true);
        setItemSwInfoSve(true);
        let Details = {
            itemId: ItemId, notificationNo: ItemDialogValues.rsp_notnNo,
            notificationSrNo: ItemDialogValues.rsp_notnSlNo, notificationRate: ItemDialogValues.rsp_rate
            , notificationAmount: ItemDialogValues.rsp_amount, qty: ItemDialogValues.rsp_quantity,
            item_description: ItemDialogValues.rsp_description
        }
        ItemService.insertItemRSP(Details).then(res => {
            const message = res.data.message;
            if (message.toString() === 'SUCCESS') {
                setMessage('RSP Add Successfully');
                setSeverity('success');
                setOpenSnack(true);
            } else {
                setMessage(message.toString());
                setSeverity('error');
                setOpenSnack(true);
            }
            ItemAddRspReset();
            let detailslice = { itemId: ItemId }
            ItemService.getItemRSP(detailslice).then(res => {
                setItemRitcDetails(res.data);
            })
        }).catch(error => {
            setMessage(error.message);
            setSeverity('error');
            setOpenSnack(true);
            ItemAddRspReset();
        })
    }

    const ItemAddRspUpdate = () => {
        setItemSwInfoUpdateDsa(true);
        setItemSwInfoUpd(true);
        let Details = {
            otificationId: ItemDialogValues.notofi_noId, notificationNo: ItemDialogValues.rsp_notnNo,
            notificationSrNo: ItemDialogValues.rsp_notnSlNo, notificationRate: ItemDialogValues.rsp_rate
            , notificationAmount: ItemDialogValues.rsp_amount, qty: ItemDialogValues.rsp_quantity,
            item_description: ItemDialogValues.rsp_description
        }
        ItemService.updateItemRSP(Details).then(res => {
            const message = res.data.message;
            if (message.toString() === 'SUCCESS') {
                setMessage('RSP Update Successfully');
                setSeverity('success');
                setOpenSnack(true);
            } else {
                setMessage(message.toString());
                setSeverity('error');
                setOpenSnack(true);
            }
            ItemAddRspReset();
            let detailslice = { itemId: ItemId }
            ItemService.getItemRSP(detailslice).then(res => {
                setItemRitcDetails(res.data);
            })
        }).catch(error => {
            setMessage(error.message);
            setSeverity('error');
            setOpenSnack(true);
            ItemAddRspReset();
        })
    }

    const ItemAddRspDelete = () => {
        setItemSwInfoDeleteDsa(true);
        setItemSwInfoDlt(true);
        ItemService.deleteItemRSP(ItemDialogValues.notofi_noId).then(res => {
            const message = res.data.message;
            if (message.toString() === 'SUCCESS') {
                setMessage('RSP Delete Successfully');
                setSeverity('success');
                setOpenSnack(true);
            } else {
                setMessage(message.toString());
                setSeverity('error');
                setOpenSnack(true);
            }
            ItemAddRspReset();
            let detailslice = { itemId: ItemId }
            ItemService.getItemRSP(detailslice).then(res => {
                setItemRitcDetails(res.data);
            })
        }).catch(error => {
            setMessage(error.message);
            setSeverity('error');
            setOpenSnack(true);
            ItemAddRspReset();
        })
    }

    const ItemAddRspReset = () => {
        setItemDialogValues({
            ...ItemDialogValues, rsp_notnNo: '', rsp_notnSlNo: '', rsp_amount: '',
            rsp_description: ItemValues.txt_item_Desc, rsp_quantity: ItemValues.txt_quantity,
            rsp_rate: '0.00', notofi_noId: ''
        })
        setItemSwInfoSaveDsa(false);
        setItemSwInfoUpdateDsa(true);
        setItemSwInfoDeleteDsa(true);

        setItemSwInfoSve(false)
        setItemSwInfoUpd(false)
        setItemSwInfoDlt(false)
    }

    const ItemAddRe_importSave = () => {
        setItemSwInfoSaveDsa(true);
        setItemSwInfoSve(true);
        let details = {
            itemId: ItemId, previousSbNo: ItemDialogValues.r_iPrivousSbNo, previousSbDate: ItemDialogValues.r_iPrivousSbdate,
            customPointCode: ItemDialogValues.r_iPort_of_export, invoiceNoSb: ItemDialogValues.r_iInvoiceNo_sb,
            itemNoSb: ItemDialogValues.r_iItemNo_sb, notificationNo: ItemDialogValues.r_iNotificationNo, notificationSrNo: ItemDialogValues.r_iNotificationSrlNo,
            freightAmount: ItemDialogValues.r_iExportFright, insuranceAmount: ItemDialogValues.r_iExportInsurance, customDutyAmount: ItemDialogValues.r_iCustomDuty,
            exciseAmount: ItemDialogValues.r_iExciseDuty
        }
        ItemService.insertItemReimport(details).then(res => {
            const message = res.data.message;
            if (message.toString() === 'SUCCESS') {
                setMessage('Re-Import Add Successfully');
                setSeverity('success');
                setOpenSnack(true);
            } else {
                setMessage(message.toString());
                setSeverity('error');
                setOpenSnack(true);
            }
            ItemAddRe_importReset();
            let detailslice = { itemId: ItemId }
            ItemService.getItemReimport(detailslice).then(res => {
                setItemRitcDetails(res.data);
            })
        }).catch(error => {
            setMessage(error.message);
            setSeverity('error');
            setOpenSnack(true);
            ItemAddRe_importReset();
        })
    }
    const ItemAddRe_importUpdate = () => {
        setItemSwInfoUpdateDsa(true);
        setItemSwInfoUpd(true);
        let details = {
            notificationId: ItemDialogValues.notofi_noId, previousSbNo: ItemDialogValues.r_iPrivousSbNo, previousSbDate: ItemDialogValues.r_iPrivousSbdate,
            customPointCode: ItemDialogValues.r_iPort_of_export, invoiceNoSb: ItemDialogValues.r_iInvoiceNo_sb,
            itemNoSb: ItemDialogValues.r_iItemNo_sb, notificationNo: ItemDialogValues.r_iNotificationNo, notificationSrNo: ItemDialogValues.r_iNotificationSrlNo,
            freightAmount: ItemDialogValues.r_iExportFright, insuranceAmount: ItemDialogValues.r_iExportInsurance, customDutyAmount: ItemDialogValues.r_iCustomDuty,
            exciseAmount: ItemDialogValues.r_iExciseDuty
        }
        ItemService.updateItemReimport(details).then(res => {
            const message = res.data.message;
            if (message.toString() === 'SUCCESS') {
                setMessage('Re-Import Update Successfully');
                setSeverity('success');
                setOpenSnack(true);
            } else {
                setMessage(message.toString());
                setSeverity('error');
                setOpenSnack(true);
            }
            ItemAddRe_importReset();
            let detailslice = { itemId: ItemId }
            ItemService.getItemReimport(detailslice).then(res => {
                setItemRitcDetails(res.data);
            })
        }).catch(error => {
            setMessage(error.message);
            setSeverity('error');
            setOpenSnack(true);
            ItemAddRe_importReset();
        })
    }
    const ItemAddRe_importDelete = () => {
        setItemSwInfoDeleteDsa(true);
        setItemSwInfoDlt(true);
        ItemService.deleteItemReimport(ItemDialogValues.notofi_noId).then(res => {
            const message = res.data.message;
            if (message.toString() === 'SUCCESS') {
                setMessage('Re-Import Delete Successfully');
                setSeverity('success');
                setOpenSnack(true);
            } else {
                setMessage(message.toString());
                setSeverity('error');
                setOpenSnack(true);
            }
            ItemAddRe_importReset();
            let detailslice = { itemId: ItemId }
            ItemService.getItemReimport(detailslice).then(res => {
                setItemRitcDetails(res.data);
            })
        }).catch(error => {
            setMessage(error.message);
            setSeverity('error');
            setOpenSnack(true);
            ItemAddRe_importReset();
        })
    }

    const ItemAddRe_importReset = () => {
        setItemDialogValues({
            ...ItemDialogValues, r_iPrivousSbNo: '', r_iPrivousSbdate: '', r_iPort_of_export: '',
            r_iInvoiceNo_sb: '', r_iItemNo_sb: '', r_iNotificationNo: '', r_iNotificationSrlNo: '', r_iExportFright: '0.00',
            r_iExportInsurance: '0.00', r_iCustomDuty: '0.00', r_iExciseDuty: '0.00', notofi_noId: ''
        })
        setItemSwInfoSaveDsa(false);
        setItemSwInfoUpdateDsa(true);
        setItemSwInfoDeleteDsa(true);

        setItemSwInfoSve(false)
        setItemSwInfoUpd(false)
        setItemSwInfoDlt(false)
    }

    const ItemAddNCDdutySave = () => {
        setItemSwInfoSaveDsa(false);
        setItemSwInfoSve(false)
        if (ItemDialogValues.ncdDuty_rate !== '') {
            var notificationAmount = '';
            if (ItemDialogValues.ncdDuty_amount !== '') {
                notificationAmount = ItemDialogValues.ncdDuty_amount;
            } else {
                notificationAmount = '0.00';
            }
            let details = {
                itemId: ItemId, notificationRate: ItemDialogValues.ncdDuty_rate, notificationType: 'NCD',
                notificationNo: ItemDialogValues.ncdDuty_notn_no, notificationSrNo: ItemDialogValues.ncdDuty_notn_slNo,
                notificationAmount: notificationAmount, notificationUnit: ItemDialogValues.ncdDuty_UQC,
                notificationFlag: ItemDialogValues.ncdDuty_flag, createdBy: getUserId()
            }
            ItemService.insertItemNotificationMultible(details).then(res => {
                const message = res.data.message;
                if (message.toString() === 'SUCCESS') {
                    setMessage('NCD Add Successfully');
                    setSeverity('success');
                    setOpenSnack(true);
                } else {
                    setMessage(message.toString());
                    setSeverity('error');
                    setOpenSnack(true);
                }
                ItemAddNCDdutyReset();
                let detailslice = { itemId: ItemId, notificationType: 'NCD', flag: 1 }
                ItemService.getItemNotification(detailslice).then(res => {
                    setItemRitcDetails(res.data);
                })
            }).catch(error => {
                setMessage(error.message);
                setSeverity('error');
                setOpenSnack(true);
                ItemAddNCDdutyReset();
            })
        } else {
            setMessage('Rate should not be empty');
            setSeverity('warning');
            setOpenSnack(true);
            ItemAddNCDdutyReset();
        }
    }
    const ItemAddNCDdutyUpdate = () => {
        setItemSwInfoUpdateDsa(false);
        setItemSwInfoUpd(false)
        if (ItemDialogValues.ncdDuty_rate !== '') {
            var notificationAmount = '';
            if (ItemDialogValues.ncdDuty_amount !== '') {
                notificationAmount = ItemDialogValues.ncdDuty_amount;
            } else {
                notificationAmount = '0.00';
            }
            let details = {
                notificationId: ItemDialogValues.notofi_noId, notificationRate: ItemDialogValues.ncdDuty_rate, notificationType: 'NCD',
                notificationNo: ItemDialogValues.ncdDuty_notn_no, notificationSrNo: ItemDialogValues.ncdDuty_notn_slNo,
                notificationAmount: notificationAmount, notificationUnit: ItemDialogValues.ncdDuty_UQC,
                notificationFlag: ItemDialogValues.ncdDuty_flag, updatedBy: getUserId()
            }
            ItemService.updateItemNotification(details).then(res => {
                const message = res.data.message;
                if (message.toString() === 'SUCCESS') {
                    setMessage('NCD Update Successfully');
                    setSeverity('success');
                    setOpenSnack(true);
                } else {
                    setMessage(message.toString());
                    setSeverity('error');
                    setOpenSnack(true);
                }
                ItemAddNCDdutyReset();
                let detailslice = { itemId: ItemId, notificationType: 'NCD', flag: 1 }
                ItemService.getItemNotification(detailslice).then(res => {
                    setItemRitcDetails(res.data);
                })
            }).catch(error => {
                setMessage(error.message);
                setSeverity('error');
                setOpenSnack(true);
                ItemAddNCDdutyReset();
            })
        } else {
            setMessage('Rate should not be empty');
            setSeverity('warning');
            setOpenSnack(true);
            ItemAddNCDdutyReset();
        }

    }
    const ItemAddNCDdutyDelete = () => {
        setItemSwInfoDeleteDsa(false);
        setItemSwInfoDlt(false)
        if (ItemDialogValues.ncdDuty_rate !== '') {
            ItemService.deleteItemNotification(ItemDialogValues.notofi_noId).then(res => {
                const message = res.data.message;
                if (message.toString() === 'SUCCESS') {
                    setMessage('NCD Delete Successfully');
                    setSeverity('success');
                    setOpenSnack(true);
                } else {
                    setMessage(message.toString());
                    setSeverity('error');
                    setOpenSnack(true);
                }
                ItemAddNCDdutyReset();
                let detailslice = { itemId: ItemId, notificationType: 'NCD', flag: 1 }
                ItemService.getItemNotification(detailslice).then(res => {
                    setItemRitcDetails(res.data);
                })
            }).catch(error => {
                setMessage(error.message);
                setSeverity('error');
                setOpenSnack(true);
                ItemAddNCDdutyReset();
            })
        } else {
            setMessage('Select IGST from the List');
            setSeverity('warning');
            setOpenSnack(true);
            ItemAddNCDdutyReset();
        }

    }
    const ItemAddNCDdutyReset = () => {
        setItemDialogValues({
            ...ItemDialogValues, ncdDuty_notn_no: '', ncdDuty_notn_slNo: '', ncdDuty_rate: '',
            ncdDuty_amount: '', ncdDuty_flag: '', ncdDuty_UQC: '', notofi_noId: ''
        })
        setItemSwInfoSaveDsa(false);
        setItemSwInfoUpdateDsa(true);
        setItemSwInfoDeleteDsa(true);

        setItemSwInfoSve(false)
        setItemSwInfoUpd(false)
        setItemSwInfoDlt(false)
    }

    const ItemProdectionSave = () => {
        setItemSwInfoSaveDsa(true);
        setItemSwInfoSve(true);
        var unitCode, prodManDate, prodExpiryDate, prodBestDate = '';
        if (ItemDialogValues.Sw_Uqc !== '') {
            unitCode = ItemDialogValues.Sw_Uqc;
        } else {
            unitCode = null;
        }
        if (ItemDialogValues.swProd_manufacture !== '') {
            prodManDate = ItemDialogValues.swProd_manufacture;
        } else {
            prodManDate = null;
        }
        if (ItemDialogValues.swprod_expiryDate !== '') {
            prodExpiryDate = ItemDialogValues.swprod_expiryDate;
        } else {
            prodExpiryDate = null;
        }
        if (ItemDialogValues.swProd_beforeDate !== '') {
            prodBestDate = ItemDialogValues.swProd_beforeDate;
        } else {
            prodBestDate = null;
        }
        let details = {
            itemId: ItemId, consignmentId: jobValues.job_no, prodIdentifier: ItemDialogValues.swProd_prodIdtifier,
            prodQty: ItemDialogValues.swprod_Quantity, unitCode: unitCode, prodManDate: prodManDate,
            prodExpiryDate: prodExpiryDate, prodBestDate: prodBestDate
        }
        ItemService.import_item_insertItemSwProduction(details).then(res => {
            const message = res.data.message;
            if (message.toString() === 'SUCCESS') {
                setMessage('Production Add Successfully');
                setSeverity('success');
                setOpenSnack(true);
            } else {
                setMessage(message.toString());
                setSeverity('error');
                setOpenSnack(true);
            }
            ItemAddProdectionReset();
            let detailslice = { itemId: ItemId, consignmentId: jobValues.job_no }
            ItemService.getSwProduction(detailslice).then(res => {
                setItemRitcDetails(res.data);
            })
        }).catch(error => {
            setMessage(error.message);
            setSeverity('error');
            setOpenSnack(true);
            ItemAddProdectionReset();
        })
    }
    const ItemAddProdectionUpdate = () => {
        setItemSwInfoUpdateDsa(true);
        setItemSwInfoUpd(true);
        var unitCode, prodManDate, prodExpiryDate, prodBestDate = '';
        if (ItemDialogValues.Sw_Uqc !== '') {
            unitCode = ItemDialogValues.Sw_Uqc;
        } else {
            unitCode = null;
        }
        if (ItemDialogValues.swProd_manufacture !== '') {
            prodManDate = ItemDialogValues.swProd_manufacture;
        } else {
            prodManDate = null;
        }
        if (ItemDialogValues.swprod_expiryDate !== '') {
            prodExpiryDate = ItemDialogValues.swprod_expiryDate;
        } else {
            prodExpiryDate = null;
        }
        if (ItemDialogValues.swProd_beforeDate !== '') {
            prodBestDate = ItemDialogValues.swProd_beforeDate;
        } else {
            prodBestDate = null;
        }
        let details = {
            itemId: ItemDialogValues.notofi_noId, prodIdentifier: ItemDialogValues.swProd_prodIdtifier,
            prodQty: ItemDialogValues.swprod_Quantity, unitCode: unitCode, prodManDate: prodManDate,
            prodExpiryDate: prodExpiryDate, prodBestDate: prodBestDate
        }
        ItemService.import_item_updateItemSwProduction(details).then(res => {
            const message = res.data.message;
            if (message.toString() === 'SUCCESS') {
                setMessage('Production Update Successfully');
                setSeverity('success');
                setOpenSnack(true);
            } else {
                setMessage(message.toString());
                setSeverity('error');
                setOpenSnack(true);
            }
            ItemAddProdectionReset();
            let detailslice = { itemId: ItemId, consignmentId: jobValues.job_no }
            ItemService.getSwProduction(detailslice).then(res => {
                setItemRitcDetails(res.data);
            })
        }).catch(error => {
            setMessage(error.message);
            setSeverity('error');
            setOpenSnack(true);
            ItemAddProdectionReset();
        })
    }
    const ItemAddProdectionDelete = () => {
        setItemSwInfoDeleteDsa(true);
        setItemSwInfoDlt(true);
        ItemService.import_item_deleteItemSwProduction(ItemDialogValues.notofi_noId).then(res => {
            const message = res.data.message;
            if (message.toString() === 'SUCCESS') {
                setMessage('Production Delete Successfully');
                setSeverity('success');
                setOpenSnack(true);
            } else {
                setMessage(message.toString());
                setSeverity('error');
                setOpenSnack(true);
            }
            ItemAddProdectionReset();
            let detailslice = { itemId: ItemId, consignmentId: jobValues.job_no }
            ItemService.getSwProduction(detailslice).then(res => {
                setItemRitcDetails(res.data);
            })
        }).catch(error => {
            setMessage(error.message);
            setSeverity('error');
            setOpenSnack(true);
            ItemAddProdectionReset();
        })
    }

    const ItemAddProdectionReset = () => {
        setItemDialogValues({
            ...ItemDialogValues, ncdDuty_notn_no: '', swProd_prodIdtifier: '', swprod_Quantity: '',
            Sw_Uqc: '', swProd_manufacture: '', swprod_expiryDate: '', swProd_beforeDate: ''
        })
        setItemSwInfoSaveDsa(false);
        setItemSwInfoUpdateDsa(true);
        setItemSwInfoDeleteDsa(true);

        setItemSwInfoSve(false)
        setItemSwInfoUpd(false)
        setItemSwInfoDlt(false)
    }
    const ItemManufactureSave = () => {
        setItemSwInfoSaveDsa(true);
        setItemSwInfoSve(true);
        let details = {
            itemId: ItemId, name: ItemDialogValues.mnfctr_manufactureName, address: ItemDialogValues.mnfctr_adress,
            city: ItemDialogValues.mnfctr_manufactureCity, pincode: ItemDialogValues.mnfctr_pincode, division: ItemDialogValues.mnfctr_division,
            countryIdString: ItemDialogValues.mnfctr_country
        }
        ItemService.import_item_insertManufacture(details).then(res => {
            const message = res.data.message;
            if (message.toString() === 'SUCCESS') {
                setMessage('Manufacture Add Successfully');
                setSeverity('success');
                setOpenSnack(true);
            } else {
                setMessage(message.toString());
                setSeverity('error');
                setOpenSnack(true);
            }
            ItemAddManufactureReset();
            let details2 = { itemId: ItemId }
            ItemService.import_item_getManufacture(details2).then(res => {
                setItemRitcDetails(res.data);
            })
        }).catch(error => {
            setMessage(error.message);
            setSeverity('error');
            setOpenSnack(true);
            ItemAddManufactureReset();
        })
    }
    const ItemAddManufactureUpdate = () => {
        setItemSwInfoUpdateDsa(true);
        setItemSwInfoUpd(true);
        let details = {
            manufactureId: ItemDialogValues.mnfctr_manufactureId, name: ItemDialogValues.mnfctr_manufactureName, address: ItemDialogValues.mnfctr_adress,
            city: ItemDialogValues.mnfctr_manufactureCity, pincode: ItemDialogValues.mnfctr_pincode, division: ItemDialogValues.mnfctr_division,
            countryIdString: ItemDialogValues.mnfctr_country
        }
        ItemService.import_item_updateManufacture(details).then(res => {
            const message = res.data.message;
            if (message.toString() === 'SUCCESS') {
                setMessage('Manufacture Update Successfully');
                setSeverity('success');
                setOpenSnack(true);
            } else {
                setMessage(message.toString());
                setSeverity('error');
                setOpenSnack(true);
            }
            ItemAddManufactureReset();
            let details2 = { itemId: ItemId }
            ItemService.import_item_getManufacture(details2).then(res => {
                setItemRitcDetails(res.data);
            })
        }).catch(error => {
            setMessage(error.message);
            setSeverity('error');
            setOpenSnack(true);
            ItemAddManufactureReset();
        })
    }
    const ItemAddManufactureDelete = () => {
        setItemSwInfoDeleteDsa(true);
        setItemSwInfoDlt(true);
        ItemService.import_item_deleteManufacture(ItemDialogValues.mnfctr_manufactureId).then(res => {
            const message = res.data.message;
            if (message.toString() === 'SUCCESS') {
                setMessage('Manufacture Delete Successfully');
                setSeverity('success');
                setOpenSnack(true);
            } else {
                setMessage(message.toString());
                setSeverity('error');
                setOpenSnack(true);
            }
            ItemAddManufactureReset();
            let details2 = { itemId: ItemId }
            ItemService.import_item_getManufacture(details2).then(res => {
                setItemRitcDetails(res.data);
            })
        }).catch(error => {
            setMessage(error.message);
            setSeverity('error');
            setOpenSnack(true);
            ItemAddManufactureReset();
        })
    }
    const ItemAddManufactureReset = () => {
        setItemDialogValues({
            ...ItemDialogValues, mnfctr_manufactureId: '', mnfctr_manufactureName: invoicevalues.SupplierName,
            mnfctr_country: invoicevalues.disable_supcountry_Name, mnfctr_adress: invoicevalues.Address1, mnfctr_manufactureCity: '',
            mnfctr_pincode: invoicevalues.PinCode, mnfctr_division: ''
        });
        setItemSwInfoSaveDsa(false);
        setItemSwInfoUpdateDsa(true);
        setItemSwInfoDeleteDsa(true);

        setItemSwInfoSve(false)
        setItemSwInfoUpd(false)
        setItemSwInfoDlt(false)
    }

    const ItemCustmExmpSave = () => {
        if (ItemDialogValues.custm_rate !== '') {
            setItemSwInfoSaveDsa(true);
            setItemSwInfoSve(true);
            let details = {
                itemId: ItemId, notificationType: 'GSE', notificationNo: ItemDialogValues.custm_notfiNo,
                notificationSrNo: ItemDialogValues.custm_Sl_No, notificationRate: ItemDialogValues.custm_rate,
                notificationAmount: ItemDialogValues.custm_amount, notificationUnit: ItemDialogValues.custm_uqc,
                notificationFlag: ItemDialogValues.custm_flag
            }
            ItemService.insertItemNotificationMultible(details).then(res => {
                const message = res.data.message;
                if (message.toString() === 'SUCCESS') {
                    setMessage('CustomNotn Exemption Add Successfully');
                    setSeverity('success');
                    setOpenSnack(true);
                } else {
                    setMessage(message.toString());
                    setSeverity('error');
                    setOpenSnack(true);
                }
                ItemAddCustmExmpNotnNoReset();
                let details2 = { itemId: ItemId, notificationType: 'GSE', flag: 1 }
                ItemService.getItemNotification(details2).then(res => {
                    setItemRitcDetails(res.data);
                })
            }).catch(error => {
                setMessage(error.message);
                setSeverity('error');
                setOpenSnack(true);
                ItemAddCustmExmpNotnNoReset();
            })
        } else {
            setMessage('Rate Should not be Empty');
            setSeverity('warning');
            setOpenSnack(true);
        }
    }
    const ItemAddCustmNotnExmpUpdate = () => {
        if (ItemDialogValues.custm_rate !== '') {
            setItemSwInfoUpdateDsa(true);
            setItemSwInfoUpd(true);
            let details = {
                notificationId: ItemDialogValues.notofi_noId, notificationType: 'GSE', notificationNo: ItemDialogValues.custm_notfiNo,
                notificationSrNo: ItemDialogValues.custm_Sl_No, notificationRate: ItemDialogValues.custm_rate,
                notificationAmount: ItemDialogValues.custm_amount, notificationUnit: ItemDialogValues.custm_uqc,
                notificationFlag: ItemDialogValues.custm_flag, updatedBy: getUserId()
            }
            ItemService.updateItemNotification(details).then(res => {
                const message = res.data.message;
                if (message.toString() === 'SUCCESS') {
                    setMessage('CustomNotn Exemption Update Successfully');
                    setSeverity('success');
                    setOpenSnack(true);
                } else {
                    setMessage(message.toString());
                    setSeverity('error');
                    setOpenSnack(true);
                }
                ItemAddCustmExmpNotnNoReset();
                let details2 = { itemId: ItemId, notificationType: 'GSE', flag: 1 }
                ItemService.getItemNotification(details2).then(res => {
                    setItemRitcDetails(res.data);
                })
            }).catch(error => {
                setMessage(error.message);
                setSeverity('error');
                setOpenSnack(true);
                ItemAddCustmExmpNotnNoReset();
            })
        } else {
            setMessage('Rate Should not be Empty');
            setSeverity('warning');
            setOpenSnack(true);
        }
    }
    const ItemAddCustmnotnExmpDelete = () => {
        setItemSwInfoDeleteDsa(true);
        setItemSwInfoDlt(true);
        ItemService.deleteItemNotification(ItemDialogValues.notofi_noId).then(res => {
            const message = res.data.message;
            if (message.toString() === 'SUCCESS') {
                setMessage('CustomNotn Exemption Delete Successfully');
                setSeverity('success');
                setOpenSnack(true);
            } else {
                setMessage(message.toString());
                setSeverity('error');
                setOpenSnack(true);
            }
            ItemAddCustmExmpNotnNoReset();
            let details2 = { itemId: ItemId, notificationType: 'GSE', flag: 1 }
            ItemService.getItemNotification(details2).then(res => {
                setItemRitcDetails(res.data);
            })
        }).catch(error => {
            setMessage(error.message);
            setSeverity('error');
            setOpenSnack(true);
            ItemAddCustmExmpNotnNoReset();
        })
    }

    const ItemAddCustmExmpNotnNoReset = () => {
        setItemDialogValues({
            ...ItemDialogValues, custm_notfiNo: '', custm_Sl_No: '', custm_rate: '', custm_flag: '',
            custm_amount: '', custm_uqc: '', notofi_noId: ''
        });
        setItemSwInfoSaveDsa(false);
        setItemSwInfoUpdateDsa(true);
        setItemSwInfoDeleteDsa(true);

        setItemSwInfoSve(false)
        setItemSwInfoUpd(false)
        setItemSwInfoDlt(false)
    }

    const ItemOthrDutySave = () => {
        if (ItemDialogValues.othrDuty_NotifiRate !== '') {
            setItemSwInfoSaveDsa(true);
            setItemSwInfoSve(true);
            let details = {
                itemId: ItemId, notificationType: ItemDialogValues.othrDuty_Type, notificationNo: ItemDialogValues.othrDuty_NotifiNo,
                notificationSrNo: ItemDialogValues.othrDuty_NotifiSlNo, notificationRate: ItemDialogValues.othrDuty_NotifiRate,
                notificationAmount: ItemDialogValues.othrDuty_NotifiAmount, notificationUnit: ItemDialogValues.othrDuty_uqc,
                notificationFlag: ItemDialogValues.othrDuty_NotifiFlag
            }
            ItemService.insertItemNotificationMultible(details).then(res => {
                const message = res.data.message;
                if (message.toString() === 'SUCCESS') {
                    setMessage('OtherDuty Add Successfully');
                    setSeverity('success');
                    setOpenSnack(true);
                } else {
                    setMessage(message.toString());
                    setSeverity('error');
                    setOpenSnack(true);
                }
                ItemAddOthrDutyReset();
                let details2 = { itemId: ItemId, notificationType: '1', flag: 1 }
                ItemService.getItemNotification(details2).then(res => {
                    setItemRitcDetails(res.data);
                })
            }).catch(error => {
                setMessage(error.message);
                setSeverity('error');
                setOpenSnack(true);
                ItemAddOthrDutyReset();
            })
        } else {
            setMessage('Rate Should not be empty');
            setSeverity('warning');
            setOpenSnack(true);
        }
    }
    const ItemOthrDutyUpdate = () => {
        if (ItemDialogValues.othrDuty_NotifiRate !== '') {
            setItemSwInfoUpdateDsa(true);
            setItemSwInfoUpd(true);
            let details = {
                notificationId: ItemDialogValues.notofi_noId, notificationType: ItemDialogValues.othrDuty_Type,
                notificationNo: ItemDialogValues.othrDuty_NotifiNo, notificationSrNo: ItemDialogValues.othrDuty_NotifiSlNo,
                notificationRate: ItemDialogValues.othrDuty_NotifiRate, notificationAmount: ItemDialogValues.othrDuty_NotifiAmount,
                notificationUnit: ItemDialogValues.othrDuty_uqc, notificationFlag: ItemDialogValues.othrDuty_NotifiFlag, updatedBy: getUserId()
            }
            ItemService.updateItemNotification(details).then(res => {
                const message = res.data.message;
                if (message.toString() === 'SUCCESS') {
                    setMessage('OtherDuty Update Successfully');
                    setSeverity('success');
                    setOpenSnack(true);
                } else {
                    setMessage(message.toString());
                    setSeverity('error');
                    setOpenSnack(true);
                }
                ItemAddOthrDutyReset();
                let details2 = { itemId: ItemId, notificationType: '1', flag: 1 }
                ItemService.getItemNotification(details2).then(res => {
                    setItemRitcDetails(res.data);
                })
            }).catch(error => {
                setMessage(error.message);
                setSeverity('error');
                setOpenSnack(true);
                ItemAddOthrDutyReset();
            })
        } else {
            setMessage('Rate Should not be empty');
            setSeverity('warning');
            setOpenSnack(true);
        }
    }
    const ItemOthrDutyDelete = () => {
        if (ItemDialogValues.othrDuty_NotifiRate !== '') {
            setItemSwInfoDeleteDsa(true);
            setItemSwInfoDlt(true);
            ItemService.deleteItemNotification(ItemDialogValues.notofi_noId).then(res => {
                const message = res.data.message;
                if (message.toString() === 'SUCCESS') {
                    setMessage('OtherDuty Delete Successfully');
                    setSeverity('success');
                    setOpenSnack(true);
                } else {
                    setMessage(message.toString());
                    setSeverity('error');
                    setOpenSnack(true);
                }
                ItemAddOthrDutyReset();
                let details2 = { itemId: ItemId, notificationType: '1', flag: 1 }
                ItemService.getItemNotification(details2).then(res => {
                    setItemRitcDetails(res.data);
                })
            }).catch(error => {
                setMessage(error.message);
                setSeverity('error');
                setOpenSnack(true);
                ItemAddOthrDutyReset();
            })
        } else {
            setMessage('Rate Should not be empty');
            setSeverity('warning');
            setOpenSnack(true);
        }
    }

    const ItemAddOthrDutyReset = () => {
        setItemDialogValues({
            ...ItemDialogValues, notofi_noId: '', othrDuty_NotifiNo: '', othrDuty_NotifiSlNo: '',
            othrDuty_NotifiRate: '', othrDuty_NotifiAmount: '', othrDuty_NotifiFlag: '', othrDuty_Type: '', othrDuty_uqc: ''
        });
        setItemSwInfoSaveDsa(false);
        setItemSwInfoUpdateDsa(true);
        setItemSwInfoDeleteDsa(true);

        setItemSwInfoSve(false)
        setItemSwInfoUpd(false)
        setItemSwInfoDlt(false)
    }

    const ItemScdSave = () => {
        if (ItemDialogValues.custm_rate !== '') {
            setItemSwInfoSaveDsa(true);
            setItemSwInfoSve(true);
            let details = {
                itemId: ItemId, notificationType: 'SCD', notificationNo: ItemDialogValues.custm_notfiNo,
                notificationSrNo: ItemDialogValues.custm_Sl_No, notificationRate: ItemDialogValues.custm_rate,
                notificationAmount: ItemDialogValues.custm_amount, notificationUnit: ItemDialogValues.custm_uqc,
                notificationFlag: ItemDialogValues.custm_flag
            }
            ItemService.insertItemNotificationMultible(details).then(res => {
                const message = res.data.message;
                if (message.toString() === 'SUCCESS') {
                    setMessage('SCD Add Successfully');
                    setSeverity('success');
                    setOpenSnack(true);
                } else {
                    setMessage(message.toString());
                    setSeverity('error');
                    setOpenSnack(true);
                }
                ItemAddCustmExmpNotnNoReset();
                let details2 = { itemId: ItemId, notificationType: 'SCD', flag: 1 }
                ItemService.getItemNotification(details2).then(res => {
                    setItemRitcDetails(res.data);
                })
            }).catch(error => {
                setMessage(error.message);
                setSeverity('error');
                setOpenSnack(true);
                ItemAddCustmExmpNotnNoReset();
            })
        } else {
            setMessage('Rate Should not be Empty');
            setSeverity('warning');
            setOpenSnack(true);
        }

    }
    const ItemAddScdUpdate = () => {
        if (ItemDialogValues.custm_rate !== '') {
            setItemSwInfoUpdateDsa(true);
            setItemSwInfoUpd(true);
            let details = {
                notificationId: ItemDialogValues.notofi_noId, notificationType: 'SCD', notificationNo: ItemDialogValues.custm_notfiNo,
                notificationSrNo: ItemDialogValues.custm_Sl_No, notificationRate: ItemDialogValues.custm_rate,
                notificationAmount: ItemDialogValues.custm_amount, notificationUnit: ItemDialogValues.custm_uqc,
                notificationFlag: ItemDialogValues.custm_flag, updatedBy: getUserId()
            }
            ItemService.updateItemNotification(details).then(res => {
                const message = res.data.message;
                if (message.toString() === 'SUCCESS') {
                    setMessage('CustomNotn Exemption Update Successfully');
                    setSeverity('success');
                    setOpenSnack(true);
                } else {
                    setMessage(message.toString());
                    setSeverity('error');
                    setOpenSnack(true);
                }
                ItemAddCustmExmpNotnNoReset();
                let details2 = { itemId: ItemId, notificationType: 'SCD', flag: 1 }
                ItemService.getItemNotification(details2).then(res => {
                    setItemRitcDetails(res.data);
                })
            }).catch(error => {
                setMessage(error.message);
                setSeverity('error');
                setOpenSnack(true);
                ItemAddCustmExmpNotnNoReset();
            })
        } else {
            setMessage('Rate Should not be Empty');
            setSeverity('warning');
            setOpenSnack(true);
        }

    }
    const ItemAddScdDelete = () => {
        setItemSwInfoDeleteDsa(true);
        setItemSwInfoDlt(true);
        ItemService.deleteItemNotification(ItemDialogValues.notofi_noId).then(res => {
            const message = res.data.message;
            if (message.toString() === 'SUCCESS') {
                setMessage('SCD Delete Successfully');
                setSeverity('success');
                setOpenSnack(true);
            } else {
                setMessage(message.toString());
                setSeverity('error');
                setOpenSnack(true);
            }
            ItemAddCustmExmpNotnNoReset();
            let details2 = { itemId: ItemId, notificationType: 'SCD', flag: 1 }
            ItemService.getItemNotification(details2).then(res => {
                setItemRitcDetails(res.data);
            })
        }).catch(error => {
            setMessage(error.message);
            setSeverity('error');
            setOpenSnack(true);
            ItemAddCustmExmpNotnNoReset();
        })
    }

    const validateControl = () => {
        if (ItemDialogValues.swcntl_typ_code !== '') {
            if (ItemDialogValues.swcntl_result_code !== '') {
                if (ItemDialogValues.swcntl_location !== '') {

                    return true;
                }
                else {
                    setMessage('Please Enter the Control Location ..!!');
                    setSeverity('warning');
                    setOpenSnack(true);
                }
            }
            else {
                setMessage('Please Select The Control Result Code ..!!');
                setSeverity('warning');
                setOpenSnack(true);
            }
        }
        else {
            setMessage('Please Select The Control Type Code ..!!');
            setSeverity('warning');
            setOpenSnack(true);
        }
        return false;
    }

    const ItemSwControlSave = () => {
        if (validateControl() === true) {
            setItemSwInfoSaveDsa(true);
            setItemSwInfoSve(true);
            var conEndDate, conStartDate, conResultCode, unitCode, srNo = '';
            if (ItemDialogValues.swcntl_start_date !== '') {
                conStartDate = ItemDialogValues.swcntl_start_date;
            } else {
                conStartDate = null
            }
            if (ItemDialogValues.swcntl_end_date !== '') {
                conEndDate = ItemDialogValues.swcntl_end_date;
            } else {
                conEndDate = null
            }
            if (ItemDialogValues.swcntl_result_code !== '') {
                conResultCode = ItemDialogValues.swcntl_result_code;
            } else {
                conResultCode = null
            }
            if (ItemDialogValues.swcntl_uqc !== '') {
                unitCode = ItemDialogValues.swcntl_uqc;
            } else {
                unitCode = null
            }
            if (ItemDialogValues.swcntl_sl_no !== '') {
                srNo = ItemDialogValues.swcntl_sl_no;
            } else {
                srNo = null
            }
            let details = {
                itemId: ItemId, consignmentId: jobValues.job_no, conType: ItemDialogValues.swcntl_typ_code,
                conLocation: ItemDialogValues.swcntl_location, conStartDate: conStartDate, conEndDate: conEndDate,
                conResultCode: conResultCode, conResultText: ItemDialogValues.swcntl_result_text, unitCode: unitCode,
                conMeasurnment: ItemDialogValues.swcntl_measurnment, srNo: srNo
            }
            ItemService.insertItemSwControl(details).then(res => {
                const message = res.data.message;
                if (message.toString() === 'SUCCESS') {
                    setMessage('SW Control Insert Successfully');
                    setSeverity('success');
                    setOpenSnack(true);
                } else {
                    setMessage(message.toString());
                    setSeverity('error');
                    setOpenSnack(true);
                }
                ItemAddSwControlReset();
                let details2 = { itemId: ItemId, consignmentId: jobValues.job_no }
                ItemService.getSwControl(details2).then(res => {
                    setItemRitcDetails(res.data);
                })
            }).catch(error => {
                setMessage(error.message);
                setSeverity('error');
                setOpenSnack(true);
                ItemAddSwControlReset();
            })
        }
    }
    const ItemSwControlUpdate = () => {
        if (validateControl() === true) {
            setItemSwInfoUpdateDsa(true);
            setItemSwInfoUpd(true);
            var conEndDate, conStartDate, conResultCode, unitCode, srNo = '';
            if (ItemDialogValues.swcntl_start_date !== '') {
                conStartDate = ItemDialogValues.swcntl_start_date;
            } else {
                conStartDate = null
            }
            if (ItemDialogValues.swcntl_end_date !== '') {
                conEndDate = ItemDialogValues.swcntl_end_date;
            } else {
                conEndDate = null
            }
            if (ItemDialogValues.swcntl_result_code !== '') {
                conResultCode = ItemDialogValues.swcntl_result_code;
            } else {
                conResultCode = null
            }
            if (ItemDialogValues.swcntl_uqc !== '') {
                unitCode = ItemDialogValues.swcntl_uqc;
            } else {
                unitCode = null
            }
            if (ItemDialogValues.swcntl_sl_no !== '') {
                srNo = ItemDialogValues.swcntl_sl_no;
            } else {
                srNo = null
            }
            let details = {
                itemId: ItemDialogValues.notofi_noId, conType: ItemDialogValues.swcntl_typ_code,
                conLocation: ItemDialogValues.swcntl_location, conStartDate: conStartDate, conEndDate: conEndDate,
                conResultCode: conResultCode, conResultText: ItemDialogValues.swcntl_result_text, unitCode: unitCode,
                conMeasurnment: ItemDialogValues.swcntl_measurnment, srNo: srNo
            }
            ItemService.updateItemSwControl(details).then(res => {
                const message = res.data.message;
                if (message.toString() === 'SUCCESS') {
                    setMessage('SW Control Update Successfully');
                    setSeverity('success');
                    setOpenSnack(true);
                } else {
                    setMessage(message.toString());
                    setSeverity('error');
                    setOpenSnack(true);
                }
                ItemAddSwControlReset();
                let details2 = { itemId: ItemId, consignmentId: jobValues.job_no }
                ItemService.getSwControl(details2).then(res => {
                    setItemRitcDetails(res.data);
                })
            }).catch(error => {
                setMessage(error.message);
                setSeverity('error');
                setOpenSnack(true);
                ItemAddSwControlReset();
            })
        }
    }
    const ItemAddSwControlDelete = () => {
        setItemSwInfoDeleteDsa(true);
        setItemSwInfoDlt(true);
        ItemService.deleteItemSwControl(ItemDialogValues.notofi_noId).then(res => {
            const message = res.data.message;
            if (message.toString() === 'SUCCESS') {
                setMessage('SW Control Delete Successfully');
                setSeverity('success');
                setOpenSnack(true);
            } else {
                setMessage(message.toString());
                setSeverity('error');
                setOpenSnack(true);
            }
            ItemAddSwControlReset();
            let details2 = { itemId: ItemId, consignmentId: jobValues.job_no }
            ItemService.getSwControl(details2).then(res => {
                setItemRitcDetails(res.data);
            })
        }).catch(error => {
            setMessage(error.message);
            setSeverity('error');
            setOpenSnack(true);
            ItemAddSwControlReset();
        })
    }
    const ItemAddSwControlReset = () => {
        setItemDialogValues({
            ...ItemDialogValues, notofi_noId: '', swcntl_end_date: '',
            swcntl_location: '', swcntl_measurnment: '0.00', swcntl_result_code: '', swcntl_result_text: '',
            swcntl_sl_no: '', swcntl_start_date: '', swcntl_typ_code: '', swcntl_uqc: ''
        });
        setItemSwInfoSaveDsa(false);
        setItemSwInfoUpdateDsa(true);
        setItemSwInfoDeleteDsa(true);

        setItemSwInfoSve(false)
        setItemSwInfoUpd(false)
        setItemSwInfoDlt(false)
    }
    const validateStatement = () => {
        if (ItemDialogValues.swStatmnt_typ !== '') {
            if (ItemDialogValues.swStmnt_dclrtiontypeMtnb !== '') {
                return true;
            }
            else {
                setMessage('Please Enter the Declaration Type ..!!');
                setSeverity('warning');
                setOpenSnack(true);
            }
        }
        else {
            setMessage('Please Select The Sw Statement Type ..!!');
            setSeverity('warning');
            setOpenSnack(true);
        }
        return false;
    }

    const ItemSwStatemntSave = () => {
        if (validateStatement() === true) {
            setItemSwInfoSaveDsa(true);
            setItemSwInfoSve(true);
            var statementCode, decNo, decDate = '';
            if (ItemDialogValues.swStatment_code !== '') {
                statementCode = ItemDialogValues.swStatment_code;
            } else {
                statementCode = null;
            }
            if (ItemDialogValues.swStatment_decNo !== '') {
                decNo = ItemDialogValues.swStatment_decNo;
            } else {
                decNo = null;
            }
            if (ItemDialogValues.swStatment_date !== '') {
                decDate = ItemDialogValues.swStatment_date;
            } else {
                decDate = null;
            }
            let details = {
                itemId: ItemId, consignmentId: jobValues.job_no, statementType: ItemDialogValues.swStatmnt_typ,
                statementCode: statementCode, statementText: ItemDialogValues.swStatment_text, decNo: decNo,
                decType: ItemDialogValues.swStmnt_dclrtiontypeMtnb, decDate: decDate
            }
            ItemService.insertItemSwStatement(details).then(res => {
                const message = res.data.message;
                if (message.toString() === 'SUCCESS') {
                    setMessage('SW Statement Insert Successfully');
                    setSeverity('success');
                    setOpenSnack(true);
                } else {
                    setMessage(message.toString());
                    setSeverity('error');
                    setOpenSnack(true);
                }
                ItemAddSwStatementReset();
                let details2 = { itemId: ItemId, consignmentId: jobValues.job_no }
                ItemService.getSwStatement(details2).then(ress => {
                    setItemRitcDetails(ress.data);
                })
            }).catch(error => {
                setMessage(error.message);
                setSeverity('error');
                setOpenSnack(true);
                ItemAddSwStatementReset();
            })
        }
    }

    const ItemSwStatementUpdate = () => {
        if (validateStatement() === true) {
            setItemSwInfoUpdateDsa(true);
            setItemSwInfoUpd(true);
            var statementCode, decNo, decDate = '';
            if (ItemDialogValues.swStatment_code !== '') {
                statementCode = ItemDialogValues.swStatment_code;
            } else {
                statementCode = null;
            }
            if (ItemDialogValues.swStatment_decNo !== '') {
                decNo = ItemDialogValues.swStatment_decNo;
            } else {
                decNo = null;
            }
            if (ItemDialogValues.swStatment_date !== '') {
                decDate = ItemDialogValues.swStatment_date;
            } else {
                decDate = null;
            }
            let details = {
                itemId: ItemDialogValues.notofi_noId, statementType: ItemDialogValues.swStatmnt_typ,
                statementCode: statementCode, statementText: ItemDialogValues.swStatment_text, decNo: decNo,
                decType: ItemDialogValues.swStmnt_dclrtiontypeMtnb, decDate: decDate
            }
            ItemService.updateItemSwStatement(details).then(res => {
                const message = res.data.message;
                if (message.toString() === 'SUCCESS') {
                    setMessage('SW Statement Update Successfully');
                    setSeverity('success');
                    setOpenSnack(true);
                } else {
                    setMessage(message.toString());
                    setSeverity('error');
                    setOpenSnack(true);
                }
                ItemAddSwStatementReset();
                let details2 = { itemId: ItemId, consignmentId: jobValues.job_no }
                ItemService.getSwStatement(details2).then(ress => {
                    setItemRitcDetails(ress.data);
                })
            }).catch(error => {
                setMessage(error.message);
                setSeverity('error');
                setOpenSnack(true);
                ItemAddSwStatementReset();
            })
        }
    }

    const ItemSwStatementDelete = () => {
        setItemSwInfoDeleteDsa(true);
        setItemSwInfoDlt(true);
        ItemService.deleteItemSwStatement(ItemDialogValues.notofi_noId).then(res => {
            const message = res.data.message;
            if (message.toString() === 'SUCCESS') {
                setMessage('SW Statement Update Successfully');
                setSeverity('success');
                setOpenSnack(true);
            } else {
                setMessage(message.toString());
                setSeverity('error');
                setOpenSnack(true);
            }
            ItemAddSwStatementReset();
            let details2 = { itemId: ItemId, consignmentId: jobValues.job_no }
            ItemService.getSwStatement(details2).then(ress => {
                setItemRitcDetails(ress.data);
            })
        }).catch(error => {
            setMessage(error.message);
            setSeverity('error');
            setOpenSnack(true);
            ItemAddSwStatementReset();
        })
    }
    const ItemAddSwStatementReset = () => {
        setItemDialogValues({
            ...ItemDialogValues, notofi_noId: '', swStatmnt_typ: '',
            swStatment_code: '', swStatment_text: '', swStmnt_dclrtiontypeMtnb: '', swStatment_date: '',
            swStatment_decNo: ''
        });
        setItemSwInfoSaveDsa(false);
        setItemSwInfoUpdateDsa(true);
        setItemSwInfoDeleteDsa(true);

        setItemSwInfoSve(false)
        setItemSwInfoUpd(false)
        setItemSwInfoDlt(false)
    }

    const ItemPolicySave = () => {
        setItemSwInfoSaveDsa(false);
        setItemSwInfoSve(false);
        let details = {
            itemId: ItemId, policyParaNo: ItemDialogValues.policy_paraNo,
            policyPeraYear: ItemDialogValues.policy_paraYear
        }
        ItemService.insertItemPolicyPara(details).then(res => {
            const message = res.data.message;
            if (message.toString() === 'SUCCESS') {
                setMessage('Policy Para Insert Successfully');
                setSeverity('success');
                setOpenSnack(true);
            } else {
                setMessage(message.toString());
                setSeverity('error');
                setOpenSnack(true);
            }
            ItemPolicyReset();
            let details2 = { itemId: ItemId }
            ItemService.getItemPolicyPara(details2).then(ress => {
                setItemRitcDetails(ress.data);
            })
        }).catch(error => {
            setMessage(error.message);
            setSeverity('error');
            setOpenSnack(true);
            ItemPolicyReset();
        })
    }
    const ItemPolicyUpdate = () => {
        setItemSwInfoUpdateDsa(false);
        setItemSwInfoUpd(false);
        let details = {
            notificationId: ItemDialogValues.notofi_noId, policyParaNo: ItemDialogValues.policy_paraNo,
            policyPeraYear: ItemDialogValues.policy_paraYear
        }
        ItemService.updateItemPolicyPara(details).then(res => {
            const message = res.data.message;
            if (message.toString() === 'SUCCESS') {
                setMessage('policy Para Update Successfully');
                setSeverity('success');
                setOpenSnack(true);
            } else {
                setMessage(message.toString());
                setSeverity('error');
                setOpenSnack(true);
            }
            ItemPolicyReset();
            let details2 = { itemId: ItemId }
            ItemService.getItemPolicyPara(details2).then(ress => {
                setItemRitcDetails(ress.data);
            })
        }).catch(error => {
            setMessage(error.message);
            setSeverity('error');
            setOpenSnack(true);
            ItemPolicyReset();
        })
    }
    const ItemPolicyDelete = () => {
        setItemSwInfoDeleteDsa(false);
        setItemSwInfoDlt(false);
        ItemService.deleteItemPolicyPara(ItemDialogValues.notofi_noId).then(res => {
            const message = res.data.message;
            if (message.toString() === 'SUCCESS') {
                setMessage('policy Para Delete Successfully');
                setSeverity('success');
                setOpenSnack(true);
            } else {
                setMessage(message.toString());
                setSeverity('error');
                setOpenSnack(true);
            }
            ItemPolicyReset();
            let details2 = { itemId: ItemId }
            ItemService.getItemPolicyPara(details2).then(ress => {
                setItemRitcDetails(ress.data);
            })
        }).catch(error => {
            setMessage(error.message);
            setSeverity('error');
            setOpenSnack(true);
            ItemPolicyReset();
        })
    }
    const ItemPolicyReset = () => {
        setItemDialogValues({ ...ItemDialogValues, notofi_noId: '', policy_paraNo: '', policy_paraYear: '' });
        setItemSwInfoSaveDsa(false);
        setItemSwInfoUpdateDsa(true);
        setItemSwInfoDeleteDsa(true);

        setItemSwInfoSve(false)
        setItemSwInfoUpd(false)
        setItemSwInfoDlt(false)
    }

    const validateSupportingDoc = () => {
        if (ItemDialogValues.FileType !== '') {
            if (ItemDialogValues.BeneficiaryName !== '') {
                if (ItemDialogValues.PlaceOfIssue !== '') {
                    if (ItemDialogValues.IssuePartyName !== '') {
                        if (ItemDialogValues.DocTypeCodet !== '') {
                            if (ItemDialogValues.DeclarationTypeMTNE !== '') {
                                if (ItemDialogValues.ImageRefNo !== '') {
                                    if (ItemDialogValues.DocIssueDate !== '') {
                                        return true;
                                    }
                                    else {
                                        setMessage('Please Enter the Document Issue Date ..!!');
                                        setSeverity('warning');
                                        setOpenSnack(true);
                                    }
                                }
                                else {
                                    setMessage('Please Enter the Image Reference No ..!!');
                                    setSeverity('warning');
                                    setOpenSnack(true);
                                }
                            }
                            else {
                                setMessage('Please Enter the Declaration Type ..!!');
                                setSeverity('warning');
                                setOpenSnack(true);
                            }
                        }
                        else {
                            setMessage('Please Enter the Document Type ..!!');
                            setSeverity('warning');
                            setOpenSnack(true);
                        }
                    }
                    else {
                        setMessage('Please Enter the Doc Issue Party Name ..!!');
                        setSeverity('warning');
                        setOpenSnack(true);
                    }
                }
                else {
                    setMessage('Please Enter The Document Issue Place ..!!');
                    setSeverity('warning');
                    setOpenSnack(true);
                }
            }
            else {
                setMessage('Please Enter The Beneficiary Party Name ..!!');
                setSeverity('warning');
                setOpenSnack(true);
            }
        }
        else {
            setMessage('Please Enter The File Type ..!!');
            setSeverity('warning');
            setOpenSnack(true);
        }
        return false;
    }

    const ItemSwDocsSave = () => {
        if (validateSupportingDoc() === true) {
            setItemSchemeSaveDsa(true);
            setItemSchemeSve(true);
            var imagRefNo, docType, docIssuePlace, docIssueDate, docExpiryDate, beneficiaryName, fileType = '';
            if (ItemDialogValues.ImageRefNo !== '') {
                imagRefNo = ItemDialogValues.ImageRefNo;
            } else {
                imagRefNo = null;
            }
            if (ItemDialogValues.DocTypeCode !== '') {
                docType = ItemDialogValues.DocTypeCode;
            } else {
                docType = null;
            }
            if (ItemDialogValues.PlaceOfIssue !== '') {
                docIssuePlace = ItemDialogValues.PlaceOfIssue;
            } else {
                docIssuePlace = null;
            }
            if (ItemDialogValues.DocIssueDate !== '') {
                docIssueDate = ItemDialogValues.DocIssueDate;
            } else {
                docIssueDate = null;
            }
            if (ItemDialogValues.DocExpiryDate !== '') {
                docExpiryDate = ItemDialogValues.DocExpiryDate;
            } else {
                docExpiryDate = null;
            }
            if (ItemDialogValues.BeneficiaryName !== '') {
                beneficiaryName = ItemDialogValues.BeneficiaryName;
            } else {
                beneficiaryName = null;
            }
            if (ItemDialogValues.FileType !== '') {
                fileType = ItemDialogValues.FileType;
            } else {
                fileType = null;
            }
            let details = {
                itemId: ItemId, consignmentId: jobValues.job_no, decType: ItemDialogValues.DeclarationTypeMTNE,
                chaLicenceNo: null, importer_iec_no: null, iceGateUser: null, imagRefNo: imagRefNo, docType: docType,
                issueCode: ItemDialogValues.IssuePartyCode, issueName: ItemDialogValues.IssuePartyName,
                issueAddress1: ItemDialogValues.IssuePartyAddress1, issueAddress2: ItemDialogValues.IssuePartyAddress2,
                issueCity: ItemDialogValues.IssuePartyCity, issuePincode: ItemDialogValues.IssuePartyPincode, docRefNo: ItemDialogValues.DocReferenceNo,
                docIssuePlace: docIssuePlace, docIssueDate: docIssueDate, docExpiryDate: docExpiryDate, beneficiaryCode: ItemDialogValues.BenificiaryCode,
                beneficiaryName: beneficiaryName, beneficiaryAddress1: ItemDialogValues.BenificiaryAddress1, beneficiaryAddress2: ItemDialogValues.BenificiaryAddress2,
                beneficiaryCity: ItemDialogValues.BenificiaryCity, beneficiaryPincode: ItemDialogValues.BenificiaryPincode, fileType: fileType
            }
            ItemService.insertItemSwSupportingDoc(details).then(res => {
                const message = res.data.message;
                if (message.toString() === 'SUCCESS') {
                    setMessage('SW Supporting Docs Insert Successfully');
                    setSeverity('success');
                    setOpenSnack(true);
                } else {
                    setMessage(message.toString());
                    setSeverity('error');
                    setOpenSnack(true);
                }
                ItemSwDocsReset()
                setItemDialogValues({ ...ItemDialogValues, ImageRefNo: '' });
                let details2 = { itemId: ItemId, consignmentId: jobValues.job_no }
                ItemService.getSwSupportingDoc(details2).then(ress => {
                    setItemRitcDetails(ress.data);
                })
            }).catch(error => {
                setMessage(error.message);
                setSeverity('error');
                setOpenSnack(true);
                setItemDialogValues({ ...ItemDialogValues, ImageRefNo: '' });
            })
        }
    }

    const ItemSwDocsUpdate = () => {
        if (validateSupportingDoc() === true) {
            setItemSchemeUpdateDsa(true);
            setItemSchemeUpd(true);
            var imagRefNo, docType, docIssuePlace, docIssueDate, docExpiryDate, beneficiaryName, fileType = '';
            if (ItemDialogValues.ImageRefNo !== '') {
                imagRefNo = ItemDialogValues.ImageRefNo;
            } else {
                imagRefNo = null;
            }
            if (ItemDialogValues.DocTypeCode !== '') {
                docType = ItemDialogValues.DocTypeCode;
            } else {
                docType = null;
            }
            if (ItemDialogValues.PlaceOfIssue !== '') {
                docIssuePlace = ItemDialogValues.PlaceOfIssue;
            } else {
                docIssuePlace = null;
            }
            if (ItemDialogValues.DocIssueDate !== '') {
                docIssueDate = ItemDialogValues.DocIssueDate;
            } else {
                docIssueDate = null;
            }
            if (ItemDialogValues.DocExpiryDate !== '') {
                docExpiryDate = ItemDialogValues.DocExpiryDate;
            } else {
                docExpiryDate = null;
            }
            if (ItemDialogValues.BeneficiaryName !== '') {
                beneficiaryName = ItemDialogValues.BeneficiaryName;
            } else {
                beneficiaryName = null;
            }
            if (ItemDialogValues.FileType !== '') {
                fileType = ItemDialogValues.FileType;
            } else {
                fileType = null;
            }
            let details = {
                itemId: ItemDialogValues.notofi_noId, decType: ItemDialogValues.DeclarationTypeMTNE,
                chaLicenceNo: null, importer_iec_no: null, iceGateUser: null, imagRefNo: imagRefNo, docType: docType,
                issueCode: ItemDialogValues.IssuePartyCode, issueName: ItemDialogValues.IssuePartyName,
                issueAddress1: ItemDialogValues.IssuePartyAddress1, issueAddress2: ItemDialogValues.IssuePartyAddress2,
                issueCity: ItemDialogValues.IssuePartyCity, issuePincode: ItemDialogValues.IssuePartyPincode, docRefNo: ItemDialogValues.DocReferenceNo,
                docIssuePlace: docIssuePlace, docIssueDate: docIssueDate, docExpiryDate: docExpiryDate, beneficiaryCode: ItemDialogValues.BenificiaryCode,
                beneficiaryName: beneficiaryName, beneficiaryAddress1: ItemDialogValues.BenificiaryAddress1, beneficiaryAddress2: ItemDialogValues.BenificiaryAddress2,
                beneficiaryCity: ItemDialogValues.BenificiaryCity, beneficiaryPincode: ItemDialogValues.BenificiaryPincode, fileType: fileType
            }
            ItemService.updateItemSwSupportingDoc(details).then(res => {
                const message = res.data.message;
                if (message.toString() === 'SUCCESS') {
                    setMessage('SW Supporting Docs Update Successfully');
                    setSeverity('success');
                    setOpenSnack(true);
                } else {
                    setMessage(message.toString());
                    setSeverity('error');
                    setOpenSnack(true);
                }
                ItemSwDocsReset();
                let details2 = { itemId: ItemId, consignmentId: jobValues.job_no }
                ItemService.getSwSupportingDoc(details2).then(ress => {
                    setItemRitcDetails(ress.data);
                })
            }).catch(error => {
                setMessage(error.message);
                setSeverity('error');
                setOpenSnack(true);
                ItemSwDocsReset();
            })
        }
    }

    const ItemSwDocsDelete = () => {
        if (validateSupportingDoc() === true) {
            setItemSchemeDeleteDsa(true);
            setItemSchemeDlt(true);
            ItemService.deleteItemSwSupDoc(ItemDialogValues.notofi_noId).then(res => {
                const message = res.data.message;
                if (message.toString() === 'SUCCESS') {
                    setMessage('SW Supporting Docs Delete Successfully');
                    setSeverity('success');
                    setOpenSnack(true);
                } else {
                    setMessage(message.toString());
                    setSeverity('error');
                    setOpenSnack(true);
                }
                ItemSwDocsReset();
                let details2 = { itemId: ItemId, consignmentId: jobValues.job_no }
                ItemService.getSwSupportingDoc(details2).then(ress => { setItemRitcDetails(ress.data); })
            }).catch(error => {
                setMessage(error.message);
                setSeverity('error');
                setOpenSnack(true);
                ItemSwDocsReset();
            })
        }
    }

    const ItemSwDocsReset = () => {
        setItemDialogValues({
            ...ItemDialogValues, notofi_noId: '', ImageRefNo: '', DocTypeCode: '', IssuePartyName: '',
            PlaceOfIssue: '', DocIssueDate: '', BeneficiaryName: '', FileType: 'PDF', DeclarationTypeMTNE: 'M',
            DocReferenceNo: '', DocExpiryDate: '', IssuePartyAddress1: '', IssuePartyAddress2: '', IssuePartyCity: '',
            IssuePartyPincode: '', IssuePartyCode: '', BenificiaryCode: '', BenificiaryAddress1: '',
            BenificiaryAddress2: '', BenificiaryCity: '', BenificiaryPincode: '', FindDocumentType: '', FindDocumentName: '',
            FindSupplierName: '', ImporterIECCode: '', ImporterIECName: '', BranchSerialNo: '', FindImporterName: '',
            FindImporterCode: '', FindImporterState: '', FindBranchSr_NO: ''
        });
        setItemSchemeSaveDsa(false);
        setItemSchemeUpdateDsa(true);
        setItemSchemeDeleteDsa(true);

        setItemSchemeSve(false)
        setItemSchemeUpd(false)
        setItemSchemeDlt(false)
    }

    /**-----------onClick-Table-Event-DialogBox-----------------------------------------**/

    const editItemDescDetails = (item) => {
        let details = { itemId: item.itemId, notificationType: 'GST', flag: 2 }
        ItemService.getItemNotification(details).then(res => {
            const data = res.data;
            const ItemAssign = data.map((itemsAssign) => itemsAssign);
            setItemValues({
                ...ItemValues, txt_item_Desc: item.item_description, txt_ritc: item.ritc
                , txt_cth: item.cth, txt_ceth: item.ceth, genericDesc: item.genDesc, txt_brand: item.brand, txt_model_no: item.modelNo
                , txt_originCntry: item.countryIdString, txt_originCntryName: item.countryName, bcd_notfication_no: item.notificationNo, bcd_amount_no: item.notificationAmount,
                bcd_sl_no: item.notificationSrNo, bcd_flg_no: item.notificationFlag, bcd_uqc_no: item.notificationUnit, bcd_rate_no: item.notificationRate,
                sws_notfication_no: item.exempNotNo, sws_sl_no: item.exempNotSrNo, sws_flg_no: item.igstFlag, sws_uqc_no: item.unitCode,
                sws_rate_no: item.ratePer, sws_amount_no: item.igstAmt, igstduty_notfion_no: ItemAssign[0].notificationNo,
                igstduty_sl_no: ItemAssign[0].notificationSrNo, igstduty_rate: ItemAssign[0].notificationRate, igstduty_amount: ItemAssign[0].notificationAmount,
                igstduty_flg: ItemAssign[0].notificationFlag, igstduty_uqc: ItemAssign[0].notificationUnit, igstduty_type: ItemAssign[0].dutyType,
                igstduty_Add_type: ItemAssign[0].addlDutyType, igstduty_flagG_C: ItemAssign[0].igstFlag, igstduty_exmpNotn_no: ItemAssign[0].exempNotNo,
                igstduty_sl_no2: ItemAssign[0].exempNotSrNo
            })
            itemItemDescCloshHandle();
        })

    }
    const editItemRitcDetails = (item) => {
        setItemValues({
            ...ItemValues, txt_ritc: item.hsCode, txt_cth: item.hsCode, txt_ceth: item.hsCode, bcd_rate_no: item.notificationRate,
            bcd_uqc_no: item.notificationUnit, sws_rate_no: item.totalAmount
        });
        itemRitcCloshHandle();
    }
    const editItemCthDetails = (item) => {
        setItemValues({ ...ItemValues, txt_cth: item.hsCode });
        itemCthCloshHandle();
    }
    const editItemCethDetails = (item) => {
        setItemValues({ ...ItemValues, txt_ceth: item.hsCode });
        itemCEThCloshHandle();
    }
    const editItemUnitDetails = (item) => {
        setItemValues({ ...ItemValues, txt_unit: item.unitCode });
        itemUnitCloshHandle();
    }
    const editItemCurrencyDetails = (item) => {
        setItemValues({ ...ItemValues, txt_currency: item.currency_code, txt_exRate: item.indianValue });
        itemCurrencyCloshHandle();
        setMessage('');
        setSeverity('');
    }
    const editItemEndUseDetails = (item) => {
        setItemValues({ ...ItemValues, txt_endusCode: item.endUseCode });
        itemEndUseCloshHandle();
    }
    const editItemOriginCntryDetails = (item) => {
        setItemValues({ ...ItemValues, txt_originCntry: item.countryIdString, txt_originCntryName: item.countryName });
        itemOriginCntryCloshHandle();
    }
    const editItemSourceCntryDetails = (item) => {
        setItemValues({ ...ItemValues, txt_sourceCountry: item.countryIdString, txt_sourceCountryName: item.countryName });
        itemSourceCntryCloshHandle();
    }
    const editItemTransitCntryDetails = (item) => {
        setItemValues({ ...ItemValues, txt_transit_country: item.countryIdString, txt_transit_countryName: item.countryName });
        itemTransiteCntryCloshHandle();
    }
    const editItemBcdNotifinoDetails = (item) => {
        setItemValues({
            ...ItemValues, bcd_notfication_no: item.notificationNo, bcd_sl_no: item.notificationSrNo,
            bcd_rate_no: item.notificationRate, bcd_flg_no: item.notificationFlag, bcd_amount_no: item.notificationAmount,
            bcd_uqc_no: item.notificationUnit
        });
        itemBcdNotifyCloshHandle();
    }
    const editItemAidcNotifinoDetails = (item) => {console.log('data item '+JSON.stringify(item))
        setItemValues({...ItemValues, aidc_notfication_no: item.notificationNo, aidc_sl_no: item.notificationSrNo,
            aidc_rate_no: item.notificationRate, aidc_flg_no: item.notificationFlag, aidc_amount_no: item.notificationAmount,
            aidc_uqc_no: item.notificationUnit}); setItemRitcDetails([]); 
            setItemAidcNotifyNoOpen(false);
    }
    const editItemSWSNotifinoDetails = (item) => {
        setItemValues({
            ...ItemValues, sws_notfication_no: item.notificationNo, sws_sl_no: item.notificationSrNo,
            sws_rate_no: item.notificationRate, sws_flg_no: item.notificationFlag, sws_amount_no: item.notificationAmount,
            sws_uqc_no: item.notificationUnit
        });
        itemSwsNotifyCloshHandle();
    }
    const editItemCVDNotifinoDetails = (item) => {
        setItemValues({
            ...ItemValues, cvd_notfication_no: item.notificationNo, cvd_sl_no: item.notificationSrNo,
            cvd_rate_no: item.notificationRate, cvd_flg_no: item.notificationFlag, cvd_amount_no: item.notificationAmount,
            cvd_uqc_no: item.notificationUnit
        });
        itemCVDNotifyCloshHandle();
    }
    const editItemEDUCessNotifinoDetails = (item) => {
        setItemValues({
            ...ItemValues, edu_css_notfication_no: item.notificationNo, edu_css_sl_no: item.notificationSrNo,
            edu_css_rate_no: item.notificationRate, edu_css_flg_no: item.notificationFlag, edu_css_amount_no: item.notificationAmount,
            edu_css_uqc_no: item.notificationUnit
        });
        itemEDUCessNotifyCloshHandle();
    }
    const editItemIgstDutyNotifinoDetails = (item) => {
        setItemValues({
            ...ItemValues, igstduty_notfion_no: item.notificationNo, igstduty_sl_no: item.notificationSrNo,
            igstduty_rate: item.notificationRate, igstduty_flg: item.notificationFlag, igstduty_amount: item.notificationAmount,
            igstduty_uqc: item.notificationUnit
        });
        itemIGSTDutyNotifyCloshHandle();
    }
    const editItemIgstCessNotifinoDetails = (item) => {
        setItemValues({
            ...ItemValues, igstcess_notfion_no: item.notificationNo, igstcess_sl_no: item.notificationSrNo,
            igstcess_rate: item.notificationRate, igstcess_flg: item.notificationFlag, igstcess_amount: item.notificationAmount
        });
        itemIGSTCessNotifyCloshHandle();
    }
    const editItemIgstDutyExmpNotifinoDetails = (item) => {
        setItemValues({ ...ItemValues, igstduty_exmpNotn_no: item.notificationNo, igstduty_sl_no2: item.notificationSrNo });
        itemIGSTDutyExmpNotifyCloshHandle();
    }
    const editItemSchemeDetails = (item) => {
        setItemDialogValues({ ...ItemDialogValues, scheme_code: item.schemeCode, scheme_codeName: item.schemeDesc });
        ItemSchemeCodeDetailsCloshHandle();
    }
    const editItemSchemeNotifiDetails = (item) => {
        setItemDialogValues({
            ...ItemDialogValues, notofi_no: item.notificationNo, srl_no: item.notificationSrNo
            , rate: item.notificationRate
        });
        ItemSchemeNotnDetailsCloshHandle();
    }

    const editItemSchemeCodeDetails = (item) => {
        setItemDialogValues({
            ...ItemDialogValues, scheme_code: item.schemeCode, scheme_codeName: item.schemeDesc,
            notofi_no: item.notificationNo, srl_no: item.notificationSrNo, exemptionrequired: item.excemptionReq,
            re_export: item.reExport, sec_20: item.sec20, notofi_noId: item.notificationId
        });
        setItemSchemeSaveDsa(true);
        setItemSchemeUpdateDsa(false);
        setItemSchemeDeleteDsa(false);

        setItemSchemeSve(false);
        setItemSchemeUpd(false);
        setItemSchemeDlt(false);
    }
    const editItemAuntiNotifiDetails = (item) => {
        setItemDialogValues({
            ...ItemDialogValues, auntiDump_notn_no: item.notificationNo, auntiDump_Srl_no: item.notificationSrNo
            , auntiDump_notifiRate: item.notificationRate, auntiDump_spaceAmt: item.notificationAmount, auntiDump_uqc: item.notificationUnit,
            auntiDump_flag: item.notificationFlag
        });
        ItemAuntiNotifiCloshHandle();
    }
    const editItemAuntiDumpingDetails = (item) => {
        setItemDialogValues({
            ...ItemDialogValues, notofi_noId: item.notificationId, auntiDump_notn_no: item.notificationNo, auntiDump_Srl_no: item.notificationSrNo,
            auntiDump_cth_srl_no: item.antiDumpSlNo, auntiDump_sup_srl_no: item.antiDumpSupplierSlNo, auntiDump_advalorem_rate: item.advaloremRate
            , auntiDump_notifiRate: item.notificationRate, auntiDump_spaceAmt: item.notificationAmount, auntiDump_uqc: item.notificationUnit,
            auntiDump_flag: item.notificationFlag, auntiDump_quantity: item.qty, auntiDump_currency: item.currency_code
        });
        setItemAuntiDumpSaveDsa(true);
        setItemAuntiDumpUpdateDsa(false);
        setItemAuntiDumpDeleteDsa(false);

        setItemAuntiDumpSve(false);
        setItemAuntiDumpUpd(false);
        setItemAuntiDumpDlt(false);
    }

    const editItemSwInfoDetails = (item) => {
        setItemDialogValues({
            ...ItemDialogValues, SwType: item.swType, SwQwalifier: item.swQualifier,
            SwCode: item.swCode, SwText: item.swtxt, sw_mesurnment: item.swMsr, Sw_Uqc: item.unitCode, notofi_noId: item.notificationId
        })
        setItemSwInfoSaveDsa(true);
        setItemSwInfoUpdateDsa(false);
        setItemSwInfoDeleteDsa(false);

        setItemSwInfoSve(false)
        setItemSwInfoUpd(false)
        setItemSwInfoDlt(false)
    }
    const editItemLicenceDetails = (item) => {
        setItemDialogValues({
            ...ItemDialogValues, licence_reg_no: item.licenceRegNo, licence_code: item.licenceCode,
            licence_Date: item.licenceRegDate, licence_reg_port: item.customPointCode, debit_duty: item.debitDuty, Sw_Uqc: item.unitCode,
            debit_value: item.debitValue, debit_quantity: item.debitQty, tra_no: item.traNo, tra_date: item.traDate,
            notofi_noId: item.notificationId, Licence_item_srlNo: item.licenceSrNo
        })
        setItemSwInfoSaveDsa(true);
        setItemSwInfoUpdateDsa(false);
        setItemSwInfoDeleteDsa(false);

        setItemSwInfoSve(false)
        setItemSwInfoUpd(false)
        setItemSwInfoDlt(false)
    }

    const editItemLicenceCodeDetails = (item) => {
        setItemDialogValues({
            ...ItemDialogValues, licence_code: item.schemeCode,
            licence_codeName: item.schemeDesc
        });
        setItemLicencCodeeOpen(false);
    }

    const editItemLicencePortDetails = (item) => {
        setItemDialogValues({ ...ItemDialogValues, licence_reg_port: item.customHouseCode });
        ItemLicencePortCloshHandle();
    }
    const editItemSwConstiuentDetails = (item) => {
        setItemDialogValues({
            ...ItemDialogValues, constituentSl_no: item.srNo, constituent_name: item.consName,
            constituent_code: item.consCode, const_percentage: item.consPerc, yield_percentage: item.consYieldPerc,
            active_indredient: item.consActive, notofi_noId: item.notificationId
        });
        setItemSwInfoSaveDsa(true);
        setItemSwInfoUpdateDsa(false);
        setItemSwInfoDeleteDsa(false);

        setItemSwInfoSve(false)
        setItemSwInfoUpd(false)
        setItemSwInfoDlt(false)
    }
    const editItemRspDetails = (item) => {
        setItemDialogValues({
            ...ItemDialogValues, rsp_notnNo: item.notificationNo, rsp_notnSlNo: item.notificationSrNo,
            rsp_amount: item.notificationRate, rsp_description: item.item_description, rsp_quantity: item.qty
            , rsp_rate: item.notificationRate, notofi_noId: item.notificationId
        });
        setItemSwInfoSaveDsa(true);
        setItemSwInfoUpdateDsa(false);
        setItemSwInfoDeleteDsa(false);

        setItemSwInfoSve(false)
        setItemSwInfoUpd(false)
        setItemSwInfoDlt(false)
    }
    const editItemReImpDetails = (item) => {
        setItemDialogValues({
            ...ItemDialogValues, notofi_noId: item.notificationId, r_iPrivousSbNo: item.previousSbNo,
            r_iPrivousSbdate: item.previousSbDate, r_iPort_of_export: item.customPointCode, r_iNotificationNo: item.notificationNo,
            r_iNotificationSrlNo: item.notificationSrNo, r_iInvoiceNo_sb: item.invoiceNoSb, r_iItemNo_sb: item.itemNoSb,
            r_iExportInsurance: item.insuranceAmount, r_iExportFright: item.freightAmount, r_iCustomDuty: item.customDutyAmount,
            r_iExciseDuty: item.exciseAmount
        });
        setItemSwInfoSaveDsa(true);
        setItemSwInfoUpdateDsa(false);
        setItemSwInfoDeleteDsa(false);

        setItemSwInfoSve(false)
        setItemSwInfoUpd(false)
        setItemSwInfoDlt(false)
    }

    const editItemPortCodeDetails = (item) => {
        setItemDialogValues({ ...ItemDialogValues, r_iPort_of_export: item.customPointCode });
        ItemReImPortCodeCloshHandle();
    }

    const editItemNCDDutyDetails = (item) => {
        setItemDialogValues({
            ...ItemDialogValues, notofi_noId: item.notificationId, ncdDuty_notn_no: item.notificationNo,
            ncdDuty_notn_slNo: item.notificationSrNo, ncdDuty_rate: item.notificationRate, ncdDuty_amount: item.notificationAmount,
            ncdDuty_flag: item.notificationFlag, ncdDuty_UQC: item.notificationUnit
        });
        setItemSwInfoSaveDsa(true);
        setItemSwInfoUpdateDsa(false);
        setItemSwInfoDeleteDsa(false);

        setItemSwInfoSve(false)
        setItemSwInfoUpd(false)
        setItemSwInfoDlt(false)
    }

    const editItemSwProductionDetails = (item) => {
        setItemDialogValues({
            ...ItemDialogValues, notofi_noId: item.notificationId, swProd_prodIdtifier: item.prodIdentifier,
            swprod_Quantity: item.prodQty, Sw_Uqc: item.unitCode, swProd_manufacture: item.prodManDate, swprod_expiryDate: item.prodExpiryDate,
            swProd_beforeDate: item.prodBestDate
        });
        setItemSwInfoSaveDsa(true);
        setItemSwInfoUpdateDsa(false);
        setItemSwInfoDeleteDsa(false);

        setItemSwInfoSve(false)
        setItemSwInfoUpd(false)
        setItemSwInfoDlt(false)
    }
    const editItemManufactureDetails = (item) => {
        setItemDialogValues({
            ...ItemDialogValues, mnfctr_manufactureName: item.name, mnfctr_country: item.countryIdString,
            mnfctr_adress: item.address, mnfctr_manufactureCity: item.city, mnfctr_pincode: item.pincode,
            mnfctr_division: item.division, mnfctr_manufactureId: item.manufactureId
        });
        setItemSwInfoSaveDsa(true);
        setItemSwInfoUpdateDsa(false);
        setItemSwInfoDeleteDsa(false);

        setItemSwInfoSve(false)
        setItemSwInfoUpd(false)
        setItemSwInfoDlt(false)
    }

    const editItemSupplierDetails = (item) => {
        setItemDialogValues({
            ...ItemDialogValues, mnfctr_manufactureName: item.supplierName,
            mnfctr_country: item.supplierCountryName, mnfctr_adress: item.supplierAddress1,
            mnfctr_pincode: item.supplierPincode
        });
        ItemSupplierCloshHandle();
    }

    const editItemCustmNotnExmpDetails = (item) => {
        setItemDialogValues({
            ...ItemDialogValues, notofi_noId: item.notificationId, custm_notfiNo: item.notificationNo,
            custm_Sl_No: item.notificationSrNo, custm_rate: item.notificationRate, custm_amount: item.notificationAmount,
            custm_flag: item.notificationFlag, custm_uqc: item.notificationUnit
        });
        setItemSwInfoSaveDsa(true);
        setItemSwInfoUpdateDsa(false);
        setItemSwInfoDeleteDsa(false);

        setItemSwInfoSve(false)
        setItemSwInfoUpd(false)
        setItemSwInfoDlt(false)
    }
    const editItemOthrDutyDetails = (item) => {
        setItemDialogValues({
            ...ItemDialogValues, notofi_noId: item.notificationId, othrDuty_NotifiNo: item.notificationNo,
            othrDuty_NotifiSlNo: item.notificationSrNo, othrDuty_NotifiRate: item.notificationRate, othrDuty_Type: item.notificationType,
            othrDuty_NotifiAmount: item.notificationAmount, othrDuty_NotifiFlag: item.notificationFlag, othrDuty_uqc: item.notificationUnit
        });
        setItemSwInfoSaveDsa(true);
        setItemSwInfoUpdateDsa(false);
        setItemSwInfoDeleteDsa(false);

        setItemSwInfoSve(false)
        setItemSwInfoUpd(false)
        setItemSwInfoDlt(false)
    }

    const editItemOthrDutyNotifiDetails = (item) => {
        setItemDialogValues({
            ...ItemDialogValues, othrDuty_NotifiNo: item.notificationNo, othrDuty_NotifiSlNo: item.notificationSrNo,
            othrDuty_NotifiRate: item.notificationRate, othrDuty_NotifiAmount: item.notificationAmount, othrDuty_NotifiFlag: item.notificationFlag,
            othrDuty_uqc: item.notificationUnit, f_scheme_codeName: ''
        })
        setItemOtherDutyNotfiOpen(false);
        itemSchemeCodeDetails([]);
    }

    const editItemSwCntlDetails = (item) => {
        setItemDialogValues({
            ...ItemDialogValues, notofi_noId: item.notificationId, swcntl_typ_code: item.conType,
            swcntl_location: item.conLocation, swcntl_start_date: item.conStartDate, swcntl_end_date: item.conEndDate,
            swcntl_result_code: item.conResultCode, swcntl_result_text: item.conResultText, swcntl_measurnment: item.conMeasurnment,
            swcntl_uqc: item.unitCode, swcntl_sl_no: item.srNo
        });
        setItemSwInfoSaveDsa(true);
        setItemSwInfoUpdateDsa(false);
        setItemSwInfoDeleteDsa(false);

        setItemSwInfoSve(false)
        setItemSwInfoUpd(false)
        setItemSwInfoDlt(false)
    }
    const editItemSwStatemntDetails = (item) => {
        let details = { swStatementType: item.statementType }
        ItemService.getSwStatementCode(details).then(res => {
            setItemCusHusCode(res.data);
        });
        setItemDialogValues({
            ...ItemDialogValues, notofi_noId: item.notificationId, swStatmnt_typ: item.statementType,
            swStatment_code: item.statementCode, swStatment_text: item.statementText, swStmnt_dclrtiontypeMtnb: item.decType,
            swStatment_decNo: item.decNo, swStatment_date: item.decDate
        });
        setItemSwInfoSaveDsa(true);
        setItemSwInfoUpdateDsa(false);
        setItemSwInfoDeleteDsa(false);

        setItemSwInfoSve(false)
        setItemSwInfoUpd(false)
        setItemSwInfoDlt(false)
    }
    const editItemPolicyParaDetails = (item) => {
        setItemDialogValues({
            ...ItemDialogValues, notofi_noId: item.notificationId, policy_paraNo: item.policyParaNo,
            policy_paraYear: item.policyPeraYear
        });
        setItemSwInfoSaveDsa(true);
        setItemSwInfoUpdateDsa(false);
        setItemSwInfoDeleteDsa(false);

        setItemSwInfoSve(false)
        setItemSwInfoUpd(false)
        setItemSwInfoDlt(false)
    }

    const EditItemSwDocsTypeCodeDetails = (trns) => {
        setItemDialogValues({
            ...ItemDialogValues, DocTypeCode: trns.supDocType, FindDocumentName: '',
            FindDocumentType: ''
        });
        setitemdoctypecode_open(false);
    }

    const EditItemSwDocsIssuePrtyNameDetails = (trns) => {
        setItemDialogValues({
            ...ItemDialogValues, IssuePartyName: trns.supplierName,
            IssuePartyAddress1: trns.supplierAddress1, IssuePartyAddress2: trns.supplierAddress2,
            IssuePartyPincode: trns.supplierPincode, FindSupplierName: ''
        });
        setItemSwDocsSupplierNameOpen(false);
    }
    const EditItemSwDocsIecCodeDetails = (trns) => {
        setItemDialogValues({
            ...ItemDialogValues, ImporterIECCode: trns.importer_iec_no, ImporterIECName: trns.importer_name,
            FindImporterCode: '', FindImporterName: ''
        });
        setItemImporterDetailsOpen(false);
    }
    const EditItemSwDocsBrncSlNoDetails = (trns) => {
        setItemImporterDetailsOpen(false);
        setItemImporterBranchDetailsOpen(false);
        setItemAddHssDetailsopen(false);
        setItemDialogValues({
            ...ItemDialogValues, FindImporterState: '', ImporterIECCode: '', BranchSerialNo: '',
            BeneficiaryName: ItemDialogValues.ImporterIECName, BenificiaryAddress1: trns.importerAddress,
            BenificiaryAddress2: trns.importerAddress1, BenificiaryCity: trns.importer_city, BenificiaryPincode: trns.pincode
        })
    }

    const editItemSWDocsDetails = (item) => {
        setItemDialogValues({
            ...ItemDialogValues, notofi_noId: item.notificationId, ImageRefNo: item.imagRefNo,
            DocTypeCode: item.docType, IssuePartyName: item.issueName, PlaceOfIssue: item.docIssuePlace, DocReferenceNo: item.docRefNo,
            IssuePartyCode: item.issueCode, IssuePartyAddress1: item.issueAddress1, IssuePartyAddress2: item.issueAddress2, IssuePartyCity: item.issueCity,
            IssuePartyPincode: item.issuePincode, BenificiaryCode: item.beneficiaryCode, BeneficiaryName: item.beneficiaryName, BenificiaryAddress1: item.beneficiaryAddress1,
            BenificiaryAddress2: item.beneficiaryAddress2, BenificiaryCity: item.beneficiaryCity, BenificiaryPincode: item.beneficiaryPincode, FileType: item.fileType,
            DeclarationTypeMTNE: item.decType, DocIssueDate: item.docIssueDate, DocExpiryDate: item.docExpiryDate
        });
        setItemSchemeSaveDsa(true);
        setItemSchemeUpdateDsa(false);
        setItemSchemeDeleteDsa(false);

        setItemSchemeSve(false)
        setItemSchemeUpd(false)
        setItemSchemeDlt(false)
    }

    //-----------rest-Item----
    const resetitem = () => {
        setSelected([]);  setItemIdSlct([]);setItemId(''); 
        setItemValues({...ItemValues, item_id: 0, item_sl_no: '', txt_item_Desc: '', txt_ritc: '', txt_cth: '', genericDesc: '', txt_rate_typeSP: '', txt_ceth: '', txt_quantity: '',
            txt_unit: '', txt_unitPrice: '', txt_currency: invoicevalues.Currency, txt_totAmount: '', txt_endusCode: '', txt_originCntry: '', txt_originCntryName: '', txt_brand: 'NA', txt_model_no: 'NA',
            txt_acessory: 0, txt_sourceCountry: '', txt_sourceCountryName: '', txt_transit_country: '', txt_transit_countryName: '', txt_exRate: '', bcd_notfication_no: '',
            bcd_sl_no: '', bcd_rate_no: '', bcd_flg_no: '', bcd_amount_no: '', bcd_uqc_no: '', aidc_notfication_no: '011/2021', aidc_sl_no: '17', aidc_rate_no: '',
            aidc_flg_no: '', aidc_amount_no: '', aidc_uqc_no: '', sws_notfication_no: '', sws_sl_no: '', sws_rate_no: '', sws_flg_no: '', sws_amount_no: '', sws_uqc_no: '', cvd_notfication_no: '',
            cvd_sl_no: '', cvd_rate_no: '', cvd_flg_no: '', cvd_amount_no: '', cvd_uqc_no: '', edu_css_notfication_no: '', edu_css_sl_no: '', edu_css_rate_no: '', edu_css_flg_no: '',
            edu_css_amount_no: '', edu_css_uqc_no: '', schemeCodeY_N: 'N', licence_y_n: 'N', Re_importY_n: "N", svb_status_y_N: 'N', manufactureY_N: 'Y', cust_Notn_exmptY_n: 'N', anti_dumbing_duty_Y_N: 'N',
            rsp_Y_N_Q_T_D_C: 'N', ncdCustomDuty_Y_N: 'N', otherDuty_Y_N: 'N', scDuty_Y_N: 'N', IGSTDuty_Y_N: 'Y', swinfo_Y_N: 'Y', swConstitutent_Y_N: 'N', swProduction_Y_N: 'N',
            swControl_Y_N: 'N', swStatementY_N: 'N', swSuportDoc_Y_N: 'Y', PolicyPara_Y_N: 'N', igstduty_type: 'G', igstduty_Add_type: 'I', igstduty_flagG_C: 'G', igstduty_notfion_no: '001/2017',
            igstduty_sl_no: '', igstduty_rate: '', igstduty_flg: '', igstduty_amount: '', igstduty_uqc: '', igstduty_exmpNotn_no: '', igstduty_sl_no2: '', igstcess_type: 'G',
            igstcess_Add_type: 'I', igstcess_flagG_C: 'G', igstcess_notfion_no: '001/2017', igstcess_sl_no: '', igstcess_rate: '', igstcess_flg: '', igstcess_amount: '',
        }); setItemDialogValues({
            ...ItemDialogValues, mnfctr_manufactureName: invoicevalues.SupplierName, mnfctr_country: invoicevalues.disable_supcountry_Name,
            mnfctr_adress: invoicevalues.Address1, mnfctr_pincode: invoicevalues.PinCode
        })
        let details2 = { invoiceId: invoicevalues.InvoiceId }
        ItemService.getInvoiceSummary(details2).then(res => {
            const data = res.data; const summury = data.map((item) => item);
            if (!summury[0]) {
                setItemSummury({
                    ...ItemSummury, invoiceValue: '', terms: '', exchangeRate: '', currency: '', fright: '', insurence: '', misc: '',
                    loadinng: '', totalValue: '', totalAmount: '', totalDuty: '', ass: '0.00', bcd: '0.00', cvd: '0.00', sws: '0.00', gst: '0.00', duty: '0.00', itm_fright: '0.00', itm_insurence: '0.00',
                    itm_misc: '0.00', itm_loadinng: '0.00', itm_totalValue: '0.00'
                })
            } else {
                setItemSummury({
                    ...ItemSummury, invoiceValue: summury[0].invoiceValue, exchangeRate: summury[0].exchangeRate, terms: summury[0].terms_code, currency: summury[0].currency_code, fright: summury[0].freightAmount,
                    insurence: summury[0].insuranceAmount, misc: summury[0].miscAmount, loadinng: summury[0].loadingValue, totalValue: summury[0].totalItemAmount, totalAmount: summury[0].totalAssableAmount,
                    totalDuty: summury[0].totalDutyAmount, itm_fright: '0.00', itm_insurence: '0.00', itm_misc: '0.00', itm_loadinng: '0.00', itm_totalValue: '0.00', ass: '0.00', bcd: '0.00',
                    cvd: '0.00', sws: '0.00', gst: '0.00', duty: '0.00'
                });
            }
        }).catch(error => { setMessage(error.message); setSeverity('error'); setOpenSnack(true); })
        setItemSaveItemDsa(false); setItemUpdateItemDsa(true); setItemDeleteItemDsa(true); setItemBEfileItemDsa(false); setItemCheackListItemDsa(false);
        setItemSve(false); setItemUpd(false); setItemDlt(false); setItemBEprnt(false); setItemCheacklistprnt(false);
        let detailslice = { invoiceId: invoicevalues.InvoiceId, flag: 1, itemSrNo: '-1' }
        ItemService.getCommercialItem(detailslice).then(res => { setItemDetails(res.data); }); document.getElementById('itemDesc').focus();
    }
    const removeiteopen = () => { setRemoveItemHiden(false); setSelectedInvoice([]); setremoItemValue(''); }
    const Backitemeopen = () => { setRemoveItemHiden(true); setSelectedInvoice([]); setremoItemValue(''); }
    const DeleteItemDesc = () => {
        var itemDesc = []; var hscode = [];
        const itmdetails = itemDescDetails.map((itm) => itm)
        for (let i = 0; i < remoItemValue.length; i++) {
            itemDesc = itemDesc.concat(itmdetails[remoItemValue[i]].item_description.toString());
            hscode = hscode.concat(itmdetails[remoItemValue[i]].ritc.toString());
        }
        let details = { itemName: itemDesc.toString(), hsCode: hscode.toString() }
        ItemService.updateItemActiveStatus(details).then(res => {
            const message = res.data.message
            if (message.toString() === 'SUCCESS') {
                setMessage(message.toString()); setSeverity('success'); setOpenSnack(true);
                var itemName = '';
                if (ItemValues.txt_item_Desc === '') { itemName = '-1' } else { itemName = ItemValues.txt_item_Desc; }
                ItemService.getItemNameSearch(itemName, '1').then(res => { setItemDescDetails(res.data) })
            }
            else { setMessage(message.toString()); setSeverity('error'); setOpenSnack(true); } setSelectedInvoice([]); setremoItemValue('')
        }).catch(error => {
            setMessage(error.message); setSeverity('error'); setOpenSnack(true); setSelectedInvoice([]); setremoItemValue('')
        }); setSelectedInvoice([]); setremoItemValue('')
    }
    /** */const [selectedInvoice, setSelectedInvoice] = useState([]);
    const [remoItemValue, setremoItemValue] = useState('')
    const AllInvoiceBasedIgmHandle = (event) => {
        if (event.target.checked) {
            const ALLItem = itemDescDetails.map((n, i) => i);
            setSelectedInvoice(ALLItem);
            setremoItemValue(ALLItem)
            return;
        }
        setSelectedInvoice([]);
    };

    const SlectedInvoiClick = (event, i) => {
        const selectedIndex = selectedInvoice.indexOf(i);
        let SelectedInvc = [];

        if (selectedIndex === -1) {
            SelectedInvc = SelectedInvc.concat(selectedInvoice, i);
            setremoItemValue(SelectedInvc)
        }
        else if (selectedIndex === 0) {
            SelectedInvc = SelectedInvc.concat(selectedInvoice.slice(1));
            setremoItemValue(SelectedInvc)
        }
        else if (selectedIndex === selectedInvoice.length - 1) {
            SelectedInvc = SelectedInvc.concat(selectedInvoice.slice(0, -1));
            setremoItemValue(SelectedInvc)
        }
        else if (selectedIndex > 0) {
            SelectedInvc = SelectedInvc.concat(selectedInvoice.slice(0, selectedIndex), selectedInvoice.slice(selectedIndex + 1),);
            setremoItemValue(SelectedInvc)
        }
        setSelectedInvoice(SelectedInvc);
    };
    const isInvoiceSelected = (cartonId) => selectedInvoice.indexOf(cartonId) !== -1;

    const [selected, setSelected] = useState([]);

    const AllMAWBHandle = (event) => {
        if (event.target.checked) {
            const ALLMawb = itemDetails.map((n) => n.itemId);
            setSelected(ALLMawb);
            setItemIdSlct(ALLMawb)
            return;
        }
        setSelected([]);
    };

    const SlectedMAWBClick = (item) => {
        setItemId(item.itemId); getCommercialItemAssign(item.itemId);
        getItemSummary(item.itemId); setItemSaveItemDsa(true);
        setItemUpdateItemDsa(false); setItemDeleteItemDsa(false);
        const selectedIndex = selected.indexOf(item.itemId);  setQuryIndex(0);
        let SelectedMawb = [];
        if (selectedIndex === -1) {
            SelectedMawb = SelectedMawb.concat(selected, item.itemId); 
            setItemIdSlct(SelectedMawb);
            // console.log('kjkjkj '+JSON.stringify(SelectedMawb))
        }
        else if (selectedIndex === 0) {
            SelectedMawb = SelectedMawb.concat(selected.slice(1));
            setItemIdSlct(SelectedMawb);
        }
        else if (selectedIndex === selected.length - 1) {
            SelectedMawb = SelectedMawb.concat(selected.slice(0, -1));
            setItemIdSlct(SelectedMawb);
        }
        else if (selectedIndex > 0) {
            SelectedMawb = SelectedMawb.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1),);
            setItemIdSlct(SelectedMawb);
        }
        setSelected(SelectedMawb);
    };

    const itemItemDescDialogTblKeyDown=(e)=>{const mydata = itemDescDetails.map(node=>node);var selectdetails = [];
        if(e.key==='ArrowDown'){ selectdetails = (ItemSelect ,mydata[QuryIndex+1].item_description); setItemSelect(selectdetails);setQuryIndex(QuryIndex+1);}
        else if(e.key==='ArrowUp'){selectdetails = (ItemSelect ,mydata[QuryIndex-1].item_description); setItemSelect(selectdetails);setQuryIndex(QuryIndex-1);}
        else if(e.key==='Enter'){editItemDescDetails(mydata[QuryIndex]);}
    }

    const itemDialogTblKeyDown=(e,type)=>{const mydata = itemRitcDetails.map(node=>node);var selectdetails = [];
        if(e.key==='ArrowDown'){ 
            if(type==='ritc'||type==='cth'||type==='ceth'){selectdetails = (ItemSelect ,mydata[QuryIndex+1].hsCode); setItemSelect(selectdetails);setQuryIndex(QuryIndex+1);}
            else if(type==='unitcode'){selectdetails = (ItemSelect ,mydata[QuryIndex+1].unitCode); setItemSelect(selectdetails);setQuryIndex(QuryIndex+1);}
            else if(type==='curruncy'){selectdetails = (ItemSelect ,mydata[QuryIndex+1].currency_code); setItemSelect(selectdetails);setQuryIndex(QuryIndex+1);}
            else if(type==='EndUseCode'){selectdetails = (ItemSelect ,mydata[QuryIndex+1].endUseCode); setItemSelect(selectdetails);setQuryIndex(QuryIndex+1);}
            else if(type==='originCntry' || type==='SourceCntry'||type==='transitCntry'){selectdetails = (ItemSelect ,mydata[QuryIndex+1].countryIdString); setItemSelect(selectdetails);setQuryIndex(QuryIndex+1);}
            else if(type==='BCDNotification'||type==='AIDC_Notification' ||type==='SWS_Notification'||type==='CVD_Notification'||type==='EDU_Notification'){selectdetails = (ItemSelect ,mydata[QuryIndex+1].notificationId.toString()); setItemSelect(selectdetails);setQuryIndex(QuryIndex+1);}
            else if(type==='IGST_Notification'||type==='IGST_CessNotification'||type==='Exc_notn'){selectdetails = (ItemSelect ,mydata[QuryIndex+1].notificationId.toString()); setItemSelect(selectdetails);setQuryIndex(QuryIndex+1);}
            else if(type==='ShemaCode'){selectdetails = (ItemSelect ,mydata[QuryIndex+1].schemeCode); setItemSelect(selectdetails);setQuryIndex(QuryIndex+1);}
            else if(type==='AuntiDumDuty'){selectdetails = (ItemSelect ,mydata[QuryIndex+1].notificationNo); setItemSelect(selectdetails);setQuryIndex(QuryIndex+1);}
            else if(type==='Sw_type'){selectdetails = (ItemSelect ,mydata[QuryIndex+1].swType); setItemSelect(selectdetails);setQuryIndex(QuryIndex+1);}
            else if(type==='licenceDetails'){selectdetails = (ItemSelect ,mydata[QuryIndex+1].licenceRegNo); setItemSelect(selectdetails);setQuryIndex(QuryIndex+1);}
            else if(type==='sw_content'){selectdetails = (ItemSelect ,mydata[QuryIndex+1].consName); setItemSelect(selectdetails);setQuryIndex(QuryIndex+1);}
            else if(type==='rsp_dutyAdd'){selectdetails = (ItemSelect ,mydata[QuryIndex+1].notificationNo); setItemSelect(selectdetails);setQuryIndex(QuryIndex+1);}
            else if(type==='re_import'){selectdetails = (ItemSelect ,mydata[QuryIndex+1].previousSbNo); setItemSelect(selectdetails);setQuryIndex(QuryIndex+1);}
            else if(type==='ncd_duty'){selectdetails = (ItemSelect ,mydata[QuryIndex+1].notificationNo); setItemSelect(selectdetails);setQuryIndex(QuryIndex+1);}
            else if(type==='Sw_production'){selectdetails = (ItemSelect ,mydata[QuryIndex+1].prodIdentifier); setItemSelect(selectdetails);setQuryIndex(QuryIndex+1);}
            else if(type==='add_mnfctr_details'){selectdetails = (ItemSelect ,mydata[QuryIndex+1].name); setItemSelect(selectdetails);setQuryIndex(QuryIndex+1);}
            else if(type==='add_custom_notn'){selectdetails = (ItemSelect ,mydata[QuryIndex+1].notificationNo); setItemSelect(selectdetails);setQuryIndex(QuryIndex+1);}
            else if(type==='othrDutyChrg'){selectdetails = (ItemSelect ,mydata[QuryIndex+1].notificationNo); setItemSelect(selectdetails);setQuryIndex(QuryIndex+1);}
            else if(type==='SpclDutyChrg'){selectdetails = (ItemSelect ,mydata[QuryIndex+1].notificationNo); setItemSelect(selectdetails);setQuryIndex(QuryIndex+1);}
            else if(type==='swControll'){selectdetails = (ItemSelect ,mydata[QuryIndex+1].conType); setItemSelect(selectdetails);setQuryIndex(QuryIndex+1);}
            else if(type==='swStatement'){selectdetails = (ItemSelect ,mydata[QuryIndex+1].statementType); setItemSelect(selectdetails);setQuryIndex(QuryIndex+1);}
            else if(type==='policyPara'){selectdetails = (ItemSelect ,mydata[QuryIndex+1].policyParaNo); setItemSelect(selectdetails);setQuryIndex(QuryIndex+1);}
            else if(type==='Sw_docs'){selectdetails = (ItemSelect ,mydata[QuryIndex+1].docType); setItemSelect(selectdetails);setQuryIndex(QuryIndex+1);}
        }
        else if(e.key==='ArrowUp'){
            if(type==='ritc'||type==='cth'||type==='ceth'){ selectdetails = (ItemSelect ,mydata[QuryIndex-1].hsCode); setItemSelect(selectdetails);setQuryIndex(QuryIndex-1);}
            else if(type==='unitcode'){ selectdetails = (ItemSelect ,mydata[QuryIndex-1].unitCode); setItemSelect(selectdetails);setQuryIndex(QuryIndex-1);}
            else if(type==='curruncy'){ selectdetails = (ItemSelect ,mydata[QuryIndex-1].currency_code); setItemSelect(selectdetails);setQuryIndex(QuryIndex-1);}
            else if(type==='EndUseCode'){ selectdetails = (ItemSelect ,mydata[QuryIndex-1].endUseCode); setItemSelect(selectdetails);setQuryIndex(QuryIndex-1);}
            else if(type==='originCntry'|| type==='SourceCntry'|| type==='transitCntry'){ selectdetails = (ItemSelect ,mydata[QuryIndex-1].countryIdString); setItemSelect(selectdetails);setQuryIndex(QuryIndex-1);}
            else if(type==='BCDNotification' || type==='AIDC_Notification'||type==='SWS_Notification'||type==='CVD_Notification'||type==='EDU_Notification'){ selectdetails = (ItemSelect ,mydata[QuryIndex-1].notificationId.toString()); setItemSelect(selectdetails);setQuryIndex(QuryIndex-1);}
            else if(type==='IGST_Notification'||type==='IGST_CessNotification'||type==='Exc_notn'){ selectdetails = (ItemSelect ,mydata[QuryIndex-1].notificationId.toString()); setItemSelect(selectdetails);setQuryIndex(QuryIndex-1);}
            else if(type==='ShemaCode'){ selectdetails = (ItemSelect ,mydata[QuryIndex-1].schemeCode); setItemSelect(selectdetails);setQuryIndex(QuryIndex-1);}
            else if(type==='AuntiDumDuty'){ selectdetails = (ItemSelect ,mydata[QuryIndex-1].notificationNo); setItemSelect(selectdetails);setQuryIndex(QuryIndex-1);}
            else if(type==='Sw_type'){ selectdetails = (ItemSelect ,mydata[QuryIndex-1].swType); setItemSelect(selectdetails);setQuryIndex(QuryIndex-1);}
            else if(type==='licenceDetails'){ selectdetails = (ItemSelect ,mydata[QuryIndex-1].licenceRegNo); setItemSelect(selectdetails);setQuryIndex(QuryIndex-1);}
            else if(type==='sw_content'){ selectdetails = (ItemSelect ,mydata[QuryIndex-1].consName); setItemSelect(selectdetails);setQuryIndex(QuryIndex-1);}
            else if(type==='rsp_dutyAdd'){ selectdetails = (ItemSelect ,mydata[QuryIndex-1].notificationNo); setItemSelect(selectdetails);setQuryIndex(QuryIndex-1);}
            else if(type==='re_import'){ selectdetails = (ItemSelect ,mydata[QuryIndex-1].previousSbNo); setItemSelect(selectdetails);setQuryIndex(QuryIndex-1);}
            else if(type==='ncd_duty'){ selectdetails = (ItemSelect ,mydata[QuryIndex-1].notificationNo); setItemSelect(selectdetails);setQuryIndex(QuryIndex-1);}
            else if(type==='Sw_production'){ selectdetails = (ItemSelect ,mydata[QuryIndex-1].prodIdentifier); setItemSelect(selectdetails);setQuryIndex(QuryIndex-1);}
            else if(type==='add_mnfctr_details'){ selectdetails = (ItemSelect ,mydata[QuryIndex-1].name); setItemSelect(selectdetails);setQuryIndex(QuryIndex-1);}
            else if(type==='add_custom_notn'){ selectdetails = (ItemSelect ,mydata[QuryIndex-1].notificationNo); setItemSelect(selectdetails);setQuryIndex(QuryIndex-1);}
            else if(type==='othrDutyChrg'){ selectdetails = (ItemSelect ,mydata[QuryIndex-1].notificationNo); setItemSelect(selectdetails);setQuryIndex(QuryIndex-1);}
            else if(type==='SpclDutyChrg'){ selectdetails = (ItemSelect ,mydata[QuryIndex-1].notificationNo); setItemSelect(selectdetails);setQuryIndex(QuryIndex-1);}
            else if(type==='swControll'){ selectdetails = (ItemSelect ,mydata[QuryIndex-1].conType); setItemSelect(selectdetails);setQuryIndex(QuryIndex-1);}
            else if(type==='swStatement'){ selectdetails = (ItemSelect ,mydata[QuryIndex-1].statementType); setItemSelect(selectdetails);setQuryIndex(QuryIndex-1);}
            else if(type==='policyPara'){ selectdetails = (ItemSelect ,mydata[QuryIndex-1].policyParaNo); setItemSelect(selectdetails);setQuryIndex(QuryIndex-1);}
            else if(type==='Sw_docs'){ selectdetails = (ItemSelect ,mydata[QuryIndex-1].docType); setItemSelect(selectdetails);setQuryIndex(QuryIndex-1);}
        }
        else if(e.key==='Enter'){
            if(type==='ritc'){editItemRitcDetails(mydata[QuryIndex]);} else if(type==='cth'){editItemCthDetails(mydata[QuryIndex]);} else if(type==='ceth'){editItemCethDetails(mydata[QuryIndex]);}
            else if(type==='unitcode'){editItemUnitDetails(mydata[QuryIndex]);} else if(type==='curruncy'){editItemCurrencyDetails(mydata[QuryIndex]);} else if(type==='EndUseCode'){editItemEndUseDetails(mydata[QuryIndex]);} 
            else if(type==='originCntry'){editItemOriginCntryDetails(mydata[QuryIndex]);} else if(type==='SourceCntry'){editItemSourceCntryDetails(mydata[QuryIndex]);} else if(type==='transitCntry'){editItemTransitCntryDetails(mydata[QuryIndex]);}
            else if(type==='BCDNotification'){editItemBcdNotifinoDetails(mydata[QuryIndex]);} else if(type==='AIDC_Notification'){editItemAidcNotifinoDetails(mydata[QuryIndex]);}
            else if(type==='SWS_Notification'){editItemSWSNotifinoDetails(mydata[QuryIndex]);}else if(type==='CVD_Notification'){editItemCVDNotifinoDetails(mydata[QuryIndex]);}
            else if(type==='EDU_Notification'){editItemEDUCessNotifinoDetails(mydata[QuryIndex]);} else if(type==='IGST_Notification'){editItemIgstDutyNotifinoDetails(mydata[QuryIndex]);}
            else if(type==='IGST_CessNotification'){editItemIgstCessNotifinoDetails(mydata[QuryIndex]);} else if(type==='Exc_notn'){editItemIgstDutyExmpNotifinoDetails(mydata[QuryIndex]);}else if(type==='ShemaCode'){editItemSchemeCodeDetails(mydata[QuryIndex]);}
            else if(type==='AuntiDumDuty'){editItemAuntiDumpingDetails(mydata[QuryIndex]);} else if(type==='Sw_type'){editItemSwInfoDetails(mydata[QuryIndex]);} else if(type==='licenceDetails'){editItemLicenceDetails(mydata[QuryIndex]);}
            else if(type==='sw_content'){editItemSwConstiuentDetails(mydata[QuryIndex]);} else if(type==='rsp_dutyAdd'){editItemRspDetails(mydata[QuryIndex]);}   else if(type==='re_import'){editItemReImpDetails(mydata[QuryIndex]);}
            else if(type==='ncd_duty'){editItemNCDDutyDetails(mydata[QuryIndex]);}     else if(type==='Sw_production'){editItemSwProductionDetails(mydata[QuryIndex]);}
            else if(type==='add_mnfctr_details'){editItemManufactureDetails(mydata[QuryIndex]);} else if(type==='add_custom_notn'){editItemCustmNotnExmpDetails(mydata[QuryIndex]);}
            else if(type==='othrDutyChrg'){editItemOthrDutyDetails(mydata[QuryIndex]);}  else if(type==='SpclDutyChrg'){editItemCustmNotnExmpDetails(mydata[QuryIndex]);}
            else if(type==='swControll'){editItemSwCntlDetails(mydata[QuryIndex]);}   else if(type==='swStatement'){editItemSwStatemntDetails(mydata[QuryIndex]);}
            else if(type==='policyPara'){editItemPolicyParaDetails(mydata[QuryIndex]);} else if(type==='Sw_docs'){editItemSWDocsDetails(mydata[QuryIndex]);}
        }
    }
    const itemDialogSchemeCodeTblKeyDown=(e,type)=>{const mydata = itemSchemeCodeDetails.map(node=>node);var selectdetails = [];
        if(e.key==='ArrowDown'){ 
            if(type==='schemecode'){selectdetails = (ItemSelect ,mydata[QuryIndex+1].schemeCode); setItemSelect(selectdetails);setQuryIndex(QuryIndex+1);}
            else if(type==='igstNotn'){selectdetails = (ItemSelect ,mydata[QuryIndex+1].notificationNo); setItemSelect(selectdetails);setQuryIndex(QuryIndex+1);}
            else if(type==='AuntiDumb'){selectdetails = (ItemSelect ,mydata[QuryIndex+1].notificationNo); setItemSelect(selectdetails);setQuryIndex(QuryIndex+1);}
            else if(type==='FindLicenceCode'){selectdetails = (ItemSelect ,mydata[QuryIndex+1].schemeCode); setItemSelect(selectdetails);setQuryIndex(QuryIndex+1);}
            else if(type==='FindLicencePort'){selectdetails = (ItemSelect ,mydata[QuryIndex+1].customHouseCode); setItemSelect(selectdetails);setQuryIndex(QuryIndex+1);}
            else if(type==='re_import_port'){selectdetails = (ItemSelect ,mydata[QuryIndex+1].customPointCode); setItemSelect(selectdetails);setQuryIndex(QuryIndex+1);}
            else if(type==='FindMnfctrSup'){selectdetails = (ItemSelect ,mydata[QuryIndex+1].supplierName); setItemSelect(selectdetails);setQuryIndex(QuryIndex+1);}
            else if(type==='othrDutIgstNoti'){selectdetails = (ItemSelect ,mydata[QuryIndex+1].notificationNo); setItemSelect(selectdetails);setQuryIndex(QuryIndex+1);}
            else if(type==='Find_Doc_typ'){selectdetails = (ItemSelect ,mydata[QuryIndex+1].supDocType); setItemSelect(selectdetails);setQuryIndex(QuryIndex+1);}
            else if(type==='FindDoc_SupName'){selectdetails = (ItemSelect ,mydata[QuryIndex+1].supplierName); setItemSelect(selectdetails);setQuryIndex(QuryIndex+1);}
            else if(type==='FindDoc_ImpName'){selectdetails = (ItemSelect ,mydata[QuryIndex+1].importer_iec_no); setItemSelect(selectdetails);setQuryIndex(QuryIndex+1);}
            else if(type==='FindDoc_ImpBrnch'){selectdetails = (ItemSelect ,mydata[QuryIndex+1].branch_sl_no); setItemSelect(selectdetails);setQuryIndex(QuryIndex+1);}
          }
        else if(e.key==='ArrowUp'){
            if(type==='schemecode'){ selectdetails = (ItemSelect ,mydata[QuryIndex-1].schemeCode); setItemSelect(selectdetails);setQuryIndex(QuryIndex-1);}
            else if(type==='igstNotn'){ selectdetails = (ItemSelect ,mydata[QuryIndex-1].notificationNo); setItemSelect(selectdetails);setQuryIndex(QuryIndex-1);}
            else if(type==='AuntiDumb'){ selectdetails = (ItemSelect ,mydata[QuryIndex-1].notificationNo); setItemSelect(selectdetails);setQuryIndex(QuryIndex-1);}
            else if(type==='FindLicenceCode'){ selectdetails = (ItemSelect ,mydata[QuryIndex-1].schemeCode); setItemSelect(selectdetails);setQuryIndex(QuryIndex-1);}
            else if(type==='FindLicencePort'){ selectdetails = (ItemSelect ,mydata[QuryIndex-1].customHouseCode); setItemSelect(selectdetails);setQuryIndex(QuryIndex-1);}
            else if(type==='re_import_port'){ selectdetails = (ItemSelect ,mydata[QuryIndex-1].customPointCode); setItemSelect(selectdetails);setQuryIndex(QuryIndex-1);}
            else if(type==='FindMnfctrSup'){ selectdetails = (ItemSelect ,mydata[QuryIndex-1].supplierName); setItemSelect(selectdetails);setQuryIndex(QuryIndex-1);}
            else if(type==='othrDutIgstNoti'){ selectdetails = (ItemSelect ,mydata[QuryIndex-1].notificationNo); setItemSelect(selectdetails);setQuryIndex(QuryIndex-1);}
            else if(type==='Find_Doc_typ'){ selectdetails = (ItemSelect ,mydata[QuryIndex-1].supDocType); setItemSelect(selectdetails);setQuryIndex(QuryIndex-1);}
            else if(type==='FindDoc_SupName'){ selectdetails = (ItemSelect ,mydata[QuryIndex-1].supplierName); setItemSelect(selectdetails);setQuryIndex(QuryIndex-1);}
            else if(type==='FindDoc_ImpName'){ selectdetails = (ItemSelect ,mydata[QuryIndex-1].importer_iec_no); setItemSelect(selectdetails);setQuryIndex(QuryIndex-1);}
            else if(type==='FindDoc_ImpBrnch'){ selectdetails = (ItemSelect ,mydata[QuryIndex-1].branch_sl_no); setItemSelect(selectdetails);setQuryIndex(QuryIndex-1);}
         }
        else if(e.key==='Enter'){
            if(type==='schemecode'){editItemSchemeDetails(mydata[QuryIndex]);} else if(type==='igstNotn'){editItemSchemeNotifiDetails(mydata[QuryIndex]);} else if(type==='AuntiDumb'){editItemAuntiNotifiDetails(mydata[QuryIndex]);}
            else if(type==='FindLicenceCode'){editItemLicenceCodeDetails(mydata[QuryIndex]);}  else if(type==='FindLicencePort'){editItemLicencePortDetails(mydata[QuryIndex]);}
            else if(type==='re_import_port'){editItemPortCodeDetails(mydata[QuryIndex]);}  else if(type==='FindMnfctrSup'){editItemSupplierDetails(mydata[QuryIndex]);}
            else if(type==='othrDutIgstNoti'){editItemOthrDutyNotifiDetails(mydata[QuryIndex]);} else if(type==='Find_Doc_typ'){EditItemSwDocsTypeCodeDetails(mydata[QuryIndex]);}
            else if(type==='FindDoc_SupName'){EditItemSwDocsIssuePrtyNameDetails(mydata[QuryIndex]);} else if(type==='FindDoc_ImpName'){EditItemSwDocsIecCodeDetails(mydata[QuryIndex]);}
            else if(type==='FindDoc_ImpBrnch'){EditItemSwDocsBrncSlNoDetails(mydata[QuryIndex]);}
            }
    }
    const itemTblDetailsKeyDownHed=(e)=>{const mydata = itemDetails.map(node=>node);
        if(e.key==='ArrowDown'){ SlectedMAWBClick(mydata[0]);setQuryIndex(0);  }
    }
    const itemTblDetailsKeyDown=(e)=>{const mydata = itemDetails.map(node=>node);
        if(e.key==='ArrowDown'){ SlectedMAWBClick(mydata[QuryIndex+1]);setQuryIndex(QuryIndex+1);  }
        else if(e.key==='ArrowUp'){ SlectedMAWBClick(mydata[QuryIndex-1]);setQuryIndex(QuryIndex-1);  }
        else if(e.key==='Enter'){ EditItemDetails(mydata[QuryIndex]);} 
    }

    const itemDialogItemdescKeyDownHandleHandle = (e) => {const mydata = itemDescDetails.map(node=>node);
         if (e.key === 'Enter') { document.getElementById('itemItemDescTbl').focus(); 
    setQuryIndex(0);var selectdetails = [];selectdetails = (ItemSelect ,mydata[0].item_description); setItemSelect(selectdetails);}
 }
    const ItemDialogFindRitcNameKeydown = (e) => {const mydata = itemRitcDetails.map(node=>node);
         if (e.key === 'Enter') { document.getElementById('ItemRitc').focus(); 
    setQuryIndex(0);var selectdetails = [];selectdetails = (ItemSelect ,mydata[0].hsCode); setItemSelect(selectdetails);}
 }
    const ItemDialogFindCthNameKeydown = (e) => {const mydata = itemRitcDetails.map(node=>node);
         if (e.key === 'Enter') { document.getElementById('ItemCth').focus(); 
    setQuryIndex(0);var selectdetails = [];selectdetails = (ItemSelect ,mydata[0].hsCode); setItemSelect(selectdetails);}
 }
    const ItemDialogFindCethNameKeydown = (e) => {const mydata = itemRitcDetails.map(node=>node);
         if (e.key === 'Enter') { document.getElementById('ItemCeth').focus(); 
    setQuryIndex(0);var selectdetails = [];selectdetails = (ItemSelect ,mydata[0].hsCode); setItemSelect(selectdetails);}
 }
    const ItemDialogFindUnitNameKeydown = (e) => {const mydata = itemRitcDetails.map(node=>node);
         if (e.key === 'Enter') { document.getElementById('ItemUnitCode_id').focus(); 
    setQuryIndex(0);var selectdetails = [];selectdetails = (ItemSelect ,mydata[0].unitCode); setItemSelect(selectdetails);}
 }
    const ItemDialogFindExchangeNameKeydown = (e) => {const mydata = itemRitcDetails.map(node=>node);
         if (e.key === 'Enter') { document.getElementById('ItemCurruncyCode_id').focus(); 
    setQuryIndex(0);var selectdetails = [];selectdetails = (ItemSelect ,mydata[0].currency_code); setItemSelect(selectdetails);}
 }
    const ItemDialogFindEndNameKeydown = (e) => {const mydata = itemRitcDetails.map(node=>node);
         if (e.key === 'Enter') { document.getElementById('ItemEndUseCodeCode_id').focus(); 
    setQuryIndex(0);var selectdetails = [];selectdetails = (ItemSelect ,mydata[0].endUseCode); setItemSelect(selectdetails);}
 }
    const ItemDialogFindOriginCountryNameKeydown = (e) => {const mydata = itemRitcDetails.map(node=>node);
         if (e.key === 'Enter') { document.getElementById('ItemOriginCountry_id').focus(); 
    setQuryIndex(0);var selectdetails = [];selectdetails = (ItemSelect ,mydata[0].countryIdString); setItemSelect(selectdetails);}
 }
    const ItemDialogFindSourceCountryNameKeydown = (e) => {const mydata = itemRitcDetails.map(node=>node);
         if (e.key === 'Enter') { document.getElementById('ItemSourceCountry_id').focus(); 
    setQuryIndex(0);var selectdetails = [];selectdetails = (ItemSelect ,mydata[0].countryIdString); setItemSelect(selectdetails);}
 }
    const ItemDialogFindTransiteCountryNameKeydown = (e) => {const mydata = itemRitcDetails.map(node=>node);
         if (e.key === 'Enter') { document.getElementById('ItemTransitCntry_id').focus(); 
    setQuryIndex(0);var selectdetails = [];selectdetails = (ItemSelect ,mydata[0].countryIdString); setItemSelect(selectdetails);}
 }
    const ItemDialogBCDFindNotifiCationSrlNoKeydown = (e) => {const mydata = itemRitcDetails.map(node=>node);
         if (e.key === 'Enter') { document.getElementById('ItemBCDNotification_id').focus(); 
    setQuryIndex(0);var selectdetails = [];selectdetails = (ItemSelect ,mydata[0].notificationId.toString()); setItemSelect(selectdetails);}
 }
    const ItemDialogAIDCFindNotifiCationSrlNoKeydown = (e) => {const mydata = itemRitcDetails.map(node=>node);
         if (e.key === 'Enter') { document.getElementById('ItemAIDC_Notification_id').focus(); 
    setQuryIndex(0);var selectdetails = [];selectdetails = (ItemSelect ,mydata[0].notificationId.toString()); setItemSelect(selectdetails);}
 }
    const ItemDialogSWsFindNotifiCationSrlNoKeydown = (e) => {const mydata = itemRitcDetails.map(node=>node);
         if (e.key === 'Enter') { document.getElementById('ItemSws_Notification_id').focus(); 
    setQuryIndex(0);var selectdetails = [];selectdetails = (ItemSelect ,mydata[0].notificationId.toString()); setItemSelect(selectdetails);}
 }
    const ItemDialogCvdFindNotifiCationSrlNoKeydown = (e) => {const mydata = itemRitcDetails.map(node=>node);
         if (e.key === 'Enter') { document.getElementById('ItemCVD_Notification_id').focus(); 
    setQuryIndex(0);var selectdetails = [];selectdetails = (ItemSelect ,mydata[0].notificationId.toString()); setItemSelect(selectdetails);}
 }
    const ItemDialogEDUCessFindNotifiCationSrlNoKeydown = (e) => {const mydata = itemRitcDetails.map(node=>node);
         if (e.key === 'Enter') { document.getElementById('ItemEDU_Notification_id').focus(); 
    setQuryIndex(0);var selectdetails = [];selectdetails = (ItemSelect ,mydata[0].notificationId.toString()); setItemSelect(selectdetails);}
 }
    const ItemDialogIGSTFindNotifiCationSrlNoKeydown = (e) => { const mydata = itemRitcDetails.map(node=>node);
         if (e.key === 'Enter') {document.getElementById('ItemIGST_Notification_id').focus(); 
    setQuryIndex(0);var selectdetails = [];selectdetails = (ItemSelect ,mydata[0].notificationId.toString()); setItemSelect(selectdetails);}
 }
    const ItemDialogIgstCessFindNotifiCationSrlNoKeydown = (e) => {const mydata = itemRitcDetails.map(node=>node);
         if (e.key === 'Enter') { document.getElementById('ItemIGST_CessNotification_id').focus();  
    setQuryIndex(0);var selectdetails = [];selectdetails = (ItemSelect ,mydata[0].notificationId.toString()); setItemSelect(selectdetails);}
 }
    const ItemDialogIgstExampFindNotifiCationSrlNoKeydown = (e) => {const mydata = itemRitcDetails.map(node=>node);
         if (e.key === 'Enter') { document.getElementById('ItemExce_Notification_id').focus(); 
    setQuryIndex(0);var selectdetails = [];selectdetails = (ItemSelect ,mydata[0].notificationId.toString()); setItemSelect(selectdetails);}
 }
    const ItemDialogFindSchemeNameKeyDown = (e) => {const mydata = itemSchemeCodeDetails.map(node=>node);
         if (e.key === 'Enter') { document.getElementById('ItemFind_SchemaCode_id').focus(); 
    setQuryIndex(0);var selectdetails = [];selectdetails = (ItemSelect ,mydata[0].schemeCode); setItemSelect(selectdetails);}
 }
    const ItemDialogFindSchemaIgstNotnSrlNoKeyDown = (e) => {const mydata = itemSchemeCodeDetails.map(node=>node);
         if (e.key === 'Enter') { document.getElementById('ItemFind_Schema_IGSTnotn_id').focus(); 
    setQuryIndex(0);var selectdetails = [];selectdetails = (ItemSelect ,mydata[0].notificationNo); setItemSelect(selectdetails);}
 }
    const itemDialogSchemeRefBtnKeyDown = (e) => {const mydata = itemRitcDetails.map(node=>node);
         if (e.key === 'Enter') { document.getElementById('Item_Schema_CodeDetails_id').focus(); 
    setQuryIndex(0);var selectdetails = [];selectdetails = (ItemSelect ,mydata[0].schemeCode); setItemSelect(selectdetails);}
 }
    const ItemDialogFindAuntiDump_notn_SrlnoKeyDown = (e) => {const mydata = itemSchemeCodeDetails.map(node=>node);
         if (e.key === 'Enter') { document.getElementById('Item_AuntiDumb_id').focus(); 
    setQuryIndex(0);var selectdetails = [];selectdetails = (ItemSelect ,mydata[0].notificationNo); setItemSelect(selectdetails);}
 }
    const ItemDialogFindAuntiDumpRefBtnKeydown = (e) => {const mydata = itemRitcDetails.map(node=>node);
         if (e.key === 'Enter') { document.getElementById('Item_Aunti_dump_dutyDetails_id').focus(); 
    setQuryIndex(0);var selectdetails = [];selectdetails = (ItemSelect ,mydata[0].notificationNo); setItemSelect(selectdetails);}
 }
    const ItemDialogSwRefBtnKeyDown = (e) => {const mydata = itemRitcDetails.map(node=>node);
         if (e.key === 'Enter') { document.getElementById('Item_Sw_type_Details_id').focus(); 
    setQuryIndex(0);var selectdetails = [];selectdetails = (ItemSelect ,mydata[0].swType); setItemSelect(selectdetails);}
 }
    const ItemDialogLicenceFindSchemNameKeyDown = (e) => {const mydata = itemSchemeCodeDetails.map(node=>node);
         if (e.key === 'Enter') { document.getElementById('Item_view_LicenceCode_id').focus(); 
    setQuryIndex(0);var selectdetails = [];selectdetails = (ItemSelect ,mydata[0].schemeCode); setItemSelect(selectdetails);}
 }
    const ItemDialogFindLicencePortNameKeyDown = (e) => {const mydata = itemSchemeCodeDetails.map(node=>node);
         if (e.key === 'Enter') { document.getElementById('Item_LicencePortFind_id').focus(); 
    setQuryIndex(0);var selectdetails = [];selectdetails = (ItemSelect ,mydata[0].customHouseCode); setItemSelect(selectdetails);}
 }
    const ItemDialogLicenceRefBtnKeyDown = (e) => {const mydata = itemSchemeCodeDetails.map(node=>node);
         if (e.key === 'Enter') { document.getElementById('Item_LicencePortFind_id').focus(); 
    setQuryIndex(0);var selectdetails = [];selectdetails = (ItemSelect ,mydata[0].customHouseCode); setItemSelect(selectdetails);}
 }
    const ItemDialogSwCntentRefBtnKeyDown = (e) => {const mydata = itemRitcDetails.map(node=>node);
         if (e.key === 'Enter') { document.getElementById('Item_Add_Sw_Content_Details_id').focus(); 
    setQuryIndex(0);var selectdetails = [];selectdetails = (ItemSelect ,mydata[0].consName); setItemSelect(selectdetails);}
 }
    const ItemDialogRspDutyRefBtnKeyDown = (e) => {const mydata = itemRitcDetails.map(node=>node);
         if (e.key === 'Enter') { document.getElementById('Item_Add_RSP_Duty_id').focus(); 
    setQuryIndex(0);var selectdetails = [];selectdetails = (ItemSelect ,mydata[0].notificationNo); setItemSelect(selectdetails);}
 }
    const ItemDialogFindRe_import_PorteNameKeyDown = (e) => {const mydata = itemSchemeCodeDetails.map(node=>node);
         if (e.key === 'Enter') { document.getElementById('Item_find_re_import_port_id').focus(); 
    setQuryIndex(0);var selectdetails = [];selectdetails = (ItemSelect ,mydata[0].customPointCode); setItemSelect(selectdetails);}
 }
    const ItemDialogReImportRefBtnKeyDown = (e) => {const mydata = itemRitcDetails.map(node=>node);
         if (e.key === 'Enter') { document.getElementById('Item_Add_re_import_id').focus(); 
    setQuryIndex(0);var selectdetails = [];selectdetails = (ItemSelect ,mydata[0].previousSbNo); setItemSelect(selectdetails);}
 }
    const ItemDialogNcdDutyRefBtnKeyDown = (e) => {const mydata = itemRitcDetails.map(node=>node);
         if (e.key === 'Enter') { document.getElementById('Item_Add_ncd_duty_id').focus(); 
    setQuryIndex(0);var selectdetails = [];selectdetails = (ItemSelect ,mydata[0].notificationNo); setItemSelect(selectdetails);}
 }
    const ItemDialogAddProductionRefBtnKeyDown = (e) => {const mydata = itemRitcDetails.map(node=>node);
         if (e.key === 'Enter') { document.getElementById('Item_Add_Sw_production_id').focus(); 
    setQuryIndex(0);var selectdetails = [];selectdetails = (ItemSelect ,mydata[0].prodIdentifier); setItemSelect(selectdetails);}
 }
    const ItemDialogFindSuplierDetKeyDown = (e) => {const mydata = itemSchemeCodeDetails.map(node=>node);
         if (e.key === 'Enter') { document.getElementById('Item_find_mnfctSuP_id').focus(); 
    setQuryIndex(0);var selectdetails = [];selectdetails = (ItemSelect ,mydata[0].supplierName); setItemSelect(selectdetails);}
 }
    const ItemManufactureRefBTNKeyHndle = (e) => {const mydata = itemRitcDetails.map(node=>node);
         if (e.key === 'Enter') { document.getElementById('Item_add_mnfctr_details_id').focus(); 
    setQuryIndex(0);var selectdetails = [];selectdetails = (ItemSelect ,mydata[0].name); setItemSelect(selectdetails);}
 }
    const ItemDialogCustmRefBtnKeydown = (e) => {const mydata = itemRitcDetails.map(node=>node);
         if (e.key === 'Enter') { document.getElementById('Item_add_custom_notn_id').focus(); 
    setQuryIndex(0);var selectdetails = [];selectdetails = (ItemSelect ,mydata[0].notificationNo); setItemSelect(selectdetails);}
 }
    const ItemDialogOtherDutyFindigstNotiSrlNoKeyDown = (e) => {const mydata = itemSchemeCodeDetails.map(node=>node);
         if (e.key === 'Enter') { document.getElementById('Item_OtherDutYfind_IGST_noti_id').focus(); 
    setQuryIndex(0);var selectdetails = [];selectdetails = (ItemSelect ,mydata[0].notificationNo); setItemSelect(selectdetails);}
 }
    const ItemDialogOthrDutyRefBtnKeydown = (e) => {const mydata = itemRitcDetails.map(node=>node);
         if (e.key === 'Enter') { document.getElementById('Item_OtherDutY_Chrgs_id').focus(); 
    setQuryIndex(0);var selectdetails = [];selectdetails = (ItemSelect ,mydata[0].notificationNo); setItemSelect(selectdetails);}
 }
    const ItemDialogScDutyRefBtnKeydown = (e) => {const mydata = itemRitcDetails.map(node=>node);
         if (e.key === 'Enter') { document.getElementById('Item_SpclDutY_Chrgs_id').focus(); 
    setQuryIndex(0);var selectdetails = [];selectdetails = (ItemSelect ,mydata[0].notificationNo); setItemSelect(selectdetails);}
 }
    const ItemDialogSwControleRefBtnKeydown = (e) => {const mydata = itemRitcDetails.map(node=>node);
         if (e.key === 'Enter') { document.getElementById('Item_sw_controll_id').focus(); 
    setQuryIndex(0);var selectdetails = [];selectdetails = (ItemSelect ,mydata[0].conType); setItemSelect(selectdetails);}
 }
    const ItemDialogSwStmntRefBtnKeydown = (e) => {const mydata = itemRitcDetails.map(node=>node);
         if (e.key === 'Enter') { document.getElementById('Item_swStatement_id').focus(); 
    setQuryIndex(0);var selectdetails = [];selectdetails = (ItemSelect ,mydata[0].statementType); setItemSelect(selectdetails);}
 }
    const ItemDialogPolicyParaRefBtnKeydown = (e) => {const mydata = itemRitcDetails.map(node=>node);
         if (e.key === 'Enter') { document.getElementById('Item_policyPara_id').focus(); 
    setQuryIndex(0);var selectdetails = [];selectdetails = (ItemSelect ,mydata[0].policyParaNo); setItemSelect(selectdetails);}
 }
    const ItemDialogViewDocumentTypeFindDocumentNameKeydown = (e) => {const mydata = itemSchemeCodeDetails.map(node=>node);
         if (e.key === 'Enter') { document.getElementById('Item_FindDoc_typ_id').focus(); 
    setQuryIndex(0);var selectdetails = [];selectdetails = (ItemSelect ,mydata[0].supDocType); setItemSelect(selectdetails);}
 }
    const ItemDialogViewDocumentTypeFindSupNameKeydown = (e) => {const mydata = itemSchemeCodeDetails.map(node=>node);
         if (e.key === 'Enter') { document.getElementById('Item_FindDoc_SupName_id').focus(); 
    setQuryIndex(0);var selectdetails = [];selectdetails = (ItemSelect ,mydata[0].supplierName); setItemSelect(selectdetails);}
 }
    const ItemDialogDocsImporterKeydown = (e) => {const mydata = itemSchemeCodeDetails.map(node=>node);
         if (e.key === 'Enter') { document.getElementById('Item_FindDoc_ImpTbl_id').focus(); 
    setQuryIndex(0);var selectdetails = [];selectdetails = (ItemSelect ,mydata[0].importer_iec_no); setItemSelect(selectdetails);}
 }
    const itemSwSupprtBeneficaryFindImporterBrnchSrlnokeydown = (e) => {const mydata = itemSchemeCodeDetails.map(node=>node);
         if (e.key === 'Enter') { document.getElementById('Item_FindDoc_ImpBrncTbl_id').focus(); 
    setQuryIndex(0);var selectdetails = [];selectdetails = (ItemSelect ,mydata[0].branch_sl_no); setItemSelect(selectdetails);}
 }
    const itemSwSupprtRefBtnTypekeydown = (e) => {const mydata = itemRitcDetails.map(node=>node);
         if (e.key === 'Enter') { document.getElementById('Item_Sw_docsDetails_id').focus(); 
    setQuryIndex(0);var selectdetails = [];selectdetails = (ItemSelect ,mydata[0].docType); setItemSelect(selectdetails);}
 }
    const ItemDublicateBtnKeyDown = (e) => {const mydata = itemDetails.map(node=>node);
         if (e.key === 'Enter') { document.getElementById('ItemDetails_id').focus(); 
    setQuryIndex(0);var selectdetails = [];selectdetails = (selected ,mydata[0].itemId); setSelected(selectdetails);}
 }

    const isMAWBSelected = (itemId) => selected.indexOf(itemId) !== -1;
    const isImportQuerySelected = (imprter) => QuerImptrSelect.indexOf(imprter) !== -1
    const isyesarQuerySelected = (imprter) => yearImptrSelect.indexOf(imprter) !== -1
    const isMasterTransitSelected = (imprter) => MasterTransitSelect.indexOf(imprter) !== -1
    const isInvoiceTblSelected = (imprter) => InvoiceSelect.indexOf(imprter) !== -1
    const isItemTblSelected = (imprter) => ItemSelect.indexOf(imprter) !== -1
    return (
        <div>
            <Home />
            <Snackbar open={openSnack} autoHideDuration={4000} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                onClose={handleClose}>
                <Alert onClose={handleClose} severity={severity}>
                    {message}
                </Alert>
            </Snackbar>
            <Notify conformdialog={confirmDialog} setConformDialog={setConfonfirmDialog} />
            <div />
            <Tabs activeKey={key} onSelect={tabsselect} className="tabscolour" variant='pills'>
                {/* --------------------------------------------Query-------------------------------------- */}
                <Tab eventKey="Query" title="Query" className='bg-light'>
                    {/**----------------------------------------Dialogbox-------------------------------------------------**/}
                    <div>
                        {/* importer dialog */}
                        <Dialog onClose={QueryImporterhandleClose} open={QueryImprtOpen} fullWidth={true} maxWidth="md">
                            <DialogTitle className="dialogboxtitlecolour p-1"><center>IMPORTER DETAILS</center></DialogTitle>
                            <div className='dialogboxcolour'><center>
                                <Form.Label>Importer Name</Form.Label>
                                <FormControl size='sm' style={{ width: "20%" }} id='Digimpr_nme' placeholder="Importer Name" onChange={QueryDialogImporterhandleChange}
                                    onKeyDown={HandleQuryDialogImpName} value={qryvalues.f_imp_Name} autoFocus />
                            </center>
                                <br></br>
                            </div>
                            <TableContainer className={classes.container}>
                                <Table stickyHeader aria-label="table" size="small" >
                                    <TableHead >
                                        <StyledTableRow>
                                            <StyledTableCell align='center'>Importer Name</StyledTableCell>
                                        </StyledTableRow>
                                    </TableHead>
                                    <TableBody>
                                        {
                                            ImporterDetails.map((importer, i) => {
                                                const itemSelectdImp = isImportQuerySelected(importer.importer_name)
                                                return (
                                                    <TableRow id='QuryImpTbl' onKeyDown={QueryImpTbleDown} hover onClick={() => editImportQry(importer, i)} key={importer.importer_name} tabIndex={-1} selected={itemSelectdImp}>
                                                        <TableCell align='center' >{importer.importer_name}</TableCell>
                                                    </TableRow>
                                                )
                                            })}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Dialog>
                        {/* year dialog */}
                        <Dialog onClose={QueryYearHandleClose} open={QueryearOpen} fullWidth={true} maxWidth="md">
                            <DialogTitle className="dialogboxtitlecolour p-1"><center>VIEW YEAR</center></DialogTitle>
                            <div className='dialogboxcolour'>
                                <center>
                                    <Form.Label>Year</Form.Label>
                                    <FormControl style={{ width: "20%" }} size='sm' autoFocus onKeyDown={QueryYearKeyDown}
                                        placeholder="Select Year" onChange={QueryDialogSlctYear} value={qryvalues.qryslct_year} maxLength="5" type='number' />
                                </center>
                                <br></br>
                            </div>
                            <TableContainer className={classes.container}>
                                <Table stickyHeader aria-label="table" size="small" >
                                    <TableHead >
                                        <TableRow>
                                            <StyledTableCell align='center'>Year</StyledTableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {
                                            QuryYearDetails.map((year,i) => {
                                                const itemSelectdImp = isyesarQuerySelected(year.consignmentNumber)
                                                return (
                                                    <TableRow hover id='yearQuery_id' onKeyDown={(e)=>QueryYearTbleDown(e,'y')} onClick={() => editQryYear(year,i)} key={year.consignmentNumber} tabIndex={-1} selected={itemSelectdImp}>
                                                        <TableCell align='center'>{year.consignmentNumber}</TableCell>
                                                    </TableRow>
                                                )
                                            })}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Dialog>
                        {/* select Job */}
                        <Dialog onClose={QueryJobHandleClose} open={QuerJobOpen} fullWidth={true} maxWidth="md">
                            <DialogTitle className="dialogboxtitlecolour p-1"><center>VIEW JOB.NO</center></DialogTitle>
                            <div className='dialogboxcolour'>
                                <center>
                                    <Form.Label>Job.No</Form.Label>
                                    <FormControl style={{ width: "20%" }} size='sm' autoFocus value={qryvalues.qryslct_job_no} onChange={QueryDalogSlctJob}
                                   onKeyDown={QueryJobKeyDown} />
                                </center>
                                <br></br>
                            </div>
                            <TableContainer className={classes.container}>
                                <Table stickyHeader aria-label="table" size="small" >
                                    <TableHead >
                                        <StyledTableRow>
                                            <StyledTableCell align='center'>Job.No</StyledTableCell>
                                        </StyledTableRow>
                                    </TableHead>
                                    <TableBody>
                                        {
                                            QuryYearDetails.map((jobno,i) => {
                                                const itemSelectdImp = isyesarQuerySelected(jobno.consignmentNumber)
                                                return(
                                                    <TableRow hover id='JobQuery_id' onKeyDown={(e)=>QueryYearTbleDown(e,'j')} onClick={() => editJobNo(jobno,i)} key={jobno.consignmentNumber} tabIndex={-1} selected={itemSelectdImp}>
                                                        <TableCell align='center'>{jobno.consignmentNumber}</TableCell>
                                                    </TableRow>
                                                )})}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Dialog>
                        {/* select edi Job */}
                        <Dialog onClose={QueryEdiJobHandleClose} open={QuerEdiJobOpen} fullWidth={true} maxWidth="md">
                            <DialogTitle className="dialogboxtitlecolour p-1"><center>EDI JOB  DETAILS</center></DialogTitle>
                            <div className='dialogboxcolour'>
                                <center>
                                    <Form.Label>Edi Job.No</Form.Label>
                                    <FormControl style={{ width: "20%" }} onKeyDown={queryEdiJobKeyDownHandle} size='sm' autoFocus value={qryvalues.qryslct_edi_job} onChange={QueryDialogSlctEdiJob} />
                                </center>
                                <br></br>
                            </div>
                            <TableContainer className={classes.container}>
                                <Table stickyHeader aria-label="table" size="small" >
                                    <TableHead >
                                        <StyledTableRow>
                                            <StyledTableCell align='center'>EDI Job.No</StyledTableCell>
                                        </StyledTableRow>
                                    </TableHead>
                                    <TableBody>
                                        {QuryYearDetails.map((edi) => { const itemSelectdImp = isyesarQuerySelected(edi.consignmentNumber)
                                                return(
                                                    <TableRow hover id='EdiJobQuery_id' onKeyDown={(e)=>QueryYearTbleDown(e,'e')} onClick={() => editEDiJonNo(edi)} key={edi.consignmentNumber} tabIndex={-1} selected={itemSelectdImp}>
                                                        <TableCell align='center'>{edi.consignmentNumber}</TableCell>
                                                    </TableRow>
                                                )})}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Dialog>
                        {/* MAWB.No */}
                        <Dialog onClose={QueryMawbNoHandleClose} open={QuerMawbNoOpen} fullWidth={true} maxWidth="md">
                            <DialogTitle className="dialogboxtitlecolour p-1"><center>VIEW MAWB.No</center></DialogTitle>
                            <div className='dialogboxcolour'>
                                <center>
                                    <Form.Label>Mawb.No</Form.Label>
                                    <FormControl style={{ width: "20%" }}  onKeyDown={queryMawbKeyDownHandle}  size='sm' autoFocus value={qryvalues.qrymawb_no} onChange={QueryDialogMawbNo} />
                                </center>
                                <br></br>
                            </div>
                            <TableContainer className={classes.container}>
                                <Table stickyHeader aria-label="table" size="small" >
                                    <TableHead >
                                        <StyledTableRow>
                                            <StyledTableCell align='center'>Mawb.No</StyledTableCell>
                                        </StyledTableRow>
                                    </TableHead>
                                    <TableBody>
                                        {
                                            QuryYearDetails.map((mawb) =>{ const itemSelectdImp = isyesarQuerySelected(mawb.consignmentNumber)
                                                return(
                                                    <TableRow hover id='mawbQuery_id' onKeyDown={(e)=>QueryYearTbleDown(e,'m')} onClick={() => editMawbNo(mawb)}
                                                        key={mawb.serialNumber} tabIndex={-1} selected={itemSelectdImp}>
                                                        <TableCell align='center'>{mawb.consignmentNumber}</TableCell>
                                                    </TableRow>
                                                )})}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Dialog>
                        {/* Hawb.No */}
                        <Dialog onClose={QueryHawbNoHandleClose} open={QuerHawbNoOpen} fullWidth={true} maxWidth="md">
                            <DialogTitle className="dialogboxtitlecolour p-1"><center>VIEW HAWB.No</center></DialogTitle>
                            <div className='dialogboxcolour'>
                                <center>
                                    <Form.Label>Hawb.No</Form.Label>
                                    <FormControl style={{ width: "20%" }} onKeyDown={queryHawbKeyDownHandle}  size='sm' autoFocus value={qryvalues.qryhawb_no} onChange={QueryDialogHawb} />
                                </center>
                                <br></br>
                            </div>
                            <TableContainer className={classes.container}>
                                <Table stickyHeader aria-label="table" size="small" >
                                    <TableHead >
                                        <StyledTableRow>
                                            <StyledTableCell align='center'>Hawb.No</StyledTableCell>
                                        </StyledTableRow>
                                    </TableHead>
                                    <TableBody>
                                        {
                                            QuryYearDetails.map((hawb) => { const itemSelectdImp = isyesarQuerySelected(hawb.consignmentNumber)
                                                    return(
                                                    <TableRow hover id='hawbQuery_id' onKeyDown={(e)=>QueryYearTbleDown(e,'h')} onClick={() => editHawbNo(hawb)}
                                                    key={hawb.serialNumber} tabIndex={-1} selected={itemSelectdImp}>
                                                        <TableCell align='center'>{hawb.consignmentNumber}</TableCell>
                                                    </TableRow>
                                                )})}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Dialog>
                        {/* Select Sublier */}
                        <Dialog onClose={QuerySublierHandleClose} open={QuerSublierNoOpen} fullWidth={true} maxWidth="md">
                            <DialogTitle className="dialogboxtitlecolour p-1"><center>VIEW Supplier</center></DialogTitle>
                            <div className='dialogboxcolour'>
                                <center>
                                    <Form.Label>SupplierName</Form.Label>
                                    <FormControl style={{ width: "20%" }} onKeyDown={querySuplierKeyDownHandle} size='sm' autoFocus value={qryvalues.qryslct_sublier} onChange={QueryDialogSlctSublier}/>
                                </center>
                                <br></br>
                            </div>
                            <TableContainer className={classes.container}>
                                <Table stickyHeader aria-label="table" size="small" >
                                    <TableHead >
                                        <StyledTableRow>
                                            <TableCell align='center'>SupplierName</TableCell>
                                        </StyledTableRow>
                                    </TableHead>
                                    <TableBody>
                                        {
                                            QuryYearDetails.map((suplier) => { const itemSelectdImp = isyesarQuerySelected(suplier.supplierName)
                                                return(
                                                    <TableRow hover id='suplierQuery_id' onKeyDown={(e)=>QueryYearTbleDown(e,'s')} key={suplier.supplierName} onClick={() => editSupplier(suplier)} tabIndex={-1} selected={itemSelectdImp}>
                                                        <TableCell align='center'>{suplier.supplierName}</TableCell>
                                                    </TableRow>
                                                )})}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Dialog>
                        {/* Select Forwader */}
                        <Dialog onClose={QueryFrwdrHandleClose} open={QuerFrwdrOpen} fullWidth={true} maxWidth="md">
                            <DialogTitle className="dialogboxtitlecolour p-1"><center>VIEW FORWARDER</center></DialogTitle>
                            <div className='dialogboxcolour'>
                                <center>
                                    <Form.Label>Forwarder Name</Form.Label>
                                    <FormControl style={{ width: "20%" }} onKeyDown={queryFrwdKeyDownHandle} size='sm' autoFocus value={qryvalues.qryslct_frwdr} onChange={QueryDialogSlctFrwder}
                                    />
                                </center>
                                <br></br>
                            </div>
                            <TableContainer className={classes.container}>
                                <Table stickyHeader aria-label="table" size="small" >
                                    <TableHead >
                                        <StyledTableRow>
                                            <StyledTableCell align='center'>ForwarderName</StyledTableCell>
                                        </StyledTableRow>
                                    </TableHead>
                                    <TableBody>
                                        {
                                            QuryYearDetails.map((frwdr) => {const itemSelectdImp = isyesarQuerySelected(frwdr.freightFwdName)
                                                return(
                                                    <TableRow hover id='frwdQuery_id' onKeyDown={(e)=>QueryYearTbleDown(e,'f')} key={frwdr.freightFwdId} onClick={() => editFrwder(frwdr)} tabIndex={-1} selected={itemSelectdImp}>
                                                        <TableCell align='center'>{frwdr.freightFwdName}</TableCell>
                                                    </TableRow>
                                                )})}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Dialog>
                        {/* iterm description */}
                        <Dialog onClose={QueryDscriptionHandleClose} open={QuerDscrOpen} fullWidth={true} maxWidth="md">
                            <DialogTitle className="dialogboxtitlecolour p-1"><center>Item Description Details</center></DialogTitle>
                            <div className='dialogboxcolour'>
                                <center>
                                    <Form.Label>Item Description</Form.Label>
                                    <FormControl style={{ width: "20%" }} onKeyDown={queryItemDescKeyDownHandle} size='sm' autoFocus value={qryvalues.qryitem_decrption} onChange={QueryDialogItemDscrption} />
                                </center>
                                <br></br>
                            </div>
                            <TableContainer className={classes.container}>
                                <Table stickyHeader aria-label="table" size="small" >
                                    <TableHead >
                                        <StyledTableRow>
                                            <StyledTableCell align='center'>Item Description</StyledTableCell>
                                        </StyledTableRow>
                                    </TableHead>
                                    <TableBody>
                                        {
                                            QuryYearDetails.map((item) =>{ const itemSelectdImp = isyesarQuerySelected(item.item_description)
                                                return(
                                                    <TableRow hover id='itemDescQuery_id' onKeyDown={(e)=>QueryYearTbleDown(e,'i')} onClick={() => editItemDsc(item)}
                                                        key={item.itemId} tabIndex={-1} selected={itemSelectdImp}>
                                                        <TableCell align='center'>{item.item_description}</TableCell>
                                                    </TableRow>
                                                )})}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Dialog>
                        {/* Hs Code */}
                        <Dialog onClose={QueryHsCodeHandleClose} open={QuerHsCodeOpen} fullWidth={true} maxWidth="md">
                            <DialogTitle className="dialogboxtitlecolour p-1"><center>VIEW HS CODE</center></DialogTitle>
                            <div className='dialogboxcolour'>
                                <center>
                                    <Form.Label>Hs Code</Form.Label>
                                    <FormControl style={{ width: "20%" }} size='sm' autoFocus value={qryvalues.qryslct_hs_code} onChange={QueryDialogHsCode} onKeyDown={queryHsCodeKeyDownHandle}
                                    />
                                    <Form.Label>Hs Name</Form.Label>
                                    <FormControl style={{ width: "20%" }} size='sm' onKeyDown={queryHsNameKeyDownHandle} id='queryDialog_hsName_id' value={qryvalues.slct_hs_Name}
                                     onChange={QueryDialogHsName}/>
                                </center>
                                <br></br>
                            </div>
                            <TableContainer className={classes.container}>
                                <Table stickyHeader className="table-bordered" size="small" >
                                    <TableHead >
                                        <StyledTableRow>
                                            <StyledTableCell align='center'>Hs Code</StyledTableCell>
                                            <StyledTableCell align='center'>Hs Name</StyledTableCell>
                                        </StyledTableRow>
                                    </TableHead>
                                    <TableBody>
                                        {
                                            QuryYearDetails.map((hsCode) => { const itemSelectdImp = isyesarQuerySelected(hsCode.hsCode)
                                                return(
                                                    <TableRow hover id='hsCodeQuery_id' onKeyDown={(e)=>QueryYearTbleDown(e,'hs')} onClick={() => editHscode(hsCode)}
                                                        key={hsCode.hsCode} tabIndex={-1} selected={itemSelectdImp}>
                                                        <TableCell align='center'>{hsCode.hsCode}</TableCell>
                                                        <TableCell align='center'>{hsCode.hsName}</TableCell>
                                                    </TableRow>
                                                )})}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Dialog>
                        {/**/}
                        <Dialog onClose={QueryCusHouseCodeHandleClose} open={QueryCusHouseopen} fullWidth={true}>
                            <DialogTitle align='center' className="dialogboxtitlecolour p-1">
                                Custom House Details
                            </DialogTitle>
                            <div className='dialogboxcolour'>
                                <div style={{ marginLeft: '22%' }}><Container className="mt-4 mb-2">
                                    <Row className="mb-1">
                                        <div className="form-inline  ml-3" style={{ width: "90%", marginLeft: "4rem" }} size="sm">
                                            <label className="dialogfont">Find CusHouse Name</label>
                                            <input type="text" className="input ml-1" style={{ textTransform: 'uppercase', textAlign: 'center' }}
                                             onKeyDown={queryCustomnameKeyDownHandle} autoFocus value={qryvalues.qryFindcusHouseName} onChange={QueryDialogCusHsName}></input>
                                        </div>
                                    </Row>
                                    <Row>
                                        <div className="form-inline mt-1 ml-3" style={{ width: "90%", marginLeft: "6rem" }} size="sm">
                                            <label className="dialogfont">Find CusHouse Code</label>
                                            <input type="text" className="input ml-2 mb-1" style={{ textTransform: 'uppercase', textAlign: 'center' }} autoFocus
                                            id='find_qury_customHouseCode_id' value={qryvalues.qryFindcusHousecode} onChange={QueryDialogCusHsCode} onKeyDown={queryCustomKeyDownHandle}></input>
                                        </div>
                                    </Row></Container>
                                </div></div>
                            <TableContainer className={classes.container}>
                                <Table stickyHeader aria-label="table" size="small" >
                                    <TableHead>
                                        <StyledTableRow>
                                            <StyledTableCell align='center'>CusHouse Code</StyledTableCell>
                                            <StyledTableCell align='center'>CusHouse Name</StyledTableCell>
                                        </StyledTableRow>
                                    </TableHead>
                                    <TableBody>
                                        {
                                            QuryYearDetails.map((trns) => {  const itemSelectdImp = isyesarQuerySelected(trns.customHouseCode)
                                                return(
                                                    <TableRow hover id='customhouseCodeQuery_id' onKeyDown={(e)=>QueryYearTbleDown(e,'c')}  key={trns.index} onClick={() => editCuscode(trns)} tabIndex={-1} selected={itemSelectdImp}>
                                                        <TableCell align='center'>{trns.customHouseCode}</TableCell>
                                                        <TableCell >{trns.customHouseLocation}</TableCell>
                                                    </TableRow>
                                                )})}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Dialog>
                        {/* alertNo */}
                        <Dialog onClose={QueryDublicateJobClose} open={QueryDublicateOpen} fullWidth={true} maxWidth="sm">
                            <DialogTitle className="dialogboxtitlecolour p-1">
                                <center>Duplicate Job</center>
                            </DialogTitle>
                            <div className='mt-2 mb-2 dialogboxcolour'>
                                <center><h6 className='summury'>Your Duplicate Job.No: </h6>
                                    <input readOnly value={QryalerJobNo} style={{ width: '15%', height: '22px', textAlign: 'center' }} />
                                </center>
                            </div>
                        </Dialog>
                        {/*Qry Amendment*/}
                        <Dialog onClose={QueryAmendmentDilgHandleClose} open={QueryAmendmentDilgopen} fullWidth={true} maxWidth="md">
                            <DialogTitle className="dialogboxtitlecolour p-1">
                                <center style={{ color: 'white' }}>Amendment BE</center>
                            </DialogTitle>
                            <div className='bg-light dialogboxcolour'>
                                <div className='form-inline mt-2'>
                                    <label style={{ marginLeft: '3%' }}>BE No</label>
                                    <input className='hi22' style={{ marginLeft: '9.5%' }} value={qryAmendvalue.Amnd_beNo} type='number'
                                        autoFocus onChange={QryBeNoChangeHandle} />

                                    <label style={{ marginLeft: '3%' }}>BE Date</label>
                                    <input type='date' style={{ marginLeft: '5.5%', textTransform: 'uppercase' }} value={qryAmendvalue.Amnd_beDate}
                                        min={'1990-01-01'} max={'2100-12-31'} onChange={QryBeDateChangeHandle} />

                                    <label style={{ marginLeft: '3%' }} className='summury'>Amendment Code</label>
                                    <select className='ml-2' style={{ width: '13%' }} value={qryAmendvalue.Amnd_code} onChange={QryAmendentcodeChangeHandle} id='AmendmentCode'>
                                        <option value={''}></option>
                                        {QuryAmdntDetails.map((trns) => (
                                            <option value={trns.amendCode}>{trns.amendCode}</option>
                                        ))}
                                    </select>
                                </div>

                                <div className='form-inline mt-2'>
                                    <label style={{ marginLeft: '3%' }} className='summury'>Request Letter No</label>
                                    <input className='ml-3' value={qryAmendvalue.Amnd_RqstLtrNo} type='number' id='rqstLtrno'
                                        onChange={QryRqstNoChangeHandle} />
                                    <label style={{ marginLeft: '3%' }} className='summury'>Request Date</label>
                                    <input className='ml-3' type='date' style={{ textTransform: 'uppercase' }} value={qryAmendvalue.Amnd_RqstDate} id='requestDate'
                                        min={'1990-01-01'} max={'2100-12-31'} onChange={QryRqstDateChangeHandle} />
                                </div>
                                <div className='form-inline mt-2 mb-3'>
                                    <label style={{ marginLeft: '3%' }} className='summury'>Reason</label>
                                    <textarea style={{ marginLeft: '8%' }} value={qryAmendvalue.Amnd_Reason} id='reason'
                                        onChange={QryRspncChangeHandle}></textarea>
                                    <Button size='small' variant="contained" color="primary" style={{ marginLeft: '10px' }} onClick={AddAmendOnClick}>Add Amend</Button>{' '}
                                    <Button size='small' variant="contained" color="primary" style={{ marginLeft: '10px' }} onClick={UpdateAmendOnClick}>Update Amend</Button>{' '}
                                    <Button size='small' variant="contained" color="primary" onClick={ClearBeAmendment}>Clear</Button>{' '}
                                </div>
                            </div>
                        </Dialog>
                    </div>
                    {/* value main dash board */}
                    <Card className='scrollbar-primary '>
                        <Grid container spacing={1} className='bg-light'>
                            <Grid item xs={2} >
                                <Paper className={classes.card1} style={{ backgroundColor: '#C8EDE7' }}>
                                    {/* <Col><Row><Col className='form-inline'> */}
                                    <Form.Label className='ml-4 summury'>Importer Name</Form.Label>
                                    <input onKeyDown={QuryImpName} onChange={Queryimporter} value={qryvalues.imp_name}
                                        id='qryimprter' className=' hi22' style={{ width: '80%' }} autoFocus />
                                    <button onClick={QueryimporterHandleOpen}
                                        className='searchbutton'>
                                        <SearchIcon fontSize="small" />
                                    </button>
                                    {/* </Col></Row></Col> */}
                                </Paper>
                            </Grid>
                            <Grid item xs={4} >
                                <Paper className={classes.card1} style={{ backgroundColor: '#C8EDE7' }}>
                                    <div className='form-inline mt-1'>
                                        <Form.Label className='ml-2 summury'>Search year</Form.Label>
                                        {/*  */}
                                        <Form.Label className='ml15 summury'>Select Job.No</Form.Label>
                                        {/*  */}
                                        <Form.Label className='ml10 summury'>Select Edi Job.No</Form.Label>
                                        {/*  */}
                                    </div>
                                    <div className='form-inline'>
                                        <input value={qryvalues.slct_year} onChange={QuerySlctYear}
                                            style={{ width: '20%' }} onKeyDown={QuryYear} id='QryYear'
                                            maxLength="5" className='ml-1 hi22' />
                                        <button onClick={QueryYearHandleOpen} className='searchbutton'>
                                            <SearchIcon fontSize="small" /></button>
                                        {/*  */}
                                        <input value={qryvalues.slct_job_no} onChange={QuerySlctJob}
                                            maxLength="11" className='ml-4 hi22' onKeyDown={QuryJobNo} id='slctJobNo'
                                            style={{ width: '20%' }} />
                                        <button onClick={QueryJobHandleOpen} className='searchbutton'>
                                            <SearchIcon fontSize="small" /></button>
                                        {/*  */}
                                        <input value={qryvalues.slct_edi_job} className='ml-3 hi22' onKeyDown={QuryEdiJobNo}
                                            maxLength="11" onChange={QuerySlctEdiJob} style={{ width: '20%' }} id='slctEdiJobNo' />
                                        <button onClick={QueryEdiJobHandleOpen} className='searchbutton'>
                                            <SearchIcon fontSize="small" /></button>
                                    </div>
                                </Paper>
                            </Grid>
                            <Grid item xs={3} >
                                <Paper className={classes.card1} style={{ backgroundColor: '#C8EDE7' }}>
                                    <div className='form-inline ml-2'>
                                        <Form.Label className='summury'>From Date</Form.Label>
                                        <Form.Label className='ml27 summury'>To Date</Form.Label>
                                    </div>
                                    <div className='form-inline'>
                                        <input value={qryvalues.frm_date} onChange={QuerySlctFrmDate} min={'1990-01-01'} max={'2500-12-31'}
                                            className='ml-1 hi22' id='frmdate' type="date" style={{ textTransform: 'uppercase' }} onKeyDown={QuryEdiFrmDate} />
                                        <input value={qryvalues.to_date} onChange={QuerySlctTomDate} min={'1990-01-01'} max={'2500-12-31'}
                                            className='ml-4 hi22' id='toDate' type="date" onKeyDown={QuryEdiToDate} style={{ textTransform: 'uppercase' }} />
                                    </div>
                                </Paper>
                            </Grid>
                            <Grid item xs={3} >
                                <Paper className={classes.card4} style={{ backgroundColor: '#C8EDE7' }}>
                                    <div className='form-inline'>
                                        <Form.Label className='ml-1 mr-2 summury'>Enter Licence No</Form.Label>
                                        <Form.Label className='ml-4 summury'>EnterBEType(H/W/X)</Form.Label>
                                    </div>
                                    <div className='form-inline'>
                                        <input value={qryvalues.licence_no} onChange={QuerySlctLicenceNo}
                                            maxLength="11" className='ml-1 hi22' style={{ width: '45%' }} id='Qrylicence' onKeyDown={QurylICENCE} />
                                        {/*  */}
                                        <input value={qryvalues.be_type_HWX} onChange={QueryBeType_H_W_X}
                                            maxLength="11" className='ml-1 hi22' style={{ width: '45%' }} id='QryBeType' onKeyDown={QuryBeType} />
                                    </div>
                                </Paper>
                            </Grid>
                            <Grid item xs={3}>
                                <Paper className={classes.card1} style={{ backgroundColor: '#C8EDE7' }}>
                                    <div className='form-inline' style={{ marginTop: '1.6%' }}>
                                        <Form.Label className='mr-4 summury'>Mawb.NO</Form.Label>
                                        {/*  */}
                                        <Form.Label className='ml25 summury'>Hawb.NO</Form.Label>
                                    </div>
                                    <div className='form-inline'>
                                        <input value={qryvalues.mawb_no} onChange={QueryMawbNo} onKeyDown={QuryMawbNo}
                                            maxLength="20" className=' hi22' style={{ width: '40%' }} id='mawbNo' />
                                        <button onClick={QueryMawbNoHandleOpen} className='searchbutton'>
                                            <SearchIcon fontSize="small" /></button>
                                        {/*  */}
                                        <input value={qryvalues.hawb_no} onChange={QueryHawb} onKeyDown={QuryHawbNo}
                                            maxLength="20" className='ml-1 hi22' style={{ width: '35%' }} id='hawbNo' />
                                        <button onClick={QueryHawbNoHandleOpen} className='searchbutton'>
                                            <SearchIcon fontSize="small" /></button>
                                    </div>
                                </Paper>
                            </Grid>
                            <Grid item xs={4}>
                                <Paper className={classes.card1} style={{ backgroundColor: '#C8EDE7' }}>
                                    <div className='form-inline summury'>
                                        <Form.Check type='radio' onChange={RadioChangeHandle}
                                            checked={radioValues === '5'} inline label={'Container.No'} value={'5'} />
                                        <Form.Check type='radio' onChange={RadioChangeHandle}
                                            checked={radioValues === '4'} inline label={'Invoice.No'} value={'4'} />
                                        <Form.Check type='radio' onChange={RadioChangeHandle}
                                            checked={radioValues === '3'} inline label={'IGM.No'} value={'3'} />
                                        <Form.Check type='radio' onChange={RadioChangeHandle}
                                            checked={radioValues === '6'} inline label={'BE.No'} value={'6'} />
                                    </div>
                                    <div className='form-inline'>
                                        <input type="text" onChange={QueryRadioInputChanghandle} onKeyDown={QuryInvoiceSearch}
                                            maxLength="50" value={qryvalues.radio_input_cnt} className='hi22' id='QuryRadioInput' />
                                    </div>
                                </Paper>
                            </Grid>
                            <Grid item xs={5}>
                                <Paper className={classes.card4} style={{ backgroundColor: '#C8EDE7' }}>
                                    <div className='form-inline' style={{ marginTop: '0.9%' }}>
                                        <Form.Label className='ml-1 mr-4 summury'>Select Supplier</Form.Label>
                                        {/*  */}
                                        <Form.Label className='ml24 summury'>Select Forwarder</Form.Label>
                                    </div>
                                    <div className='form-inline'>
                                        <input value={qryvalues.slct_sublier} onChange={QuerySlctSublier}
                                            maxLength="60" onKeyDown={QurySupplier} className='ml-1 hi22' id='Qurysuplier' />
                                        <button onClick={QuerySublierHandleOpen} className='searchbutton'>
                                            <SearchIcon fontSize="small" /></button>
                                        {/*  */}
                                        <input value={qryvalues.slct_frwdr} onChange={QuerySlctFrwder}
                                            maxLength="60" onKeyDown={QuryFrwdr} className='ml7 hi22' id='QuryFrwdr' />
                                        <button onClick={QueryFrwdrHandleOpen} className='searchbutton'>
                                            <SearchIcon fontSize="small" /></button>
                                    </div>
                                </Paper>
                            </Grid>
                            <Grid item xs={12}>
                                <Paper className={classes.card4} style={{ backgroundColor: '#C8EDE7' }}>
                                    <div className='form-inline'>
                                        {/*  */}
                                        <Form.Label className='ml-1 summury'>Item Description</Form.Label>
                                        <input value={qryvalues.item_decrption} onChange={QueryItemDscrption} onKeyDown={QuryItemDesc}
                                            className='ml-1 hi22' id='itemDiscription' />
                                        <button onClick={QueryDscriptionHandleOpen} className='searchbutton'>
                                            <SearchIcon fontSize="small" /></button>
                                        {/*  */}
                                        <Form.Label className='ml-1 summury'>Select HsCode</Form.Label>
                                        <input value={qryvalues.slct_hs_code} onChange={QueryHsCode} onKeyDown={QuryHscode}
                                            maxLength="9" className='ml-1 hi22' style={{ width: '7%' }} id='hsCode' />
                                        <button onClick={QueryHsCodeHandleOpen} className='searchbutton'>
                                            <SearchIcon fontSize="small" /></button>
                                        {/*  */}
                                        <Form.Label className='ml-1 summury'>Mode(A/L/S)</Form.Label>
                                        <input value={qryvalues.slct_modeType} id='QuryModeType' onKeyDown={QuryModeTyypeKeyDown}
                                            maxLength="1" onChange={QueryModeType} className='ml-1 hi22' style={{ width: '4%', textAlign: 'center', textTransform: 'uppercase' }} />
                                        {/*  */}
                                        <Form.Label className='ml-1 summury'>CusHouseCode</Form.Label>
                                        <input value={qryvalues.slct_portCode} onChange={QueryPortCode} onKeyDown={QuryCusHosCodeKeyDown}
                                            maxLength="6" className='ml-1 hi22' style={{ width: '7%', textTransform: 'uppercase' }} id='QuryCusHosCode' />
                                        <button onClick={QueryCusHouseCodeHandleOpen} className='searchbutton'>
                                            <SearchIcon fontSize="small" /></button>
                                    </div>
                                    <div style={{ marginTop: '2%', backgroundColor: '#C8EDE7' }}>
                                        <center >
                                            <Button size='small' variant="contained" color="primary" className='impjobbtn mb-2'>Search</Button>{' '}
                                            <Button size='small' variant="contained" color="primary" className='impjobbtn mb-2' onClick={NewJob}>NewJob</Button>{' '}
                                            <Button size='small' variant="contained" color="primary" className='impjobbtn mb-2' onClick={reset}>clear</Button>{' '}
                                            <Button size='small' variant="contained" color="primary" className='impjobbtn mb-2'>Close</Button>{' '}
                                            <Button size='small' variant="contained" color="primary" className='impjobbtn mb-2' onClick={QueryDublicateJobno} disabled={QryProcsDupli}>{QryProcsDupli ? 'Processing' : 'DublicateJob'}</Button>{' '}
                                            <Button size='small' variant="contained" color="primary" className='impjobbtn mb-2' onKeyDown={QuryJobAmndBeKeyDown} onClick={QueryAmendmentDilgHandleOpen}>Amendment BE</Button>{' '}
                                        </center></div>
                                </Paper>
                            </Grid>
                        </Grid>
                        {/*  */}
                    </Card>
                    <Card>
                        <TableContainer className={classes.containerquery}>
                            <Table stickyHeader className='table-bordered' size="small" >
                                <TableHead >
                                    <StyledTableRow>
                                        <StyledTableCell className='p-1'>Sl.no</StyledTableCell>
                                        <StyledTableCell className='p-1'>Importer</StyledTableCell>
                                        <StyledTableCell className='p-1'>Job.No</StyledTableCell>
                                        <StyledTableCell className='p-1'>Job Date</StyledTableCell>
                                        <StyledTableCell className='p-1'>BeType</StyledTableCell>
                                        <StyledTableCell className='p-1'>Be.No</StyledTableCell>
                                        <StyledTableCell className='p-1'>Be Date</StyledTableCell>
                                        <StyledTableCell className='p-1'>Created By</StyledTableCell>
                                        <StyledTableCell className='p-1'>Created Date</StyledTableCell>
                                        <StyledTableCell className='p-1'>Updated By</StyledTableCell>
                                        <StyledTableCell className='p-1'>Updated Date</StyledTableCell>
                                        <StyledTableCell className='p-1'>Mode</StyledTableCell>
                                        <StyledTableCell className='p-1'>Status</StyledTableCell>
                                    </StyledTableRow>
                                </TableHead>
                                <TableBody>
                                    {jobDetails.map((jobs) => { const itemSelectdImp = isyesarQuerySelected(jobs.consignmentNumber)
                                        return(
                                        <TableRow hover key={jobs.serialNumber} onClick={() => editJobsdetails(jobs)} className='igmtbl'
                                        id='jobDetailsQuery_id' onKeyDown={QueryJobTbleDown} tabIndex={-1} selected={itemSelectdImp}>
                                            <TableCell className='p-1'>{jobs.serialNumber}</TableCell>
                                            <TableCell className='p-1'>{jobs.importer_name}</TableCell>
                                            <TableCell className='p-1'>{jobs.consignmentNumber}</TableCell>
                                            <TableCell className='p-1'>{jobs.userJobDate}</TableCell>
                                            <TableCell className='p-1'>{jobs.impTypeBoe}</TableCell>
                                            <TableCell className='p-1'>{jobs.beNo}</TableCell>
                                            <TableCell className='p-1'>{jobs.beDate}</TableCell>
                                            <TableCell className='p-1'>{jobs.userName}</TableCell>
                                            <TableCell className='p-1'>{jobs.userDate}</TableCell>
                                            <TableCell className='p-1'>{jobs.updatedName}</TableCell>
                                            <TableCell className='p-1'>{jobs.updatedDate}</TableCell>
                                            <TableCell className='p-1'>{jobs.status}</TableCell>
                                            <TableCell className='p-1'>{jobs.stats}</TableCell>
                                        </TableRow>
                                    )})}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Card>
                    <br></br>
                </Tab>
                {/*------------------------------------------------------------------------------------------------------
                  -----------------------------TabsMaster-------------------------------------------*/}
                <Tab eventKey="Master" title="Master">
                    <div>
                        {/*----------------------model dialog---------------------------------------*/}
                        <Dialog onClose={JobModelsearchHandleClose} open={JobModelOpen} fullWidth={true} maxWidth="md">
                            <DialogTitle className="dialogboxtitlecolour p-1"><center>VIEW TRANSIT MODE DETAILS</center></DialogTitle>
                            <div className='dialogboxcolour'>
                                <Row><center>
                                    <div className='form-inline mt-1' style={{ marginLeft: "30%" }}>
                                        <FormLabel>Find Transit Name</FormLabel>
                                        <InputGroup size='sm' className='ml-1'>
                                            <FormControl style={{ textTransform: "uppercase" }} onKeyDown={JobDialogTransitNameKeyDown}
                                                placeholder="FIND TRANSIT NAME" onChange={JobDialogTransitChangeHandel}
                                                value={jobDialogValues.transit_name} />
                                        </InputGroup>
                                    </div>
                                </center></Row>
                                <Row><center>
                                    <div className='form-inline' style={{ marginLeft: "30%", marginTop: "1rem" }}>
                                        <FormLabel>Find Transit Code</FormLabel>
                                        <InputGroup size='sm' className='ml-2'>
                                            <FormControl style={{ textTransform: "uppercase" }} autoFocus
                                                id='JobDialogFTransitCode' placeholder="FIND TRANSIT CODE" onChange={JobDialogTransitCodeChangeHandel}
                                                value={jobDialogValues.transit_code} onKeyDown={JobDialogTransitCodeKeyDown} />
                                        </InputGroup>
                                    </div>
                                </center></Row>
                                <br></br>
                            </div>
                            <TableContainer className={classes.container}>
                                <Table stickyHeader aria-label="table" size="small" >
                                    <TableHead >
                                        <StyledTableRow>
                                            <StyledTableCell align='center'>FIND TRANSIT CODE</StyledTableCell>
                                            <StyledTableCell align='center'>FIND TRANSIT NAME</StyledTableCell>
                                        </StyledTableRow>
                                    </TableHead>
                                    <TableBody>
                                        {
                                            transitDetails.map((trns) => {const selectedItem = isMasterTransitSelected(trns.transitTypeCode);
                                                return(
                                                    <TableRow hover id='masterTrnsit_id' onKeyDown={masterTransitKeyDown} onClick={() => jobeditTransitType(trns)}
                                                        key={trns.transitTypeCode} tabIndex={-1} selected={selectedItem}>
                                                        <TableCell align='center'>{trns.transitTypeCode}</TableCell>
                                                        <TableCell align='center'>{trns.transitTypeName}</TableCell>
                                                    </TableRow>
                                                )})}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Dialog>
                        {/*-------------------------------chsCode dialog------------------------------*/}
                        <Dialog onClose={JobChsCodeHandleClose} open={JobChsOpen} fullWidth={true} maxWidth="md">
                            <DialogTitle className="dialogboxtitlecolour p-1"><center>VIEW CUSTOM HOUSE DETAILS</center></DialogTitle>
                            <div className='dialogboxcolour'>
                                <Col><center>
                                    <Form.Label>Find Custom House Name</Form.Label>
                                    <FormControl style={{ textTransform: "uppercase", width: '20%' }}
                                        onChange={JobDialogCHSChangeHandel} size='sm' onKeyDown={JobDialogCusHousNameKeyDown}
                                        value={jobDialogValues.cusHousName} />
                                </center></Col>
                                <Col><center>
                                    <Form.Label>Find Custom House Code</Form.Label>
                                    <FormControl style={{ textTransform: "uppercase", width: '20%' }}
                                        id='JobDialogFCusHouseCode' onChange={JobDialogChsCodeChangeHandel} size='sm' autoFocus
                                        value={jobDialogValues.cusHousCode} onKeyDown={JobDialogCusHousCodeKeyDown} />
                                </center></Col>
                                <br></br>
                            </div>
                            <TableContainer className={classes.container}>
                                <Table stickyHeader aria-label="table" size="small" >
                                    <TableHead >
                                        <StyledTableRow>
                                            <StyledTableCell align='center'>CUSTOM HOUSE CODE</StyledTableCell>
                                            <StyledTableCell align='center'>CUSTOM HOUSE NAME</StyledTableCell>
                                        </StyledTableRow>
                                    </TableHead>
                                    <TableBody>
                                        {
                                            CustomHouseDetails.map((cus) => { const selectedItem = isMasterTransitSelected(cus.customHouseCode);
                                                return(
                                                    <TableRow hover id='masterCusCode_id' onKeyDown={masterCustomKeyDown} onClick={() => JobEditCusHouscode(cus)}
                                                        key={cus.customHouseCode} tabIndex={-1} selected={selectedItem}>
                                                        <TableCell align='center'>{cus.customHouseCode}</TableCell>
                                                        <TableCell align='center'>{cus.customHouseLocation}</TableCell>
                                                    </TableRow>
                                                )})}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Dialog>
                        {/*------------------------branch dialog---------------------------------------*/}
                        <Dialog onClose={JobBranchHandleClose} open={JobBranchOpen} fullWidth={true} maxWidth="md">
                            <DialogTitle className="dialogboxtitlecolour p-1"><center>VIEW BRANCH DETAILS</center></DialogTitle>
                            <div className='dialogboxcolour'>
                                <Col><center>
                                    <Form.Label>Find Branch Name</Form.Label>
                                    <FormControl style={{ textTransform: "uppercase", width: '15%' }} autoFocus
                                        placeholder="FIND BRANCH NAME" onChange={JobDialogBranchChangeHandel}
                                        value={jobDialogValues.branch}  onKeyDown={JobDialogBranchKeyDown} />
                                </center></Col>
                                <br></br>
                            </div>
                            <TableContainer className={classes.container}>
                                <Table stickyHeader aria-label="table" size="small" >
                                    <TableHead >
                                        <StyledTableRow>
                                            <StyledTableCell align='center'>Regional Name</StyledTableCell>
                                        </StyledTableRow>
                                    </TableHead>
                                    <TableBody>
                                        {
                                            BranchDetails.map((brncdta) => {const selectedItem = isMasterTransitSelected(brncdta.regionalName);
                                                return(
                                                    <TableRow hover id='masterBranch_id' onKeyDown={masterBranchKeyDown} onClick={() => JobEditBranchName(brncdta)}
                                                        key={brncdta.regionalName} tabIndex={-1} selected={selectedItem}>
                                                        <TableCell align='center'>{brncdta.regionalName}</TableCell>
                                                    </TableRow>
                                                )})}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Dialog>
                        {/*------------------------frwdr dialog------------------------------------------*/}
                        <Dialog onClose={JobFrwdrHandleClose} open={JobFrwdrOpen} fullWidth={true} maxWidth="md">
                            <DialogTitle className="dialogboxtitlecolour p-1"><center>VIEW FORWARDER DETAILS</center></DialogTitle>
                            <div className='dialogboxcolour'>
                                <center><Form.Label>Find Forwarder</Form.Label>
                                    <FormControl style={{ textTransform: "uppercase", width: '18%' }}
                                        onChange={JobDialogForwdrChangeHandel} autoFocus
                                        value={jobDialogValues.forwdr}  onKeyDown={JobDialogforwrdrKeyDown} />
                                </center>
                                <br></br>
                            </div>
                            <TableContainer className={classes.container}>
                                <Table stickyHeader aria-label="table" size="small" >
                                    <TableHead >
                                        <StyledTableRow>
                                            <StyledTableCell align='center'>Regional Name</StyledTableCell>
                                        </StyledTableRow>
                                    </TableHead>
                                    <TableBody>
                                        {
                                            ForwdrDetails.map((frwd) =>{ const selectedItem = isMasterTransitSelected(frwd.freightFwdName);
                                                return(
                                                    <StyledTableRow hover id='masterRegional_id' onKeyDown={masterFrwdrKeyDown} onClick={() => JobEditFrwdr(frwd)}
                                                        key={frwd.freightFwdId} tabIndex={-1} selected={selectedItem}>
                                                        <StyledTableCell align='center'>{frwd.freightFwdName}</StyledTableCell>
                                                    </StyledTableRow>
                                                )})}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Dialog>
                        {/*------------------------Iec dialog----------------------------------------*/}
                        <Dialog onClose={JobIecHandleClose} open={JobIecOpen} fullWidth={true} maxWidth="md">
                            <DialogTitle className="dialogboxtitlecolour p-1"><center>VIEW IMPORTER DETAILS</center></DialogTitle>
                            <div className='dialogboxcolour'>
                                <center>
                                    <FormLabel>Find Importer Name</FormLabel>
                                    <FormControl style={{ textTransform: "uppercase", width: '20%' }}
                                        onChange={JobDialogImpNameChangeHandel} size='sm' onKeyDown={JobDialogIecImporterNameKeyDown}
                                        value={jobDialogValues.importer_name} />

                                </center>
                                <center>
                                    <FormLabel>Find Importer Code</FormLabel>
                                    <FormControl style={{ textTransform: "uppercase", width: '20%' }} id='JobDialogImportCode' onChange={JobDialogImpCodeChangeHandel} size='sm' autoFocus
                                        value={jobDialogValues.importer_code} onKeyDown={JobDialogIecImporterCodeKeyDown} />
                                </center>
                                <br></br>
                            </div>
                            <TableContainer className={classes.container}>
                                <Table stickyHeader aria-label="table" size="small" >
                                    <TableHead >
                                        <StyledTableRow>
                                            <StyledTableCell align='center'>Importer IEC Code</StyledTableCell>
                                            <StyledTableCell align='center'>Importer Name</StyledTableCell>
                                        </StyledTableRow>
                                    </TableHead>
                                    <TableBody>
                                        {
                                            JobImporterDetails.map((impdtails) => { const selectedItem = isMasterTransitSelected(impdtails.importer_iec_no);
                                                return(
                                                    <TableRow hover  id='masterImporterIec_id' onKeyDown={masterImporterIecKeyDown} onClick={() => jobEditImporter(impdtails)}
                                                        key={impdtails.importer_iec_no} tabIndex={-1} selected={selectedItem}>
                                                        <TableCell align='center'>{impdtails.importer_iec_no}</TableCell>
                                                        <TableCell align='center'>{impdtails.importer_name}</TableCell>
                                                    </TableRow>
                                                )})}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Dialog>
                        {/*--------------------Branch_sr dialog----------------------------*/}
                        <Dialog onClose={JobBrancSrHandleClose} open={JobBrncSrOpen} fullWidth={true} maxWidth="md">
                            <DialogTitle className="dialogboxtitlecolour p-1"><center>VIEW IMPORTER BRANCH DETAILS</center></DialogTitle>
                            <div className='dialogboxcolour'>
                                <center>
                                    <div  >
                                        <FormLabel>Find Importer State</FormLabel>
                                        <FormControl style={{ textTransform: "uppercase", width: "20%", textAlign: "center" }}
                                            size="sm" onChange={JobDialogImpStateChangeHandel} onKeyDown={JobDialogImporterStateKeyDown}
                                            value={jobDialogValues.importer_state} />
                                    </div>
                                </center>
                                <center>
                                    <div className='mt-3'>
                                        <FormLabel>Find Branch SrNo</FormLabel>
                                        <FormControl style={{ textTransform: "uppercase", width: "20%", textAlign: "center" }} onKeyDown={JobDialogBranchSl_noKeyDown}
                                            id='JobDialogJobBranchSlNo' onChange={JobDialogBranchSrChangeHandel} size="sm" autoFocus value={jobDialogValues.branch_sr_no} />
                                    </div>
                                </center>
                                <br></br>
                            </div>
                            <TableContainer className={classes.container}>
                                <Table stickyHeader aria-label="table" size="small" >
                                    <TableHead >
                                        <StyledTableRow>
                                            <StyledTableCell align='center'>Sl.No</StyledTableCell>
                                            <StyledTableCell align='center'>State</StyledTableCell>
                                            <StyledTableCell align='center'>Address</StyledTableCell>
                                            <StyledTableCell align='center'>Address_2</StyledTableCell>
                                        </StyledTableRow>
                                    </TableHead>
                                    <TableBody>
                                        {
                                            BranchSrDetails.map((brncsr) => { const selectedItem = isMasterTransitSelected(brncsr.branch_sl_no);
                                                return(
                                                    <TableRow hover id='masterBrnch_sl_id' onKeyDown={masterBrnchSlNOKeyDown} onClick={() => jobEditBrncSl(brncsr)}
                                                        key={brncsr.branchSrNoState} tabIndex={-1} selected={selectedItem}>
                                                        <TableCell align='center'>{brncsr.branch_sl_no}</TableCell>
                                                        <TableCell align='center'>{brncsr.importerState}</TableCell>
                                                        <TableCell align='center'>{brncsr.importerAddress}</TableCell>
                                                        <TableCell align='center'>{brncsr.importerAddress1}</TableCell>
                                                    </TableRow>
                                                )})}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Dialog>
                        {/*--------------------------Ad Code dialog--------------------------------*/}
                        <Dialog onClose={JobAdCodeHandleClose} open={JobAdCodeOpen} fullWidth={true} maxWidth="md">
                            <DialogTitle className="dialogboxtitlecolour p-1"><center>VIEW AD CODE DETAILS</center></DialogTitle>
                            <div className='dialogboxcolour'>
                                <Row><center>
                                    <div className='form-inline mt-2' style={{ marginLeft: "30%" }}>
                                        <FormLabel className='mr-1'>FIND AD CODE</FormLabel>
                                        <InputGroup size='sm'>
                                            <FormControl style={{ textTransform: "uppercase" }} onKeyDown={JobDialogAdCodeKeyDown}
                                            onChange={JobDialogAdCodeChangeHandel} autoFocus value={jobDialogValues.ad_code} />
                                        </InputGroup>
                                    </div>
                                </center></Row>
                                <br></br>
                            </div>
                            <TableContainer className={classes.container}>
                                <Table stickyHeader aria-label="table" size="small" >
                                    <TableHead >
                                        <StyledTableRow>
                                            <StyledTableCell align='center'>IEC.Code</StyledTableCell>
                                            <StyledTableCell align='center'>AdCode</StyledTableCell>
                                            <StyledTableCell align='center'>ForexCode</StyledTableCell>
                                            <StyledTableCell align='center'>IfscCode</StyledTableCell>
                                            <StyledTableCell align='center'>AccountNo</StyledTableCell>
                                            <StyledTableCell align='center'>BankName</StyledTableCell>
                                            <StyledTableCell align='center'>BankAddress</StyledTableCell>
                                        </StyledTableRow>
                                    </TableHead>
                                    <TableBody>
                                        {
                                            JobAdCodeDetails.map((brncsr) => { const selectedItem = isMasterTransitSelected(brncsr.ad_code);
                                                return(
                                                    <TableRow hover id='masterAdCode_id' onKeyDown={masterAdCodeKeyDown} onClick={() => jobEditAdCode(brncsr)}
                                                        key={brncsr.importer_iec_no} tabIndex={-1} selected={selectedItem}>
                                                        <TableCell align='center'>{brncsr.importer_iec_no}</TableCell>
                                                        <TableCell align='center'>{brncsr.ad_code}</TableCell>
                                                        <TableCell align='center'>{brncsr.forexCode}</TableCell>
                                                        <TableCell align='center'>{brncsr.ifscCode}</TableCell>
                                                        <TableCell align='center'>{brncsr.accountNo}</TableCell>
                                                        <TableCell align='center'>{brncsr.bankName}</TableCell>
                                                        <TableCell align='center'>{brncsr.bankAdress}</TableCell>
                                                    </TableRow>
                                                )})}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Dialog>
                        {/*--------------CountryOrigin dialog-----------------------------*/}
                        <Dialog onClose={JobCountryOriginHandleClose} open={JobCountryOriginOpen}
                            fullWidth={true} maxWidth="md">
                            <DialogTitle className="dialogboxtitlecolour p-1"><center>VIEW ORIGIN COUNTRY DETAILS</center></DialogTitle>
                            <div className='dialogboxcolour'>
                                <Row><center>
                                    <InputGroup className='form-inline w-50 mt-2' size='sm'>
                                        <FormLabel>Find Country Name</FormLabel>
                                        <FormControl className='ml-1' style={{ textTransform: "uppercase" }}
                                            onChange={JobDialogCntryOrgnNameeChangeHandel} onKeyDown={JobDialogFindOriginCntryNameKeyDown}
                                            value={jobDialogValues.f_countryOrginName} />
                                    </InputGroup></center></Row>
                                <Row><center>
                                    <InputGroup className='form-inline w-50 mt-2' size='sm'>
                                        <FormLabel>Find Country Code</FormLabel>
                                        <FormControl className='ml-2' style={{ textTransform: "uppercase" }} onKeyDown={JobDialogFindOriginCntryCodeKeyDown}
                                            id='JobDialogOriginFCntryCode' onChange={JobDialogCntryOrgnCodeChangeHandel} value={jobDialogValues.f_countryOriginCode} autoFocus />
                                    </InputGroup></center></Row>
                                <br></br></div><TableContainer className={classes.container}>
                                <Table stickyHeader aria-label="table" size="small" >
                                    <TableHead >
                                        <StyledTableRow>
                                            <StyledTableCell align='center'>CountryCode</StyledTableCell>
                                            <StyledTableCell align='center'>CountryName</StyledTableCell>
                                        </StyledTableRow>
                                    </TableHead>
                                    <TableBody>
                                        {
                                            JobCountryOrigineDtails.map((cntrorgn) => { const selectedItem = isMasterTransitSelected(cntrorgn.countryIdString);
                                                return(
                                                    <TableRow hover id='masterOriginCountry_id' onKeyDown={masterOriginCountryKeyDown} onClick={() => JobEditCntryOrign(cntrorgn)}
                                                        key={cntrorgn.countryIdString} tabIndex={-1} selected={selectedItem}>
                                                        <TableCell align='center'>{cntrorgn.countryIdString}</TableCell>
                                                        <TableCell align='center'>{cntrorgn.countryName}</TableCell>
                                                    </TableRow>
                                                )})}
                                    </TableBody>
                                </Table>
                            </TableContainer>

                        </Dialog>
                        {/*----------------CountryOfCm dialog----------------------------*/}
                        <Dialog onClose={JobCountryCMHandleClose} open={JobCountryCmOpen} fullWidth={true} maxWidth="md">
                            <DialogTitle className="dialogboxtitlecolour p-1"><center>VIEW CONSIGNMENT COUNTRY DETAILS</center></DialogTitle>
                            <div className='dialogboxcolour'>
                                <Row><center>
                                    <InputGroup className='form-inline w-50 mt-2' size='sm'>
                                        <FormLabel>Find Country Name</FormLabel>
                                        <FormControl className='ml-1' style={{ textTransform: "uppercase" }} onChange={JobDialogCntryOfCmNamChangeHandel}
                                            value={jobDialogValues.f_countryOfCm} />
                                    </InputGroup></center></Row>
                                <Row><center>
                                    <InputGroup className='form-inline w-50 mt-1' size='sm'>
                                        <FormLabel>Find Country Code</FormLabel>
                                        <FormControl className='ml-2' style={{ textTransform: "uppercase" }} onChange={JobDialogCntryOfCmCodChangeHandel}
                                            autoFocus value={jobDialogValues.f_countryOfCmCode} onKeyDown={JobDialogFindConsignCntryCodeKeyDown} />
                                    </InputGroup></center></Row>
                                <br></br>
                            </div>
                            <TableContainer className={classes.container}>
                                <Table stickyHeader aria-label="table" size="small" >
                                    <TableHead >
                                        <StyledTableRow>
                                            <StyledTableCell align='center'>CountryCode</StyledTableCell>
                                            <StyledTableCell align='center'>CountryName</StyledTableCell>
                                        </StyledTableRow>
                                    </TableHead>
                                    <TableBody>
                                        {
                                            JobCountryOfCmDtails.map((cntrorgn) => { const selectedItem = isMasterTransitSelected(cntrorgn.countryIdString);
                                                return(
                                                    <TableRow hover  id='masterConsignmentCountry_id' onKeyDown={masterConsigmentCountryKeyDown} onClick={() => JobEditCntryOfCm(cntrorgn)}
                                                        key={cntrorgn.countryIdString} tabIndex={-1} selected={selectedItem}>
                                                        <TableCell align='center'>{cntrorgn.countryIdString}</TableCell>
                                                        <TableCell align='center'>{cntrorgn.countryName}</TableCell>
                                                    </TableRow>
                                                )})}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Dialog>
                        {/*---------------------------PortOfLoading dialog------------------------------*/}
                        <Dialog onClose={JobPortOfLoadinHandleClose} open={JobPortOfLoadingOpen} fullWidth={true} maxWidth="md">
                            <DialogTitle className="dialogboxtitlecolour p-1"><center>VIEW ORIGIN PORT DETAILS</center></DialogTitle>
                            <div className='dialogboxcolour'>
                                <Row><center>
                                    <InputGroup className='form-inline w-50 mt-2' size='sm'>
                                        <FormLabel>Find OriginPort Name</FormLabel>
                                        <FormControl className='ml-1' onKeyDown={JobDialogFindPortCntryNameKeyDown} onChange={JobDialogPortNameChangeHandel}
                                            value={jobDialogValues.f_port_ofName} style={{ textTransform: 'uppercase' }} />
                                    </InputGroup></center></Row>
                                <Row><center>
                                    <InputGroup className='form-inline w-50 mt-1' size='sm'>
                                        <FormLabel>Find OriginPort Code</FormLabel>
                                        <FormControl className='ml-2' autoFocus style={{ textTransform: 'uppercase' }} onKeyDown={JobDialogFindPortCntrycodeKeyDown}
                                            id='JobDialogPortFindPortCode' onChange={JobDialogPortCodeChangeHandel} value={jobDialogValues.f_port_Code} />
                                    </InputGroup></center></Row>
                                <br></br>
                            </div>
                            <TableContainer className={classes.container}>
                                <Table stickyHeader aria-label="table" size="small" >
                                    <TableHead >
                                        <StyledTableRow>
                                            <StyledTableCell align='center'>CountryCode</StyledTableCell>
                                            <StyledTableCell align='center'>CountryName</StyledTableCell>
                                        </StyledTableRow>
                                    </TableHead>
                                    <TableBody>
                                        {
                                            JobCountryOfCmDtails.map((cntrorgn) => { const selectedItem = isMasterTransitSelected(cntrorgn.customPointCode);
                                                return(
                                                    <TableRow hover id='masterOriginPort_id' onKeyDown={masterOriginPortKeyDown}  onClick={() => JobEditCntryOfPort(cntrorgn)}
                                                        key={cntrorgn.consignmentNumber} tabIndex={-1} selected={selectedItem}>
                                                        <TableCell align='center'>{cntrorgn.customPointCode}</TableCell>
                                                        <TableCell align='center'>{cntrorgn.customPointName}</TableCell>
                                                    </TableRow>
                                                )})}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Dialog>
                    </div>
                    {/*-------------------------input-Y/N-Dialogbox-----------------------------------------------------------------------------------*/}
                    <div>
                        {/* certificate */}
                        <Dialog onClose={JobCertificateClose} open={JobCertificateOpen} fullWidth={true} maxWidth="md">
                            <DialogTitle className="dialogboxtitlecolour p-1"><center>Add Certificate Details</center></DialogTitle>
                            <div className='dialogboxcolour'>
                                <div className='form-inline mt-2 mb-2'>
                                    <Form.Label style={{ marginLeft: '7%', color: 'red' }}>Certificate No</Form.Label>
                                    <input className='ml-1' value={jobDialogValues.certificate_No}
                                        onChange={JobDialogCertificateNoChangeHandel} autoFocus onKeyDown={JobDialogCertificateNoKeyDown}
                                        style={{ height: '22px', textTransform: 'uppercase' }} />
                                    {/*  */}
                                    <Form.Label style={{ color: 'red' }}>Certificate Type</Form.Label>
                                    <select className='ml-1' value={jobDialogValues.certificate_Type} onKeyDown={JobDialogCertificateTypeKeyDown}
                                        onChange={JobDialogCertificateTypeChangeHandel} id='jobCertificateType'
                                        style={{ height: '22px', textTransform: 'uppercase', width: '20%' }}>
                                        <option value={''}></option>
                                        {certifcatetypeDetai.map((type) => (
                                            <option value={type.certificateTypeDesc}>{type.certificateTypeDesc}</option>
                                        ))}
                                    </select>
                                    {/*  */}
                                    <Form.Label style={{ color: 'red' }}>Certificate Date</Form.Label>
                                    <input className='ml-1' type='date' value={jobDialogValues.certificate_Date} onKeyDown={JobDialogCertificateDateKeyDown}
                                        id='JobCertificateDate' onChange={JobDialogCertificateDateChangeHandel} min={'1990-01-01'} max={'2100-12-31'}
                                        style={{ height: '22px', textTransform: 'uppercase' }} />
                                    {/*  */}
                                </div>
                                <div className='form-inline mt-1 mb-1' >
                                    <Button style={{ marginLeft: '35%' }} className='mr-1' onClick={SaveCertificate} disabled={jobDialoSavDisa} size='small' variant="contained" color="primary">
                                        {jobDialogSave ? 'processing...' : 'Save'}</Button>{' '}
                                    <Button disabled={jobDialogUpdtDisa} className='mr-1' size='small' variant="contained" color="primary"
                                        onClick={UpdateCertificate} >{jobDialogUpdate ? 'processing...' : 'Update'}</Button>{' '}
                                    <Button onClick={DeleteCertificate} className='mr-1' size='small' variant="contained" color="primary"
                                        disabled={jobDialogDltDisa}>{jobDialogDelete ? 'processing...' : 'Delete'}</Button>{' '}
                                    <Button onClick={certificateReset} onKeyDown={JobDialogCertificateRefBtnKeyDown} size='small' variant="contained" color="primary">Refresh</Button>{' '}
                                </div>
                            </div>
                            <TableContainer className={classes.container}>
                                <Table stickyHeader aria-label="table" size="small" >
                                    <TableHead >
                                        <StyledTableRow>
                                            <StyledTableCell align='center'>Sl.No</StyledTableCell>
                                            <StyledTableCell align='center'>Job.No</StyledTableCell>
                                            <StyledTableCell align='center'>Certificate.No</StyledTableCell>
                                            <StyledTableCell align='center'>Certificate Type</StyledTableCell>
                                            <StyledTableCell align='center'>Certificate Date</StyledTableCell>
                                        </StyledTableRow>
                                    </TableHead>
                                    <TableBody>
                                        {
                                            JobAdCodeDetails.map((brncsr) => { const selectedItem = isMasterTransitSelected(brncsr.certificateNo);
                                                return(
                                                    <TableRow hover id='masterCertificateNo_id' onKeyDown={masterCertificateNoKeyDown} onClick={() => jobEditCertificate(brncsr)}
                                                        key={brncsr.certificateId} tabIndex={-1} selected={selectedItem}>
                                                        <TableCell align='center'>{brncsr.serialNumber}</TableCell>
                                                        <TableCell align='center'>{brncsr.consignmentId}</TableCell>
                                                        <TableCell align='center'>{brncsr.certificateNo}</TableCell>
                                                        <TableCell align='center'>{brncsr.certificateType}</TableCell>
                                                        <TableCell align='center'>{brncsr.certificateDate}</TableCell>
                                                    </TableRow>
                                                )})}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Dialog>
                        {/*---------------------------------- Bond ---------------------------*/}
                        <Dialog onClose={JobBondClose} open={JobBondOpen} fullWidth={true} maxWidth="md">
                            <DialogTitle className="dialogboxtitlecolour p-1"><center>Add Bond Details</center></DialogTitle>
                            {/*  */}
                            <Dialog onClose={JobBondPortClose} open={JobBondPortOpen} fullWidth={true} maxWidth="md">
                                <DialogTitle className="dialogboxtitlecolour p-1"><center>Add Bond Port Details</center></DialogTitle>
                                <div className='dialogboxcolour'>
                                    <div className='form-inline mt-3'>
                                        <Form.Label style={{ marginLeft: '25%' }}>Find BondPortName</Form.Label>
                                        <FormControl onChange={JobDialogF_BondPortNameChangeHandel} onKeyDown={JobDialogFindBondPortNameKeyDown}
                                            style={{ width: '25%', marginLeft: '1%', textTransform: 'uppercase' }} value={jobDialogValues.bond_portName} size="sm" />
                                    </div>
                                    <div className='form-inline mt-3'>
                                        <Form.Label style={{ marginLeft: '25%' }}>Find BondPortCode</Form.Label>
                                        <FormControl value={jobDialogValues.find_bond_port} onChange={JobDialogF_BondPortCodeChangeHandel} autoFocus onKeyDown={JobDialogFindBondPortCodeKeyDown}
                                            id='JobFindBandPortCode' style={{ width: '25%', marginLeft: '1.7%', textTransform: 'uppercase' }} size="sm" />
                                    </div>
                                    <br></br>
                                </div>
                                <TableContainer className={classes.container}>
                                    <Table stickyHeader aria-label="table" size="small" >
                                        <TableHead >
                                            <StyledTableRow>
                                                <StyledTableCell align='center'>BondPortCode</StyledTableCell>
                                                <StyledTableCell align='center'>BondPortName</StyledTableCell>
                                            </StyledTableRow>
                                        </TableHead>
                                        <TableBody>
                                            {
                                                CustomHouseDetails.map((brncsr) => { const selectedItem = isMasterTransitSelected(brncsr.customHouseCode);
                                                    return(
                                                        <TableRow hover id='masterBondPortCode_id' onKeyDown={masterBondPortKeyDown} onClick={() => jobbondPortCusDetails(brncsr)}
                                                            key={brncsr.certificateId} tabIndex={-1} selected={selectedItem}>
                                                            <TableCell align='center'>{brncsr.customHouseCode}</TableCell>
                                                            <TableCell align='center'>{brncsr.customHouseLocation}</TableCell>
                                                        </TableRow>
                                                    )})}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Dialog>
                            {/* */}
                            <div className='dialogboxcolour'>
                                <div className='form-inline mt-2' style={{ color: 'red' }}>
                                    <Form.Label style={{ marginLeft: '8%' }}>Bond.No</Form.Label>
                                    <input className='ml-1 hi22' onChange={JobDialogBondNoChangeHandel} required id='bondNo'
                                        autoFocus value={jobDialogValues.bondNo} style={{ textTransform: 'uppercase' }} onKeyDown={JobDialogBondPortNoKeyDown} />
                                    {/*  */}
                                    <Form.Label className='ml-1'>Bond Code</Form.Label>
                                    <select className='ml-1 hi22' onChange={JobDialogBondCodeChangeHandel} onKeyDown={JobDialogBondCodeKeyDown}
                                        id='JobKeyBondCode' value={jobDialogValues.bond_code} required style={{ width: '22%', textTransform: 'uppercase' }}>
                                        <option value={''}></option>
                                        {bondcodeDrp.map((code) => (
                                            <option value={code.bondCodeDesc}>{code.bondCodeDesc}</option>
                                        ))}
                                    </select>
                                    {/*  */}
                                    <Form.Label className='ml-1'>Band Port</Form.Label>
                                    <input className='ml-1 hi22' onChange={JobDialogBondPortChangeHandel} required
                                        id='JobBondBondPort' value={jobDialogValues.bond_port} onKeyDown={jobdialogeBondPortKeyUp} style={{ textTransform: 'uppercase' }} />
                                    <button className='hi22 bg-success' onClick={DialogeJobBondPortOpenHandle}>
                                        <SearchIcon fontSize="small" />
                                    </button>
                                </div>
                                <div className='form-inline mt-2'>
                                    <Form.Label style={{ marginLeft: '5%' }}>Bond Amount</Form.Label>
                                    <input className='ml-1 hi22' value={jobDialogValues.bond_amount} onChange={JobDialogBondAmountChangeHandel}
                                        style={{ width: '14%', textTransform: 'uppercase' }} id='BondAmount' type={'number'} onKeyDown={jobdialogeBondAmountKeyUp} />
                                    <Form.Label className='ml-1'>BG Debited</Form.Label>
                                    <input className='ml-1 hi22' value={jobDialogValues.bg_debited} onChange={JobDialogBgDebitedChangeHandel}
                                        style={{ width: '14%', textTransform: 'uppercase' }} id='BgDebited' type={'number'} onKeyDown={jobdialogeBondBgDebitedKeyDown} />
                                    <Form.Label className='ml-1'>BG Rate</Form.Label>
                                    <input className='ml-1 hi22' value={jobDialogValues.bg_rate} id='BgRate' onChange={JobDialogBgRateChangeHandel}
                                        style={{ width: '14%', textTransform: 'uppercase' }} type={'number'} onKeyDown={jobdialogeBondBgRateKeyDown} />
                                    <Form.Label className='ml-1'>BG Amount</Form.Label>
                                    <input className='ml-1 hi22' value={jobDialogValues.bg_ammount} id='BgAmount' onChange={JobDialogBgAmountChangeHandel}
                                        style={{ width: '14%', textTransform: 'uppercase' }} type={'number'} onKeyDown={jobdialogeBondBgAmountKeyDown} />
                                </div>
                                <div className='form-inline mt-2 mb-2'>
                                    <Button size='small' variant="contained" color="primary" className='mr-1' style={{ marginLeft: '35%' }} disabled={bondSaveDisab}
                                        onClick={JobDialogeBondDetailSave}>{jobBondSave ? 'Processing..' : 'Save'}</Button>{' '}
                                    <Button size='small' variant="contained" color="primary" className='mr-1' disabled={bondUpdtDisab} onClick={JobDialogeBondDetailUpdate}>{jobBondUpdt ? 'Processing..' : 'Update'}</Button>{' '}
                                    <Button size='small' variant="contained" color="primary" className='mr-1' disabled={bondDltDisab} onClick={JobDialogeBondDetailDelete}>{jobBondDlt ? 'Processing..' : 'Delete'}</Button>{' '}
                                    <Button size='small' variant="contained" color="primary" onKeyDown={JobDialogBondRefBtnKeyDown} onClick={bondReset}>Refresh</Button>{' '}
                                </div>
                            </div>
                            <TableContainer className={classes.container}>
                                <Table stickyHeader aria-label="table" size="small" >
                                    <TableHead >
                                        <StyledTableRow>
                                            <StyledTableCell align='center'>Sl.No</StyledTableCell>
                                            <StyledTableCell align='center'>Job.No</StyledTableCell>
                                            <StyledTableCell align='center'>Bond.No</StyledTableCell>
                                            <StyledTableCell align='center'>BondCode</StyledTableCell>
                                            <StyledTableCell align='center'>BondPort</StyledTableCell>
                                            <StyledTableCell align='center'>BondAmount</StyledTableCell>
                                            <StyledTableCell align='center'>BG.Debited</StyledTableCell>
                                            <StyledTableCell align='center'>BG.Rate</StyledTableCell>
                                            <StyledTableCell align='center'>BG.Amount</StyledTableCell>
                                        </StyledTableRow>
                                    </TableHead>
                                    <TableBody>
                                        {
                                            JobAdCodeDetails.map((brncsr) => { const selectedItem = isMasterTransitSelected(brncsr.bondNo);
                                                return(
                                                    <TableRow hover id='masterBondDetails_id' onKeyDown={masterBondDetailsKeyDown} onClick={() => jobEditBondDetails(brncsr)}
                                                        key={brncsr.certificateId} tabIndex={-1} selected={selectedItem}>
                                                        <TableCell align='center'>{brncsr.serialNumber}</TableCell>
                                                        <TableCell align='center'>{brncsr.consignmentId}</TableCell>
                                                        <TableCell align='center'>{brncsr.bondNo}</TableCell>
                                                        <TableCell align='center'>{brncsr.bondCode}</TableCell>
                                                        <TableCell align='center'>{brncsr.destinationId}</TableCell>
                                                        <TableCell align='center'>{brncsr.bondAmount}</TableCell>
                                                        <TableCell align='center'>{brncsr.bgDebit}</TableCell>
                                                        <TableCell align='center'>{brncsr.bgRate}</TableCell>
                                                        <TableCell align='center'>{brncsr.bgAmount}</TableCell>
                                                    </TableRow>
                                                )})}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Dialog>
                        {/*------------------------JobContainer---------------------------------------*/}
                        <Dialog onClose={JobContainerClose} open={JobContainerOpen} fullWidth={true} maxWidth="md">
                            <DialogTitle className="dialogboxtitlecolour p-1"><center>Add Container Details</center></DialogTitle>
                            <Grid container spacing={1}>
                                <Grid item xs={5}>
                                    <Paper className={classes.cardJob} style={{ backgroundColor: '#C8EDE7', height: '273px' }}>
                                        <Form>
                                            <div className='form-inline mt-1'>
                                                <Form.Label>IGM NO</Form.Label>
                                                <select value={jobDialogValues.container_igm_no}
                                                    onChange={JobDialogIgmNoChangeHandel} onKeyDown={jobdialogeContainerIgmNoKeyDown} autoFocus
                                                    style={{ height: '22px', textTransform: 'uppercase', marginLeft: '24%', width: '46%' }}>
                                                    <option>{''}</option>{
                                                        jobigmdropdwon.map((trns) => (
                                                            <option value={trns.igmId}>{trns.igmNo}</option>
                                                        ))}
                                                </select>
                                            </div>
                                            <div className='form-inline mt-1'>
                                                <Form.Label style={{ color: 'red' }}>Container No</Form.Label>
                                                <input value={jobDialogValues.container_no} required={true} onKeyDown={jobdialogeContainerNoKeyDown}
                                                    onChange={JobDialogContainerNoChangeHandel} id='JobDialogContainerNo'
                                                    style={{ height: '22px', textTransform: 'uppercase', marginLeft: '15%' }} />
                                            </div>
                                            {/*  */}
                                            <div className='form-inline mt-1'>
                                                <Form.Label>Container Size</Form.Label>
                                                <input value={jobDialogValues.container_size} onChange={JobDialogContainersizeChangeHandel} onKeyDown={jobdialogeContainerSizeKeyDown}
                                                    id='JobDialogContainerSize' style={{ height: '22px', textTransform: 'uppercase', marginLeft: '12.5%' }} />
                                            </div>
                                            {/*  */}
                                            <div className='form-inline mt-1'>
                                                <Form.Label>LCL/FCL/CCL(L/F/C)</Form.Label>
                                                <input className='ml-1' value={jobDialogValues.l_f_c} onKeyDown={jobdialogeContainerLFCKeyDown}
                                                    id='jobDialogContainerLFC' onChange={JobDialog_L_F_C_ChangeHandel} maxLength={1}
                                                    style={{ height: '22px', textTransform: 'uppercase', textAlign: 'center' }} />
                                            </div>
                                            {/*  */}
                                            <div className='form-inline mt-1'>
                                                <Form.Label>Seal No</Form.Label>
                                                <input value={jobDialogValues.seal_no} onKeyDown={jobdialogeContainerSealNoKeyDown}
                                                    id='JobDialogcontainerSealNo' onChange={JobDialogSealNoChangeHandel} style={{ height: '22px', textTransform: 'uppercase', marginLeft: '23.5%' }} />
                                            </div>
                                            {/*  */}
                                            <div className='form-inline mt-1'>
                                                <Form.Label>Truck No</Form.Label>
                                                <input value={jobDialogValues.truck_no} onChange={JobDialogTruckNoChangeHandel} onKeyDown={jobdialogeContainerTruckNoKeyDown}
                                                    id='JobDialogTruckNo' style={{ height: '22px', textTransform: 'uppercase', marginLeft: '21.5%' }} />
                                            </div>
                                            {/*  */}
                                            <div className='form-inline mt-3'>
                                                <Button size='small' variant="contained" color="primary" className='mr-1' onClick={jobContainerSave} disabled={JobContainerSveDsab}>
                                                    {JobContainerSve ? "Processing.." : "Save"}</Button>{' '}
                                                <Button size='small' variant="contained" color="primary" className='mr-1' onClick={jobContainerUpdate} disabled={JobContainerUpdtDsab}>
                                                    {JobContainerUpdt ? "Processing.." : "Update"}</Button>{' '}
                                                <Button size='small' variant="contained" color="primary" className='mr-1' onClick={jobContainerDelete} disabled={JobContainerDltDsab}>
                                                    {JobContainerDlt ? "Processing.." : "Delete"}</Button>{' '}
                                                <Button size='small' variant="contained" color="primary" onKeyDown={JobDialogContainerRefBtnKeyDown} onClick={containerReset}>Cancel</Button>{' '}
                                            </div>
                                        </Form>
                                    </Paper>
                                </Grid>
                                <Grid item xs={7}>
                                    <Paper className={classes.cardJob}>
                                        <TableContainer className={classes.container}>
                                            <Table stickyHeader aria-label="table" size="small" >
                                                <TableHead >
                                                    <StyledTableRow>
                                                        <StyledTableCell align='center'>Job.No</StyledTableCell>
                                                        <StyledTableCell align='center'>Container.No</StyledTableCell>
                                                        <StyledTableCell align='center'>Size</StyledTableCell>
                                                        <StyledTableCell align='center'>LCL.FCL</StyledTableCell>
                                                        <StyledTableCell align='center'>IGM.NO</StyledTableCell>
                                                        <StyledTableCell align='center'>Seal.No</StyledTableCell>
                                                        <StyledTableCell align='center'>Truck.No</StyledTableCell>
                                                    </StyledTableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {
                                                        JobAdCodeDetails.map((brncsr) =>{ const selectedItem = isMasterTransitSelected(brncsr.containorNo);
                                                            return(
                                                                <TableRow hover id='masterContainerDetails_id' onKeyDown={masterContainerDetailsKeyDown} onClick={() => jobEditContainer(brncsr)}
                                                                    key={brncsr.containerId} tabIndex={-1} selected={selectedItem}>
                                                                    <TableCell align='center' className='p-1'>{brncsr.consignmentId}</TableCell>
                                                                    <TableCell align='center' className='p-1'>{brncsr.containorNo}</TableCell>
                                                                    <TableCell align='center' className='p-1'>{brncsr.containorSize}</TableCell>
                                                                    <TableCell align='center' className='p-1'>{brncsr.lcl_fcl}</TableCell>
                                                                    <TableCell align='center' className='p-1'>{brncsr.igmNo}</TableCell>
                                                                    <TableCell align='center' className='p-1'>{brncsr.sealNo}</TableCell>
                                                                    <TableCell align='center' className='p-1'>{brncsr.truck_no}</TableCell>
                                                                </TableRow>
                                                            )})}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </Paper>
                                </Grid>
                            </Grid>
                        </Dialog>
                        {/*------------------- Type(HWX)--------------------*/}
                        <Dialog onClose={JobTypeHWXClose} open={JobTypeHWXOpen} fullWidth={true} maxWidth="lg">
                            <DialogTitle className="dialogboxtitlecolour p-1">WareHouse Details</DialogTitle>
                            {/*  */}
                            <Dialog onClose={JobTypeHWX_custSiteId_Close} open={JobTypeHWXCUSIDOpen} fullWidth={true} maxWidth="md">
                                <DialogTitle className="dialogboxtitlecolour p-1">
                                    <center>VIEW CUSTOM HOUSE DETAILS</center></DialogTitle>
                                <div className='dialogboxcolour'>
                                    <Col><center>
                                        <Form.Label>Find Custom Name</Form.Label>
                                        <FormControl style={{ textTransform: "uppercase", width: '20%' }} onKeyDown={JobDialogWhereCusHusNameKeyDown}
                                            onChange={JobDialogwareCHSChangeHandel} size='sm' id='wareCustomeName' value={jobDialogValues.typeH_w_xCustSiteName} />
                                    </center></Col>
                                    <Col><center>
                                        <Form.Label>Find Custom Code</Form.Label>
                                        <FormControl style={{ textTransform: "uppercase", width: '20%' }} autoFocus onKeyDown={JobDialogWhereCusHusKeyDown}
                                        onChange={JobDialogwereChsCodeChangeHandel} size='sm' id='msterFindCustomeCode' value={jobDialogValues.findtypeH_w_xCustSiteId} />
                                    </center></Col>
                                    <br></br>
                                </div>
                                <TableContainer className={classes.container}>
                                    <Table stickyHeader aria-label="table" size="small" >
                                        <TableHead >
                                            <StyledTableRow>
                                                <StyledTableCell align='center'>CUSTOM HOUSE CODE</StyledTableCell>
                                                <StyledTableCell align='center'>CUSTOM HOUSE NAME</StyledTableCell>
                                            </StyledTableRow>
                                        </TableHead>
                                        <TableBody>
                                            {
                                                CustomHouseDetails.map((cus) => { const selectedItem = isMasterTransitSelected(cus.customHouseCode);
                                                    return(
                                                        <TableRow hover id='masterwhereCusHusDetails_id' onKeyDown={masterWhereCusHusDetailsKeyDown} onClick={() => JobEditwareCusHouscode(cus)}
                                                            key={cus.customHouseCode} tabIndex={-1} selected={selectedItem}>
                                                            <TableCell align='center'>{cus.customHouseCode}</TableCell>
                                                            <TableCell align='center'>{cus.customHouseLocation}</TableCell>
                                                        </TableRow>
                                                    )})}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Dialog>
                            {/*  */}
                            <Dialog onClose={JobTypeHWX_pkgCode_Close} open={JobTypeHWXpkgcodeOpen} fullWidth={true} maxWidth="md">
                                <DialogTitle className="dialogboxtitlecolour p-1">
                                    <center>VIEW PACKAGE DETAILS</center></DialogTitle>
                                <div className='dialogboxcolour'>
                                    <Col><center>
                                        <Form.Label>Find Package Name</Form.Label>
                                        <FormControl style={{ textTransform: "uppercase", width: '20%' }} onKeyDown={JobDialogWherePkgNameKeyDown}
                                            onChange={JobDialogwarePackageNameChangeHandel} size='sm' id='warePKGName' value={jobDialogValues.typeH_w_xPkgName} />
                                    </center></Col>
                                    <Col><center>
                                        <Form.Label>Find Package Code</Form.Label>
                                        <FormControl style={{ textTransform: "uppercase", width: '20%' }} onChange={JobDialogwerePackageCodeChangeHandel} size='sm' id='MstrFindPKgCode'
                                            autoFocus value={jobDialogValues.findtypeH_w_xPkgCode} onKeyDown={JobDialogWherePkgcodeKeyDown} />
                                    </center></Col>
                                    <br></br>
                                </div>
                                <TableContainer className={classes.container}>
                                    <Table stickyHeader aria-label="table" size="small" >
                                        <TableHead >
                                            <StyledTableRow>
                                                <StyledTableCell align='center'>Package Code</StyledTableCell>
                                                <StyledTableCell align='center'>Package Rate</StyledTableCell>
                                            </StyledTableRow>
                                        </TableHead>
                                        <TableBody>
                                            {
                                                CustomHouseDetails.map((cus) => { const selectedItem = isMasterTransitSelected(cus.unitCode);
                                                    return(
                                                        <TableRow hover id='masterwherePKGDetails_id' onKeyDown={masterWherePkgKeyDown} onClick={() => JobEditwarePkgCode(cus)}
                                                            key={cus.customHouseCode} tabIndex={-1} selected={selectedItem}>
                                                            <TableCell align='center'>{cus.unitCode}</TableCell>
                                                            <TableCell align='center'>{cus.unitName}</TableCell>
                                                        </TableRow>
                                                    )})}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Dialog>
                            {/*  */}
                            <Dialog onClose={JobTypeHWX_UnitCode_Close} open={JobTypeHWXUnitCodeOpen} fullWidth={true} maxWidth="md">
                                <DialogTitle className="dialogboxtitlecolour p-1">
                                    <center>VIEW UNIT CODE DETAILS</center></DialogTitle>
                                <div className='dialogboxcolour'>
                                    <Col><center>
                                        <Form.Label>Find Unit Name</Form.Label>
                                        <FormControl style={{ textTransform: "uppercase", width: '20%' }} onKeyDown={JobDialogWhereUniteNameKeyDown}
                                            onChange={JobDialogwareUnitNameChangeHandel} size='sm' id='wareUnitName' value={jobDialogValues.typeH_w_xUnitName} />
                                    </center></Col>
                                    <Col><center>
                                        <Form.Label>Find Unit Code</Form.Label>
                                        <FormControl style={{ textTransform: "uppercase", width: '20%' }} onKeyDown={JobDialogWhereUnitecodeKeyDown}
                                            onChange={JobDialogwereUnitCodeChangeHandel} size='sm' id='wareunitCode' value={jobDialogValues.findtypeH_w_xUnitCode} autoFocus />
                                    </center></Col>
                                    <br></br>
                                </div>
                                <TableContainer className={classes.container}>
                                    <Table stickyHeader aria-label="table" size="small" >
                                        <TableHead >
                                            <StyledTableRow>
                                                <StyledTableCell align='center'>Unit Code</StyledTableCell>
                                                <StyledTableCell align='center'>Unit Rate</StyledTableCell>
                                            </StyledTableRow>
                                        </TableHead>
                                        <TableBody>
                                            {
                                                CustomHouseDetails.map((cus) => { const selectedItem = isMasterTransitSelected(cus.unitCode);
                                                    return(
                                                        <TableRow hover id='masterwhereUnitDetails_id' onKeyDown={masterWhereunitKeyDown} onClick={() => JobEditwareUnitCode(cus)}
                                                            key={cus.customHouseCode} tabIndex={-1} selected={selectedItem}>
                                                            <TableCell align='center'>{cus.unitCode}</TableCell>
                                                            <TableCell align='center'>{cus.unitName}</TableCell>
                                                        </TableRow>
                                                    )})}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Dialog>
                            {/*  */}
                            <Paper className={classes.cardJob} style={{ backgroundColor: '#C8EDE7' }}>
                                <div className='form-inline mt-3'>
                                    <label style={{ color: "red", marginLeft: '3%' }}>Code</label>
                                    <input style={{ height: '22px', marginLeft: '4.6%' }} onKeyDown={jobdialogeTypeHWXKeyDown}
                                        autoFocus value={jobDialogValues.typeH_w_xCode} onChange={JabDialogTypeWXHCodeChangehandle}
                                    />
                                    {/*  */}
                                    <label className='ml-2'>Cust Site Id</label>
                                    <input style={{ height: '22px', marginLeft: '2%', width: '10%' }} onKeyDown={jobDialogeWarehusCusIdkeyup}
                                        id='JobCustSiteId' value={jobDialogValues.typeH_w_xCustSiteId} onChange={JabDialogTypeWXhCustSiteIdChangehandle}
                                    />
                                    <button className='searchbutton' onClick={JobTypeHWX_custSiteId_Open}>
                                        <SearchIcon fontSize='small' />
                                    </button>
                                    {/*  */}
                                    <label className='ml-2'>BE No</label>
                                    <input style={{ height: '22px', marginLeft: '3%' }} onKeyDown={jobDialogeWarehusBeNokeyup}
                                        onChange={JabDialogTypeWXhBeNoChangehandle} id={'beno'} value={jobDialogValues.typeH_w_xBeNo}
                                    />
                                    {/*  */}
                                    <label className='ml-2'>BE Date</label>
                                    <input style={{ height: '22px', marginLeft: '2%', textTransform: 'uppercase' }} type='date' onKeyDown={jobDialogeWarehusBeDateKeyDown}
                                        id='JobDialogBedate' onChange={JabDialogTypeWXhBeDateChangehandle} min={'1990-01-01'} max={'2100-12-31'} value={jobDialogValues.typeH_w_xBeDate}
                                    />
                                </div>
                                <div className='form-inline mt-3'>
                                    <label style={{ marginLeft: '3%' }}>No.Of.Pkg</label>
                                    <input style={{ height: '22px', marginLeft: '2%' }} type='number' onKeyDown={jobDialogeWarehusNoOfPkgKeyDown}
                                        id='JobDialogNoOfPkg' onChange={JabDialogTypeWXhNoOfPkgChangehandle} value={jobDialogValues.typeH_w_xNoOfPkg} />
                                    {/*  */}
                                    <label className='ml-2'>Pkg Code</label>
                                    <input style={{ height: '22px', marginLeft: '3%', width: '10%' }} id='JobDialogPkgCode'
                                        onChange={JabDialogTypeWXhPkgCodeChangehandle}
                                        value={jobDialogValues.typeH_w_xPkgCode} onKeyDown={JobTypeHWX_pkgCodeKeyUp}
                                    />
                                    <button className='searchbutton' onClick={JobTypeHWX_pkgCode_Open}>
                                        <SearchIcon fontSize='small' />
                                    </button>
                                    {/*  */}
                                    <label className='ml-2'>Gross Wt</label>
                                    <input style={{ height: '22px', marginLeft: '0.8%' }} type='number' onKeyDown={jobDialogeWarehusGrossWtKeyDown}
                                        onChange={JabDialogTypeWXhGrossWgtChangehandle} id='JobtypeHwxgrosswt'
                                        value={jobDialogValues.typeH_w_xGroos}
                                    />
                                    {/*  */}
                                    <label className='ml-2'>Unit</label>
                                    <input style={{ height: '22px', marginLeft: '3.8%', width: '8%' }}
                                        id='JobDialogUnit' onChange={JabDialogTypeWXhUnitCodeChangehandle} onKeyDown={JobTypeHWX_UnitCodeKeyUp} value={jobDialogValues.typeH_w_xUnitCode}
                                    />
                                    <button className='searchbutton' onClick={JobTypeHWX_UnitCode_Open}>
                                        <SearchIcon fontSize='small' />
                                    </button>
                                </div>
                                <div className='form-inline mt-3'>
                                    <label style={{ marginLeft: '3%' }}>Annexure.No</label>
                                    <input style={{ height: '22px', marginLeft: '0.6%' }} id='AnnexureNo'
                                        onChange={JabDialogTypeWXhAnnexureNoChangehandle} onKeyDown={JobTypeHWX_AnnexreNoKeyUp}
                                        value={jobDialogValues.typeH_w_xAnnexureNo}
                                    />
                                    {/*  */}
                                    <label className='ml-2'>Annexure Date</label>
                                    <input style={{ height: '22px', marginLeft: '0.4%', textTransform: 'uppercase', width: '12.8%' }}
                                        onChange={JabDialogTypeWXhAnnexureDateChangehandle} min={'1990-01-01'} max={'2100-12-31'} onKeyDown={JobTypeHWX_AnnexureDateKeyUp}
                                        id='JobDialogAnnexureDate' value={jobDialogValues.typeH_w_xAnnexureDate} type='date' />
                                    {/*  */}
                                    <label className='ml-2'>Date Of Final Warehousing(DFW)</label>
                                    <input style={{ height: '22px', marginLeft: '9.5%', textTransform: 'uppercase' }} onKeyDown={JobTypeHWX_DateOfFinalWareHouseKeyUp}
                                        onChange={JabDialogTypeWXhDFWChangehandle} id='JobDateOfFinalDFW'
                                        value={jobDialogValues.typeH_w_xDFW} type='date' min={'1990-01-01'} max={'2100-12-31'} />
                                </div>
                                <div className='form-inline mt-3'>
                                    <label style={{ marginLeft: '3%' }}>Loading For Exbond</label>
                                    <Form.Check inline label="Amount" value={'a'} onChange={JabDialogTypeWXhLE_RadioChangehandle} checked={JobTypeHWX_LE_Radio === 'a'}
                                        type='radio' style={{ marginLeft: '5%' }} />
                                    <Form.Check inline label="Rate" value={'r'} onChange={JabDialogTypeWXhLE_RadioChangehandle} checked={JobTypeHWX_LE_Radio === 'r'} type='radio' />
                                    <input style={{ height: '22px', marginLeft: '3%', width: '13%' }} onKeyDown={JobTypeHWX_WareHouseLoadingForExBondKeyUp}
                                        id='loadingForExBond' onChange={JabDialogTypeWXhLFE_Changehandle} value={jobDialogValues.typeH_w_xLFE}
                                    />
                                    {/*  */}
                                    <label className='ml-2'>Miscellaneous Load Rate</label>
                                    <Form.Check inline label="Amount" value={'a'} checked={JobTypeHWX_MLR_Radio === 'a'} onChange={JabDialogTypeWXhMLR_RadioChangehandle}
                                        type='radio' style={{ marginLeft: '1%' }} />
                                    <Form.Check inline label="Rate" value={'r'} checked={JobTypeHWX_MLR_Radio === 'r'} onChange={JabDialogTypeWXhMLR_RadioChangehandle}
                                        type='radio'/>
                                    <input style={{ height: '22px', marginLeft: '1%', width: '11%' }} id='JobDialogTypeMiscellaneousLoadRate'
                                        onKeyDown={JobTypeHWX_WareHouseMiscellaneousKeyUp} onChange={JabDialogTypeWXhMLRChangehandle} value={jobDialogValues.typeH_w_xMLR} />
                                </div>
                                <div className='form-inline mt-3'>
                                    <label style={{ marginLeft: '3%' }}>Exbond Consulate Description</label>
                                    <input style={{ height: '22px', marginLeft: '1%', width: '41%' }} onKeyDown={JobTypeHWX_WareHouseExbondConsulateKeyUp}
                                        id='JobDialogExbondConsulateDescription' onChange={JabDialogTypeWXhECDChangehandle} value={jobDialogValues.typeH_w_xECD} />
                                </div>
                                <div className=' mt-3'>
                                    <center>
                                        <Button size='small' variant="contained" color="primary" onClick={jobupdateWarehouse}>update</Button>{' '}
                                        <Button size='small' variant="contained" color="primary" onClick={jobWarehouseClear}>clear</Button>{' '}
                                    </center>
                                </div>
                            </Paper>
                        </Dialog>
                        {/*------------------- Hss(Y/N) -------------------*/}
                        <Dialog onClose={JobHssClose} open={JobHSSOpen} fullWidth={true} maxWidth="sm">
                            <DialogTitle className="dialogboxtitlecolour p-1">
                                <center>Add Hss Details</center> </DialogTitle>
                            {/*  */}
                            <Dialog onClose={JobHss_iecClose} open={JobHSS_IecOpen} fullWidth={true} maxWidth="md">
                                <DialogTitle className="dialogboxtitlecolour p-1">
                                    <center>Viwe Importer Details</center>
                                </DialogTitle>
                                <div className='dialogboxcolour'>
                                    <center>
                                        <FormLabel>Importer Name</FormLabel>
                                        <FormControl style={{ textTransform: "uppercase", width: '20%' }}
                                            onChange={JobDialogHss_ImpNameChangeHandel} size='sm' onKeyDown={JobDialogHssFindImportNameKeyDown}
                                            value={jobDialogValues.hss_iecName} />

                                    </center>
                                    <center>
                                        <FormLabel>Find Importer Code</FormLabel>
                                        <FormControl style={{ textTransform: "uppercase", width: '20%' }} autoFocus onKeyDown={JobDialogHssFindImportCodeKeyDown}
                                            id='JobDialogHssFindImporterCode' onChange={JobDialogHss_ImpCodeChangeHandel} size='sm' value={jobDialogValues.findhss_iecCode} />
                                    </center>
                                    <br></br>
                                </div>
                                <TableContainer className={classes.container}>
                                    <Table stickyHeader aria-label="table" size="small" >
                                        <TableHead >
                                            <StyledTableRow>
                                                <StyledTableCell align='center'>Importer IEC Code</StyledTableCell>
                                                <StyledTableCell align='center'>Importer Name</StyledTableCell>
                                            </StyledTableRow>
                                        </TableHead>
                                        <TableBody>
                                            {
                                                JobImporterDetails.map((Hss) => { const selectedItem = isMasterTransitSelected(Hss.importer_iec_no);
                                                    return(
                                                        <TableRow hover id='masterHssImportDetails_id' onKeyDown={masterHssImrtCodeKeyDown} onClick={() => EditHssImport(Hss)}
                                                            key={Hss.importer_iec_no} tabIndex={-1} selected={selectedItem}>
                                                            <TableCell align='center'>{Hss.importer_iec_no}</TableCell>
                                                            <TableCell align='center'>{Hss.importer_name}</TableCell>
                                                        </TableRow>
                                                    )})}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Dialog>
                            {/*  */}
                            <Dialog onClose={JobHss_brncSrClose} open={JobHSS_BrncSrOpen} fullWidth={true} maxWidth="md">
                                <DialogTitle className="dialogboxtitlecolour p-1">
                                    <center>Viwe Importer Branch Details</center>
                                </DialogTitle>
                                <div className='dialogboxcolour'>
                                    <center>
                                        <FormLabel>Find Importer State</FormLabel>
                                        <FormControl style={{ textTransform: "uppercase", width: '20%' }} onKeyDown={JobDialogHssFindImportStateKeyDown}
                                            onChange={JobDialogHss_impStateChangeHandel} size='sm' value={jobDialogValues.hss_brncSrName} />

                                    </center>
                                    <center>
                                        <FormLabel>Find Branch SrNo</FormLabel>
                                        <FormControl style={{ textTransform: "uppercase", width: '20%' }} id='JobDialogHssFindBranchSLno' onKeyDown={JobDialogHssFindBrnchSrlKeyDown}
                                            autoFocus onChange={JobDialogHss_BrnSrNoChangeHandel} size='sm' value={jobDialogValues.findhss_brnchSrNo} />
                                    </center>
                                    <br></br>
                                </div>
                                <TableContainer className={classes.container}>
                                    <Table stickyHeader aria-label="table" size="small" >
                                        <TableHead >
                                            <StyledTableRow>
                                                <StyledTableCell align='center'>SrNo</StyledTableCell>
                                                <StyledTableCell align='center'>State</StyledTableCell>
                                                <StyledTableCell align='center'>Address1</StyledTableCell>
                                                <StyledTableCell align='center'>Address2</StyledTableCell>
                                            </StyledTableRow>
                                        </TableHead>
                                        <TableBody>
                                            {
                                                BranchSrDetails.map((brncsr) => { const selectedItem = isMasterTransitSelected(brncsr.branch_sl_no);
                                                    return(
                                                        <TableRow hover onClick={() => jobEditHss_BrncSl(brncsr)} key={brncsr.branchSrNoState} id='masterHssBrnchSlno_id' 
                                                        onKeyDown={masterHssBrnchSlNoKeyDown}tabIndex={-1} selected={selectedItem}>
                                                            <TableCell align='center'>{brncsr.branch_sl_no}</TableCell>
                                                            <TableCell align='center'>{brncsr.importerState}</TableCell>
                                                            <TableCell align='center'>{brncsr.importerAddress}</TableCell>
                                                            <TableCell align='center'>{brncsr.importerAddress1}</TableCell>
                                                        </TableRow>
                                                    )})}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Dialog>
                            {/*  */}
                            <Paper className={classes.cardJob} style={{ backgroundColor: '#C8EDE7' }}>
                                <div className='form-inline'>
                                    <label className='summury ml-2'>IEC Code</label>
                                    <input className='hi22 wid12 ml-1' onChange={JobDialogHss_iecCodeHandle} onKeyDown={masterhssiecodeOnkeyDown}
                                        autoFocus value={jobDialogValues.hss_iecCode}
                                    />
                                    <button className='searchbutton' onClick={JobHss_iec_Open}>
                                        <SearchIcon fontSize='small' />
                                    </button>
                                    <label className='summury ml-2'>BranchSr.No</label>
                                    <input className='hi22 wid1 ml-1' onChange={JobDialogHss_brnchSrHandle} onKeyDown={masterhssBrnchSrOnkeyDown}
                                        id='JobDialogHssBranchSlNo' value={jobDialogValues.hss_brnchSrNo} />
                                    <button className='searchbutton' onClick={JobHssbrncSrOpen}>
                                        <SearchIcon fontSize='small' />
                                    </button>
                                    <label className='summury ml-2'>Preceding Level(0/1)</label>
                                    <input className='hi22 wid1 ml-1' onChange={JobDialogHss_PrecedingLvlHandle} onKeyDown={masterhssPrecedingLvl01keyDown}
                                        id='JobDialogHssPrecedingLevel01' value={jobDialogValues.hss_precedingLevel} required
                                    />
                                </div>

                                <div className='form-inline mt-2'>
                                    <label className='ml-2'>Name</label>
                                    <input className='hi22 widh22 ml-4' disabled value={jobDialogValues.hss_name} />
                                </div>

                                <div className='form-inline mt-2'>
                                    <label className='ml-2'>Address1</label>
                                    <input className='hi23 ml-1' style={{ width: "33.5%" }} value={jobDialogValues.hss_address1} disabled />
                                    <label className='ml-2'>Address2</label>
                                    <input className='hi23  ml-3' style={{ width: "33.5%" }} value={jobDialogValues.hss_address2} disabled />
                                </div>

                                <div className='form-inline mt-2 mb-2'>
                                    <label className='ml-2 mr-3'>City</label>
                                    <input className='hi22 wid13 ml-4' value={jobDialogValues.hss_city} disabled />
                                    <label className='ml-2'>State</label>
                                    <input className='hi22 wid13 ml-1' value={jobDialogValues.hss_state} disabled />
                                    <label className='ml-2'>PinCode</label>
                                    <input className='hi22 wid13 ml-1' disabled value={jobDialogValues.hss_pincode} />
                                </div>
                                <div className='mb-1'>
                                    <center>
                                        <Button size='small' variant="contained" color="primary" onClick={jobHss_Save} disabled={JobHssSaveDsab}>{JobHssSve ? "Processing.." : "Save"}</Button>{' '}
                                        <Button size='small' variant="contained" color="primary" disabled={JobHssUpdateDsab} onClick={jobHssUpdate}>{JobHssUpd ? "Processing.." : "Update"}</Button>{' '}
                                        <Button size='small' variant="contained" color="primary" disabled={JobHssDeleteDsab} onClick={jobHssDelete}>{JobHssDlt ? "Processing.." : "Delete"}</Button>{' '}
                                        <Button size='small' variant="contained" color="primary" onKeyDown={masterhssDetailsRefBtnkeyDown} onClick={jobHssRefresh}>Refresh</Button>{' '}
                                    </center>
                                </div>
                            </Paper>
                            <TableContainer className={classes.container}>
                                <Table stickyHeader className='table-bordered' size="small" >
                                    <TableHead >
                                        <StyledTableRow>
                                            <StyledTableCell className='p-1' style={{ width: '5%' }}>Sl</StyledTableCell>
                                            <StyledTableCell className='p-1' style={{ width: '15%' }}>Job.No</StyledTableCell>
                                            <StyledTableCell className='p-1' style={{ width: '15%' }}>IEC Code</StyledTableCell>
                                            <StyledTableCell className='p-1' align='center'>Name</StyledTableCell>
                                            <StyledTableCell className='p-1' style={{ width: '20%' }}>Preceding Level</StyledTableCell>
                                        </StyledTableRow>
                                    </TableHead>
                                    <TableBody>
                                        {
                                            jobHssDetails.map((hss) => { const selectedItem = isMasterTransitSelected(hss.iecCodeHss);
                                                return(
                                                    <TableRow hover onClick={() => JobEditHssDetail(hss)} key={hss.serialNumber} id='masterHssDetails_id' 
                                                    onKeyDown={masterHssDetailsKeyDown}tabIndex={-1} selected={selectedItem}>
                                                        <TableCell className='p-1' style={{ width: '5%' }}>{hss.serialNumber}</TableCell>
                                                        <TableCell className='p-1' style={{ width: '15%' }}>{hss.consignmentId}</TableCell>
                                                        <TableCell className='p-1' style={{ width: '15%' }}>{hss.iecCodeHss}</TableCell>
                                                        <TableCell className='p-1'>{hss.importer_name}</TableCell>
                                                        <TableCell className='p-1' style={{ width: '20%' }}>{hss.precedingLevel}</TableCell>
                                                    </TableRow>
                                                )})}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Dialog>
                        {/*------------------- sec-48(y/n)--------------------------------*/}
                        <Dialog onClose={JobSec_48Closehandle} open={JobSec_48Open} fullWidth={true} maxWidth="sm">
                            <DialogTitle className="dialogboxtitlecolour p-1">
                                <center>Add Sec-48 Details</center>
                            </DialogTitle>
                            <div className='dialogboxcolour'>
                                <div className='mt-2'>
                                    <center>
                                        <label>Permission Code</label>
                                        <input disabled value={jobDialogValues.sec_PermissionCode} style={{ fontWeight: 'bold' }} />
                                    </center>
                                </div>
                                <div className='form-inline mt-1'>
                                    <label className='summury ml-2 mr-2'>Permission Description</label>
                                    <Form.Control as="textarea" rows={3} style={{ width: '65%' }} autoFocus
                                        value={jobDialogValues.sec_PermissionDesc} onChange={jobDialogePermissionDescChngHndl} />
                                </div>
                                <div className='mt-1 mb-1'>
                                    <center>
                                        <Button size='small' variant="contained" color="primary" onClick={() => jobSec48Save('S48')} disabled={JobSec_48SaveDsab}>{JobSec_48Sve ? "Processing.." : "Save"}</Button>{' '}
                                        <Button size='small' variant="contained" color="primary" onClick={() => jobSec48Update('S48')} disabled={JobSec_48Updatedsab}>{JobSec_48Upd ? "Processing.." : "Update"}</Button>{' '}
                                        <Button size='small' variant="contained" color="primary" onClick={() => jobSec48Delete('S48')} disabled={JobSec_48DeleteDsab}>{JobSec_48Dlt ? "Processing.." : "Delete"}</Button>{' '}
                                        <Button size='small' variant="contained" color="primary" onKeyDown={masterSec48DetailsRefBtnkeyDown} onClick={() => jobSec48Refresh('S48')}>Refresh</Button>{' '}
                                    </center>
                                </div>
                            </div>
                            <TableContainer className={classes.container}>
                                <Table stickyHeader className='table-bordered' size="small" >
                                    <TableHead >
                                        <StyledTableRow>
                                            <StyledTableCell className='p-1' style={{ width: '5%' }}>Sl.No</StyledTableCell>
                                            <StyledTableCell className='p-1' style={{ width: '15%' }}>Job.No</StyledTableCell>
                                            <StyledTableCell className='p-1' style={{ width: '20%' }}>Permission Code</StyledTableCell>
                                            <StyledTableCell className='p-1' align='center'>Permission Desc</StyledTableCell>
                                        </StyledTableRow>
                                    </TableHead>
                                    <TableBody>
                                        {
                                            jobSecDetails.map((hss) => { const selectedItem = isMasterTransitSelected(hss.permissionCode);
                                                return(
                                                    <TableRow hover onClick={() => JobEditSec48Detail(hss)} key={hss.consignmentId} id='masterSec48Details_id' 
                                                    onKeyDown={masterSec48DetailsKeyDown}tabIndex={-1} selected={selectedItem}>
                                                        <TableCell className='p-1' style={{ width: '5%' }}>{hss.serialNumber}</TableCell>
                                                        <TableCell className='p-1' style={{ width: '15%' }}>{hss.consignmentId}</TableCell>
                                                        <TableCell className='p-1' style={{ width: '20%' }}>{hss.permissionCode}</TableCell>
                                                        <TableCell className='p-1'>{hss.permissionReq}</TableCell>
                                                    </TableRow>
                                                )})}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Dialog>
                        {/*------------------- 1stCheack(y/n)--------------------------------*/}
                        <Dialog onClose={Job1stCheackClosehandle} open={Job1stCheackOpen} fullWidth={true} maxWidth="sm">
                            <DialogTitle className="dialogboxtitlecolour p-1">
                                <center>Add 1st Check Details</center>
                            </DialogTitle>
                            <div className='dialogboxcolour'>
                                <div className='mt-2'>
                                    <center>
                                        <label>Permission Code</label>
                                        <input disabled value={jobDialogValues.sec_PermissionCode} style={{ fontWeight: 'bold', marginLeft: '1%' }} />
                                    </center>
                                </div>
                                <div className='form-inline mt-1'>
                                    <label className='summury ml-2 mr-2'>Permission Description</label>
                                    <Form.Control as="textarea" rows={3} style={{ width: '65%' }} autoFocus
                                        value={jobDialogValues.sec_PermissionDesc} onChange={jobDialogePermissionDescChngHndl}
                                    />
                                </div>
                                <div className='mt-1 mb-1'>
                                    <center>
                                        <Button size='small' variant="contained" color="primary" onClick={() => jobSec48Save('FCK')} disabled={JobSec_48SaveDsab}>{JobSec_48Sve ? "Processing.." : "Save"}</Button>{' '}
                                        <Button size='small' variant="contained" color="primary" onClick={() => jobSec48Update('FCK')} disabled={JobSec_48Updatedsab}>{JobSec_48Upd ? "Processing.." : "Update"}</Button>{' '}
                                        <Button size='small' variant="contained" color="primary" onClick={() => jobSec48Delete('FCK')} disabled={JobSec_48DeleteDsab}>{JobSec_48Dlt ? "Processing.." : "Delete"}</Button>{' '}
                                        <Button size='small' variant="contained" color="primary" onKeyDown={master1stCheckRefBtnkeyDown} onClick={() => jobSec48Refresh('FCK')}>Refresh</Button>{' '}
                                    </center>
                                </div>
                            </div>
                            <TableContainer className={classes.container}>
                                <Table stickyHeader className='table-bordered' size="small" >
                                    <TableHead >
                                        <StyledTableRow>
                                            <StyledTableCell className='p-1' style={{ width: '5%' }}>Sl.No</StyledTableCell>
                                            <StyledTableCell className='p-1' style={{ width: '15%' }}>Job.No</StyledTableCell>
                                            <StyledTableCell className='p-1' style={{ width: '20%' }}>Permission Code</StyledTableCell>
                                            <StyledTableCell className='p-1' align='center'>Permission Desc</StyledTableCell>
                                        </StyledTableRow>
                                    </TableHead>
                                    <TableBody>
                                        {
                                            jobSecDetails.map((hss) => { const selectedItem = isMasterTransitSelected(hss.permissionCode);
                                                return(
                                                    <TableRow hover onClick={() => JobEdit1stCheckDetail(hss)} key={hss.consignmentId} id='master1stCheck_id' 
                                                    onKeyDown={master1stCheckKeyDown}tabIndex={-1} selected={selectedItem}>
                                                        <TableCell className='p-1' style={{ width: '5%' }}>{hss.serialNumber}</TableCell>
                                                        <TableCell className='p-1' style={{ width: '15%' }}>{hss.consignmentId}</TableCell>
                                                        <TableCell className='p-1' style={{ width: '20%' }}>{hss.permissionCode}</TableCell>
                                                        <TableCell className='p-1'>{hss.permissionReq}</TableCell>
                                                    </TableRow>
                                                )})}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Dialog>
                        {/*------------------- comarcialtax-----------------------*/}
                        <Dialog onClose={JobCommercialtxClosehandle} open={JobComrcilTaxOpen} fullWidth={true} maxWidth="md">
                            <DialogTitle className="dialogboxtitlecolour p-1">
                                <center>Add Commercial Tax Details</center>
                            </DialogTitle>
                            <div className='dialogboxcolour'>
                                <div className='form-inline ml-4 mt-2'>
                                    <label className='ml-4'>State Code</label>
                                    <select className='ml-1 hi22 wid13 txcnt' onChange={JobCtxStateCodeChangeHandle}
                                        value={jobDialogValues.comrcial_StateCode} autoFocus onKeyDown={JobDialogCmrcialTaxStateCodekeyDown}>
                                        <option>{''}</option>
                                        <option value={jobDialogValues.comrcial_StateCode}>{jobDialogValues.comrcial_StateCode}</option>
                                        <option value={jobDialogValues.comrcial_ctx_regNo}>{jobDialogValues.comrcial_ctx_regNo}</option>
                                    </select>
                                    <label>CTX Type</label>
                                    <select className='ml-1 hi22 wid12 txcnt' onChange={JobCtxTypeChangeHandle} onKeyDown={JobDialogCmrcialTaxCtxTypekeyDown}
                                        id='JobDialogComercialCTXtax' value={jobDialogValues.comrcial_CtxCode}>
                                        <option value={''}></option>
                                        {jobGstinDrp.map((type) => (
                                            <option value={type.gstinTypeCode}>{type.gstinTypeCode}</option>
                                        ))}
                                    </select>
                                    <label>CTX RegistrationNo</label>
                                    <input className='ml-1 hi22 wid13' onChange={JobCtxRegNoChangeHandle} onKeyDown={JobDialogCmrcialTaxCtxRegistrationKeyDown}
                                        id='JobDialogCtxRegistrationNo' value={jobDialogValues.comrcial_ctx_regNo} />
                                </div>
                                <div className='mt-1 mb-1'>
                                    <center>
                                        <Button size='small' variant="contained" color="primary" onClick={commercialTaxSave} disabled={JobComTxSaveDsab}>
                                            {JobComTxSve ? "Processing.." : "Save"}</Button>{' '}
                                        <Button size='small' variant="contained" color="primary" onClick={commercialTaxUpdate} disabled={JobComTxUpdateDsab}>
                                            {JobComTxUpd ? "Processing.." : "Update"}</Button>{' '}
                                        <Button size='small' variant="contained" color="primary" onClick={commercialTaxDelete} disabled={JobComTxDeleteDsab}>
                                            {JobComTxDlt ? "Processing.." : "Delete"}</Button>{' '}
                                        <Button size='small' variant="contained" color="primary" onKeyDown={JobDialogCmrcialTaxRefBtnKeyDown} onClick={ComrcialRefresh} >Refresh</Button>{' '}
                                    </center>
                                </div>
                            </div>
                            <TableContainer className={classes.container}>
                                <Table stickyHeader className='table-bordered' size="small" >
                                    <TableHead >
                                        <StyledTableRow>
                                            <StyledTableCell className='p-1'>Sl.No</StyledTableCell>
                                            <StyledTableCell className='p-1'>Job.No</StyledTableCell>
                                            <StyledTableCell className='p-1'>State Code</StyledTableCell>
                                            <StyledTableCell className='p-1'>CTX Type</StyledTableCell>
                                            <StyledTableCell className='p-1'>CTX RegNo</StyledTableCell>
                                        </StyledTableRow>
                                    </TableHead>
                                    <TableBody>
                                        {
                                            jobCmrcialDetails.map((cmt) => { const selectedItem = isMasterTransitSelected(cmt.taxStateCode);
                                                return(
                                                    <TableRow hover onClick={() => JobEditCmrcialTxDetail(cmt)} key={cmt.consignmentId} id='masterCmrcl_id' 
                                                    onKeyDown={masterCmrclKeyDown}tabIndex={-1} selected={selectedItem}>
                                                        <TableCell className='p-1'>{cmt.serialNumber}</TableCell>
                                                        <TableCell className='p-1'>{cmt.consignmentId}</TableCell>
                                                        <TableCell className='p-1'>{cmt.taxStateCode}</TableCell>
                                                        <TableCell className='p-1'>{cmt.gstinTypeCode}</TableCell>
                                                        <TableCell className='p-1'>{cmt.gstinNo}</TableCell>
                                                    </TableRow>
                                                )})}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Dialog>
                        {/*---------------------UnitCode------------------------------------*/}
                        <Dialog onClose={JobUnitCodeClosehandle} open={JobUnitCodeOpen} fullWidth={true} maxWidth="md">
                            <DialogTitle className="dialogboxtitlecolour p-1">
                                <center>VIEW UNIT CODE DETAILS</center></DialogTitle>
                            <div className='dialogboxcolour'>
                                <Col><center>
                                    <Form.Label>Find Unit Name</Form.Label>
                                    <FormControl style={{ textTransform: "uppercase", width: '20%' }}  onKeyDown={JobDialogIGMUnitNameKeyDown}
                                        onChange={JobDialogwareUnitNameChangeHandel} size='sm' value={jobDialogValues.typeH_w_xUnitName} />
                                </center></Col>
                                <Col><center>
                                    <Form.Label>Find Unit Code</Form.Label>
                                    <FormControl style={{ textTransform: "uppercase", width: '20%' }} onKeyDown={JobDialogIGMUnitCodeKeyDown} id='igm_FindUniteCode_id'
                                    onChange={JobDialogwereUnitCodeChangeHandel} size='sm' autoFocus value={jobDialogValues.findtypeH_w_xUnitCode} />
                                </center></Col>
                                <br></br>
                            </div>
                            <TableContainer className={classes.container}>
                                <Table stickyHeader aria-label="table" size="small" >
                                    <TableHead >
                                        <StyledTableRow>
                                            <StyledTableCell align='center'>Unit Code</StyledTableCell>
                                            <StyledTableCell align='center'>Unit Rate</StyledTableCell>
                                        </StyledTableRow>
                                    </TableHead>
                                    <TableBody>
                                        {CustomHouseDetails.map((cus) => { const selectedItem = isMasterTransitSelected(cus.unitCode);
                                                return(
                                                    <TableRow hover onClick={() => JobEditIgmUnitCode(cus)} key={cus.customHouseCode} id='masterUnitCodeDetails_id' 
                                                    onKeyDown={masterUniteCodeDetailsKeyDown}tabIndex={-1} selected={selectedItem}>
                                                        <TableCell align='center'>{cus.unitCode}</TableCell>
                                                        <TableCell align='center'>{cus.unitName}</TableCell>
                                                    </TableRow>
                                                )})}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Dialog>
                        {/* --------------------PkgCode-------------------------------------*/}
                        <Dialog onClose={JobPkgCodeClosehandle} open={JobPkgCodeOpen} fullWidth={true} maxWidth="md">
                            <DialogTitle className="dialogboxtitlecolour p-1">
                                <center>VIEW PKG CODE DETAILS</center></DialogTitle>
                            <div className='dialogboxcolour'>
                                <Col><center>
                                    <Form.Label>Find Unit Name</Form.Label>
                                    <FormControl style={{ textTransform: "uppercase", width: '20%' }} onChange={JobDialogwareUnitNameChangeHandel} size='sm'
                                     onKeyDown={JobDialogIGMPKGNameKeyDown} value={jobDialogValues.typeH_w_xUnitName} />
                                </center></Col>
                                <Col><center>
                                    <Form.Label>Find Unit Code</Form.Label>
                                    <FormControl style={{ textTransform: "uppercase", width: '20%' }} onKeyDown={JobDialogIGMPKGCodeKeyDown}
                                    id='igmFindPkgCode_id' onChange={JobDialogwereUnitCodeChangeHandel} size='sm' autoFocus value={jobDialogValues.findtypeH_w_xUnitCode} />
                                </center></Col>
                                <br></br>
                            </div>
                            <TableContainer className={classes.container}>
                                <Table stickyHeader aria-label="table" size="small" >
                                    <TableHead >
                                        <StyledTableRow>
                                            <StyledTableCell align='center'>Package Code</StyledTableCell>
                                            <StyledTableCell align='center'>Package Rate</StyledTableCell>
                                        </StyledTableRow>
                                    </TableHead>
                                    <TableBody>
                                        {
                                            CustomHouseDetails.map((cus) => { const selectedItem = isMasterTransitSelected(cus.unitCode);
                                                return(
                                                    <TableRow hover onClick={() => JobEditIgmPkgCode(cus)} key={cus.unitCode} id='masterIGMPKGCodeDetails_id' 
                                                    onKeyDown={masterIGMPKGCodeDetailsKeyDown}tabIndex={-1} selected={selectedItem}>
                                                        <TableCell align='center'>{cus.unitCode}</TableCell>
                                                        <TableCell align='center'>{cus.unitName}</TableCell>
                                                    </TableRow>
                                                )})}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Dialog>
                        {/*---------------------repport--------------------------------------*/}
                        <Dialog onClose={JobRepPortClosehandle} open={JobRepPortOpen} fullWidth={true} maxWidth="md">
                            <DialogTitle className="dialogboxtitlecolour p-1">
                                <center>
                                    VIEW GATEWAY PORT DETAILS
                                </center>
                            </DialogTitle>
                            <div className='dialogboxcolour'>
                                <div className='form-inline mt-2'>
                                    <label style={{ marginLeft: '30%' }}>Find Gateway PortName</label>
                                    <input value={jobDialogValues.f_report_name} onChange={jobFindReportNameChngHandle}  onKeyDown={JobDialogIGMGateWayPortNameKeyDown}/>
                                </div>
                                <div className='form-inline mt-2'>
                                    <label style={{ marginLeft: '30%' }}>Find Gateway PortCode</label>
                                    <input className='ml-1' value={jobDialogValues.f_report_code} onChange={jobFindReportCodeChngHandle} autoFocus 
                                    id='igmFind_gatwayPortCode_id' onKeyDown={JobDialogIGMGateWayPortKeyDown}/>
                                </div>
                                <br></br>
                            </div>
                            <TableContainer className={classes.container}>
                                <Table stickyHeader aria-label="table" size="small" >
                                    <TableHead >
                                        <StyledTableRow>
                                            <StyledTableCell align='center'>GateWay Report Code</StyledTableCell>
                                            <StyledTableCell align='center'>GateWay Report Name</StyledTableCell>
                                        </StyledTableRow>
                                    </TableHead>
                                    <TableBody>
                                        {
                                            CustomHouseDetails.map((cus) => { const selectedItem = isMasterTransitSelected(cus.customHouseCode);
                                                return(
                                                    <TableRow hover onClick={() => JobEditReport(cus)} key={cus.customHouseCode} id='masterIGMGatewayReport_id' 
                                                    onKeyDown={masterIGMGateWayPortKeyDown}tabIndex={-1} selected={selectedItem}>
                                                        <TableCell align='center'>{cus.customHouseCode}</TableCell>
                                                        <TableCell align='center'>{cus.customHouseLocation}</TableCell>
                                                    </TableRow>
                                                )})}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Dialog>
                        {/*---------------------AlertJobNo------------------------------------*/}
                        <Dialog onClose={JobEdiJobAlertClosehandle} open={OpenJobAlert} fullWidth={true} maxWidth="md">
                            {/* <DialogTitle className='bg-light'></DialogTitle> */}
                            <div style={{ backgroundColor: '#C8EDE7' }}>
                                <div className='form-inline mt-3'>
                                    <input style={{ width: '5%', marginLeft: "80%" }} />
                                </div>
                                <div className='form-inline mt-2 mb-4'>
                                    <h3 style={{ marginLeft: '40%', fontWeight: 'bold' }}> Your JOB.NO:</h3>
                                    <h3 style={{ color: 'red', fontWeight: 'bold' }}>{jobValues.job_no}</h3>
                                </div>
                            </div>
                        </Dialog>
                        {/*---------------------BOE Updation----------------------------------*/}
                        <Dialog onClose={JobBOEupdationClosehandle} open={OpenJobBOEupdation} fullWidth={true} maxWidth="sm">
                            <DialogTitle className="dialogboxtitlecolour p-1">
                                <center style={{ color: 'white' }}>BOE Updation</center>
                            </DialogTitle>
                            <div className='dialogboxcolour'>
                                <div className='form-inline mt-3 ml-4'>
                                    <label style={{ marginLeft: '30%' }}>BE No</label>
                                    <input className='ml-4 hi22' value={jobValues.be_no} type='number'
                                        onChange={jobBOEBeNoChngHandle} autoFocus />
                                </div>
                                <div className='form-inline mt-3 ml-4'>
                                    <label style={{ marginLeft: '30%' }}>BE Date</label>
                                    <input className='ml-3' type='date' value={jobValues.be_date} style={{ textTransform: 'uppercase' }}
                                        onChange={jobBOEBeDateChngHandle} min={'1990-01-01'} max={'2100-12-31'} />
                                </div>
                                <div className='form-inline mt-3 ml-4'>
                                    <label style={{ marginLeft: '30%' }}>Response</label>
                                    <select style={{ width: '30%' }} value={jobValues.be_response} onChange={jobBOEBeResponseChngHandle}>
                                        <option value={''}></option>
                                        {BeUpdationRespncDD.map((trns) => (
                                            <option value={trns.beResponse}>{trns.beResponse}</option>
                                        ))}
                                    </select>
                                </div>
                                <div className='form-inline mt-3 ml-4'>
                                    <label style={{ marginLeft: '30%' }}>Reason</label>
                                    <textarea className='ml-3' style={{ width: '30%' }} value={jobValues.be_reason}
                                        onChange={jobBOEBeReasonChngHandle}>
                                    </textarea>
                                </div>
                                <div className='mt-2 mb-1'><center>
                                    <Button size='small' variant="contained" color="primary" onClick={jobBeUpdationSave}>Save</Button>{' '}
                                    <Button size='small' variant="contained" color="primary" onClick={JobBOEupdationClosehandle}>close</Button>{' '}
                                </center></div>
                            </div>
                        </Dialog>
                        {/* print */}
                        <Dialog onClose={jobPrintCloshHandle} open={OpenJobPrint} fullWidth={true} maxWidth="sm">
                            <DialogTitle className="dialogboxtitlecolour p-1">
                                <center>VIWE PRINT DETAILS</center>
                            </DialogTitle>
                            <div className='dialogboxcolour'>
                                <div className='mt-3'>
                                    <center>
                                        <Button size='small' variant="contained" color="primary" disabled={ItemBEfileItemDsa} onClick={JobBePrint}>
                                            {ItemBEprnt ? 'Printing..' : 'BE Print'}</Button>{' '}
                                    </center>
                                </div>
                                <div className='mt-3 mb-3'>
                                    <center>
                                        <Button size='small' variant="contained" color="primary" disabled={ItemCheackListItemDsa} onClick={JobCheacklistPrint}>
                                            {ItemCheacklistprnt ? 'Printing..' : 'CheackList Print'}</Button>{' '}
                                    </center>
                                </div>
                            </div>
                        </Dialog>
                    </div>
                    {/* Vlues card maind */}
                    <Grid container className='bg-light'>
                        {/* 1 */}
                        <Grid item xs={12} >
                            <Paper className={classes.cardJob} style={{ backgroundColor: '#C8EDE7', fontWeight: 'bold' }}>
                                {/* <div className='form-inline title'> <div style={{ marginLeft: '43%', fontWeight: 'bold' }}><h3>IMPORT-JOB</h3></div> */}
                                <div className='form-inline title'><div className="title" style={{ marginLeft: '43%', fontSize: '150%' }}>IMPORT-JOB</div>
                                    <Form.Label style={{ color: 'blue', marginLeft: '5%' }}>CHA Code</Form.Label>
                                    <input value={jobValues.chaCode} onChange={jobChaCodehangeHandle} style={{ height: '19px' }} maxLength="50" />
                                    <Form.Label className='ml-4' style={{ color: 'blue', textAlign: 'center', fontweight: 'bold' }}>Job.No</Form.Label>
                                    <input value={jobValues.job_no} disabled
                                        style={{ width: '10%', textAlign: 'center', fontweight: 'bold', color: 'red' }} />
                                </div>
                                <div className='form-inline mt-1'>
                                    <FormLabel style={{ color: "red" }}>Mode(A/L/S)</FormLabel>
                                    <input className='ml-1 ' style={{ textTransform: "uppercase", width: '5%', height: '22px' }}
                                        maxLength="1" onChange={jobModeChangeHandle} onKeyDown={jobModeKeyUpHandle} id='MastertransiteType'
                                        value={jobValues.mode_A_L_S} onBlur={focusoutAirMode} />
                                    <button onClick={JobModeSearchHandleOpen} className='searchbutton'>
                                        <SearchIcon fontSize="small" /></button>
                                    {/*  */}
                                    <input className='ml-1' style={{ textTransform: "uppercase", height: '22px' }}
                                        disabled onChange={jobModelNameChangeHandle}
                                        value={jobValues.model_A_L_S_Name} />
                                    {/*  */}
                                    <FormLabel style={{ color: "red" }}>CusHouseCode</FormLabel>
                                    <input className='ml-1' style={{ textTransform: "uppercase", width: '7%', height: '22px' }}
                                        maxLength="6" onChange={jobChsCodeChangeHandle} onKeyDown={jobChsCodeKeyUpHandle}
                                        value={jobValues.customHousCode} id='chsCode' />
                                    <button onClick={JobChsCodeHandleOpen} className='searchbutton'>
                                        <SearchIcon fontSize="small" /></button>
                                    {/*  */}
                                    <input style={{ textTransform: "uppercase", height: '22px' }}
                                        disabled onChange={jobChsNameCodeChangeHandle} className='ml-1 mr-1'
                                        value={jobValues.chs_name} />
                                    {/*  */}
                                    <FormLabel style={{ color: "red" }}>Branch</FormLabel>
                                    <input className='ml-1' style={{ textTransform: "uppercase", width: '10%', height: '22px' }}
                                        maxLength="6" placeholder="Branch" onChange={jobBranchChangeHandle} onKeyDown={jobBranchKeyUpHandle}
                                        value={jobValues.branch} id='Branch' />
                                    <button onClick={JobBranchHandleOpen} className='searchbutton mr-1'>
                                        <SearchIcon fontSize="small" /></button>
                                    {/*  */}
                                    <Form.Text style={{ fontWeight: 'bold' }}>Forwarder</Form.Text>
                                    <input className='ml-1' style={{ textTransform: "uppercase", width: '10%', height: '22px' }}
                                        maxLength="6" placeholder="Forwarder" onChange={jobForwarderChangeHandle} onKeyDown={jobForwdrKeyUpHandle}
                                        value={jobValues.forwarder} id='frwdr' />
                                    <button onClick={JobFrwdrHandleOpen} className='searchbutton'>
                                        <SearchIcon fontSize="small" /></button>
                                </div>
                            </Paper>
                        </Grid>
                        {/* 2 */}
                        <Grid item xs={10} style={{ marginTop: '0.1%' }}>
                            <Paper className={classes.paper} style={{ backgroundColor: '#C8EDE7' }}>
                                IMPORTER DETAILS
                                <div className='form-inline' style={{ fontWeight: 'bold' }}>
                                    <Form.Check style={{ color: "red" }} inline label="Govt.IEC" value={'Govt_IEC'} onChange={JobRadioChangeHandle}
                                        checked={JobradioValues === 'Govt_IEC'} type='radio' />
                                    <Form.Check style={{ color: "red" }} inline label="IEC Code" value={'IEC_code'} onChange={JobRadioChangeHandle}
                                        checked={JobradioValues === 'IEC_code'} type='radio' />
                                    <input style={{ textTransform: "uppercase", width: '7%', height: '22px' }} maxLength="10" onChange={JobIecSearchChangeHandle} onKeyDown={jobIecSearchKeyUpHandle}
                                        value={jobValues.iec_search} id='gvt_iec' />
                                    <button onClick={JobIecHandleOpen} className='searchbutton'><SearchIcon fontSize="small" /></button>
                                    {/* </> */}
                                    <FormLabel className='ml-1' style={{ color: "red" }}>Name</FormLabel>
                                    <input disabled className='ml-1' style={{ textTransform: "uppercase", width: '20%', height: '22px' }} value={jobValues.name} />
                                    {/* </> */}
                                    <FormLabel className='ml-1' style={{ color: "red" }}>Branch Sr.No</FormLabel>
                                    <input className='ml-1' onKeyDown={jobBranchSrNoKeyUpHandle} maxLength="5" onChange={JobBr_SrChangeHandle} style={{ textTransform: "uppercase", width: '4%', height: '22px' }}
                                        value={jobValues.branch_sr_no} id='brnc_no' />
                                    <button onClick={JobBrancSrHandleOpen} className='searchbutton'> <SearchIcon fontSize="small" /></button>
                                    {/* </> */}
                                    <FormLabel className='ml-1 mr-1' style={{ color: "red" }}>Address1</FormLabel>
                                    <input type='address' disabled style={{ textTransform: "uppercase", width: '20%', height: '22px' }} value={jobValues.address_1} />
                                </div>
                                <div className='form-inline  mt-1' style={{ fontWeight: 'bold' }}>
                                    {/* </> */}
                                    <FormLabel className='mr-1' style={{ color: "red" }}>Address2</FormLabel> <input className='ml-1' as='textarea' disabled style={{ textTransform: "uppercase", width: '20%', height: '22px' }} value={jobValues.addresh_2} />
                                    {/* </> */}
                                    <FormLabel className='ml-1' style={{ color: "red" }}>City</FormLabel> <input disabled className='ml-1 mr-1' style={{ textTransform: "uppercase", height: '22px', width: '10%' }} value={jobValues.city} />
                                    {/* </> */}
                                    <FormLabel style={{ color: "red" }}>State</FormLabel> <input disabled className='ml-1 mr-1' style={{ textTransform: "uppercase", height: '22px', width: '15%' }} value={jobValues.state} />
                                    {/* </> */}
                                    <FormLabel style={{ color: "red" }}>PinCode</FormLabel> <input disabled className='ml-1' style={{ width: '10%', height: '22px' }} value={jobValues.pincode} />
                                    {/* </> */}
                                    <FormLabel className='ml-1' style={{ color: "red" }}>AD Code</FormLabel>
                                    <input className='ml-1' style={{ height: '22px', width: '10%' }} maxLength="10" onChange={JobADcodChangeHandle} id='ad_code' onKeyDown={jobAdCodeKeyUP} value={jobValues.ad_code} />
                                    <button onClick={JobAdCodeHandleOpen} onKeyDown={jobAdButtonKeyUP} className='searchbutton'> <SearchIcon fontSize="small" /> </button>
                                </div>
                            </Paper>
                        </Grid>
                        {/* job main */}
                        <Grid item xs={2} style={{ marginTop: '0.1%' }}>
                            <Paper className={classes.cardJob} style={{ backgroundColor: '#C8EDE7', height: '100%' }}>
                                <center>
                                    <div className='form-inline'>
                                        <FormLabel className='mr-1' style={{ color: "red", fontWeight: 'bold' }}>JOB.NO</FormLabel>
                                        <input style={{ border: "4px solid yellow", width: '60%', textAlign: 'center', height: '42px', fontSize: '170%', fontweight: 'bold', color: 'red' }} disabled
                                            maxLength="10" placeholder="JOB.No" onChange={jobJob_NoChangeHandle} value={jobValues.job_no} />
                                    </div>
                                </center>
                                <center>
                                    <div className='form-inline mt-1' style={{ fontWeight: 'bold' }}>
                                        <FormLabel style={{ color: 'darkblue' }}>EDI JOB.NO</FormLabel>
                                        <input className='ml-1' onChange={jobEdiJob_NoChangeHandle} style={{ width: '30%', border: '2px solid blue', textAlign: 'center' }}
                                            maxLength="10" value={jobValues.edi_job_no} id='Jobedi_job' onKeyDown={jobEdiJobKeyUP} />
                                    </div>
                                </center>
                                {/* </> */}
                            </Paper>
                        </Grid>
                        {/* 3 */}
                        <Grid item xs={12} style={{ marginTop: '0.1%' }}>
                            <Paper className={classes.paper} style={{ backgroundColor: '#C8EDE7' }}>
                                Origin Details
                                <div className='form-inline' style={{ fontWeight: 'bold' }}>

                                    <FormLabel style={{ color: "red" }}>Country Of Origin</FormLabel>
                                    <input className='ml-1' style={{ textTransform: "uppercase", width: "3%", height: '22px' }} maxLength={3}
                                        onChange={JobcountryOriginChangeHandle} id='jonCntryOrgin' onBlur={cntryOfOrginOnBlur} value={jobValues.countryOrigin} onKeyDown={JobcntryorgnKeyUp} />
                                    <button onClick={JobCountryOriginHandleOpen} className='searchbutton'>
                                        <SearchIcon fontSize="small" /></button>
                                    <input className='ml-1 ' style={{ textTransform: "uppercase", height: '22px', width: '8%' }} disabled value={jobValues.countryOriginName} />

                                    <FormLabel className='ml-1' style={{ color: "red" }}>Country Of cm</FormLabel>
                                    <input className='ml-1 ' style={{ textTransform: "uppercase", width: "3%", height: '22px' }} onChange={JobcountryCmChangeHandle} maxLength={3} id='jobCntryOfCm'
                                        value={jobValues.countrt_of_cm} onKeyDown={jobCntryCmkeyUp} />
                                    <button onClick={JobCountryCMHandleOpen} className='searchbutton'>
                                        <SearchIcon fontSize="small" /></button>
                                    <input className='ml-1 ' disabled style={{ textTransform: "uppercase", height: '22px', width: '8%' }} value={jobValues.countrt_of_cmName} />

                                    <FormLabel className='ml-1' style={{ color: "red" }}>Port Of Loading</FormLabel>
                                    <input className='ml-1' style={{ textTransform: "uppercase", width: "3%", height: '22px' }} maxLength={6} id='portLoding'
                                        onChange={JobPortOfLoadingChangeHandle} onKeyDown={jobPortofLoadingKeyup} value={jobValues.port_of_loding} />
                                    <button onClick={JobPortOfLoadinHandleOpen} className='searchbutton'>
                                        <SearchIcon fontSize="small" /></button>
                                    <input className='ml-1 ' style={{ textTransform: "uppercase", height: '22px', width: '8%' }} disabled value={jobValues.port_of_lodingName} />

                                    <FormLabel className='ml-1'>Certificate(Y/N)</FormLabel>
                                    <input className='ml-1 txcnt' maxLength={1} style={{ textTransform: "uppercase", width: '2%', height: '22px' }}
                                        onChange={JobCertificateChangeHandle} onKeyDown={JobCertificateKeyUp} id='Certificate' value={jobValues.certificate_y_N} />

                                    <FormLabel className="ml-1">Bond(Y/N)</FormLabel>
                                    <input style={{ width: '2%', height: '22px', textTransform: 'uppercase', textAlign: 'center' }} value={jobValues.bond_y_N}
                                        id='Bond' onChange={JobBondChangeHandle} onKeyDown={jobBondKeyUp} className='ml-1 txcnt' />

                                    <FormLabel className="ml-1">Class(G/P/N)</FormLabel>
                                    <input maxLength={1} className='ml-1 txcnt' style={{ textTransform: "uppercase", width: '2%', height: '22px' }}
                                    onChange={JobClassChangeHandle} id='Classgpn' onKeyDown={jobClassKeyUp} value={jobValues.class_g_p_n} />
                                </div>
                            </Paper>
                        </Grid>
                        <Grid item xs={12} style={{ marginTop: '0.1%' }}>
                            <Paper className={classes.paper} style={{ backgroundColor: '#C8EDE7' }}>
                                Type Of BOE
                                <div style={{ fontWeight: 'bold' }}>
                                    <div className="form-inline mt-1 "  >
                                        <FormLabel style={{ color: "red" }}>Type(H/W/X)</FormLabel>
                                        <input maxLength={1} id='Type(H/W/X)' style={{ textTransform: "uppercase", width: '3%', height: '22px', textAlign: 'center', marginLeft: '1.2%' }}
                                        onChange={JobTypeHWXChangeHandle} onKeyDown={JobTypeHWXKeyUp} value={jobValues.type_H_W_x} />

                                        <FormLabel className='ml-1' style={{ color: "red" }}>ImpType(G/O/P/U)</FormLabel>
                                        <input maxLength={1} id="impTypeG_O_P_U" style={{ textTransform: "uppercase", width: '3%', height: '22px', textAlign: 'center', marginLeft: '0.2%' }}
                                        onChange={JobImpTypeGOPUChangeHandle} onKeyDown={JobImpTypeGOPUKeyUp} value={jobValues.imp_type_G_O_p_U} />

                                        <FormLabel className='ml-1' style={{ color: "red" }}>Kacha(Y/N)</FormLabel>
                                        <input className='ml-1 txcnt' maxLength={1} id='jobkacha' onKeyDown={JobkachaKeyUp}
                                        style={{ textTransform: "uppercase", width: '3%', height: '22px' }} onChange={JobKachaChangeHandle} value={jobValues.kacha_y_N} />

                                        <FormLabel className='ml-1'>Dif/Def(D/F)</FormLabel>
                                        <input className='ml-1 txcnt' maxLength={1} id='JobDifDefDF' onKeyDown={JobDifDefKeyUp}
                                        style={{ textTransform: "uppercase", width: '3%', height: '22px' }} onChange={JobDifDefChangeHandle} value={jobValues.dif_def} />

                                        <FormLabel className='ml-1' style={{ color: "red" }}>GreenChn(Y/N)</FormLabel>
                                        <input className='ml-1 txcnt' maxLength={1} id='JobgreenChn' onKeyDown={JobGressnChnKeyUp}
                                        style={{ textTransform: "uppercase", width: '3%', height: '22px' }} onChange={JobGreenChnChangeHandle} value={jobValues.green_chn} />

                                        <FormLabel className='ml-1' style={{ color: "red" }}>Hss(Y/N)</FormLabel>
                                        <input className='ml-1 txcnt' maxLength={1} id='JobHss' style={{ textTransform: "uppercase", width: '3%', height: '22px' }}
                                        onChange={JobHssYNChangeHandle} onKeyDown={JobHssKeyUp} value={jobValues.hss_y_n} />

                                        <FormLabel className='ml-1' style={{ color: "red" }}>Sec-48(Y/N)</FormLabel>
                                        <input className='ml-1 txcnt' maxLength={1} style={{ textTransform: "uppercase", width: '3%', height: '22px' }}
                                        onChange={JobSec_48ChangeHandle} id='sec' onKeyDown={JobSec_48KeyUp} value={jobValues.sec_48_y_n} />

                                        <FormLabel className='ml-1' style={{ color: "red" }}>PublicSec(Y/N)</FormLabel>
                                        <input className='ml-1 txcnt' maxLength={1} id='publicSec' style={{ textTransform: "uppercase", width: '3%', height: '22px' }}
                                        onChange={JobpublicSecChangeHandle} value={jobValues.public_sec_y_n} onKeyDown={JobPublicSecKeyUp} />
                                    </div>
                                    <div className='form-inline mt-1'>
                                        <FormLabel style={{ color: "red" }}>1stCheck(Y/N)</FormLabel>
                                        <input className='ml-1 mr-1 txcnt' maxLength={1} id='1stcheack' onKeyDown={Job1stCheackKeyUp}
                                        style={{ textTransform: "uppercase", width: '3%', height: '22px' }} onChange={Job1stCheackChangeHandle} value={jobValues.first_check_y_n} />
                                        <FormLabel style={{ color: "red" }}>PriorBE(Y/N)</FormLabel>
                                        <input className='ml-1 txcnt' maxLength={1} style={{ textTransform: "uppercase", width: '3%', height: '22px' }}
                                        onChange={JobPriorBeChangeHandle} id='priorbe' onKeyDown={JobPriorKeydown} value={jobValues.prior_be_y_n} />
                                        <FormLabel className='ml-1' style={{ color: "red" }}>CommercialTax(Y/N)</FormLabel>
                                        <input maxLength={1} className='txcnt' style={{ textTransform: "uppercase", width: '3%', height: '22px', marginLeft: '1%' }}
                                        onChange={JobCommercialtaxChangeHandle} onKeyDown={JobCommercialtaxKeydown} value={jobValues.commercial_tax_y_n} id='cmmrcialtax' />
                                        <FormLabel className='ml-1'>UCR</FormLabel>
                                        <input className='ml-1' maxLength={1} id='ucr' onKeyDown={JobUcrKeydown} style={{ textTransform: "uppercase", width: '15%', height: '22px' }}
                                            onChange={JobUcrChangeHandle} value={jobValues.ucr} />
                                        <FormLabel className='ml-1'>UCRType</FormLabel>
                                        <input className='ml-1' maxLength={1} id='ucrType' onKeyDown={JobUcrTypeKeydown} style={{ textTransform: "uppercase", width: '10%', height: '22px' }}
                                            onChange={JobUcrTypeChangeHandle} value={jobValues.ucr_type} />
                                        <FormLabel className='ml-1 txcnt' style={{ color: "red" }}>PaymentMode(D/T)</FormLabel>
                                        <input className='ml-1' maxLength={1} onKeyDown={JobPaymentModeKeydown} style={{ textTransform: "uppercase", width: '3%', height: '22px', textAlign: 'center' }}
                                        onChange={JobPaymentmodeChangeHandle} id='PaymentMode' value={jobValues.paymentMode_D_T} />
                                    </div>
                                </div>
                            </Paper>
                        </Grid>
                        <Grid item xs={12} style={{ marginTop: '0.1%' }}>
                            <Paper className={classes.paper} style={{ backgroundColor: '#C8EDE7' }}>
                                IGM Details
                                <div style={{ fontWeight: 'bold' }}>
                                    <div className='form-inline mt-1'>
                                        <Row className='form-inline'>
                                            <Col md={{ span: 2 }}>
                                                <Row>
                                                    <Col className='form-inline'>
                                                        <FormLabel hidden={JobIgmhide}>IGM.No</FormLabel>
                                                        <input hidden={JobIgmhide} id='igmno' style={{ textTransform: "uppercase", width: '62%', height: '22px', marginLeft: '7%' }}
                                                        maxLength="20" onChange={JobIgmNoChangeHandle} value={jobValues.igm_No} onKeyDown={JobIgmNoKeydown} />
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col className='form-inline mt-1'>
                                                        <Form.Label hidden={JobIgmhide}>IGM.Date</Form.Label>
                                                        <input type='date' hidden={JobIgmhide} onChange={JobIgmdateChangeHandle}
                                                            min={'2020x`'} max={'2024'} style={{ textTransform: "uppercase", width: '63%', height: '22px', marginLeft: '1%' }} value={jobValues.igmDate}
                                                            onKeyDown={jobigmdatekeydown} id='igm_date' />
                                                    </Col>
                                                </Row>
                                            </Col>
                                            <Col md={{ span: 2 }}>
                                                <Row>
                                                    <Col className='form-inline'>
                                                        <FormLabel style={{ color: "red" }}>{JobIgmtrnsitChnghide ? "MBL.No" : "MAWB.No"}</FormLabel>
                                                        <input id='mblno' onKeyDown={JobMBLNoKeydown} maxLength="20" style={{ textTransform: "uppercase", width: '53%', height: '22px', marginLeft: '6%' }}
                                                            onChange={JobMawbNoChangeHandle} value={jobValues.mawb_no} />
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col className='form-inline mt-1'>
                                                        <Form.Label style={{ color: 'red' }}>{JobIgmtrnsitChnghide ? "MBL Date" : "MAWB Date"}</Form.Label>
                                                        <input type='date' value={jobValues.mawbDate} onKeyDown={jobmawb_datekeydown} id='mawb_date'
                                                            min={'1990-01-01'} max={'2100-12-31'} style={{ width: '54%', height: '22px', textTransform: "uppercase", marginLeft: '1%' }} onChange={JobMawbDateChangeHandle} />
                                                    </Col>
                                                </Row>
                                            </Col>
                                            <Col md={{ span: 2 }}>
                                                <Row>
                                                    <Col className='form-inline'>
                                                        <FormLabel>{JobIgmtrnsitChnghide ? "HBL.No" : "HAWB.No"}</FormLabel>
                                                        <input id='hblno' onKeyDown={JobHBLNoKeydown} maxLength="20" style={{ textTransform: "uppercase", width: '55%', height: '22px', marginLeft: '6%' }}
                                                            onChange={JobHawbNoChangeHandle} value={jobValues.hawb_no} />
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col className='form-inline mt-1'>
                                                        <Form.Label>{JobIgmtrnsitChnghide ? "HBL Date" : "HAWB Date"}</Form.Label>
                                                        <input type='date' value={jobValues.hawbDate} onKeyDown={jobHaw_datekeydown} id='Haw_date'
                                                            min={'1990-01-01'} max={'2100-12-31'} style={{ textTransform: "uppercase", width: '55%', height: '22px', marginLeft: '1%' }} onChange={JobHawbDateChangeHandle} />
                                                    </Col>
                                                </Row>
                                            </Col>
                                            <Col md={{ span: 2 }}>
                                                <Row>
                                                    <Col className='form-inline'>
                                                        <FormLabel style={{ color: "red" }}>No.of.pkgs</FormLabel>
                                                        <input id='noOfPkgs' maxLength="20" style={{ width: '34%', height: '22px', marginLeft: '1%' }} onChange={JobNoOfPkgChangeHandle}
                                                            value={jobValues.no_of_pkgs} onKeyDown={JobNoOfPkgsKeydown} />
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col className='form-inline mt-1'>
                                                        <Form.Label style={{ color: 'red', marginRight: '3%' }}>PKG.Code</Form.Label>
                                                        <input style={{ width: '18%', height: '22px', marginLeft: '1%', textTransform: 'uppercase' }} onKeyDown={JobPkgCodeKeyDown}
                                                            maxLength="10" value={jobValues.pkg_code} onChange={JobPkgCodeChangeHandle} id='pkg_code' />
                                                        <button className='searchbutton' onClick={JobPkgCode_Openhandle}>
                                                            <SearchIcon fontSize='small' /></button>
                                                    </Col>
                                                </Row>
                                            </Col>
                                            <Grid item xs={4}>
                                                <Col>
                                                    <Row>
                                                        <Col className='form-inline'>
                                                            <FormLabel style={{ color: "red", marginLeft: '-22%' }}>GrossWT</FormLabel>
                                                            <input className='ml-1' style={{ width: '20%', height: '22px' }} maxLength="20" onChange={JobGrossWtChangeHandle} value={jobValues.gross_wt} id='grooswt'
                                                                onKeyDown={JobGrossWtKeydown} />
                                                            <FormLabel className='ml-1' style={{ color: "red" }}>Unit</FormLabel>
                                                            <input className='ml-1' size='sm' id='jobunit' style={{ textTransform: "uppercase", width: '10%', height: '22px' }}
                                                                onChange={JobunitChangeHandle} onKeyDown={JobunitKeyDown} value={jobValues.unit} />
                                                            <button onClick={JobUnitCode_Openhandle} className='searchbutton'>
                                                                <SearchIcon fontSize="small" /></button>
                                                            <FormLabel className='ml-1' hidden={JobInwardatehide}>InwardDate</FormLabel>
                                                            <input className='ml-1' type='date' style={{ width: '24%', height: '22px', textTransform: 'uppercase' }}
                                                            min={'1990-01-01'} max={'2100-12-31'} onChange={JobInwaedateChangeHandle} hidden={JobInwardatehide} id='InwardDate' onKeyDown={jobInwardatekeydown} value={jobValues.inWardDate} />
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col className='form-inline mt-1'>
                                                            <Form.Label style={{ marginLeft: '-22%' }}>Marks&Number</Form.Label>
                                                            <input className='ml-1' style={{ width: '40%', height: '22px' }} id='marks_number' value={jobValues.marks_and_number} onChange={JobMarksNumsChangeHandle}
                                                                onKeyDown={jobmarks_numberkeydown} onBlur={JobMarksNumberonBlur} />
                                                            <FormLabel className='ml-1'>Container(Y/N)</FormLabel>
                                                            <input className='ml-2 txcnt' maxLength={1} id='container' style={{ textTransform: "uppercase", width: '10%', height: '22px', textAlign: 'center' }}
                                                            onChange={JobContainerChangeHandle} onKeyDown={jobContainerKeyUp} value={jobValues.container_detail} />
                                                        </Col>
                                                    </Row>
                                                </Col>
                                            </Grid>
                                        </Row>
                                    </div>
                                    <div>
                                    </div>
                                    <div className='form-inlline mt-1'>
                                        <input hidden id='jobmrkentr' />
                                        <label style={{ color: 'red' }} hidden={JobGatwayhide}>GateWayIgmNo</label>
                                        <input className='ml-1 mr-1' style={{ width: '10%', height: '22px' }} hidden={JobGatwayhide}
                                            value={jobValues.gatewayNo} onChange={JobGatewaNoChangeHandle} onKeyDown={jobgateway_igmnokeydown} id='gateway_igmno' />
                                        <label style={{ color: 'red' }} hidden={JobRepPorthide}>RepPort</label>
                                        <input className='ml-1' style={{ width: '6%', height: '22px' }} hidden={JobRepPorthide}
                                            value={jobValues.repPortCode} onChange={JobRepPortChangeHandle} onKeyDown={JobRepPortKeyDown} id='Report_id' />
                                        <button className='searchbutton' hidden={JobRepPorthide} onClick={JobRepPort_Openhandle}>
                                            <SearchIcon fontSize='small' />
                                        </button>
                                        <input className='ml-1 mr-1' style={{ height: '22px' }} disabled hidden={JobRepPorthide}
                                            value={jobValues.repPortName} />
                                        <label style={{ color: 'red' }} hidden={JobGatwayhide}>GateWayDate</label>
                                        <input className='ml-1' style={{ width: '10%', height: '22px', textTransform: 'uppercase' }} hidden={JobGatwayhide}
                                            min={'1990-01-01'} max={'2100-12-31'} value={jobValues.gateWayDate} type='date' onChange={JobGateWayDateChangeHandle}
                                            onBlur={JobGatewayDateonBlur} onKeyDown={JobGatewayKeyDown} id='gateWayDate' />
                                    </div>
                                    <div className='mb-1 mt-1'>
                                        <center>
                                            <Button size='small' variant="contained" color="primary" onClick={saveigm} disabled={JobIGMSaveDsab} id='Jsvigm'>{JobIGMSve ? 'Processing...' : 'Add IGM'}</Button>{' '}
                                            <Button size='small' variant="contained" color="primary" onClick={updateIgm} disabled={JobIGMUpdatedsab} id='JupdIgm'>{JobIGMUpd ? 'Processing...' : 'Update IGM'}</Button>{' '}
                                            <Button size='small' variant="contained" color="primary" onClick={JobDeleteIgmDetails} disabled={JobIGMDeleteDsab}>{JobIGMDlt ? 'Processing...' : 'Delete IGM'}</Button>{' '}
                                            <Button size='small' variant="contained" color="primary" onKeyDown={masterIgmRefBtneKeyDown} onClick={refreshigm}>Refresh Igm</Button>{' '}
                                        </center>
                                    </div>
                                    <div>
                                        <TableContainer className={classes.containerJob}>
                                            <Table stickyHeader className='table-bordered'>
                                                <TableHead>
                                                    <StyledTableRow >
                                                        <StyledTableCell className='p-1'>Sl.No</StyledTableCell>
                                                        <StyledTableCell className='p-1'>Igm.No</StyledTableCell>
                                                        <StyledTableCell className='p-1'>Igm.Date</StyledTableCell>
                                                        <StyledTableCell className='p-1'>Mbl.No</StyledTableCell>
                                                        <StyledTableCell className='p-1'>Mbl.Date</StyledTableCell>
                                                        <StyledTableCell className='p-1'>Hawb.No</StyledTableCell>
                                                        <StyledTableCell className='p-1'>Hawb.Date</StyledTableCell>
                                                        <StyledTableCell className='p-1'>Inward.Date</StyledTableCell>
                                                        <StyledTableCell className='p-1'>NoOfPkg</StyledTableCell>
                                                        <StyledTableCell className='p-1'>GroosWT</StyledTableCell>
                                                        <StyledTableCell className='p-1'>UnitCode</StyledTableCell>
                                                        <StyledTableCell className='p-1'>PkgCode</StyledTableCell>
                                                        <StyledTableCell className='p-1'>GateWayIGMno</StyledTableCell>
                                                        <StyledTableCell className='p-1'>ReportingPort</StyledTableCell>
                                                        <StyledTableCell className='p-1'>GateWayDate</StyledTableCell>
                                                    </StyledTableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {jobIgmDetails.map((igm) => { const selectedItem = isMasterTransitSelected(igm.igmNo);
                                                       return(
                                                        <StyledTableRow hover key={igm.consignmentId} id='masterIgmTableId' onKeyDown={masterIgmTableKeyDown} tabIndex={-1} selected={selectedItem} onClick={() => EditIgmDetails(igm)} className='igmtbl'>
                                                            <StyledTableCell className='p-1 '>{igm.serialNumber}</StyledTableCell>
                                                            <StyledTableCell className='p-1'>{igm.igmNo}</StyledTableCell>
                                                            <StyledTableCell className='p-1'>{igm.igmDate} </StyledTableCell>
                                                            <StyledTableCell className='p-1'>{igm.mawbNo}</StyledTableCell>
                                                            <StyledTableCell className='p-1'>{igm.mawb_date}</StyledTableCell>
                                                            <StyledTableCell className='p-1'>{igm.hawb_no}</StyledTableCell>
                                                            <StyledTableCell className='p-1'>{igm.hawbDate}</StyledTableCell>
                                                            <StyledTableCell className='p-1'>{igm.inwardDate}</StyledTableCell>
                                                            <StyledTableCell className='p-1'>{igm.noofPkg}</StyledTableCell>
                                                            <StyledTableCell className='p-1'>{igm.totalWeight}</StyledTableCell>
                                                            <StyledTableCell className='p-1'>{igm.uomCode}</StyledTableCell>
                                                            <StyledTableCell className='p-1'>{igm.packageCode}</StyledTableCell>
                                                            <StyledTableCell className='p-1'>{igm.gateWay_igmNo}</StyledTableCell>
                                                            <StyledTableCell className='p-1'>{igm.gateWay_port_code}</StyledTableCell>
                                                            <StyledTableCell className='p-1'>{igm.gateWay_igmDate}</StyledTableCell>
                                                        </StyledTableRow>)})}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </div>
                                    <div className='mt-2' >
                                        <center>
                                            <Button hidden size='small' variant="contained" color="primary" onClick={saveJob} disabled={EDiJobSaveDsa}>
                                                {EDiJobSve ? 'Processing...' : 'Save Job'}</Button>{' '}
                                            <Button size='small' variant="contained" color="primary" onClick={updateEdiJob} disabled={EDiJobUpdateDsa}>
                                                {EDiJobUpd ? 'Processing...' : 'Update'}</Button>{' '}
                                            <Button size='small' variant="contained" color="primary" onClick={EdiJobDelete} disabled={EDiJobDeleteDsa}>
                                                {EDiJobDlt ? 'Processing...' : 'Delete'}</Button>{' '}
                                            <Button size='small' variant="contained" color="primary" onClick={JobReset}>Cancel</Button>{' '}
                                            <Button size='small' variant="contained" color="primary" onClick={jobPrintOpenHandle}>Print</Button>{' '}
                                            <Button size='small' variant="contained" color="primary" onClick={JobBOEupdationOpenhandle}>Boe Updation</Button>{' '}
                                        </center>
                                    </div>
                                </div>
                            </Paper>
                        </Grid>
                    </Grid>
                </Tab>
                {/* --------------------------------------------------------------------------------------------------------
                -----------------------------TabsInvoice--------------------------------- ------*/}
                <Tab eventKey="Invoice" title="Invoice" >
                    {/* ..................................................Dialog....................................................................... */}
                    <div>
                        {/* InvoiceBulkUpload */}
                        <Dialog open={invoiceBulkUploadOpen} onClose={invoiceBulkUploadclose} fullWidth={true} maxWidth="sm">
                            <DialogTitle className="dialogboxtitlecolour p-1">
                                <center>INVOICE UPLOAD</center>
                            </DialogTitle>
                            <div className='dialogboxcolour'>
                                <center>
                                    <label onClick={invoice_excelUploadFile} className="btn btn-default p-1" >Upload
                                        {excelUpload ? <input type="file" onChange={invoiceselectFile} hidden /> : null}
                                    </label>
                                    {currentFile && (
                                        <LinearProgress color="secondary" />
                                    )}
                                    <label className="btn btn-default p-1" onClick={InvoiceErrorFilesOpen} >View Error Files</label>
                                </center>
                                <Divider />
                                <center>
                                    <h6>Click Download Template Button to  Download</h6>
                                    <br />
                                    <h6>Click Upload Button to Upload Invoice Details</h6>
                                </center>
                                <Divider />
                                <div className='mt-2 mb-2'>
                                    <center>
                                        <Button size='small' variant="contained" color="primary" onClick={invoice_Dwnld_temp}>Download Template</Button>{' '}
                                        <Button size='small' variant="contained" color="primary" onClick={invoiceBulkUploadclose}>Close</Button>{' '}
                                        <Button size='small' variant="contained" color="primary" onClick={invoiceBulkrefresh}>Refresh</Button>{' '}
                                    </center></div>
                            </div>
                        </Dialog>
                        <Dialog onClose={InvoiceErrorFilesClose} open={invoiceBulkUploadErrorOpen} fullWidth={true} maxWidth='md'>
                            <DialogTitle align='center' className="dialogboxtitlecolour p-1">INVOICE ERROR REPORT</DialogTitle>
                            <div>
                                <TableContainer className={classes.container}>
                                    <Table stickyHeader className="table-bordered">
                                        <TableHead>
                                            <StyledTableRow>
                                                <StyledTableCell align='center' className="p-1">Sl.No</StyledTableCell>
                                                <StyledTableCell align='center' className="p-1">Invoice Sr No</StyledTableCell>
                                                <StyledTableCell align='center' className="p-1">Invoice No</StyledTableCell>
                                                <StyledTableCell align='center' className="p-1" style={{ color: 'red' }}>Error Type</StyledTableCell>
                                                <StyledTableCell align='center' className="p-1">Value</StyledTableCell>
                                                <StyledTableCell align='center' className="p-1">Supplier Name</StyledTableCell>
                                            </StyledTableRow>
                                        </TableHead>
                                        <TableBody>
                                            {
                                                invoicedetails.map(
                                                    (trns) => (
                                                        <StyledTableRow hover key={trns.index}>
                                                            <StyledTableCell className="p-1">{trns.serialNumber}</StyledTableCell>
                                                            <StyledTableCell className="p-1">{trns.slNo}</StyledTableCell>
                                                            <StyledTableCell className="p-1">{trns.invoiceNumber}</StyledTableCell>
                                                            <StyledTableCell className="p-1">{trns.errorType}</StyledTableCell>
                                                            <StyledTableCell className="p-1">{trns.invoiceValue}</StyledTableCell>
                                                            <StyledTableCell className="p-1">{trns.supplierName}</StyledTableCell>
                                                        </StyledTableRow>
                                                    ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </div>
                        </Dialog>
                        {/* ///// */}
                        <Dialog open={InvoiceCurrencyopen} onClose={InvoiceCurrencyhandleClose} fullWidth={true} maxWidth='md'>
                            <DialogTitle align='center' className="dialogboxtitlecolour p-1">
                                CURRENCY DETAILS
                            </DialogTitle>
                            <div className='dialogboxcolour'>
                                <div style={{ marginLeft: '26%' }}>
                                    <Container className="mb-2 mt-4">
                                        <Row>
                                            <div className="form-inline ml-5" style={{ width: "80%", marginLeft: "4rem" }}>
                                                <label className="dialogfont">Find Currency Name</label>
                                                <input type="text" className="input ml-1" style={{ textTransform: 'uppercase', textAlign: 'center' }} onKeyDown={InvoiceDialogCurruncyCodeKeyDown}
                                                    value={dialoginvoicevalues.FindCurrencyName} onChange={InvoiceFindCurrencyNameChangeHandle}></input>
                                            </div>
                                        </Row>
                                        <Row>
                                            <div className="form-inline mt-1 ml-5" style={{ width: "80%", marginLeft: "6rem" }}>
                                                <label className="dialogfont">Find Currency Code</label>
                                                <input type="text" className="input ml-2 mb-1" style={{ textTransform: 'uppercase', textAlign: 'center' }} autoFocus onKeyDown={InvoiceDialogCurruncyNameKeyDown}
                                                    id='InvoiceDialogCurrunCode' value={dialoginvoicevalues.FindCurrencyCode} onChange={InvoiceFindCurrencyCodeChangeHandle}></input>
                                            </div>
                                        </Row></Container>
                                </div>
                            </div>
                            <TableContainer className={classes.container}>
                                <Table stickyHeader className="table-bordered">
                                    <TableHead>
                                        <StyledTableRow>
                                            <StyledTableCell align='center' className='p-1'>Currency Code</StyledTableCell>
                                            <StyledTableCell align='center' className='p-1'>Exchange Rate</StyledTableCell>
                                        </StyledTableRow>
                                    </TableHead>
                                    <TableBody className="Tablebgcolorcss" >
                                        {
                                            invoicedetails.map((trns) => { const selectedItem = isInvoiceTblSelected(trns.currency_code);
                                                return(
                                                    <TableRow hover key={trns.currency_code} onClick={() => editInvoiceCurrency(trns)} id='invoiceCurruncyTblDetails_id'
                                                    tabIndex={-1} onKeyDown={(e)=>InvoiceCurruncyTbleKeyDown(e,'curruncy')} selected={selectedItem}>
                                                        <TableCell align='center' className='p-1'>{trns.currency_code}</TableCell>
                                                        <TableCell align='center' className='p-1'>{trns.indianValue}</TableCell>
                                                    </TableRow>
                                                )})}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Dialog>
                        <Dialog open={InvoiceTermsopen} onClose={InvoiceTermshandleClose} fullWidth={true} maxWidth='md'>
                            <DialogTitle align='center' className="dialogboxtitlecolour p-1">
                                TERMS DETAILS
                            </DialogTitle>
                            <div className='dialogboxcolour'>
                                <div style={{ marginLeft: '26%' }}><Container className="mb-2 mt-4">
                                    <Row>
                                        <div className="form-inline ml-5" style={{ width: "80%", marginLeft: "4rem" }}>
                                            <label className="dialogfont">Find Terms Name</label>
                                            <input type="text" className="input ml-1" style={{ textTransform: 'uppercase', textAlign: 'center' }}
                                                value={dialoginvoicevalues.FindTermsName} onChange={InvoiceFindTermsNameChangeHandle} onKeyDown={InvoiceDialogTermsNameKeyDown}></input>
                                        </div>
                                    </Row>
                                    <Row>
                                        <div className="form-inline mt-1 ml-5" style={{ width: "80%", marginLeft: "6rem" }}>
                                            <label className="dialogfont">Find Terms Code</label>
                                            <input type="text" className="input ml-2 mb-1" style={{ textTransform: 'uppercase', textAlign: 'center' }} autoFocus onKeyDown={InvoiceDialogTermsCodeKeyDown}
                                                id='InvoiceFindTermsCode' value={dialoginvoicevalues.FindTermsCode} onChange={InvoiceFindTermsCodeChangeHandle}></input>
                                        </div>
                                    </Row></Container>
                                </div>
                            </div>
                            <TableContainer className={classes.container}>
                                <Table stickyHeader className="table-bordered">
                                    <TableHead>
                                        <StyledTableRow>
                                            <StyledTableCell align='center' className="p-1" >Terms Code</StyledTableCell>
                                            <StyledTableCell align='center' className="p-1" >Terms Name</StyledTableCell>
                                        </StyledTableRow>
                                    </TableHead>
                                    <TableBody>
                                        {
                                            invoicedetails.map((trns) => { const selectedItem = isInvoiceTblSelected(trns.terms_code);
                                                return(
                                                    <TableRow hover key={trns.terms_code} onClick={() => editinvoiceterms(trns)} id='invoiceTermsTblDetails_id'
                                                    tabIndex={-1} onKeyDown={(e)=>InvoiceCurruncyTbleKeyDown(e,'termsCntion')} selected={selectedItem}>
                                                        <TableCell align='center' className="p-1">{trns.terms_code}</TableCell>
                                                        <TableCell align='center' className="p-1">{trns.terms_Name}</TableCell>
                                                    </TableRow>
                                                )})}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Dialog>
                        <Dialog open={InvoiceSuplierNameopen} onClose={InvoiceSupplierNamehandlehandleClose} fullWidth={true} maxWidth='md'>
                            <DialogTitle align='center' className="dialogboxtitlecolour p-1">SUPPLIER DETAILS
                            </DialogTitle>
                            <div className='dialogboxcolour'>
                                <div style={{ marginLeft: '26%' }}><Container className="mb-2 mt-4">
                                    <Row>
                                        <div className="form-inline ml-5" style={{ width: "80%", marginLeft: "4rem" }} size="sm">
                                            <label className="dialogfont">Find Supplier Name</label>
                                            <input type="text" className="input ml-1" style={{ textTransform: 'uppercase', textAlign: 'center' }} autoFocus onKeyDown={InvoiceDialogSupplierNameKeyDown}
                                                value={dialoginvoicevalues.FindSupplierName} onChange={InvoiceFindSupplierNameChangeHandle}></input>
                                        </div>
                                    </Row></Container>
                                </div>
                            </div>
                            <TableContainer className={classes.container}>
                                <Table stickyHeader className="table-bordered">
                                    <TableHead>
                                        <StyledTableRow>
                                            <StyledTableCell align='center' className="p-1" >Name</StyledTableCell>
                                            <StyledTableCell align='center' className="p-1">Address 1</StyledTableCell>
                                            <StyledTableCell align='center' className="p-1">Address 2</StyledTableCell>
                                            <StyledTableCell align='center' className="p-1">Pincode</StyledTableCell>
                                            <StyledTableCell align='center' className="p-1">Country Name</StyledTableCell>
                                        </StyledTableRow>
                                    </TableHead>
                                    <TableBody>
                                        {
                                            invoicedetails.map((trns) => { const selectedItem = isInvoiceTblSelected(trns.supplierName);
                                                return(
                                                    <TableRow hover key={trns.supplierName} onClick={() => editinvoicesupplierName(trns)} id='invoiceSupplierTblDetails_id'
                                                    tabIndex={-1} onKeyDown={(e)=>InvoiceCurruncyTbleKeyDown(e,'Supplier')} selected={selectedItem}>
                                                        <TableCell align='center' className="p-1">{trns.supplierName}</TableCell>
                                                        <TableCell align='center' className="p-1">{trns.supplierAddress1}</TableCell>
                                                        <TableCell align='center' className="p-1">{trns.supplierAddress2}</TableCell>
                                                        <TableCell align='center' className="p-1">{trns.supplierPincode}</TableCell>
                                                        <TableCell align='center' className="p-1">{trns.supplierCountryName}</TableCell>
                                                    </TableRow>
                                                )})}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Dialog>
                        <Dialog open={InvoiceSupplierCountryopen} onClose={InvoiceSupplierCountryhandleClose} fullWidth={true} maxWidth='md'>
                            <DialogTitle align='center' className="dialogboxtitlecolour p-1"> SUPPLIER COUNTRY DETAILS
                            </DialogTitle>
                            <div className='dialogboxcolour'>
                                <div style={{ marginLeft: '26%' }}><Container className="mb-2 mt-4">
                                    <Row>
                                        <div className="form-inline ml-5" style={{ width: "80%", marginLeft: "4rem" }}>
                                            <label className="dialogfont">Find Country Name</label>
                                            <input type="text" className="input ml-1" style={{ textTransform: 'uppercase', textAlign: 'center' }} onKeyDown={InvoiceDialogSupplierCntryNameKeyDown}
                                                value={dialoginvoicevalues.FindCountryName} onChange={InvoiceFindCountryNameChangeHandle}></input>
                                        </div>
                                    </Row>
                                    <Row>
                                        <div className="form-inline mt-1 ml-5" style={{ width: "80%", marginLeft: "6rem" }}>
                                            <label className="dialogfont">Find Country Code</label>
                                            <input type="text" className="input ml-2 mb-1" style={{ textTransform: 'uppercase', textAlign: 'center' }} autoFocus onKeyDown={InvoiceDialogSupplierCntryCodeKeyDown}
                                                id='InvoiceFindCntryCode' value={dialoginvoicevalues.FindCountryCode} onChange={InvoiceFindCountryCodeChangeHandle}></input>
                                        </div>
                                    </Row></Container>
                                </div>
                            </div>
                            <TableContainer className={classes.container}>
                                <Table stickyHeader className="table-bordered">
                                    <TableHead>
                                        <StyledTableRow>
                                            <StyledTableCell align='center' className="p-1" >Country Code</StyledTableCell>
                                            <StyledTableCell align='center' className="p-1" >Country Name</StyledTableCell>
                                        </StyledTableRow>
                                    </TableHead>
                                    <TableBody>
                                        {
                                            invoicedetails.map((trns) => { const selectedItem = isInvoiceTblSelected(trns.countryIdString);
                                                return(
                                                    <TableRow hover key={trns.countryName} onClick={() => editInvoiceCountryName(trns)} id='invoiceSupplierCountryTblDetails_id'
                                                    tabIndex={-1} onKeyDown={(e)=>InvoiceCurruncyTbleKeyDown(e,'SupplierCountry')} selected={selectedItem}>
                                                        <TableCell align='center' className="p-1" >{trns.countryIdString}</TableCell>
                                                        <TableCell align='center' className="p-1" >{trns.countryName}</TableCell>
                                                    </TableRow>
                                                )})}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Dialog>
                        <Dialog open={InvoiceNatureOfTransactionopen} onClose={InvoiceNatureOfTransactionhandleClose} fullWidth={true} maxWidth='md'>
                            <DialogTitle align='center' className="dialogboxtitlecolour p-1">
                                NATURE TRANSACTION DETAILS
                            </DialogTitle>
                            <div className='dialogboxcolour'>
                                <div style={{ marginLeft: '26%' }}><Container className="mb-2 mt-4">
                                    <Row>
                                        <div className="form-inline ml-5" style={{ width: "80%", marginLeft: "4rem" }} size="sm">
                                            <label className="dialogfont">Find Transaction Name</label>
                                            <input type="text" className="input ml-1" style={{ textTransform: 'uppercase', textAlign: 'center' }} onKeyDown={InvoiceDialogNatureTrnsctionNameKeyDown}
                                                value={dialoginvoicevalues.FindTransactionName} onChange={InvoiceFindTransactionNameChangeHandle}></input>
                                        </div>
                                    </Row>
                                    <Row>
                                        <div className="form-inline mt-1 ml-5" style={{ width: "80%", marginLeft: "6rem", }} size="sm">
                                            <label className="dialogfont">Find Transaction Code</label>
                                            <input type="text" className="input ml-2 mb-1" style={{ textTransform: 'uppercase', textAlign: 'center' }} autoFocus onKeyDown={InvoiceDialogNatureTrnsctionCodeKeyDown}
                                                id='invoiceTransctionCode' value={dialoginvoicevalues.FindTransactionCode} onChange={InvoiceFindTransactionCodeChangeHandle}></input>
                                        </div>
                                    </Row></Container>
                                </div>
                            </div>
                            <TableContainer className={classes.container}>
                                <Table stickyHeader className="table-bordered">
                                    <TableHead>
                                        <StyledTableRow>
                                            <StyledTableCell align='center' className='p-1'>Transaction Code</StyledTableCell>
                                            <StyledTableCell align='center' className='p-1'>Transaction Name</StyledTableCell>
                                        </StyledTableRow>
                                    </TableHead>
                                    <TableBody>
                                        {
                                            invoicedetails.map((trns) => { const selectedItem = isInvoiceTblSelected(trns.transactionCode);
                                                return(
                                                    <TableRow hover key={trns.transactionCode} onClick={() => editInvoiceTransactiondetails(trns)} id='invoiceTransitionCountryTblDetails_id'
                                                    tabIndex={-1} onKeyDown={(e)=>InvoiceCurruncyTbleKeyDown(e,'TransitionCountry')} selected={selectedItem}>
                                                        <TableCell align='center' className='p-1'>{trns.transactionCode}</TableCell>
                                                        <TableCell align='center' className='p-1'>{trns.transactionName}</TableCell>
                                                    </TableRow>
                                                )})}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Dialog>
                        <Dialog open={InvoiceTermOfPaymentChangeopen} onClose={InvoiceTermOfPaymentChangehandleClose} fullWidth={true} maxWidth='md'>
                            <DialogTitle align='center' className="dialogboxtitlecolour p-1">
                                PAYMENTS TERMS DETAILS
                            </DialogTitle>
                            <div className='dialogboxcolour'>
                                <div style={{ marginLeft: '24%' }}><Container className="mb-2 mt-4">
                                    <Row>
                                        <div className="form-inline ml-5" style={{ width: "80%", marginLeft: "4rem" }} size="sm">
                                            <label className="dialogfont">Find Payment Terms Name</label>
                                            <input type="text" className="input ml-1" style={{ textTransform: 'uppercase', textAlign: 'center' }} onKeyDown={InvoiceDialogPaymentTermsNameKeyDown}
                                                value={dialoginvoicevalues.FindPaymentTermsName} onChange={InvoiceFindPaymentTermsNameChangeHandle}></input>
                                        </div>
                                    </Row>
                                    <Row>
                                        <div className="form-inline mt-1 ml-5" style={{ width: "80%", marginLeft: "6rem" }} size="sm">
                                            <label className="dialogfont">Find Payment Terms Code</label>
                                            <input type="text" className="input ml-2 mb-1" style={{ textTransform: 'uppercase', textAlign: 'center' }} autoFocus onKeyDown={InvoiceDialogPaymentTermsCodeKeyDown}
                                                id='PaymentTermsCode' value={dialoginvoicevalues.FindPaymentTermsCode} onChange={InvoiceFindPaymentTermsCodeChangeHandle}></input>
                                        </div>
                                    </Row></Container>
                                </div>
                            </div>
                            <TableContainer className={classes.container}>
                                <Table stickyHeader className="table-bordered">
                                    <TableHead>
                                        <StyledTableRow>
                                            <StyledTableCell align='center' className="p-1">Payment Terms Code</StyledTableCell>
                                            <StyledTableCell align='center' className="p-1">Payment Terms Name</StyledTableCell>
                                        </StyledTableRow>
                                    </TableHead>
                                    <TableBody>
                                        {
                                            invoicedetails.map((trns) => { const selectedItem = isInvoiceTblSelected(trns.paymentTermsCode);
                                                return(
                                                    <TableRow hover key={trns.paymentTermsCode} onClick={() => editInvoiceTermsofpayment(trns)} id='invoicePaymentTermsTblDetails_id'
                                                    tabIndex={-1} onKeyDown={(e)=>InvoiceCurruncyTbleKeyDown(e,'paymentTerms')} selected={selectedItem}>
                                                        <TableCell align='center' className="p-1">{trns.paymentTermsCode}</TableCell>
                                                        <TableCell align='center' className="p-1">{trns.paymentTermsName}</TableCell>
                                                    </TableRow>
                                                )})}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Dialog>
                        <Dialog open={InvoiceValuationMethodopen} onClose={InvoiceValuationMethodhandleClose} fullWidth={true} maxWidth='md'>
                            <DialogTitle align='center' className="dialogboxtitlecolour p-1">
                                VALUATION METHOD DETAILS
                            </DialogTitle>
                            <div className='dialogboxcolour'>
                                <div style={{ marginLeft: '24%' }}><Container className="mb-2 mt-4">
                                    <Row>
                                        <div className="form-inline ml-5" style={{ width: "80%", marginLeft: "4rem" }} size="sm">
                                            <label className="dialogfont">Find Payment Terms Name</label>
                                            <input type="text" className="input ml-1" style={{ textTransform: 'uppercase', textAlign: 'center' }} onKeyDown={InvoiceDialogValutionMethodtermsNameKeyDown}
                                                value={dialoginvoicevalues.ValuationFindPaymentTermsName} onChange={InvoiceValuationFindPaymentTermsNameChangeHandle}></input>
                                        </div>
                                    </Row>
                                    <Row>
                                        <div className="form-inline mt-1 ml-5" style={{ width: "80%", marginLeft: "6rem" }} size="sm">
                                            <label className="dialogfont">Find Payment Terms Code</label>
                                            <input type="text" className="input ml-2 mb-1" style={{ textTransform: 'uppercase', textAlign: 'center' }} autoFocus onKeyDown={InvoiceDialogValutiontermsCodeKeyDown}
                                                id='ValuationPaymentMethodDetails' value={dialoginvoicevalues.ValuationFindPaymentTermsCode} onChange={InvoiceValuationFindPaymentTermsCodeChangeHandle}></input>
                                        </div>
                                    </Row></Container>
                                </div>
                            </div>
                            <TableContainer className={classes.container}>
                                <Table stickyHeader className="table-bordered">
                                    <TableHead>
                                        <StyledTableRow>
                                            <StyledTableCell align='center' className="p-1">Payment Terms Code</StyledTableCell>
                                            <StyledTableCell align='center' className="p-1">Payment Terms Name</StyledTableCell>
                                        </StyledTableRow>
                                    </TableHead>
                                    <TableBody>
                                        {
                                            invoicedetails.map((trns) => { const selectedItem = isInvoiceTblSelected(trns.valuationMethodCode);
                                                return(
                                                    <TableRow hover key={trns.valuationMethodCode} onClick={() => editInvoicevaluationmethod(trns)} id='invoiceValuetionMethodTblDetails_id'
                                                    tabIndex={-1} onKeyDown={(e)=>InvoiceCurruncyTbleKeyDown(e,'valuetionMethod')} selected={selectedItem}>
                                                        <TableCell align='center' className="p-1">{trns.valuationMethodCode}</TableCell>
                                                        <TableCell align='center' className="p-1">{trns.valuationMethodName}</TableCell>
                                                    </TableRow>
                                                )})}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Dialog>
                        <Dialog open={InvoiceAEOCountryopen} onClose={InvoiceAEOCountryhandleClose} fullWidth={true} maxWidth='md'>
                            <DialogTitle align='center' className="dialogboxtitlecolour p-1">
                                AEO COUNTRY DETAILS
                            </DialogTitle>
                            <div className='dialogboxcolour'>
                                <div style={{ marginLeft: '26%' }}><Container className="mb-2 mt-4">
                                    <Row>
                                        <div className="form-inline ml-5" style={{ width: "80%", marginLeft: "4rem" }} size="sm">
                                            <label className="dialogfont">Find Country Name</label>
                                            <input type="text" className="input ml-1" style={{ textTransform: 'uppercase', textAlign: 'center' }} onKeyDown={InvoiceDialogAEoCountryDetailsKeyDown}
                                                value={dialoginvoicevalues.AeoFindCountryName} onChange={InvoiceAeoFindCountryNameChangeHandle}></input>
                                        </div>
                                    </Row>
                                    <Row>
                                        <div className="form-inline mt-1 ml-5" style={{ width: "80%", marginLeft: "6rem" }} size="sm">
                                            <label className="dialogfont" >Find Country Code</label>
                                            <input type="text" className="input ml-2 mb-1" style={{ textTransform: 'uppercase', textAlign: 'center' }} autoFocus onKeyDown={InvoiceDialogAEoCountryCodeDetailsKeyDown}
                                                id='InvoiceAeoFContryCode' value={dialoginvoicevalues.AeoFindCountryCode} onChange={InvoiceAeoFindCountryCodeChangeHandle}></input>
                                        </div>
                                    </Row></Container>
                                </div>
                            </div>
                            <TableContainer className={classes.container}>
                                <Table stickyHeader className="table-bordered">
                                    <TableHead>
                                        <StyledTableRow>
                                            <StyledTableCell align='center' className="p-1">Country Code</StyledTableCell>
                                            <StyledTableCell align='center' className="p-1">Country Name</StyledTableCell>
                                        </StyledTableRow>
                                    </TableHead>
                                    <TableBody>
                                        {
                                            invoicedetails.map((trns) => { const selectedItem = isInvoiceTblSelected(trns.countryIdString);
                                                return(
                                                    <TableRow hover key={trns.countryIdString} onClick={() => editInvoiceAEoCountry(trns)} id='invoiceAEOCOUNTRYTblDetails_id'
                                                    tabIndex={-1} onKeyDown={(e)=>InvoiceCurruncyTbleKeyDown(e,'AEOCOUNTRY')} selected={selectedItem}>
                                                        <TableCell align='center' className="p-1">{trns.countryIdString}</TableCell>
                                                        <TableCell align='center' className="p-1">{trns.countryName}</TableCell>
                                                    </TableRow>
                                                )})}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Dialog>
                        {/* .........................................KeyUpdialogevent....................................... */}
                        <Dialog open={invoicetermsdialogopen} onClose={inovicetermskeyhandleClose} fullWidth={true} maxWidth='md'>
                            <DialogTitle align='center' className="dialogboxtitlecolour p-1">{Addterms ? 'ADD TERMS INVOICE' : 'AUTO BIFURCATION-TERMS OF INVOICE'}</DialogTitle>
                            {invc_showADDterms ? <div className='dialogboxcolour'>
                                <div className="form-inline mb-1 mt-3">
                                    <label style={{ marginLeft: '24%' }}>CHARGES</label>
                                    <label style={{ marginLeft: '13%' }}>CURRENCY</label>
                                    <label style={{ marginLeft: '10%' }}>EXCHANGE RATE</label>
                                    <label style={{ marginLeft: '12%' }}>RATE(%)</label>
                                </div>

                                <div className="form-inline mb-3" hidden={hideinvoiceFright}>
                                    <Col><label className='summury'>Freight </label></Col>
                                    <Col><input type='number' style={{ height: '22px', width: '70%', textAlign: 'center' }} autoFocus
                                        value={BifrctionStsValues.FreightCHARGES} onChange={FreightCHARGESchangehandle} onKeyDown={invoiceTermsFrightChargsKeDown} /></Col>
                                    <Col><select style={{ height: '22px', width: '70%', textAlign: 'center', }} onKeyDown={invoiceTermsFrightCurruncyKeDown}
                                        id='invoiceFrightCurruncy' value={BifrctionStsValues.FreightCURRENCY} onChange={FreightCURRENCYchangehandle}>
                                        <option>{''}</option>{
                                            invoicedetails.map((trns) => (
                                                <option value={trns.currency_code}>{trns.currency_code}</option>
                                            ))}
                                    </select></Col>
                                    <Col><input type='number' style={{ height: '22px', width: '70%', textAlign: 'center' }} onKeyDown={invoiceTermsFrightExchangRateKeDown}
                                        id='invoiceFrightExchngRate' value={BifrctionStsValues.FreightEXCHANGE} onChange={FreightEXCHANGEchangehandle} /></Col>
                                    <Col><input type='number' style={{ height: '22px', width: '70%', textAlign: 'center' }} onKeyDown={invoiceTermsFrightRateKeyDown}
                                        id='InvoiceFrightRate' value={BifrctionStsValues.FreightRATE} onChange={FreightRATEchangehandle} /></Col>
                                </div>

                                <div className="form-inline mb-3" hidden={hideInsurance}>
                                    <Col><label className='summury'>Insurance </label></Col>
                                    <Col><input type='number' style={{ height: '22px', width: '70%', textAlign: 'center' }} onKeyDown={invoiceTermsInsuranceChargesKeyDown}
                                        id='InvoiceInsuranceCharges' value={BifrctionStsValues.InsuranceCHARGES} onChange={InsuranceCHARGESchangehandle} /></Col>
                                    <Col><select style={{ height: '22px', width: '70%', textAlign: 'center' }} onKeyDown={invoiceTermsInsuranceCurruncyKeyDown}
                                        id='InvoiceInsuranceCurruncy' value={BifrctionStsValues.InsuranceCURRENCY} onChange={InsuranceCURRENCYchangehandle}>
                                        <option>{''}</option>{
                                            invoicedetails.map((trns) => (
                                                <option value={trns.currency_code}>{trns.currency_code}</option>
                                            ))}
                                    </select></Col>
                                    <Col><input type='number' style={{ height: '22px', width: '70%', textAlign: 'center' }} onKeyDown={invoiceTermsInsuranceExchangeRateKeyDown}
                                        id='InvoiceInsuranceExchangeRate' value={BifrctionStsValues.InsuranceEXCHANGE} onChange={InsuranceEXCHANGEchangehandle} /></Col>
                                    <Col><input type='number' style={{ height: '22px', width: '70%', textAlign: 'center' }} onKeyDown={invoiceTermsInsuranceRateKeyDown}
                                        id='InvoiceInsuranceRate' value={BifrctionStsValues.InsuranceRATE} onChange={InsuranceRATEchangehandle} /></Col>
                                </div>

                                <div className="form-inline mb-3" hidden={hideAgencyCom}>
                                    <Col><label>Agency Com</label></Col>
                                    <Col><input type='number' style={{ height: '22px', width: '70%', textAlign: 'center' }} onKeyDown={invoiceTermsAgencChargesKeyDown}
                                        id='InvoiceAgencyCharges' value={BifrctionStsValues.AgencyComCHARGES} onChange={AgencyComCHARGESchangehandle} /></Col>
                                    <Col><select style={{ height: '22px', width: '70%', textAlign: 'center' }} onKeyDown={invoiceTermsAgencyCurruncyKeyDown}
                                        id='InvoiceAgencyCurruncy' value={BifrctionStsValues.AgencyComCURRENCY} onChange={AgencyComCURRENCYchangehandle}>
                                        <option>{''}</option>{
                                            invoicedetails.map((trns) => (
                                                <option value={trns.currency_code}>{trns.currency_code}</option>
                                            ))}
                                    </select></Col>
                                    <Col><input type='number' style={{ height: '22px', width: '70%', textAlign: 'center' }} onKeyDown={invoiceTermsAgencyExchangeRateKeyDown}
                                        id='InvoiceAgencyExchangeRate' value={BifrctionStsValues.AgencyComEXCHANGE} onChange={AgencyComEXCHANGEchangehandle} /></Col>
                                    <Col><input type='number' style={{ height: '22px', width: '70%', textAlign: 'center' }} onKeyDown={invoiceTermsAgencyRateKeyDown}
                                        id='invoiceAgencyRate' value={BifrctionStsValues.AgencyComRATE} onChange={AgencyComRATEchangehandle} /></Col>
                                </div>

                                <div className="form-inline mb-3" hidden={hideLoading}>
                                    <Col><label>Loading</label></Col>
                                    <Col><input type='number' style={{ height: '22px', width: '70%', textAlign: 'center' }} onKeyDown={invoiceTermsLoadChargesKeyDown}
                                        id='invoiceLodingCharges' value={BifrctionStsValues.LoadingCHARGES} onChange={LoadingCHARGESchangehandle} /></Col>
                                    <Col><select style={{ height: '22px', width: '70%', textAlign: 'center' }} onKeyDown={invoiceTermsLoadCurruncyKeyDown}
                                        id='InvoiceLoadingCurruncy' value={BifrctionStsValues.LoadingCURRENCY} onChange={LoadingCURRENCYchangehandle}>
                                        <option>{''}</option>{
                                            invoicedetails.map((trns) => (
                                                <option value={trns.currency_code}>{trns.currency_code}</option>
                                            ))}
                                    </select></Col>
                                    <Col><input type='number' style={{ height: '22px', width: '70%', textAlign: 'center' }} onKeyDown={invoiceTermsLoadingExchangeRateKeyDown}
                                        id='InvoiceLoadingExchangeRate' value={BifrctionStsValues.LoadingEXCHANGE} onChange={LoadingEXCHANGEchangehandle} /></Col>
                                    <Col><input type='number' style={{ height: '22px', width: '70%', textAlign: 'center' }} onKeyDown={invoiceTermsLoadingRateKeyDown}
                                        id='invoiceLoadingRate' value={BifrctionStsValues.LoadingRATE} onChange={LoadingRATEchangehandle} /></Col>
                                </div>

                                <div className="form-inline mb-3" hidden={hideMiscValues}>
                                    <Col><label>Misc Values</label></Col>
                                    <Col><input type='number' style={{ height: '22px', width: '70%', textAlign: 'center' }} onKeyDown={invoiceTermsinvoiceMiscChargesKeyDown}
                                        id='InvoiceMiscCharges' value={BifrctionStsValues.MiscValuesCHARGES} onChange={MiscValuesCHARGESchangehandle} /></Col>
                                    <Col><select style={{ height: '22px', width: '70%', textAlign: 'center' }} onKeyDown={invoiceTermsinvoiceMiscCurruncyKeyDown}
                                        id='InvoiceMiscCurruncy' value={BifrctionStsValues.MiscValuesCURRENCY} onChange={MiscValuesCURRENCYchangehandle}>
                                        <option>{''}</option>{
                                            invoicedetails.map((trns) => (
                                                <option value={trns.currency_code}>{trns.currency_code}</option>
                                            ))}
                                    </select></Col>
                                    <Col><input type='number' style={{ height: '22px', width: '70%', textAlign: 'center' }} onKeyDown={invoiceTermsinvoiceMiscExchangeRateKeyDown}
                                        id='InvoiceCurruncyExchangeRate' value={BifrctionStsValues.MiscValuesEXCHANGE} onChange={MiscValuesEXCHANGEchangehandle} /></Col>
                                    <Col><input type='number' style={{ height: '22px', width: '70%', textAlign: 'center' }} onKeyDown={invoiceTermsinvoiceMiscRateKeyDown}
                                        id='InvoiceExchangeRate' value={BifrctionStsValues.MiscValuesRATE} onChange={MisValuesRATEchangehandle} /></Col>
                                </div>

                                <div className="form-inline mb-3" hidden={hideHssValues}>
                                    <Col><label style={{ marginLeft: '-44%' }}>HSS Values</label></Col>
                                    <Col><input type='number' style={{ marginLeft: '-44%', height: '22px', width: '40%', textAlign: 'center' }} onKeyDown={invoiceTermsinvoiceHssValueChargesKeyDown}
                                        id='InvoiceHssValueCharges' value={BifrctionStsValues.HSSValuesCHARGES} onChange={HSSValuesCHARGESchangehandle} /></Col>
                                    <Col><input type='number' style={{ marginLeft: '44%', height: '22px', width: '40%', textAlign: 'center' }} onKeyDown={invoiceTermsinvoiceHssValueRateKeyDown}
                                        id='InvoiceHssValueRate' value={BifrctionStsValues.HSSValuesRATE} onChange={HSSValuesRATEchangehandle} /></Col>
                                </div>
                                <div className="form-inline mb-2" hidden={hideLanding}>
                                    <Col><label style={{ marginLeft: '-64%' }}>Landing</label></Col>
                                    <Col><input type='number' style={{ marginLeft: '64%', height: '22px', width: '26%', textAlign: 'center' }}
                                        id='InvoiceLandingRate' value={BifrctionStsValues.LandingRATE} onChange={LandingValuesRATEchangehandle} /></Col>
                                </div>
                            </div> :
                                ///Autobifrication//
                                <div className='dialogboxcolour'>
                                    <DialogContent style={{ height: '300px' }}>
                                        <div className="form-inline mb-1 mt-1">
                                            <label style={{ marginLeft: '23%' }}>CHARGES</label>
                                            <label style={{ marginLeft: '13%' }}>CURRENCY</label>
                                            <label style={{ marginLeft: '9.5%' }}>EXCHANGE RATE</label>
                                            <label style={{ marginLeft: '11%' }}>RATE(%)</label>
                                        </div>

                                        <div className="form-inline mb-4" hidden={hiddenbifur_frieght}>
                                            <Col><label style={{ marginLeft: '2%', color: 'red', fontWeight: 'bold' }}>Freight Details</label></Col>
                                            <Col><input type='number' style={{ height: '22px', width: '60%', textAlign: 'center' }} onKeyDown={invoiceTermsAutoFrightchrgesKeyDown}
                                                value={BifrctionStsValues.FreightDetailsCHARGES} onChange={FreightDetailsCHARGESchangehandle} /></Col>
                                            <Col><select style={{ height: '22px', width: '60%', textAlign: 'center' }} onKeyDown={invoiceTermsAutoFrightCurruncyKeyDown}
                                                id='InvoiceAutoFrightCurruncy' value={BifrctionStsValues.FreightDetailsCURRENCY} onChange={FreightDetailsCURRENCYchangehandle}>
                                                <option>{''}</option>
                                                {invoicedetails.map((trns) => (
                                                    <option value={trns.currency_code}>{trns.currency_code}</option>
                                                ))}
                                            </select></Col>
                                            <Col><input type='number' value={BifrctionStsValues.FreightDetailsExchange} style={{ height: '22px', width: '60%', textAlign: 'center' }}
                                                disabled /></Col>
                                            <Col><input type='number' style={{ height: '22px', width: '60%', textAlign: 'center' }} onKeyDown={invoiceTermsAutoFrightRateKeyDown}
                                                id='InvoiceAutoFrightRate' value={BifrctionStsValues.FreightDetailsRATE} onChange={FreightDetailsRATEchangehandle} /></Col>
                                        </div>

                                        <div className="form-inline mb-4" hidden={hiddenbifur_insurance}>
                                            <Col><label className='summury'>Insurance Details</label></Col>
                                            <Col><input type='number' style={{ height: '22px', width: '60%', textAlign: 'center' }} onKeyDown={invoiceTermsAutoInsuranceChargeKeyDown}
                                                id='InvoicAutoInsuranceCharges' value={BifrctionStsValues.InsuranceDetailsCHARGES} onChange={InsuranceDetailsCHARGESchangehandle} /></Col>
                                            <Col><select style={{ height: '22px', width: '60%', textAlign: 'center' }} onKeyDown={invoiceTermsAutoInsuranceCurruncyKeyDown}
                                                id='InvoiceAutoInsuranceCurruncy' value={BifrctionStsValues.InsuranceDetailsCURRENCY} onChange={InsuranceDetailsCURRENCYchangehandle}>
                                                <option>{''}</option>{
                                                    invoicedetails.map((trns) => (
                                                        <option value={trns.currency_code}>{trns.currency_code}</option>
                                                    ))}
                                            </select></Col>
                                            <Col><input type='number' value={BifrctionStsValues.InsuranceDetailsExchange} style={{ height: '22px', width: '60%', textAlign: 'center' }}
                                                disabled /></Col>
                                            <Col><input type='number' style={{ height: '22px', width: '60%', textAlign: 'center' }} onKeyDown={invoiceTermsAutoInsuranceRateKeyDown}
                                                id='InvoiceAutoInsuranceRate' value={BifrctionStsValues.InsuranceDetailsRATE} onChange={InsuranceDetailsRATEchangehandle} /></Col>
                                        </div>



                                        <div className="form-inline mb-4" hidden={hiddenbifur_misc}>
                                            <Col><label>Misc Details</label></Col>
                                            <Col><input type='number' style={{ height: '22px', width: '60%', textAlign: 'center' }} onKeyDown={invoiceTermsAutoMiscChargesKeyDown}
                                                id='InvoiceAutoMiscCharges' value={BifrctionStsValues.MiscDetailsCHARGES} onChange={MiscDetailsCHARGESchangehandle} /></Col>
                                            <Col><select style={{ height: '22px', width: '60%', textAlign: 'center' }} onKeyDown={invoiceTermsAutoMiscCurruncyKeyDown}
                                                id='InvoiceAutoMisCurruncy' value={BifrctionStsValues.MiscDetailsCURRENCY} onChange={MiscDetailsCURRENCYchangehandle}>
                                                <option>{''}</option>
                                                {invoicedetails.map((trns) => (
                                                    <option value={trns.currency_code}>{trns.currency_code}</option>))}
                                            </select></Col>
                                            <Col><input type='number' value={BifrctionStsValues.MiscDetailsEXCHANGE} style={{ height: '22px', width: '60%', textAlign: 'center' }}
                                                disabled /></Col>
                                            <Col><input type='number' style={{ height: '22px', width: '60%', textAlign: 'center' }} onKeyDown={invoiceTermsAutoMiscRateKeyDown}
                                                id='InvoiceAutoMiscRate' value={BifrctionStsValues.MiscDetailsRATE} onChange={MiscDetailsRATEchangehandle} /></Col>
                                        </div>

                                        <div className="form-inline mb-3" hidden={hiddenbifur_agencycomn}>
                                            <Col><label>Agency Comn</label></Col>
                                            <Col><input type='number' style={{ height: '22px', width: '60%', textAlign: 'center' }} onKeyDown={invoiceTermsAutoAgencyChargesKeyDown}
                                                id='InvoiceAutoAgencyCharges' value={BifrctionStsValues.AgencyCommCHARGES} onChange={AgencyCommCHARGESchangehandle} /></Col>
                                            <Col><select style={{ height: '22px', width: '60%', textAlign: 'center' }} onKeyDown={invoiceTermsAutoAgencyCurruncyKeyDown}
                                                id='InvoiceAutoAgencyCurrunhcy' value={BifrctionStsValues.AgencyCommCURRENCY} onChange={AgencyCommCURRENCYchangehandle}>
                                                <option>{''}</option>
                                                {invoicedetails.map((trns) => (
                                                    <option value={trns.currency_code}>{trns.currency_code}</option>))}
                                            </select></Col>
                                            <Col><input type='number' value={BifrctionStsValues.AgencycommDetailsExchange} style={{ height: '22px', width: '60%', textAlign: 'center' }}
                                                disabled /></Col>
                                            <Col><input type='number' style={{ height: '22px', width: '60%', textAlign: 'center' }} onKeyDown={invoiceTermsAutoAgencyRateKeyDown}
                                                id='InvoiceAutoAutoAgencyrate' value={BifrctionStsValues.AgencyCommRATE} onChange={AgencyCommRATEchangehandle} /></Col>
                                        </div>
                                        <div className=" mt-2">
                                            <center>
                                                <Button size='small' variant="contained" color="primary" onClick={InvoiceAutoBifr_Update}>{InvoiceProcsUpd ? 'processing' : 'Update'}</Button>{' '}
                                            </center>
                                        </div>
                                    </DialogContent>
                                </div>}

                        </Dialog>
                        <Dialog open={InvoiceSvbLoadingopen} onClose={InvoiceSvbLoadingkeyhandleClose} fullWidth={true} maxWidth='lg'>
                            <DialogTitle align='center' className="dialogboxtitlecolour p-1" >
                                Add SVB Loading Details
                            </DialogTitle >
                            {/* style={{backgroundColor:'lightgreen'}} */}
                            <div className='dialogboxcolour'>
                                <Container className="mb-2 mt-4">
                                    <div className="mb-2 form-inline">

                                        <label >SVB_ReferenceNo</label>
                                        <input type="text" className="hi22 ml-1 mr-2" style={{ textTransform: 'uppercase', width: '16%', textAlign: 'center' }} autoFocus
                                            value={dialoginvoicevalues.SVBReferenceNo} onChange={InvoiceSVBReferenceNoChangeHandle} onKeyDown={invoiceSvbRefnokeyup} id={'invoiceSvbRef'} />
                                        <label>SVB_Date</label>
                                        <input type="Date" className=" hi22 ml-1 mr-2" style={{ textTransform: 'uppercase', width: '13%', textAlign: 'center' }}
                                            value={dialoginvoicevalues.SVBDate} onChange={InvoiceSVBDateChangeHandle} onKeyDown={invoiceSvbdatekeyup} id={'invoicesvbdate'} />
                                        <label>Custom_House_Code</label>
                                        <input type="text" className="hi22 wid15 ml-2" style={{ textTransform: 'uppercase', textAlign: 'center' }}
                                            value={dialoginvoicevalues.CustomHouseCode} onChange={InvoiceCustomHouseCodeChangeHandle} onKeyDown={Invoicesvb_custom_hus_cd_keyup} id={'invoicesvbCHC'} />
                                        <button className="searchbutton  mr-1" onClick={InvoiceCustomHouseCodehandleClickOpen} >
                                            <Search fontSize="small" /></button>
                                        <label>SVB_Type(A/D/B)</label>
                                        <input type="text" className="hi22 ml-1 mr-2" style={{ textTransform: 'uppercase', width: '7%', textAlign: 'center' }}
                                            value={dialoginvoicevalues.SVBType} onChange={InvoiceSVBTypeChangeHandle} onKeyDown={invoiceSvbTypkeyup} id={'invoicesvbTyp'} />
                                    </div>
                                    <div className="mb-2 mt-3 form-inline">
                                        <label hidden={invoiceSvb_AV_Hidn}>SVB_Load_Assable_Value_percentage</label>
                                        <input type="number" className="input ml-1 mr-2 hi22" style={{ textTransform: 'uppercase', width: '5%', textAlign: 'center' }}
                                            value={dialoginvoicevalues.SVB_Load_Assable_Value_percentage}
                                            onChange={InvoiceSVB_Load_Assable_Value_percentageChangeHandle} hidden={invoiceSvb_AV_Hidn} onKeyDown={invoiceSvbASPrnctkeyup} id={'invoicesvbASPrnct'} />
                                        <label hidden={invoiceSvb_duty_Hidn}>SVB_Load_Duty_Percentage</label>
                                        <input type="number" className="input ml-1 mr-2 hi22" style={{ textTransform: 'uppercase', width: '5%', textAlign: 'center' }}
                                            value={dialoginvoicevalues.SVB_Load_Duty_Percentage} onChange={InvoiceSVB_Load_Duty_PercentageChangeHandle} onKeyDown={invoiceSvbDutyPrcntkeyup}
                                            hidden={invoiceSvb_duty_Hidn} id={'invoicesvbDutyPrcnt'} />
                                        <label hidden={invoiceSvb_AV_Hidn}>Av_is_Final_or_Provisional</label>
                                        <input type="text" className="input ml-1 mr-2 hi22" style={{ textTransform: 'uppercase', width: '5%', textAlign: 'center' }}
                                            value={dialoginvoicevalues.Av_is_Final_or_Provisional} onChange={InvoiceAv_is_Final_or_ProvisionalChangeHandle}
                                            onKeyDown={invoiceSvbAVfinlkeyup} hidden={invoiceSvb_AV_Hidn} id={'invoicesvbAVfinl'} />
                                        <label hidden={invoiceSvb_duty_Hidn}>Duty_is_Final_or_Provisional</label>
                                        <input type="text" className="input ml-1 mr-2 hi22" style={{ textTransform: 'uppercase', width: '5%', textAlign: 'center' }}
                                            value={dialoginvoicevalues.Duty_is_Final_or_Provisional} onChange={InvoiceDuty_is_Final_or_ProvisionalChangeHandle}
                                            onKeyDown={invoiceSvbdutyfinlkeyup} hidden={invoiceSvb_duty_Hidn} id={'invoicesvbDutyFinl'} />
                                    </div>
                                </Container>
                                <Grid item container direction="row" justifyContent="center" alignItems="center" className="mb-2" >
                                    <div><Button size='small' variant="contained" color="primary" className='mr-1' disabled={InvoiceSaveDsa} onClick={InvoiceSvbSave} id={'invoicesvbsave'}>{InvoiceProcsSve ? 'processing' : 'Save'}</Button>{' '}</div>
                                    <div><Button size='small' variant="contained" color="primary" className='mr-1' disabled={InvoiceUpdateDsa} onClick={InvoiceSvbUpdate} id={'invoicesvbUpdate'}>{InvoiceProcsUpd ? 'processing' : 'Update'}</Button>{' '}</div>
                                    <div><Button size='small' variant="contained" color="primary" className='mr-1' disabled={InvoiceDeleteDsa} onClick={InvoiceSvbDelete}>{InvoiceProcsDlt ? 'Processing' : 'Delete'}</Button>{' '}</div>
                                    <div><Button size='small' variant="contained" color="primary" onKeyDown={invoiceSvbDetailsRefkeyup} onClick={InvoiceSvbReset}>Refresh</Button>{' '}</div>
                                </Grid >
                            </div>
                            <TableContainer className={classes.container}>
                                <Table stickyHeader className="table-bordered">
                                    <TableHead>
                                        <StyledTableRow>
                                            <StyledTableCell align='center' className="p-1">Sl</StyledTableCell>
                                            <StyledTableCell align='center' style={{ width: '13%' }} className="p-1">InvoiceNo</StyledTableCell>
                                            <StyledTableCell align='center' className="p-1">SVB_ReferenceNo</StyledTableCell>
                                            <StyledTableCell align='center' style={{ width: '10%' }} className="p-1">SVB_Date</StyledTableCell>
                                            <StyledTableCell align='center' className="p-1">CustomHouseCode</StyledTableCell>
                                            <StyledTableCell align='center' style={{ width: '5%' }} className="p-1">LoadOnType</StyledTableCell>
                                            <StyledTableCell align='center' style={{ width: '5%' }} className="p-1">LoadAssableValue</StyledTableCell>
                                            <StyledTableCell align='center' style={{ width: '5%' }} className="p-1">LoadDutyPercentage</StyledTableCell>
                                            <StyledTableCell align='center' className="p-1">AvFinalOrProvisional</StyledTableCell>
                                            <StyledTableCell align='center' className="p-1">DutyFinalOrProvisional</StyledTableCell>
                                        </StyledTableRow>
                                    </TableHead>
                                    <TableBody>
                                        {
                                            invoicedetails.map((trns) => { const selectedItem = isInvoiceTblSelected(trns.svbRefNo);
                                                return(
                                                    <TableRow hover key={trns.serialNumber} onClick={() => EditInvoiceSVBDetails(trns)} id='invoiceSVPLoadingTblDetails_id'
                                                    tabIndex={-1} onKeyDown={(e)=>InvoicDetailsTbleKeyDown(e,'SVPLoading')} selected={selectedItem}>
                                                        <TableCell align='center'>{trns.serialNumber}</TableCell>
                                                        <TableCell align='center'>{trns.invoiceNumber}</TableCell>
                                                        <TableCell align='center'>{trns.svbRefNo}</TableCell>
                                                        <TableCell align='center'>{trns.svbDate}</TableCell>
                                                        <TableCell align='center'>{trns.cusHouseCode}</TableCell>
                                                        <TableCell align='center'>{trns.loadType}</TableCell>
                                                        <TableCell align='center'>{trns.assablePerc}</TableCell>
                                                        <TableCell align='center'>{trns.dutyPerc}</TableCell>
                                                        <TableCell align='center'>{trns.avFinal}</TableCell>
                                                        <TableCell align='center'>{trns.dutyFinal}</TableCell>
                                                    </TableRow>
                                                )})}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Dialog>
                        <Dialog open={InvoiceCustomHouseCodeopen} onClose={InvoiceCustomHouseCodehandleClose} fullWidth={true}>
                            <DialogTitle align='center' className="dialogboxtitlecolour p-1">
                                Custom House Details
                            </DialogTitle><div className='dialogboxcolour'>
                                <div style={{ marginLeft: '22%' }}><Container className="mt-4 mb-2">
                                    <Row className="mb-1">
                                        <div className="form-inline ml-3" style={{ width: "90%", marginLeft: "4rem" }} size="sm">
                                            <label className="dialogfont">Find CusHouse Name</label>
                                            <input type="text" className="input ml-1" style={{ textTransform: 'uppercase', textAlign: 'center' }}
                                                value={dialoginvoicevalues.FindCusHouseName} onChange={InvoiceFindCusHouseNameChangeHandle}></input>
                                        </div>
                                    </Row>
                                    <Row>
                                        <div className="form-inline mt-1 ml-3" style={{ width: "90%", marginLeft: "6rem" }} size="sm">
                                            <label className="dialogfont">Find CusHouse Code</label>
                                            <input type="text" className="input ml-2 mb-1" style={{ textTransform: 'uppercase', textAlign: 'center' }} autoFocus onKeyDown={invoiceCusHousCodekeyup}
                                                value={dialoginvoicevalues.FindCusHouseCode} onChange={InvoiceFindCusHouseCodeChangeHandle}></input>
                                        </div>
                                    </Row></Container>
                                </div>
                            </div>
                            <TableContainer className={classes.container}>
                                <Table stickyHeader aria-label="table" size="small" >
                                    <TableHead>
                                        <StyledTableRow>
                                            <StyledTableCell align='center'>CusHouse Code</StyledTableCell>
                                            <StyledTableCell align='center'>CusHouse Name</StyledTableCell>
                                        </StyledTableRow>
                                    </TableHead>
                                    <TableBody>
                                        {
                                            invoicedetails2.map((trns) => { const selectedItem = isInvoiceTblSelected(trns.customHouseCode);
                                                return(
                                                    <TableRow hover key={trns.customHouseCode} onClick={() => editinvoicecustomcode(trns)} id='invoiceCusHusDetailsTblDetails_id'
                                                    tabIndex={-1} onKeyDown={(e)=>InvoicDetailsTbleKeyDown(e,'InvoiceCustHusDet')} selected={selectedItem}>
                                                        <TableCell align='center'>{trns.customHouseCode}</TableCell>
                                                        <TableCell align='center'>{trns.customHouseLocation}</TableCell>
                                                    </TableRow>
                                                )})}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Dialog>
                        <Dialog maxWidth='md' fullWidth={true} open={InvoiceThirdPartyopen} onClose={InvoiceThirdPartyhandleClose}>
                            <DialogTitle align="center" className="dialogboxtitlecolour p-1">
                                Add ThirdParty Details
                            </DialogTitle>
                            <div className='dialogboxcolour'>
                                <Container>
                                    <Row className="mb-2" >
                                        <div className='form-inline mt-2'>
                                            <label className="dialogfont">ThirdPartyName</label>

                                            <input className="hi22 ml-1" style={{ textTransform: 'uppercase', textAlign: 'center' }}
                                                value={dialoginvoicevalues.ThirdPartyName} onChange={InvoiceThirdPartyNameChangeHandle}
                                                onKeyDown={InvoiceThirdpartydailogname_keyup} autoFocus id={'invoiceTPnameId'} />
                                            <button className="searchbutton mr-2" onClick={InvoiceThirdPartyNameClickOpen}
                                            ><Search fontSize="small" /></button>
                                            <label className="dialogfont">Country</label>
                                            <select className="hi22 wid12 mr-2 ml-1" style={{ textTransform: 'uppercase' }}
                                                value={dialoginvoicevalues.ThirdPartyCountry} onChange={InvoiceThirdPartyCountryChangeHandle} onKeyDown={invoiceTPcntrykeyup} id={'invoiceTPcntry'} >
                                                <option>{''}</option>{
                                                    invoiceCountryntDrp.map((trns) => (
                                                        <option value={trns.countryName}>{trns.countryName}</option>
                                                    ))}
                                            </select>
                                            <label className="dialogfont mr-1">Address</label>
                                            <textarea style={{ width: '15rem', height: '3.8rem', textTransform: 'uppercase', textAlign: 'center' }}
                                                value={dialoginvoicevalues.ThirdPartyAddress} onChange={InvoiceThirdPartyAddressChangeHandle} onKeyDown={invoiceTPAdreskeyup} id={'invoiceTPadrs'}>
                                            </textarea>
                                        </div>

                                    </Row>
                                    <div className="mb-2 form-inline">

                                        <label className="dialogfont">ThirdPartyCity</label>
                                        <input type="text" className="hi22 ml-3 " style={{ textTransform: 'uppercase', marginRight: '5%', textAlign: 'center' }}
                                            value={dialoginvoicevalues.ThirdPartyCity} onChange={InvoiceThirdPartyCityChangeHandle} onKeyDown={invoiceTPCitykeyup} id={'invoiceTPCity'} />

                                        <label className="dialogfont">Pincode</label>
                                        <input type="text" className="hi22 wid12 ml-1 mr-2" style={{ textTransform: 'uppercase', textAlign: 'center' }}
                                            value={dialoginvoicevalues.ThirdPartyPincode} onChange={InvoiceThirdPartyPincodeChangeHandle} onKeyDown={invoiceTPPincdkeyup} id={'invoiceTPpincd'} />

                                        <label className="dialogfont">Division</label>
                                        <input type="text" className="hi22 wid12 ml-1 mr-2" style={{ textTransform: 'uppercase', textAlign: 'center' }}
                                            value={dialoginvoicevalues.ThirdPartyDivision} onChange={InvoiceThirdPartyDivisionChangeHandle} onKeyDown={invoiceTPDivsnkeyup} id={'invoiceDiv'} />
                                    </div>
                                </Container>
                                <Grid item container direction="row" justifyContent="center" alignItems="center" className="mb-2" >

                                    <div><Button size='small' variant="contained" color="primary" className='mr-1' disabled={InvoiceSaveDsa} onClick={InvoiceThirdPartySave} id={'invoiceTPsave'}>{InvoiceProcsSve ? 'Processing' : 'Save'}</Button>{' '}</div>
                                    <div><Button size='small' variant="contained" color="primary" className='mr-1' disabled={InvoiceUpdateDsa} onClick={InvoiceThirdPartyUpdate} id={'invoiceTPUpdate'}>{InvoiceProcsUpd ? 'Processing' : 'Update'}</Button>{' '}</div>
                                    <div><Button size='small' variant="contained" color="primary" className='mr-1' disabled={InvoiceDeleteDsa} onClick={InvoiceThirdPartyDelete}>{InvoiceProcsDlt ? 'Processing' : 'Delete'}</Button>{' '}</div>
                                    <div><Button size='small' variant="contained" color="primary" onKeyDown={invoiceTP_RefBtnkeyup} onClick={InvoiceThirdPartyReset}>Refresh</Button>{' '}</div>
                                </Grid >
                            </div>
                            <TableContainer className={classes.container}>
                                <Table stickyHeader className="table-bordered">
                                    <TableHead>
                                        <StyledTableRow>
                                            <StyledTableCell align='center' className="p-1">Sl</StyledTableCell>
                                            <StyledTableCell align='center' className="p-1">InvoiceNo</StyledTableCell>
                                            <StyledTableCell align='center' className="p-1">ThirdPartyName</StyledTableCell>
                                            <StyledTableCell align='center' className="p-1">ThirdPartyCity</StyledTableCell>
                                            <StyledTableCell align='center' className="p-1">ThirdPartyCountry</StyledTableCell>
                                            <StyledTableCell align='center' className="p-1">ThirdPartyPincode</StyledTableCell>
                                            <StyledTableCell align='center' className="p-1">ThirdPartyDivision</StyledTableCell>
                                            <StyledTableCell align='center' className="p-1">ThirdPartyAddress</StyledTableCell>
                                        </StyledTableRow>
                                    </TableHead>
                                    <TableBody>
                                        {
                                            invoicedetails.map((trns) => { const selectedItem = isInvoiceTblSelected(trns.name);
                                                return(
                                                    <TableRow hover key={trns.name} onClick={() => editInvoiceThirdparty(trns)} id='invoicThirdPartyDtailsTblDetails_id'
                                                    tabIndex={-1} onKeyDown={(e)=>InvoicDetailsTbleKeyDown(e,'ThirdParty')} selected={selectedItem}>
                                                        <TableCell align='center'>{trns.serialNumber}</TableCell>
                                                        <TableCell align='center'>{trns.invoiceNumber}</TableCell>
                                                        <TableCell align='center'>{trns.name}</TableCell>
                                                        <TableCell align='center'>{trns.city}</TableCell>
                                                        <TableCell align='center'>{trns.countryName}</TableCell>
                                                        <TableCell align='center'>{trns.pincode}</TableCell>
                                                        <TableCell align='center'>{trns.division}</TableCell>
                                                        <TableCell align='center'>{trns.address}</TableCell>
                                                    </TableRow>
                                                )})}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Dialog>
                        <Dialog open={InvoiceThirdPartyNameopen} onClose={InvoiceThirdPartyNamehandleClose} fullWidth={true} maxWidth='md'>
                            <DialogTitle align='center' className="dialogboxtitlecolour p-1">Supplier Details</DialogTitle>
                            <div className='dialogboxcolour'>
                                <Container className="mb-2 mt-3">
                                    <div style={{ marginLeft: '30%' }}>
                                        <label className="dialogfont">Find Supplier Name</label>
                                        <input type="text" className="input ml-2" style={{ textTransform: 'uppercase', textAlign: 'center' }} autoFocus onKeyDown={InvoiceDialogThirdPartySupplierNameKeyDown}
                                            value={dialoginvoicevalues.FindSupplierNameDialog} onChange={InvoiceFindSupplierNameDialogChangeHandle} />
                                    </div>
                                </Container>
                            </div>
                            <TableContainer className={classes.container}>
                                <Table stickyHeader aria-label="table">
                                    <TableHead>
                                        <StyledTableRow>
                                            <StyledTableCell className='p-1' align='center'>Name</StyledTableCell>
                                            <StyledTableCell className='p-1' align='center'>Address 1</StyledTableCell>
                                            <StyledTableCell className='p-1' align='center'>Address 2</StyledTableCell>
                                            <StyledTableCell className='p-1' align='center'>Pincode</StyledTableCell>
                                            <StyledTableCell className='p-1' align='center'>Country Name</StyledTableCell>
                                        </StyledTableRow>
                                    </TableHead>
                                    <TableBody>
                                        {
                                            invoicedetails2.map((trns) => { const selectedItem = isInvoiceTblSelected(trns.supplierName);
                                                return(
                                                    <TableRow hover key={trns.supplierName} onClick={() => editInvoicethirdpartyname(trns)} id='invoiceThirdPartySuplierNameTblDetails_id'
                                                    tabIndex={-1} onKeyDown={(e)=>InvoicDetailsTbleKeyDown(e,'ThirdPartySuplierName')} selected={selectedItem}>
                                                        <TableCell align='center'>{trns.supplierName}</TableCell>
                                                        <TableCell align='center'>{trns.supplierAddress1}</TableCell>
                                                        <TableCell align='center'>{trns.supplierAddress2}</TableCell>
                                                        <TableCell align='center'>{trns.supplierPincode}</TableCell>
                                                        <TableCell align='center'>{trns.supplierCountryName}</TableCell>
                                                    </TableRow>
                                                )})}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Dialog>
                        <Dialog maxWidth='md' fullWidth={true} open={InvoiceSelleropen} onClose={InvoiceSellerhandleClose}>
                            <DialogTitle align='center' className="dialogboxtitlecolour p-1">
                                Add Seller Details
                            </DialogTitle>
                            <div className='dialogboxcolour'>
                                <Container>
                                    <Row>
                                        <div className="form-inline mt-3 mb-2">
                                            <label className="dialogfont">Seller Name</label>
                                            <input type="text" className="ml-1 hi22 mr-2" style={{ textTransform: 'uppercase', textAlign: 'center' }}
                                                value={dialoginvoicevalues.SellerName} onChange={InvoiceSellerNameChangeHandle} onKeyDown={invoicesellernmkeyup} autoFocus />

                                            <label className="dialogfont">Seller Country</label>
                                            <select className="ml-1 mr-2 hi22 wid12" style={{ textTransform: 'uppercase' }}
                                                value={dialoginvoicevalues.SellerCountry} onChange={InvoiceSellerCountryChangeHandle} onKeyDown={invoicesellercntrykeyup} id={'invoicesellercntry'}>
                                                <option value={''}></option>
                                                {invoiceCountryntDrp.map((trns) => (
                                                    <option value={trns.countryIdString}>{trns.countryName}</option>
                                                ))}
                                            </select>
                                            <label className="dialogfont">Seller Address</label>
                                            <textarea type="text" className="ml-1" style={{ textTransform: 'uppercase', textAlign: 'center', width: '15rem', height: '3.8rem' }}
                                                value={dialoginvoicevalues.SellerAddress} onChange={InvoiceSellerAddressChangeHandle} onKeyDown={invoiceselleradrskeyup} id={'invoiceselleradrs'}> </textarea>

                                        </div>
                                    </Row>
                                    <Row className="mb-2">
                                        <div className="form-inline">
                                            <label className="dialogfont">Seller City</label>
                                            <input type="text" className="ml-3 hi22 mr-2" style={{ textTransform: 'uppercase', textAlign: 'center' }}
                                                value={dialoginvoicevalues.SellerCity} onChange={InvoiceSellerCityChangeHandle} onKeyDown={invoicesellercitykeyup} id={'invoicesellercity'} />



                                            <label className="dialogfont">Seller Pincode</label>
                                            <input type="text" className="ml-1 hi22 mr-2" style={{ textTransform: 'uppercase', textAlign: 'center' }}
                                                value={dialoginvoicevalues.SellerPincode} onChange={InvoiceSellerPincodeChangeHandle} onKeyDown={invoicesellerpncdkeyup} id={'invoicesellerpncd'} />



                                            <label className="dialogfont">Seller Division</label>
                                            <input type="text" className="ml-1 hi22" style={{ textTransform: 'uppercase', textAlign: 'center' }}
                                                value={dialoginvoicevalues.SellerDivision} onChange={InvoiceSellerDivisionChangeHandle} onKeyDown={invoicesellerdivkeyup} id={'invoicesellerdiv'} />
                                        </div>
                                    </Row>

                                </Container>
                                <Grid item container direction="row" justifyContent="center" alignItems="center" className="mb-2 mt-2">
                                    <div><Button size='small' variant="contained" color="primary" className='mr-1' disabled={InvoiceSaveDsa} onClick={InvoiceSellerSave} id={'invoicesellersaveid'}>{InvoiceProcsSve ? 'Processing' : 'Save'}</Button>{' '}</div>
                                    <div><Button size='small' variant="contained" color="primary" className='mr-1' disabled={InvoiceUpdateDsa} onClick={InvoiceSellerUpdate} id={'invoicesellerupdateid'}>{InvoiceProcsUpd ? 'Processing' : 'Update'}</Button>{' '}</div>
                                    <div><Button size='small' variant="contained" color="primary" className='mr-1' disabled={InvoiceDeleteDsa} onClick={InvoiceSellerDelete}>{InvoiceProcsDlt ? 'Processing' : 'Delete'}</Button>{' '}</div>
                                    <div><Button size='small' variant="contained" color="primary" onKeyDown={invoicesellerRefBtnKeyup} onClick={InvoiceSellerReset}>Refresh</Button>{' '}</div>
                                </Grid >
                            </div>
                            <TableContainer className={classes.container}>
                                <Table stickyHeader className="table-bordered">
                                    <TableHead>
                                        <StyledTableRow>
                                            <StyledTableCell align='center' className="p-1">Sl</StyledTableCell>
                                            <StyledTableCell align='center' className="p-1">InvoiceNo</StyledTableCell>
                                            <StyledTableCell align='center' className="p-1">SellerName</StyledTableCell>
                                            <StyledTableCell align='center' className="p-1">SellerCity</StyledTableCell>
                                            <StyledTableCell align='center' className="p-1">SellerCountry</StyledTableCell>
                                            <StyledTableCell align='center' className="p-1">SellerPincode</StyledTableCell>
                                            <StyledTableCell align='center' className="p-1">SellerDivision</StyledTableCell>
                                            <StyledTableCell align='center' className="p-1">SellerAddress</StyledTableCell>
                                        </StyledTableRow>
                                    </TableHead>
                                    <TableBody>
                                        {
                                            invoicedetails.map((trns) => { const selectedItem = isInvoiceTblSelected(trns.name);
                                                return(
                                                    <TableRow hover key={trns.city} onClick={() => editInvoiceSellerdetails(trns)} id='invoicesellerTblDetails_id'
                                                    tabIndex={-1} onKeyDown={(e)=>InvoicDetailsTbleKeyDown(e,'sellerdetails')} selected={selectedItem}>
                                                        <TableCell align='center'>{trns.serialNumber}</TableCell>
                                                        <TableCell align='center'>{trns.invoiceNumber}</TableCell>
                                                        <TableCell align='center'>{trns.name}</TableCell>
                                                        <TableCell align='center'>{trns.city}</TableCell>
                                                        <TableCell align='center'>{trns.countryName}</TableCell>
                                                        <TableCell align='center'>{trns.pincode}</TableCell>
                                                        <TableCell align='center'>{trns.division}</TableCell>
                                                        <TableCell align='center'>{trns.address}</TableCell>
                                                    </TableRow>
                                                )})}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Dialog >
                        <Dialog open={InvoiceBrokeropen} onClose={InvoiceBrokerhandleClose} maxWidth='md' fullWidth={true}>
                            <DialogTitle align='center' className="dialogboxtitlecolour p-1">
                                Add Broker Details
                            </DialogTitle>
                            <div className='dialogboxcolour'>
                                <Container>
                                    <Row>
                                        <div className="form-inline mt-3 mb-2">
                                            <label className="dialogfont">Broker Name</label>
                                            <input type="text" className="ml-1 mr-2" style={{ textTransform: 'uppercase', textAlign: 'center' }}
                                                autoFocus value={dialoginvoicevalues.BrokerName} onChange={InvoiceBrokerNameChangeHandle} onKeyDown={invoiceBrokernmkeyup} />

                                            <label className="dialogfont">Broker Country</label>
                                            <select type="text" className="hi22 wid12 ml-1 mr-2" style={{ textTransform: 'uppercase', textAlign: 'center' }}
                                                value={dialoginvoicevalues.BrokerCountry} onChange={InvoiceBrokerCountryChangeHandle} onKeyDown={invoiceBrokercntrykeyup} id={'invoiceBrokercntry'}>
                                                <option value={''}></option>
                                                {invoiceCountryntDrp.map((trns) => (
                                                    <option value={trns.countryIdString}>{trns.countryName}</option>
                                                ))}
                                            </select>

                                            <label className="dialogfont">Broker Address</label>
                                            <textarea type="text" className="ml-1" style={{ textTransform: 'uppercase', textAlign: 'center', width: '14rem', height: '3.8rem' }}
                                                value={dialoginvoicevalues.BrokerAddress} onChange={InvoiceBrokerAddressChangeHandle} onKeyDown={invoiceBrokeradrskeyup} id={'invoiceBrokeradrs'}></textarea>
                                        </div>

                                    </Row >
                                    <Row className="mb-2">
                                        <div className="form-inline">
                                            <label className="dialogfont">Broker City</label>
                                            <input type="text" className="ml-4 mr-2" style={{ textTransform: 'uppercase', textAlign: 'center' }}
                                                value={dialoginvoicevalues.BrokerCity} onChange={InvoiceBrokerCityChangeHandle} onKeyDown={invoiceBrokercitykeyup} id={'invoiceBrokercity'} />

                                            <label className="dialogfont">Broker Pincode</label>
                                            <input type="text" className="ml-1 mr-2" style={{ textTransform: 'uppercase', textAlign: 'center' }}
                                                value={dialoginvoicevalues.BrokerPincode} onChange={InvoiceBrokerPincodeChangeHandle} onKeyDown={invoiceBrokerpncdkeyup} id={'invoiceBrokerpncd'} />

                                            <label className="dialogfont">Broker Division</label>
                                            <input type="text" className="ml-1" style={{ textTransform: 'uppercase', textAlign: 'center' }}
                                                value={dialoginvoicevalues.BrokerDivision} onChange={InvoiceBrokerDivisionChangeHandle} onKeyDown={invoiceBrokerdivkeyup} id={'invoiceBrokerdiv'} />
                                        </div>
                                    </Row>
                                </Container >
                                <Grid item container direction="row" justifyContent="center" alignItems="center" className="mb-2 mt-2">
                                    <div><Button size='small' variant="contained" color="primary" className='mr-1' disabled={InvoiceSaveDsa} onClick={InvoiceBrokerSave} id={'invoicebrokersaveid'}>{InvoiceProcsSve ? 'Processing' : 'Save'}</Button>{' '}</div>
                                    <div><Button size='small' variant="contained" color="primary" className='mr-1' disabled={InvoiceUpdateDsa} onClick={InvoiceBrokerUpdate} id={'invoicebrokerupdateid'}>{InvoiceProcsUpd ? 'Processing' : 'Update'}</Button>{' '}</div>
                                    <div><Button size='small' variant="contained" color="primary" className='mr-1' disabled={InvoiceDeleteDsa} onClick={InvoiceBrokerDelete}>{InvoiceProcsDlt ? 'Processing' : 'Delete'}</Button>{' '}</div>
                                    <div><Button size='small' variant="contained" color="primary" onKeyDown={invoiceBrokerRefBtnkeyup} onClick={InvoiceBrokerReset}>Refresh</Button>{' '}</div>
                                </Grid >
                            </div>
                            <TableContainer className={classes.container}>
                                <Table stickyHeader className="table-bordered">
                                    <TableHead>
                                        <StyledTableRow>
                                            <StyledTableCell align='center' className="p-1">Sl</StyledTableCell>
                                            <StyledTableCell align='center' className="p-1">InvoiceNo</StyledTableCell>
                                            <StyledTableCell align='center' className="p-1">BrokerName</StyledTableCell>
                                            <StyledTableCell align='center' className="p-1">BrokerCity</StyledTableCell>
                                            <StyledTableCell align='center' className="p-1">BrokerCountry</StyledTableCell>
                                            <StyledTableCell align='center' className="p-1">BrokerPincode</StyledTableCell>
                                            <StyledTableCell align='center' className="p-1">BrokerDivision</StyledTableCell>
                                            <StyledTableCell align='center' className="p-1">ThirdPartyAdress</StyledTableCell>
                                        </StyledTableRow>
                                    </TableHead>
                                    <TableBody>
                                        {
                                            invoicedetails.map((trns) => { const selectedItem = isInvoiceTblSelected(trns.name);
                                                return(
                                                    <TableRow hover key={trns.serialNumber} onClick={() => editInvoiceBrokerdetails(trns)} id='invoiceBrokerTblDetails_id'
                                                    tabIndex={-1} onKeyDown={(e)=>InvoicDetailsTbleKeyDown(e,'BrokerDetails')} selected={selectedItem}>
                                                        <TableCell align='center'>{trns.serialNumber}</TableCell>
                                                        <TableCell align='center'>{trns.invoiceNumber}</TableCell>
                                                        <TableCell align='center'>{trns.name}</TableCell>
                                                        <TableCell align='center'>{trns.city}</TableCell>
                                                        <TableCell align='center'>{trns.countryName}</TableCell>
                                                        <TableCell align='center'>{trns.pincode}</TableCell>
                                                        <TableCell align='center'>{trns.division}</TableCell>
                                                        <TableCell align='center'>{trns.address}</TableCell>
                                                    </TableRow>
                                                )})}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Dialog >
                        <Dialog open={InvoiceAddDiscountDetailsopen} onClose={InvoiceAddDiscountDetailshandleClose} maxWidth='md' fullWidth={true}>
                            <DialogTitle align='center' className="dialogboxtitlecolour p-1">
                                Add Discount Details
                            </DialogTitle>
                            <div className='dialogboxcolour'>
                                <Container>
                                    <div className="form-inline mt-3">

                                        <label className="dialogfont">Nature of Discount</label>
                                        <input type='number' className=' ml-1 mr-1' style={{ textTransform: 'uppercase', textAlign: 'center' }} autoFocus
                                            value={dialoginvoicevalues.NatureofDiscount} onChange={InvoiceNatureofDiscountChangeHandle} onKeyDown={invoiceDisct_natrkeyup} />

                                        <label className="dialogfont">Discount Rate</label>
                                        <input type='number' className=' ml-1 mr-1' style={{ textTransform: 'uppercase', textAlign: 'center' }}
                                            value={dialoginvoicevalues.DiscountRate} onChange={InvoiceDiscountRateChangeHandle} onKeyDown={invoiceDisct_ratekeyup} id={'invoiceDiscntrate'} />

                                        <label className="dialogfont">Discount Amount</label>
                                        <input type='number' className=' ml-1' style={{ textTransform: 'uppercase', textAlign: 'center' }}
                                            value={dialoginvoicevalues.DiscountAmount} onChange={InvoiceDiscountAmountChangeHandle} onKeyDown={invoiceDisct_amntkeyup} id={'invoiceDiscntamnt'} />

                                    </div>
                                </Container>
                                <Grid item container direction="row" justifyContent="center" alignItems="center" className="mb-2 mt-2" >

                                    <div><Button size='small' variant="contained" color="primary" className='mr-1' disabled={InvoiceSaveDsa} onClick={InvoiceDiscount_dtlsSave} id={'invoiceDiscntSaveId'}>{InvoiceProcsSve ? 'Processing' : 'Save'}</Button>{' '}</div>
                                    <div><Button size='small' variant="contained" color="primary" className='mr-1' disabled={InvoiceUpdateDsa} onClick={InvoiceDiscount_dtlsUpdate} id={'invoiceDiscntUpdateId'}>{InvoiceProcsUpd ? 'Processing' : 'Update'}</Button>{' '}</div>
                                    <div><Button size='small' variant="contained" color="primary" className='mr-1' disabled={InvoiceDeleteDsa} onClick={InvoiceDiscount_dtlsDelete}>{InvoiceProcsDlt ? 'Processing' : 'Delete'}</Button>{' '}</div>
                                    <div><Button size='small' variant="contained" color="primary" onKeyDown={invoiceDisct_RefBtnkeyup} onClick={InvoiceDiscount_dtlsReset}>Refresh</Button>{' '}</div>
                                </Grid >
                            </div>
                            <TableContainer className={classes.container}>
                                <Table stickyHeader className="table-bordered">
                                    <TableHead>
                                        <StyledTableRow>
                                            <StyledTableCell align='center' className="p-1">Sl</StyledTableCell>
                                            <StyledTableCell align='center' className="p-1">Invoice No</StyledTableCell>
                                            <StyledTableCell align='center' className="p-1">Nature of Discount</StyledTableCell>
                                            <StyledTableCell align='center' className="p-1">Discount Rate</StyledTableCell>
                                            <StyledTableCell align='center' className="p-1">Discount Amount</StyledTableCell>
                                        </StyledTableRow>
                                    </TableHead>
                                    <TableBody>
                                        {
                                            invoicedetails.map((trns) => { const selectedItem = isInvoiceTblSelected(trns.natDiscount);
                                                return(
                                                    <TableRow hover key={trns.natDiscount} onClick={() => editInvoiceDiscountdetails(trns)} id='invoiceDiscountTblDetails_id'
                                                    tabIndex={-1} onKeyDown={(e)=>InvoicDetailsTbleKeyDown(e,'DiscountDetails')} selected={selectedItem}>
                                                        <TableCell align='center'>{trns.serialNumber}</TableCell>
                                                        <TableCell align='center'>{trns.invoiceNumber}</TableCell>
                                                        <TableCell align='center'>{trns.natDiscount}</TableCell>
                                                        <TableCell align='center'>{trns.discountRate}</TableCell>
                                                        <TableCell align='center'>{trns.discountAmount}</TableCell>
                                                    </TableRow>
                                                )})}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Dialog>
                        <Dialog open={InvoiceAddMiscDetailsopen} onClose={InvoiceAddMiscDetailshandleClose} fullWidth={true} maxWidth='md'>
                            <DialogTitle align='center' className="dialogboxtitlecolour p-1">
                                Add Misc Details
                            </DialogTitle>
                            <div className='dialogboxcolour'>
                                <Container>
                                    <Row>
                                        <div className="form-inline mt-3 mb-2">
                                            <label className="dialogfont" style={{ marginLeft: '14%' }}>Misc Code Type</label>
                                            <input style={{ textTransform: 'uppercase', textAlign: 'center', marginLeft: '1.3%', marginRight: '2.7%' }} autoFocus
                                                className='hi22' value={dialoginvoicevalues.MiscCodeType} onChange={InvoiceMiscCodeTypeChangeHandle} onKeyDown={invoiceMisctypkeyup} />

                                            <label className="dialogfont">Misc Description</label>
                                            <input type='text' style={{ textTransform: 'uppercase', textAlign: 'center', marginLeft: '1%' }}
                                                className='hi22' value={dialoginvoicevalues.MiscDescription} onChange={InvoiceMiscDescriptionChangeHandle}
                                                onKeyDown={invoiceMiscDeckeyup} id={'invoicemiscDesc'} />

                                        </div>
                                        <div className='form-inline mb-2'>
                                            <label className="dialogfont" style={{ marginLeft: '14%' }}>Misc Rate</label>
                                            <input type='text' style={{ textTransform: 'uppercase', textAlign: 'center', marginLeft: '6.5%', marginRight: '3.2%' }} className='hi22'
                                                value={dialoginvoicevalues.MiscRate} onChange={InvoiceMiscRateChangeHandle} onKeyDown={invoiceMiscratekeyup} id={'invoicemiscrate'} />

                                            <label className="dialogfont">Misc Amount</label>
                                            <input type='text' style={{ textTransform: 'uppercase', textAlign: 'center', marginLeft: '3.6%' }}
                                                className='hi22' value={dialoginvoicevalues.MiscAmmount} onChange={InvoiceMiscAmmountChangeHandle} onKeyDown={invoiceMiscamntkeyup} id={'invoicemiscamnt'} />
                                        </div>
                                    </Row>
                                </Container>
                                <Grid item container direction="row" justifyContent="center" alignItems="center" className="mb-2 mt-2">

                                    <div><Button size='small' variant="contained" color="primary" className='mr-1' disabled={InvoiceSaveDsa} onClick={InvoiceMisc_dtlsSave} id={'invoicemiscSaveId'}>{InvoiceProcsSve ? 'Processing' : 'Save'}</Button>{' '}</div>
                                    <div><Button size='small' variant="contained" color="primary" className='mr-1' disabled={InvoiceUpdateDsa} onClick={InvoiceMisc_dtlsUpdate} id={'invoicemiscUpdateId'}>{InvoiceProcsUpd ? 'Processing' : 'Update'}</Button>{' '}</div>
                                    <div><Button size='small' variant="contained" color="primary" className='mr-1' disabled={InvoiceDeleteDsa} onClick={InvoiceMisc_dtlsDelete}>{InvoiceProcsDlt ? 'Processing' : 'Delete'}</Button>{' '}</div>
                                    <div><Button size='small' variant="contained" color="primary" onKeyDown={invoiceMiscRefBtnkeyup} onClick={InvoiceMisc_dtlsReset}>Refresh</Button>{' '}</div>
                                </Grid>
                            </div>
                            <TableContainer className={classes.container}>
                                <Table stickyHeader className="table-bordered">
                                    <TableHead>
                                        <StyledTableRow>
                                            <StyledTableCell align='center' className="p-1">Sl</StyledTableCell>
                                            <StyledTableCell align='center' className="p-1">Invoice No</StyledTableCell>
                                            <StyledTableCell align='center' className="p-1">Misc Code Type</StyledTableCell>
                                            <StyledTableCell align='center' className="p-1">Misc Description</StyledTableCell>
                                            <StyledTableCell align='center' className="p-1">Misc Rate</StyledTableCell>
                                            <StyledTableCell align='center' className="p-1">Misc Amount</StyledTableCell>
                                        </StyledTableRow>
                                    </TableHead>
                                    <TableBody>
                                        {
                                            invoicedetails.map((trns) => { const selectedItem = isInvoiceTblSelected(trns.miscCode);
                                                return(
                                                    <StyledTableRow hover key={trns.miscCode} onClick={() => editInvoiceMiscdetails(trns)} id='invoicemiscDetailsTblDetails_id'
                                                    tabIndex={-1} onKeyDown={(e)=>InvoicDetailsTbleKeyDown(e,'miscDetails')} selected={selectedItem}>
                                                        <StyledTableCell align='center'>{trns.serialNumber}</StyledTableCell>
                                                        <StyledTableCell align='center'>{trns.invoiceNumber}</StyledTableCell>
                                                        <StyledTableCell align='center'>{trns.miscCode}</StyledTableCell>
                                                        <StyledTableCell align='center'>{trns.miscDescription}</StyledTableCell>
                                                        <StyledTableCell align='center'>{trns.miscRate}</StyledTableCell>
                                                        <StyledTableCell align='center'>{trns.miscAmount}</StyledTableCell>
                                                    </StyledTableRow>
                                                )})}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Dialog>
                    </div>
                    {/* ..................................inputs................................................... */}
                    <Card className='dialogboxcolour'>
                        <Box className='bg-light form-inline'>
                            <Box sx={{ width: '86%', height: '456px' }}>
                                <Paper className={classes.card} style={{ backgroundColor: '#C8EDE7' }}>
                                    <div className="form-inline">
                                        <div className="title" style={{ marginLeft: '44%', fontSize: '150%' }}>IMPORT-INVOICE</div>
                                        <label style={{ marginLeft: '20%', color: 'blue' }} className='mr-1'>JOB NO</label>
                                        <input type='text' style={{ width: '10%', textAlign: 'center', fontweight: 'bold', color: 'red' }} disabled value={jobValues.job_no} />
                                    </div>
                                    <div className="form-inline">
                                        <div className={classes.card3} style={{ fontWeight: "bold", color: 'slategrey' }}>INVOICE DETAILS</div>
                                        <Form.Check className="mr-2" type="radio" style={{ marginLeft: '34%', color: "rgb(16, 8, 92)", fontWeight: "bold" }} onChange={invoiceradioChangeHandle}
                                            checked={invoiceradiovalues === '1'} label={'Auto Bifurcation'} value={'1'} />
                                        <Form.Check type="radio" onChange={invoiceradioChangeHandle} inline style={{ color: "rgb(16,8,92)", fontWeight: "bold" }}
                                            checked={invoiceradiovalues === '2'} label={'Manual'} value={'2'} />
                                    </div>
                                    <div className="form-inline">
                                        <label className="dangerinvoiceiptextcss mr-1" style={{ fontWeight: "bold" }}>Invoice No</label>
                                        <input className='mr-2' type="text" maxLength={16} value={invoicevalues.invoiceNo} onChange={InvoiceInvoiceNoChangeHandle} onKeyDown={invoiceinvoicenokeyup} id='invoiceNo'
                                            style={{ height: '34px', width: '14%', color: 'red', fontWeight: "bold", border: '4px solid yellow', textAlign: 'center', textTransform: 'uppercase' }} />
                                        <label className="dangerinvoiceiptextcss mr-1 ml-1" style={{ fontWeight: "bold" }}>Invoice Date</label>
                                        <input className='mr-2' type="Date" style={{ height: '22px', width: '9%', textTransform: 'uppercase' }}
                                            value={invoicevalues.invoiceDate} id='invoicedate' onChange={InvoiceInvoicedateChangeHandle} onKeyDown={invoiceinvoicedatekeyup} />
                                        <label className="dangerinvoiceiptextcss mr-1 ml-1" style={{ fontWeight: "bold" }}>Invoice Value</label>
                                        <input className='mr-2' style={{ height: '22px', width: '8%', textAlign: 'center', textTransform: 'uppercase' }}
                                            value={invoicevalues.invoiceValue} onChange={InvoiceInvoiceValueChangeHandle} onKeyDown={invoiceinvoicevaluekeyup} onBlur={insertCommercialInvoiceAlertNo}
                                            id='invoicevalue' />
                                        <label className="dangerinvoiceiptextcss mr-1 ml-1" style={{ fontWeight: "bold" }}>Currency</label>
                                        <input type="text" maxLength={3} style={{ height: '22px', width: '4%', textAlign: 'center', textTransform: 'uppercase' }}
                                            value={invoicevalues.Currency} onChange={InvoiceCurrencyValueChangeHandle} onKeyDown={invoiceinvoicecurrencykeyup} id='invoicecurrency' />
                                        <button className='searchbutton' onClick={InvoiceCurrencyhandleClickOpen}><Search fontSize="small" /></button>
                                        <label className="dangerinvoiceiptextcss mr-1 ml-1" style={{ fontWeight: "bold" }}>ExchangeRate</label>
                                        <input className='mr-2' type="text" disabled style={{ height: '22px', width: '5%', textAlign: 'center' }}
                                            value={invoicevalues.ExchangeRate} onChange={InvoiceExchangeRateChangeHandle} />
                                        <label className="dangerinvoiceiptextcss mr-1" style={{ fontWeight: "bold" }}>Terms</label>
                                        <input type="text" maxLength={3} style={{ height: '22px', width: '3.7%', textTransform: 'uppercase', textAlign: 'center' }}
                                            value={invoicevalues.Terms} onChange={InvoiceTermsChangeHandle}
                                            onKeyDown={invoiceinvoicetermskeyup} id='invoiceterms' />
                                        <button className="searchbutton" onClick={InvoiceTermshandleClickOpen}><Search fontSize="small" /></button>
                                    </div>
                                </Paper>
                                <Grid>
                                    <Paper className={classes.card} style={{ backgroundColor: '#C8EDE7' }}>
                                        <Grid item className="pb-1">
                                            <div className={classes.card3} style={{ fontWeight: "bold", color: 'slategrey' }}>SUPPLIER DETAILS</div>
                                            <div className="form-inline">
                                                <label className="dangerinvoiceiptextcss" style={{ fontWeight: "bold" }}>Supplier Name</label>
                                                <input type="text" style={{ height: '22px', width: '22%', textTransform: 'uppercase' }} className='ml-3'
                                                    value={invoicevalues.SupplierName} onChange={InvoiceSupplierNameChangeHandle} id='invoicesup_name'
                                                    onKeyDown={invoicesup_namekeyup} />
                                                <button className='mr-3 searchbutton' onClick={InvoiceSupplierNamehandleClickOpen}><Search fontSize="small" /></button>
                                                <label className="dangerinvoiceiptextcss" style={{ fontWeight: "bold" }}>Address1</label>
                                                <input type="text" style={{ height: '22px', width: '22%', textTransform: 'uppercase' }} className='ml-1 mr-2'
                                                    value={invoicevalues.Address1} onChange={InvoiceAddress1ChangeHandle} onKeyDown={invoicesup_ad1keyup}
                                                    id='invoicesup_ad1' />
                                                <label style={{ fontWeight: "bold" }}>Address2</label>
                                                <input type="text" style={{ height: '22px', width: '22%', textTransform: 'uppercase' }} className='ml-2'
                                                    value={invoicevalues.Address2} onChange={InvoiceAddress2ChangeHandle} onKeyDown={invoicesup_ad2keyup}
                                                    id='invoicesup_ad2' />
                                            </div>
                                            <div className="form-inline mt-1">
                                                <label className="dangerinvoiceiptextcss" style={{ fontWeight: "bold" }}>Supplier Country</label>
                                                <input type="text" style={{ height: '22px', width: '5%', textTransform: 'uppercase' }} className='ml-1 mt-1'
                                                    value={invoicevalues.SupplierCountry} onChange={InvoiceSupplierCountryChangeHandle}
                                                    onKeyDown={invoicesup_cntrykeyup} id='invoicesup_cntry' />
                                                <button className='mt-1 searchbutton' onClick={InvoiceSupplierCountryhandleClickOpen}><Search fontSize="small" /></button>
                                                <input disabled value={invoicevalues.disable_supcountry_Name} style={{ height: '22px', width: '17%', textTransform: 'uppercase' }} className='ml-1 mr-2 mt-1' />
                                                <label style={{ fontWeight: "bold" }}>Address3</label>
                                                <input type="text" style={{ height: '22px', width: '22%', textTransform: 'uppercase' }} className='ml-2 mr-2'
                                                    value={invoicevalues.Address3} onChange={InvoiceAddress3ChangeHandle}
                                                    onKeyDown={invoicesup_ad3keyup} id='invoicesup_ad3' />
                                                <label style={{ fontWeight: "bold" }}>PinCode</label>
                                                <input style={{ height: '22px', width: '22%' }} className='ml-3'
                                                    value={invoicevalues.PinCode} onChange={InvoicePinCodeChangeHandle}
                                                    onKeyDown={invoicesup_pincode} id='invoicesup_pincode' />
                                            </div>
                                        </Grid>
                                    </Paper>
                                </Grid>
                                <Grid >
                                    <Paper className={classes.card} style={{ backgroundColor: '#C8EDE7' }}>
                                        <Grid>
                                            <div className={classes.card3} style={{ fontWeight: "bold", color: 'slategrey' }}>THIRDPARTY DETAILS</div>
                                            <div className="form-inline">
                                                <label style={{ fontWeight: "bold" }}>SVBLoading(Y/N)</label>
                                                <input type="text" style={{ height: '22px', width: '2%', textTransform: 'uppercase', textAlign: 'center' }}
                                                    className='ml-2 mr-2' onKeyDown={InvoiceSvbLoadingKeyUp}
                                                    value={invoicevalues.SVBLoading} onChange={InvoiceSVBLoadingChangeHandle} id='invoiceSVBLoading' />

                                                <label style={{ fontWeight: "bold" }}>SVBDescription</label>
                                                <input type="text" style={{ height: '22px', width: '10%', textTransform: 'uppercase' }} className='ml-2 mr-2'
                                                    value={invoicevalues.SVBDescription} onChange={InvoiceSVBDescriptionChangeHandle}
                                                    id='SVBDescription' onKeyDown={invoicesusvbdescritionkeyup} />

                                                <label style={{ fontWeight: "bold" }}>ThirdParty(Y/N)</label>
                                                <input type="text" style={{ height: '22px', width: '2%', textTransform: 'uppercase', textAlign: 'center' }}
                                                    className='ml-2 mr-2' onKeyDown={InvoiceThirdPartyKeyUp}
                                                    value={invoicevalues.Thirdparty} onChange={InvoiceThirdpartyChangeHandle} id='invoiceThirdParty' />

                                                <label style={{ fontWeight: "bold" }}>Seller(Y/N)</label>
                                                <input type="text" style={{ height: '22px', width: '2%', textTransform: 'uppercase', textAlign: 'center' }}
                                                    className='ml-2 mr-2' onKeyDown={InvoiceSellerKeyUp} id='invoiceSeller'
                                                    value={invoicevalues.Seller} onChange={InvoiceSellerChangeHandle} />

                                                <label style={{ fontWeight: "bold" }}>Broker(Y/N)</label>
                                                <input type="text" style={{ height: '22px', width: '2%', textTransform: 'uppercase', textAlign: 'center' }}
                                                    className='ml-2 mr-2' onKeyDown={InvoiceBrokerKeyUp} id='invoicebroker'
                                                    value={invoicevalues.Broker} onChange={InvoiceBrokerChangeHandle} />

                                                <label style={{ fontWeight: "bold" }}>RelationB/W.Buyer&Seller(Y/N)</label>
                                                <input type="text" style={{ height: '22px', width: '2%', textTransform: 'uppercase', textAlign: 'center' }}
                                                    className='ml-2' onKeyDown={invoice_rela_bw_bandskeyup} id='invoicerela_bw_bs'
                                                    value={invoicevalues.RelationBetweenBuyerSeller} onChange={InvoiceRelationBetweenBuyerSellerChangeHandle} />
                                            </div>
                                        </Grid>
                                    </Paper>
                                </Grid>
                                <Grid>
                                    <Paper className={classes.card} style={{ backgroundColor: '#C8EDE7' }}>

                                        <div className={classes.card3} style={{ fontWeight: "bold", color: 'slategrey' }}>TRANSACTION DETAILS</div>
                                        <div className="form-inline">
                                            <label className="dangerinvoiceiptextcss" style={{ fontWeight: "bold", marginRight: '.1%', fontSize: '90%' }}>NatureOfTransaction</label>
                                            <input type="text" maxLength={1} style={{ height: '22px', width: '3%', textTransform: 'uppercase', textAlign: 'center' }}
                                                value={invoicevalues.NatureOfTransaction} onChange={InvoiceNatureOfTransactionChangeHandle}
                                                id='invoiceNatureOfTransaction' onKeyDown={invoiceNatureOfTransactionkeyup} />
                                            <button className="searchbutton"
                                                onClick={InvoiceNatureOfTransactionhandleClickOpen}
                                            ><center><Search fontSize="small" /></center>
                                            </button>
                                            <input disabled value={invoicevalues.disable_NatureofTransaction_Name} style={{ height: '22px', width: '8%', marginRight: '.2%' }} />

                                            <label className="dangerinvoiceiptextcss" style={{ fontWeight: "bold", marginRight: '.1%', fontSize: '90%' }}>TermsOfPayment</label>
                                            <input type="text" maxLength={3} style={{ height: '22px', width: '3.5%', textTransform: 'uppercase' }}
                                                value={invoicevalues.TermOfPayment} onChange={InvoiceTermOfPaymentChangeHandle}
                                                id='invoiceTermsOfPayment' onKeyDown={invoiceTermsOfPaymentkeyup} />
                                            <button className="searchbutton" onClick={InvoiceTermOfPaymentChangehandleClickOpen}><Search fontSize="small" /></button>
                                            <input disabled value={invoicevalues.disable_Termsofpayment} style={{ height: '22px', width: '8%', textAlign: 'center', marginRight: '.2%' }} />

                                            <label style={{ fontWeight: "bold", marginRight: '.1%', fontSize: '90%' }}>Cond.OfRestrictionSale(Y/N)</label>
                                            <input type="text" style={{ height: '22px', width: '2%', textAlign: 'center', textTransform: "uppercase", marginRight: '.2%' }}
                                                value={invoicevalues.ConditionsOfRestrictionSale} onChange={InvoiceConditionsOfRestrictionSaleChangeHandle}
                                                id='invoiceCond_OfRestrictionSale' onKeyDown={invoicecond_OfRestrictionSaleonkeyup} />

                                            <label style={{ fontWeight: "bold", marginRight: '.1%', fontSize: '90%' }} className="dangerinvoiceiptextcss">ValuationMethod</label>
                                            <input type="text" style={{ height: '22px', width: '5%', textTransform: 'uppercase' }}
                                                value={invoicevalues.ValuationMethod} onChange={InvoiceValuationMethodChangeHandle}
                                                id='invoiceValuationMethod' onKeyDown={invoiceValuationMethod} />
                                            <button className="searchbutton" onClick={InvoiceValuationMethodClickOpen}><Search fontSize="small" /></button>
                                            <input disabled value={invoicevalues.disable_valuationmethod} style={{ height: '22px', width: '10%', textAlign: 'center' }} />
                                        </div>
                                    </Paper>
                                </Grid>
                                <Grid>
                                    <Paper className={classes.card} style={{ backgroundColor: '#C8EDE7' }}>

                                        <div style={{ fontWeight: "bold", color: 'slategrey' }}>OTHER CHARGES DETAILS</div>
                                        <div className="form-inline">
                                            <label className='ml-4' style={{ fontWeight: "bold" }}>DiscountChargesIncludedInThisInvoice(Y/N)</label>
                                            <input type="text" style={{ height: '22px', width: '2%', textTransform: 'uppercase', textAlign: 'center' }} className='ml-2 mr-2'
                                                onKeyDown={InvoiceAddDiscountDetailsKeyUp} id='invoiceDiscountCharges'
                                                value={invoicevalues.DiscountChargesIncludedInThisInvoice} onChange={InvoiceDiscountChargesIncludedInThisInvoiceChangeHandle} />

                                            <label style={{ fontWeight: "bold" }}>CummulativeCharges(Y/N)</label>
                                            <input type="text" style={{ height: '22px', width: '2%', textTransform: 'uppercase', textAlign: 'center' }} className='ml-2 mr-2'
                                                value={invoicevalues.CummulativeCharges} onChange={InvoiceCummulativeChargesChangeHandle}
                                                onKeyDown={invoiceCummulativeChargeskeyup} id='invoiceCummulativeCharges' />

                                            <label style={{ fontWeight: "bold" }}>AreThereMiscChargesNotSpecifiedInThisInvoice(Y/N)</label>
                                            <input type="text" style={{ height: '22px', width: '2%', textTransform: 'uppercase', textAlign: 'center' }} className='ml-2'
                                                onKeyDown={InvoiceAddMiscDetailsKeyUp} id='invoiceMiscCharges' value={invoicevalues.AreThereMiscChargesNotSpecifiedInThisInvoice}
                                                onChange={InvoiceAreThereMiscChargesNotSpecifiedInThisInvoiceChangeHandle} />
                                        </div>
                                    </Paper>
                                </Grid>
                                <Grid>
                                    <Paper className={classes.card} style={{ backgroundColor: '#C8EDE7' }}>
                                        <div className="form-inline">
                                            <Grid item xs={4}>
                                                <div className={classes.card3} style={{ fontWeight: "bold", color: 'slategrey' }}>PURCHASE ORDER DETAILS</div>
                                                <div className="form-inline">
                                                    <label style={{ fontWeight: "bold" }}>No</label>
                                                    <input type="text" maxLength={20}
                                                        style={{ height: '22px', width: '30%', textAlign: "center" }} className='ml-1 mr-1'
                                                        value={invoicevalues.PurchaseOrderDetailsNo} onChange={InvoicePurchaseOrderDetailsNoChangeHandle}
                                                        onKeyDown={invoicePODnokeyup} id='invoicePODno' />
                                                    <label style={{ fontWeight: "bold" }}>Date</label>
                                                    <input type="Date" style={{ height: '22px', width: '30%', textTransform: 'uppercase' }} className='ml-1'
                                                        value={invoicevalues.PurchaseOrderDetailsDate} onChange={InvoicePurchaseOrderDetailsDateChangeHandle}
                                                        onKeyDown={invoicePODdatekeyup} id='invoicePODdate' />
                                                </div>
                                            </Grid>
                                            <Grid item xs={4}>
                                                <div className={classes.card3} style={{ fontWeight: "bold", color: 'slategrey' }}>CONTRACT DETAILS</div>
                                                <div className="form-inline">
                                                    <label style={{ fontWeight: "bold" }}>No</label>
                                                    <input type="text" maxLength={20} style={{ height: '22px', width: '30%', textAlign: 'center' }} className='ml-1 mr-1'
                                                        value={invoicevalues.ContractDetailsNo} onChange={InvoiceContractDetailsNoChangeHandle}
                                                        onKeyDown={invoiceCDnokeyup} id='invoiceCDno' />
                                                    <label style={{ fontWeight: "bold" }}>Date</label>
                                                    <input type="Date" style={{ height: '22px', width: '30%', textTransform: 'uppercase' }} className='ml-1'
                                                        value={invoicevalues.ContractDetailsDate} onChange={InvoiceContractDetailsDateChangeHandle}
                                                        onKeyDown={invoiceCDdatekeyup} id='invoiceCDdate' />
                                                </div>
                                            </Grid>
                                            <Grid item xs={4}>
                                                <div className={classes.card3} style={{ fontWeight: "bold", color: 'slategrey' }}>LETTER OF CREDIT DETAILS</div>
                                                <div className="form-inline">
                                                    <label style={{ fontWeight: "bold" }}>No</label>
                                                    <input type="text" maxLength={20} style={{ height: '22px', width: '30%', textAlign: 'center' }} className='ml-1 mr-1'
                                                        value={invoicevalues.LetterOfCreditDetailsNo} onChange={InvoiceLetterOfCreditDetailsNoChangeHandle}
                                                        onKeyDown={invoiceLCDno1keyup} id='invoiceLCDno' />
                                                    <label style={{ fontWeight: "bold" }}>Date</label>
                                                    <input type="Date" style={{ height: '22px', width: '30%', textTransform: 'uppercase' }} className='ml-1'
                                                        value={invoicevalues.LetterOfCreditDetailsDate} onChange={InvoiceLetterOfCreditDetailsDateChangeHandle} id='invoiceLCDdate' />
                                                </div>
                                            </Grid>
                                        </div>
                                        <div className={classes.card1} style={{ backgroundColor: '#C8EDE7' }}>
                                            <center>
                                                <div className="form-inline" style={{ marginLeft: '28%', margintop: '2%' }}>
                                                    <div><Button size='small' variant="contained" color="primary" className="mr-2" disabled={InvoiceSaveTableDsa} onClick={InvoiceSave}>
                                                        {InvoiceProcsTableSve ? 'Processing' : 'Save'}</Button>{' '}</div>
                                                    <div><Button size='small' variant="contained" color="primary" className="mr-2" disabled={InvoiceUpdateTableDsa} onClick={InvoiceUpdate}>
                                                        {InvoiceProcsTableUpd ? 'Processing' : 'Update'}</Button>{' '}</div>
                                                    <div><Button size='small' variant="contained" color="primary" className="mr-2" disabled={InvoiceDeleteTableDsa} onClick={InvoiceDelete}>
                                                        {InvoiceProcsTableDlt ? 'Processing' : 'Delete'}</Button>{' '}</div>
                                                    <div><Button size='small' variant="contained" color="primary" className="mr-2" onClick={InvoiceReset}>Cancel</Button>{' '}</div>
                                                    <div><Button size='small' variant="contained" color="primary" className="mr-2" disabled={invoiceDublicateTableDsa} onClick={InvoiceDuplicateBtn}>
                                                        {InvoiceProcsTableDubli ? 'Processing' : 'Duplicate Invoice'}</Button>{' '}</div>
                                                    <div><Button size='small' variant="contained" color="primary" className="mr-2" onClick={invoiceBulkUploadhandleOpen}  onKeyDown={invoiceBulkUpldBTNkeyup}>Bulk Upload</Button>{' '}</div>

                                                </div>
                                            </center>
                                        </div>
                                    </Paper>
                                </Grid>
                            </Box>
                            <Box sx={{ width: '14%' }}>
                                <Paper className={classes.card_OI} style={{ backgroundColor: '#C8EDE7', height: '438px', marginTop: '-6%' }}>
                                    <div className={classes.card3} style={{ fontWeight: "bold", color: 'slategrey' }}>OTHER INFORMATION</div>
                                    <label className='mt-3' style={{ fontWeight: "bold" }}>AEO Code</label>
                                    <input type="text" maxLength={17} style={{ height: '22px', width: '100%', textTransform: 'uppercase' }} className='mb-2'
                                        value={invoicevalues.AEOCode} onChange={InvoiceAEOCodeChangeHandle}
                                        onKeyDown={invoiceaeocodekeyup} id='invoiceaeocode' />
                                    <label style={{ fontWeight: "bold" }}>AEO Role</label>
                                    <input type="text" maxLength={3} style={{ height: '22px', width: '100%', textAlign: 'center' }} className='mb-2'
                                        value={invoicevalues.AEORole} onChange={InvoiceAEORoleChangeHandle}
                                        onKeyDown={invoiceaeorolekeyup} id='invoiceaeorole' />
                                    <label style={{ fontWeight: "bold" }}>AEO Country</label>
                                    <div className="form-inline">
                                        <input type="text" maxLength={3} style={{ height: '22px', width: '70%', textAlign: 'center', textTransform: 'uppercase' }}
                                            className='mb-1' value={invoicevalues.AEOCountry} onChange={InvoiceAEOCountryChangeHandle}
                                            onKeyDown={invoiceaeocountrykeyup} id='invoiceaeocountry' />
                                        <button className="searchbutton mb-1" onClick={InvoiceAEOCountryhandleClickOpen}><Search fontSize="small" /></button>
                                    </div>
                                    <input style={{ height: '22px', width: '100%', textAlign: 'center' }} className="mb-2" disabled value={invoicevalues.disable_AeocountryName} />
                                    <label style={{ fontWeight: "bold" }}>Load No</label>
                                    <input type="text" maxLength={1} style={{ height: '22px', width: '100%', }} className='mb-2'
                                        value={invoicevalues.LoadNo} onChange={InvoiceLoadNoChangeHandle}
                                        onKeyDown={invoiceloadnokeyup} id='invoiceloadno' />
                                    <label style={{ fontWeight: "bold" }}>Condition 1</label>
                                    <input type="text" style={{ height: '22px', width: '100%' }} className='mb-2'
                                        value={invoicevalues.Condition1} onChange={InvoiceCondition1ChangeHandle}
                                        onKeyDown={invoicecond1keyup} id='invoicecond1' />
                                    <label style={{ fontWeight: "bold" }}>Condition 2</label>
                                    <input type="text" style={{ height: '22px', width: '100%' }} className='mb-2'
                                        value={invoicevalues.Condition2} onChange={InvoiceCondition2ChangeHandle}
                                        onKeyDown={invoicecond2keyup} id='invoicecond2' />
                                    <label style={{ fontWeight: "bold" }}>Other Information</label>
                                    <input type="text" style={{ height: '22px', width: '100%' }}
                                        value={invoicevalues.OtherInformation} onChange={InvoiceOtherInformationChangeHandle}
                                        onKeyDown={invoiceotherinformationkeyup} id='invoiceotherinformation' />
                                </Paper>
                            </Box>
                        </Box>
                        <Paper className={classes.card_Tb} style={{ backgroundColor: '#C8EDE7', marginTop: '-0.80%' }}>
                            <TableContainer className={classes.container2}>
                                <Table stickyHeader className="table-bordered">
                                    <TableHead>
                                        <StyledTableRow>
                                            <StyledTableCell className="p-1">Sl.No</StyledTableCell>
                                            <StyledTableCell className="p-1">Invoice No</StyledTableCell>
                                            <StyledTableCell className="p-1">Invoice Date</StyledTableCell>
                                            <StyledTableCell className="p-1">Invoice Value</StyledTableCell>
                                            <StyledTableCell className="p-1">Currency</StyledTableCell>
                                            <StyledTableCell className="p-1">Invoice Term</StyledTableCell>
                                            <StyledTableCell className="p-1">Freight Value</StyledTableCell>
                                            <StyledTableCell className="p-1">Insurance Value</StyledTableCell>
                                        </StyledTableRow>
                                    </TableHead>
                                    <TableBody style={{ background: 'white' }}>{
                                    invoiceTabledetails.map((trns,i) => { const selectedItem = isInvoiceTblSelected(trns.invoiceNumber);
                                        return(
                                            <TableRow key={trns.serialNumber} hover onClick={() => editInvoiceTableDetails(trns,i)} className='igmtbl' id='InvoiceTable_id'
                                            onKeyDown={invoiceTblSelctKeyDown} tabIndex={-1} selected={selectedItem}>
                                                <TableCell className="p-1">{trns.invoiceNoSb}</TableCell>
                                                <TableCell className="p-1">{trns.invoiceNumber}</TableCell>
                                                <TableCell className="p-1">{trns.invoiceDate}</TableCell>
                                                <TableCell className="p-1">{trns.invoiceValue}</TableCell>
                                                <TableCell className="p-1">{trns.currency_code}</TableCell>
                                                <TableCell className="p-1">{trns.invoiceTerm}</TableCell>
                                                <TableCell className="p-1">{trns.freightValue}</TableCell>
                                                <TableCell className="p-1">{trns.insuranceValue}</TableCell>
                                            </TableRow>
                                        )})}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Paper>
                    </Card >
                </Tab>
                {/*-------------------------------------------------------------------------------------------------------
                --------------------------TabsItem----------------------------------------------------*/}
                <Tab eventKey="item" title="Item">
                    <div>
                        {/*ItemDesc*/}
                        <Dialog onClose={itemItemDescCloshHandle} open={itemDescOpen} fullWidth={true} maxWidth="md">
                            <DialogTitle className="dialogboxtitlecolour p-1"><center>View Item Details</center></DialogTitle>
                            <div className='dialogboxcolour'>
                                <div className='form-inline ml-4'>
                                    <button className='btn btn-danger p-1' onClick={removeiteopen}>Remove Item</button>
                                </div>
                                <div className='form-inline mb-1'>
                                    <Form.Label style={{ marginLeft: '15%' }}>Find Item Name</Form.Label>
                                    <input className='wid57' style={{ textTransform: 'uppercase' }} value={ItemDialogValues.f_item_desc}
                                        onChange={itemDialogItemdescChangeHandle} autoFocus onKeyDown={itemDialogItemdescKeyDownHandleHandle}/>
                                </div>
                                {removeitemHiden ? null : <div className='form-inline'>
                                    <button className='btn btn-danger p-1' onClick={DeleteItemDesc}>Delete</button>
                                    <button className='btn btn-light p-1' onClick={Backitemeopen}>Back</button>
                                </div>}
                            </div>
                            <TableContainer className={classes.containeritem} style={{ backgroundColor: 'wheat' }}>
                                <Table stickyHeader className='table-bordered border-primary'>
                                    <TableHead>
                                        <StyledTableRow >
                                            {removeitemHiden ? null : <StyledTableCell padding="checkbox">
                                                <Checkbox indeterminate={selectedInvoice.length} checked={selectedInvoice.length}
                                                    onChange={AllInvoiceBasedIgmHandle} inputProps={{ 'aria-label': 'select all desserts' }} /></StyledTableCell>}
                                            <StyledTableCell className={classes.tbsize}>ItemName</StyledTableCell>
                                            <StyledTableCell className='p-1'>RITC</StyledTableCell>
                                            <StyledTableCell className='p-1'>CTH</StyledTableCell>
                                            <StyledTableCell className='p-1'>CETH</StyledTableCell>
                                            <StyledTableCell className='p-1'>EndUseCode</StyledTableCell>
                                            <StyledTableCell className='p-1'>BCD.NotnNo</StyledTableCell>
                                            <StyledTableCell className='p-1'>BCD.NotnSrlNo</StyledTableCell>
                                            <StyledTableCell className='p-1'>BCD.flag</StyledTableCell>
                                            <StyledTableCell className='p-1'>BCD.Unit</StyledTableCell>
                                            <StyledTableCell className='p-1'>BCD.Rate</StyledTableCell>
                                            <StyledTableCell className='p-1'>BCD.Amt</StyledTableCell>
                                            <StyledTableCell className='p-1'>SWS.NotnNo</StyledTableCell>
                                            <StyledTableCell className='p-1'>SWS.NotnSrlNo</StyledTableCell>
                                            <StyledTableCell className='p-1'>SWSflag</StyledTableCell>
                                            <StyledTableCell className='p-1'>SWSUnit</StyledTableCell>
                                            <StyledTableCell className='p-1'>SWS.Rate</StyledTableCell>
                                            <StyledTableCell className='p-1'>SWS.Amt</StyledTableCell>
                                        </StyledTableRow>
                                    </TableHead>
                                    {removeitemHiden ? <TableBody>
                                        {itemDescDetails.map((item) => {
                                            const selectedItem = isItemTblSelected(item.item_description);
                                           return (
                                            <TableRow key={item.itemId} hover onClick={() => editItemDescDetails(item)} onKeyDown={(e)=>itemItemDescDialogTblKeyDown(e)} tabIndex={-1}
                                             selected={selectedItem} id='itemItemDescTbl'>
                                                <TableCell className='p-1'>{item.item_description}</TableCell>
                                                <TableCell className='p-1'>{item.ritc}</TableCell>
                                                <TableCell className='p-1'>{item.cth} </TableCell>
                                                <TableCell className='p-1'>{item.ceth}</TableCell>
                                                <TableCell className='p-1'>{item.endUseCode}</TableCell>
                                                <TableCell className='p-1'>{item.notificationNo}</TableCell>
                                                <TableCell className='p-1'>{item.notificationSrNo}</TableCell>
                                                <TableCell className='p-1'>{item.notificationFlag}</TableCell>
                                                <TableCell className='p-1'>{item.notificationUnit}</TableCell>
                                                <TableCell className='p-1'>{item.notificationRate}</TableCell>
                                                <TableCell className='p-1'>{item.notificationAmount}</TableCell>
                                                <TableCell className='p-1'>{item.exempNotNo} </TableCell>
                                                <TableCell className='p-1'>{item.exempNotSrNo}</TableCell>
                                                <TableCell className='p-1'>{item.igstFlag}</TableCell>
                                                <TableCell className='p-1'>{item.unitCode}</TableCell>
                                                <TableCell className='p-1'>{item.ratePer}</TableCell>
                                                <TableCell className='p-1'>{item.igstAmt}</TableCell>
                                            </TableRow>)})}
                                    </TableBody> : <TableBody> {itemDescDetails.map((item, i) => {
                                        const SelctedInvoice = isInvoiceSelected(i);
                                        return (
                                            <StyledTableRow hover key={item.item_description} onClick={(event) => SlectedInvoiClick(event, i)}
                                                role="checkbox" aria-checked={SelctedInvoice} tabIndex={-1} selected={SelctedInvoice}>

                                                <StyledTableCell padding="checkbox"><Checkbox checked={SelctedInvoice} /></StyledTableCell>
                                                <StyledTableCell className='p-1'>{item.item_description}</StyledTableCell>
                                                <StyledTableCell className='p-1'>{item.ritc}</StyledTableCell>
                                                <StyledTableCell className='p-1'>{item.cth} </StyledTableCell>
                                                <StyledTableCell className='p-1'>{item.ceth}</StyledTableCell>
                                                <StyledTableCell className='p-1'>{item.endUseCode}</StyledTableCell>
                                                <StyledTableCell className='p-1'>{item.notificationNo}</StyledTableCell>
                                                <StyledTableCell className='p-1'>{item.notificationSrNo}</StyledTableCell>
                                                <StyledTableCell className='p-1'>{item.notificationFlag}</StyledTableCell>
                                                <StyledTableCell className='p-1'>{item.notificationUnit}</StyledTableCell>
                                                <StyledTableCell className='p-1'>{item.notificationRate}</StyledTableCell>
                                                <StyledTableCell className='p-1'>{item.notificationAmount}</StyledTableCell>
                                                <StyledTableCell className='p-1'>{item.exempNotNo} </StyledTableCell>
                                                <StyledTableCell className='p-1'>{item.exempNotSrNo}</StyledTableCell>
                                                <StyledTableCell className='p-1'>{item.igstFlag}</StyledTableCell>
                                                <StyledTableCell className='p-1'>{item.unitCode}</StyledTableCell>
                                                <StyledTableCell className='p-1'>{item.ratePer}</StyledTableCell>
                                                <StyledTableCell className='p-1'>{item.igstAmt}</StyledTableCell>
                                            </StyledTableRow>)
                                    })}</TableBody>}
                                </Table>
                            </TableContainer>
                        </Dialog>
                        {/*-Ritc-*/}
                        <Dialog onClose={itemRitcCloshHandle} open={itemRitcOpen} fullWidth={true} maxWidth="md">
                            <DialogTitle className="dialogboxtitlecolour p-1">
                                <center>RITC DetailS</center>
                            </DialogTitle>
                            <div className='dialogboxcolour'>
                                <div className='form-inline mt-2'>
                                    <label style={{ marginLeft: '27%' }}>Find RITC Code</label>
                                    <input style={{ marginLeft: '1%', width: '30%', textTransform: 'uppercase' }} autoFocus
                                        value={ItemDialogValues.f_ritcCode} onChange={ItemDialogFindRitcCodeChangeHandle}
                                        onKeyDown={ItemDialogFindRitcCodeKeydown} />
                                </div>
                                <div className='form-inline mt-2'>
                                    <label style={{ marginLeft: '27%' }}>Find RITC Name</label>
                                    <input style={{ width: '30%', marginLeft: '0.5%', textTransform: 'uppercase' }} id='FindRitcName'
                                        value={ItemDialogValues.f_ritcName} onChange={ItemDialogFindRitcNameChangeHandle} onKeyDown={ItemDialogFindRitcNameKeydown} />
                                </div>
                                <br></br>
                            </div>
                            <TableContainer className={classes.container}>
                                <Table stickyHeader className='table-bordered border-primary'>
                                    <TableHead>
                                        <StyledTableRow >
                                            <StyledTableCell style={{ width: '10%' }} className='p-1'>RITC.Code</StyledTableCell>
                                            <StyledTableCell style={{ width: '30%' }} className='p-1'>RITCName</StyledTableCell>
                                            <StyledTableCell style={{ width: '10%' }} className='p-1'>BCD.Rate</StyledTableCell>
                                            <StyledTableCell style={{ width: '10%' }} className='p-1'>BCD.Amount</StyledTableCell>
                                            <StyledTableCell style={{ width: '10%' }} className='p-1'>BCD.Unit</StyledTableCell>
                                            <StyledTableCell style={{ width: '10%' }} className='p-1'>SWS.Amount</StyledTableCell>
                                        </StyledTableRow>
                                    </TableHead>
                                    <TableBody>
                                        {itemRitcDetails.map((item) => { const selectedItem = isItemTblSelected(item.hsCode);
                                            return(
                                            <TableRow key={item.hsCode} hover onClick={() => editItemRitcDetails(item)} id='ItemRitc'
                                            onKeyDown={(e)=>itemDialogTblKeyDown(e,'ritc')} tabIndex={-1} selected={selectedItem}>
                                                <TableCell style={{ width: '10%' }} className='p-1'>{item.hsCode}</TableCell>
                                                <TableCell style={{ width: '30%' }} className='p-1'>{item.hsName}</TableCell>
                                                <TableCell style={{ width: '10%' }} className='p-1'>{item.notificationRate} </TableCell>
                                                <TableCell style={{ width: '10%' }} className='p-1'>{item.notificationAmount}</TableCell>
                                                <TableCell style={{ width: '10%' }} className='p-1'>{item.notificationUnit}</TableCell>
                                                <TableCell style={{ width: '10%' }} className='p-1'>{item.totalAmount}</TableCell>
                                            </TableRow>)})}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Dialog>
                        {/*--CTH--*/}
                        <Dialog onClose={itemCthCloshHandle} open={itemCTHOpen} fullWidth={true} maxWidth="md">
                            <DialogTitle className="dialogboxtitlecolour p-1">
                                <center>CTH Details</center>
                            </DialogTitle>
                            <div className='dialogboxcolour'>
                                <div className='form-inline mt-2'>
                                    <label style={{ marginLeft: '27%' }}>Find CTH Code</label>
                                    <input style={{ marginLeft: '0.7%', width: '30%', textTransform: 'uppercase' }} autoFocus
                                        value={ItemDialogValues.f_ritcCode} onChange={ItemDialogFindRitcCodeChangeHandle} onKeyDown={ItemDialogFindCthCodeKeydown}
                                    />
                                </div>
                                <div className='form-inline mt-2'>
                                    <label style={{ marginLeft: '27%' }}>Find CTH Name</label>
                                    <input style={{ marginLeft: '0.3%', width: '30%' }} id='itemFindCTHName' onKeyDown={ItemDialogFindCthNameKeydown}
                                        value={ItemDialogValues.f_ritcName} onChange={ItemDialogFindRitcNameChangeHandle} />
                                </div>
                                <br></br>
                            </div>
                            <TableContainer className={classes.container}>
                                <Table stickyHeader className='table-bordered border-primary'>
                                    <TableHead>
                                        <StyledTableRow >
                                            <StyledTableCell style={{ width: '10%' }} className='p-1'>CTH Code</StyledTableCell>
                                            <StyledTableCell style={{ width: '30%' }} className='p-1'>CTH Name</StyledTableCell>
                                        </StyledTableRow>
                                    </TableHead>
                                    <TableBody>
                                        {itemRitcDetails.map((item) => { const selectedItem = isItemTblSelected(item.hsCode);
                                            return(
                                            <TableRow key={item.hsName} hover onClick={() => editItemCthDetails(item)} id='ItemCth'
                                            onKeyDown={(e)=>itemDialogTblKeyDown(e,'cth')} tabIndex={-1} selected={selectedItem}>
                                                <TableCell style={{ width: '10%' }} className='p-1'>{item.hsCode}</TableCell>
                                                <TableCell style={{ width: '30%' }} className='p-1'>{item.hsName}</TableCell>
                                            </TableRow>)})}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Dialog>
                        {/*---CETH---*/}
                        <Dialog onClose={itemCEThCloshHandle} open={itemCETHOpen} fullWidth={true} maxWidth="md">
                            <DialogTitle className="dialogboxtitlecolour p-1">
                                <center>CETH DETAILS</center>
                            </DialogTitle>
                            <div className='dialogboxcolour'>
                                <div className='form-inline mt-2'>
                                    <label style={{ marginLeft: '27%' }}>Find CETH Code</label>
                                    <input style={{ marginLeft: '1.5%', width: '30%', textTransform: 'uppercase' }} autoFocus
                                        value={ItemDialogValues.f_ritcCode} onChange={ItemDialogFindRitcCodeChangeHandle} onKeyDown={ItemDialogFindCethCodeKeydown}
                                    />
                                </div>
                                <div className='form-inline mt-2'>
                                    <label style={{ marginLeft: '27%' }}>Find CETH Name</label>
                                    <input style={{ width: '30%', marginLeft: '1%', textTransform: 'uppercase' }} onKeyDown={ItemDialogFindCethNameKeydown}
                                        id='itemFindCethName' value={ItemDialogValues.f_ritcName} onChange={ItemDialogFindRitcNameChangeHandle} />
                                </div>
                                <br></br>
                            </div>
                            <TableContainer className={classes.container}>
                                <Table stickyHeader className='table-bordered border-primary'>
                                    <TableHead>
                                        <StyledTableRow >
                                            <StyledTableCell style={{ width: '10%' }} className='p-1'>CETH Code</StyledTableCell>
                                            <StyledTableCell style={{ width: '30%' }} className='p-1'>CETH Name</StyledTableCell>
                                        </StyledTableRow>
                                    </TableHead>
                                    <TableBody>
                                        {itemRitcDetails.map((item) => { const selectedItem = isItemTblSelected(item.hsCode);
                                            return(
                                            <TableRow key={item.hsCode} hover onClick={() => editItemCethDetails(item)} id='ItemCeth'
                                            onKeyDown={(e)=>itemDialogTblKeyDown(e,'ceth')} tabIndex={-1} selected={selectedItem}>
                                                <TableCell style={{ width: '10%' }} className='p-1'>{item.hsCode}</TableCell>
                                                <TableCell style={{ width: '30%' }} className='p-1'>{item.hsName}</TableCell>
                                            </TableRow>)})}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Dialog>
                        {/*=getUom=*/}
                        <Dialog onClose={itemUnitCloshHandle} open={itemUnitOpen} fullWidth={true} maxWidth="md">
                            <DialogTitle className="dialogboxtitlecolour p-1">
                                <center>View Unit Code Details</center>
                            </DialogTitle>
                            <div className='dialogboxcolour'>
                                <div className='form-inline mt-2'>
                                    <label style={{ marginLeft: '27%' }}>Find Unit Code</label>
                                    <input style={{ marginLeft: '1.5%', width: '30%', textTransform: 'uppercase' }} autoFocus
                                        value={ItemDialogValues.f_unitCode} onChange={ItemDialogFindUnitCodeChangeHandle} onKeyDown={ItemDialogFindUnitCodeKeydown}
                                    />
                                </div>
                                <div className='form-inline mt-2'>
                                    <label style={{ marginLeft: '27%' }}>Find Unit Name</label>
                                    <input style={{ width: '30%', marginLeft: '1%', textTransform: 'uppercase' }} onKeyDown={ItemDialogFindUnitNameKeydown}
                                        id='ItemFindUnitCode' value={ItemDialogValues.f_unitName} onChange={ItemDialogFindUnitNameChangeHandle} />
                                </div>
                                <br></br>
                            </div>
                            <TableContainer className={classes.container}>
                                <Table stickyHeader className='table-bordered border-primary'>
                                    <TableHead>
                                        <StyledTableRow >
                                            <StyledTableCell className='p-1'>Unit Code</StyledTableCell>
                                            <StyledTableCell className='p-1'>Unit Name</StyledTableCell>
                                        </StyledTableRow>
                                    </TableHead>
                                    <TableBody>
                                        {itemRitcDetails.map((item) => { const selectedItem = isItemTblSelected(item.unitCode);
                                            return(
                                            <TableRow key={item.unitCode} hover onClick={() => editItemUnitDetails(item)} id='ItemUnitCode_id'
                                            onKeyDown={(e)=>itemDialogTblKeyDown(e,'unitcode')} tabIndex={-1} selected={selectedItem}>
                                                <TableCell className='p-1'>{item.unitCode}</TableCell>
                                                <TableCell className='p-1'>{item.unitName}</TableCell>
                                            </TableRow>)})}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Dialog>
                        {/*=Currency=*/}
                        <Dialog onClose={itemCurrencyCloshHandle} open={ItemCurrencyOpen} fullWidth={true} maxWidth="md">
                            <DialogTitle className="dialogboxtitlecolour p-1">
                                <center>View Currency Details</center>
                            </DialogTitle>
                            <div className='dialogboxcolour'>
                                <div className='form-inline mt-2'>
                                    <label style={{ marginLeft: '27%' }}>Find Currency Code</label>
                                    <input style={{ marginLeft: '1.5%', width: '30%', textTransform: 'uppercase' }} autoFocus onKeyDown={ItemDialogFindCurruncyCodeKeydown}
                                        value={ItemDialogValues.f_currencyCode} onChange={ItemDialogFindCurrencyCodeChangeHandle}
                                    />
                                </div>
                                <div className='form-inline mt-2'>
                                    <label style={{ marginLeft: '27%' }}>Find Currency Name</label>
                                    <input style={{ marginLeft: '1%', width: '30%', textTransform: 'uppercase' }} onKeyDown={ItemDialogFindExchangeNameKeydown}
                                        id='ItemFindCurruncyName' value={ItemDialogValues.f_currencyName} onChange={ItemDialogFindCurrencyNameChangeHandle} />
                                </div>
                                <br></br>
                            </div>
                            <TableContainer className={classes.container}>
                                <Table stickyHeader className='table-bordered border-primary'>
                                    <TableHead>
                                        <StyledTableRow >
                                            <StyledTableCell className='p-1' align='center'>Currency Code</StyledTableCell>
                                            <StyledTableCell className='p-1' align='center'>Exchange Rate</StyledTableCell>
                                        </StyledTableRow>
                                    </TableHead>
                                    <TableBody>
                                        {itemRitcDetails.map((item) => { const selectedItem = isItemTblSelected(item.currency_code);
                                            return(
                                            <TableRow key={item.currency_code} hover onClick={() => editItemCurrencyDetails(item)} id='ItemCurruncyCode_id'
                                            onKeyDown={(e)=>itemDialogTblKeyDown(e,'curruncy')} tabIndex={-1} selected={selectedItem}>
                                                <TableCell className='p-1' align='center'>{item.currency_code}</TableCell>
                                                <TableCell className='p-1' align='center'>{item.indianValue}</TableCell>
                                            </TableRow>)})}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Dialog>
                        {/*---EndUseCode---*/}
                        <Dialog onClose={itemEndUseCloshHandle} open={ItemEndUseOpen} fullWidth={true} maxWidth="md">
                            <DialogTitle className="dialogboxtitlecolour p-1">
                                <center>View EndUseCode Details</center>
                            </DialogTitle>
                            <div className='dialogboxcolour'>
                                <div className='form-inline mt-2'>
                                    <label style={{ marginLeft: '27%' }}>Find EndUse Code</label>
                                    <input style={{ marginLeft: '1.5%', width: '30%', textTransform: 'uppercase' }} autoFocus onKeyDown={ItemDialogFindEndCodeKeydown}
                                        value={ItemDialogValues.f_enduse_code} onChange={ItemDialogFindEndUseCodeChangeHandle}
                                    />
                                </div>
                                <div className='form-inline mt-2'>
                                    <label style={{ marginLeft: '27%' }}>Find EndUse Name</label>
                                    <input style={{ marginLeft: '1%', width: '30%', textTransform: 'uppercase' }} onKeyDown={ItemDialogFindEndNameKeydown}
                                        id='ItemFindEndUseName' value={ItemDialogValues.f_enduse_name} onChange={ItemDialogFindEndUseNameChangeHandle} />
                                </div>
                                <br></br>
                            </div>
                            <TableContainer className={classes.container}>
                                <Table stickyHeader className='table-bordered border-primary'>
                                    <TableHead>
                                        <StyledTableRow >
                                            <StyledTableCell className='p-1' style={{ width: '20%' }} align='center'>EndUse Code</StyledTableCell>
                                            <StyledTableCell className='p-1' align='center'>EndUse Name</StyledTableCell>
                                        </StyledTableRow>
                                    </TableHead>
                                    <TableBody>
                                        {itemRitcDetails.map((item) => { const selectedItem = isItemTblSelected(item.endUseCode);
                                            return(
                                            <TableRow key={item.endUseCode} hover onClick={() => editItemEndUseDetails(item)} id='ItemEndUseCodeCode_id'
                                            onKeyDown={(e)=>itemDialogTblKeyDown(e,'EndUseCode')} tabIndex={-1} selected={selectedItem}>
                                                <TableCell className='p-1' style={{ width: '20%' }} align='center'>{item.endUseCode}</TableCell>
                                                <TableCell className='p-1' align='center'>{item.endUseDesc}</TableCell>
                                            </TableRow>)})}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Dialog>
                        {/*---originCntry---*/}
                        <Dialog onClose={itemOriginCntryCloshHandle} open={ItemOriginCntryOpen} fullWidth={true} maxWidth="sm">
                            <DialogTitle className="dialogboxtitlecolour p-1">
                                <center>View Origin Country Details</center>
                            </DialogTitle>
                            <div className='dialogboxcolour'>
                                <div className='form-inline mt-2'>
                                    <label style={{ marginLeft: '23%' }}>Find Origin Country Code</label>
                                    <input style={{ marginLeft: '1.9%', width: '30%', textTransform: 'uppercase' }} autoFocus onKeyDown={ItemDialogFindOriginCountryCodeKeydown}
                                        value={ItemDialogValues.f_originCntryCode} onChange={ItemDialogOriginCntryCodeChangeHandle}
                                    />
                                </div>
                                <div className='form-inline mt-2'>
                                    <label style={{ marginLeft: '23%' }}>Find Origin Country Name</label>
                                    <input style={{ marginLeft: '1%', width: '30%', textTransform: 'uppercase' }} onKeyDown={ItemDialogFindOriginCountryNameKeydown}
                                        id='FindOriginCountry' value={ItemDialogValues.f_originCntryName} onChange={ItemDialogFindOriginCntryNameChangeHandle} />
                                </div>
                                <br></br>
                            </div>
                            <TableContainer className={classes.container}>
                                <Table stickyHeader className='table-bordered border-primary'>
                                    <TableHead>
                                        <StyledTableRow >
                                            <StyledTableCell className='p-1' style={{ width: '20%' }} align='center'>Country Code</StyledTableCell>
                                            <StyledTableCell className='p-1' align='center'>Country Name</StyledTableCell>
                                        </StyledTableRow>
                                    </TableHead>
                                    <TableBody>
                                        {itemRitcDetails.map((item) => { const selectedItem = isItemTblSelected(item.countryIdString);
                                            return(
                                            <TableRow key={item.countryIdString} hover onClick={() => editItemOriginCntryDetails(item)} id='ItemOriginCountry_id'
                                            onKeyDown={(e)=>itemDialogTblKeyDown(e,'originCntry')} tabIndex={-1} selected={selectedItem}>
                                                <TableCell className='p-1' style={{ width: '20%' }} align='center'>{item.countryIdString}</TableCell>
                                                <TableCell className='p-1' align='center'>{item.countryName}</TableCell>
                                            </TableRow>)})}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Dialog>
                        {/*---SourceCntry---*/}
                        <Dialog onClose={itemSourceCntryCloshHandle} open={ItemSourceCntryOpen} fullWidth={true} maxWidth="sm">
                            <DialogTitle className="dialogboxtitlecolour p-1">
                                <center>View Origin Country Details</center>
                            </DialogTitle>
                            <div className='dialogboxcolour'>
                                <div className='form-inline mt-2'>
                                    <label style={{ marginLeft: '23%' }}>Find Country Code</label>
                                    <input style={{ marginLeft: '1.7%', width: '30%', textTransform: 'uppercase' }} autoFocus onKeyDown={ItemDialogFindSourceCountryCodeKeydown}
                                        value={ItemDialogValues.f_originCntryCode} onChange={ItemDialogOriginCntryCodeChangeHandle}
                                    />
                                </div>
                                <div className='form-inline mt-2'>
                                    <label style={{ marginLeft: '23%' }}>Find Country Name</label>
                                    <input style={{ width: '30%', marginLeft: '1%', textTransform: 'uppercase' }} onKeyDown={ItemDialogFindSourceCountryNameKeydown}
                                        id='ItemSourceCountry' value={ItemDialogValues.f_originCntryName} onChange={ItemDialogFindOriginCntryNameChangeHandle} />
                                </div>
                                <br></br>
                            </div>
                            <TableContainer className={classes.container}>
                                <Table stickyHeader className='table-bordered border-primary'>
                                    <TableHead>
                                        <StyledTableRow >
                                            <StyledTableCell className='p-1' style={{ width: '20%' }} align='center'>Country Code</StyledTableCell>
                                            <StyledTableCell className='p-1' align='center'>Country Name</StyledTableCell>
                                        </StyledTableRow>
                                    </TableHead>
                                    <TableBody>
                                        {itemRitcDetails.map((item) => { const selectedItem = isItemTblSelected(item.countryIdString);
                                            return(
                                            <TableRow key={item.countryIdString} hover onClick={() => editItemSourceCntryDetails(item)} id='ItemSourceCountry_id'
                                            onKeyDown={(e)=>itemDialogTblKeyDown(e,'SourceCntry')} tabIndex={-1} selected={selectedItem}>
                                                <TableCell className='p-1' style={{ width: '20%' }} align='center'>{item.countryIdString}</TableCell>
                                                <TableCell className='p-1' align='center'>{item.countryName}</TableCell>
                                            </TableRow>)})}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Dialog>
                        {/*---TransiteCntry---*/}
                        <Dialog onClose={itemTransiteCntryCloshHandle} open={ItemTransitCntryOpen} fullWidth={true} maxWidth="sm">
                            <DialogTitle className="dialogboxtitlecolour p-1">
                                <center>View Origin Country Details</center>
                            </DialogTitle>
                            <div className='dialogboxcolour'>
                                <div className='form-inline mt-2'>
                                    <label style={{ marginLeft: '27%' }}>Find Country Code</label>
                                    <input style={{ marginLeft: '2%', width: '30%', textTransform: 'uppercase' }} autoFocus onKeyDown={ItemDialogFindTransiteCountryCodeKeydown}
                                        value={ItemDialogValues.f_originCntryCode} onChange={ItemDialogOriginCntryCodeChangeHandle}
                                    />
                                </div>
                                <div className='form-inline mt-2'>
                                    <label style={{ marginLeft: '27%' }}>Find Country Name</label>
                                    <input style={{ width: '30%', marginLeft: '1%', textTransform: 'uppercase' }} onKeyDown={ItemDialogFindTransiteCountryNameKeydown}
                                        id='ItemFindCountryName' value={ItemDialogValues.f_originCntryName} onChange={ItemDialogFindOriginCntryNameChangeHandle} />
                                </div>
                                <br></br>
                            </div>
                            <TableContainer className={classes.container}>
                                <Table stickyHeader className='table-bordered border-primary'>
                                    <TableHead>
                                        <StyledTableRow >
                                            <StyledTableCell className='p-1' style={{ width: '20%' }} align='center'>Country Code</StyledTableCell>
                                            <StyledTableCell className='p-1' align='center'>Country Name</StyledTableCell>
                                        </StyledTableRow>
                                    </TableHead>
                                    <TableBody>
                                        {itemRitcDetails.map((item) => { const selectedItem = isItemTblSelected(item.countryIdString);
                                            return(
                                            <TableRow key={item.countryIdString} hover onClick={() => editItemTransitCntryDetails(item)} id='ItemTransitCntry_id'
                                            onKeyDown={(e)=>itemDialogTblKeyDown(e,'transitCntry')} tabIndex={-1} selected={selectedItem}>
                                                <TableCell className='p-1' style={{ width: '20%' }} align='center'>{item.countryIdString}</TableCell>
                                                <TableCell className='p-1' align='center'>{item.countryName}</TableCell>
                                            </TableRow>)})}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Dialog>
                        {/*---BcdNotification---*/}
                        <Dialog onClose={itemBcdNotifyCloshHandle} open={ItemBcdNotifyNoOpen} fullWidth={true} maxWidth="md">
                            <DialogTitle className="dialogboxtitlecolour p-1">
                                <center>View BCD Notification Details</center>
                            </DialogTitle>
                            <div className='dialogboxcolour'>
                                <div className='form-inline mt-2'>
                                    <label style={{ marginLeft: '27%' }}>Find Notification No</label>
                                    <input className='hi22' style={{ marginLeft: '2.5%' }} autoFocus value={ItemDialogValues.f_bcd_notificationNo}
                                        onChange={ItemDialogBcdNotifyNoChangeHandle} onKeyDown={ItemDialogBCDFindNotifiCationNoKeydown} />
                                </div>
                                <div className='form-inline mt-2'>
                                    <label style={{ marginLeft: '27%' }}>Find Notification SrNo</label>
                                    <input className='hi22' style={{ marginLeft: '1%' }} value={ItemDialogValues.f_bcd_notificationSrNo}
                                        id='ItemBcdNotifiSlNo' onChange={ItemDialogBcdNotifySrNoChangeHandle} onKeyDown={ItemDialogBCDFindNotifiCationSrlNoKeydown} />
                                </div>
                                <br></br>
                            </div>
                            <TableContainer className={classes.container}>
                                <Table stickyHeader className='table-bordered border-primary'>
                                    <TableHead>
                                        <StyledTableRow >
                                            <StyledTableCell className='p-1' align='center'>Notification No</StyledTableCell>
                                            <StyledTableCell className='p-1' align='center'>Notification srNo</StyledTableCell>
                                            <StyledTableCell className='p-1' align='center'>Rate</StyledTableCell>
                                            <StyledTableCell className='p-1' align='center'>Amount</StyledTableCell>
                                            <StyledTableCell className='p-1' align='center'>Unit</StyledTableCell>
                                            <StyledTableCell className='p-1' align='center'>Flag</StyledTableCell>
                                        </StyledTableRow>
                                    </TableHead>
                                    <TableBody>
                                        {itemRitcDetails.map((item) =>{ const selectedItem = isItemTblSelected(item.notificationId.toString());
                                            return(
                                            <TableRow key={item.notificationId} hover onClick={() => editItemBcdNotifinoDetails(item)} id='ItemBCDNotification_id'
                                            onKeyDown={(e)=>itemDialogTblKeyDown(e,'BCDNotification')} tabIndex={-1} selected={selectedItem}>
                                                <TableCell className='p-1' align='center'>{item.notificationNo}</TableCell>
                                                <TableCell className='p-1' align='center'>{item.notificationSrNo}</TableCell>
                                                <TableCell className='p-1' align='center'>{item.notificationRate}</TableCell>
                                                <TableCell className='p-1' align='center'>{item.notificationAmount}</TableCell>
                                                <TableCell className='p-1' align='center'>{item.notificationUnit}</TableCell>
                                                <TableCell className='p-1' align='center'>{item.notificationFlag}</TableCell>
                                            </TableRow>)})}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Dialog>
                        {/*-------Aidc------*/}
                        <Dialog onClose={itemAidcNotifyCloshHandle} open={ItemAidcNotifyNoOpen} fullWidth={true} maxWidth="md">
                            <DialogTitle className="dialogboxtitlecolour p-1">
                                <center>View AIDC Notn Details</center>
                            </DialogTitle>
                            <div className='dialogboxcolour'>
                                <div className='form-inline mt-2'>
                                    <label style={{ marginLeft: '27%' }}>Find Notification No</label>
                                    <input className='hi22' style={{ marginLeft: '2.4%' }} autoFocus value={ItemDialogValues.f_aidc_notificationNo}
                                        onChange={ItemDialogAidcNotifyNoChangeHandle} onKeyDown={ItemDialogAIDCFindNotifiCationNoKeydown} />
                                </div>
                                <div className='form-inline mt-2'>
                                    <label style={{ marginLeft: '27%' }}>Find Notification SrNo</label>
                                    <input className='hi22' style={{ marginLeft: '1%' }} value={ItemDialogValues.f_aidc_notificationSrNo}
                                        id='ItemAidcNotifiSlNo' onChange={ItemDialogAidcNotifySrNoChangeHandle} onKeyDown={ItemDialogAIDCFindNotifiCationSrlNoKeydown} />
                                </div>
                                <br></br>
                            </div>
                            <TableContainer className={classes.container}>
                                <Table stickyHeader className='table-bordered border-primary'>
                                    <TableHead>
                                        <StyledTableRow >
                                            <StyledTableCell className='p-1' align='center'>Notification No</StyledTableCell>
                                            <StyledTableCell className='p-1' align='center'>Notification srNo</StyledTableCell>
                                            <StyledTableCell className='p-1' align='center'>Rate</StyledTableCell>
                                            <StyledTableCell className='p-1' align='center'>Amount</StyledTableCell>
                                            <StyledTableCell className='p-1' align='center'>Unit</StyledTableCell>
                                            <StyledTableCell className='p-1' align='center'>Flag</StyledTableCell>
                                        </StyledTableRow>
                                    </TableHead>
                                    <TableBody>
                                        {itemRitcDetails.map((item) => { const selectedItem = isItemTblSelected(item.notificationId.toString());
                                            return(
                                            <TableRow key={item.notificationId} hover onClick={() => editItemAidcNotifinoDetails(item)} id='ItemAIDC_Notification_id'
                                            onKeyDown={(e)=>itemDialogTblKeyDown(e,'AIDC_Notification')} tabIndex={-1} selected={selectedItem}>
                                                <TableCell className='p-1' align='center'>{item.notificationNo}</TableCell>
                                                <TableCell className='p-1' align='center'>{item.notificationSrNo}</TableCell>
                                                <TableCell className='p-1' align='center'>{item.notificationRate}</TableCell>
                                                <TableCell className='p-1' align='center'>{item.notificationAmount}</TableCell>
                                                <TableCell className='p-1' align='center'>{item.notificationUnit}</TableCell>
                                                <TableCell className='p-1' align='center'>{item.notificationFlag}</TableCell>
                                            </TableRow>)})}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Dialog>
                        {/*-------sws------*/}
                        <Dialog onClose={itemSwsNotifyCloshHandle} open={ItemSwsNotifyNoOpen} fullWidth={true} maxWidth="md">
                            <DialogTitle className="dialogboxtitlecolour p-1">
                                <center>View SWS Notn Details</center>
                            </DialogTitle>
                            <div className='dialogboxcolour'>
                                <div className='form-inline mt-2'>
                                    <label style={{ marginLeft: '27%' }}>Find Notification No</label>
                                    <input className='hi22' style={{ marginLeft: '2.4%' }} autoFocus value={ItemDialogValues.f_SWS_notificationNo}
                                        onChange={ItemDialogSWSNotifyNoChangeHandle} onKeyDown={ItemDialogSWsFindNotifiCationNoKeydown} />
                                </div>
                                <div className='form-inline mt-2'>
                                    <label style={{ marginLeft: '27%' }}>Find Notification SrNo</label>
                                    <input className='hi22' style={{ marginLeft: '1%' }} value={ItemDialogValues.f_SWS_notificationSrNo}
                                        id='ItemSwsFindNotifiSlNo' onChange={ItemDialogSWSNotifySrNoChangeHandle} onKeyDown={ItemDialogSWsFindNotifiCationSrlNoKeydown}/>
                                </div>
                                <br></br>
                            </div>
                            <TableContainer className={classes.container}>
                                <Table stickyHeader className='table-bordered border-primary'>
                                    <TableHead>
                                        <StyledTableRow >
                                            <StyledTableCell className='p-1' align='center'>Notification No</StyledTableCell>
                                            <StyledTableCell className='p-1' align='center'>Notification srNo</StyledTableCell>
                                            <StyledTableCell className='p-1' align='center'>Rate</StyledTableCell>
                                            <StyledTableCell className='p-1' align='center'>Amount</StyledTableCell>
                                            <StyledTableCell className='p-1' align='center'>Unit</StyledTableCell>
                                            <StyledTableCell className='p-1' align='center'>Flag</StyledTableCell>
                                        </StyledTableRow>
                                    </TableHead>
                                    <TableBody>
                                        {itemRitcDetails.map((item) => { const selectedItem = isItemTblSelected(item.notificationId.toString());
                                            return(
                                            <TableRow key={item.notificationId} hover onClick={() => editItemSWSNotifinoDetails(item)} id='ItemSws_Notification_id'
                                            onKeyDown={(e)=>itemDialogTblKeyDown(e,'SWS_Notification')} tabIndex={-1} selected={selectedItem}>
                                                <TableCell className='p-1' align='center'>{item.notificationNo}</TableCell>
                                                <TableCell className='p-1' align='center'>{item.notificationSrNo}</TableCell>
                                                <TableCell className='p-1' align='center'>{item.notificationRate}</TableCell>
                                                <TableCell className='p-1' align='center'>{item.notificationAmount}</TableCell>
                                                <TableCell className='p-1' align='center'>{item.notificationUnit}</TableCell>
                                                <TableCell className='p-1' align='center'>{item.notificationFlag}</TableCell>
                                            </TableRow>)})}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Dialog>
                        {/*-------CVD------*/}
                        <Dialog onClose={itemCVDNotifyCloshHandle} open={ItemCVDNotifyNoOpen} fullWidth={true} maxWidth="md">
                            <DialogTitle className="dialogboxtitlecolour p-1">
                                <center>View CVD Notify Details</center>
                            </DialogTitle>
                            <div className='dialogboxcolour'>
                                <div className='form-inline mt-2'>
                                    <label style={{ marginLeft: '27%' }}>Find Notification No</label>
                                    <input className='hi22' style={{ marginLeft: '2.4%' }} autoFocus value={ItemDialogValues.f_CVD_notificationNo}
                                        onChange={ItemDialogCVDNotifyNoChangeHandle} onKeyDown={ItemDialogCvdFindNotifiCationNoKeydown} />
                                </div>
                                <div className='form-inline mt-2'>
                                    <label style={{ marginLeft: '27%' }}>Find Notification SrNo</label>
                                    <input className='hi22' style={{ marginLeft: '1%' }} value={ItemDialogValues.f_CVD_notificationSrNo}
                                        id='cvdFindNotifiSlNo' onChange={ItemDialogCVDNotifySrNoChangeHandle} onKeyDown={ItemDialogCvdFindNotifiCationSrlNoKeydown} />
                                </div>
                                <br></br>
                            </div>
                            <TableContainer className={classes.container}>
                                <Table stickyHeader className='table-bordered border-primary'>
                                    <TableHead>
                                        <StyledTableRow >
                                            <StyledTableCell className='p-1' align='center'>Notification No</StyledTableCell>
                                            <StyledTableCell className='p-1' align='center'>Notification srNo</StyledTableCell>
                                            <StyledTableCell className='p-1' align='center'>Rate</StyledTableCell>
                                            <StyledTableCell className='p-1' align='center'>Amount</StyledTableCell>
                                            <StyledTableCell className='p-1' align='center'>Unit</StyledTableCell>
                                            <StyledTableCell className='p-1' align='center'>Flag</StyledTableCell>
                                        </StyledTableRow>
                                    </TableHead>
                                    <TableBody>
                                        {itemRitcDetails.map((item) => { const selectedItem = isItemTblSelected(item.notificationId.toString());
                                            return(
                                            <TableRow key={item.notificationId} hover onClick={() => editItemCVDNotifinoDetails(item)} id='ItemCVD_Notification_id'
                                            onKeyDown={(e)=>itemDialogTblKeyDown(e,'CVD_Notification')} tabIndex={-1} selected={selectedItem}>
                                                <TableCell className='p-1' align='center'>{item.notificationNo}</TableCell>
                                                <TableCell className='p-1' align='center'>{item.notificationSrNo}</TableCell>
                                                <TableCell className='p-1' align='center'>{item.notificationRate}</TableCell>
                                                <TableCell className='p-1' align='center'>{item.notificationAmount}</TableCell>
                                                <TableCell className='p-1' align='center'>{item.notificationUnit}</TableCell>
                                                <TableCell className='p-1' align='center'>{item.notificationFlag}</TableCell>
                                            </TableRow>)})}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Dialog>
                        {/*-------EDU.CESS------*/}
                        <Dialog onClose={itemEDUCessNotifyCloshHandle} open={ItemEDuCessNotifyNoOpen} fullWidth={true} maxWidth="md">
                            <DialogTitle className="dialogboxtitlecolour p-1">
                                <center>View EDU.CESS Notify Details</center>
                            </DialogTitle>
                            <div className='dialogboxcolour'>
                                <div className='form-inline mt-2'>
                                    <label style={{ marginLeft: '27%' }}>Find Notification No</label>
                                    <input className='hi22' style={{ marginLeft: '2.4%' }} autoFocus value={ItemDialogValues.f_EDU_notificationNo}
                                        onChange={ItemDialogEDUNotifyNoChangeHandle} onKeyDown={ItemDialogEDUCessFindNotifiCationNoKeydown} />
                                </div>
                                <div className='form-inline mt-2'>
                                    <label style={{ marginLeft: '27%' }}>Find Notification SrNo</label>
                                    <input className='hi22' style={{ marginLeft: '1%' }} value={ItemDialogValues.f_EDU_notificationSrNo}
                                        id='ItemEduCessFindNotifiSlNo' onChange={ItemDialogEDUNotifySrNoChangeHandle} onKeyDown={ItemDialogEDUCessFindNotifiCationSrlNoKeydown} />
                                </div>
                                <br></br>
                            </div>
                            <TableContainer className={classes.container}>
                                <Table stickyHeader className='table-bordered border-primary'>
                                    <TableHead>
                                        <StyledTableRow >
                                            <StyledTableCell className='p-1' align='center'>Notification No</StyledTableCell>
                                            <StyledTableCell className='p-1' align='center'>Notification srNo</StyledTableCell>
                                            <StyledTableCell className='p-1' align='center'>Rate</StyledTableCell>
                                            <StyledTableCell className='p-1' align='center'>Amount</StyledTableCell>
                                            <StyledTableCell className='p-1' align='center'>Unit</StyledTableCell>
                                            <StyledTableCell className='p-1' align='center'>Flag</StyledTableCell>
                                        </StyledTableRow>
                                    </TableHead>
                                    <TableBody>
                                        {itemRitcDetails.map((item) => { const selectedItem = isItemTblSelected(item.notificationId.toString());
                                            return(
                                            <TableRow key={item.notificationId} hover onClick={() => editItemEDUCessNotifinoDetails(item)} id='ItemEDU_Notification_id'
                                            onKeyDown={(e)=>itemDialogTblKeyDown(e,'EDU_Notification')} tabIndex={-1} selected={selectedItem}>
                                                <TableCell className='p-1' align='center'>{item.notificationNo}</TableCell>
                                                <TableCell className='p-1' align='center'>{item.notificationSrNo}</TableCell>
                                                <TableCell className='p-1' align='center'>{item.notificationRate}</TableCell>
                                                <TableCell className='p-1' align='center'>{item.notificationAmount}</TableCell>
                                                <TableCell className='p-1' align='center'>{item.notificationUnit}</TableCell>
                                                <TableCell className='p-1' align='center'>{item.notificationFlag}</TableCell>
                                            </TableRow>)})}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Dialog>
                        {/*-------IGSt.Duty------*/}
                        <Dialog onClose={itemIGSTDutyNotifyCloshHandle} open={ItemIGSTDutyNotifyNoOpen} fullWidth={true} maxWidth="md">
                            <DialogTitle className="dialogboxtitlecolour p-1">
                                <center>View IGST Notify Details</center>
                            </DialogTitle>
                            <div className='dialogboxcolour'>
                                <div className='form-inline mt-2'>
                                    <label style={{ marginLeft: '27%' }}>Find Notification No</label>
                                    <input className='hi22' style={{ marginLeft: '2.4%' }} autoFocus value={ItemDialogValues.f_IGSTDuty_notificationNo}
                                        onChange={ItemDialogIGSTDutyNotifyNoChangeHandle} onKeyDown={ItemDialogIGSTFindNotifiCationNoKeydown} />
                                </div>
                                <div className='form-inline mt-2'>
                                    <label style={{ marginLeft: '27%' }}>Find Notification SrNo</label>
                                    <input className='hi22' style={{ marginLeft: '1%' }} value={ItemDialogValues.f_IGSTDuty_notificationSrNo}
                                        id='ItemIgstFindNotifiSlNo' onChange={ItemDialogIGSTDutynotifySrNoChangeHandle} onKeyDown={ItemDialogIGSTFindNotifiCationSrlNoKeydown} />
                                </div>
                                <br></br>
                            </div>
                            <TableContainer className={classes.container}>
                                <Table stickyHeader className='table-bordered border-primary'>
                                    <TableHead>
                                        <StyledTableRow >
                                            <StyledTableCell className='p-1' align='center'>Notification No</StyledTableCell>
                                            <StyledTableCell className='p-1' align='center'>Notification srNo</StyledTableCell>
                                            <StyledTableCell className='p-1' align='center'>Rate</StyledTableCell>
                                            <StyledTableCell className='p-1' align='center'>Amount</StyledTableCell>
                                            <StyledTableCell className='p-1' align='center'>Unit</StyledTableCell>
                                            <StyledTableCell className='p-1' align='center'>Flag</StyledTableCell>
                                        </StyledTableRow>
                                    </TableHead>
                                    <TableBody>
                                        {itemRitcDetails.map((item) => { const selectedItem = isItemTblSelected(item.notificationId.toString());
                                            return(
                                            <TableRow key={item.notificationId} hover onClick={() => editItemIgstDutyNotifinoDetails(item)} id='ItemIGST_Notification_id'
                                            onKeyDown={(e)=>itemDialogTblKeyDown(e,'IGST_Notification')} tabIndex={-1} selected={selectedItem}>
                                                <TableCell className='p-1' align='center'>{item.notificationNo}</TableCell>
                                                <TableCell className='p-1' align='center'>{item.notificationSrNo}</TableCell>
                                                <TableCell className='p-1' align='center'>{item.notificationRate}</TableCell>
                                                <TableCell className='p-1' align='center'>{item.notificationAmount}</TableCell>
                                                <TableCell className='p-1' align='center'>{item.notificationUnit}</TableCell>
                                                <TableCell className='p-1' align='center'>{item.notificationFlag}</TableCell>
                                            </TableRow>)})}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Dialog>
                        {/*-------IGSt.Cess------*/}
                        <Dialog onClose={itemIGSTCessNotifyCloshHandle} open={ItemIGSTCessNotifyNoOpen} fullWidth={true} maxWidth="md">
                            <DialogTitle className="dialogboxtitlecolour p-1">
                                <center>View IGST CESS Notify Details</center>
                            </DialogTitle>
                            <div className='dialogboxcolour'>
                                <div className='form-inline mt-2'>
                                    <label style={{ marginLeft: '27%' }}>Find Notification No</label>
                                    <input className='hi22' style={{ marginLeft: '2.4%' }} autoFocus value={ItemDialogValues.f_IGSTCess_notificationNo}
                                        onChange={ItemDialogIGSTCessNotifyNoChangeHandle} onKeyDown={ItemDialogIgstCessFindNotifiCationNoKeydown} />
                                </div>
                                <div className='form-inline mt-2'>
                                    <label style={{ marginLeft: '27%' }}>Find Notification SrNo</label>
                                    <input className='hi22' style={{ marginLeft: '1%' }} value={ItemDialogValues.f_IGSTCess_notificationSrNo}
                                        id='ItemIgstCessNotifiSlNo' onChange={ItemDialogIGSTCessnotifySrNoChangeHandle} onKeyDown={ItemDialogIgstCessFindNotifiCationSrlNoKeydown} />
                                </div>
                                <br></br>
                            </div>
                            <TableContainer className={classes.container}>
                                <Table stickyHeader className='table-bordered border-primary'>
                                    <TableHead>
                                        <StyledTableRow >
                                            <StyledTableCell className='p-1' align='center'>Notification No</StyledTableCell>
                                            <StyledTableCell className='p-1' align='center'>Notification srNo</StyledTableCell>
                                            <StyledTableCell className='p-1' align='center'>Rate</StyledTableCell>
                                            <StyledTableCell className='p-1' align='center'>Amount</StyledTableCell>
                                            <StyledTableCell className='p-1' align='center'>Unit</StyledTableCell>
                                            <StyledTableCell className='p-1' align='center'>Flag</StyledTableCell>
                                        </StyledTableRow>
                                    </TableHead>
                                    <TableBody>
                                        {itemRitcDetails.map((item) => { const selectedItem = isItemTblSelected(item.notificationId.toString());
                                            return(
                                            <TableRow key={item.notificationId} hover onClick={() => editItemIgstCessNotifinoDetails(item)} id='ItemIGST_CessNotification_id'
                                            onKeyDown={(e)=>itemDialogTblKeyDown(e,'IGST_CessNotification')} tabIndex={-1} selected={selectedItem}>
                                                <TableCell className='p-1' align='center'>{item.notificationNo}</TableCell>
                                                <TableCell className='p-1' align='center'>{item.notificationSrNo}</TableCell>
                                                <TableCell className='p-1' align='center'>{item.notificationRate}</TableCell>
                                                <TableCell className='p-1' align='center'>{item.notificationAmount}</TableCell>
                                                <TableCell className='p-1' align='center'>{item.notificationUnit}</TableCell>
                                                <TableCell className='p-1' align='center'>{item.notificationFlag}</TableCell>
                                            </TableRow>)})}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Dialog>
                        {/*-------EXmp.Notn------*/}
                        <Dialog onClose={itemIGSTDutyExmpNotifyCloshHandle} open={ItemIgstExmpNotnOpen} fullWidth={true} maxWidth="md">
                            <DialogTitle className="dialogboxtitlecolour p-1">
                                <center>View IGST CESS Notify Details</center>
                            </DialogTitle>
                            <div className='dialogboxcolour'>
                                <div className='form-inline mt-2'>
                                    <label style={{ marginLeft: '27%' }}>Find Notification No</label>
                                    <input className='hi22' style={{ marginLeft: '2.4%' }} autoFocus value={ItemDialogValues.f_IGSTDutyExmp_notificationNo}
                                        onChange={ItemDialogIGSTDutyExmpNotifyNoChangeHandle} onKeyDown={ItemDialogIgstExampFindNotifiCationNoKeydown} />
                                </div>
                                <div className='form-inline mt-2'>
                                    <label style={{ marginLeft: '27%' }}>Find Notification SrNo</label>
                                    <input className='hi22' style={{ marginLeft: '1%' }} value={ItemDialogValues.f_IGSTDutyExmp_notificationSrNo}
                                        id='ItemExmpNotnFindNotifiSlNo' onChange={ItemDialogIGSTDutyExmpnotifySrNoChangeHandle} onKeyDown={ItemDialogIgstExampFindNotifiCationSrlNoKeydown} />
                                </div>
                                <br></br>
                            </div>
                            <TableContainer className={classes.container}>
                                <Table stickyHeader className='table-bordered border-primary'>
                                    <TableHead>
                                        <StyledTableRow >
                                            <StyledTableCell className='p-1' align='center'>Notification No</StyledTableCell>
                                            <StyledTableCell className='p-1' align='center'>Notification srNo</StyledTableCell>
                                            <StyledTableCell className='p-1' align='center'>Rate</StyledTableCell>
                                            <StyledTableCell className='p-1' align='center'>Amount</StyledTableCell>
                                            <StyledTableCell className='p-1' align='center'>Unit</StyledTableCell>
                                            <StyledTableCell className='p-1' align='center'>Flag</StyledTableCell>
                                        </StyledTableRow>
                                    </TableHead>
                                    <TableBody>
                                        {itemRitcDetails.map((item) => { const selectedItem = isItemTblSelected(item.notificationId.toString());
                                            return(
                                            <TableRow key={item.notificationId} hover onClick={() => editItemIgstDutyExmpNotifinoDetails(item)} id='ItemExce_Notification_id'
                                            onKeyDown={(e)=>itemDialogTblKeyDown(e,'Exc_notn')} tabIndex={-1} selected={selectedItem}>
                                                <TableCell className='p-1' align='center'>{item.notificationNo}</TableCell>
                                                <TableCell className='p-1' align='center'>{item.notificationSrNo}</TableCell>
                                                <TableCell className='p-1' align='center'>{item.notificationRate}</TableCell>
                                                <TableCell className='p-1' align='center'>{item.notificationAmount}</TableCell>
                                                <TableCell className='p-1' align='center'>{item.notificationUnit}</TableCell>
                                                <TableCell className='p-1' align='center'>{item.notificationFlag}</TableCell>
                                            </TableRow>)})}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Dialog>
                    </div>
                    {/*  */}
                    <div>
                        {/*--- SchemeCode ---*/}
                        <Dialog onClose={ItemSchemeCodeCloshHandle} open={ItemSchemeCodeOpen} fullWidth={true} maxWidth="md">
                            <div>
                                <Dialog onClose={ItemSchemeCodeDetailsCloshHandle} open={ItemSchemeCodeDetailsOpen} fullWidth={true} maxWidth="md">
                                    <DialogTitle className="dialogboxtitlecolour p-1">
                                        <center>View Scheme Code Details</center>
                                    </DialogTitle>
                                    <div className='dialogboxcolour'>
                                        <div className='form-inline mt-2'>
                                            <label style={{ marginLeft: '30%' }}>Find scheme Code</label>
                                            <input style={{ textTransform: 'uppercase', marginLeft: '1.5%' }} onKeyDown={ItemDialogFindSchemeCodeKeyDown}
                                                autoFocus value={ItemDialogValues.f_scheme_code} onChange={ItemDialogFindSchemeCodeChngHandle} />
                                        </div>
                                        <div className='form-inline mt-2 mb-2'>
                                            <label style={{ marginLeft: '30%' }}>Find scheme Name</label>
                                            <input style={{ textTransform: 'uppercase', marginLeft: '1%' }} onKeyDown={ItemDialogFindSchemeNameKeyDown}
                                            id='SchemeCode_findSchemeName_id' value={ItemDialogValues.f_scheme_codeName} onChange={ItemDialogFindSchemeNameChngHandle} />
                                        </div>
                                    </div>
                                    <TableContainer className={classes.container}>
                                        <Table stickyHeader className='table-bordered border-primary'>
                                            <TableHead>
                                                <StyledTableRow >
                                                    <StyledTableCell className='p-1' align='center'>SchemeCode</StyledTableCell>
                                                    <StyledTableCell className='p-1' align='center'>SchemeName</StyledTableCell>
                                                </StyledTableRow>
                                            </TableHead>
                                            <TableBody>
                                                {itemSchemeCodeDetails.map((item) => { const selectedItem = isItemTblSelected(item.schemeCode);
                                                    return(
                                                    <TableRow key={item.schemeDesc} hover onClick={() => editItemSchemeDetails(item)} id='ItemFind_SchemaCode_id'
                                                    onKeyDown={(e)=>itemDialogSchemeCodeTblKeyDown(e,'schemecode')} tabIndex={-1} selected={selectedItem}>
                                                        <TableCell className='p-1' align='center'>{item.schemeCode}</TableCell>
                                                        <TableCell className='p-1' align='center'>{item.schemeDesc}</TableCell>
                                                    </TableRow>)})}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </Dialog>
                                {/*  */}
                                <Dialog onClose={ItemSchemeNotnDetailsCloshHandle} open={ItemSchemeNotenDetailsOpen} fullWidth={true} maxWidth="md">
                                    <DialogTitle className="dialogboxtitlecolour p-1">
                                        <center>View IGST Notn Details</center>
                                    </DialogTitle>
                                    <div className='dialogboxcolour'>
                                        <div className='form-inline mt-2'>
                                            <label style={{ marginLeft: '30%' }}>Find Notification.No</label>
                                            <input style={{ textTransform: 'uppercase', marginLeft: '2.75%' }} onKeyDown={ItemDialogFindSchemaIgstNotnNoKeyDown}
                                                autoFocus value={ItemDialogValues.f_IGST_notificationNo} onChange={ItemDialogFindSchemeNotnChngHandle} />
                                        </div>
                                        <div className='form-inline mt-1 mb-2'>
                                            <label style={{ marginLeft: '30%' }}>Find NotificationSrl.No</label>
                                            <input style={{ textTransform: 'uppercase', marginLeft: '1%' }} onKeyDown={ItemDialogFindSchemaIgstNotnSrlNoKeyDown}
                                            id='DialodFindSchema_IgstNotn_id' value={ItemDialogValues.f_IGST_notificationSrNo} onChange={ItemDialogFindSchemeSrlNoChngHandle} />
                                        </div>
                                    </div>
                                    <TableContainer className={classes.container}>
                                        <Table stickyHeader className='table-bordered border-primary'>
                                            <TableHead>
                                                <StyledTableRow >
                                                    <StyledTableCell className='p-1' align='center'>Notification.NO</StyledTableCell>
                                                    <StyledTableCell className='p-1' align='center'>Notification.SrlNo</StyledTableCell>
                                                    <StyledTableCell className='p-1' align='center'>Rate</StyledTableCell>
                                                    <StyledTableCell className='p-1' align='center'>Amount</StyledTableCell>
                                                    <StyledTableCell className='p-1' align='center'>Unit</StyledTableCell>
                                                    <StyledTableCell className='p-1' align='center'>Flag</StyledTableCell>
                                                </StyledTableRow>
                                            </TableHead>
                                            <TableBody>
                                                {itemSchemeCodeDetails.map((item) => { const selectedItem = isItemTblSelected(item.notificationNo);
                                                    return(
                                                    <TableRow key={item.notificationId} hover onClick={() => editItemSchemeNotifiDetails(item)} id='ItemFind_Schema_IGSTnotn_id'
                                                    onKeyDown={(e)=>itemDialogSchemeCodeTblKeyDown(e,'igstNotn')} tabIndex={-1} selected={selectedItem}>
                                                        <TableCell className='p-1' align='center'>{item.notificationNo}</TableCell>
                                                        <TableCell className='p-1' align='center'>{item.notificationSrNo}</TableCell>
                                                        <TableCell className='p-1' align='center'>{item.notificationRate}</TableCell>
                                                        <TableCell className='p-1' align='center'>{item.notificationAmount}</TableCell>
                                                        <TableCell className='p-1' align='center'>{item.notificationUnit}</TableCell>
                                                        <TableCell className='p-1' align='center'>{item.notificationFlag}</TableCell>
                                                    </TableRow>)})}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </Dialog>
                            </div>
                            {/*  */}
                            <DialogTitle className="dialogboxtitlecolour p-1">
                                <center>Add Scheme Code</center>
                            </DialogTitle>
                            <div>
                                <div className='dialogboxcolour'>
                                    <div className='form-inline'>
                                        <label className='ml15 mt-3'>SchemeCode</label>
                                        <input style={{ marginLeft: '9.4%', textTransform: 'uppercase' }} className='wid12 hi22 mt-3' onKeyDown={itemDialogSchemeCodeOnKeyDown}
                                            autoFocus value={ItemDialogValues.scheme_code} onChange={itemDialogSchemeCodeChngHndl} />
                                        <button className='searchbutton mt-3' onClick={ItemSchemeCodeDetails_OpenHandle}>
                                            <SearchIcon fontSize="small" />
                                        </button>
                                        <input className='ml-1 hi22 mt-3' disabled value={ItemDialogValues.scheme_codeName} style={{ width: '29.7%' }} />
                                    </div>
                                    <div className='form-inline mt-1'>
                                        <label className='ml15'>Notification.No</label>
                                        <input style={{ marginLeft: '8%', textTransform: 'uppercase' }} className='wid12 hi22' id='schem_notifi_no' onKeyDown={itemDialogSchemeNotnNoOnKeyDown}
                                            value={ItemDialogValues.notofi_no} onChange={itemDialogShemNotificationNoChngHndl} />
                                        <button className='searchbutton' onClick={ItemSchemeNotnDetails_OpenHandle}>
                                            <SearchIcon fontSize="small" />
                                        </button>
                                        <label className='ml-1'>Sl.No</label>
                                        <input className='ml-1 wid12 hi22' onKeyDown={itemDialogSchemeSrlNoeOnKeyDown} onBlur={getSchemeNotifiDetails}
                                            value={ItemDialogValues.srl_no} onChange={itemDialogShemSrlNoChngHndl} id='scheme_SrlNo' />
                                        <label className='ml-1'>Rate</label>
                                        <input className='ml-1 hi22 wid1' disabled value={ItemDialogValues.rate} />
                                    </div>
                                    <div className='form-inline mt-1'>
                                        <label className='ml15'>ExemptionRequired(Y/N)</label>
                                        <input style={{ textTransform: 'uppercase', textAlign: 'center', marginLeft: '1.5%' }} className='hi22 wid5'
                                            id='Scheme_excemption' onKeyDown={itemDialogSchemeExcemptionOnKeyDown}
                                            value={ItemDialogValues.exemptionrequired} onChange={itemDialogShemExcempRquiredChngHndl} />
                                    </div>
                                    <div className='form-inline mt-1'>
                                        <label className='ml15'>Re-Export(Y/N)</label>
                                        <input style={{ textTransform: 'uppercase', textAlign: 'center', marginLeft: '8%' }} className='hi22 wid5'
                                            id='Re-ExportDialog' onKeyDown={itemDialogSchemeReExportOnKeyDown} value={ItemDialogValues.re_export} onChange={itemDialogShemreExportChngHndl} />
                                    </div>
                                    <div className='form-inline mt-1'>
                                        <label className='ml15'>Sec-20(Y/N)</label>
                                        <input style={{ textTransform: 'uppercase', textAlign: 'center', marginLeft: '9.8%' }} className='hi22 wid5'
                                            id='sec_20DialogSchem' onKeyDown={itemDialogSchemeSec20OnKeyDown} value={ItemDialogValues.sec_20} onChange={itemDialogShemSec_20ChngHndl} />
                                    </div>
                                    <div className='mt-2 mb-1'>
                                        <center>
                                            <Button size='small' variant="contained" color="primary" className='mr-1' disabled={ItemSchemeSaveDsa} onClick={ItemAddSchemeSave}>{ItemSchemeSve ? 'Processing..' : 'Save'}</Button>{' '}
                                            <Button size='small' variant="contained" color="primary" className='mr-1' disabled={ItemSchemeUpdateDsa} onClick={ItemAddSchemeUpdate}>{ItemSchemeUpd ? 'Processing..' : 'Update'}</Button>{' '}
                                            <Button size='small' variant="contained" color="primary" className='mr-1' disabled={ItemSchemeDeleteDsa} onClick={ItemAddSchemeDelete}>{ItemSchemeDlt ? 'Processing..' : 'Delete'}</Button>{' '}
                                            <Button size='small' variant="contained" color="primary" onKeyDown={itemDialogSchemeRefBtnKeyDown} onClick={SchemeCodeReset}>Refresh</Button>{' '}
                                        </center>
                                    </div>
                                </div>
                                <TableContainer className={classes.container}>
                                    <Table stickyHeader className='table-bordered border-primary'>
                                        <TableHead>
                                            <StyledTableRow >
                                                <StyledTableCell className='p-1' align='center'>Sl.No</StyledTableCell>
                                                <StyledTableCell className='p-1' align='center'>SchemeCode</StyledTableCell>
                                                <StyledTableCell className='p-1' align='center'>NotficationNo</StyledTableCell>
                                                <StyledTableCell className='p-1' align='center'>Notn Srl.No</StyledTableCell>
                                                <StyledTableCell className='p-1' align='center'>ExcemptionReport</StyledTableCell>
                                            </StyledTableRow>
                                        </TableHead>
                                        <TableBody>
                                            {itemRitcDetails.map((item) => { const selectedItem = isItemTblSelected(item.schemeCode);
                                                return(
                                                <TableRow key={item.schemeCode} hover onClick={() => editItemSchemeCodeDetails(item)} id='Item_Schema_CodeDetails_id'
                                                onKeyDown={(e)=>itemDialogTblKeyDown(e,'ShemaCode')} tabIndex={-1} selected={selectedItem}>
                                                    <TableCell className='p-1' align='center'>{item.serialNumber}</TableCell>
                                                    <TableCell className='p-1' align='center'>{item.schemeCode}</TableCell>
                                                    <TableCell className='p-1' align='center'>{item.notificationNo}</TableCell>
                                                    <TableCell className='p-1' align='center'>{item.notificationSrNo}</TableCell>
                                                    <TableCell className='p-1' align='center'>{item.excemptionReq}</TableCell>
                                                </TableRow>)})}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </div>
                        </Dialog>
                        {/*-- -AuntiDumbing- ----*/}
                        <Dialog onClose={ItemAuntiDumbingCloshHandle} open={ItemAuntiDumpingOpen} fullWidth={true} maxWidth="md">
                            {/*  */}
                            <Dialog onClose={ItemAuntiNotifiCloshHandle} open={ItemAuntiNotifiOpen} fullWidth={true} maxWidth="md">
                                <DialogTitle className="dialogboxtitlecolour p-1">
                                    <center>View Aunti Dumping Details</center>
                                </DialogTitle>
                                <div className='dialogboxcolour'>
                                    <div className='form-inline mt-2'>
                                        <label style={{ marginLeft: '31.2%' }}>Find Notification.No</label>
                                        <input style={{ textTransform: 'uppercase' }} className='ml-3' autoFocus onKeyDown={ItemDialogFindAuntiDump_notn_noKeyDown}
                                            value={ItemDialogValues.f_auntiDump_notn_no} onChange={ItemDialogFindAuntiDump_notn_noChngHandle} />
                                    </div>
                                    <div className='form-inline mt-1 mb-2'>
                                        <label style={{ marginLeft: '30%' }}>Find Notification Srl.No</label>
                                        <input style={{ textTransform: 'uppercase' }} className='ml-2' onKeyDown={ItemDialogFindAuntiDump_notn_SrlnoKeyDown}
                                        id='FindAuntiDumbNotifySrlNo_id' value={ItemDialogValues.f_auntiDump_Srl_no} onChange={ItemDialogFindAuntiDump_Srl_noChngHandle} />
                                    </div>
                                </div>
                                <TableContainer className={classes.container}>
                                    <Table stickyHeader className='table-bordered border-primary'>
                                        <TableHead>
                                            <StyledTableRow >
                                                <StyledTableCell className='p-1' align='center'>Notification.No</StyledTableCell>
                                                <StyledTableCell className='p-1' align='center'>NotificationSrlNo</StyledTableCell>
                                                <StyledTableCell className='p-1' align='center'>Rate</StyledTableCell>
                                                <StyledTableCell className='p-1' align='center'>Amount</StyledTableCell>
                                                <StyledTableCell className='p-1' align='center'>Unit</StyledTableCell>
                                                <StyledTableCell className='p-1' align='center'>Flag</StyledTableCell>
                                            </StyledTableRow>
                                        </TableHead>
                                        <TableBody>
                                            {itemSchemeCodeDetails.map((item) => { const selectedItem = isItemTblSelected(item.notificationNo);
                                                return(
                                                <TableRow key={item.notificationId} hover onClick={() => editItemAuntiNotifiDetails(item)} id='Item_AuntiDumb_id'
                                                onKeyDown={(e)=>itemDialogSchemeCodeTblKeyDown(e,'AuntiDumb')} tabIndex={-1} selected={selectedItem}>
                                                    <TableCell className='p-1' align='center'>{item.notificationNo}</TableCell>
                                                    <TableCell className='p-1' align='center'>{item.notificationSrNo}</TableCell>
                                                    <TableCell className='p-1' align='center'>{item.notificationRate}</TableCell>
                                                    <TableCell className='p-1' align='center'>{item.notificationAmount}</TableCell>
                                                    <TableCell className='p-1' align='center'>{item.notificationUnit}</TableCell>
                                                    <TableCell className='p-1' align='center'>{item.notificationFlag}</TableCell>
                                                </TableRow>)})}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Dialog>
                            {/*  */}
                            <DialogTitle className="dialogboxtitlecolour p-1">
                                <center>Add AuntiDumping Duty</center>
                            </DialogTitle>
                            <div>
                                <div className='dialogboxcolour'>
                                    <Col>
                                        <Row>
                                            <Col><Form.Label className='summury mt-3'>Notification.No</Form.Label></Col>
                                            <Col><input style={{ height: '23px', width: '65%' }} className='mt-3' value={ItemDialogValues.auntiDump_notn_no}
                                                autoFocus onChange={ItemAuntidmpNotnChngHndl} onKeyDown={ItemDialogFindAuntiDump_notn_noKeydown} />
                                                <button className='searchbutton mt-3' style={{ height: '22px' }} onClick={ItemAuntiNotifi_OpenHandle}>
                                                    <SearchIcon fontSize="small" /></button></Col>
                                            <Col><Form.Label className='summury mt-3'>Serial.No</Form.Label></Col>
                                            <Col><input style={{ height: '22px' }} className='mt-3' value={ItemDialogValues.auntiDump_Srl_no}
                                                onChange={ItemAuntidmpSrlNoChngHndl} id='auntiNotifiSrlNo' onBlur={getCustomNotificationAuntiDumping}
                                                onKeyDown={ItemDialogFindAuntiDump_SrlNoKeydown} /></Col>
                                        </Row>
                                        <Row>
                                            <Col><Form.Label className='summury'>CTH Serial.No</Form.Label></Col>
                                            <Col><input style={{ height: '22px' }} value={ItemDialogValues.auntiDump_cth_srl_no}
                                                onChange={ItemAuntidmpCthSrlNoChngHndl} id='AuntiDumpCthSrlNo'
                                                onKeyDown={ItemDialogFindAuntiDump_CthSrlNoKeydown} /></Col>
                                            <Col><Form.Label>Sup Serial.No</Form.Label></Col>
                                            <Col><input style={{ height: '22px' }} value={ItemDialogValues.auntiDump_sup_srl_no}
                                                onChange={ItemAuntidmpSupSrlNoChngHndl} id='AuntiDumpSubSrlNo'
                                                onKeyDown={ItemDialogFindAuntiDump_SupSrlNoKeydown} /></Col>
                                        </Row>
                                        <Row>
                                            <Col> <Form.Label className='summury'>Advalorem Rate</Form.Label></Col>
                                            <Col><input style={{ height: '22px' }} value={ItemDialogValues.auntiDump_advalorem_rate}
                                                onChange={ItemAuntidmpAdvaloremRateChngHndl} id='Advalorem_rate' onKeyDown={ItemDialogFindAuntiDump_AdvalromRateKeydown} /></Col>
                                            <Col><Form.Label>Flag</Form.Label></Col>
                                            <Col><input style={{ height: '22px' }} value={ItemDialogValues.auntiDump_flag}
                                                onChange={ItemAuntidmpFlagChngHndl} id='auntiDumbFlag' onKeyDown={ItemDialogFindAuntiDump_FlagKeydown} /></Col>
                                        </Row>
                                        <Row>
                                            <Col><Form.Label className='summury'>Quantity</Form.Label></Col>
                                            <Col><input style={{ height: '22px', width: '' }} value={ItemDialogValues.auntiDump_quantity}
                                                onChange={ItemAuntidmpQuantityChngHndl} id='AuntiDumbquantity' onKeyDown={ItemDialogFindAuntiDump_QuantityKeydown} /></Col>
                                            <Col><Form.Label>UQC</Form.Label></Col>
                                            <Col><input style={{ height: '22px' }} value={ItemDialogValues.auntiDump_uqc} id='auntiDumb_Uqc'
                                                onChange={ItemAuntidmpUnitChngHndl} onKeyDown={ItemDialogFindAuntiDump_UqcKeydown} /></Col>
                                        </Row>
                                        <Row>
                                            <Col><Form.Label className='summury'>Notifi Rate</Form.Label></Col>
                                            <Col><input disabled style={{ height: '22px', }} value={ItemDialogValues.auntiDump_notifiRate} /></Col>
                                            <Col><Form.Label>Currency</Form.Label></Col>
                                            <Col><input style={{ height: '22px' }} value={ItemDialogValues.auntiDump_currency}
                                                onChange={ItemAuntidmpCurrencyChngHndl} id='currency' onKeyDown={ItemDialogFindAuntiDump_CurruncyKeydown} /></Col>
                                        </Row>
                                        <Row>
                                            <Col><Form.Label className='summury'>Spec Amt</Form.Label></Col>
                                            <Col><input disabled style={{ height: '22px', marginLeft: '-53.5%' }} value={ItemDialogValues.auntiDump_spaceAmt} /></Col>
                                        </Row>
                                    </Col>
                                    <div className='mt-2'>
                                        <center>
                                            <Button size='small' variant="contained" color="primary" className='mr-1 mb-2' disabled={ItemAuntiDumpSaveDsa} onClick={ItemAuntiDumbSave}>{ItemAuntiDumpSve ? 'Processing...' : 'Save'}</Button>{' '}
                                            <Button size='small' variant="contained" color="primary" className='mr-1 mb-2' disabled={ItemAuntiDumpUpdateDsa} onClick={ItemAuntiDumbUpdate}>{ItemAuntiDumpUpd ? 'Processing...' : 'Update'}</Button>{' '}
                                            <Button size='small' variant="contained" color="primary" className='mr-1 mb-2' disabled={ItemAuntiDumpDeleteDsa} onClick={ItemAuntiDump_Delet}>{ItemAuntiDumpDlt ? 'Processing...' : 'Delete'}</Button>{' '}
                                            <Button size='small' variant="contained" color="primary" onKeyDown={ItemDialogFindAuntiDumpRefBtnKeydown} className='mb-2' onClick={AuntiDumpReset}>Refresh</Button>{' '}
                                        </center>
                                    </div>
                                </div>
                                <TableContainer className={classes.container}>
                                    <Table stickyHeader className='table-bordered border-primary'>
                                        <TableHead>
                                            <StyledTableRow >
                                                <StyledTableCell className='p-1' align='center'>Sl</StyledTableCell>
                                                <StyledTableCell className='p-1' align='center'>NotficationNo</StyledTableCell>
                                                <StyledTableCell className='p-1' align='center'>Sl.No</StyledTableCell>
                                                <StyledTableCell className='p-1' align='center'>Rate</StyledTableCell>
                                                <StyledTableCell className='p-1' align='center'>Flag</StyledTableCell>
                                                <StyledTableCell className='p-1' align='center'>Amount</StyledTableCell>
                                                <StyledTableCell className='p-1' align='center'>UQC</StyledTableCell>
                                            </StyledTableRow>
                                        </TableHead>
                                        <TableBody>
                                            {itemRitcDetails.map((item) => { const selectedItem = isItemTblSelected(item.notificationNo);
                                               return (
                                                <TableRow key={item.notificationId} hover onClick={() => editItemAuntiDumpingDetails(item)} id='Item_Aunti_dump_dutyDetails_id'
                                                onKeyDown={(e)=>itemDialogTblKeyDown(e,'AuntiDumDuty')} tabIndex={-1} selected={selectedItem}>
                                                    <TableCell className='p-1' align='center'>{item.serialNumber}</TableCell>
                                                    <TableCell className='p-1' align='center'>{item.notificationNo}</TableCell>
                                                    <TableCell className='p-1' align='center'>{item.notificationSrNo}</TableCell>
                                                    <TableCell className='p-1' align='center'>{item.notificationRate}</TableCell>
                                                    <TableCell className='p-1' align='center'>{item.notificationFlag}</TableCell>
                                                    <TableCell className='p-1' align='center'>{item.notificationAmount}</TableCell>
                                                    <TableCell className='p-1' align='center'>{item.notificationUnit}</TableCell>
                                                </TableRow>)})}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </div>
                        </Dialog>
                        {/* ---Sw-Info--- */}
                        <Dialog onClose={ItemSwInfoCloshHandle} open={ItemSwInfoOpen} fullWidth={true} maxWidth="sm">
                            <DialogTitle className="dialogboxtitlecolour p-1">
                                <center>Add SW Info</center>
                            </DialogTitle>
                            <div>
                                <div className='dialogboxcolour'>
                                    <div className='form-inline ml-4'>
                                        <Form.Label className='ml-4 summury mt-2'>SW Type</Form.Label>
                                        <select className='hi22 wid12 ml-2 mr-1 mt-2' value={ItemDialogValues.SwType} autoFocus
                                            onChange={ItemDialogSwTypeChngHandl} onKeyDown={ItemDialogSwTypeKeyDown}>
                                            <option>{''}</option>{
                                                itemSwInfoTypeDrp.map((item) => (
                                                    <option value={item.swCode}>{item.swCode}</option>
                                                ))}
                                        </select>
                                        <Form.Label className='ml-1 summury mt-2'>SW Qualifier</Form.Label>
                                        <select className='hi22 wid12 ml1_5 mt-2' value={ItemDialogValues.SwQwalifier} id='swQWalifer'
                                            onChange={ItemDialogSwQualifierChngHandl} onKeyDown={ItemDialogSwQualifierKeyDown}>
                                            <option>{''}</option>{
                                                ItemSwQualifrDrp.map((item) => (
                                                    <option value={item.swQualifier}>{item.swQualifier}</option>
                                                ))}
                                        </select>
                                        <Form.Label className='ml-2 mt-2'>SW Code</Form.Label>
                                        <select className='hi22 wid12 ml-2 mt-2' value={ItemDialogValues.SwCode}
                                            onChange={ItemDialogSwCodeChngHandl} id='swCode' onKeyDown={ItemDialogSwCodeKeyDown}>
                                            <option>{''}</option>{
                                                ItemSwCodeDrp.map((item) => (
                                                    <option value={item.swCode}>{item.swCode}</option>
                                                ))}
                                        </select>
                                    </div>
                                    <div className='form-inline mt-2 ml-4'>
                                        <Form.Label className='ml-4'>SW Text</Form.Label>
                                        <input className='hi22 wid12 ml2' value={ItemDialogValues.SwText}
                                            onChange={ItemDialogSwTextChngHandl} id='swText' onKeyDown={ItemDialogSwTextKeyDown} />
                                        <Form.Label className='ml-1'>Measurnment</Form.Label>
                                        <input className='hi22 wid12 ml-1' value={ItemDialogValues.sw_mesurnment}
                                            onChange={ItemDialogSwMeasurementChngHandl} id='swMeadureMent' onKeyDown={ItemDialogSwMesurementKeyDown} />
                                        <Form.Label className='ml2'>SW UQC</Form.Label>
                                        <select className='hi22 wid12 ml1_8' value={ItemDialogValues.Sw_Uqc}
                                            onChange={ItemDialogSwUqcChngHandl} id='swUqc' onKeyDown={ItemDialogSwUqcKeyDown}>
                                            <option>{''}</option>{
                                                ItemSwUQCDrp.map((item) => (
                                                    <option value={item.unitCode}>{item.unitCode}</option>
                                                ))}
                                        </select>
                                    </div>
                                    <div className='mt-2 mb-1'>
                                        <center>
                                            <Button size='small' variant="contained" color="primary" className='mr-1' disabled={ItemSwInfoSaveDsa} onClick={ItemAddSwInfoSave}>{ItemSwInfoSve ? 'Processing...' : 'Save'}</Button>{' '}
                                            <Button size='small' variant="contained" color="primary" className='mr-1' disabled={ItemSwInfoUpdateDsa} onClick={ItemAddSwInfoUpdate}>{ItemSwInfoUpd ? 'Processing...' : 'Update'}</Button>{' '}
                                            <Button size='small' variant="contained" color="primary" className='mr-1' disabled={ItemSwInfoDeleteDsa} onClick={ItemAddSwInfoDelete}>{ItemSwInfoDlt ? 'Processing...' : 'Delete'}</Button>{' '}
                                            <Button size='small' variant="contained" color="primary" onKeyDown={ItemDialogSwRefBtnKeyDown} onClick={SwInfoReset}>Refresh</Button>{' '}
                                        </center>
                                    </div>
                                </div>
                                <TableContainer className={classes.container}>
                                    <Table stickyHeader className='table-bordered border-primary'>
                                        <TableHead>
                                            <StyledTableRow >
                                                <StyledTableCell className='p-1' align='center'>Sl.No</StyledTableCell>
                                                <StyledTableCell className='p-1' align='center'>Type</StyledTableCell>
                                                <StyledTableCell className='p-1' align='center'>Qualifier</StyledTableCell>
                                                <StyledTableCell className='p-1' align='center'>Code</StyledTableCell>
                                                <StyledTableCell className='p-1' align='center'>Text</StyledTableCell>
                                                <StyledTableCell className='p-1' align='center'>Measurnment</StyledTableCell>
                                                <StyledTableCell className='p-1' align='center'>UQC</StyledTableCell>
                                            </StyledTableRow>
                                        </TableHead>
                                        <TableBody>
                                            {itemRitcDetails.map((item) => { const selectedItem = isItemTblSelected(item.swType);
                                                return(
                                                <TableRow key={item.swType} hover onClick={() => editItemSwInfoDetails(item)} id='Item_Sw_type_Details_id'
                                                onKeyDown={(e)=>itemDialogTblKeyDown(e,'Sw_type')} tabIndex={-1} selected={selectedItem}>
                                                    <TableCell className='p-1' align='center'>{item.serialNumber}</TableCell>
                                                    <TableCell className='p-1' align='center'>{item.swType}</TableCell>
                                                    <TableCell className='p-1' align='center'>{item.swQualifier}</TableCell>
                                                    <TableCell className='p-1' align='center'>{item.swCode}</TableCell>
                                                    <TableCell className='p-1' align='center'>{item.swtxt}</TableCell>
                                                    <TableCell className='p-1' align='center'>{item.swMsr}</TableCell>
                                                    <TableCell className='p-1' align='center'>{item.unitCode}</TableCell>
                                                </TableRow>)})}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </div>
                        </Dialog>
                        {/* --licence-- */}
                        <Dialog onClose={ItemLicenceCloshHandle} open={ItemLicenceOpen} fullWidth={true} maxWidth="md">
                            <DialogTitle className="dialogboxtitlecolour p-1">
                                <center>Add Licence Details</center>
                            </DialogTitle>
                            {/*  */}
                            <Dialog onClose={ItemLicenceCodeCloshHandle} open={ItemLicencCodeeOpen} fullWidth={true} maxWidth="md">
                                <DialogTitle className="dialogboxtitlecolour p-1">
                                    <center>View Licence Code</center>
                                </DialogTitle>
                                <div className='dialogboxcolour'>
                                    <div className='form-inline mt-2'>
                                        <label style={{ marginLeft: '30%' }}>Find schemeCode</label>
                                        <input style={{ textTransform: 'uppercase' }} className='ml-3' autoFocus onKeyDown={ItemDialogLicenceFindSchemCodeKeyDown}
                                            value={ItemDialogValues.f_scheme_code} onChange={ItemDialogFindSchemeCodeChngHandle} />
                                    </div>
                                    <div className='form-inline mt-1 mb-2'>
                                        <label style={{ marginLeft: '30%' }}>Find schemeName</label>
                                        <input style={{ textTransform: 'uppercase' }} className='ml1_2' onKeyDown={ItemDialogLicenceFindSchemNameKeyDown}
                                        id='Licence_FindShemaName_id' value={ItemDialogValues.f_scheme_codeName} onChange={ItemDialogFindSchemeNameChngHandle} />
                                    </div>
                                </div>
                                <TableContainer className={classes.container}>
                                    <Table stickyHeader className='table-bordered border-primary'>
                                        <TableHead>
                                            <StyledTableRow >
                                                <StyledTableCell className='p-1' align='center'>SchemeCode</StyledTableCell>
                                                <StyledTableCell className='p-1' align='center'>SchemeName</StyledTableCell>
                                            </StyledTableRow>
                                        </TableHead>
                                        <TableBody>
                                            {itemSchemeCodeDetails.map((item) => { const selectedItem = isItemTblSelected(item.schemeCode);
                                                return(
                                                <TableRow key={item.schemeDesc} hover onClick={() => editItemLicenceCodeDetails(item)} id='Item_view_LicenceCode_id'
                                                onKeyDown={(e)=>itemDialogSchemeCodeTblKeyDown(e,'FindLicenceCode')} tabIndex={-1} selected={selectedItem}>
                                                    <TableCell className='p-1' align='center'>{item.schemeCode}</TableCell>
                                                    <TableCell className='p-1' align='center'>{item.schemeDesc}</TableCell>
                                                </TableRow>)})}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Dialog>
                            {/*  */}
                            <Dialog onClose={ItemLicencePortCloshHandle} open={ItemLicencPortOpen} fullWidth={true} maxWidth="md">
                                <DialogTitle className="dialogboxtitlecolour p-1">
                                    <center>View Licence Port</center>
                                </DialogTitle>
                                <div className='dialogboxcolour'>
                                    <div className='form-inline mt-2'>
                                        <label style={{ marginLeft: '30%' }}>Find Port Code</label>
                                        <input style={{ textTransform: 'uppercase' }} className='ml-3' autoFocus onKeyDown={ItemDialogFindLicencePorteCodeKeyDown}
                                            value={ItemDialogValues.f_licencePortCode} onChange={ItemDialogFindLicenceCodeChngHandle} />
                                    </div>
                                    <div className='form-inline mt-1 mb-2'>
                                        <label style={{ marginLeft: '30%' }}>Find Port Name</label>
                                        <input style={{ textTransform: 'uppercase' }} className='ml1_2' onKeyDown={ItemDialogFindLicencePortNameKeyDown}
                                        id='LicencePort_name_id' value={ItemDialogValues.f_licencePortName} onChange={ItemDialogFindLicenceNameChngHandle} />
                                    </div>
                                </div>
                                <TableContainer className={classes.container}>
                                    <Table stickyHeader className='table-bordered border-primary'>
                                        <TableHead>
                                            <StyledTableRow >
                                                <StyledTableCell className='p-1' align='center'>LicencePortCode</StyledTableCell>
                                                <StyledTableCell className='p-1' align='center'>LicencePortName</StyledTableCell>
                                            </StyledTableRow>
                                        </TableHead>
                                        <TableBody>
                                            {itemSchemeCodeDetails.map((item) => { const selectedItem = isItemTblSelected(item.customHouseCode);
                                                return(
                                                <TableRow key={item.customHouseCode} hover onClick={() => editItemLicencePortDetails(item)} id='Item_LicencePortFind_id'
                                                onKeyDown={(e)=>itemDialogSchemeCodeTblKeyDown(e,'FindLicencePort')} tabIndex={-1} selected={selectedItem}>
                                                    <TableCell className='p-1' align='center'>{item.customHouseCode}</TableCell>
                                                    <TableCell className='p-1' align='center'>{item.customHouseLocation}</TableCell>
                                                </TableRow>)})}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Dialog>
                            {/*  */}
                            <div>
                                <div className='dialogboxcolour'>
                                    <Col>
                                        <Row>
                                            <Col><label className='mt-3'>Licence Reg.No</label></Col>
                                            <Col><input className='mt-3' style={{ height: '22px' }} value={ItemDialogValues.licence_reg_no}
                                                onChange={ItemDialogLicenceRegNoChngHandl} autoFocus onKeyDown={ItemDialogLicenceRegNoKeyDown} /></Col>
                                            <Col><label className='mt-3'>Licence Code</label></Col>
                                            <Col><input style={{ textTransform: 'uppercase', height: '22px', width: '15.5%' }} className='mt-3' value={ItemDialogValues.licence_code}
                                                id='licenceCode' onChange={ItemDialogLicenceCodeChngHandl} onKeyDown={ItemDialogLicenceCodeKeyDown} />
                                                <button className='searchbutton mt-3' onClick={ItemLicenceCode_OpenHandle}>
                                                    <SearchIcon fontSize='small' />
                                                </button>
                                                <input disabled className='mt-3' style={{ height: '22px', width: '50%' }}
                                                    value={ItemDialogValues.licence_codeName} /></Col>
                                        </Row>
                                        <Row>
                                            <Col><label>Licence Reg Date</label></Col>
                                            <Col><input type={'date'} style={{ height: '22px', width: '82%' }} value={ItemDialogValues.licence_Date}
                                                onChange={ItemDialogLicenceRegDateChngHandl} id='Lice_date' onKeyDown={ItemDialogLicenceDateKeyDown} /></Col>
                                            <Col><label>Licence Reg.Port</label></Col>
                                            <Col><input style={{ textTransform: 'uppercase', height: '22px', width: '65%' }} value={ItemDialogValues.licence_reg_port}
                                                id='LicenceRegPort' onChange={ItemDialogLicenceRegPortChngHandl} onKeyDown={ItemDialogLicenceRegPortKeyDown} />
                                                <button className='searchbutton' onClick={ItemLicencePort_OpenHandle}>
                                                    <SearchIcon fontSize='small' />
                                                </button></Col>
                                        </Row>
                                        <Row>
                                            <Col><label>Debit UOM</label></Col>
                                            <Col><select style={{ height: '22px', width: '81.5%' }} value={ItemDialogValues.Sw_Uqc}
                                                onChange={ItemDialogSwUqcChngHandl} id='debit_uom' onKeyDown={ItemDialogLicenceDebitUomKeyDown} >
                                                <option value={''}></option>
                                                {ItemSwUQCDrp.map((item) => (
                                                    <option value={item.unitCode}>{item.unitCode}</option>
                                                ))}
                                            </select></Col>
                                            <Col><label>Debit Value</label></Col>
                                            <Col><input style={{ height: '22px' }} value={ItemDialogValues.debit_value}
                                                onChange={ItemDialogDebitValueChngHandl} id='DebitValue' onKeyDown={ItemDialogLicenceDebitValueKeyDown} /></Col>
                                        </Row>
                                        <Row>
                                            <Col><label>Debit Quantity</label></Col>
                                            <Col><input style={{ height: '22px' }} value={ItemDialogValues.debit_quantity}
                                                onChange={ItemDialogDebitQuantityChngHandl} id='DebitQuantity' onKeyDown={ItemDialogLicenceDebitQuantityKeyDown} /></Col>
                                            <Col><label>Debit Duty</label></Col>
                                            <Col><input style={{ height: '22px' }} value={ItemDialogValues.debit_duty}
                                                onChange={ItemDialogDebitDutyChngHandl} id='debitDuty' onKeyDown={ItemDialogLicenceDebitDutyKeyDown} /></Col>
                                        </Row>
                                        <Row>
                                            <Col><label>TRA No</label></Col>
                                            <Col><input style={{ height: '22px' }} value={ItemDialogValues.tra_no}
                                                onChange={ItemDialogTraNoChngHandl} id='TraNo' onKeyDown={ItemDialogLicenceTraNoKeyDown} /></Col>
                                            <Col><label>TRA Date</label></Col>
                                            <Col><input type={'date'} style={{ height: '22px', width: '81.5%' }} value={ItemDialogValues.tra_date}
                                                onChange={ItemDialogTraDateChngHandl} id='TraDate' onKeyDown={ItemDialogLicenceTraDateKeyDown} /></Col>
                                        </Row>
                                        <Row>
                                            <Col><label>Item Serial No In Licence</label></Col>
                                            <Col><input style={{ height: '22px', marginLeft: '-53.3%' }} value={ItemDialogValues.Licence_item_srlNo}
                                                onChange={ItemDialogLicenceSrlNoChngHandl} id='ItemSerialNoInLicence' onKeyDown={ItemDialogLicenceItemSerialNoInKeyDown} /></Col>
                                        </Row>
                                    </Col>
                                    <div className='mt-2'>
                                        <center>
                                            <Button size='small' variant="contained" color="primary" className='mr-1 mb-2' disabled={ItemSwInfoSaveDsa} onClick={ItemAddLicenceSave}>{ItemSwInfoSve ? 'Processing...' : 'Save'}</Button>{' '}
                                            <Button size='small' variant="contained" color="primary" className='mr-1 mb-2' disabled={ItemSwInfoUpdateDsa} onClick={ItemAddLicenceUpdate}>{ItemSwInfoUpd ? 'Processing...' : 'Update'}</Button>{' '}
                                            <Button size='small' variant="contained" color="primary" className='mr-1 mb-2' disabled={ItemSwInfoDeleteDsa} onClick={ItemAddLicenceDelete}>{ItemSwInfoDlt ? 'Processing...' : 'Delete'}</Button>{' '}
                                            <Button size='small' variant="contained" color="primary" className='mb-2' onKeyDown={ItemDialogLicenceRefBtnKeyDown} onClick={LicenceReset}>Refresh</Button>{' '}
                                        </center>
                                    </div>
                                </div>
                                <TableContainer className={classes.container}>
                                    <Table stickyHeader className='table-bordered border-primary'>
                                        <TableHead>
                                            <StyledTableRow >
                                                <StyledTableCell className='p-1' align='center'>Sl</StyledTableCell>
                                                <StyledTableCell className='p-1' align='center'>LicenceReg.No</StyledTableCell>
                                                <StyledTableCell className='p-1' align='center'>LicenceReg Date</StyledTableCell>
                                                <StyledTableCell className='p-1' align='center'>LicenceCode</StyledTableCell>
                                                <StyledTableCell className='p-1' align='center'>LicenceRegPort</StyledTableCell>
                                                <StyledTableCell className='p-1' align='center'>DebitValue</StyledTableCell>
                                                <StyledTableCell className='p-1' align='center'>DebitQty</StyledTableCell>
                                                <StyledTableCell className='p-1' align='center'>DebitUom</StyledTableCell>
                                                <StyledTableCell className='p-1' align='center'>TRA No</StyledTableCell>
                                                <StyledTableCell className='p-1' align='center'>TRA Date</StyledTableCell>
                                            </StyledTableRow>
                                        </TableHead>
                                        <TableBody>
                                            {itemRitcDetails.map((item) => { const selectedItem = isItemTblSelected(item.licenceRegNo);
                                                return(
                                                <TableRow key={item.licenceRegNo} hover onClick={() => editItemLicenceDetails(item)} id='Item_Add_leicence_Details_id'
                                                onKeyDown={(e)=>itemDialogTblKeyDown(e,'licenceDetails')} tabIndex={-1} selected={selectedItem}>
                                                    <TableCell className='p-1' align='center'>{item.serialNumber}</TableCell>
                                                    <TableCell className='p-1' align='center'>{item.licenceRegNo}</TableCell>
                                                    <TableCell className='p-1' align='center'>{item.licenceRegDate}</TableCell>
                                                    <TableCell className='p-1' align='center'>{item.licenceCode}</TableCell>
                                                    <TableCell className='p-1' align='center'>{item.customPointCode}</TableCell>
                                                    <TableCell className='p-1' align='center'>{item.debitValue}</TableCell>
                                                    <TableCell className='p-1' align='center'>{item.debitQty}</TableCell>
                                                    <TableCell className='p-1' align='center'>{item.unitCode}</TableCell>
                                                    <TableCell className='p-1' align='center'>{item.traNo}</TableCell>
                                                    <TableCell className='p-1' align='center'>{item.traDate}</TableCell>
                                                </TableRow>)})}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </div>
                        </Dialog>
                        {/* --Sw-Constitunent-- */}
                        <Dialog onClose={ItemSwConstituentCloshHandle} open={ItemConstituentOpen} fullWidth={true} maxWidth="md">
                            <DialogTitle className="dialogboxtitlecolour p-1">
                                <center>Add SW Constituent</center>
                            </DialogTitle>
                            <div>
                                <div className='dialogboxcolour'>
                                    <div className='form-inline ml-4'>
                                        <Form.Label className='mt-3'>Constituent Sl.No</Form.Label>
                                        <input className='hi22 ml0_6 mt-3' value={ItemDialogValues.constituentSl_no} id='ConstitutentSlNo'
                                            autoFocus onChange={ItemDialogConstituenSlNoChngHndl} onKeyDown={ItemDialogSwConstituentSlNoKeyDown} />
                                        <Form.Label className='ml-2 mt-3'>Constituent Name</Form.Label>
                                        <input className='hi22 ml-1 mt-3' value={ItemDialogValues.constituent_name}
                                            id='ContituentName' onChange={ItemDialogConstituenNameChngHndl} onKeyDown={ItemDialogSwConstituentNameKeyDown} />
                                        <Form.Label className='ml-2 mt-3'>Constituent Code</Form.Label>
                                        <input className='hi22 ml-1 mt-3' value={ItemDialogValues.constituent_code}
                                            id='constituentCode' onChange={ItemDialogConstituenCodeChngHndl} onKeyDown={ItemDialogSwConstituentCodeKeyDown} />
                                    </div>
                                    <div className='form-inline ml-4 mt-2'>
                                        <Form.Label>Const Percentage</Form.Label>
                                        <input className='hi22 ml-1' value={ItemDialogValues.const_percentage}
                                            id='constPercnt' onChange={ItemDialogConstPercentageChngHndl} onKeyDown={ItemDialogSwConstituentPercntKeyDown} />
                                        <Form.Label className='ml-2'>Yield Percentage</Form.Label>
                                        <input className='hi22 ml1_2' value={ItemDialogValues.yield_percentage}
                                            id='yieldPercnt' onChange={ItemDialogYieldPercentageChngHndl} onKeyDown={ItemDialogSwCntentYieldPercntKeyDown} />
                                        <Form.Label className='ml-2'>Active Ingredient</Form.Label>
                                        <input className='hi22 ml0_9' value={ItemDialogValues.active_indredient}
                                            id='activeIngredient' onChange={ItemDialogActiveIngredientChngHndl} onKeyDown={ItemDialogSwCntentActiveIngredientKeyDown} />
                                    </div>
                                    <div className='mt-2'>
                                        <center>
                                            <Button size='small' variant="contained" color="primary" className='mb-2' disabled={ItemSwInfoSaveDsa} onClick={ItemAddSWConstituentSave}>{ItemSwInfoSve ? 'Processing...' : 'Save'}</Button>{' '}
                                            <Button size='small' variant="contained" color="primary" className='mb-2' disabled={ItemSwInfoUpdateDsa} onClick={ItemAddSWConstituentUpdate}>{ItemSwInfoUpd ? 'Processing...' : 'Update'}</Button>{' '}
                                            <Button size='small' variant="contained" color="primary" className='mb-2' disabled={ItemSwInfoDeleteDsa} onClick={ItemAddSWConstituentDelete}>{ItemSwInfoDlt ? 'Processing...' : 'Delete'}</Button>{' '}
                                            <Button size='small' variant="contained" color="primary" className='mb-2' onKeyDown={ItemDialogSwCntentRefBtnKeyDown} onClick={ItemAddSWConstituentReset}>Refresh</Button>{' '}
                                        </center>
                                    </div>
                                </div>
                                <TableContainer className={classes.container}>
                                    <Table stickyHeader className='table-bordered border-primary'>
                                        <TableHead>
                                            <StyledTableRow >
                                                <StyledTableCell className='p-1' align='center'>Sl</StyledTableCell>
                                                <StyledTableCell className='p-1' align='center'>ConstituentSrl.No</StyledTableCell>
                                                <StyledTableCell className='p-1' align='center'>Constituent Name</StyledTableCell>
                                                <StyledTableCell className='p-1' align='center'>Constituent Code</StyledTableCell>
                                                <StyledTableCell className='p-1' align='center'>Constituent Percentage</StyledTableCell>
                                                <StyledTableCell className='p-1' align='center'>Yield Percentage</StyledTableCell>
                                                <StyledTableCell className='p-1' align='center'>Active Igredient</StyledTableCell>
                                            </StyledTableRow>
                                        </TableHead>
                                        <TableBody>
                                            {itemRitcDetails.map((item) => { const selectedItem = isItemTblSelected(item.consName);
                                                return(
                                                <TableRow key={item.consName} hover onClick={() => editItemSwConstiuentDetails(item)} id='Item_Add_Sw_Content_Details_id'
                                                onKeyDown={(e)=>itemDialogTblKeyDown(e,'sw_content')} tabIndex={-1} selected={selectedItem}>
                                                    <TableCell className='p-1' align='center'>{item.serialNumber}</TableCell>
                                                    <TableCell className='p-1' align='center'>{item.srNo}</TableCell>
                                                    <TableCell className='p-1' align='center'>{item.consName}</TableCell>
                                                    <TableCell className='p-1' align='center'>{item.consCode}</TableCell>
                                                    <TableCell className='p-1' align='center'>{item.consPerc}</TableCell>
                                                    <TableCell className='p-1' align='center'>{item.consYieldPerc}</TableCell>
                                                    <TableCell className='p-1' align='center'>{item.consActive}</TableCell>
                                                </TableRow>)})}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </div>
                        </Dialog>
                        {/* --Rsp-- */}
                        <Dialog onClose={ItemRspDutyCloshHandle} open={ItemRspDutyOpen} fullWidth={true} maxWidth="md">
                            <DialogTitle className="dialogboxtitlecolour p-1">
                                <center>Add RSP Duty</center>
                            </DialogTitle>
                            <div>
                                <div className='dialogboxcolour'>
                                    <div className='form-inline ml12'>
                                        <Form.Label className='mt-3'>NOTN No</Form.Label>
                                        <input className='hi22 ml-1 mt-3' value={ItemDialogValues.rsp_notnNo}
                                            onChange={ItemDialogRspNotnNoChngHndl} autoFocus onKeyDown={ItemDialogRspDutyNotenKeyDown} />
                                        <Form.Label className='ml-2 mt-3'>NOTN Sl.No</Form.Label>
                                        <input className='hi22 ml-1 mt-3' value={ItemDialogValues.rsp_notnSlNo}
                                            id='notnSlNo' onChange={ItemDialogRspSlNoChngHndl} onKeyDown={ItemDialogRspDutySlNoKeyDown} />
                                        <Form.Label className='ml1_5 mt-3 summury'>Amount</Form.Label>
                                        <input className='hi22 ml-1 mt-3' value={ItemDialogValues.rsp_amount}
                                            id='amount' onChange={ItemDialogRspAmountChngHndl} onKeyDown={ItemDialogRspDutyAmountKeyDown} />
                                    </div>
                                    <div className='form-inline ml12 mt-2'>
                                        <Form.Label>Rate</Form.Label>
                                        <input className='hi22 ml4_2' value={ItemDialogValues.rsp_rate}
                                            id='RspDutyrate' onChange={ItemDialogRspRateChngHndl} onKeyDown={ItemDialogRspDutyRateKeyDown} />
                                        <Form.Label className='ml-2 summury'>Description</Form.Label>
                                        <input className='hi22 ml0_7' value={ItemDialogValues.rsp_description}
                                            id='Rsp_Description' onChange={ItemDialogRspDescriptioneChngHndl} onKeyDown={ItemDialogRspDutyDescriptionKeyDown} />
                                        <Form.Label className='ml-2 summury'>Quantity</Form.Label>
                                        <input className='hi22 ml-1' value={ItemDialogValues.rsp_quantity}
                                            id='RSPquantity' onChange={ItemDialogRspQuantityChngHndl} onKeyDown={ItemDialogRspDutyQuantityKeyDown} />
                                    </div>
                                    <div className='mt-3'>
                                        <center>
                                            <Button size='small' variant="contained" color="primary" className='mb-3' disabled={ItemSwInfoSaveDsa} onClick={ItemAddRSPSave}>{ItemSwInfoSve ? 'Processing...' : 'Save'}</Button>{' '}
                                            <Button size='small' variant="contained" color="primary" className='mb-3' disabled={ItemSwInfoUpdateDsa} onClick={ItemAddRspUpdate}>{ItemSwInfoUpd ? 'Processing...' : 'Update'}</Button>{' '}
                                            <Button size='small' variant="contained" color="primary" className='mb-3' disabled={ItemSwInfoDeleteDsa} onClick={ItemAddRspDelete}>{ItemSwInfoDlt ? 'Processing...' : 'Delete'}</Button>{' '}
                                            <Button size='small' variant="contained" color="primary" onKeyDown={ItemDialogRspDutyRefBtnKeyDown} className='mb-3' onClick={ItemAddRspReset}>Refresh</Button>{' '}
                                        </center>
                                    </div>
                                </div>
                                <TableContainer className={classes.container}>
                                    <Table stickyHeader className='table-bordered border-primary'>
                                        <TableHead>
                                            <StyledTableRow >
                                                <StyledTableCell className='p-1' align='center'>Sl</StyledTableCell>
                                                <StyledTableCell className='p-1' align='center'>RSP Notification.No</StyledTableCell>
                                                <StyledTableCell className='p-1' align='center'>Sl.No</StyledTableCell>
                                                <StyledTableCell className='p-1' align='center'>Description</StyledTableCell>
                                                <StyledTableCell className='p-1' align='center'>Quantity</StyledTableCell>
                                                <StyledTableCell className='p-1' align='center'>Rate</StyledTableCell>
                                                <StyledTableCell className='p-1' align='center'>Amount</StyledTableCell>
                                            </StyledTableRow>
                                        </TableHead>
                                        <TableBody>
                                            {itemRitcDetails.map((item) => { const selectedItem = isItemTblSelected(item.notificationNo);
                                                return(
                                                <TableRow key={item.notificationId} hover onClick={() => editItemRspDetails(item)} id='Item_Add_RSP_Duty_id'
                                                onKeyDown={(e)=>itemDialogTblKeyDown(e,'rsp_dutyAdd')} tabIndex={-1} selected={selectedItem}>
                                                    <TableCell className='p-1' align='center'>{item.serialNumber}</TableCell>
                                                    <TableCell className='p-1' align='center'>{item.notificationNo}</TableCell>
                                                    <TableCell className='p-1' align='center'>{item.notificationSrNo}</TableCell>
                                                    <TableCell className='p-1' align='center'>{item.item_description}</TableCell>
                                                    <TableCell className='p-1' align='center'>{item.qty}</TableCell>
                                                    <TableCell className='p-1' align='center'>{item.notificationRate}</TableCell>
                                                    <TableCell className='p-1' align='center'>{item.notificationAmount}</TableCell>
                                                </TableRow>)})}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </div>
                        </Dialog>
                        {/* Re-imports */}
                        <Dialog onClose={ItemReImportCloshHandle} open={ItemReImportOpen} fullWidth={true} maxWidth="md">
                            <DialogTitle className="dialogboxtitlecolour p-1">
                                <center>Add Re-Import</center>
                            </DialogTitle>
                            {/* --R_PortOfCode-- */}
                            <Dialog onClose={ItemReImPortCodeCloshHandle} open={ItemReImpPortCodeOpen} fullWidth={true} maxWidth="md">
                                <DialogTitle className="dialogboxtitlecolour p-1">
                                    <center>Re-Import Port Details</center>
                                </DialogTitle>
                                <div>
                                    <div className='dialogboxcolour'>
                                        <div className='form-inline'>
                                            <label style={{ marginLeft: '30%' }} className='mt-3'>Find PortCode</label>
                                            <input style={{ textTransform: 'uppercase' }} className='ml-3 mt-3' autoFocus onKeyDown={ItemDialogFindRe_import_PorteCodeKeyDown}
                                                value={ItemDialogValues.f_scheme_code} onChange={ItemDialogFindPortCodeChngHandle} />
                                        </div>
                                        <div className='form-inline mt-2'>
                                            <label style={{ marginLeft: '30%' }} className='mb-2'>Find PortName</label>
                                            <input style={{ textTransform: 'uppercase' }} className='ml1_2 mb-2' onKeyDown={ItemDialogFindRe_import_PorteNameKeyDown}
                                            id='Find_re_import_name' value={ItemDialogValues.f_scheme_codeName} onChange={ItemDialogFindPortNameChngHandle} />
                                        </div>
                                    </div>
                                    <TableContainer className={classes.container}>
                                        <Table stickyHeader className='table-bordered border-primary'>
                                            <TableHead>
                                                <StyledTableRow >
                                                    <StyledTableCell className='p-1' align='center'>OriginportCode</StyledTableCell>
                                                    <StyledTableCell className='p-1' align='center'>OriginPortName</StyledTableCell>
                                                </StyledTableRow>
                                            </TableHead>
                                            <TableBody>
                                                {itemSchemeCodeDetails.map((item) => { const selectedItem = isItemTblSelected(item.customPointCode);
                                                    return(
                                                    <TableRow key={item.customPointCode} hover onClick={() => editItemPortCodeDetails(item)} id='Item_find_re_import_port_id'
                                                    onKeyDown={(e)=>itemDialogSchemeCodeTblKeyDown(e,'re_import_port')} tabIndex={-1} selected={selectedItem}>
                                                        <TableCell className='p-1' align='center'>{item.customPointCode}</TableCell>
                                                        <TableCell className='p-1' align='center'>{item.customPointName}</TableCell>
                                                    </TableRow>)})}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </div>
                            </Dialog>
                            <div className='dialogboxcolour'>
                                <div>
                                    <div className='form-inline mt-2 ml5'>
                                        <label className='summury mt-3'>Privious SB.No</label>
                                        <input className='hi22 ml-2 mt-3' value={ItemDialogValues.r_iPrivousSbNo}
                                            autoFocus onChange={ItemDialogRiPriviousSbNoChngHndl} onKeyDown={ItemDialogReImportPrivousSbNoKeyDown} />
                                        <label className='summury ml-4 mt-3'>Privious SB Date</label>
                                        <input className='hi22 mt-3 ml1_8' style={{ width: '19%' }} value={ItemDialogValues.r_iPrivousSbdate} type={'date'}
                                            id='priviousSbDate' onChange={ItemDialogRiPriviousSbDateChngHndl} onKeyDown={ItemDialogReImportSBDateKeyDown} />
                                    </div>
                                    <div className='form-inline mt-2 ml5'>
                                        <label className='summury'>Port Of Export</label>
                                        <input className='hi22 ml1_5' style={{ width: '15%' }} value={ItemDialogValues.r_iPort_of_export}
                                            id='ReImportPortOfExit' onChange={ItemDialogRiPortExportChngHndl} onKeyDown={ItemDialogRiPortExportKeyDown} />
                                        <button className='searchbutton' onClick={ItemReImPortCode_OpenHandle}>
                                            <SearchIcon fontSize='small' />
                                        </button>
                                    </div>
                                    <div className='form-inline mt-2 ml5'>
                                        <label className=''>Invoice No in SB</label>
                                        <input className='hi22 ml0_4' value={ItemDialogValues.r_iInvoiceNo_sb}
                                            id='invoiceNoSb' onChange={ItemDialogRiInvoiceNoSbChngHndl} onKeyDown={ItemDialogReImportInvoiceSbKeyDown} />
                                        <label className='ml-4 mr-4'>Item No in SB</label>
                                        <input className='hi22 ml1_3' value={ItemDialogValues.r_iItemNo_sb}
                                            id='itemNoSb' onChange={ItemDialogRiItemSbNoChngHndl} onKeyDown={ItemDialogReImportItemNoSbKeyDown} />
                                    </div>
                                    <div className='form-inline mt-2 ml5'>
                                        <label className='summury'>Notification No</label>
                                        <input className='hi22 ml-2' value={ItemDialogValues.r_iNotificationNo}
                                            id='notificationNo' onChange={ItemDialogRiNotificationNoChngHndl} onKeyDown={ItemDialogReImportNotificationNoKeyDown} />
                                        <label className='summury ml-4 mr-2'>Notification Sl.No</label>
                                        <input className='hi22' value={ItemDialogValues.r_iNotificationSrlNo} onKeyDown={ItemDialogReImportNotificationSlNoKeyDown}
                                            id='NotificationSlNo' onChange={ItemDialogRiNotificationSlNoChngHndl} />
                                    </div>
                                    <div className='form-inline mt-2 ml5'>
                                        <label className=''>Export Freight</label>
                                        <input className='hi22 ml1_8' value={ItemDialogValues.r_iExportFright}
                                            id='ExportFright' onChange={ItemDialogRiExportFrightChngHndl} onKeyDown={ItemDialogReImportExportFrightKeyDown} />
                                        <label className='ml-4'>Export Insurance</label>
                                        <input className='hi22 ml1_7' value={ItemDialogValues.r_iExportInsurance} onKeyDown={ItemDialogReImportExportInsuranceKeyDown}
                                            id='exportInsurance' onChange={ItemDialogRiExportInsurenceChngHndl} />
                                    </div>
                                    <div className='form-inline mt-2 ml5'>
                                        <label className=''>Custom Duty</label>
                                        <input className='hi22 ml-4' value={ItemDialogValues.r_iCustomDuty}
                                            id='customDuty' onChange={ItemDialogRiCustomDutyChngHndl} onKeyDown={ItemDialogReImportCustomDutyKeyDown} />
                                        <label className='ml-4 '>Excise Duty</label>
                                        <input className='hi22 ml5_3' value={ItemDialogValues.r_iExciseDuty}
                                            id='Excise_Duty' onChange={ItemDialogRiExciseDutyChngHndl} onKeyDown={ItemDialogReImportExciseDutyKeyDown} />
                                    </div>
                                </div>
                                <div className='mt-3'>
                                    <center>
                                        <Button size='small' variant="contained" className='mb-2' color="primary" disabled={ItemSwInfoSaveDsa} onClick={ItemAddRe_importSave}>{ItemSwInfoSve ? 'Processing...' : 'Save'}</Button>{' '}
                                        <Button size='small' variant="contained" className='mb-2' color="primary" disabled={ItemSwInfoUpdateDsa} onClick={ItemAddRe_importUpdate}>{ItemSwInfoUpd ? 'Processing...' : 'Update'}</Button>{' '}
                                        <Button size='small' variant="contained" className='mb-2' color="primary" disabled={ItemSwInfoDeleteDsa} onClick={ItemAddRe_importDelete}>{ItemSwInfoDlt ? 'Processing...' : 'Delete'}</Button>{' '}
                                        <Button size='small' variant="contained" className='mb-2' color="primary" onKeyDown={ItemDialogReImportRefBtnKeyDown} onClick={ItemAddRe_importReset}>Refresh</Button>{' '}
                                    </center>
                                </div>
                            </div>
                            <TableContainer className={classes.container}>
                                <Table stickyHeader className='table-bordered border-primary'>
                                    <TableHead>
                                        <StyledTableRow >
                                            <StyledTableCell className='p-1' align='center'>Sl</StyledTableCell>
                                            <StyledTableCell className='p-1' align='center'>PrerviousSB.No</StyledTableCell>
                                            <StyledTableCell className='p-1' align='center'>PrerviousSB.Date</StyledTableCell>
                                            <StyledTableCell className='p-1' align='center'>Port Export</StyledTableCell>
                                            <StyledTableCell className='p-1' align='center'>Notn No</StyledTableCell>
                                            <StyledTableCell className='p-1' align='center'>SrlNo</StyledTableCell>
                                            <StyledTableCell className='p-1' align='center'>ExportFright</StyledTableCell>
                                            <StyledTableCell className='p-1' align='center'>ExportInsurance</StyledTableCell>
                                            <StyledTableCell className='p-1' align='center'>CustomDuty</StyledTableCell>
                                            <StyledTableCell className='p-1' align='center'>ExciseDuty</StyledTableCell>
                                        </StyledTableRow>
                                    </TableHead>
                                    <TableBody>
                                        {itemRitcDetails.map((item) => { const selectedItem = isItemTblSelected(item.previousSbNo);
                                            return(
                                            <TableRow key={item.previousSbNo} hover onClick={() => editItemReImpDetails(item)} id='Item_Add_re_import_id'
                                            onKeyDown={(e)=>itemDialogTblKeyDown(e,'re_import')} tabIndex={-1} selected={selectedItem}>
                                                <TableCell className='p-1' align='center'>{item.serialNumber}</TableCell>
                                                <TableCell className='p-1' align='center'>{item.previousSbNo}</TableCell>
                                                <TableCell className='p-1' align='center'>{item.previousSbDate}</TableCell>
                                                <TableCell className='p-1' align='center'>{item.customPointCode}</TableCell>
                                                <TableCell className='p-1' align='center'>{item.notificationNo}</TableCell>
                                                <TableCell className='p-1' align='center'>{item.notificationSrNo}</TableCell>
                                                <TableCell className='p-1' align='center'>{item.freightAmount}</TableCell>
                                                <TableCell className='p-1' align='center'>{item.insuranceAmount}</TableCell>
                                                <TableCell className='p-1' align='center'>{item.customDutyAmount}</TableCell>
                                                <TableCell className='p-1' align='center'>{item.exciseAmount}</TableCell>
                                            </TableRow>)})}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Dialog>
                        {/* --Ncd-Duty-- */}
                        <Dialog onClose={ItemNcdDutyCloshHandle} open={ItemNcdDutyOpen} fullWidth={true} maxWidth="md">
                            <DialogTitle className="dialogboxtitlecolour p-1">
                                <center>Add NCD Duty</center>
                            </DialogTitle>
                            <div>
                                <div className='dialogboxcolour'>
                                    <div className='form-inline ml37_5'>
                                        <Form.Label className='summury mt-3'>Notification NO</Form.Label>
                                        <Form.Label className='ml9 summury mt-3'>Sl NO</Form.Label>
                                        <Form.Label className='ml4 summury mt-3'>Rate</Form.Label>
                                        <Form.Label className='ml-3 summury mt-3'>Flag</Form.Label>
                                        <Form.Label className='ml-3 summury mt-3'>Amount</Form.Label>
                                        <Form.Label className='ml-3 summury mt-3'>UQC</Form.Label>
                                    </div>
                                    <div className='form-inline mt-2 ml22'>
                                        <Form.Label>NCD Custom Duty</Form.Label>
                                        <input className='hi22 ml-1' value={ItemDialogValues.ncdDuty_notn_no}
                                            id='ncdCustmDuty' onChange={ItemDialogNcdNotnNoChngHandle} autoFocus onKeyDown={ItemDialogNcdDutyCustmDutyKeyDown} />
                                        <input className='hi22 wid1 ml-1' value={ItemDialogValues.ncdDuty_notn_slNo} onKeyDown={ItemDialogNcdDutySlnoDutyKeyDown}
                                            id='NcdSlNo' onChange={ItemDialogNcdNotnSlNoChngHandle} onBlur={ItemDialogNcdNotnFocusOut} />
                                        <input className='hi22 wid1 ml-1' value={ItemDialogValues.ncdDuty_rate} disabled />
                                        <input className='hi22 wid5 ml-1' value={ItemDialogValues.ncdDuty_flag} disabled />
                                        <input className='hi22 wid1 ml-1' value={ItemDialogValues.ncdDuty_amount} disabled />
                                        <input className='hi22 wid1 ml-1' value={ItemDialogValues.ncdDuty_UQC} disabled />
                                    </div>
                                    <div>
                                        <center className='mt-3'>
                                            <Button size='small' variant="contained" color="primary" className='mb-2' disabled={ItemSwInfoSaveDsa} onClick={ItemAddNCDdutySave}>{ItemSwInfoSve ? 'Processing...' : 'Save'}</Button>{' '}
                                            <Button size='small' variant="contained" color="primary" className='mb-2' disabled={ItemSwInfoUpdateDsa} onClick={ItemAddNCDdutyUpdate}>{ItemSwInfoUpd ? 'Processing...' : 'Update'}</Button>{' '}
                                            <Button size='small' variant="contained" color="primary" className='mb-2' disabled={ItemSwInfoDeleteDsa} onClick={ItemAddNCDdutyDelete}>{ItemSwInfoDlt ? 'Processing...' : 'Delete'}</Button>{' '}
                                            <Button size='small' variant="contained" color="primary" className='mb-2' onKeyDown={ItemDialogNcdDutyRefBtnKeyDown} onClick={ItemAddNCDdutyReset}>Refresh</Button>{' '}
                                        </center>
                                    </div>
                                </div>
                                <TableContainer className={classes.container}>
                                    <Table stickyHeader className='table-bordered border-primary'>
                                        <TableHead>
                                            <StyledTableRow >
                                                <StyledTableCell className='p-1' align='center'>Sl</StyledTableCell>
                                                <StyledTableCell className='p-1' align='center'>Notification.No</StyledTableCell>
                                                <StyledTableCell className='p-1' align='center'>Sl.No</StyledTableCell>
                                                <StyledTableCell className='p-1' align='center'>Rate</StyledTableCell>
                                                <StyledTableCell className='p-1' align='center'>flg</StyledTableCell>
                                                <StyledTableCell className='p-1' align='center'>Amount</StyledTableCell>
                                                <StyledTableCell className='p-1' align='center'>UQC</StyledTableCell>
                                            </StyledTableRow>
                                        </TableHead>
                                        <TableBody>
                                            {itemRitcDetails.map((item) => { const selectedItem = isItemTblSelected(item.notificationNo);
                                                return(
                                                <TableRow key={item.notificationId} hover onClick={() => editItemNCDDutyDetails(item)} id='Item_Add_ncd_duty_id'
                                                onKeyDown={(e)=>itemDialogTblKeyDown(e,'ncd_duty')} tabIndex={-1} selected={selectedItem}>
                                                    <TableCell className='p-1' align='center'>{item.serialNumber}</TableCell>
                                                    <TableCell className='p-1' align='center'>{item.notificationNo}</TableCell>
                                                    <TableCell className='p-1' align='center'>{item.notificationSrNo}</TableCell>
                                                    <TableCell className='p-1' align='center'>{item.notificationRate}</TableCell>
                                                    <TableCell className='p-1' align='center'>{item.notificationFlag}</TableCell>
                                                    <TableCell className='p-1' align='center'>{item.notificationAmount}</TableCell>
                                                    <TableCell className='p-1' align='center'>{item.notificationUnit}</TableCell>
                                                </TableRow>)})}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </div>
                        </Dialog>
                        {/* --SwProduction-- */}
                        <Dialog onClose={ItemSwProductionCloshHandle} open={ItemSwProductionOpen} fullWidth={true} maxWidth="md">
                            <DialogTitle className="dialogboxtitlecolour p-1">
                                <center>Add Production</center>
                            </DialogTitle>
                            <div>
                                <div className='dialogboxcolour'>
                                    <div className='form-inline'>
                                        <Form.Label className='ml-1 mt-3'>Production Identifier</Form.Label>
                                        <input className='hi22 ml-2 mt-3' value={ItemDialogValues.swProd_prodIdtifier}
                                            id='productionIdntifies' onChange={ItemDialogProdIdentiChngHandl} autoFocus onKeyDown={ItemDialogAddProductionIdentifieKeyDown} />
                                        <Form.Label className='ml-1 mt-3'>Quantity</Form.Label>
                                        <input className='hi22 ml-4 mt-3' value={ItemDialogValues.swprod_Quantity}
                                            id='addproductionQuantity' onChange={ItemDialogProQuantityChngHandl} onKeyDown={ItemDialogAddProductionQuantityKeyDown} />
                                        <Form.Label className='ml-1 mt-3'>Production UQC</Form.Label>
                                        <select className='hi22 wid12 ml-3 mt-3' style={{ width: '18%' }} value={ItemDialogValues.Sw_Uqc}
                                            onChange={ItemDialogSwUqcChngHandl} id='debit_uom' onKeyDown={ItemDialogAddProductionUqcKeyDown}>
                                            <option value={''}></option>
                                            {ItemSwUQCDrp.map(item => (
                                                <option value={item.unitCode}>{item.unitCode}</option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className='form-inline mt-2'>
                                        <Form.Label className='ml-1'>Manufacture Date</Form.Label>
                                        <input className='hi22 ml1_9' style={{ width: '18%' }} value={ItemDialogValues.swProd_manufacture}
                                            id='manufactureDate ' onChange={ItemDialogManufctrDateChngHandl} type={'date'} onKeyDown={ItemDialogAddProductionManfactureDateKeyDown} />
                                        <Form.Label>Expiry Date</Form.Label>
                                        <input className='hi22 ml0_9' style={{ width: '18%' }} value={ItemDialogValues.swprod_expiryDate} onKeyDown={ItemDialogAddProductionExpiryDateKeyDown}
                                            id='expiryDate' onChange={ItemDialogExipryDateChngHandl} type={'date'} />
                                        <Form.Label>Best Before Date</Form.Label>
                                        <input className='hi22 ml1_5' style={{ width: '18%' }} value={ItemDialogValues.swProd_beforeDate} onKeyDown={ItemDialogAddProductionBestBeforeDateKeyDown}
                                            id='bestBeforeDate' onChange={ItemDialogBeforeDateChngHandl} type={'date'} />
                                    </div>
                                    <div>
                                        <center className='mt-3'>
                                            <Button size='small' variant="contained" color="primary" className='mb-2' disabled={ItemSwInfoSaveDsa} onClick={ItemProdectionSave}>{ItemSwInfoSve ? 'Processing...' : 'Save'}</Button>{' '}
                                            <Button size='small' variant="contained" color="primary" className='mb-2' disabled={ItemSwInfoUpdateDsa} onClick={ItemAddProdectionUpdate}>{ItemSwInfoUpd ? 'Processing...' : 'Update'}</Button>{' '}
                                            <Button size='small' variant="contained" color="primary" className='mb-2' disabled={ItemSwInfoDeleteDsa} onClick={ItemAddProdectionDelete}>{ItemSwInfoDlt ? 'Processing...' : 'Delete'}</Button>{' '}
                                            <Button size='small' variant="contained" color="primary" className='mb-2' onKeyDown={ItemDialogAddProductionRefBtnKeyDown} onClick={ItemAddProdectionReset}>Refresh</Button>{' '}
                                        </center>
                                    </div>
                                </div>
                                <TableContainer className={classes.container}>
                                    <Table stickyHeader className='table-bordered border-primary'>
                                        <TableHead>
                                            <StyledTableRow >
                                                <StyledTableCell className='p-1' align='center'>Sl</StyledTableCell>
                                                <StyledTableCell className='p-1' align='center'>Identifier</StyledTableCell>
                                                <StyledTableCell className='p-1' align='center'>Quantity</StyledTableCell>
                                                <StyledTableCell className='p-1' align='center'>UQC</StyledTableCell>
                                                <StyledTableCell className='p-1' align='center'>Manufacture Date</StyledTableCell>
                                                <StyledTableCell className='p-1' align='center'>ExpiryDate</StyledTableCell>
                                                <StyledTableCell className='p-1' align='center'>BestBefore Date</StyledTableCell>
                                            </StyledTableRow>
                                        </TableHead>
                                        <TableBody>
                                            {itemRitcDetails.map((item) => { const selectedItem = isItemTblSelected(item.prodIdentifier);
                                                return(
                                                <StyledTableRow key={item.prodIdentifier} hover onClick={() => editItemSwProductionDetails(item)} id='Item_Add_Sw_production_id'
                                                onKeyDown={(e)=>itemDialogTblKeyDown(e,'Sw_production')} tabIndex={-1} selected={selectedItem}>
                                                    <StyledTableCell className='p-1' align='center'>{item.serialNumber}</StyledTableCell>
                                                    <StyledTableCell className='p-1' align='center'>{item.prodIdentifier}</StyledTableCell>
                                                    <StyledTableCell className='p-1' align='center'>{item.prodQty}</StyledTableCell>
                                                    <StyledTableCell className='p-1' align='center'>{item.unitCode}</StyledTableCell>
                                                    <StyledTableCell className='p-1' align='center'>{item.prodManDate}</StyledTableCell>
                                                    <StyledTableCell className='p-1' align='center'>{item.prodExpiryDate}</StyledTableCell>
                                                    <StyledTableCell className='p-1' align='center'>{item.prodBestDate}</StyledTableCell>
                                                </StyledTableRow>)})}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </div>
                        </Dialog>
                        {/* --SvbStatus-- */}
                        <Dialog onClose={ItemSVBStatusCloshHandle} open={ItemSvbStatusOpen} fullWidth={true} maxWidth="sm">
                            <DialogTitle className="dialogboxtitlecolour p-1">
                                <center>Add SVB Status</center>
                            </DialogTitle>
                            <div className='dialogboxcolour'>
                                <Row>
                                    <Col><Form.Label style={{ justifyContent: 'left', marginTop: '2%' }}>Reference No</Form.Label></Col>
                                    <Col><input className='hi22' style={{ textAlign: 'center', marginTop: '2%' }} value={ItemDialogValues.svb_reference_no}
                                        autoFocus onChange={ItemDialogSvbReferenceChngHndl} onKeyDown={ItemDialogSvbRefrenceNoKeyDown} /></Col>
                                </Row>
                                <Row>
                                    <Col><Form.Label style={{ justifyContent: 'left' }} >Reference Date</Form.Label></Col>
                                    <Col><input className='hi22' style={{ textAlign: 'center' }} type={'date'} id='SvBrefrenceDate' onKeyDown={ItemDialogSvbRefrenceDateKeyDown}
                                        value={ItemDialogValues.svb_refrenceDate} onChange={ItemDialogSvbReferenceDateChngHndl} /></Col>
                                </Row>
                                <Row>
                                    <Col><Form.Label style={{ justifyContent: 'left' }}>CustomHouseCode[SVB]</Form.Label></Col>
                                    <Col><select className='hi22' style={{ textAlign: 'center' }} value={ItemDialogValues.svb_customhouseCode}
                                        id='custmHouseSvb' onChange={ItemDialogSvbCustomHusCodeChngHndl} onKeyDown={ItemDialogSvbCustmHuseCodeSVBKeyDown}>
                                        <option value={''}></option>
                                        {ItemCusHusCode.map((item) => (
                                            <option value={item.customPointCode}>{item.customPointCode}</option>
                                        ))}
                                    </select></Col>
                                </Row>
                                <Row>
                                    <Col><Form.Label style={{ justifyContent: 'left' }}>SVB Load On[A/D]</Form.Label></Col>
                                    <Col> <input className='hi22' style={{ textAlign: 'center' }} value={ItemDialogValues.svb_loadOn_Ad}
                                        id='SVBLoadOnAD' onChange={ItemDialogSvbLoadOnADChngHndl} onKeyDown={ItemDialogSvbSvbLoadOnADKeyDown} /></Col>
                                </Row>
                                <Row>
                                    <Col><Form.Label style={{ justifyContent: 'left' }}>SVB Load %[A.V.]</Form.Label></Col>
                                    <Col><input className='hi22' style={{ textAlign: 'center' }} value={ItemDialogValues.svb_load_AV}
                                        id='svbLoadAV' onChange={ItemDialogSvbLoadAVChngHndl} onKeyDown={ItemDialogSvbSvbLoadOnAVKeyDown} /></Col>
                                </Row>
                                <Row>
                                    <Col><Form.Label style={{ justifyContent: 'left' }}>SVB Load %[Duty]</Form.Label></Col>
                                    <Col><input className='hi22' style={{ textAlign: 'center' }} value={ItemDialogValues.svb_load_duty}
                                        id='svLoadDuty' onChange={ItemDialogSvbLoadDutyChngHndl} onKeyDown={ItemDialogSvbSvbLoadOnDutyKeyDown} /></Col>
                                </Row>
                                <Row>
                                    <Col><Form.Label style={{ justifyContent: 'left' }}>LoadFinal/Provisional[A.V](Y/N)</Form.Label></Col>
                                    <Col><input className='hi22' style={{ textAlign: 'center' }} value={ItemDialogValues.svb_provi_AV}
                                        id='LoadFinalProvisionalAv' onChange={ItemDialogSvbProviAvChngHndl} onKeyDown={ItemDialogSvbLoadProvisionalAVKeyDown} /></Col>
                                </Row>
                                <Row>
                                    <Col><Form.Label style={{ justifyContent: 'left' }}>LoadFinal/Provisional[Duty](Y/N)</Form.Label></Col>
                                    <Col> <input className='hi22' style={{ textAlign: 'center' }} value={ItemDialogValues.svb_provi_duty}
                                        id='provisionalDuty' onChange={ItemDialogSvbProviDutyChngHndl} onKeyDown={ItemDialogSvbLoadProvisionalDutyKeyDown} /></Col>
                                </Row>
                            </div>
                        </Dialog>
                        {/* --Manufacture-- */}
                        <Dialog onClose={ItemManufactureCloshHandle} open={ItemManufactureOpen} fullWidth={true} maxWidth="md">
                            {/* name */}
                            <Dialog onClose={ItemSupplierCloshHandle} open={ItemSupplierNameOpen} fullWidth={true} maxWidth="md">
                                <DialogTitle className="dialogboxtitlecolour p-1">
                                    <center>View Supplier Details</center>
                                </DialogTitle>
                                <div><div className='dialogboxcolour'>
                                    <center>
                                        <Form.Label className='mt-3 ml-1 mr-1 mb-3'>FindSupplierName</Form.Label>
                                        <input className='mt-3 mb-3' value={ItemDialogValues.f_suplier_name}
                                            autoFocus onChange={ItemDialogFindSupplierChngHndl} onKeyDown={ItemDialogFindSuplierDetKeyDown} />
                                    </center></div>
                                    <TableContainer className={classes.container}>
                                        <Table stickyHeader className='table-bordered border-primary'>
                                            <TableHead>
                                                <StyledTableRow >
                                                    <StyledTableCell className='p-1' align='center'>name</StyledTableCell>
                                                    <StyledTableCell className='p-1' align='center'>Address1</StyledTableCell>
                                                    <StyledTableCell className='p-1' align='center'>Address2</StyledTableCell>
                                                    <StyledTableCell className='p-1' align='center'>PinCode</StyledTableCell>
                                                    <StyledTableCell className='p-1' align='center'>CountryName</StyledTableCell>
                                                </StyledTableRow>
                                            </TableHead>
                                            <TableBody>
                                                {itemSchemeCodeDetails.map((item) => { const selectedItem = isItemTblSelected(item.supplierName);
                                                    return(
                                                    <TableRow key={item.supplierName} hover onClick={() => editItemSupplierDetails(item)} id='Item_find_mnfctSuP_id'
                                                    onKeyDown={(e)=>itemDialogSchemeCodeTblKeyDown(e,'FindMnfctrSup')} tabIndex={-1} selected={selectedItem}>
                                                        <TableCell className='p-1' align='center'>{item.supplierName}</TableCell>
                                                        <TableCell className='p-1' align='center'>{item.supplierAddress1}</TableCell>
                                                        <TableCell className='p-1' align='center'>{item.supplierAddress2}</TableCell>
                                                        <TableCell className='p-1' align='center'>{item.supplierPincode}</TableCell>
                                                        <TableCell className='p-1' align='center'>{item.supplierCountryName}</TableCell>
                                                    </TableRow>)})}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </div>
                            </Dialog>
                            {/**/}
                            <DialogTitle className="dialogboxtitlecolour p-1">
                                <center>Add Manufacture details</center>
                            </DialogTitle>
                            <div><div className='dialogboxcolour'>
                                <div className='form-inline ml-4'>
                                    <Form.Label className='mt-3'>Manufacture Name</Form.Label>
                                    <input className='hi22 wid12 ml-1 mt-3' value={ItemDialogValues.mnfctr_manufactureName}
                                        autoFocus onChange={ItemDialogManufactrNameChngHndl} onKeyDown={ItemManufactrNameSupplierKeyHndle} />
                                    <button className='searchbutton mt-3' onClick={ItemSupplier_OpenHandle}>
                                        <SearchIcon fontSize='small' />
                                    </button>
                                    <Form.Label className='ml-1 mt-3'>Country</Form.Label>
                                    <select className='hi22 wid19 ml-2 mt-3' value={ItemDialogValues.mnfctr_country}
                                        onChange={ItemDialogMnfctrCountryChngHndl} id='mnfctr_cntry' onKeyDown={ItemManufactrNameCountryKeyHndle}>
                                        <option value={''}></option>
                                        {itemCountryDetails.map((item) => (
                                            <option value={item.countryName}>{item.countryName}</option>
                                        ))}
                                    </select>
                                    <Form.Label className='ml-1 mt-3'>Address</Form.Label>
                                    <textarea className='ml-1 mt-3' value={ItemDialogValues.mnfctr_adress} onKeyDown={ItemManufactureAddressKeyHndle}
                                        id='ManufatureDetailsAddress' onChange={ItemDialogMnfctrAdressChngHndl}>
                                    </textarea>
                                </div>
                                <div className='form-inline mt-1 ml-4'>
                                    <Form.Label >Manufacture City</Form.Label>
                                    <input className='hi22 ml1_8 wid18_7' value={ItemDialogValues.mnfctr_manufactureCity}
                                        id='ManufactureCity' onChange={ItemDialogMnfctrManufactureCityChngHndl} onKeyDown={ItemManufactureCityKeyHndle} />
                                    <Form.Label className='ml-1'>PinCode</Form.Label>
                                    <input className='hi22 ml0_5 wid19' value={ItemDialogValues.mnfctr_pincode} onKeyDown={ItemManufacturePinCodeKeyHndle}
                                        id='ManufacturePinCode' onChange={ItemDialogMnfctrPincodeChngHndl} />
                                    <Form.Label className='ml-1'>Division</Form.Label>
                                    <input className='hi22 ml0_7 wid17_8' value={ItemDialogValues.mnfctr_division} onKeyDown={ItemManufactureDivisionKeyHndle}
                                        id='ManufactureDivision' onChange={ItemDialogMnfctrDivisionChngHndl} />
                                </div>
                                <div>
                                    <center className='mt-3'>
                                        <Button size='small' variant="contained" color="primary" className='mb-2' disabled={ItemSwInfoSaveDsa} onClick={ItemManufactureSave}>{ItemSwInfoSve ? 'Processing...' : 'Save'}</Button>{' '}
                                        <Button size='small' variant="contained" color="primary" className='mb-2' disabled={ItemSwInfoUpdateDsa} onClick={ItemAddManufactureUpdate}>{ItemSwInfoUpd ? 'Processing...' : 'Update'}</Button>{' '}
                                        <Button size='small' variant="contained" color="primary" className='mb-2' disabled={ItemSwInfoDeleteDsa} onClick={ItemAddManufactureDelete}>{ItemSwInfoDlt ? 'Processing...' : 'Delete'}</Button>{' '}
                                        <Button size='small' variant="contained" color="primary" className='mb-2' onKeyDown={ItemManufactureRefBTNKeyHndle} onClick={ItemAddManufactureReset}>Refresh</Button>{' '}
                                    </center>
                                </div>
                            </div>
                                <TableContainer className={classes.container}>
                                    <Table stickyHeader className='table-bordered border-primary'>
                                        <TableHead>
                                            <StyledTableRow >
                                                <StyledTableCell className='p-1' align='center'>Sl</StyledTableCell>
                                                <StyledTableCell className='p-1' align='center'>Manufacture Name</StyledTableCell>
                                                <StyledTableCell className='p-1' align='center'>City</StyledTableCell>
                                                <StyledTableCell className='p-1' align='center'>Country</StyledTableCell>
                                                <StyledTableCell className='p-1' align='center'>PinCode</StyledTableCell>
                                                <StyledTableCell className='p-1' align='center'>Division</StyledTableCell>
                                                <StyledTableCell className='p-1' align='center'>Adress</StyledTableCell>
                                            </StyledTableRow>
                                        </TableHead>
                                        <TableBody>
                                            {itemRitcDetails.map((item) => { const selectedItem = isItemTblSelected(item.name);
                                                return(
                                                <TableRow key={item.name} hover onClick={() => editItemManufactureDetails(item)} id='Item_add_mnfctr_details_id'
                                                onKeyDown={(e)=>itemDialogTblKeyDown(e,'add_mnfctr_details')} tabIndex={-1} selected={selectedItem}>
                                                    <TableCell className='p-1' align='center'>{item.serialNumber}</TableCell>
                                                    <TableCell className='p-1' align='center'>{item.name}</TableCell>
                                                    <TableCell className='p-1' align='center'>{item.city}</TableCell>
                                                    <TableCell className='p-1' align='center'>{item.countryIdString}</TableCell>
                                                    <TableCell className='p-1' align='center'>{item.pincode}</TableCell>
                                                    <TableCell className='p-1' align='center'>{item.division}</TableCell>
                                                    <TableCell className='p-1' align='center'>{item.address}</TableCell>
                                                </TableRow>)})}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </div>
                        </Dialog>
                        {/* --cusNotnExmpt-- */}
                        <Dialog onClose={ItemCustNotnExmpCloshHandle} open={ItemCustNotnExmpOpen} fullWidth={true} maxWidth="md">
                            <DialogTitle className="dialogboxtitlecolour p-1">
                                <center>Add Custom Notn Exemption</center>
                            </DialogTitle>
                            <div className='dialogboxcolour'><div>
                                <div className='form-inline ml38'>
                                    <Form.Label className='summury mt-3'>Notification.No</Form.Label>
                                    <Form.Label className='summury ml6 mt-3'>Sl.No</Form.Label>
                                    <Form.Label className='summury ml5 mt-3'>Rate</Form.Label>
                                    <Form.Label className='summury ml-4 mt-3'>Flag</Form.Label>
                                    <Form.Label className='summury ml5 mt-3'>Amount</Form.Label>
                                    <Form.Label className='summury ml5 mt-3'>UQC</Form.Label>
                                </div>
                                <div className='form-inline mt-1 ml17'>
                                    <Form.Label>Custom Notn Exemption</Form.Label>
                                    <input className='hi22 ml-1' value={ItemDialogValues.custm_notfiNo} autoFocus
                                        onChange={ItemDialogCustmNotifiNoChngHndl} onKeyDown={ItemDialogCustmNotifioKeydown} />
                                    <input className='hi22 ml-1 wid1' value={ItemDialogValues.custm_Sl_No} id='custm_sl_no'
                                        onChange={ItemDialogCustmSlNoChngHndl} onKeyDown={ItemDialogCustmSlNoKeydown}
                                        onBlur={getCustomNotificationExemp} />
                                    <input className='hi22 ml-1 wid1' disabled value={ItemDialogValues.custm_rate} />
                                    <input className='hi22 ml-1 wid5' disabled value={ItemDialogValues.custm_flag} />
                                    <input className='hi22 ml-1 wid10' disabled value={ItemDialogValues.custm_amount} />
                                    <input className='hi22 ml-1 wid1' disabled value={ItemDialogValues.custm_uqc} />
                                </div>
                            </div>
                                <div>
                                    <center className='mt-3'>
                                        <Button size='small' variant="contained" color="primary" className='mb-2' disabled={ItemSwInfoSaveDsa} onClick={ItemCustmExmpSave}>{ItemSwInfoSve ? 'Processing...' : 'Save'}</Button>{' '}
                                        <Button size='small' variant="contained" color="primary" className='mb-2' disabled={ItemSwInfoUpdateDsa} onClick={ItemAddCustmNotnExmpUpdate}>{ItemSwInfoUpd ? 'Processing...' : 'Update'}</Button>{' '}
                                        <Button size='small' variant="contained" color="primary" className='mb-2' disabled={ItemSwInfoDeleteDsa} onClick={ItemAddCustmnotnExmpDelete}>{ItemSwInfoDlt ? 'Processing...' : 'Delete'}</Button>{' '}
                                        <Button size='small' variant="contained" color="primary" className='mb-2' onKeyDown={ItemDialogCustmRefBtnKeydown} onClick={ItemAddCustmExmpNotnNoReset}>Refresh</Button>{' '}
                                    </center>
                                </div>
                            </div>
                            <TableContainer className={classes.container}>
                                <Table stickyHeader className='table-bordered border-primary'>
                                    <TableHead>
                                        <StyledTableRow >
                                            <StyledTableCell className='p-1' align='center'>Sl</StyledTableCell>
                                            <StyledTableCell className='p-1' align='center'>Notification No</StyledTableCell>
                                            <StyledTableCell className='p-1' align='center'>Sl.No</StyledTableCell>
                                            <StyledTableCell className='p-1' align='center'>Rate</StyledTableCell>
                                            <StyledTableCell className='p-1' align='center'>Flag</StyledTableCell>
                                            <StyledTableCell className='p-1' align='center'>Amount</StyledTableCell>
                                            <StyledTableCell className='p-1' align='center'>UQC</StyledTableCell>
                                        </StyledTableRow>
                                    </TableHead>
                                    <TableBody>
                                        {itemRitcDetails.map((item) => { const selectedItem = isItemTblSelected(item.notificationNo);
                                            return(
                                            <TableRow key={item.serialNumber} hover onClick={() => editItemCustmNotnExmpDetails(item)} id='Item_add_custom_notn_id'
                                            onKeyDown={(e)=>itemDialogTblKeyDown(e,'add_custom_notn')} tabIndex={-1} selected={selectedItem}>
                                                <TableCell className='p-1' align='center'>{item.serialNumber}</TableCell>
                                                <TableCell className='p-1' align='center'>{item.notificationNo}</TableCell>
                                                <TableCell className='p-1' align='center'>{item.notificationSrNo}</TableCell>
                                                <TableCell className='p-1' align='center'>{item.notificationRate}</TableCell>
                                                <TableCell className='p-1' align='center'>{item.notificationFlag}</TableCell>
                                                <TableCell className='p-1' align='center'>{item.notificationAmount}</TableCell>
                                                <TableCell className='p-1' align='center'>{item.notificationUnit}</TableCell>
                                            </TableRow>)})}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Dialog>
                        {/* --OtherDuty-- */}
                        <Dialog onClose={ItemOtherDutyCloshHandle} open={ItemOtherDutyOpen} fullWidth={true} maxWidth="md">
                            {/* --dutyNotifi-- */}
                            <Dialog onClose={ItemOtherDutyNotfiCloshHandle} open={ItemOtherDutyNotfiOpen} fullWidth={true} maxWidth="md">
                                <DialogTitle className="dialogboxtitlecolour p-1">
                                    <center>View IGST Notification Details</center>
                                </DialogTitle>
                                <div><div className='dialogboxcolour'>
                                    <div className='form-inline'>
                                        <label className='mt-3' style={{ marginLeft: '30%', marginRight: '2.3%' }}>Find Notification.No</label>
                                        <input style={{ textTransform: 'uppercase' }} className='mt-3' autoFocus onKeyDown={ItemDialogOtherDutyFindigstNotiNoKeyDown}
                                            value={ItemDialogValues.f_scheme_code} onChange={ItemDialogFindothrDtyNotfiNoChngHandle} />
                                    </div>
                                    <div className='form-inline mt-2'>
                                        <label className='mb-2' style={{ marginLeft: '30%', marginRight: '1%' }}>Find NotificationSl.No</label>
                                        <input style={{ textTransform: 'uppercase' }} className='mb-2' onKeyDown={ItemDialogOtherDutyFindigstNotiSrlNoKeyDown}
                                        id='OtherDutyNotifySrlNo' value={ItemDialogValues.f_scheme_codeName} onChange={ItemDialogFindothrDtyNotfiSlNoChngHandle} />
                                    </div>
                                </div>
                                    <TableContainer className={classes.container}>
                                        <Table stickyHeader className='table-bordered border-primary'>
                                            <TableHead>
                                                <StyledTableRow >
                                                    <StyledTableCell className='p-1' align='center'>Notification.No</StyledTableCell>
                                                    <StyledTableCell className='p-1' align='center'>NotificationSl.No</StyledTableCell>
                                                    <StyledTableCell className='p-1' align='center'>NotificationRate</StyledTableCell>
                                                    <StyledTableCell className='p-1' align='center'>NotificationAmount</StyledTableCell>
                                                    <StyledTableCell className='p-1' align='center'>NotificationUnit</StyledTableCell>
                                                    <StyledTableCell className='p-1' align='center'>NotificationFlag</StyledTableCell>
                                                </StyledTableRow>
                                            </TableHead>
                                            <TableBody>
                                                {itemSchemeCodeDetails.map((item) => { const selectedItem = isItemTblSelected(item.notificationNo);
                                                    return(
                                                    <TableRow key={item.notificationNo} hover onClick={() => editItemOthrDutyNotifiDetails(item)} id='Item_OtherDutYfind_IGST_noti_id'
                                                    onKeyDown={(e)=>itemDialogSchemeCodeTblKeyDown(e,'othrDutIgstNoti')} tabIndex={-1} selected={selectedItem}>
                                                        <TableCell className='p-1' align='center'>{item.notificationNo}</TableCell>
                                                        <TableCell className='p-1' align='center'>{item.notificationSrNo}</TableCell>
                                                        <TableCell className='p-1' align='center'>{item.notificationRate}</TableCell>
                                                        <TableCell className='p-1' align='center'>{item.notificationAmount}</TableCell>
                                                        <TableCell className='p-1' align='center'>{item.notificationUnit}</TableCell>
                                                        <TableCell className='p-1' align='center'>{item.notificationFlag}</TableCell>
                                                    </TableRow>)})}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </div>
                            </Dialog>
                            {/*  */}
                            <DialogTitle className="dialogboxtitlecolour p-1">
                                <center>Add Other Duty</center>
                            </DialogTitle>
                            <div className='dialogboxcolour'>
                                <div>
                                    <div className='form-inline'>
                                        <Form.Label className='summury ml20 mt-3'>Other Duty Type</Form.Label>
                                        <Form.Label className='summury ml10 mt-3'>Notification.No</Form.Label>
                                        <Form.Label className='summury ml5 mt-3'>Sl.No</Form.Label>
                                        <Form.Label className='summury ml3 mt-3'>Rate</Form.Label>
                                        <Form.Label className='summury ml-4 mt-3'>Flag</Form.Label>
                                        <Form.Label className='summury ml3 mt-3'>Amount</Form.Label>
                                        <Form.Label className='summury ml3 mt-3'>UQC</Form.Label>
                                    </div>
                                    <div className='form-inline mt-1 ml16'>
                                        <select className='hi22 wid20 ml-1' value={ItemDialogValues.othrDuty_Type}
                                            autoFocus onChange={ItemDialogOthrDutyTypeChngHndl} onKeyDown={ItemDialogOthrDutyTyypeKeydown} >
                                            <option value={''}></option>
                                            {ItemCusHusCode.map((item) => (
                                                <option value={item.notificationType}>{item.notificationTypeName}</option>
                                            ))}
                                        </select>
                                        <input className='hi22 ml-1' value={ItemDialogValues.othrDuty_NotifiNo} id='otherDutyNotifyNo'
                                            onChange={ItemDialogOthrDutyNotifiNotifiNoChngHndl} onKeyDown={ItemDialogOthrDutyNotifioKeydown} />
                                        <button className='searchbutton' onClick={ItemOtherDutyNotfi_oprnHandle}>
                                            <SearchIcon fontSize='small' />
                                        </button>
                                        <input className='hi22 ml-1 wid1' value={ItemDialogValues.othrDuty_NotifiSlNo} id='othr_sl_no'
                                            onChange={ItemDialogOthrDutyNotifiNotifiSlNoChngHndl} onKeyDown={ItemDialogOthrDutySlNoKeydown}
                                            onBlur={getCustomNotificationOtherDuty} />
                                        <input className='hi22 ml-1 wid1' disabled value={ItemDialogValues.othrDuty_NotifiRate} />
                                        <input className='hi22 ml-1 wid5' disabled value={ItemDialogValues.othrDuty_NotifiFlag} />
                                        <input className='hi22 ml-1 wid10' disabled value={ItemDialogValues.othrDuty_NotifiAmount} />
                                        <input className='hi22 ml-1 wid1' disabled value={ItemDialogValues.othrDuty_uqc} />
                                    </div>
                                </div>
                                <div>
                                    <center className='mt-3'>
                                        <Button size='small' variant="contained" color="primary" className='mb-2' disabled={ItemSwInfoSaveDsa} onClick={ItemOthrDutySave}>{ItemSwInfoSve ? 'Processing...' : 'Save'}</Button>{' '}
                                        <Button size='small' variant="contained" color="primary" className='mb-2' disabled={ItemSwInfoUpdateDsa} onClick={ItemOthrDutyUpdate}>{ItemSwInfoUpd ? 'Processing...' : 'Update'}</Button>{' '}
                                        <Button size='small' variant="contained" color="primary" className='mb-2' disabled={ItemSwInfoDeleteDsa} onClick={ItemOthrDutyDelete}>{ItemSwInfoDlt ? 'Processing...' : 'Delete'}</Button>{' '}
                                        <Button size='small' variant="contained" color="primary" className='mb-2' onKeyDown={ItemDialogOthrDutyRefBtnKeydown} onClick={ItemAddOthrDutyReset}>Refresh</Button>{' '}
                                    </center>
                                </div>
                            </div>
                            <TableContainer className={classes.container}>
                                <Table stickyHeader className='table-bordered border-primary'>
                                    <TableHead>
                                        <StyledTableRow >
                                            <StyledTableCell className='p-1' align='center'>Sl</StyledTableCell>
                                            <StyledTableCell className='p-1' align='center'>Notification No</StyledTableCell>
                                            <StyledTableCell className='p-1' align='center'>Sl.No</StyledTableCell>
                                            <StyledTableCell className='p-1' align='center'>Rate</StyledTableCell>
                                            <StyledTableCell className='p-1' align='center'>Flag</StyledTableCell>
                                            <StyledTableCell className='p-1' align='center'>Amount</StyledTableCell>
                                            <StyledTableCell className='p-1' align='center'>UQC</StyledTableCell>
                                        </StyledTableRow>
                                    </TableHead>
                                    <TableBody>
                                        {itemRitcDetails.map((item) => { const selectedItem = isItemTblSelected(item.notificationNo);
                                            return(
                                            <TableRow key={item.serialNumber} hover onClick={() => editItemOthrDutyDetails(item)} id='Item_OtherDutY_Chrgs_id'
                                                    onKeyDown={(e)=>itemDialogTblKeyDown(e,'othrDutyChrg')} tabIndex={-1} selected={selectedItem}>
                                                <TableCell className='p-1' align='center'>{item.serialNumber}</TableCell>
                                                <TableCell className='p-1' align='center'>{item.notificationNo}</TableCell>
                                                <TableCell className='p-1' align='center'>{item.notificationSrNo}</TableCell>
                                                <TableCell className='p-1' align='center'>{item.notificationRate}</TableCell>
                                                <TableCell className='p-1' align='center'>{item.notificationFlag}</TableCell>
                                                <TableCell className='p-1' align='center'>{item.notificationAmount}</TableCell>
                                                <TableCell className='p-1' align='center'>{item.notificationUnit}</TableCell>
                                            </TableRow>)})}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Dialog>
                        {/* --ScDuty-- */}
                        <Dialog onClose={ItemScDutyCloshHandle} open={ItemScDutyOpen} fullWidth={true} maxWidth="md">
                            <DialogTitle className="dialogboxtitlecolour p-1">
                                <center>Add Special Duty</center>
                            </DialogTitle>
                            <div className='dialogboxcolour'>
                                <div>
                                    <div className='form-inline ml20'>
                                        <Form.Label className='summury ml-4 mt-3'>Notification.No</Form.Label>
                                        <Form.Label className='summury ml6 mt-3'>Sl.No</Form.Label>
                                        <Form.Label className='summury ml5 mt-3'>Rate</Form.Label>
                                        <Form.Label className='summury ml-4 mt-3'>Flag</Form.Label>
                                        <Form.Label className='summury ml5 mt-3'>Amount</Form.Label>
                                        <Form.Label className='summury ml5 mt-3'>UQC</Form.Label>
                                    </div>
                                    <div className='form-inline mt-1'>
                                        <Form.Label className='ml10'>Spcial Duty</Form.Label>
                                        <input className='hi22 ml-1' value={ItemDialogValues.custm_notfiNo} autoFocus
                                            onChange={ItemDialogCustmNotifiNoChngHndl} onKeyDown={ItemDialogScDutyNotifioKeydown} />
                                        <input className='hi22 ml-1 wid1' value={ItemDialogValues.custm_Sl_No} id='ScDuty_sl_no'
                                            onChange={ItemDialogCustmSlNoChngHndl} onKeyDown={ItemDialogScDutySlNoKeydown}
                                            onBlur={getScDutyNotification} />
                                        <input className='hi22 ml-1 wid1' disabled value={ItemDialogValues.custm_rate} />
                                        <input className='hi22 ml-1 wid5' disabled value={ItemDialogValues.custm_flag} />
                                        <input className='hi22 ml-1 wid10' disabled value={ItemDialogValues.custm_amount} />
                                        <input className='hi22 ml-1 wid1' disabled value={ItemDialogValues.custm_uqc} />
                                    </div>
                                </div>
                                <div>
                                    <center className='mt-3'>
                                        <Button size='small' variant="contained" color="primary" className='mb-2' disabled={ItemSwInfoSaveDsa} onClick={ItemScdSave}>{ItemSwInfoSve ? 'Processing...' : 'Save'}</Button>{' '}
                                        <Button size='small' variant="contained" color="primary" className='mb-2' disabled={ItemSwInfoUpdateDsa} onClick={ItemAddScdUpdate}>{ItemSwInfoUpd ? 'Processing...' : 'Update'}</Button>{' '}
                                        <Button size='small' variant="contained" color="primary" className='mb-2' disabled={ItemSwInfoDeleteDsa} onClick={ItemAddScdDelete}>{ItemSwInfoDlt ? 'Processing...' : 'Delete'}</Button>{' '}
                                        <Button size='small' variant="contained" color="primary" className='mb-2' onKeyDown={ItemDialogScDutyRefBtnKeydown} onClick={ItemAddCustmExmpNotnNoReset}>Refresh</Button>{' '}
                                    </center>
                                </div>
                            </div>
                            <TableContainer className={classes.container}>
                                <Table stickyHeader className='table-bordered border-primary'>
                                    <TableHead>
                                        <StyledTableRow >
                                            <StyledTableCell className='p-1' align='center'>Sl</StyledTableCell>
                                            <StyledTableCell className='p-1' align='center'>Notification No</StyledTableCell>
                                            <StyledTableCell className='p-1' align='center'>Sl.No</StyledTableCell>
                                            <StyledTableCell className='p-1' align='center'>Rate</StyledTableCell>
                                            <StyledTableCell className='p-1' align='center'>Flag</StyledTableCell>
                                            <StyledTableCell className='p-1' align='center'>Amount</StyledTableCell>
                                            <StyledTableCell className='p-1' align='center'>UQC</StyledTableCell>
                                        </StyledTableRow>
                                    </TableHead>
                                    <TableBody>
                                        {itemRitcDetails.map((item) => { const selectedItem = isItemTblSelected(item.notificationNo);
                                            return(
                                            <TableRow key={item.serialNumber} hover onClick={() => editItemCustmNotnExmpDetails(item)} id='Item_SpclDutY_Chrgs_id'
                                            onKeyDown={(e)=>itemDialogTblKeyDown(e,'SpclDutyChrg')} tabIndex={-1} selected={selectedItem}>
                                                <TableCell className='p-1' align='center'>{item.serialNumber}</TableCell>
                                                <TableCell className='p-1' align='center'>{item.notificationNo}</TableCell>
                                                <TableCell className='p-1' align='center'>{item.notificationSrNo}</TableCell>
                                                <TableCell className='p-1' align='center'>{item.notificationRate}</TableCell>
                                                <TableCell className='p-1' align='center'>{item.notificationFlag}</TableCell>
                                                <TableCell className='p-1' align='center'>{item.notificationAmount}</TableCell>
                                                <TableCell className='p-1' align='center'>{item.notificationUnit}</TableCell>
                                            </TableRow>)})}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Dialog>
                        {/* --SW Control-- */}
                        <Dialog onClose={ItemSWControlCloshHandle} open={ItemSWControlOpen} fullWidth={true} maxWidth="md">
                            <DialogTitle className="dialogboxtitlecolour p-1">
                                <center>Add SW Control</center>
                            </DialogTitle>
                            <div><div className='dialogboxcolour'>
                                <div className='form-inline ml7'>
                                    <label className='mt-3'>Control Type Code</label>
                                    <select className='ml-1 mt-3 hi22 wid12' value={ItemDialogValues.swcntl_typ_code}
                                        autoFocus onChange={ItemDialogSwcntlTypeCodeChngHndl} onKeyDown={ItemDialogSwControleTypeCodeKeydown}>
                                        <option value={''}></option>
                                        {ItemCusHusCode.map((item) => (
                                            <option value={item.swControl}>{item.swControl}</option>
                                        ))}
                                    </select>
                                    <label className='ml-1 mt-3'>Location</label>
                                    <input className='ml-4 hi22 wid12 mt-3' value={ItemDialogValues.swcntl_location}
                                        id='swControllLocation' onChange={ItemDialogSwcntlLocationChngHndl} onKeyDown={ItemDialogSwControleLocationKeydown} />
                                    <label className='ml-1 mt-3'>StartDate</label>
                                    <input className='ml3_5 hi22 mt-3' type={'date'} value={ItemDialogValues.swcntl_start_date}
                                        id='startDate' onChange={ItemDialogSwcntlStartDateChngHndl} onKeyDown={ItemDialogSwControleStartDateKeydown} />
                                </div>
                                <div className='form-inline mt-1 ml7'>
                                    <label>Control End Date</label>
                                    <input className='ml1_5 hi22 wid15 ml2' type={'date'} value={ItemDialogValues.swcntl_end_date}
                                        id='ContrlEndDate' onChange={ItemDialogSwcntlEndDateChngHndl} onKeyDown={ItemDialogSwControleEndDateKeydown} />
                                    <label className='ml-1'>Result Code</label>
                                    <select className='hi22 wid12 ml0_5' value={ItemDialogValues.swcntl_result_code}
                                        id='SwcontrolresultCode' onChange={ItemDialogSwcntlResultCodeChngHndl} onKeyDown={ItemDialogSwControleResultCodeKeydown}>
                                        <option value={''}></option>
                                        {ItemSwCodeDrp.map(item => (
                                            <option value={item.swControlResultCode}>{item.swControlResultCode}</option>
                                        ))}
                                    </select>
                                    <label className='ml-1'>Result Text</label>
                                    <input className='hi22 ml2_2 wid14' value={ItemDialogValues.swcntl_result_text} onKeyDown={ItemDialogSwControleResultTextKeydown}
                                        id='SWControlResultText' onChange={ItemDialogSwcntlResultTextChngHndl} />
                                </div>
                                <div className='form-inline mt-1 ml7'>
                                    <label>Measurnment</label>
                                    <input className='ml3_5 hi22 wid12 ml3_6' value={ItemDialogValues.swcntl_measurnment}
                                        id='SwControllmeasurMent' onChange={ItemDialogSwcntlMeasurnmentChngHndl} onKeyDown={ItemDialogSwControleMeasurementKeydown} />
                                    <label className='ml-1'>Control UQC</label>
                                    <select className='ml-1 hi22 wid12' value={ItemDialogValues.swcntl_uqc}
                                        onChange={ItemDialogSwcntlUqcChngHndl}>
                                        <option value={''}></option>
                                        {ItemSwUQCDrp.map(item => (
                                            <option value={item.unitCode}>{item.unitCode}</option>
                                        ))}
                                    </select>
                                    <label className='ml-1'>Control Sl.No</label>
                                    <input className='wid14 hi22 sample9' value={ItemDialogValues.swcntl_sl_no}
                                        id='SwControlSlNo' onChange={ItemDialogSwcntlSlNoChngHndl} onKeyDown={ItemDialogSwControleSl_NoKeydown} />
                                </div>
                                <div>
                                    <center className='mt-3'>
                                        <Button size='small' variant="contained" color="primary" className='mb-2' id='Sc_duty_Sve' disabled={ItemSwInfoSaveDsa} onClick={ItemSwControlSave}>{ItemSwInfoSve ? 'Processing...' : 'Save'}</Button>{' '}
                                        <Button size='small' variant="contained" color="primary" className='mb-2' disabled={ItemSwInfoUpdateDsa} onClick={ItemSwControlUpdate}>{ItemSwInfoUpd ? 'Processing...' : 'Update'}</Button>{' '}
                                        <Button size='small' variant="contained" color="primary" className='mb-2' disabled={ItemSwInfoDeleteDsa} onClick={ItemAddSwControlDelete}>{ItemSwInfoDlt ? 'Processing...' : 'Delete'}</Button>{' '}
                                        <Button size='small' variant="contained" color="primary" className='mb-2' onKeyDown={ItemDialogSwControleRefBtnKeydown} onClick={ItemAddSwControlReset}>Refresh</Button>{' '}
                                    </center>
                                </div>
                            </div>
                                <TableContainer className={classes.container}>
                                    <Table stickyHeader className='table-bordered border-primary'>
                                        <TableHead>
                                            <StyledTableRow >
                                                <StyledTableCell className='p-1' align='center'>Sl</StyledTableCell>
                                                <StyledTableCell className='p-1' align='center'>TypeCode</StyledTableCell>
                                                <StyledTableCell className='p-1' align='center'>Location</StyledTableCell>
                                                <StyledTableCell className='p-1' align='center'>StartDate</StyledTableCell>
                                                <StyledTableCell className='p-1' align='center'>EndDate</StyledTableCell>
                                                <StyledTableCell className='p-1' align='center'>ResultCode</StyledTableCell>
                                                <StyledTableCell className='p-1' align='center'>ResultText</StyledTableCell>
                                                <StyledTableCell className='p-1' align='center'>Measurnment</StyledTableCell>
                                                <StyledTableCell className='p-1' align='center'>UQC</StyledTableCell>
                                                <StyledTableCell className='p-1' align='center'>Sl.No</StyledTableCell>
                                            </StyledTableRow>
                                        </TableHead>
                                        <TableBody>
                                            {itemRitcDetails.map((item) => { const selectedItem = isItemTblSelected(item.conType);
                                                return(
                                                <TableRow key={item.serialNumber} hover onClick={() => editItemSwCntlDetails(item)} id='Item_sw_controll_id'
                                                onKeyDown={(e)=>itemDialogTblKeyDown(e,'swControll')} tabIndex={-1} selected={selectedItem}>
                                                    <TableCell className='p-1' align='center'>{item.serialNumber}</TableCell>
                                                    <TableCell className='p-1' align='center'>{item.conType}</TableCell>
                                                    <TableCell className='p-1' align='center'>{item.conLocation}</TableCell>
                                                    <TableCell className='p-1' align='center'>{item.conStartDate}</TableCell>
                                                    <TableCell className='p-1' align='center'>{item.conEndDate}</TableCell>
                                                    <TableCell className='p-1' align='center'>{item.conResultCode}</TableCell>
                                                    <TableCell className='p-1' align='center'>{item.conResultText}</TableCell>
                                                    <TableCell className='p-1' align='center'>{item.conMeasurnment}</TableCell>
                                                    <TableCell className='p-1' align='center'>{item.unitCode}</TableCell>
                                                    <TableCell className='p-1' align='center'>{item.srNo}</TableCell>
                                                </TableRow>)})}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </div>
                        </Dialog>
                        {/* --SW Statement-- */}
                        <Dialog onClose={ItemSWStatementCloshHandle} open={ItemSWStatementOpen} fullWidth={true} maxWidth="md">
                            <DialogTitle className="dialogboxtitlecolour p-1">
                                <center>Add SW Statement</center>
                            </DialogTitle>
                            <div><div className='dialogboxcolour'>
                                <div className='form-inline ml15'>
                                    <label className='mt-3'>Statement Type</label>
                                    <select className='wid12 hi22 ml-1 mt-3' value={ItemDialogValues.swStatmnt_typ}
                                        autoFocus onChange={ItemDialogSwStmntTypeChngHndl} onKeyDown={ItemDialogSwStatementTypeKeydown}>
                                        <option value={''}></option>
                                        {ItemSwCodeDrp.map((item) => (
                                            <option value={item.swstatementTypeName}>{item.swStatementType}</option>
                                        ))}
                                    </select>
                                    <label className='mt-3 ml-1'>Statement Code</label>
                                    <select className='wid12 hi22 ml-1 mt-3' value={ItemDialogValues.swStatment_code}
                                        id='SWStatementStatementCode' onChange={ItemDialogSwStmntCodeChngHndl} onKeyDown={ItemDialogSwStatementCodeKeydown}>
                                        <option value={''}></option>
                                        {ItemCusHusCode.map((item) => (
                                            <option value={item.swStatement}>{item.swStatement}</option>
                                        ))}
                                    </select>
                                    <label className='mt-3 ml-1'>Statement Text</label>
                                    <input className='hi22 mt-3 ml1 wid15_1' value={ItemDialogValues.swStatment_text}
                                        id='SwStatementText' onChange={ItemDialogSwStmntTxtChngHndl} onKeyDown={ItemDialogSwStatementTextKeydown} />
                                </div>
                                <div className='form-inline mt-2 ml-4'>
                                    <label className='sample1'>Declaration Type(M/T/N/B)</label>
                                    <input className='hi22 wid13_1' value={ItemDialogValues.swStmnt_dclrtiontypeMtnb} onKeyDown={ItemDialogSwStatementDeclaretionTypeKeydown}
                                        id='SwStatementDeclaretionType' onChange={ItemDialogSwStmntDecTypeMTNBChngHndl} style={{ textTransform: 'uppercase', textAlign: 'center' }} />
                                    <label className='ml-1' >Declaration No</label>
                                    <input className='hi22 ml1_3 wid13_1' value={ItemDialogValues.swStatment_decNo}
                                        id='SwStatementDeclarationNo' onChange={ItemDialogSwStmntDecNoChngHndl} onKeyDown={ItemDialogSwStatementDeclaretionNoKeydown} />
                                    <label className='ml-1'>Declaration Date</label>
                                    <input className='hi22' type={'date'} value={ItemDialogValues.swStatment_date}
                                        id='SwStatementDecalarationDate' onChange={ItemDialogSwStmntDecDateChngHndl} onKeyDown={ItemDialogSwStatementDeclaretionDateKeydown} />
                                </div>
                                <div>
                                    <center className='mt-3'>
                                        <Button size='small' variant="contained" color="primary" className='mb-2' id='Sc_duty_Sve' disabled={ItemSwInfoSaveDsa} onClick={ItemSwStatemntSave}>{ItemSwInfoSve ? 'Processing...' : 'Save'}</Button>{' '}
                                        <Button size='small' variant="contained" color="primary" className='mb-2' disabled={ItemSwInfoUpdateDsa} onClick={ItemSwStatementUpdate}>{ItemSwInfoUpd ? 'Processing...' : 'Update'}</Button>{' '}
                                        <Button size='small' variant="contained" color="primary" className='mb-2' disabled={ItemSwInfoDeleteDsa} onClick={ItemSwStatementDelete}>{ItemSwInfoDlt ? 'Processing...' : 'Delete'}</Button>{' '}
                                        <Button size='small' variant="contained" color="primary" className='mb-2' onKeyDown={ItemDialogSwStmntRefBtnKeydown} onClick={ItemAddSwStatementReset}>Refresh</Button>{' '}
                                    </center>
                                </div>
                            </div>
                                <TableContainer className={classes.container}>
                                    <Table stickyHeader className='table-bordered border-primary'>
                                        <TableHead>
                                            <StyledTableRow >
                                                <StyledTableCell className='p-1' align='center'>Sl</StyledTableCell>
                                                <StyledTableCell className='p-1' align='center'>StatementType</StyledTableCell>
                                                <StyledTableCell className='p-1' align='center'>StatementCode</StyledTableCell>
                                                <StyledTableCell className='p-1' align='center'>StatementText</StyledTableCell>
                                                <StyledTableCell className='p-1' align='center'>DeclarationType</StyledTableCell>
                                                <StyledTableCell className='p-1' align='center'>DeclarationNo</StyledTableCell>
                                                <StyledTableCell className='p-1' align='center'>DeclarationDate</StyledTableCell>
                                            </StyledTableRow>
                                        </TableHead>
                                        <TableBody>
                                            {itemRitcDetails.map((item) => { const selectedItem = isItemTblSelected(item.conType);
                                                return(
                                                <TableRow key={item.serialNumber} hover onClick={() => editItemSwStatemntDetails(item)} id='Item_swStatement_id'
                                                onKeyDown={(e)=>itemDialogTblKeyDown(e,'swStatement')} tabIndex={-1} selected={selectedItem}>
                                                    <TableCell className='p-1' align='center'>{item.serialNumber}</TableCell>
                                                    <TableCell className='p-1' align='center'>{item.statementType}</TableCell>
                                                    <TableCell className='p-1' align='center'>{item.statementCode}</TableCell>
                                                    <TableCell className='p-1' align='center'>{item.statementText}</TableCell>
                                                    <TableCell className='p-1' align='center'>{item.decType}</TableCell>
                                                    <TableCell className='p-1' align='center'>{item.decNo}</TableCell>
                                                    <TableCell className='p-1' align='center'>{item.decDate}</TableCell>
                                                </TableRow>)})}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </div>
                        </Dialog>
                        {/* --Policy Para- */}
                        <Dialog onClose={ItemPolicyParaCloshHandle} open={ItemPolicyParaOpen} fullWidth={true} maxWidth="md">
                            <DialogTitle className="dialogboxtitlecolour p-1">
                                <center>Add Policy Para</center>
                            </DialogTitle>
                            <div className='dialogboxcolour'>
                                <div>
                                    <center>
                                        <label className='mt-3'>Policy Para No</label>
                                        <input value={ItemDialogValues.policy_paraNo} onKeyDown={ItemDialogPolicyParaPolicyNoKeydown}
                                            autoFocus className='ml-3 mt-3' onChange={ItemDialogPolicyParaNoChngHndl} />
                                    </center>
                                </div>
                                <div className='mt-2'>
                                    <center>
                                        <label>Policy Para Year</label>
                                        <input className='ml-1' value={ItemDialogValues.policy_paraYear} onKeyDown={ItemDialogPolicyParaPolicyYearKeydown}
                                            id='PolicyParaPolicyYear' onChange={ItemDialogPolicyParaYearChngHndl} />
                                    </center>
                                </div>
                                <div className='mt-2 mb-1'>
                                    <center>
                                        <Button size='small' variant="contained" color="primary" id='Sc_duty_Sve' disabled={ItemSwInfoSaveDsa} onClick={ItemPolicySave}>{ItemSwInfoSve ? 'Processing...' : 'Save'}</Button>{' '}
                                        <Button size='small' variant="contained" color="primary" disabled={ItemSwInfoUpdateDsa} onClick={ItemPolicyUpdate}>{ItemSwInfoUpd ? 'Processing...' : 'Update'}</Button>{' '}
                                        <Button size='small' variant="contained" color="primary" disabled={ItemSwInfoDeleteDsa} onClick={ItemPolicyDelete}>{ItemSwInfoDlt ? 'Processing...' : 'Delete'}</Button>{' '}
                                        <Button size='small' variant="contained" color="primary" onKeyDown={ItemDialogPolicyParaRefBtnKeydown} onClick={ItemPolicyReset}>Refresh</Button>{' '}
                                    </center>
                                </div>
                            </div>
                            <TableContainer className={classes.container}>
                                <Table stickyHeader className='table-bordered border-primary'>
                                    <TableHead>
                                        <StyledTableRow >
                                            <StyledTableCell className='p-1' align='center'>Sl</StyledTableCell>
                                            <StyledTableCell className='p-1' align='center'>Policy Para No</StyledTableCell>
                                            <StyledTableCell className='p-1' align='center'>Policy Para Year</StyledTableCell>
                                        </StyledTableRow>
                                    </TableHead>
                                    <TableBody>
                                        {itemRitcDetails.map((item) => { const selectedItem = isItemTblSelected(item.policyParaNo);
                                            return(
                                            <TableRow key={item.serialNumber} hover onClick={() => editItemPolicyParaDetails(item)} id='Item_policyPara_id'
                                            onKeyDown={(e)=>itemDialogTblKeyDown(e,'policyPara')} tabIndex={-1} selected={selectedItem}>
                                                <TableCell className='p-1' align='center'>{item.serialNumber}</TableCell>
                                                <TableCell className='p-1' align='center'>{item.policyParaNo}</TableCell>
                                                <TableCell className='p-1' align='center'>{item.policyPeraYear}</TableCell>
                                            </TableRow>)})}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Dialog>
                        {/* --swDocs-- */}
                        <Dialog onClose={ItemSwDocsCloshHandle} open={ItemSwDocsOpen} fullWidth={true} maxWidth="lg">
                            {/*item_doctype*/}
                            <Dialog open={itemdoctypecode_open} onClose={ItemDoc_typecodeOpenHandle_close} fullWidth={true} maxWidth='md'>
                                <DialogTitle align='center' className="dialogboxtitlecolour p-1">
                                    VIEW DOCUMENT TYPE
                                </DialogTitle>
                                <div>
                                    <div className="dialogboxcolour">
                                        <div className="form-inline" style={{ width: "80%", marginLeft: "18rem", }} size="sm">
                                            <label className="mt-3">Find Document Type</label>
                                            <input classNmae='mt-3' value={ItemDialogValues.FindDocumentType} autoFocus onKeyDown={ItemDialogViewDocumentTypeFindDocumentKeydown}
                                                onChange={ItemFindDocumentTypeChangeHandle} style={{ textTransform: 'uppercase', textAlign: 'center', marginLeft: "3rem" }} />
                                        </div>
                                        <div className="form-inline " style={{ width: "80%", marginLeft: "18rem", }} size="sm">
                                            <label >Find Document Name</label>
                                            <input value={ItemDialogValues.FindDocumentName} onChange={ItemFindDocumentNameChangeHandle} id='ViwDocumentTypeName'
                                             onKeyDown={ItemDialogViewDocumentTypeFindDocumentNameKeydown} className=" mt-2 mb-2" style={{ textTransform: 'uppercase', textAlign: 'center', marginLeft: "2.6rem" }} />
                                        </div>
                                    </div>
                                </div>
                                <TableContainer className={classes.container}>
                                    <Table stickyHeader className="table-bordered">
                                        <TableHead>
                                            <StyledTableRow>
                                                <StyledTableCell align='center' className='p-1'>Document Type Code</StyledTableCell>
                                                <StyledTableCell align='center' className='p-1'>Document Type Name</StyledTableCell>
                                            </StyledTableRow>
                                        </TableHead>
                                        <TableBody>
                                            {
                                                itemSchemeCodeDetails.map((trns) => { const selectedItem = isItemTblSelected(trns.supDocType);
                                                    return(
                                                        <TableRow hover key={trns.supDocType} onClick={() => EditItemSwDocsTypeCodeDetails(trns)}  id='Item_FindDoc_typ_id'
                                                        onKeyDown={(e)=>itemDialogSchemeCodeTblKeyDown(e,'Find_Doc_typ')} tabIndex={-1} selected={selectedItem}>
                                                            <TableCell align='center' className='p-1'>{trns.supDocType}</TableCell>
                                                            <TableCell align='center' className='p-1'>{trns.supDocName}</TableCell>
                                                        </TableRow>
                                                    )})}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Dialog>
                            {/*item_issuepartyname*/}
                            <Dialog open={ItemSwDocsSupplierNameOpen} onClose={ItemissuepartynameOpenHandle_close} fullWidth={true} maxWidth='md'>
                                <DialogTitle align='center' className="dialogboxtitlecolour p-1">
                                    VIEW SUPPLIER DETAILS
                                </DialogTitle>
                                <div className='dialogboxcolour'>
                                    <div className="mb-2 mt-4">
                                        <div className="form-inline mt-2" style={{ width: "80%", marginLeft: "30%", }} size="sm">
                                            <label>Find Supplier Name</label>
                                            <input value={ItemDialogValues.FindSupplierName} onChange={ItemFindSupplierNameChangeHandle} autoFocus
                                                style={{ textTransform: 'uppercase', textAlign: 'center', marginLeft: "3rem" }} onKeyDown={ItemDialogViewDocumentTypeFindSupNameKeydown} />
                                        </div>
                                    </div>
                                </div>
                                <TableContainer className={classes.container}>
                                    <Table stickyHeader className="table-bordered">
                                        <TableHead>
                                            <StyledTableRow>
                                                <StyledTableCell align='center' className='p-1'>Name</StyledTableCell>
                                                <StyledTableCell align='center' className='p-1'>Address1</StyledTableCell>
                                                <StyledTableCell align='center' className='p-1'>Address2</StyledTableCell>
                                                <StyledTableCell align='center' className='p-1'>PinCode</StyledTableCell>
                                                <StyledTableCell align='center' className='p-1'>CountryName</StyledTableCell>
                                            </StyledTableRow>
                                        </TableHead>
                                        <TableBody>
                                            {itemSchemeCodeDetails.map((trns) => { const selectedItem = isItemTblSelected(trns.supplierName);
                                                return(
                                                <TableRow hover key={trns.supplierName} onClick={() => EditItemSwDocsIssuePrtyNameDetails(trns)}  id='Item_FindDoc_SupName_id'
                                                onKeyDown={(e)=>itemDialogSchemeCodeTblKeyDown(e,'FindDoc_SupName')} tabIndex={-1} selected={selectedItem}>
                                                    <TableCell align='center' className='p-1'>{trns.supplierName}</TableCell>
                                                    <TableCell align='center' className='p-1'>{trns.supplierAddress1}</TableCell>
                                                    <TableCell align='center' className='p-1'>{trns.supplierAddress2}</TableCell>
                                                    <TableCell align='center' className='p-1'>{trns.supplierPincode}</TableCell>
                                                    <TableCell align='center' className='p-1'>{trns.countryName}</TableCell>
                                                </TableRow>
                                            )})}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Dialog>
                            {/*item_beneficiaryname*/}
                            <Dialog open={ItemAddHssDetailsopen} onClose={ItemBeneficiaryOpenHandleclose} maxWidth='md' fullWidth={true}>
                                <DialogTitle align='center' className="dialogboxtitlecolour p-1">Add SW Supporting Docs</DialogTitle>
                                <Paper className={classes.paper} style={{ backgroundColor: '#C8EDE7' }}>
                                    <div className='mt-3 '>
                                        <center>
                                            <label >Importer IEC Code</label>
                                            <input value={ItemDialogValues.ImporterIECCode} onChange={ItemImporterIECCodeChangeHandle} onKeyDown={itemSwSupprtBeneficaryimporterieckeydown}
                                                className='ml1_5 hi22' autoFocus />
                                            <button className='searchbutton hi22' onClick={ItemImporterDetailsOpenHandle}><SearchIcon /></button>
                                        </center>
                                    </div>
                                    <div className='mt-4 mb-3'>
                                        <center>
                                            <label >Branch Serial No</label>
                                            <input value={ItemDialogValues.BranchSerialNo} onChange={ItemBranchSerialNoChangeHandle}
                                                id='SwDocsSrlNo' onKeyDown={itemSwSupprtBeneficaryimporterbrnchSrNokeydown} className='hi22 ml-4' />
                                            <button className='searchbutton hi22' onClick={ItemImporterBranchDetailsOpenHandle}><SearchIcon /></button>
                                        </center>
                                    </div>
                                </Paper>
                            </Dialog>
                            {/*Item_importer_iec*/}
                            <Dialog open={ItemImporterDetailsOpen} onClose={ItemImporterDetailsOpenHandleClose} fullWidth={true} maxWidth='md'>
                                <DialogTitle align='center' className="dialogboxtitlecolour p-1">
                                    VIEW IMPORTER DETAILS
                                </DialogTitle>
                                <div className='dialogboxcolour'>
                                    <div className="mb-2 mt-4">
                                        <div className="form-inline mt-2" style={{ width: "80%", marginLeft: "15rem", }} size="sm">
                                            <label >Find Importer Name</label>
                                            <input value={ItemDialogValues.FindImporterName} onChange={ItemFindImporterNameChangeHandle} autoFocus
                                                style={{ textTransform: 'uppercase', textAlign: 'center', marginLeft: "2.9rem" }} onKeyDown={itemSwSupprtBeneficaryFindimporterieckeydown} />
                                        </div>
                                        <div className="form-inline " style={{ width: "80%", marginLeft: "15rem", }} size="sm">
                                            <label >Find Importer Code</label>
                                            <input value={ItemDialogValues.FindImporterCode} onChange={ItemFindImporterCodeChangeHandle} id='SwDocsFindItemIecCode'
                                             onKeyDown={ItemDialogDocsImporterKeydown} className=" mt-2 mb-1" style={{ textTransform: 'uppercase', textAlign: 'center', marginLeft: "3.2rem" }} />
                                        </div>
                                    </div>
                                </div>
                                <TableContainer className={classes.container}>
                                    <Table stickyHeader className="table-bordered">
                                        <TableHead>
                                            <StyledTableRow>
                                                <StyledTableCell align='center' className='p-1'>Importer IEC Code</StyledTableCell>
                                                <StyledTableCell align='center' className='p-1'>Importer Name</StyledTableCell>
                                            </StyledTableRow>
                                        </TableHead>
                                        <TableBody>
                                            {itemSchemeCodeDetails.map((trns) => { const selectedItem = isItemTblSelected(trns.importer_iec_no);
                                                return(
                                                <TableRow hover key={trns.importer_iec_no} onClick={() => EditItemSwDocsIecCodeDetails(trns)} id='Item_FindDoc_ImpTbl_id'
                                                onKeyDown={(e)=>itemDialogSchemeCodeTblKeyDown(e,'FindDoc_ImpName')} tabIndex={-1} selected={selectedItem}>
                                                    <TableCell align='center' className='p-1'>{trns.importer_iec_no}</TableCell>
                                                    <TableCell align='center' className='p-1'>{trns.importer_name}</TableCell>
                                                </TableRow>
                                            )})}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Dialog>
                            {/*Item_importer_Branch*/}
                            <Dialog open={ItemImporterBranchDetailsOpen} onClose={ItemImporterBranchDetailsOpenHandleClose} fullWidth={true} maxWidth='md'>
                                <DialogTitle align='center' className="dialogboxtitlecolour p-1">
                                    VIEW IMPORTER BRANCH DETAILS
                                </DialogTitle>
                                <div className='dialogboxcolour'>
                                    <div className="mb-2 mt-4">

                                        <div className="form-inline mt-2" style={{ width: "80%", marginLeft: "12rem", }} size="sm">
                                            <label>Find Importer State</label>
                                            <input value={ItemDialogValues.FindImporterState} onChange={ItemFindImporterStateChangeHandle} autoFocus
                                                style={{ textTransform: 'uppercase', textAlign: 'center', marginLeft: "3rem" }} onKeyDown={itemSwSupprtBeneficaryFindImporterStatekeydown} />
                                        </div>
                                        <div className="form-inline " style={{ width: "80%", marginLeft: "12rem", }} size="sm">
                                            <label>Find Branch Sr.NO</label>
                                            <input value={ItemDialogValues.FindBranchSr_NO} onChange={ItemFindBranchSr_NOChangeHandle} id='SwDocsFindBrnchSrNo'
                                             onKeyDown={itemSwSupprtBeneficaryFindImporterBrnchSrlnokeydown} className=" mt-2 mb-1" style={{ textTransform: 'uppercase', textAlign: 'center', marginLeft: "3.2rem" }} />
                                        </div>
                                    </div>
                                </div>
                                <TableContainer className={classes.container}>
                                    <Table stickyHeader className="table-bordered">
                                        <TableHead>
                                            <StyledTableRow>
                                                <StyledTableCell align='center' className='p-1'>Sr.No</StyledTableCell>
                                                <StyledTableCell align='center' className='p-1'>State</StyledTableCell>
                                                <StyledTableCell align='center' className='p-1'>Address1</StyledTableCell>
                                                <StyledTableCell align='center' className='p-1'>Address2</StyledTableCell>
                                            </StyledTableRow>
                                        </TableHead>
                                        <TableBody>
                                            {itemSchemeCodeDetails.map((trns) => { const selectedItem = isItemTblSelected(trns.branch_sl_no);
                                                return(
                                                <TableRow hover key={trns.branch_sl_no} onClick={() => EditItemSwDocsBrncSlNoDetails(trns)} id='Item_FindDoc_ImpBrncTbl_id'
                                                onKeyDown={(e)=>itemDialogSchemeCodeTblKeyDown(e,'FindDoc_ImpBrnch')} tabIndex={-1} selected={selectedItem}>
                                                    <TableCell align='center' className='p-1'>{trns.branch_sl_no}</TableCell>
                                                    <TableCell align='center' className='p-1'>{trns.importerState}</TableCell>
                                                    <TableCell align='center' className='p-1'>{trns.importerAddress}</TableCell>
                                                    <TableCell align='center' className='p-1'>{trns.importerAddress1}</TableCell>
                                                </TableRow>
                                            )})}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Dialog>
                            {/*  */}
                            <DialogTitle className="dialogboxtitlecolour p-1" align='center'>Add SW Supporting Docs</DialogTitle>
                            <div className='form-inline'>
                                <Grid container spacing={1}>
                                    <Grid xs={4} item>
                                        <Paper className={classes.paper} style={{ backgroundColor: '#C8EDE7' }}>
                                            <Row>
                                                <Col>
                                                    <label className='summury' style={{ justifyContent: 'left' }}>Image RefNo</label>
                                                </Col>
                                                <Col>
                                                    <input value={ItemDialogValues.ImageRefNo} onChange={ItemImageRefNoChangeHandle} autoFocus onKeyDown={itemSwSupprtDocImageRefNokeydown}
                                                        maxLength={16} className='mb-2 hi22' style={{ textTransform: 'uppercase' }} />
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col>
                                                    <label className='summury' style={{ justifyContent: 'left' }}>Doc Type Code</label>
                                                </Col>
                                                <Col>
                                                    <input value={ItemDialogValues.DocTypeCode} onChange={ItemDocTypeCodeChangeHandle} onKeyDown={itemSwSupprtDocTypCodekeydown}
                                                        id='SwDocsDocTypeCode' className='mb-2 hi22 widh73' style={{ textTransform: 'uppercase' }} />
                                                    <button className='mb-2 searchbutton' onClick={ItemDoc_typecodeOpenHandle}>
                                                        <SearchIcon fontSize="small" />
                                                    </button>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col>
                                                    <label className='summury' style={{ justifyContent: 'left' }}>Issue Party Name</label>
                                                </Col>
                                                <Col>
                                                    <input value={ItemDialogValues.IssuePartyName} onChange={ItemIssuePartyNameChangeHandle} onKeyDown={itemSwSupprtIssuepartynamekeydown}
                                                        id='SwDocsIssuePartyName' className='mb-2 hi22 widh73' style={{ textTransform: 'uppercase' }} />
                                                    <button className='mb-2 searchbutton ' onClick={ItemissuepartynameOpenHandle}>
                                                        <SearchIcon fontSize="small" /></button>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col>
                                                    <label className='summury' style={{ justifyContent: 'left' }}>Place Of Issue</label>
                                                </Col>
                                                <Col>
                                                    <input value={ItemDialogValues.PlaceOfIssue} onChange={ItemPlaceOfIssueIssuePartyNameChangeHandle} onKeyDown={itemSwSupprtPlaceOfIssuekeydown}
                                                        id='SwDocsPlaceOfIssue' className='hi22 mb-2' style={{ textTransform: 'uppercase' }} />
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col>
                                                    <label className='summury' style={{ justifyContent: 'left' }}>Doc Issue Date</label>
                                                </Col>
                                                <Col>
                                                    <input value={ItemDialogValues.DocIssueDate} onChange={ItemDocIssueDateChangeHandle} id='SwDocsDocIssueDate' onKeyDown={itemSwSupprtDocIssueDatekeydown}
                                                        min={'1990-01-01'} max={'2100-12-31'} className='hi22 mb-2 ' type='date' style={{ textTransform: 'uppercase' }} />
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col>
                                                    <label className='summury' style={{ justifyContent: 'left' }}>Beneficiary Name</label>
                                                </Col>
                                                <Col>
                                                    <input value={ItemDialogValues.BeneficiaryName} onChange={ItemBeneficiaryNameChangeHandle} onKeyDown={itemSwSupprtBeneficaryNamekeydown}
                                                        id='SwDocsBeneficiaryName' className='hi22 mb-2 widh73' style={{ textTransform: 'uppercase' }} />
                                                    <button className='searchbutton mb-2 ' onClick={ItemBeneficiaryOpenHandle}>
                                                        <SearchIcon fontSize="small" /></button>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col>
                                                    <label className='summury' style={{ justifyContent: 'left' }}>File Type</label>
                                                </Col>
                                                <Col>
                                                    <select value={ItemDialogValues.FileType} onChange={ItemFileTypeChangeHandle} onKeyDown={itemSwSupprtFileTypekeydown}
                                                        id='SwDocsFileType' className='hi22 mb-2 ' style={{ textAlign: 'center', textTransform: 'uppercase' }}>
                                                        <option value={''}></option>
                                                        {ItemSwUQCDrp.map((item) => (
                                                            <option value={item.supDocFileType}>{item.supDocFileType}</option>
                                                        ))}
                                                    </select>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col>
                                                    <label className='summury' style={{ justifyContent: 'left' }}>Declaration Type(M/T/N/E)</label>
                                                </Col>
                                                <Col>
                                                    <input value={ItemDialogValues.DeclarationTypeMTNE} onChange={ItemDeclarationTypeChangeHandle} onKeyDown={itemSwSupprtDeclaretionTypekeydown}
                                                        id='SwDocsDeclarationTYpeMTNE' className='hi22 mb-2 ' style={{ textTransform: 'uppercase', textAlign: 'center' }} maxLength={1} />
                                                </Col>
                                            </Row>
                                            <Row>
                                                <label>(M-Master,N-Invoice,T-Item)</label>
                                            </Row>
                                        </Paper>
                                    </Grid>
                                    <Grid xs={8} item>
                                        <Paper className={classes.paper} style={{ backgroundColor: '#C8EDE7' }}>
                                            <Row>
                                                <Col><label style={{ justifyContent: 'left' }}>Doc Reference No</label></Col>
                                                <Col><input value={ItemDialogValues.DocReferenceNo} onChange={ItemDocReferenceNoChangeHandle} onKeyDown={itemSwSupprtDocRefrenceNokeydown}
                                                    className='mb-2' style={{ textTransform: 'uppercase' }} /></Col>

                                                <Col><label style={{ justifyContent: 'left' }}>Doc Expiry Date</label></Col>
                                                <Col><input value={ItemDialogValues.DocExpiryDate} onChange={ItemDocExpiryDateChangeHandle} id='SWDocsDocExpiryDate'
                                                    text='date' style={{ textTransform: 'uppercase' }} onKeyDown={itemSwSupprtDocExpiryDatekeydown} /></Col>
                                            </Row>
                                            <Row>
                                                <Col><label style={{ justifyContent: 'left' }}>IssuePartyAddress1</label></Col>
                                                <Col><input value={ItemDialogValues.IssuePartyAddress1} onChange={ItemIssuePartyAddress1ChangeHandle} onKeyDown={itemSwSupprtIssuepartyAddress1keydown}
                                                    id='SWDocsIssuePartyAddress1' className='mb-2' style={{ textTransform: 'uppercase' }} /></Col>

                                                <Col><label style={{ justifyContent: 'left' }}>IssuePartyAddress2</label></Col>
                                                <Col><input value={ItemDialogValues.IssuePartyAddress2} onChange={ItemIssuePartyAddress2ChangeHandle} onKeyDown={itemSwSupprtIssuepartyAddress2keydown}
                                                    id='SWDocsIssuePartyAddress2' style={{ textTransform: 'uppercase' }} /></Col>
                                            </Row>
                                            <Row>
                                                <Col><label style={{ justifyContent: 'left' }}>Issue PartyCity</label></Col>
                                                <Col><input value={ItemDialogValues.IssuePartyCity} onChange={ItemIssuePartyCityChangeHandle} onKeyDown={itemSwSupprtIssuepartyCitykeydown}
                                                    id='swDocsIssuePartyCity' className='mb-2' style={{ textTransform: 'uppercase' }} /></Col>

                                                <Col><label style={{ justifyContent: 'left' }}>Issue PartyPincode</label></Col>
                                                <Col><input value={ItemDialogValues.IssuePartyPincode} onChange={ItemIssuePartyPincodeChangeHandle}
                                                    id='SwDocsIssuePartyPincode' style={{ textTransform: 'uppercase' }} onKeyDown={itemSwSupprtIssuePartyPinCodekeydown} /></Col>
                                            </Row>
                                            <Row>
                                                <Col><label style={{ justifyContent: 'left' }}>Issue PartyCode</label></Col>
                                                <Col><input value={ItemDialogValues.IssuePartyCode} onChange={ItemIssuePartyCodeChangeHandle} onKeyDown={itemSwSupprtIssuePartyCodekeydown}
                                                    id='SwDocsIssuePartyCode' className='mb-2' style={{ textTransform: 'uppercase' }} /></Col>

                                                <Col><label style={{ justifyContent: 'left' }}>BenificiaryCode</label></Col>
                                                <Col><input value={ItemDialogValues.BenificiaryCode} onChange={ItemBenificiaryCodeChangeHandle} onKeyDown={itemSwSupprtBenificiaryCodekeydown}
                                                    id='SwDocsBenificiaryCode' style={{ textTransform: 'uppercase' }} /></Col>
                                            </Row>
                                            <Row>
                                                <Col><label style={{ justifyContent: 'left' }}>BenificiaryAddress1</label></Col>
                                                <Col><input value={ItemDialogValues.BenificiaryAddress1} onChange={ItemBenificiaryAddress1ChangeHandle} onKeyDown={itemSwSupprtBenificiaryAddress1keydown}
                                                    id='swDocsBenificiaryAddress1' className='mb-2' style={{ textTransform: 'uppercase' }} /></Col>

                                                <Col><label style={{ justifyContent: 'left' }}>BenificiaryAddress2</label></Col>
                                                <Col><input value={ItemDialogValues.BenificiaryAddress2} onChange={ItemBenificiaryAddress2ChangeHandle}
                                                    id='swDocsBenificiaryAddress2' style={{ textTransform: 'uppercase' }} onKeyDown={itemSwSupprtBenificiaryAddress2keydown} /></Col>
                                            </Row>
                                            <Row>
                                                <Col><label style={{ justifyContent: 'left' }}>BenificiaryCity</label></Col>
                                                <Col><input value={ItemDialogValues.BenificiaryCity} onChange={ItemBenificiaryCityChangeHandle} onKeyDown={itemSwSupprtBenificiaryCitykeydown}
                                                    id='swDocsBenificiaryCity' className='mb-2' style={{ textTransform: 'uppercase' }} /></Col>

                                                <Col><label style={{ justifyContent: 'left' }}>BenificiaryPincode</label></Col>
                                                <Col><input value={ItemDialogValues.BenificiaryPincode} onChange={ItemBenificiaryPincodeChangeHandle}
                                                    id='SwDocsBenificiaryPincode' style={{ textTransform: 'uppercase' }} onKeyDown={itemSwSupprtFileTypekeydown} /></Col>
                                            </Row>
                                            <center className='mt-3 mb-3'>
                                                <Button size='small' variant="contained" color="primary" disabled={ItemSchemeSaveDsa} onClick={ItemSwDocsSave}>{ItemSchemeSve ? 'Processing..' : 'Save'}</Button>{' '}
                                                <Button size='small' variant="contained" color="primary" disabled={ItemSchemeUpdateDsa} onClick={ItemSwDocsUpdate}>{ItemSchemeUpd ? 'Processing..' : 'Update'}</Button>{' '}
                                                <Button size='small' variant="contained" color="primary" disabled={ItemSchemeDeleteDsa} onClick={ItemSwDocsDelete}>{ItemSchemeDlt ? 'Processing..' : 'Delete'}</Button>{' '}
                                                <Button size='small' variant="contained" color="primary"  onKeyDown={itemSwSupprtRefBtnTypekeydown} onClick={ItemSwDocsReset}>Refresh</Button>{' '}
                                            </center>
                                        </Paper>
                                    </Grid>
                                </Grid>
                            </div>
                            <TableContainer className={classes.container}>
                                <Table stickyHeader className='table-bordered border-primary'>
                                    <TableHead>
                                        <StyledTableRow >
                                            <StyledTableCell className='p-1' align='center'>Sl.No</StyledTableCell>
                                            <StyledTableCell className='p-1' align='center'>DocTypeCode</StyledTableCell>
                                            <StyledTableCell className='p-1' align='center'>ImgRefNo</StyledTableCell>
                                            <StyledTableCell className='p-1' align='center'>DecType</StyledTableCell>
                                            <StyledTableCell className='p-1' align='center'>IssuePlace</StyledTableCell>
                                            <StyledTableCell className='p-1' align='center'>IssueDate</StyledTableCell>
                                            <StyledTableCell className='p-1' align='center'>ExpiryDate</StyledTableCell>
                                            <StyledTableCell className='p-1' align='center'>IssuePartyName</StyledTableCell>
                                            <StyledTableCell className='p-1' align='center'>BeneficiaryPartyName</StyledTableCell>
                                            <StyledTableCell className='p-1' align='center'>File Type</StyledTableCell>
                                        </StyledTableRow>
                                    </TableHead>
                                    <TableBody>
                                        {itemRitcDetails.map((item) => { const selectedItem = isItemTblSelected(item.docType);
                                            return(
                                            <TableRow key={item.serialNumber} hover onClick={() => editItemSWDocsDetails(item)} id='Item_Sw_docsDetails_id'
                                            onKeyDown={(e)=>itemDialogTblKeyDown(e,'Sw_docs')} tabIndex={-1} selected={selectedItem}>
                                                <TableCell className='p-1' align='center'>{item.serialNumber}</TableCell>
                                                <TableCell className='p-1' align='center'>{item.docType}</TableCell>
                                                <TableCell className='p-1' align='center'>{item.imagRefNo}</TableCell>
                                                <TableCell className='p-1' align='center'>{item.decType}</TableCell>
                                                <TableCell className='p-1' align='center'>{item.docIssuePlace}</TableCell>
                                                <TableCell className='p-1' align='center'>{item.docIssueDate}</TableCell>
                                                <TableCell className='p-1' align='center'>{item.docExpiryDate}</TableCell>
                                                <TableCell className='p-1' align='center'>{item.issueName}</TableCell>
                                                <TableCell className='p-1' align='center'>{item.beneficiaryName}</TableCell>
                                                <TableCell className='p-1' align='center'>{item.fileType}</TableCell>
                                            </TableRow>)})}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Dialog>
                    </div>
                    {/* beDownlod */}
                    <Dialog onClose={ItemBEPrintCloshHandle} open={ItemBePrintOpen} >
                        <DialogTitle className="dialogboxtitlecolour p-1">
                            <center>BE Print</center>
                        </DialogTitle>
                        <Container>
                            <div className='mb-2 dialogboxcolour'>
                                <center>
                                    <div className='mt-3'>
                                        <label>ICEGATE USER</label>
                                        <select className='hi22 widh25 ml-1' value={ItemDialogValues.iceGateUser} autoFocus
                                            onChange={ItemIceGateUserChangeHandle}>
                                            <option value={''}></option>
                                            {ItemSwUQCDrp.map((item) => (
                                                <option value={item.userName}>{item.userName}</option>
                                            ))}
                                        </select>
                                    </div>
                                </center>
                                <center>
                                    <Button size='medium' variant="contained" color="primary" className='m-2' disabled={ItemSchemeSaveDsa} onClick={ItemDownlodBeClick}>{ItemSchemeSve ? 'Processing' : 'Download'}</Button>{' '}
                                </center>
                            </div>
                        </Container>
                    </Dialog>
                    {/* ItembulkUpload */}
                    <Dialog onClose={ItemBulkUploadCloshHandle} open={ItemBulkUploadOpen} fullWidth={true} maxWidth="sm">
                        <DialogTitle className="dialogboxtitlecolour p-1">
                            <center>ITEM UPLOAD</center>
                        </DialogTitle>
                        <div className='dialogboxcolour'>
                            <center>
                                <label onClick={excelUploadFile} className="btn btn-default p-1" >Upload
                                    {excelUpload ? <input type="file" onChange={selectFile} hidden /> : null}
                                </label>
                                {currentFile && (
                                    <LinearProgress color="secondary" />
                                )}
                                <label className="btn btn-default p-1" onClick={ItemErrorFilesOpenHandle} >View Error Files</label>
                            </center>
                            <Divider />
                            <center>
                                <h6>Click Download Template Button to  Download</h6>
                                <br />
                                <h6>Click Upload Button to Upload Item Details</h6>
                            </center>
                            <Divider />
                            <div className='mb-2 mt-1'>
                                <center>
                                    <Button size='small' variant="contained" color="primary" onClick={ItemDwnTemp}>Download Template</Button>{' '}
                                    <Button size='small' variant="contained" color="primary" onClick={ItemBulkUploadCloshHandle}>Close</Button>{' '}
                                    <Button size='small' variant="contained" color="primary">Refresh</Button>{' '}
                                </center></div>
                        </div>
                    </Dialog>
                    {/*ErrorTable*/}
                    <Dialog onClose={ItemErrorFilesCloseHandle} open={ItemBulkUploadErrorOpen} fullWidth={true} maxWidth='md'>
                        <DialogTitle align='center' className="dialogboxtitlecolour p-1">ITEM ERROR REPORT</DialogTitle>
                        <div>
                            <TableContainer className={classes.container}>
                                <Table stickyHeader className="table-bordered">
                                    <TableHead>
                                        <StyledTableRow>
                                            <StyledTableCell align='center' className="p-1">Sl.No</StyledTableCell>
                                            <StyledTableCell align='center' className="p-1">Item Sr No</StyledTableCell>
                                            <StyledTableCell align='center' className="p-1">Item Description</StyledTableCell>
                                            <StyledTableCell align='center' className="p-1" style={{ color: 'red' }}>Error Type</StyledTableCell>
                                            <StyledTableCell align='center' className="p-1">Quantity</StyledTableCell>
                                            <StyledTableCell align='center' className="p-1">Unit</StyledTableCell>
                                            <StyledTableCell align='center' className="p-1">Unit Price</StyledTableCell>
                                            <StyledTableCell align='center' className="p-1">Currency Code</StyledTableCell>
                                            <StyledTableCell align='center' className="p-1">Total</StyledTableCell>
                                            <StyledTableCell align='center' className="p-1">RITC</StyledTableCell>
                                            <StyledTableCell align='center' className="p-1">CTH</StyledTableCell>
                                            <StyledTableCell align='center' className="p-1">CETH</StyledTableCell>
                                        </StyledTableRow>
                                    </TableHead>
                                    <TableBody>
                                        {ItemErrordetails.map(
                                            (trns) => (
                                                <StyledTableRow hover key={trns.index}>
                                                    <StyledTableCell className="p-1">{trns.serialNumber}</StyledTableCell>
                                                    <StyledTableCell className="p-1">{trns.itemSrNo}</StyledTableCell>
                                                    <StyledTableCell className="p-1">{trns.item_description}</StyledTableCell>
                                                    <StyledTableCell className="p-1">{trns.errorType}</StyledTableCell>
                                                    <StyledTableCell className="p-1">{trns.qty}</StyledTableCell>
                                                    <StyledTableCell className="p-1">{trns.unitCode}</StyledTableCell>
                                                    <StyledTableCell className="p-1">{trns.unitPrice}</StyledTableCell>
                                                    <StyledTableCell className="p-1">{trns.currency_code}</StyledTableCell>
                                                    <StyledTableCell className="p-1">{trns.totalAmount}</StyledTableCell>
                                                    <StyledTableCell className="p-1">{trns.ritc}</StyledTableCell>
                                                    <StyledTableCell className="p-1">{trns.cth}</StyledTableCell>
                                                    <StyledTableCell className="p-1">{trns.ceth}</StyledTableCell>
                                                </StyledTableRow>
                                            ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </div>
                    </Dialog>
                    {/* input-Values */}
                    <Box className='bg-light form-inline'>
                        <Box sx={{ width: '82%', height: '460' }}>
                            <Paper className={classes.card1} style={{ backgroundColor: '#C8EDE7' }}>
                                <div className='form-inline'>
                                    <Form.Label className='mr-1'>Sl.No</Form.Label>
                                    <Form.Control size='sm' style={{ width: '5%', textAlign: 'center' }}
                                        value={ItemValues.item_sl_no} onChange={ItemSlNoChangeHandle} />
                                    <h5 style={{ marginLeft: "2%" }}>Invoice No</h5>
                                    <h5 style={{ color: 'red' }}>:</h5>
                                    <h6 style={{ color: 'red', fontweight: 'bold' }}>{invoicevalues.invoiceNo}</h6>
                                    <div className="title" style={{ marginLeft: '15%', fontSize: '150%' }}>IMPORT-ITEM</div>{/** */}
                                    <Form.Label style={{ marginLeft: "15%", marginRight: '1%' }}>Job.No</Form.Label>
                                    <Form.Control style={{ width: '10%', textAlign: 'center', fontweight: 'bold', color: 'red' }} readOnly value={jobValues.job_no} />
                                </div>
                            </Paper>
                            <Grid container>
                                <Grid >
                                    <Paper className={classes.card1} style={{ backgroundColor: '#C8EDE7' }}>
                                        <div className='pt-1'>
                                            <div className='form-inline'>
                                                <Form.Label style={{ color: 'red' }}>Item Desc</Form.Label>
                                                <input style={{ width: '54%', height: '22px', border: '2px solid yellow', marginLeft: "1.9%", textTransform: 'uppercase' }}
                                                    value={ItemValues.txt_item_Desc} onChange={ItemItemDescChangeHandle} id='itemDesc'
                                                    onKeyDown={itemDescKeyDown} autoFocus />
                                                <button className='searchbutton' onClick={itemItemDescOpenHandle}>
                                                    <SearchIcon fontSize="small" />
                                                </button>
                                                {/*  */}
                                                <Form.Label style={{ color: 'red', marginLeft: "0.5%", marginRight: '0.4%' }}>RITC</Form.Label>
                                                <input style={{ width: '6%', height: '22px', textTransform: 'uppercase' }} id='ritc' onKeyDown={ItemritcKeyDown}
                                                    maxLength={8} value={ItemValues.txt_ritc} onChange={ItemRitcChangeHandle} />
                                                <button className='searchbutton' onClick={itemRitc_OpenHandle}>
                                                    <SearchIcon fontSize="small" />
                                                </button>
                                                {/*  */}
                                                <Form.Label style={{ color: 'red', marginLeft: "0.5%", marginRight: '0.4%' }}>CTH</Form.Label>
                                                <input style={{ width: '7%', height: '22px', textTransform: 'uppercase' }} id='cth' onKeyDown={ItemcthKeyDown}
                                                    maxLength={8} value={ItemValues.txt_cth} onChange={ItemCTHChangeHandle} />
                                                <button className='searchbutton' onClick={itemCTH_OpenHandle}>
                                                    <SearchIcon fontSize="small" />
                                                </button>
                                            </div>
                                            <div className='form-inline mt-1'>
                                                <Form.Label style={{ color: 'red', marginRight: '0.5%' }}>GenericDesc</Form.Label>
                                                <input style={{ width: '57%', height: '22px', textTransform: 'uppercase' }} id='genericDesc' onKeyDown={ItemgenericDescKeyDown}
                                                    value={ItemValues.genericDesc} onChange={ItemGenericDeschangeHandle} />
                                                {/*  */}
                                                <Form.Label style={{ color: 'red', marginLeft: "1%" }}>Rate Type(Std/Pref)[S/P]</Form.Label>
                                                <input className='ml-2' style={{ height: '22px', textTransform: 'uppercase', textAlign: 'center', width: '7%' }} id='rateType' onKeyDown={ItemrateTypeKeyDown}
                                                    maxLength={1} value={ItemValues.txt_rate_typeSP} onChange={ItemRateTypeSPChangeHandle} />
                                            </div>
                                            {/*  */}
                                            <div className='form-inline mt-1'>
                                                <Form.Label style={{ color: 'red' }}>CETH</Form.Label>
                                                <input style={{ width: '8%', height: '22px', marginLeft: "4%" }}
                                                    maxLength={8} value={ItemValues.txt_ceth} onChange={ItemCethChangeHandle} id='ceth' onKeyDown={ItemcethKeyDown}
                                                />
                                                <button className='searchbutton' onClick={itemCETH_OpenHandle}>
                                                    <SearchIcon fontSize="small" />
                                                </button>
                                                {/*  */}
                                                <Form.Label style={{ color: 'red', marginLeft: "1%" }}>Quantity</Form.Label>
                                                <input style={{ width: '7%', height: '22px', marginLeft: '0.5%', textTransform: 'uppercase' }} id='quantity' onKeyDown={ItemquantityKeyDown}
                                                    value={ItemValues.txt_quantity} onChange={ItemQuantityChangeHandle} />
                                                {/*  */}
                                                <Form.Label style={{ color: 'red', marginLeft: "1%" }}>Unit</Form.Label>
                                                <input style={{ width: '5%', height: '22px', marginLeft: '0.5%', textTransform: 'uppercase' }} id='unit' onKeyDown={ItemunitKeyDown}
                                                    maxLength={3} value={ItemValues.txt_unit} onChange={ItemUnitChangeHandle} />
                                                <button className='searchbutton' onClick={itemUnit_OpenHandle}>
                                                    <SearchIcon fontSize="small" />
                                                </button>
                                                {/*  */}
                                                <Form.Label style={{ color: 'red', marginLeft: "1%" }}>UnitPrice</Form.Label>
                                                <input style={{ width: '9%', height: '22px', marginLeft: '0.5%' }} id='unitPrice'
                                                    value={ItemValues.txt_unitPrice} onChange={ItemUnitPriceChangeHandle} onKeyDown={ItemunitPriceKeyDown} />
                                                {/*  */}
                                                <Form.Label style={{ color: 'red', marginLeft: "0.5%" }}>Currency</Form.Label>
                                                <input style={{ width: '5%', height: '22px', marginLeft: '0.5%', textTransform: 'uppercase' }}
                                                    maxLength={3} value={ItemValues.txt_currency} onChange={ItemCurrencyChangeHandle} id='itemCurncyid' onKeyDown={ItemitemCurncyKeyDown} />
                                                <button className='searchbutton' onClick={itemCurrency_OpenHandle}>
                                                    <SearchIcon fontSize="small" />
                                                </button>
                                                {/*  */}
                                                <Form.Label style={{ color: 'red', marginLeft: "0.5%", marginRight: '0.5%' }}>TotalAmount</Form.Label>
                                                <input style={{ width: '7.5%', height: '22px' }} onBlur={insertcmrcialItemalrtno}
                                                    value={ItemValues.txt_totAmount} onChange={ItemTotalAmountChangeHandle} id='totalamntId' onKeyDown={ItemtotalamntIdKeyDown} />
                                            </div>
                                            {/*  */}
                                            <div className='form-inline mt-1'>
                                                <Form.Label style={{ color: 'red' }}>EndUseCode</Form.Label>
                                                <input style={{ width: '8%', height: '22px', marginLeft: '0.5%', textTransform: 'uppercase' }}
                                                    maxLength={7} value={ItemValues.txt_endusCode} onChange={ItemEndUseCodeChangeHandle} id='endusecode' onKeyDown={ItemendusecodeKeyDown}
                                                />
                                                <button className='searchbutton' onClick={itemEndUse_OpenhHandle}>
                                                    <SearchIcon fontSize="small" />
                                                </button>
                                                {/*  */}
                                                <Form.Label className='ml-1'>Origin Country</Form.Label>
                                                <input style={{ width: '5%', height: '22px', textTransform: 'uppercase', marginLeft: '0.5%' }}
                                                    maxLength={2} value={ItemValues.txt_originCntry} onChange={ItemOriginCntryChangeHandle} id='orgincntry' onKeyDown={ItemorgincntryKeyDown}
                                                />
                                                <button className='searchbutton' onClick={itemOriginCntry_OpenHandle}>
                                                    <SearchIcon fontSize="small" />
                                                </button>
                                                {/*  */}
                                                <input disabled style={{ width: '12%', height: '22px', textTransform: 'uppercase', marginLeft: '0.2%' }} value={ItemValues.txt_originCntryName} />
                                                {/*  */}
                                                <Form.Label style={{ color: 'red' }} className='ml-1 mr-1'>Brand</Form.Label>
                                                <input style={{ width: '14%', height: '22px', textTransform: 'uppercase' }} id='brandId' onKeyDown={ItembrandKeyDown}
                                                    maxLength={20} value={ItemValues.txt_brand} onChange={ItemBrandChangeHandle}
                                                />
                                                {/*  */}
                                                <Form.Label style={{ color: 'red' }} className='ml-1 mr-1'>Model No</Form.Label>
                                                <input style={{ width: '10%', height: '22px', textTransform: 'uppercase' }}
                                                    maxLength={20} value={ItemValues.txt_model_no} onChange={ItemModelNoChangeHandle} id='modelNoId' onKeyDown={ItemmodelNoKeyDown}
                                                />
                                            </div>
                                            {/*  */}
                                            <div className='form-inline mt-1'>
                                                <Form.Label style={{ color: 'red' }}>Accessory(0/1/2)</Form.Label>
                                                <input style={{ width: "3%", height: '22px', color: 'red', textAlign: 'center', marginLeft: '1%' }} id='AccessoryId' onKeyDown={ItemAccessoryKeyDown}
                                                    maxLength={1} value={ItemValues.txt_acessory} onChange={ItemAcessoryChangeHandle}
                                                />
                                                {/*  */}
                                                <Form.Label className='ml-1 mr-1'>Source Country</Form.Label>
                                                <input style={{ width: '5%', height: '22px', textTransform: 'uppercase' }}
                                                    maxLength={2} value={ItemValues.txt_sourceCountry} onChange={ItemSourceCntryChangeHandle} id='srcCntryId' onKeyDown={ItemsrcCntryKeyDown}
                                                />
                                                <button className='searchbutton' onClick={itemSourceCntry_OpenHandle}>
                                                    <SearchIcon fontSize="small" />
                                                </button>
                                                {/*  */}
                                                <input disabled className='hi22 ml-1' style={{ width: '12' }} value={ItemValues.txt_sourceCountryName} />
                                                {/*  */}
                                                <Form.Label className='ml-1 mr-1'>Transit Country</Form.Label>
                                                <input style={{ width: '5%', height: '22px', textTransform: 'uppercase' }}
                                                    maxLength={2} value={ItemValues.txt_transit_country} onChange={ItemTransitCntryChangeHandle} id='transistCntryId' onKeyDown={ItemtransistCntryKeyDown}
                                                />
                                                <button className='searchbutton' onClick={itemTransiteCntry_OpenHandle} id='trnsit_btn'>
                                                    <SearchIcon fontSize="small" />
                                                </button>
                                                {/*  */}
                                                <input disabled className='hi22 ml-1' style={{ width: '12%' }}
                                                    value={ItemValues.txt_transit_countryName} />
                                                {/*  */}
                                                <Form.Label className='ml-1 mr-1'>ExcRate</Form.Label>
                                                <input disabled style={{ width: '9%', height: '22px', textTransform: 'uppercase' }}
                                                    value={ItemValues.txt_exRate} />
                                            </div>
                                        </div>
                                    </Paper>
                                </Grid>
                                <Grid container className='form-inline'>
                                    <Paper className={classes.card1} style={{ backgroundColor: '#C8EDE7' }}>
                                        <div className='form-inline'>
                                            <Grid item xs={5}>
                                                <div className='form-inline'>
                                                    <Row className='form-inline'>
                                                        <Col md={2}>
                                                            <Row><Col style={{ marginTop: '20%' }}><label style={{ justifyContent: 'left' }}>BCD</label></Col></Row>
                                                            <Row><Col style={{ marginTop: '11%' }}><label style={{ justifyContent: 'left' }}>AIDC</label></Col></Row>
                                                            <Row><Col style={{ marginTop: '11%' }}><label style={{ justifyContent: 'left' }}>SWS</label></Col></Row>
                                                            <Row><Col style={{ marginTop: '11%' }}><label style={{ justifyContent: 'left' }}>CVD</label></Col></Row>
                                                            <Row><Col style={{ marginTop: '11%' }}><label style={{ justifyContent: 'left' }}>EDU_CESS</label></Col></Row>
                                                        </Col>
                                                        <Col xs={6}>
                                                            <Row><div className='form-inline'>
                                                                <Col xs={7}><label style={{ color: 'blue', fontSize: '11px' }}>Notification_No</label></Col>
                                                                <Col style={{ marginLeft: '-10%' }} xs={4}><label style={{ color: 'blue', fontSize: '11px' }}>Sl.No</label></Col>
                                                            </div>
                                                            </Row>
                                                            <Row><div className='form-inline'>
                                                                <Col xs={9} className='form-inline'>
                                                                    <input style={{ width: '50%', height: '22px', justifyContent: 'left' }} id="bcd_notifyNo"
                                                                         value={ItemValues.bcd_notfication_no} onChange={ItemBCDNotifiNoChangeHandle} onKeyDown={ItemBCDNotifiNoKeyDown} />
                                                                    <button className='searchbutton' onClick={itemBcdNotify_OpenHandle} >
                                                                        <SearchIcon fontSize="small" /></button>
                                                                </Col>
                                                                <Col style={{ marginLeft: '-25%' }} xs={3}>
                                                                    <input style={{ width: '30px', height: '22px', justifyContent: 'left' }} id="bcd_srlNo" onBlur={getBcdNotifiDetails}
                                                                        value={ItemValues.bcd_sl_no} onChange={ItemBCDSlNoChangeHandle} onKeyDown={ItemBCDSrlNoKeyDown} />
                                                                </Col>
                                                            </div>
                                                            </Row>
                                                            <Row><div className='form-inline'>
                                                                <Col xs={9} className='form-inline'>
                                                                    <input style={{ width: '50%', height: '22px', marginTop: '0.4rem', justifyContent: 'left' }} id='aidc_notify'
                                                                        value={ItemValues.aidc_notfication_no} onChange={ItemAdidcNotifiNoChangeHandle}
                                                                        onKeyDown={ItemAdidcNotifiNoKeyDown} />
                                                                    <button className='searchbutton mt-1' onClick={itemAidcNotify_OpenHandle}>
                                                                        <SearchIcon fontSize="small" />
                                                                    </button>
                                                                </Col>
                                                                <Col style={{ marginLeft: '-25%' }} xs={3}>
                                                                    <input style={{ width: '30px', height: '22px', marginTop: '0.4rem', justifyContent: 'left' }} id='aidc_SrlNo' onBlur={getAIDCNotifiDetails}
                                                                        value={ItemValues.aidc_sl_no} onChange={ItemAdidcSlNoChangeHandle} onKeyDown={ItemAdidcSrlnoKeyDown} />
                                                                </Col>
                                                            </div>
                                                            </Row>
                                                            <Row><div className='form-inline'>
                                                                <Col xs={9} className='form-inline'>
                                                                    <input style={{ width: '50%', height: '22px', marginTop: '0.4rem', justifyContent: 'left' }} id='sws_notifi'
                                                                        value={ItemValues.sws_notfication_no} onChange={ItemSwsNotificationChangeHandle}
                                                                        onKeyDown={ItemSwsNotificationKeyDown} />
                                                                    <button className='searchbutton mt-1' onClick={itemSwsNotify_OpenHandle}>
                                                                        <SearchIcon fontSize="small" />
                                                                    </button>
                                                                </Col>
                                                                <Col style={{ marginLeft: '-25%' }} xs={3}>
                                                                    <input style={{ width: '30px', height: '22px', marginTop: '0.4rem', justifyContent: 'left' }} id='sws_srlNo' onBlur={getSWSNotifiDetails}
                                                                        value={ItemValues.sws_sl_no} onChange={ItemSwsSlNoChangeHandle} onKeyDown={ItemSws_SrlnoKeyDown} />
                                                                </Col>
                                                            </div>
                                                            </Row>
                                                            <Row><div className='form-inline'>
                                                                <Col xs={9}>
                                                                    <input style={{ width: '50%', height: '22px', marginTop: '0.4rem', justifyContent: 'left' }} id='cvd_notifi'
                                                                        value={ItemValues.cvd_notfication_no} onChange={ItemCvdNotifyChangeHandle}
                                                                        onKeyDown={ItemCVDNotificationKeyDown} />
                                                                    <button className='searchbutton mt-1' onClick={itemCVDNotify_OpenHandle}>
                                                                        <SearchIcon fontSize="small" />
                                                                    </button>
                                                                </Col>
                                                                <Col style={{ marginLeft: '-25%' }} xs={3}>
                                                                    <input style={{ width: '30px', height: '22px', marginTop: '0.4rem', justifyContent: 'left' }} id='cvd_srlno' onBlur={getCVDNotifiDetails}
                                                                        value={ItemValues.cvd_sl_no} onChange={ItemCvdSlNoChangeHandle} onKeyDown={ItemCVD_SrlnoKeyDown} />
                                                                </Col>
                                                            </div>
                                                            </Row>
                                                            <Row><div className='form-inline'>
                                                                <Col xs={9}>
                                                                    <input style={{ width: '50%', height: '22px', marginTop: '0.4rem', justifyContent: 'left' }} id='edu_cess_notfi'
                                                                        value={ItemValues.edu_css_notfication_no} onChange={ItemEDUcessNotiChangeHandle}
                                                                        onKeyDown={ItemEDUcessNotiKeyDown} />
                                                                    <button className='searchbutton mt-1' onClick={itemEDUCessNotify_OpenHandle}>
                                                                        < SearchIcon fontSize="small" />
                                                                    </button>
                                                                </Col>
                                                                <Col style={{ marginLeft: '-25%' }} xs={3}>
                                                                    <input style={{ width: '30px', height: '22px', marginTop: '0.4rem', justifyContent: 'left' }} id='edu_cess_srlNo'
                                                                        value={ItemValues.edu_css_sl_no} onChange={ItemEDUcessSrlNoChangeHandle} onKeyDown={ItemEDUCess_SrlnoKeyDown}
                                                                        onBlur={getEDUCessNotifiDetails} />
                                                                </Col>
                                                            </div>
                                                            </Row>
                                                        </Col>
                                                        <Col xs={2} style={{ marginLeft: '-82px' }}>
                                                            <label className='ml14 clrBlue' style={{ fontSize: '11px', justifyContent: 'center' }}>Rate(%)</label>
                                                            <input style={{ width: '50px', height: '22px', textAlign: 'center' }} disabled value={ItemValues.bcd_rate_no} />
                                                            <input style={{ width: '50px', height: '22px', marginTop: '0.4rem', textAlign: 'center' }} disabled value={ItemValues.aidc_rate_no} />
                                                            <input style={{ width: '50px', height: '22px', marginTop: '0.4rem', textAlign: 'center' }} disabled value={ItemValues.sws_rate_no} />
                                                            <input style={{ width: '50px', height: '22px', marginTop: '0.4rem', textAlign: 'center' }} disabled value={ItemValues.cvd_rate_no} />
                                                            <input style={{ width: '50px', height: '22px', marginTop: '0.4rem', textAlign: 'center' }} disabled value={ItemValues.edu_css_rate_no} />
                                                        </Col>
                                                        <Col xs={1} style={{ marginLeft: '-22px' }}>
                                                            <label className='ml14 clrBlue' style={{ fontSize: '11px', justifyContent: 'center' }}>Flg</label>
                                                            <input style={{ width: '30px', height: '22px', textAlign: 'center' }} value={ItemValues.bcd_flg_no} disabled />
                                                            <input style={{ width: '30px', height: '22px', marginTop: '0.4rem', textAlign: 'center' }} disabled value={ItemValues.aidc_flg_no} />
                                                            <input style={{ width: '30px', height: '22px', marginTop: '0.4rem', textAlign: 'center' }} disabled value={ItemValues.sws_flg_no} />
                                                            <input style={{ width: '30px', height: '22px', marginTop: '0.4rem', textAlign: 'center' }} disabled value={ItemValues.cvd_flg_no} />
                                                            <input style={{ width: '30px', height: '22px', marginTop: '0.4rem', textAlign: 'center' }} disabled value={ItemValues.edu_css_flg_no} />
                                                        </Col>
                                                        <Col xs={2} style={{ marginLeft: '-5px' }}>
                                                            <label className='ml14 clrBlue' style={{ fontSize: '11px', justifyContent: 'center' }}>Amount</label>
                                                            <input style={{ width: '40px', height: '22px', textAlign: 'center' }} disabled value={ItemValues.bcd_amount_no} />
                                                            <input style={{ width: '40px', height: '22px', marginTop: '0.4rem', textAlign: 'center' }} disabled value={ItemValues.aidc_amount_no} />
                                                            <input style={{ width: '40px', height: '22px', marginTop: '0.4rem', textAlign: 'center' }} disabled value={ItemValues.sws_amount_no} />
                                                            <input style={{ width: '40px', height: '22px', marginTop: '0.4rem', textAlign: 'center' }} disabled value={ItemValues.cvd_amount_no} />
                                                            <input style={{ width: '40px', height: '22px', marginTop: '0.4rem', textAlign: 'center' }} disabled value={ItemValues.edu_css_amount_no} />
                                                        </Col>
                                                        <Col xs={2} style={{ marginLeft: '-35px' }}>
                                                            <Row><Col><label className='ml14 clrBlue' style={{ fontSize: '11px', justifyContent: 'center' }}>UQC</label></Col></Row>
                                                            <Row><Col><input style={{ width: '40px', height: '22px', textAlign: 'center' }} disabled value={ItemValues.bcd_uqc_no} /></Col></Row>
                                                            <Row><Col><input style={{ width: '40px', height: '22px', marginTop: '0.4rem', textAlign: 'center' }} disabled value={ItemValues.aidc_uqc_no} /></Col></Row>
                                                            <Row><Col><input style={{ width: '40px', height: '22px', marginTop: '0.4rem', textAlign: 'center' }} disabled value={ItemValues.sws_uqc_no} /></Col></Row>
                                                            <Row><Col><input style={{ width: '40px', height: '22px', marginTop: '0.4rem', textAlign: 'center' }} disabled value={ItemValues.cvd_uqc_no} /></Col></Row>
                                                            <Row><Col><input style={{ width: '40px', height: '22px', marginTop: '0.4rem', textAlign: 'center' }} disabled value={ItemValues.edu_css_uqc_no} /></Col></Row>
                                                        </Col>
                                                    </Row>
                                                </div>{/* md={{ span: 2 }} */}
                                            </Grid>
                                            <Grid item xs={7}>
                                                <div className='form-inline'>
                                                    <Row className='form-inline'>
                                                        <Col sm={'auto'}>
                                                            <Row><Form.Label style={{ color: 'green', justifyContent: 'left' }}>SchemeCode(Y/N)</Form.Label></Row>
                                                            <Row><Form.Label style={{ color: 'green', marginTop: '0.4rem', justifyContent: 'left' }}>Licence(Y/N)</Form.Label></Row>
                                                            <Row><Form.Label style={{ color: 'green', marginTop: '0.4rem', justifyContent: 'left' }}>Re_Import(Y/N)</Form.Label></Row>
                                                            <Row><Form.Label style={{ color: 'green', marginTop: '0.4rem', justifyContent: 'left' }}>SVB_Status(Y/N)</Form.Label></Row>
                                                            <Row><Form.Label style={{ color: 'green', marginTop: '0.4rem', justifyContent: 'left' }}>Manufacture(Y/N)</Form.Label></Row>
                                                            <Row><Form.Label style={{ color: 'green', marginTop: '0.4rem', justifyContent: 'left' }}>Cust_Notn_Exempt</Form.Label></Row>
                                                        </Col>
                                                        <Col sm={1} style={{ marginLeft: '-18px' }}>
                                                            <Row><Col>
                                                                <input style={{ width: '30px', textAlign: 'center', height: '22px', textTransform: 'uppercase' }} id='schemecodeYN'
                                                                    value={ItemValues.schemeCodeY_N} onChange={ItemSchemeCodeChangeHandle}
                                                                    onKeyDown={ItemSchemeCodeYnKeyDown} /></Col>
                                                            </Row>
                                                            <Row className='mt-1'><Col>
                                                                <input style={{ width: '30px', textAlign: 'center', height: '22px', textTransform: 'uppercase' }}
                                                                    value={ItemValues.licence_y_n} onChange={ItemLicenceYNChangeHandle} disabled={ItemlicenceDisa}
                                                                    id='licence' onKeyDown={ItemLicenceYNKeyDown} /></Col>
                                                            </Row>
                                                            <Row className='mt-1'><Col>
                                                                <input style={{ width: '30px', textAlign: 'center', height: '22px', textTransform: 'uppercase' }}
                                                                    id='re_import' value={ItemValues.Re_importY_n} onKeyDown={ItemReImportKeyDown}
                                                                    onChange={ItemReImportChangeHandle} /></Col>
                                                            </Row>
                                                            <Row className='mt-1'><Col>
                                                                <input style={{ width: '30px', textAlign: 'center', height: '22px', textTransform: 'uppercase' }}
                                                                    id='svbStatus' value={ItemValues.svb_status_y_N} onKeyDown={ItemSvbStatusYNKeyDown}
                                                                    onChange={ItemSvbStatusYNChangeHandle} /></Col>
                                                            </Row>
                                                            <Row className='mt-1'><Col>
                                                                <input style={{ width: '30px', textAlign: 'center', height: '22px', textTransform: 'uppercase' }} id='ManufactureYn'
                                                                    value={ItemValues.manufactureY_N} onChange={ItemManufactureYNChangeHandle} onKeyDown={ItemManufactureYNKeyDown} /></Col>
                                                            </Row>
                                                            <Row className='mt-1'><Col>
                                                                <input style={{ width: '30px', textAlign: 'center', height: '22px', textTransform: 'uppercase' }} onKeyDown={CustNotExptKeydown}
                                                                    id='cust_notnId' value={ItemValues.cust_Notn_exmptY_n} onChange={ItemCustNotnExmpChangeHandle} /></Col>
                                                            </Row>
                                                        </Col>
                                                        <Col md={3}>
                                                            <Row><Col><Form.Label style={{ color: 'blue', justifyContent: 'left' }}>AuntiDumpingDuty(Y/N)</Form.Label></Col></Row>
                                                            <Row><Col><Form.Label style={{ color: 'Blue', marginTop: '0.4rem', justifyContent: 'left' }} >RSP(Y/N/Q/T/D/C)</Form.Label></Col></Row>
                                                            <Row><Col><Form.Label style={{ color: 'Blue', marginTop: '0.4rem', justifyContent: 'left' }}>NCD_CustomDuty(Y/N)</Form.Label></Col></Row>
                                                            <Row><Col><Form.Label style={{ color: 'Blue', marginTop: '0.4rem', justifyContent: 'left' }}>Other_Duty(Y/N)</Form.Label></Col></Row>
                                                            <Row><Col><Form.Label style={{ color: 'Blue', marginTop: '0.4rem', justifyContent: 'left' }}>SC_Duty(Y/N)</Form.Label></Col></Row>
                                                            <Row><Col><Form.Label style={{ color: 'Blue', marginTop: '0.4rem', justifyContent: 'left' }}>IGSTDuty(Y/N)</Form.Label></Col></Row>
                                                        </Col>
                                                        <Col md={1}>
                                                            <Row className='form-inline'><Col>
                                                                <input style={{ width: '30px', textAlign: 'center', height: '22px', textTransform: 'uppercase', }}
                                                                    value={ItemValues.anti_dumbing_duty_Y_N} onChange={ItemAntiDumbingDutyChangeHandle}
                                                                    onKeyDown={ItemAntiDumbingDutykeyDown} id='auntiDumping' /></Col>
                                                            </Row>
                                                            <Row className='form-inline mt-1'><Col>
                                                                <input style={{ width: '30px', textAlign: 'center', height: '22px', textTransform: 'uppercase' }} id='item_Rsp'
                                                                    value={ItemValues.rsp_Y_N_Q_T_D_C} onChange={ItemRspYNQTDCChangeHandle} onKeyDown={ItemRspYNQTDCKeyDown} /></Col>
                                                            </Row>
                                                            <Row className='form-inline mt-1'><Col>
                                                                <input style={{ width: '30px', textAlign: 'center', height: '22px', textTransform: 'uppercase' }} id='ncd_customDuty'
                                                                    value={ItemValues.ncdCustomDuty_Y_N} onChange={ItemNcdCusDutyChangeHandle}
                                                                    onKeyDown={ItemNCDcustomDutyYnKeyDown} /></Col>
                                                            </Row>
                                                            <Row className='form-inline mt-1'><Col>
                                                                <input style={{ width: '30px', textAlign: 'center', height: '22px', textTransform: 'uppercase' }} id='otherDuty'
                                                                    value={ItemValues.otherDuty_Y_N} onChange={ItemOtherDutyYNChangeHandle} onKeyDown={ItemOtherDutyYNKeyDown} /></Col>
                                                            </Row>
                                                            <Row className='form-inline mt-1'><Col>
                                                                <input style={{ width: '30px', textAlign: 'center', height: '22px', textTransform: 'uppercase' }}
                                                                    value={ItemValues.scDuty_Y_N} onChange={ItemSCdutyChangeHandle} id='sc_duty'
                                                                    onKeyDown={ItemSCDYNKeyDown} /></Col>
                                                            </Row>
                                                            <Row className='form-inline mt-1'><Col>
                                                                <input style={{ width: '30px', textAlign: 'center', height: '22px', textTransform: 'uppercase' }}
                                                                    value={ItemValues.IGSTDuty_Y_N} onChange={ItemIgstDutyyYNChangeHandle} id='igst_duty'
                                                                    disabled={ItemIgstDutyYNDisa} /></Col>
                                                            </Row>
                                                        </Col>
                                                        <Col sm={'auto'}>
                                                            <Row><Col><Form.Label style={{ color: 'Fuchsia', justifyContent: 'left' }}>SW_info(Y/N)</Form.Label></Col></Row>
                                                            <Row><Col><Form.Label style={{ color: 'Fuchsia', marginTop: '0.4rem', justifyContent: 'left' }} >SW_Constituent(Y/N)</Form.Label></Col></Row>
                                                            <Row><Col><Form.Label style={{ color: 'Fuchsia', marginTop: '0.4rem', justifyContent: 'left' }}>SW_Production(Y/N)</Form.Label></Col></Row>
                                                            <Row><Col><Form.Label style={{ color: 'Fuchsia', marginTop: '0.4rem', justifyContent: 'left' }}>SW_Control(Y/N)</Form.Label></Col></Row>
                                                            <Row><Col><Form.Label style={{ color: 'Fuchsia', marginTop: '0.4rem', justifyContent: 'left' }}>SW_Statement(Y/N)</Form.Label></Col></Row>
                                                            <Row><Col><Form.Label style={{ color: 'Fuchsia', marginTop: '0.4rem', justifyContent: 'left' }}>SW_SupportDoc(Y/N)</Form.Label></Col></Row>
                                                            <Row><Col><Form.Label style={{ color: 'Fuchsia', marginTop: '0.4rem', justifyContent: 'left' }}>Policy_Para(Y/N)</Form.Label></Col></Row>
                                                        </Col>
                                                        <Col md={'auto'} style={{ marginLeft: '-13px' }}>
                                                            <Row className='form-inline'><Col>
                                                                <input style={{ width: '30px', height: '22px', textTransform: 'uppercase', textAlign: 'center' }}
                                                                    id='sw_info' value={ItemValues.swinfo_Y_N} onChange={ItemSwinfoYNChangeHandle} onKeyDown={ItemSwinfoYNKeyDown} /></Col>
                                                            </Row>
                                                            <Row className='form-inline mt-1'><Col>
                                                                <input style={{ width: '30px', height: '22px', textTransform: 'uppercase', textAlign: 'center' }}
                                                                    id="SW_Constituent" onKeyDown={ItemConstituentYnKeyDown}
                                                                    value={ItemValues.swConstitutent_Y_N} onChange={ItemConstituentYnChangeHandle} /></Col>
                                                            </Row>
                                                            <Row className='form-inline mt-1'><Col>
                                                                <input style={{ width: '30px', height: '22px', textTransform: 'uppercase', textAlign: 'center' }}
                                                                    id='sw_production' value={ItemValues.swProduction_Y_N} onChange={ItemSWproductionChangeHandle}
                                                                    onKeyDown={ItemSWproductionKeyDown} /></Col>
                                                            </Row>
                                                            <Row className='form-inline mt-1'><Col>
                                                                <input style={{ width: '30px', height: '22px', textTransform: 'uppercase', textAlign: 'center' }}
                                                                    id='sw_control' value={ItemValues.swControl_Y_N} onChange={ItemSwControllChangeHandle}
                                                                    onKeyDown={ItemSwControllKeyDown} /></Col>
                                                            </Row>
                                                            <Row className='form-inline mt-1'><Col>
                                                                <input style={{ width: '30px', height: '22px', textTransform: 'uppercase', textAlign: 'center' }}
                                                                    id='sw_statement' onKeyDown={ItemSWStatmntKeyDown}
                                                                    value={ItemValues.swStatementY_N} onChange={ItemSwStatemntChangeHandle} /></Col>
                                                            </Row>
                                                            <Row className='form-inline mt-1'><Col>
                                                                <input style={{ width: '30px', height: '22px', textTransform: 'uppercase', textAlign: 'center' }}
                                                                    id='SW_support' onKeyDown={ItemSwDocsKeyDown}
                                                                    value={ItemValues.swSuportDoc_Y_N} onChange={ItemSWsuportChangeHandle} /></Col>
                                                            </Row>
                                                            <Row className='form-inline mt-1'><Col>
                                                                <input style={{ width: '30px', height: '22px', textAlign: 'center', textTransform: 'uppercase' }}
                                                                    value={ItemValues.PolicyPara_Y_N} onChange={ItemPolicParaYNChangeHandle} id='policy_para'
                                                                    onKeyDown={ItemPolicyParaKeyDown} /></Col>
                                                            </Row>
                                                        </Col>
                                                    </Row>
                                                </div>
                                            </Grid>
                                        </div>
                                    </Paper>
                                </Grid>
                                <Grid item xs={12}>
                                    <Paper className={classes.card1} style={{ backgroundColor: '#C8EDE7' }}>
                                        <Row>
                                            <Row >
                                                <Col xs={1}> <Form.Label className='mt-3'>IGSTDuty</Form.Label></Col>
                                                <Col xs={1} style={{ marginLeft: '-1%' }}> <Form.Label style={{ color: 'red' }}>DutyType</Form.Label>
                                                    <select style={{ width: '70px', height: '22px', textAlign: 'center' }} onKeyDown={IgstDutyKeydown}
                                                        id='igst_duty_type' value={ItemValues.igstduty_type} onChange={ItemIgstDutTyypeChangeHandle}>
                                                        <option value={''}></option>
                                                        {ItemIGSTdutyTypeDetails.map((duty) => (
                                                            <option value={duty.dutyType}>{duty.dutyType}</option>
                                                        ))}</select></Col>{' '}
                                                <Col xs={1} >
                                                    <Form.Label style={{ color: 'red', marginLeft: '2.7%' }}>AddDutyType</Form.Label>
                                                    <select style={{ width: '70px', height: '22px', textAlign: 'center', marginLeft: '0.5%' }} onKeyDown={AddDutyTypKeydown}
                                                        id={'AddDutyTyp'} value={ItemValues.igstduty_Add_type} onChange={ItemIgstDutyAddTypeChangeHandle}>
                                                        <option value={''}></option>
                                                        {ItemIGSTdutyAddTypeDetails.map(duty => (
                                                            <option value={duty.addlDutyType}>{duty.addlDutyType}</option>
                                                        ))}
                                                    </select>
                                                </Col>
                                                <Col xs={1}>
                                                    <Form.Label style={{ color: 'red' }}>Flg(G/C)</Form.Label>
                                                    <input style={{ width: '60px', height: '22px', textAlign: 'center' }} onKeyDown={FlagKeydown}
                                                        maxLength={2} id={'ItemflagGC'} value={ItemValues.igstduty_flagG_C} onChange={ItemIgstDutyFlagGCChangeHandle} />
                                                </Col>
                                                <Col xs={2} style={{ marginLeft: '-1%' }}>
                                                    <Form.Label style={{ color: 'red', marginLeft: '-35%' }}>Notification.No</Form.Label>
                                                    <input style={{ width: '75px', height: '22px', textAlign: 'center' }}
                                                        value={ItemValues.igstduty_notfion_no} onChange={ItemIgstDutyNotfiNoChangeHandle}
                                                        onKeyDown={ItemIgstDutyNotfiNoKeyDown} id='igstDuty_notify' />
                                                    <button className='searchbutton' onClick={itemIGSTDutyNotify_OpenHandle}>
                                                        <SearchIcon fontSize="small" />
                                                    </button>
                                                </Col>
                                                <Col xs={1} style={{ marginLeft: '-5%' }}>
                                                    <Form.Label style={{ color: 'red' }}>Sl.No</Form.Label>
                                                    <input style={{ width: '60px', height: '22px', textAlign: 'center' }}
                                                        value={ItemValues.igstduty_sl_no} onChange={ItemIgstDutySrlNoChangeHandle} onBlur={getIgstDutyNotifiDetails}
                                                        onKeyDown={ItemIgstDutySrlnoKeyDown} id='igstDuty_srlno' />
                                                </Col>
                                                <Col xs={1} style={{ marginLeft: '-1%' }}>
                                                    <Form.Label style={{ color: 'red' }}>Rate(%)</Form.Label>
                                                    <input style={{ width: '60px', height: '22px', textAlign: 'center' }} disabled value={ItemValues.igstduty_rate} />
                                                </Col>
                                                <Col xs={1} style={{ marginLeft: '-1%' }}>
                                                    <Form.Label style={{ color: 'red' }}>Flg</Form.Label>
                                                    <input style={{ width: '56px', height: '22px', textAlign: 'center' }} disabled value={ItemValues.igstduty_flg} />
                                                </Col>
                                                <Col xs={1} style={{ marginLeft: '-1%' }}>
                                                    <Form.Label style={{ color: 'red' }}>Amount</Form.Label>
                                                    <input style={{ width: '60px', height: '22px' }} disabled value={ItemValues.igstduty_amount} />
                                                </Col>
                                                <Col xs={1} style={{ marginLeft: '-1%' }}>
                                                    <Form.Label style={{ color: 'red' }}>UQC</Form.Label>
                                                    <input style={{ width: '60px', height: '22px', textAlign: 'center' }} disabled value={ItemValues.igstduty_uqc} />
                                                </Col>
                                                <Col xs={2} style={{ marginLeft: '-1%' }}>
                                                    <Form.Label style={{ color: 'red', marginLeft: '-35%' }}>ExempNotnNo</Form.Label>
                                                    <input style={{ width: '70px', height: '22px', textAlign: 'center' }} id='igstDutyExmpNotiNo'
                                                        value={ItemValues.igstduty_exmpNotn_no} onChange={ItemIgstDutyExmpNotiNoChangeHandle}
                                                        onKeyDown={ItemIgstDutyExmpNotifiNoKeyDown} />
                                                    <button className='searchbutton' onClick={itemIGSTExmpNotify_OpenHandle}>
                                                        <SearchIcon fontSize="small" />
                                                    </button>
                                                </Col>
                                                <Col xs={1} style={{ marginLeft: '-6%' }}>
                                                    <Form.Label style={{ color: 'red' }}>Sl.No</Form.Label>
                                                    <input style={{ width: '60px', height: '22px', textAlign: 'center' }} value={ItemValues.igstduty_sl_no2}
                                                        onChange={ItemIgstDutyExmpSrlNo2ChangeHandle} id='igstDutyExmpSrlNo' onKeyDown={ItemIgstDutyExmpSrlnoKeyDown} />
                                                </Col>
                                            </Row>
                                            <Row className='mt-2'>
                                                <Col xs={1}><Form.Label >IGSTCess</Form.Label></Col>
                                                <Col xs={1} style={{ marginLeft: '-1%' }}><select style={{ width: '70px', height: '22px', textAlign: 'center' }} onKeyDown={Igstcess_typeKeyDown} id='igstcess_type'
                                                    value={ItemValues.igstcess_type} onChange={ItemIgstCessTypeChangeHandle}>
                                                    <option value={''}></option>
                                                    {ItemIGSTcessTypeDetails.map((duty) => (
                                                        <option value={duty.dutyType}>{duty.dutyType}</option>
                                                    ))}
                                                </select></Col>
                                                <Col xs={1}>
                                                    <select style={{ width: '70px', height: '22px', textAlign: 'center' }} onKeyDown={IgstcessAddtypKeyDown} id='igstcessAddtyp'
                                                        value={ItemValues.igstcess_Add_type} onChange={ItemIgstCessAddTypeChangeHandle}>
                                                        <option value={''}></option>
                                                        {ItemIGSTcessAddTypeDetails.map((duty) => (
                                                            <option value={duty.addlDutyType}>{duty.addlDutyType}</option>
                                                        ))}
                                                    </select>
                                                </Col>
                                                <Col xs={1}>
                                                    <input style={{ width: '60px', height: '22px', textAlign: 'center' }} onKeyDown={IgstcessflagKeyDown} id='igstcessflag'
                                                        value={ItemValues.igstcess_flagG_C} onChange={ItemIgstCessFlagGcChangeHandle} />
                                                </Col>
                                                <Col xs={2} style={{ marginLeft: '-1%' }}>
                                                    <input style={{ width: '75px', height: '22px', textAlign: 'center' }} id='igstCess_notifno'
                                                        value={ItemValues.igstcess_notfion_no} onChange={ItemIgstCessNotifiNoChangeHandle} onKeyDown={ItemIgstCessNotfiNoKeyDown} />
                                                    <button className='searchbutton' onClick={itemIGSTCessNotify_OpenHandle}>
                                                        <SearchIcon fontSize="small" />
                                                    </button>
                                                </Col>
                                                <Col xs={1} style={{ marginLeft: '-5%' }}>
                                                    <input style={{ width: '60px', height: '22px', textAlign: 'center' }}
                                                        value={ItemValues.igstcess_sl_no} onChange={ItemIgstCessSrlNoChangeHandle} id='igstCess_SrlNo'
                                                        onKeyDown={ItemIgstCessSrlnoKeyDown} onBlur={getIgstCessNotifiDetails} />
                                                </Col>
                                                <Col xs={1} style={{ marginLeft: '-1%' }}>
                                                    <input style={{ width: '60px', height: '22px', textAlign: 'center' }} disabled value={ItemValues.igstcess_rate} />
                                                </Col>
                                                <Col xs={1} style={{ marginLeft: '-1%' }}>
                                                    <input style={{ width: '56px', height: '22px', textAlign: 'center' }} disabled value={ItemValues.igstcess_flg} />
                                                </Col>
                                                <Col xs={1} style={{ marginLeft: '-1%' }}>
                                                    <input style={{ width: '60px', height: '22px' }} disabled value={ItemValues.igstcess_amount} />
                                                </Col>
                                            </Row>
                                        </Row>
                                        <div className='mt-2'>
                                            <center style={{ marginLeft: '5%' }}>
                                                <Button size='small' variant="contained" color="primary" id='sve_itm' disabled={ItemSaveItemDsa} onClick={Itemsaveitem}>{ItemSve ? 'Processing..' : 'Save'}</Button>{' '}
                                                <Button size='small' variant="contained" color="primary" id='update_item' disabled={ItemUpdateItemDsa} onClick={ItemUpdateitem}>{ItemUpd ? 'Processing..' : 'Update'}</Button>{' '}
                                                <Button size='small' variant="contained" color="primary" disabled={ItemDeleteItemDsa} onClick={ItemDeleteItem}>{ItemDlt ? 'Processing..' : 'Delete'}</Button>{' '}
                                                <Button size='small' variant="contained" color="primary" onClick={resetitem}>cancel</Button>{' '}
                                                <Button size='small' variant="contained" color="primary" disabled={ItemBEfileItemDsa} onClick={() => ItemBeCheackListPrint(0)}>
                                                    {ItemBEprnt ? 'Printing..' : 'BE Print'}</Button>{' '}
                                                <Button size='small' variant="contained" color="primary" disabled={ItemCheackListItemDsa} onClick={() => ItemBeCheackListPrint(1)}>
                                                    {ItemCheacklistprnt ? 'Printing..' : 'CheckList Print'}</Button>{' '}
                                                <Button size='small' variant="contained" color="primary" onClick={ItemBulkUploadOpenHandle}>Bulk Upload</Button>{' '}
                                                <Button size='small' variant="contained" color="primary" onKeyDown={ItemDublicateBtnKeyDown} onClick={ItemDublicateItemSave}>Duplicate Item</Button>{' '}
                                            </center>
                                        </div>
                                    </Paper>
                                </Grid>
                            </Grid>
                        </Box>
                        <Box className='ml-1' sx={{ width: '17%', height: '460' }}>
                            <Paper className={classes.cardd3} style={{ backgroundColor: '#C8EDE7', height: '492px' }}>
                                <Row>
                                    <center>
                                        <Paper style={{ backgroundColor: 'lightblue' }} elevation={5}>
                                            <center>
                                                Invoice Summary
                                            </center>
                                        </Paper>
                                    </center>
                                </Row>
                                <Row className='mt-3'>
                                    <Col xs={4}><div><Form.Label style={{ justifyContent: 'left' }}>INV.Value</Form.Label></div></Col>
                                    <Col><Form.Label className='summury' style={{ justifyContent: 'left' }}>: {ItemSummury.invoiceValue}</Form.Label></Col>
                                </Row>
                                <Row >
                                    <Col xs={4}><Form.Label style={{ justifyContent: 'left' }}>Terms</Form.Label></Col>
                                    <Col ><Form.Label className='summury' style={{ justifyContent: 'left' }}>: {ItemSummury.terms}</Form.Label></Col>
                                </Row>
                                <Row>
                                    <Col xs={4}><Form.Label style={{ justifyContent: 'left' }}>Currency</Form.Label></Col>
                                    <Col ><Form.Label className='summury' style={{ justifyContent: 'left' }}>: {ItemSummury.currency}</Form.Label></Col>
                                </Row>
                                <Row>
                                    <Col xs={4}><Form.Label style={{ justifyContent: 'left' }}>Freight</Form.Label></Col>
                                    <Col ><Form.Label className='summury' style={{ justifyContent: 'left' }}>: {ItemSummury.fright} INR</Form.Label></Col>
                                </Row>
                                <Row>
                                    <Col xs={4}><Form.Label style={{ justifyContent: 'left' }}>Insurance</Form.Label></Col>
                                    <Col><Form.Label className='summury' style={{ justifyContent: 'left' }}>: {ItemSummury.insurence} INR</Form.Label></Col>
                                </Row>
                                <Row>
                                    <Col xs={4}><Form.Label style={{ justifyContent: 'left' }}>Misc</Form.Label></Col>
                                    <Col><Form.Label className='summury' style={{ justifyContent: 'left' }}>: {ItemSummury.misc}</Form.Label></Col>
                                </Row>
                                <Row>
                                    <Col xs={4}><Form.Label style={{ justifyContent: 'left' }}>Loading</Form.Label></Col>
                                    <Col ><Form.Label className='summury' style={{ justifyContent: 'left' }}>: {ItemSummury.loadinng}</Form.Label></Col>
                                </Row>
                                <Row>
                                    <Col xs={4}><Form.Label style={{ justifyContent: 'left' }}>TotValue</Form.Label></Col>
                                    <Col ><Form.Label className='summury' style={{ justifyContent: 'left' }}>: {ItemSummury.totalValue} {ItemSummury.currency}</Form.Label></Col>
                                </Row>
                                <Row>
                                    <Col xs={4}><Form.Label style={{ justifyContent: 'left' }}>TotAss</Form.Label></Col>
                                    <Col ><Form.Label className='summury' style={{ justifyContent: 'left' }}>: {ItemSummury.totalAmount} INR</Form.Label></Col>
                                </Row>
                                <Row >
                                    <Col xs={4}><Form.Label style={{ justifyContent: 'left' }}>TotDuty</Form.Label></Col>
                                    <Col ><Form.Label className='summury' style={{ justifyContent: 'left' }}>: {ItemSummury.totalDuty} INR</Form.Label></Col>
                                </Row>
                                <Row>
                                    <center className='mt-3'>
                                        <Paper style={{ backgroundColor: 'lightblue', marginTop: '10%', marginBottom: '3%' }} elevation={5}>
                                            <center>
                                                Item Summary
                                            </center>
                                        </Paper>
                                    </center>
                                </Row>
                                <Row>
                                    <Row className='mt-3'>
                                        <Col xs={3}><Form.Label style={{ justifyContent: 'left' }}>ASS</Form.Label></Col>
                                        <Col><Form.Label className='summury' style={{ justifyContent: 'left' }}>: {ItemSummury.ass}</Form.Label></Col>
                                    </Row>
                                    <Row>
                                        <Col xs={3}><Form.Label style={{ justifyContent: 'left' }}>BCD</Form.Label></Col>
                                        <Col><Form.Label className='summury' style={{ justifyContent: 'left' }}>: {ItemSummury.bcd} INR</Form.Label></Col>
                                    </Row>
                                    <Row>
                                        <Col xs={3}><Form.Label style={{ justifyContent: 'left' }}>CVD</Form.Label></Col>
                                        <Col><Form.Label className='summury' style={{ justifyContent: 'left' }}>: {ItemSummury.cvd} INR</Form.Label></Col>
                                    </Row>
                                    <Row>
                                        <Col xs={3}><Form.Label style={{ justifyContent: 'left' }}>SWS</Form.Label></Col>
                                        <Col><Form.Label className='summury' style={{ justifyContent: 'left' }}>: {ItemSummury.sws} INR</Form.Label></Col>
                                    </Row>
                                    <Row>
                                        <Col xs={3}><Form.Label style={{ justifyContent: 'left' }}>GST</Form.Label></Col>
                                        <Col><Form.Label className='summury' style={{ justifyContent: 'left' }}>: {ItemSummury.gst} INR</Form.Label></Col>
                                    </Row>
                                    <Row>
                                        <Col xs={3} ><Form.Label style={{ justifyContent: 'left' }}>DUTY</Form.Label></Col>
                                        <Col><Form.Label className='summury' style={{ justifyContent: 'left' }}>: {ItemSummury.duty} INR</Form.Label></Col>
                                    </Row>
                                </Row>
                            </Paper>
                        </Box>
                        <Box className='mt-2' sx={{ width: '100%' }}>
                            <Paper className={classes.cardd3} style={{ backgroundColor: 'white', marginTop: '-0.2%' }}>
                                <TableContainer className={classes.container}>
                                    <Table stickyHeader className='table-bordered '>
                                        <TableHead>
                                            <StyledTableRow >
                                                <StyledTableCell className='p-1' onKeyDown={itemTblDetailsKeyDownHed}>
                                                    <Checkbox className='p-1' indeterminate={selected.length} checked={selected.length}
                                                        onChange={AllMAWBHandle} color='secondary' inputProps={{ 'aria-label': 'select all desserts' }} />
                                                </StyledTableCell>
                                                <StyledTableCell className='p-1'>Sl.No</StyledTableCell>
                                                <StyledTableCell className='p-1'>Invoice.No</StyledTableCell>
                                                <StyledTableCell className='p-1'>Item Description</StyledTableCell>
                                                <StyledTableCell className='p-1'>RITC</StyledTableCell>
                                                <StyledTableCell className='p-1'>Quantity</StyledTableCell>
                                                <StyledTableCell className='p-1'>Unit</StyledTableCell>
                                                <StyledTableCell className='p-1'>Unit Price</StyledTableCell>
                                                <StyledTableCell className='p-1'>Total Amount</StyledTableCell>
                                            </StyledTableRow>
                                        </TableHead>
                                        <TableBody>
                                            {/* onClick={(event) => SlectedMAWBClick(event, item.itemId)} */}
                                            {itemDetails.map((item) => { const checkSelcted = isMAWBSelected(item.itemId);
                                                return (
                                                    <TableRow hover key={item.itemId}  id='ItemDetails_id' onKeyDown={itemTblDetailsKeyDown} tabIndex={-1} selected={checkSelcted}>
                                                        <TableCell className='p-1' padding="checkbox" onClick={()=>SlectedMAWBClick(item)}> 
                                                            <Checkbox checked={checkSelcted} className='p-1' role="checkbox" color='secondary' aria-checked={checkSelcted}  /></TableCell>
                                                        <TableCell onClick={() => EditItemDetails(item)} className='p-1'>{item.itemSrNo}</TableCell>
                                                        <TableCell onClick={() => EditItemDetails(item)} className='p-1'>{item.invoiceNumber}</TableCell>
                                                        <TableCell onClick={() => EditItemDetails(item)} className='p-1'>{item.item_description} </TableCell>
                                                        <TableCell onClick={() => EditItemDetails(item)} className='p-1'>{item.ritc}</TableCell>
                                                        <TableCell onClick={() => EditItemDetails(item)} className='p-1'>{item.qty}</TableCell>
                                                        <TableCell onClick={() => EditItemDetails(item)} className='p-1'>{item.unitCode}</TableCell>
                                                        <TableCell onClick={() => EditItemDetails(item)} className='p-1'>{item.unitPrice}</TableCell>
                                                        <TableCell onClick={() => EditItemDetails(item)} className='p-1'>{item.totalAmount}</TableCell>
                                                    </TableRow>)
                                            })}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Paper>
                        </Box>
                    </Box>
                </Tab>
            </Tabs>
        </div >
    )
}

export default ImportTabs